export const coreAirports = {
  AAA: {
    code: "AAA",
    name: "ANAA",
    chineseName: "阿纳",
    traditionalName: "阿納",
    airports: [
      {
        code: "AAA",
        name: "Anaa airport",
        chineseName: "安娜机场",
        traditionalName: "安娜機場",
      },
    ],
  },
  AAC: {
    code: "AAC",
    name: "EL ARISH",
    chineseName: "阿里什",
    traditionalName: "阿裡什",
    airports: [
      {
        code: "AAC",
        name: "El arish intl.",
        chineseName: "阿里什国际机场",
        traditionalName: "阿裡什國際機場",
      },
    ],
  },
  AAD: {
    code: "AAD",
    name: "ADADO",
    chineseName: "阿达巴",
    traditionalName: "阿達巴",
    airports: [
      {
        code: "AAD",
        name: "Adado airport",
        chineseName: "阿达多机场",
        traditionalName: "阿達多機場",
      },
    ],
  },
  AAE: {
    code: "AAE",
    name: "ANNABA",
    chineseName: "安纳巴",
    traditionalName: "安納巴",
    airports: [
      {
        code: "AAE",
        name: "Rabah bitat",
        chineseName: "拉巴赫比塔特机场",
        traditionalName: "拉巴赫比塔特機場",
      },
    ],
  },
  AAK: {
    code: "AAK",
    name: "ARANUKA",
    chineseName: "阿拉努卡",
    traditionalName: "阿拉魯卡",
    airports: [
      {
        code: "AAK",
        name: "Aranuka airport",
        chineseName: "布阿里基机场",
        traditionalName: "布阿裡基機場",
      },
    ],
  },
  AAL: {
    code: "AAL",
    name: "AALBORG",
    chineseName: "奥尔堡",
    traditionalName: "奧爾堡",
    airports: [
      {
        code: "AAL",
        name: "Aalborg airport",
        chineseName: "奥尔堡机场",
        traditionalName: "奧爾堡機場",
      },
    ],
  },
  AAM: {
    code: "AAM",
    name: "MALA MALA",
    chineseName: "马拉马拉",
    traditionalName: "馬拉馬拉",
    airports: [
      {
        code: "AAM",
        name: "Mala mala airport",
        chineseName: "马拉马拉机场",
        traditionalName: "馬拉馬拉機場",
      },
    ],
  },
  AAN: {
    code: "AAN",
    name: "AL AIN",
    chineseName: "艾因",
    traditionalName: "艾因",
    airports: [
      {
        code: "AAN",
        name: "Al ain intl.",
        chineseName: "艾因机场",
        traditionalName: "艾因機場",
      },
    ],
  },
  AAR: {
    code: "AAR",
    name: "AARHUS",
    chineseName: "奥胡斯",
    traditionalName: "奧爾胡斯",
    airports: [
      {
        code: "AAR",
        name: "Aarhus airport",
        chineseName: "奥胡斯机场",
        traditionalName: "奧爾胡斯機場",
      },
    ],
  },
  AAT: {
    code: "AAT",
    name: "ALTAY",
    chineseName: "阿勒泰",
    traditionalName: "阿勒泰",
    airports: [
      {
        code: "AAT",
        name: "Altay airport",
        chineseName: "雪都机场",
        traditionalName: "雪都機場",
      },
    ],
  },
  AAX: {
    code: "AAX",
    name: "ARAXA",
    chineseName: "阿拉沙",
    traditionalName: "阿拉沙",
    airports: [
      {
        code: "AAX",
        name: "Araxa airport",
        chineseName: "阿拉沙机场",
        traditionalName: "阿拉沙機場",
      },
    ],
  },
  AAY: {
    code: "AAY",
    name: "AL GHAYDAH",
    chineseName: "艾尔格哈达",
    traditionalName: "艾爾格哈達",
    airports: [
      {
        code: "AAY",
        name: "Al ghaydah airport",
        chineseName: "艾尔格哈达机场",
        traditionalName: "艾爾格哈達機場",
      },
    ],
  },
  AAZ: {
    code: "AAZ",
    name: "QUETZALTENANGO",
    chineseName: "克萨尔特南戈",
    traditionalName: "克薩爾特南戈",
    airports: [
      {
        code: "AAZ",
        name: "Quetzaltenango airport",
        chineseName: "克萨尔特南戈机场",
        traditionalName: "克薩爾特南戈機場",
      },
    ],
  },
  ABA: {
    code: "ABA",
    name: "ABAKAN",
    chineseName: "阿巴坎",
    traditionalName: "阿巴坎",
    airports: [
      {
        code: "ABA",
        name: "Abakan airport",
        chineseName: "阿巴坎机场",
        traditionalName: "阿巴坎機場",
      },
    ],
  },
  ABB: {
    code: "ABB",
    name: "ASABA",
    chineseName: "阿萨巴",
    traditionalName: "阿薩巴",
    airports: [
      {
        code: "ABB",
        name: "Asaba intl.",
        chineseName: "阿萨巴国际机场",
        traditionalName: "阿薩巴國際機場",
      },
    ],
  },
  ABC: {
    code: "ABC",
    name: "ALBACETE",
    chineseName: "阿尔巴塞特",
    traditionalName: "阿爾巴塞特",
    airports: [
      {
        code: "ABC",
        name: "Albacete airport",
        chineseName: "阿尔巴塞特机场",
        traditionalName: "阿爾巴塞特機場",
      },
    ],
  },
  ABD: {
    code: "ABD",
    name: "ABADAN",
    chineseName: "阿巴丹",
    traditionalName: "阿巴丹",
    airports: [
      {
        code: "ABD",
        name: "Abadan airport",
        chineseName: "阿巴丹机场",
        traditionalName: "阿巴丹機場",
      },
    ],
  },
  ABE: {
    code: "ABE",
    name: "ALLENTOWN",
    chineseName: "阿伦敦",
    traditionalName: "阿倫敦",
    airports: [
      {
        code: "ABE",
        name: "Lehigh valley intl",
        chineseName: "利哈伊谷国际机场",
        traditionalName: "利哈伊穀國際機場",
      },
    ],
  },
  ABF: {
    code: "ABF",
    name: "ABAIANG",
    chineseName: "阿拜昂环礁",
    traditionalName: "阿拜昂環礁",
    airports: [
      {
        code: "ABF",
        name: "Abaiang airport",
        chineseName: "阿拜昂环礁机场",
        traditionalName: "阿拜昂環礁機場",
      },
    ],
  },
  ABI: {
    code: "ABI",
    name: "ABILENE",
    chineseName: "阿比林",
    traditionalName: "阿比林",
    airports: [
      {
        code: "ABI",
        name: "Abilene reg. airport",
        chineseName: "阿比林地方机场",
        traditionalName: "阿比林地方機場",
      },
    ],
  },
  ABJ: {
    code: "ABJ",
    name: "ABIDJAN",
    chineseName: "阿比让",
    traditionalName: "阿必尚",
    airports: [
      {
        code: "ABJ",
        name: "Felix houphouet-boigny",
        chineseName: "费里克斯霍佛特博伊机场",
        traditionalName: "費裏克斯霍佛特博伊機場",
      },
    ],
  },
  ABK: {
    code: "ABK",
    name: "KEBRI DEHAR",
    chineseName: "卡卜里达尔",
    traditionalName: "卡蔔裏達爾",
    airports: [
      {
        code: "ABK",
        name: "Kebri dehar airport",
        chineseName: "卡布里达机场",
        traditionalName: "卡布裡達機場",
      },
    ],
  },
  ABL: {
    code: "ABL",
    name: "AMBLER",
    chineseName: "安布勒",
    traditionalName: "安布勒",
    airports: [
      {
        code: "ABL",
        name: "Ambler airport",
        chineseName: "安布勒机场",
        traditionalName: "安布勒機場",
      },
    ],
  },
  ABM: {
    code: "ABM",
    name: "BAMAGA",
    chineseName: "巴马加",
    traditionalName: "巴馬加",
    airports: [
      {
        code: "ABM",
        name: "Northern peninsula",
        chineseName: "巴马加机场",
        traditionalName: "巴馬加機場",
      },
    ],
  },
  ABQ: {
    code: "ABQ",
    name: "ALBUQUERQUE",
    chineseName: "阿尔伯克基",
    traditionalName: "阿爾伯克基",
    airports: [
      {
        code: "ABQ",
        name: "International sunport",
        chineseName: "阿尔伯克基国际机场",
        traditionalName: "阿爾伯克基國際機場",
      },
    ],
  },
  ABR: {
    code: "ABR",
    name: "ABERDEEN",
    chineseName: "阿伯丁",
    traditionalName: "亞伯丁",
    airports: [
      {
        code: "ABR",
        name: "Aberdeen reg. airport",
        chineseName: "阿伯丁地方机场",
        traditionalName: "亞伯丁地方機場",
      },
    ],
  },
  ABS: {
    code: "ABS",
    name: "ABU SIMBEL",
    chineseName: "阿布辛贝",
    traditionalName: "阿布辛貝",
    airports: [
      {
        code: "ABS",
        name: "Abu simbel airport",
        chineseName: "阿布辛贝勒机场",
        traditionalName: "阿布辛貝勒機場",
      },
    ],
  },
  ABT: {
    code: "ABT",
    name: "AL BAHA",
    chineseName: "阿尔巴哈",
    traditionalName: "阿爾巴哈",
    airports: [
      {
        code: "ABT",
        name: "Al-aqiq",
        chineseName: "阿尔阿奇克机场",
        traditionalName: "阿爾阿奇克機場",
      },
    ],
  },
  ABU: {
    code: "ABU",
    name: "ATAMBUA",
    chineseName: "阿坦布阿",
    traditionalName: "阿坦布阿",
    airports: [
      {
        code: "ABU",
        name: "Haliwen",
        chineseName: "阿坦布阿机场",
        traditionalName: "阿坦布阿機場",
      },
    ],
  },
  ABV: {
    code: "ABV",
    name: "ABUJA",
    chineseName: "阿布贾",
    traditionalName: "阿布札",
    airports: [
      {
        code: "ABV",
        name: "Nnamdi azikiwe intl",
        chineseName: "纳姆迪阿齐基韦国际机场",
        traditionalName: "納姆迪阿齊基韋國際機場",
      },
    ],
  },
  ABX: {
    code: "ABX",
    name: "ALBURY",
    chineseName: "奥尔伯里",
    traditionalName: "奧爾伯裏",
    airports: [
      {
        code: "ABX",
        name: "Albury",
        chineseName: "奥尔伯里机场",
        traditionalName: "奧爾伯裏機場",
      },
    ],
  },
  ABY: {
    code: "ABY",
    name: "ALBANY",
    chineseName: "奥尔巴尼",
    traditionalName: "奧爾巴尼",
    airports: [
      {
        code: "ABY",
        name: "Southwest georgia rgnl",
        chineseName: "多格尔提郡机场",
        traditionalName: "多格爾提郡機場",
      },
    ],
  },
  ABZ: {
    code: "ABZ",
    name: "ABERDEEN",
    chineseName: "阿伯丁",
    traditionalName: "亞伯丁",
    airports: [
      {
        code: "ABZ",
        name: "Dyce",
        chineseName: "阿伯丁机场",
        traditionalName: "亞伯丁機場",
      },
    ],
  },
  ACA: {
    code: "ACA",
    name: "ACAPULCO",
    chineseName: "阿卡普尔科",
    traditionalName: "阿卡普爾科",
    airports: [
      {
        code: "ACA",
        name: "Juan n. alvarez intl",
        chineseName: "胡安阿尔瓦雷斯国际机场",
        traditionalName: "胡安阿爾瓦雷斯國際機場",
      },
    ],
  },
  ACC: {
    code: "ACC",
    name: "ACCRA",
    chineseName: "阿克拉",
    traditionalName: "阿克拉",
    airports: [
      {
        code: "ACC",
        name: "Kotoka intl",
        chineseName: "科托卡国际机场",
        traditionalName: "科托卡國際機場",
      },
    ],
  },
  ACD: {
    code: "ACD",
    name: "ACANDI",
    chineseName: "阿坎迪",
    traditionalName: "阿坎迪",
    airports: [
      {
        code: "ACD",
        name: "Alcides fernandez",
        chineseName: "阿尔西德斯·费尔南德斯机场",
        traditionalName: "阿爾西德斯·費爾南德斯機場",
      },
    ],
  },
  ACE: {
    code: "ACE",
    name: "LANZAROTE",
    chineseName: "兰萨罗特市",
    traditionalName: "蘭薩羅特市",
    airports: [
      {
        code: "ACE",
        name: "Lanzarote airport",
        chineseName: "兰萨罗特机场",
        traditionalName: "蘭薩羅特機場",
      },
    ],
  },
  ACF: {
    code: "ACF",
    name: "ALAER",
    chineseName: "阿拉尔",
    traditionalName: "阿拉爾",
    airports: [
      {
        code: "ACF",
        name: "Alaer talimu",
        chineseName: "塔里木机场",
        traditionalName: "塔里木機場",
      },
    ],
  },
  ACH: {
    code: "ACH",
    name: "ALTENRHEIN",
    chineseName: "圣加仑腾莱茵",
    traditionalName: "聖加侖騰萊茵",
    airports: [
      {
        code: "ACH",
        name: "St gallen-altenrhein",
        chineseName: "圣加仑阿尔腾莱茵机场",
        traditionalName: "聖加侖阿爾騰萊茵機場",
      },
    ],
  },
  ACI: {
    code: "ACI",
    name: "ALDERNEY",
    chineseName: "奥尔德尼",
    traditionalName: "奧爾德尼",
    airports: [
      {
        code: "ACI",
        name: "Alderney airport",
        chineseName: "奥尔德尼机场",
        traditionalName: "奧爾德尼機場",
      },
    ],
  },
  ACK: {
    code: "ACK",
    name: "NANTUCKET",
    chineseName: "楠塔基特",
    traditionalName: "楠塔基特",
    airports: [
      {
        code: "ACK",
        name: "Memorial",
        chineseName: "楠塔基特机场",
        traditionalName: "楠塔基特機場",
      },
    ],
  },
  ACO: {
    code: "ACO",
    name: "COBANO",
    chineseName: "阿斯科纳",
    traditionalName: "阿斯科納",
    airports: [
      {
        code: "ACO",
        name: "Cobano airport",
        chineseName: "阿斯科纳机场",
        traditionalName: "阿斯科納機場",
      },
    ],
  },
  ACP: {
    code: "ACP",
    name: "MARAGHEH",
    chineseName: "马拉盖",
    traditionalName: "馬拉蓋",
    airports: [
      {
        code: "ACP",
        name: "Sahand",
        chineseName: "萨罕德机场",
        traditionalName: "薩罕德機場",
      },
    ],
  },
  ACT: {
    code: "ACT",
    name: "WACO",
    chineseName: "韦科",
    traditionalName: "韋科",
    airports: [
      {
        code: "ACT",
        name: "Waco reg. airport",
        chineseName: "韦科地方机场",
        traditionalName: "韋科地方機場",
      },
    ],
  },
  ACV: {
    code: "ACV",
    name: "ARCATA/EUREKA",
    chineseName: "加利福尼亚州",
    traditionalName: "加利福尼亞州",
    airports: [
      {
        code: "ACV",
        name: "Arcata apt",
        chineseName: "阿卡塔机场",
        traditionalName: "阿卡塔機場",
      },
    ],
  },
  ACX: {
    code: "ACX",
    name: "XINGYI",
    chineseName: "兴义",
    traditionalName: "興義",
    airports: [
      {
        code: "ACX",
        name: "Xingyi airport",
        chineseName: "兴义万峰林机场",
        traditionalName: "興義萬峰林機場",
      },
    ],
  },
  ACY: {
    code: "ACY",
    name: "ATLANTIC CITY",
    chineseName: "大西洋城",
    traditionalName: "大西洋城",
    airports: [
      {
        code: "ACY",
        name: "Atlantic city intl.",
        chineseName: "大西洋城国际机场",
        traditionalName: "大西洋城國際機場",
      },
    ],
  },
  ACZ: {
    code: "ACZ",
    name: "ZABOL",
    chineseName: "扎博勒",
    traditionalName: "紮博勒",
    airports: [
      {
        code: "ACZ",
        name: "Zabol airport",
        chineseName: "扎博勒机场",
        traditionalName: "紮博勒機場",
      },
    ],
  },
  ADA: {
    code: "ADA",
    name: "ADANA",
    chineseName: "阿达纳",
    traditionalName: "阿達納",
    airports: [
      {
        code: "ADA",
        name: "Sakirpasa",
        chineseName: "夏客巴萨机场",
        traditionalName: "夏客巴薩機場",
      },
    ],
  },
  ADD: {
    code: "ADD",
    name: "ADDIS ABABA",
    chineseName: "亚的斯亚贝巴",
    traditionalName: "阿迪斯阿貝巴",
    airports: [
      {
        code: "ADD",
        name: "Bole intl",
        chineseName: "博莱国际机场",
        traditionalName: "博萊國際機場",
      },
    ],
  },
  ADE: {
    code: "ADE",
    name: "ADEN",
    chineseName: "亚丁",
    traditionalName: "亞丁",
    airports: [
      {
        code: "ADE",
        name: "Aden intl.",
        chineseName: "亚丁国际机场",
        traditionalName: "亞丁國際機場",
      },
    ],
  },
  ADF: {
    code: "ADF",
    name: "ADIYAMAN",
    chineseName: "阿德亚曼",
    traditionalName: "阿德亞曼",
    airports: [
      {
        code: "ADF",
        name: "Adiyaman airport",
        chineseName: "阿德亚曼机场",
        traditionalName: "阿德亞曼機場",
      },
    ],
  },
  ADK: {
    code: "ADK",
    name: "ADAK ISLAND",
    chineseName: "埃达克",
    traditionalName: "埃達克",
    airports: [
      {
        code: "ADK",
        name: "Adak island airport",
        chineseName: "埃达克岛机场",
        traditionalName: "埃達克島機場",
      },
    ],
  },
  ADL: {
    code: "ADL",
    name: "ADELAIDE",
    chineseName: "阿德莱德",
    traditionalName: "阿德萊德",
    airports: [
      {
        code: "ADL",
        name: "Adelaide intl.",
        chineseName: "阿德莱德机场",
        traditionalName: "阿德萊德機場",
      },
    ],
  },
  ADQ: {
    code: "ADQ",
    name: "KODIAK",
    chineseName: "科迪亚克",
    traditionalName: "科迪亞克",
    airports: [
      {
        code: "ADQ",
        name: "Kodiak airport",
        chineseName: "科迪亚克机场",
        traditionalName: "科迪亞克機場",
      },
    ],
  },
  ADU: {
    code: "ADU",
    name: "ARDABIL",
    chineseName: "阿尔达比勒",
    traditionalName: "阿爾達比勒",
    airports: [
      {
        code: "ADU",
        name: "Ardabil airport",
        chineseName: "阿尔达比勒机场",
        traditionalName: "阿爾達比勒機場",
      },
    ],
  },
  ADZ: {
    code: "ADZ",
    name: "SAN ANDRES ISLAND",
    chineseName: "圣安德烈斯岛",
    traditionalName: "聖安德列斯島",
    airports: [
      {
        code: "ADZ",
        name: "Gustavo r. pinilla int",
        chineseName: "古斯塔沃罗哈斯皮尼利亚国际机场",
        traditionalName: "古斯塔沃羅哈斯皮尼利亞國際機場",
      },
    ],
  },
  AEA: {
    code: "AEA",
    name: "ABEMAMA",
    chineseName: "阿贝马马环礁",
    traditionalName: "阿貝馬馬環礁",
    airports: [
      {
        code: "AEA",
        name: "Abemama airport",
        chineseName: "阿贝马马机场",
        traditionalName: "阿貝馬馬機場",
      },
    ],
  },
  AEB: {
    code: "AEB",
    name: "BAISE",
    chineseName: "百色",
    traditionalName: "百色",
    airports: [
      {
        code: "AEB",
        name: "Youjiang",
        chineseName: "百色巴马机场",
        traditionalName: "百色巴馬機場",
      },
    ],
  },
  AEG: {
    code: "AEG",
    name: "PADANGSIDEMPUAN",
    chineseName: "埃克戈当",
    traditionalName: "埃克戈當",
    airports: [
      {
        code: "AEG",
        name: "Aekgodang",
        chineseName: "埃克戈当机场",
        traditionalName: "埃克戈當機場",
      },
    ],
  },
  AEH: {
    code: "AEH",
    name: "ABECHE",
    chineseName: "阿贝歇",
    traditionalName: "阿貝歇",
    airports: [
      {
        code: "AEH",
        name: "Abeche airport",
        chineseName: "阿贝歇机场",
        traditionalName: "阿貝歇機場",
      },
    ],
  },
  AEM: {
    code: "AEM",
    name: "AMGU",
    chineseName: "Amgu",
    traditionalName: "Amgu",
    airports: [
      {
        code: "AEM",
        name: "Amgu airport",
        chineseName: "AMGU机场",
        traditionalName: "Amgu機場",
      },
    ],
  },
  AER: {
    code: "AER",
    name: "SOCHI",
    chineseName: "索契",
    traditionalName: "索契",
    airports: [
      {
        code: "AER",
        name: "Sochi intl.",
        chineseName: "索契国际机场",
        traditionalName: "索契國際機場",
      },
    ],
  },
  AES: {
    code: "AES",
    name: "ALESUND",
    chineseName: "奥勒松",
    traditionalName: "奧勒松",
    airports: [
      {
        code: "AES",
        name: "Vigra",
        chineseName: "维格拉机场",
        traditionalName: "維格拉機場",
      },
    ],
  },
  AET: {
    code: "AET",
    name: "ALLAKAKET",
    chineseName: "阿拉斯加州阿拉卡凯特",
    traditionalName: "阿拉斯加州阿拉卡凱特",
    airports: [
      {
        code: "AET",
        name: "Allakaket airport",
        chineseName: "阿拉加凯特机场",
        traditionalName: "阿拉加凱特機場",
      },
    ],
  },
  AEU: {
    code: "AEU",
    name: "ABU MUSA ISLAND",
    chineseName: "阿布穆萨",
    traditionalName: "阿布穆薩",
    airports: [
      {
        code: "AEU",
        name: "Abu musa island airport",
        chineseName: "阿布穆萨机场",
        traditionalName: "阿布穆薩機場",
      },
    ],
  },
  AEX: {
    code: "AEX",
    name: "ALEXANDRIA",
    chineseName: "亚历山大城",
    traditionalName: "亞曆山大城",
    airports: [
      {
        code: "AEX",
        name: "Alexandria intl.",
        chineseName: "亚历山德里亚国际机场",
        traditionalName: "亞歷山德里亞國際機場",
      },
    ],
  },
  AEY: {
    code: "AEY",
    name: "AKUREYRI",
    chineseName: "阿库雷里",
    traditionalName: "阿庫雷裏",
    airports: [
      {
        code: "AEY",
        name: "Akureyri airport",
        chineseName: "阿克雷里机场",
        traditionalName: "阿克雷裏機場",
      },
    ],
  },
  AFA: {
    code: "AFA",
    name: "SAN RAFAEL",
    chineseName: "圣拉斐尔",
    traditionalName: "聖拉菲爾",
    airports: [
      {
        code: "AFA",
        name: "San rafael",
        chineseName: "圣拉斐尔机场",
        traditionalName: "聖拉菲爾機場",
      },
    ],
  },
  AFL: {
    code: "AFL",
    name: "ALTA FLORESTA",
    chineseName: "上弗洛雷斯塔",
    traditionalName: "上弗洛雷斯塔",
    airports: [
      {
        code: "AFL",
        name: "Oswaldo marques dias",
        chineseName: "上弗洛雷斯塔机场",
        traditionalName: "上弗洛雷斯塔機場",
      },
    ],
  },
  AGA: {
    code: "AGA",
    name: "AGADIR",
    chineseName: "阿加迪尔",
    traditionalName: "阿加迪爾",
    airports: [
      {
        code: "AGA",
        name: "Al massira",
        chineseName: "阿尔马希拉机场",
        traditionalName: "阿爾馬希拉機場",
      },
    ],
  },
  AGH: {
    code: "AGH",
    name: "ANGELHOLM/HELSINGBORG",
    chineseName: "安吉尔霍姆/赫尔辛堡",
    traditionalName: "安吉爾霍姆/赫爾辛堡",
    airports: [
      {
        code: "AGH",
        name: "Angelholm/helsingborg airport",
        chineseName: "恩厄尔霍尔姆机场",
        traditionalName: "恩厄爾霍爾姆機場",
      },
    ],
  },
  AGN: {
    code: "AGN",
    name: "ANGOON",
    chineseName: "阿拉斯加州安贡",
    traditionalName: "阿拉斯加州安貢",
    airports: [
      {
        code: "AGN",
        name: "Sea plane base",
        chineseName: "安贡水上飞机基地",
        traditionalName: "安貢水上飛機基地",
      },
    ],
  },
  AGP: {
    code: "AGP",
    name: "MALAGA",
    chineseName: "马拉加",
    traditionalName: "馬拉加",
    airports: [
      {
        code: "AGP",
        name: "Malaga airport",
        chineseName: "马拉加机场",
        traditionalName: "馬拉加機場",
      },
    ],
  },
  AGR: {
    code: "AGR",
    name: "AGRA",
    chineseName: "阿格拉",
    traditionalName: "阿格拉",
    airports: [
      {
        code: "AGR",
        name: "Agra airport",
        chineseName: "阿格拉机场",
        traditionalName: "阿格拉機場",
      },
    ],
  },
  AGS: {
    code: "AGS",
    name: "AUGUSTA",
    chineseName: "奥古斯塔",
    traditionalName: "奧古斯塔",
    airports: [
      {
        code: "AGS",
        name: "Regional (bush field)",
        chineseName: "布什机场",
        traditionalName: "布希機場",
      },
    ],
  },
  AGT: {
    code: "AGT",
    name: "CIUDAD DEL ESTE",
    chineseName: "东方市",
    traditionalName: "東方市",
    airports: [
      {
        code: "AGT",
        name: "Guarani intl",
        chineseName: "瓜拉尼国际机场",
        traditionalName: "瓜拉尼國際機場",
      },
    ],
  },
  AGU: {
    code: "AGU",
    name: "AGUASCALIENTES",
    chineseName: "阿瓜斯卡连特斯",
    traditionalName: "阿瓜斯卡達特斯",
    airports: [
      {
        code: "AGU",
        name: "Jesus teran peredo int",
        chineseName: "耶稣特朗佩雷国际机场",
        traditionalName: "耶穌特朗佩雷國際機場",
      },
    ],
  },
  AGX: {
    code: "AGX",
    name: "AGATTI ISLAND",
    chineseName: "阿格蒂岛",
    traditionalName: "阿格蒂島",
    airports: [
      {
        code: "AGX",
        name: "Agatti island airport",
        chineseName: "阿格蒂岛机场",
        traditionalName: "阿格蒂島機場",
      },
    ],
  },
  AHB: {
    code: "AHB",
    name: "ABHA",
    chineseName: "艾卜哈",
    traditionalName: "艾卜哈",
    airports: [
      {
        code: "AHB",
        name: "Abha airport",
        chineseName: "艾伯哈机场",
        traditionalName: "艾伯哈機場",
      },
    ],
  },
  AHE: {
    code: "AHE",
    name: "AHE",
    chineseName: "阿合",
    traditionalName: "阿合",
    airports: [
      {
        code: "AHE",
        name: "Ahe airport",
        chineseName: "阿黑机场",
        traditionalName: "阿黑機場",
      },
    ],
  },
  AHJ: {
    code: "AHJ",
    name: "ABA/HONGYUAN",
    chineseName: "阿坝",
    traditionalName: "阿壩",
    airports: [
      {
        code: "AHJ",
        name: "Aba/hongyuan airport",
        chineseName: "阿坝红原机场",
        traditionalName: "阿壩紅原機場",
      },
    ],
  },
  AHO: {
    code: "AHO",
    name: "ALGHERO",
    chineseName: "阿尔盖罗",
    traditionalName: "阿爾蓋羅",
    airports: [
      {
        code: "AHO",
        name: "Fertilia",
        chineseName: "费尔蒂利亚机场",
        traditionalName: "費爾蒂利亞機場",
      },
    ],
  },
  AHU: {
    code: "AHU",
    name: "AL HOCEIMA",
    chineseName: "胡塞马",
    traditionalName: "胡塞馬",
    airports: [
      {
        code: "AHU",
        name: "Cherif el idrissi",
        chineseName: "查里弗阿尔伊德里希机场",
        traditionalName: "查裏弗阿爾伊德裏希機場",
      },
    ],
  },
  AIA: {
    code: "AIA",
    name: "ALLIANCE",
    chineseName: "艾利安斯",
    traditionalName: "艾利安斯",
    airports: [
      {
        code: "AIA",
        name: "Alliance municipal",
        chineseName: "阿莱恩斯机场",
        traditionalName: "阿萊恩斯機場",
      },
    ],
  },
  AIC: {
    code: "AIC",
    name: "AIROK",
    chineseName: "艾罗克",
    traditionalName: "艾羅克",
    airports: [
      {
        code: "AIC",
        name: "Ailinglapalap",
        chineseName: "艾尔奥克机场",
        traditionalName: "艾爾奧克機場",
      },
    ],
  },
  AIM: {
    code: "AIM",
    name: "AILUK ISLAND",
    chineseName: "艾卢克岛",
    traditionalName: "艾盧克島",
    airports: [
      {
        code: "AIM",
        name: "Ailuk island airport",
        chineseName: "艾卢克岛机场",
        traditionalName: "艾盧克島機場",
      },
    ],
  },
  AIN: {
    code: "AIN",
    name: "WAINWRIGHT",
    chineseName: "阿拉斯加州温赖特",
    traditionalName: "阿拉斯加州溫賴特",
    airports: [
      {
        code: "AIN",
        name: "Wainwright airport",
        chineseName: "韦恩莱特机场",
        traditionalName: "韋恩萊特機場",
      },
    ],
  },
  AIP: {
    code: "AIP",
    name: "ADAMPUR",
    chineseName: "Ailinglapap岛城",
    traditionalName: "Ailinglapap島城",
    airports: [
      {
        code: "AIP",
        name: "Adampur airport",
        chineseName: "艾林拉帕拉普环礁机场",
        traditionalName: "艾林拉帕拉普環礁機場",
      },
    ],
  },
  AIR: {
    code: "AIR",
    name: "ARIPUANA",
    chineseName: "阿里普阿南",
    traditionalName: "阿裏普阿南",
    airports: [
      {
        code: "AIR",
        name: "Aripuana airport",
        chineseName: "阿里普阿南机场",
        traditionalName: "阿裏普阿南機場",
      },
    ],
  },
  AIS: {
    code: "AIS",
    name: "ARORAE",
    chineseName: "阿罗赖岛",
    traditionalName: "阿羅賴島",
    airports: [
      {
        code: "AIS",
        name: "Arorae airport",
        chineseName: "阿罗赖岛机场",
        traditionalName: "阿羅賴島機場",
      },
    ],
  },
  AIT: {
    code: "AIT",
    name: "AITUTAKI ISLAND",
    chineseName: "艾图塔基",
    traditionalName: "艾圖塔基",
    airports: [
      {
        code: "AIT",
        name: "Aitutaki island airport",
        chineseName: "埃图塔基机场",
        traditionalName: "埃圖塔基機場",
      },
    ],
  },
  AJA: {
    code: "AJA",
    name: "AJACCIO",
    chineseName: "阿雅克肖",
    traditionalName: "阿雅丘",
    airports: [
      {
        code: "AJA",
        name: "Napoleon bonaparte",
        chineseName: "阿雅克肖拿破仑波拿巴机场",
        traditionalName: "阿雅克肖拿破侖波拿巴機場",
      },
    ],
  },
  AJF: {
    code: "AJF",
    name: "JOUF",
    chineseName: "奥尔朱夫",
    traditionalName: "奧爾朱夫",
    airports: [
      {
        code: "AJF",
        name: "Jouf airport",
        chineseName: "约夫机场",
        traditionalName: "約夫機場",
      },
    ],
  },
  AJI: {
    code: "AJI",
    name: "AGRI",
    chineseName: "阿格里",
    traditionalName: "阿格裏",
    airports: [
      {
        code: "AJI",
        name: "Agri airport",
        chineseName: "阿格里机场",
        traditionalName: "阿格裏機場",
      },
    ],
  },
  AJL: {
    code: "AJL",
    name: "AIZAWL",
    chineseName: "艾藻尔",
    traditionalName: "艾藻爾",
    airports: [
      {
        code: "AJL",
        name: "Lengpui",
        chineseName: "艾藻尔机场",
        traditionalName: "艾藻爾機場",
      },
    ],
  },
  AJN: {
    code: "AJN",
    name: "ANJOUAN",
    chineseName: "昂儒昂",
    traditionalName: "昂德昂",
    airports: [
      {
        code: "AJN",
        name: "Ouani",
        chineseName: "奥阿尼机场",
        traditionalName: "奧阿尼機場",
      },
    ],
  },
  AJR: {
    code: "AJR",
    name: "ARVIDSJAUR",
    chineseName: "阿尔维斯尧尔",
    traditionalName: "阿爾維斯堯爾",
    airports: [
      {
        code: "AJR",
        name: "Arvidsjaur airport",
        chineseName: "阿尔维斯克尔机场",
        traditionalName: "阿爾維斯克爾機場",
      },
    ],
  },
  AJU: {
    code: "AJU",
    name: "ARACAJU",
    chineseName: "阿拉卡茹",
    traditionalName: "阿拉卡茹",
    airports: [
      {
        code: "AJU",
        name: "Santa maria",
        chineseName: "圣玛丽亚机场",
        traditionalName: "聖瑪麗亞機場",
      },
    ],
  },
  AKA: {
    code: "AKA",
    name: "ANKANG",
    chineseName: "安康",
    traditionalName: "安康",
    airports: [
      {
        code: "AKA",
        name: "Fuqiang",
        chineseName: "安康富强机场",
        traditionalName: "安康富强機場",
      },
    ],
  },
  AKB: {
    code: "AKB",
    name: "ATKA",
    chineseName: "阿拉斯加州阿特卡",
    traditionalName: "阿拉斯加州阿特卡",
    airports: [
      {
        code: "AKB",
        name: "Atka airport",
        chineseName: "阿特卡机场",
        traditionalName: "阿特卡機場",
      },
    ],
  },
  AKH: {
    code: "AKH",
    name: "AL KHARJ",
    chineseName: "阿尔哈吉",
    traditionalName: "阿爾哈吉",
    airports: [
      {
        code: "AKH",
        name: "Prince sultan ab",
        chineseName: "Al Kharj机场",
        traditionalName: "Al Kharj機場",
      },
    ],
  },
  AKI: {
    code: "AKI",
    name: "AKIAK",
    chineseName: "阿拉斯加州阿基克",
    traditionalName: "阿拉斯加州阿基克",
    airports: [
      {
        code: "AKI",
        name: "Akiak airport",
        chineseName: "阿基亚克机场",
        traditionalName: "阿基亞克機場",
      },
    ],
  },
  AKJ: {
    code: "AKJ",
    name: "ASAHIKAWA",
    chineseName: "旭川",
    traditionalName: "旭川",
    airports: [
      {
        code: "AKJ",
        name: "Asahikawa airport",
        chineseName: "旭川机场",
        traditionalName: "旭川機場",
      },
    ],
  },
  AKK: {
    code: "AKK",
    name: "AKHIOK",
    chineseName: "阿拉斯加州阿乔克",
    traditionalName: "阿拉斯加州阿喬克",
    airports: [
      {
        code: "AKK",
        name: "Akhiok airport",
        chineseName: "阿克希奥克机场",
        traditionalName: "阿克希奧克機場",
      },
    ],
  },
  AKL: {
    code: "AKL",
    name: "AUCKLAND",
    chineseName: "奥克兰",
    traditionalName: "奧克蘭",
    airports: [
      {
        code: "AKL",
        name: "Auckland intl.",
        chineseName: "奥克兰国际机场",
        traditionalName: "奧克蘭國際機場",
      },
    ],
  },
  AKN: {
    code: "AKN",
    name: "KING SALMON",
    chineseName: "萨蒙王村",
    traditionalName: "薩蒙王村",
    airports: [
      {
        code: "AKN",
        name: "King salmon airport",
        chineseName: "萨蒙王村机场",
        traditionalName: "薩蒙王村機場",
      },
    ],
  },
  AKP: {
    code: "AKP",
    name: "ANAKTUVUK PASS",
    chineseName: "阿纳克图乌克",
    traditionalName: "阿納克圖烏克",
    airports: [
      {
        code: "AKP",
        name: "Anaktuvuk pass airport",
        chineseName: "阿纳克图乌克机场",
        traditionalName: "阿納克圖烏克機場",
      },
    ],
  },
  AKR: {
    code: "AKR",
    name: "AKURE",
    chineseName: "阿库雷",
    traditionalName: "阿庫雷",
    airports: [
      {
        code: "AKR",
        name: "Akure airport",
        chineseName: "阿库雷机场",
        traditionalName: "阿庫雷機場",
      },
    ],
  },
  AKS: {
    code: "AKS",
    name: "AUKI",
    chineseName: "奥基",
    traditionalName: "奧基",
    airports: [
      {
        code: "AKS",
        name: "Gwaunaru'u",
        chineseName: "瓜乌纳鲁乌机场",
        traditionalName: "瓜烏納魯烏機場",
      },
    ],
  },
  AKU: {
    code: "AKU",
    name: "AKSU",
    chineseName: "阿克苏",
    traditionalName: "阿克蘇",
    airports: [
      {
        code: "AKU",
        name: "Aksu airport",
        chineseName: "红旗坡机场",
        traditionalName: "紅旗坡機場",
      },
    ],
  },
  AKV: {
    code: "AKV",
    name: "AKULIVIK",
    chineseName: "阿库里维克",
    traditionalName: "阿庫裡維克",
    airports: [
      {
        code: "AKV",
        name: "Akulivik airport",
        chineseName: "阿库里维克机场",
        traditionalName: "阿庫裡維克機場",
      },
    ],
  },
  AKX: {
    code: "AKX",
    name: "AKTOBE",
    chineseName: "阿克纠宾斯克",
    traditionalName: "阿克糾賓斯克",
    airports: [
      {
        code: "AKX",
        name: "Aktobe airport",
        chineseName: "阿克托别机场",
        traditionalName: "阿克托別機場",
      },
    ],
  },
  AKY: {
    code: "AKY",
    name: "SITTWE",
    chineseName: "实兑",
    traditionalName: "實兌",
    airports: [
      {
        code: "AKY",
        name: "Sittwe airport",
        chineseName: "实兑机场",
        traditionalName: "實兌機場",
      },
    ],
  },
  ALA: {
    code: "ALA",
    name: "ALMATY",
    chineseName: "阿拉木图",
    traditionalName: "阿拉木圖",
    airports: [
      {
        code: "ALA",
        name: "Almaty intl.",
        chineseName: "阿拉木图国际机场",
        traditionalName: "阿拉木圖國際機場",
      },
    ],
  },
  ALB: {
    code: "ALB",
    name: "ALBANY",
    chineseName: "奥尔巴尼",
    traditionalName: "奧爾巴尼",
    airports: [
      {
        code: "ALB",
        name: "Albany intl.",
        chineseName: "奥尔巴尼国际机场",
        traditionalName: "奧爾巴尼國際機場",
      },
    ],
  },
  ALC: {
    code: "ALC",
    name: "ALICANTE",
    chineseName: "阿利坎特",
    traditionalName: "阿利坎特",
    airports: [
      {
        code: "ALC",
        name: "Alicante airport",
        chineseName: "阿里坎特机场",
        traditionalName: "阿裡坎特機場",
      },
    ],
  },
  ALF: {
    code: "ALF",
    name: "ALTA",
    chineseName: "阿尔塔",
    traditionalName: "阿爾塔",
    airports: [
      {
        code: "ALF",
        name: "Alta airport",
        chineseName: "阿尔塔机场",
        traditionalName: "阿爾塔機場",
      },
    ],
  },
  ALG: {
    code: "ALG",
    name: "ALGIERS",
    chineseName: "阿尔及尔",
    traditionalName: "阿爾及爾",
    airports: [
      {
        code: "ALG",
        name: "Houari boumediene",
        chineseName: "霍阿里博梅蒂纳机场",
        traditionalName: "霍阿裏博梅蒂納機場",
      },
    ],
  },
  ALH: {
    code: "ALH",
    name: "ALBANY",
    chineseName: "奥尔巴尼",
    traditionalName: "奧爾巴尼",
    airports: [
      {
        code: "ALH",
        name: "Albany airport",
        chineseName: "奥尔巴尼机场",
        traditionalName: "奧爾巴尼機場",
      },
    ],
  },
  ALO: {
    code: "ALO",
    name: "WATERLOO",
    chineseName: "滑铁卢",
    traditionalName: "滑鐵盧",
    airports: [
      {
        code: "ALO",
        name: "Waterloo reg. airport",
        chineseName: "滑铁卢机场",
        traditionalName: "滑鐵盧機場",
      },
    ],
  },
  ALP: {
    code: "ALP",
    name: "ALEPPO",
    chineseName: "阿勒颇",
    traditionalName: "阿勒頗",
    airports: [
      {
        code: "ALP",
        name: "Aleppo intl.",
        chineseName: "阿勒波机场",
        traditionalName: "阿勒波機場",
      },
    ],
  },
  ALS: {
    code: "ALS",
    name: "ALAMOSA",
    chineseName: "科罗拉多州阿拉莫萨",
    traditionalName: "科羅拉多州阿拉莫薩",
    airports: [
      {
        code: "ALS",
        name: "San luis valley rgnl",
        chineseName: "圣路易斯谷地区机场",
        traditionalName: "聖路易斯穀地區機場",
      },
    ],
  },
  ALW: {
    code: "ALW",
    name: "WALLA WALLA",
    chineseName: "沃拉沃拉",
    traditionalName: "沃拉沃拉",
    airports: [
      {
        code: "ALW",
        name: "Walla walla reg. airport",
        chineseName: "沃拉沃拉机场",
        traditionalName: "沃拉沃拉機場",
      },
    ],
  },
  ALY: {
    code: "ALY",
    name: "ALEXANDRIA",
    chineseName: "亚历山大",
    traditionalName: "亞歷山大",
    airports: [
      {
        code: "HBE",
        name: "Borg el arab",
        chineseName: "博格埃尔阿拉伯机场",
        traditionalName: "柏格埃爾阿拉伯機場",
      },
    ],
  },
  ALZ: {
    code: "ALZ",
    name: "ALITAK",
    chineseName: "阿利塔克",
    traditionalName: "阿利塔克",
    airports: [
      {
        code: "ALZ",
        name: "Sea plane base",
        chineseName: "水上飞机场",
        traditionalName: "水上飛機場",
      },
    ],
  },
  AMA: {
    code: "AMA",
    name: "AMARILLO",
    chineseName: "阿马里洛",
    traditionalName: "阿馬裏洛",
    airports: [
      {
        code: "AMA",
        name: "Rick husband intl",
        chineseName: "里克哈兹班德国际机场",
        traditionalName: "裡克哈茲班德國際機場",
      },
    ],
  },
  AMD: {
    code: "AMD",
    name: "AHMEDABAD",
    chineseName: "艾哈迈达巴德",
    traditionalName: "艾哈默德巴德",
    airports: [
      {
        code: "AMD",
        name: "S.vallabhbhai patel",
        chineseName: "艾哈迈达巴德国际机场",
        traditionalName: "艾哈默德巴德國際機場",
      },
    ],
  },
  AMH: {
    code: "AMH",
    name: "ARBA MINCH",
    chineseName: "阿尔巴门奇",
    traditionalName: "阿爾巴門奇",
    airports: [
      {
        code: "AMH",
        name: "Arba minch airport",
        chineseName: "阿尔巴门奇机场",
        traditionalName: "阿爾巴門奇機場",
      },
    ],
  },
  AMM: {
    code: "AMM",
    name: "AMMAN",
    chineseName: "安曼",
    traditionalName: "安曼",
    airports: [
      {
        code: "ADJ",
        name: "Marka intl",
        chineseName: "安曼机场",
        traditionalName: "安曼機場",
      },
      {
        code: "AMM",
        name: "Queen alia intl",
        chineseName: "阿里亚皇后国际机场",
        traditionalName: "阿裏亞皇后國際機場",
      },
    ],
  },
  AMQ: {
    code: "AMQ",
    name: "AMBON",
    chineseName: "安汶",
    traditionalName: "安汶",
    airports: [
      {
        code: "AMQ",
        name: "Pattimura",
        chineseName: "帕提姆拉机场",
        traditionalName: "帕提姆拉機場",
      },
    ],
  },
  AMS: {
    code: "AMS",
    name: "AMSTERDAM",
    chineseName: "阿姆斯特丹",
    traditionalName: "阿姆斯特丹",
    airports: [
      {
        code: "AMS",
        name: "Schiphol airport",
        chineseName: "史基浦机场",
        traditionalName: "史基浦機場",
      },
    ],
  },
  ANC: {
    code: "ANC",
    name: "ANCHORAGE",
    chineseName: "安克雷奇",
    traditionalName: "安克雷奇",
    airports: [
      {
        code: "ANC",
        name: "Ted stevens intl",
        chineseName: "泰德史蒂文斯国际机场",
        traditionalName: "泰德史蒂文斯國際機場",
      },
      {
        code: "MRI",
        name: "Merrill field",
        chineseName: "安克雷奇机场",
        traditionalName: "安克雷奇機場",
      },
    ],
  },
  ANF: {
    code: "ANF",
    name: "ANTOFAGASTA",
    chineseName: "安托法加斯塔",
    traditionalName: "安托法加斯塔",
    airports: [
      {
        code: "ANF",
        name: "Cerro moreno",
        chineseName: "塞罗莫雷诺机场",
        traditionalName: "塞羅莫雷諾機場",
      },
    ],
  },
  ANI: {
    code: "ANI",
    name: "ANIAK",
    chineseName: "阿尼亚克",
    traditionalName: "阿尼亞克",
    airports: [
      {
        code: "ANI",
        name: "Aniak airport",
        chineseName: "阿尼亚克机场",
        traditionalName: "阿尼亞克機場",
      },
    ],
  },
  ANK: {
    code: "ANK",
    name: "ANKARA",
    chineseName: "安卡拉",
    traditionalName: "安卡拉",
    airports: [
      {
        code: "ANK",
        name: "Etimesgut",
        chineseName: "安卡拉伊蒂梅斯机场",
        traditionalName: "安卡拉伊蒂梅斯機場",
      },
      {
        code: "ESB",
        name: "Esenboga",
        chineseName: "埃森博卡机场",
        traditionalName: "埃森博卡機場",
      },
    ],
  },
  ANR: {
    code: "ANR",
    name: "ANTWERP",
    chineseName: "安特卫普",
    traditionalName: "安特衛普",
    airports: [
      {
        code: "ANR",
        name: "Antwerp intl.",
        chineseName: "安德卫普国际机场",
        traditionalName: "安德衛普國際機場",
      },
    ],
  },
  ANU: {
    code: "ANU",
    name: "ANTIGUA",
    chineseName: "安提瓜",
    traditionalName: "安提瓜",
    airports: [
      {
        code: "ANU",
        name: "V.c. bird intl",
        chineseName: "伯德国际机场",
        traditionalName: "伯德國際機場",
      },
    ],
  },
  ANV: {
    code: "ANV",
    name: "ANVIK",
    chineseName: "安维克",
    traditionalName: "安維克",
    airports: [
      {
        code: "ANV",
        name: "Anvik airport",
        chineseName: "安维克机场",
        traditionalName: "安維克機場",
      },
    ],
  },
  ANX: {
    code: "ANX",
    name: "ANDENES",
    chineseName: "安德尼斯",
    traditionalName: "安德尼斯",
    airports: [
      {
        code: "ANX",
        name: "Andoya",
        chineseName: "安德尼斯机场",
        traditionalName: "安德尼斯機場",
      },
    ],
  },
  AOG: {
    code: "AOG",
    name: "ANSHAN",
    chineseName: "鞍山",
    traditionalName: "鞍山",
    airports: [
      {
        code: "AOG",
        name: "Teng'ao",
        chineseName: "腾鳌机场",
        traditionalName: "騰鼇機場",
      },
    ],
  },
  AOI: {
    code: "AOI",
    name: "ANCONA",
    chineseName: "安科纳",
    traditionalName: "安科納",
    airports: [
      {
        code: "AOI",
        name: "Falconara",
        chineseName: "法尔科纳拉机场",
        traditionalName: "法爾科納拉機場",
      },
    ],
  },
  AOJ: {
    code: "AOJ",
    name: "AOMORI",
    chineseName: "青森",
    traditionalName: "青森",
    airports: [
      {
        code: "AOJ",
        name: "Aomori airport",
        chineseName: "青森机场",
        traditionalName: "青森機場",
      },
    ],
  },
  AOK: {
    code: "AOK",
    name: "KARPATHOS",
    chineseName: "卡尔帕索斯岛",
    traditionalName: "卡爾帕索斯島",
    airports: [
      {
        code: "AOK",
        name: "Karpathos airport",
        chineseName: "卡尔帕索斯机场",
        traditionalName: "卡爾帕索斯機場",
      },
    ],
  },
  AOO: {
    code: "AOO",
    name: "ALTOONA",
    chineseName: "阿图纳",
    traditionalName: "阿圖納",
    airports: [
      {
        code: "AOO",
        name: "Blair county",
        chineseName: "阿尔托纳机场",
        traditionalName: "阿爾托納機場",
      },
    ],
  },
  AOR: {
    code: "AOR",
    name: "ALOR SETAR",
    chineseName: "亚罗士打",
    traditionalName: "阿羅士打",
    airports: [
      {
        code: "AOR",
        name: "Sultan abdul halim",
        chineseName: "苏丹阿都哈林机场",
        traditionalName: "蘇丹阿都哈林機場",
      },
    ],
  },
  AOS: {
    code: "AOS",
    name: "AMOOK BAY",
    chineseName: "阿穆克湾",
    traditionalName: "阿穆克灣",
    airports: [
      {
        code: "AOS",
        name: "Sea plane base",
        chineseName: "阿姆克水上飞机基地",
        traditionalName: "阿姆克水上飛機基地",
      },
    ],
  },
  APC: {
    code: "APC",
    name: "NAPA",
    chineseName: "纳帕",
    traditionalName: "納帕",
    airports: [
      {
        code: "APC",
        name: "Napa county",
        chineseName: "纳帕机场",
        traditionalName: "納帕機場",
      },
    ],
  },
  APF: {
    code: "APF",
    name: "NAPLES",
    chineseName: "那不勒斯",
    traditionalName: "那不勒斯",
    airports: [
      {
        code: "APF",
        name: "Naples municipal",
        chineseName: "那不勒斯机场",
        traditionalName: "那不勒斯機場",
      },
    ],
  },
  APK: {
    code: "APK",
    name: "APATAKI",
    chineseName: "阿帕塔基",
    traditionalName: "阿帕塔基",
    airports: [
      {
        code: "APK",
        name: "Apataki airport",
        chineseName: "阿帕塔基机场",
        traditionalName: "阿帕塔基機場",
      },
    ],
  },
  APL: {
    code: "APL",
    name: "NAMPULA",
    chineseName: "楠普拉",
    traditionalName: "楠普拉",
    airports: [
      {
        code: "APL",
        name: "Nampula airport",
        chineseName: "卢姆波机场",
        traditionalName: "盧姆波機場",
      },
    ],
  },
  APN: {
    code: "APN",
    name: "ALPENA",
    chineseName: "阿尔皮纳",
    traditionalName: "阿爾皮納",
    airports: [
      {
        code: "APN",
        name: "Alpena county regional",
        chineseName: "阿尔皮纳郡地区机场",
        traditionalName: "阿爾皮納郡地區機場",
      },
    ],
  },
  APO: {
    code: "APO",
    name: "APARTADO",
    chineseName: "阿帕",
    traditionalName: "阿帕",
    airports: [
      {
        code: "APO",
        name: "Carepa-a.r. betancourt",
        chineseName: "阿帕尔塔多机场",
        traditionalName: "阿帕爾塔多機場",
      },
    ],
  },
  APW: {
    code: "APW",
    name: "APIA",
    chineseName: "阿皮亚",
    traditionalName: "亞庇",
    airports: [
      {
        code: "APW",
        name: "Faleolo intl",
        chineseName: "法莱奥洛国际机场",
        traditionalName: "法萊奧洛國際機場",
      },
      {
        code: "FGI",
        name: "Fagali'i",
        chineseName: "法加里机场",
        traditionalName: "法加里機場",
      },
    ],
  },
  AQA: {
    code: "AQA",
    name: "ARARAQUARA",
    chineseName: "阿拉拉夸拉",
    traditionalName: "阿拉拉誇拉",
    airports: [
      {
        code: "AQA",
        name: "Bartolomeu de gusmao",
        chineseName: "阿拉拉夸拉机场",
        traditionalName: "阿拉拉誇拉機場",
      },
    ],
  },
  AQG: {
    code: "AQG",
    name: "ANQING",
    chineseName: "安庆",
    traditionalName: "安慶",
    airports: [
      {
        code: "AQG",
        name: "Tianzhushan",
        chineseName: "天柱山机场",
        traditionalName: "天柱山機場",
      },
    ],
  },
  AQI: {
    code: "AQI",
    name: "QAISUMAH",
    chineseName: "Qaisumah",
    traditionalName: "Qaisumah",
    airports: [
      {
        code: "AQI",
        name: "Hafar al batin",
        chineseName: "凯苏马机场",
        traditionalName: "凱蘇馬機場",
      },
    ],
  },
  AQJ: {
    code: "AQJ",
    name: "AQABA",
    chineseName: "亚喀巴",
    traditionalName: "亞喀巴",
    airports: [
      {
        code: "AQJ",
        name: "King hussein intl",
        chineseName: "侯赛因国王国际机场",
        traditionalName: "侯賽因國王國際機場",
      },
    ],
  },
  AQP: {
    code: "AQP",
    name: "AREQUIPA",
    chineseName: "阿雷基帕",
    traditionalName: "阿雷基帕",
    airports: [
      {
        code: "AQP",
        name: "Rodriguez ballon intl",
        chineseName: "罗德里格斯巴隆国际机场",
        traditionalName: "羅德里格斯巴隆國際機場",
      },
    ],
  },
  ARC: {
    code: "ARC",
    name: "ARCTIC VILLAGE",
    chineseName: "北极村",
    traditionalName: "北極村",
    airports: [
      {
        code: "ARC",
        name: "Arctic village airport",
        chineseName: "北极村机场",
        traditionalName: "北極村機場",
      },
    ],
  },
  ARD: {
    code: "ARD",
    name: "ALOR",
    chineseName: "阿洛岛",
    traditionalName: "阿洛島",
    airports: [
      {
        code: "ARD",
        name: "Mali",
        chineseName: "阿洛岛机场",
        traditionalName: "阿洛島機場",
      },
    ],
  },
  ARH: {
    code: "ARH",
    name: "ARKHANGELSK",
    chineseName: "阿尔汉格尔斯克",
    traditionalName: "阿爾漢格爾斯克",
    airports: [
      {
        code: "ARH",
        name: "Talagi",
        chineseName: "塔拉吉机场",
        traditionalName: "塔拉吉機場",
      },
    ],
  },
  ARI: {
    code: "ARI",
    name: "ARICA",
    chineseName: "阿里卡",
    traditionalName: "阿里卡",
    airports: [
      {
        code: "ARI",
        name: "Chacalluta",
        chineseName: "查卡鲁塔机场",
        traditionalName: "查卡魯塔機場",
      },
    ],
  },
  ARK: {
    code: "ARK",
    name: "ARUSHA",
    chineseName: "阿鲁沙",
    traditionalName: "阿魯沙",
    airports: [
      {
        code: "ARK",
        name: "Arusha airport",
        chineseName: "阿鲁沙机场",
        traditionalName: "阿魯沙機場",
      },
    ],
  },
  ARM: {
    code: "ARM",
    name: "ARMIDALE",
    chineseName: "阿米代尔",
    traditionalName: "阿米代爾",
    airports: [
      {
        code: "ARM",
        name: "Armidale airport",
        chineseName: "阿米代尔机场",
        traditionalName: "阿米代爾機場",
      },
    ],
  },
  ART: {
    code: "ART",
    name: "WATERTOWN",
    chineseName: "沃特敦",
    traditionalName: "沃特敦",
    airports: [
      {
        code: "ART",
        name: "Watertown intl.",
        chineseName: "沃特敦国际机场",
        traditionalName: "沃特敦國際機場",
      },
    ],
  },
  ARU: {
    code: "ARU",
    name: "ARACATUBA",
    chineseName: "阿拉萨图巴",
    traditionalName: "阿拉薩圖巴",
    airports: [
      {
        code: "ARU",
        name: "Dario guarita",
        chineseName: "阿拉萨图巴机场",
        traditionalName: "阿拉薩圖巴機場",
      },
    ],
  },
  ARW: {
    code: "ARW",
    name: "ARAD",
    chineseName: "阿拉德",
    traditionalName: "阿拉德",
    airports: [
      {
        code: "ARW",
        name: "Arad airport",
        chineseName: "阿拉德机场",
        traditionalName: "阿拉德機場",
      },
    ],
  },
  ASB: {
    code: "ASB",
    name: "ASHGABAT",
    chineseName: "阿什哈巴德",
    traditionalName: "阿什哈巴德",
    airports: [
      {
        code: "ASB",
        name: "Ashgabat intl.",
        chineseName: "阿什哈巴德机场",
        traditionalName: "阿什哈巴德機場",
      },
    ],
  },
  ASD: {
    code: "ASD",
    name: "ANDROS TOWN",
    chineseName: "安德罗斯城",
    traditionalName: "安德羅斯城",
    airports: [
      {
        code: "ASD",
        name: "Andros town intl.",
        chineseName: "安德罗斯城机场",
        traditionalName: "安德羅斯城機場",
      },
    ],
  },
  ASE: {
    code: "ASE",
    name: "ASPEN",
    chineseName: "阿斯彭",
    traditionalName: "阿斯彭",
    airports: [
      {
        code: "ASE",
        name: "Pitkin county",
        chineseName: "皮特金县机场",
        traditionalName: "皮特金縣機場",
      },
    ],
  },
  ASF: {
    code: "ASF",
    name: "ASTRAKHAN",
    chineseName: "阿斯特拉罕",
    traditionalName: "阿斯特拉罕",
    airports: [
      {
        code: "ASF",
        name: "Astrakhan airport",
        chineseName: "阿斯特拉罕机场",
        traditionalName: "阿斯特拉罕機場",
      },
    ],
  },
  ASJ: {
    code: "ASJ",
    name: "AMAMI",
    chineseName: "奄美大岛",
    traditionalName: "奄美大島",
    airports: [
      {
        code: "ASJ",
        name: "Amami airport",
        chineseName: "奄美大岛机场",
        traditionalName: "奄美大島機場",
      },
    ],
  },
  ASM: {
    code: "ASM",
    name: "ASMARA",
    chineseName: "阿斯马拉",
    traditionalName: "阿斯馬拉",
    airports: [
      {
        code: "ASM",
        name: "Asmara intl.",
        chineseName: "阿斯马拉国际机场",
        traditionalName: "阿斯馬拉國際機場",
      },
    ],
  },
  ASO: {
    code: "ASO",
    name: "ASOSA",
    chineseName: "阿索萨",
    traditionalName: "阿索薩",
    airports: [
      {
        code: "ASO",
        name: "Asosa airport",
        chineseName: "阿索萨机场",
        traditionalName: "阿索薩機場",
      },
    ],
  },
  ASP: {
    code: "ASP",
    name: "ALICE SPRINGS",
    chineseName: "艾丽斯斯普林斯",
    traditionalName: "艾麗斯斯普林斯",
    airports: [
      {
        code: "ASP",
        name: "Alice springs airport",
        chineseName: "艾丽斯斯普林斯机场",
        traditionalName: "愛麗絲斯普林斯機場",
      },
    ],
  },
  ASR: {
    code: "ASR",
    name: "KAYSERI",
    chineseName: "开塞利",
    traditionalName: "開塞利",
    airports: [
      {
        code: "ASR",
        name: "Erkilet",
        chineseName: "埃尔基莱特机场",
        traditionalName: "埃爾基萊特機場",
      },
    ],
  },
  ASU: {
    code: "ASU",
    name: "ASUNCION",
    chineseName: "亚松森",
    traditionalName: "亞松森",
    airports: [
      {
        code: "ASU",
        name: "Silvio pettirossi intl",
        chineseName: "西尔维奥佩蒂罗西国际机场",
        traditionalName: "西爾維奧佩蒂羅西國際機場",
      },
    ],
  },
  ASV: {
    code: "ASV",
    name: "AMBOSELI",
    chineseName: "安博塞利",
    traditionalName: "安博塞利",
    airports: [
      {
        code: "ASV",
        name: "Amboseli airport",
        chineseName: "安博塞利机场",
        traditionalName: "安博塞利機場",
      },
    ],
  },
  ASW: {
    code: "ASW",
    name: "ASWAN",
    chineseName: "阿斯旺",
    traditionalName: "阿斯旺",
    airports: [
      {
        code: "ASW",
        name: "Aswan intl.",
        chineseName: "阿斯旺国际机场",
        traditionalName: "阿斯旺國際機場",
      },
    ],
  },
  ATA: {
    code: "ATA",
    name: "HUARAZ",
    chineseName: "安塔",
    traditionalName: "安塔",
    airports: [
      {
        code: "ATA",
        name: "German arias graziani",
        chineseName: "安塔机场",
        traditionalName: "安塔機場",
      },
    ],
  },
  ATD: {
    code: "ATD",
    name: "ATOIFI",
    chineseName: "阿托菲",
    traditionalName: "阿托菲",
    airports: [
      {
        code: "ATD",
        name: "Atoifi airport",
        chineseName: "阿托伊菲机场",
        traditionalName: "阿托伊菲機場",
      },
    ],
  },
  ATH: {
    code: "ATH",
    name: "ATHENS",
    chineseName: "雅典",
    traditionalName: "雅典",
    airports: [
      {
        code: "ATH",
        name: "Eleftherios venizelos",
        chineseName: "埃勒弗瑟里奥斯韦尼泽罗斯国际机场",
        traditionalName: "埃勒弗瑟裏奧斯韋尼澤羅斯國際機場",
      },
    ],
  },
  ATK: {
    code: "ATK",
    name: "ATQASUK",
    chineseName: "阿特卡什克",
    traditionalName: "阿特卡什克",
    airports: [
      {
        code: "ATK",
        name: "E.burnell sr memorial",
        chineseName: "爱德华伯内尔锶纪念机场",
        traditionalName: "愛德華伯內爾鍶紀念機場",
      },
    ],
  },
  ATL: {
    code: "ATL",
    name: "ATLANTA",
    chineseName: "亚特兰大",
    traditionalName: "亞特蘭大",
    airports: [
      {
        code: "ATL",
        name: "Hartsfield-jackson int",
        chineseName: "哈兹菲尔德.杰克逊国际机场",
        traditionalName: "哈茲菲爾德. 傑克遜國際機場",
      },
    ],
  },
  ATM: {
    code: "ATM",
    name: "ALTAMIRA",
    chineseName: "阿尔塔米拉",
    traditionalName: "阿爾塔米拉",
    airports: [
      {
        code: "ATM",
        name: "Altamira airport",
        chineseName: "阿尔塔米拉机场",
        traditionalName: "阿爾塔米拉機場",
      },
    ],
  },
  ATQ: {
    code: "ATQ",
    name: "AMRITSAR",
    chineseName: "阿姆利则",
    traditionalName: "阿姆利則",
    airports: [
      {
        code: "ATQ",
        name: "Sri guru ram dass jee",
        chineseName: "拉贾桑西国际机场",
        traditionalName: "拉賈桑西國際機場",
      },
    ],
  },
  ATT: {
    code: "ATT",
    name: "ATMAUTLUAK",
    chineseName: "亚特卢克毛阿克",
    traditionalName: "亞特盧克毛阿克",
    airports: [
      {
        code: "ATT",
        name: "Atmautluak airport",
        chineseName: "亚特卢克毛阿克机场",
        traditionalName: "亞特盧克毛阿克機場",
      },
    ],
  },
  ATW: {
    code: "ATW",
    name: "APPLETON",
    chineseName: "阿普尔顿",
    traditionalName: "阿爾普頓",
    airports: [
      {
        code: "ATW",
        name: "Appleton intl.",
        chineseName: "奥塔加米郡机场",
        traditionalName: "奧塔加米郡機場",
      },
    ],
  },
  ATY: {
    code: "ATY",
    name: "WATERTOWN",
    chineseName: "沃特敦",
    traditionalName: "沃特敦",
    airports: [
      {
        code: "ATY",
        name: "Watertown reg. airport",
        chineseName: "沃特敦机场",
        traditionalName: "沃特敦機場",
      },
    ],
  },
  ATZ: {
    code: "ATZ",
    name: "ASYUT",
    chineseName: "艾斯尤特",
    traditionalName: "艾斯尤特",
    airports: [
      {
        code: "ATZ",
        name: "Asyut airport",
        chineseName: "阿西尤特机场",
        traditionalName: "阿西尤特機場",
      },
    ],
  },
  AUA: {
    code: "AUA",
    name: "ARUBA",
    chineseName: "阿鲁巴",
    traditionalName: "阿魯巴",
    airports: [
      {
        code: "AUA",
        name: "Reina beatrix",
        chineseName: "雷纳比特里克斯机场",
        traditionalName: "雷納比特裡克斯機場",
      },
    ],
  },
  AUC: {
    code: "AUC",
    name: "ARAUCA",
    chineseName: "阿劳卡",
    traditionalName: "阿勞卡",
    airports: [
      {
        code: "AUC",
        name: "Santiago perez quiroz",
        chineseName: "阿劳卡机场",
        traditionalName: "阿勞卡機場",
      },
    ],
  },
  AUG: {
    code: "AUG",
    name: "AUGUSTA",
    chineseName: "奥古斯塔",
    traditionalName: "奧古斯塔",
    airports: [
      {
        code: "AUG",
        name: "State",
        chineseName: "奥古斯塔州立机场",
        traditionalName: "奧古斯塔州立機場",
      },
    ],
  },
  AUH: {
    code: "AUH",
    name: "ABU DHABI",
    chineseName: "阿布扎比",
    traditionalName: "阿布達比",
    airports: [
      {
        code: "AUH",
        name: "Zayed intl.",
        chineseName: "阿布扎比国际机场",
        traditionalName: "阿布達比國際機場",
      },
    ],
  },
  AUK: {
    code: "AUK",
    name: "ALAKANUK",
    chineseName: "阿拉斯加州阿拉卡努克",
    traditionalName: "阿拉斯加州阿拉卡努克",
    airports: [
      {
        code: "AUK",
        name: "Alakanuk airport",
        chineseName: "阿拉卡努克机场",
        traditionalName: "阿拉卡努克機場",
      },
    ],
  },
  AUL: {
    code: "AUL",
    name: "AUR ISLAND",
    chineseName: "奥尔岛",
    traditionalName: "奧爾島",
    airports: [
      {
        code: "AUL",
        name: "Aur island airport",
        chineseName: "奥尔岛机场",
        traditionalName: "奧爾島機場",
      },
    ],
  },
  AUQ: {
    code: "AUQ",
    name: "HIVA OA",
    chineseName: "阿图奥纳",
    traditionalName: "阿圖奧納",
    airports: [
      {
        code: "AUQ",
        name: "Atuona",
        chineseName: "阿图奥纳机场",
        traditionalName: "阿圖奧納機場",
      },
    ],
  },
  AUR: {
    code: "AUR",
    name: "AURILLAC",
    chineseName: "欧里亚克",
    traditionalName: "歐里西克",
    airports: [
      {
        code: "AUR",
        name: "Aurillac airport",
        chineseName: "欧里亚克机场",
        traditionalName: "歐里西克機場",
      },
    ],
  },
  AUS: {
    code: "AUS",
    name: "AUSTIN",
    chineseName: "奥斯汀",
    traditionalName: "奧斯丁",
    airports: [
      {
        code: "AUS",
        name: "Austin-bergstrom intl",
        chineseName: "奥斯汀博格斯多姆国际机场",
        traditionalName: "奧斯汀博格斯多姆國際機場",
      },
    ],
  },
  AUU: {
    code: "AUU",
    name: "AURUKUN",
    chineseName: "奥卢昆",
    traditionalName: "奧盧昆",
    airports: [
      {
        code: "AUU",
        name: "Aurukun airport",
        chineseName: "奥卢昆机场",
        traditionalName: "奧盧昆機場",
      },
    ],
  },
  AUW: {
    code: "AUW",
    name: "WAUSAU",
    chineseName: "瓦苏",
    traditionalName: "瓦蘇",
    airports: [
      {
        code: "CWA",
        name: "Central wisconsin",
        chineseName: "中威斯康星机场",
        traditionalName: "中威斯康星機場",
      },
    ],
  },
  AUY: {
    code: "AUY",
    name: "ANATOM ISLAND",
    chineseName: "Aneitium城",
    traditionalName: "Aneitium城",
    airports: [
      {
        code: "AUY",
        name: "Anatom island airport",
        chineseName: "阿内蒂乌姆机场",
        traditionalName: "阿內蒂烏姆機場",
      },
    ],
  },
  AVA: {
    code: "AVA",
    name: "ANSHUN",
    chineseName: "安顺",
    traditionalName: "安順",
    airports: [
      {
        code: "AVA",
        name: "Huangguoshu",
        chineseName: "黄果树机场",
        traditionalName: "黃果樹機場",
      },
    ],
  },
  AVL: {
    code: "AVL",
    name: "ASHEVILLE/HENDERSONV",
    chineseName: "阿什维尔",
    traditionalName: "阿什維爾",
    airports: [
      {
        code: "AVL",
        name: "Asheville regional",
        chineseName: "阿什维尔地区机场",
        traditionalName: "阿什維爾地區機場",
      },
    ],
  },
  AVP: {
    code: "AVP",
    name: "WILKES-BARRE/SCRANTON",
    chineseName: "威尔克斯-巴里",
    traditionalName: "威爾克斯-巴里",
    airports: [
      {
        code: "AVP",
        name: "Wilkes-barre/scranton intl.",
        chineseName: "威尔克斯巴里国际机场",
        traditionalName: "威爾克斯巴里國際機場",
      },
    ],
  },
  AWA: {
    code: "AWA",
    name: "AWASA",
    chineseName: "阿瓦萨",
    traditionalName: "阿瓦薩",
    airports: [
      {
        code: "AWA",
        name: "Awasa airport",
        chineseName: "阿瓦萨机场",
        traditionalName: "阿瓦薩機場",
      },
    ],
  },
  AWD: {
    code: "AWD",
    name: "ANIWA ISLAND",
    chineseName: "阿尼瓦",
    traditionalName: "阿尼瓦",
    airports: [
      {
        code: "AWD",
        name: "Aniwa island airport",
        chineseName: "阿尼瓦机场",
        traditionalName: "阿尼瓦機場",
      },
    ],
  },
  AWZ: {
    code: "AWZ",
    name: "AHWAZ",
    chineseName: "阿瓦士",
    traditionalName: "阿瓦士",
    airports: [
      {
        code: "AWZ",
        name: "Ahwaz airport",
        chineseName: "阿赫瓦茨机场",
        traditionalName: "阿赫瓦茨機場",
      },
    ],
  },
  AXA: {
    code: "AXA",
    name: "ANGUILLA",
    chineseName: "峡谷",
    traditionalName: "峽谷",
    airports: [
      {
        code: "AXA",
        name: "Clayton j. lloyd intl",
        chineseName: "克莱顿J.劳埃德国际机场",
        traditionalName: "克萊頓J. 勞埃德國際機場",
      },
    ],
  },
  AXD: {
    code: "AXD",
    name: "ALEXANDROUPOLIS",
    chineseName: "亚历山德鲁波利斯",
    traditionalName: "亞曆山德魯波利斯",
    airports: [
      {
        code: "AXD",
        name: "Dimokritos",
        chineseName: "德莫克里托斯机场",
        traditionalName: "德莫克裏托斯機場",
      },
    ],
  },
  AXF: {
    code: "AXF",
    name: "ALXA LEFT BANNER",
    chineseName: "阿拉善左旗",
    traditionalName: "阿拉善左旗",
    airports: [
      {
        code: "AXF",
        name: "Alxa left banner airport",
        chineseName: "阿拉善左旗机场",
        traditionalName: "阿拉善左旗機場",
      },
    ],
  },
  AXJ: {
    code: "AXJ",
    name: "AMAKUSA",
    chineseName: "天草",
    traditionalName: "天草",
    airports: [
      {
        code: "AXJ",
        name: "Amakusa airport",
        chineseName: "天草机场",
        traditionalName: "天草機場",
      },
    ],
  },
  AXM: {
    code: "AXM",
    name: "ARMENIA",
    chineseName: "亚美尼亚 ",
    traditionalName: "亞美尼亞",
    airports: [
      {
        code: "AXM",
        name: "El eden intl",
        chineseName: "埃尔伊登国际机场",
        traditionalName: "埃爾伊登國際機場",
      },
    ],
  },
  AXP: {
    code: "AXP",
    name: "SPRING POINT",
    chineseName: "春点",
    traditionalName: "春點",
    airports: [
      {
        code: "AXP",
        name: "Spring point airport",
        chineseName: "斯普林波因特机场",
        traditionalName: "斯普林波因特機場",
      },
    ],
  },
  AXR: {
    code: "AXR",
    name: "ARUTUA",
    chineseName: "阿鲁图亚",
    traditionalName: "阿魯圖亞",
    airports: [
      {
        code: "AXR",
        name: "Arutua airport",
        chineseName: "阿鲁图亚机场",
        traditionalName: "阿魯圖亞機場",
      },
    ],
  },
  AXT: {
    code: "AXT",
    name: "AKITA",
    chineseName: "秋田",
    traditionalName: "秋田",
    airports: [
      {
        code: "AXT",
        name: "Akita airport",
        chineseName: "秋田机场",
        traditionalName: "秋田機場",
      },
    ],
  },
  AXU: {
    code: "AXU",
    name: "AXUM",
    chineseName: "阿克苏姆",
    traditionalName: "阿克蘇姆",
    airports: [
      {
        code: "AXU",
        name: "Axum airport",
        chineseName: "阿克苏姆机场",
        traditionalName: "阿克蘇姆機場",
      },
    ],
  },
  AXX: {
    code: "AXX",
    name: "ANGEL FIRE",
    chineseName: "天使之火，新墨西哥",
    traditionalName: "天使之火，新墨西哥",
    airports: [
      {
        code: "AXX",
        name: "Angel fire airport",
        chineseName: "安吉尔法厄机场",
        traditionalName: "安吉爾法厄機場",
      },
    ],
  },
  AYJ: {
    code: "AYJ",
    name: "AYODHYA",
    chineseName: "阿约提亚",
    traditionalName: "阿約提亞",
    airports: [
      {
        code: "AYJ",
        name: "Ayodhya airport",
        chineseName: "阿约提亚机场",
        traditionalName: "阿約提亞機場",
      },
    ],
  },
  AYN: {
    code: "AYN",
    name: "ANYANG",
    chineseName: "安阳",
    traditionalName: "安陽",
    airports: [
      {
        code: "HQQ",
        name: "Hong qiqu airport",
        chineseName: "红旗渠机场",
        traditionalName: "紅旗渠機場",
      },
    ],
  },
  AYP: {
    code: "AYP",
    name: "AYACUCHO",
    chineseName: "阿亚库乔",
    traditionalName: "阿亞庫喬",
    airports: [
      {
        code: "AYP",
        name: "Alfredo m. duarte",
        chineseName: "阿亚库乔机场",
        traditionalName: "阿亞庫喬機場",
      },
    ],
  },
  AYQ: {
    code: "AYQ",
    name: "AYERS ROCK",
    chineseName: "艾尔斯岩",
    traditionalName: "艾爾斯岩",
    airports: [
      {
        code: "AYQ",
        name: "Connellan",
        chineseName: "康内尔兰机场",
        traditionalName: "康內爾蘭機場",
      },
    ],
  },
  AYT: {
    code: "AYT",
    name: "ANTALYA",
    chineseName: "安塔利亚",
    traditionalName: "安塔利亞",
    airports: [
      {
        code: "AYT",
        name: "Antalya airport",
        chineseName: "安塔利亚机场",
        traditionalName: "安塔利亞機場",
      },
    ],
  },
  AZD: {
    code: "AZD",
    name: "YAZD",
    chineseName: "亚兹德",
    traditionalName: "亞茲德",
    airports: [
      {
        code: "AZD",
        name: "Shahid sadooghi",
        chineseName: "亚兹德机场",
        traditionalName: "亞茲德機場",
      },
    ],
  },
  AZH: {
    code: "AZH",
    name: "AZAMGARH",
    chineseName: "阿扎姆加尔",
    traditionalName: "阿紮姆加爾",
    airports: [
      {
        code: "AZH",
        name: "Azamgarh airport",
        chineseName: "阿扎姆加尔机场",
        traditionalName: "阿扎姆加爾機場",
      },
    ],
  },
  AZO: {
    code: "AZO",
    name: "KALAMAZOO/BATTLE CREEK",
    chineseName: "卡拉马祖",
    traditionalName: "卡拉馬祖",
    airports: [
      {
        code: "AZO",
        name: "Kalamazoo/battle creek intl.",
        chineseName: "卡拉马祖机场",
        traditionalName: "卡拉馬祖機場",
      },
    ],
  },
  AZR: {
    code: "AZR",
    name: "ADRAR",
    chineseName: "阿德拉尔",
    traditionalName: "阿德拉爾",
    airports: [
      {
        code: "AZR",
        name: "Touat",
        chineseName: "阿德拉尔机场",
        traditionalName: "阿德拉爾機場",
      },
    ],
  },
  AZS: {
    code: "AZS",
    name: "SAMANA",
    chineseName: "萨马纳",
    traditionalName: "薩馬納",
    airports: [
      {
        code: "AZS",
        name: "El catey intl",
        chineseName: "萨马纳国际机场",
        traditionalName: "薩馬納國際機場",
      },
    ],
  },
  BAH: {
    code: "BAH",
    name: "BAHRAIN",
    chineseName: "巴林",
    traditionalName: "巴林",
    airports: [
      {
        code: "BAH",
        name: "Bahrain intl.",
        chineseName: "巴林国际机场",
        traditionalName: "巴林國際機場",
      },
    ],
  },
  BAK: {
    code: "BAK",
    name: "BAKU",
    chineseName: "巴库",
    traditionalName: "巴庫",
    airports: [
      {
        code: "GYD",
        name: "Heydar aliyev intl",
        chineseName: "盖达尔阿利耶夫国际机场",
        traditionalName: "蓋達爾阿利耶夫國際機場",
      },
    ],
  },
  BAL: {
    code: "BAL",
    name: "BATMAN",
    chineseName: "巴特曼",
    traditionalName: "巴特曼",
    airports: [
      {
        code: "BAL",
        name: "Batman airport",
        chineseName: "巴特曼机场",
        traditionalName: "巴特曼機場",
      },
    ],
  },
  BAQ: {
    code: "BAQ",
    name: "BARRANQUILLA",
    chineseName: "巴兰基亚",
    traditionalName: "巴蘭基亞",
    airports: [
      {
        code: "BAQ",
        name: "Ernesto cortissoz intl",
        chineseName: "埃内斯托考提索茨机场",
        traditionalName: "埃內斯托考提索茨機場",
      },
    ],
  },
  BAR: {
    code: "BAR",
    name: "QIONGHAI",
    chineseName: "琼海",
    traditionalName: "瓊海",
    airports: [
      {
        code: "BAR",
        name: "Bo'ao",
        chineseName: "博鳌机场",
        traditionalName: "博鼇機場",
      },
    ],
  },
  BAS: {
    code: "BAS",
    name: "BALALAE",
    chineseName: "巴拉莱",
    traditionalName: "巴拉萊",
    airports: [
      {
        code: "BAS",
        name: "Balalae airport",
        chineseName: "巴拉莱伊机场",
        traditionalName: "巴拉萊伊機場",
      },
    ],
  },
  BAV: {
    code: "BAV",
    name: "BAOTOU",
    chineseName: "包头",
    traditionalName: "包頭",
    airports: [
      {
        code: "BAV",
        name: "Erliban",
        chineseName: "包头东河机场",
        traditionalName: "包頭東河機場",
      },
    ],
  },
  BAX: {
    code: "BAX",
    name: "BARNAUL",
    chineseName: "巴尔瑙尔",
    traditionalName: "巴爾瑙爾",
    airports: [
      {
        code: "BAX",
        name: "Barnaul airport",
        chineseName: "巴尔瑙尔机场",
        traditionalName: "巴爾瑙爾機場",
      },
    ],
  },
  BAY: {
    code: "BAY",
    name: "BAIA MARE",
    chineseName: "巴亚马雷",
    traditionalName: "巴亞馬雷",
    airports: [
      {
        code: "BAY",
        name: "Baia mare airport",
        chineseName: "巴亚马雷机场",
        traditionalName: "巴亞馬雷機場",
      },
    ],
  },
  BBA: {
    code: "BBA",
    name: "BALMACEDA",
    chineseName: "巴尔马塞达",
    traditionalName: "巴爾馬塞達",
    airports: [
      {
        code: "BBA",
        name: "Balmaceda airport",
        chineseName: "巴尔马塞达机场",
        traditionalName: "巴爾馬塞達機場",
      },
    ],
  },
  BBG: {
    code: "BBG",
    name: "BUTARITARI",
    chineseName: "布塔里塔里岛",
    traditionalName: "布塔里塔里島",
    airports: [
      {
        code: "BBG",
        name: "Butaritari airport",
        chineseName: "布塔里塔里机场",
        traditionalName: "布塔里塔里機場",
      },
    ],
  },
  BBI: {
    code: "BBI",
    name: "BHUBANESHWAR",
    chineseName: "布巴内斯瓦尔",
    traditionalName: "巴布內斯瓦爾",
    airports: [
      {
        code: "BBI",
        name: "Biju patnaik",
        chineseName: "比居帕特奈克国际机场",
        traditionalName: "比居帕特納克國際機場",
      },
    ],
  },
  BBK: {
    code: "BBK",
    name: "KASANE",
    chineseName: "卡萨内",
    traditionalName: "卡薩內",
    airports: [
      {
        code: "BBK",
        name: "Kasane airport",
        chineseName: "卡萨内机场",
        traditionalName: "卡薩內機場",
      },
    ],
  },
  BBL: {
    code: "BBL",
    name: "BALLERA",
    chineseName: "巴博尔萨",
    traditionalName: "巴博爾薩",
    airports: [
      {
        code: "BBL",
        name: "Ballera airport",
        chineseName: "巴博尔萨机场",
        traditionalName: "巴博爾薩機場",
      },
    ],
  },
  BBN: {
    code: "BBN",
    name: "BARIO",
    chineseName: "巴里奥",
    traditionalName: "巴裏奧",
    airports: [
      {
        code: "BBN",
        name: "Bario airport",
        chineseName: "巴里奥机场",
        traditionalName: "巴裏奧機場",
      },
    ],
  },
  BBQ: {
    code: "BBQ",
    name: "BARBUDA",
    chineseName: "巴布达",
    traditionalName: "巴布達",
    airports: [
      {
        code: "BBQ",
        name: "Codrington airport",
        chineseName: "巴布达科德灵顿机场",
        traditionalName: "巴布達科德靈頓機場",
      },
    ],
  },
  BCA: {
    code: "BCA",
    name: "BARACOA",
    chineseName: "巴拉科阿",
    traditionalName: "巴拉科阿",
    airports: [
      {
        code: "BCA",
        name: "Gustavo rizo",
        chineseName: "古斯塔沃里佐机场",
        traditionalName: "古斯塔沃裏佐機場",
      },
    ],
  },
  BCD: {
    code: "BCD",
    name: "BACOLOD",
    chineseName: "巴科洛得",
    traditionalName: "巴科洛得",
    airports: [
      {
        code: "BCD",
        name: "Silay international",
        chineseName: "锡莱国际机场",
        traditionalName: "錫萊國際機場",
      },
    ],
  },
  BCI: {
    code: "BCI",
    name: "BARCALDINE",
    chineseName: "巴卡尔丁",
    traditionalName: "巴卡爾丁",
    airports: [
      {
        code: "BCI",
        name: "Barcaldine airport",
        chineseName: "巴卡尔丁机场",
        traditionalName: "巴卡爾丁機場",
      },
    ],
  },
  BCM: {
    code: "BCM",
    name: "BACAU",
    chineseName: "巴克乌",
    traditionalName: "巴克烏",
    airports: [
      {
        code: "BCM",
        name: "Bacau airport",
        chineseName: "巴克乌机场",
        traditionalName: "巴克烏機場",
      },
    ],
  },
  BCN: {
    code: "BCN",
    name: "BARCELONA",
    chineseName: "巴塞罗那",
    traditionalName: "巴賽隆納",
    airports: [
      {
        code: "BCN",
        name: "Josep tarradellas barcelona -",
        chineseName: "巴塞罗那机场",
        traditionalName: "巴賽隆納機場",
      },
    ],
  },
  BCO: {
    code: "BCO",
    name: "JINKA",
    chineseName: "金卡",
    traditionalName: "金卡",
    airports: [
      {
        code: "BCO",
        name: "Bako",
        chineseName: "金卡机场",
        traditionalName: "金卡機場",
      },
    ],
  },
  BCT: {
    code: "BCT",
    name: "BOCA RATON",
    chineseName: "博卡拉顿",
    traditionalName: "博卡拉頓",
    airports: [
      {
        code: "BCT",
        name: "Boca raton airport",
        chineseName: "博卡拉顿机场",
        traditionalName: "博卡拉頓機場",
      },
    ],
  },
  BDA: {
    code: "BDA",
    name: "BERMUDA",
    chineseName: "百慕大",
    traditionalName: "百慕大",
    airports: [
      {
        code: "BDA",
        name: "L.f wade international",
        chineseName: "L F韦德国际机场",
        traditionalName: "L F韋德國際機場",
      },
    ],
  },
  BDB: {
    code: "BDB",
    name: "BUNDABERG",
    chineseName: "班达伯格",
    traditionalName: "班達伯格",
    airports: [
      {
        code: "BDB",
        name: "Bundaberg airport",
        chineseName: "班达伯格机场",
        traditionalName: "班達伯格機場",
      },
    ],
  },
  BDD: {
    code: "BDD",
    name: "BADU ISLAND",
    chineseName: "巴都岛",
    traditionalName: "巴都島",
    airports: [
      {
        code: "BDD",
        name: "Badu island airport",
        chineseName: "巴度岛机场",
        traditionalName: "巴度島機場",
      },
    ],
  },
  BDH: {
    code: "BDH",
    name: "BANDAR LENGEH",
    chineseName: "伦格港",
    traditionalName: "倫格港",
    airports: [
      {
        code: "BDH",
        name: "Bandar lengeh airport",
        chineseName: "伦格港机场",
        traditionalName: "倫格港機場",
      },
    ],
  },
  BDJ: {
    code: "BDJ",
    name: "BANJARMASIN",
    chineseName: "马辰",
    traditionalName: "班格爾馬辛",
    airports: [
      {
        code: "BDJ",
        name: "Syamsudin noor",
        chineseName: "斯贾姆苏丁诺尔机场",
        traditionalName: "斯賈姆蘇丁諾爾機場",
      },
    ],
  },
  BDO: {
    code: "BDO",
    name: "BANDUNG",
    chineseName: "万隆",
    traditionalName: "萬隆",
    airports: [
      {
        code: "BDO",
        name: "Husein sastranegara",
        chineseName: "侯赛因萨斯特雷纳加拉机场",
        traditionalName: "侯賽因薩斯特雷納加拉機場",
      },
    ],
  },
  BDP: {
    code: "BDP",
    name: "BHADRAPUR",
    chineseName: "帕格尔布尔",
    traditionalName: "帕格爾布林",
    airports: [
      {
        code: "BDP",
        name: "Chandragadhi",
        chineseName: "帕格尔布尔机场",
        traditionalName: "帕格爾布林機場",
      },
    ],
  },
  BDQ: {
    code: "BDQ",
    name: "VADODARA",
    chineseName: "巴罗达",
    traditionalName: "巴羅達",
    airports: [
      {
        code: "BDQ",
        name: "Vadodara airport",
        chineseName: "瓦多达拉机场",
        traditionalName: "瓦多達拉機場",
      },
    ],
  },
  BDS: {
    code: "BDS",
    name: "BRINDISI",
    chineseName: "布林迪西",
    traditionalName: "布林迪西",
    airports: [
      {
        code: "BDS",
        name: "Casale",
        chineseName: "萨兰托机场",
        traditionalName: "薩蘭托機場",
      },
    ],
  },
  BDT: {
    code: "BDT",
    name: "GBADOLITE",
    chineseName: "巴多利特",
    traditionalName: "巴多利特",
    airports: [
      {
        code: "BDT",
        name: "Gbadolite airport",
        chineseName: "巴多利特机场",
        traditionalName: "巴多利特機場",
      },
    ],
  },
  BDU: {
    code: "BDU",
    name: "BARDUFOSS",
    chineseName: "巴度弗斯",
    traditionalName: "巴度弗斯",
    airports: [
      {
        code: "BDU",
        name: "Bardufoss airport",
        chineseName: "巴度弗斯机场",
        traditionalName: "巴度弗斯機場",
      },
    ],
  },
  BEB: {
    code: "BEB",
    name: "BENBECULA",
    chineseName: "本贝丘拉",
    traditionalName: "本貝丘拉",
    airports: [
      {
        code: "BEB",
        name: "Benbecula airport",
        chineseName: "本贝丘拉机场",
        traditionalName: "本貝丘拉機場",
      },
    ],
  },
  BEF: {
    code: "BEF",
    name: "BLUEFIELDS",
    chineseName: "布卢菲尔兹",
    traditionalName: "布盧菲耳德",
    airports: [
      {
        code: "BEF",
        name: "Bluefields airport",
        chineseName: "布卢菲尔兹机场",
        traditionalName: "布盧菲耳德機場",
      },
    ],
  },
  BEG: {
    code: "BEG",
    name: "BELGRADE",
    chineseName: "贝尔格莱德",
    traditionalName: "貝爾格勒",
    airports: [
      {
        code: "BEG",
        name: "Nikola tesla",
        chineseName: "尼古拉特斯拉机场",
        traditionalName: "尼古拉特斯拉機場",
      },
    ],
  },
  BEJ: {
    code: "BEJ",
    name: "TANJUNG REDEB",
    chineseName: "贝劳",
    traditionalName: "貝勞",
    airports: [
      {
        code: "BEJ",
        name: "Kalimarau",
        chineseName: "卡里玛卢机场",
        traditionalName: "卡裡瑪盧機場",
      },
    ],
  },
  BEK: {
    code: "BEK",
    name: "BAREILLY",
    chineseName: "巴雷利",
    traditionalName: "巴雷利",
    airports: [
      {
        code: "BEK",
        name: "Bareilly airport",
        chineseName: "巴雷利机场",
        traditionalName: "巴雷利機場",
      },
    ],
  },
  BEL: {
    code: "BEL",
    name: "BELEM",
    chineseName: "贝伦",
    traditionalName: "貝倫",
    airports: [
      {
        code: "BEL",
        name: "Val de cans intl",
        chineseName: "瓦尔德坎斯国际机场",
        traditionalName: "瓦爾德坎斯國際機場",
      },
    ],
  },
  BEM: {
    code: "BEM",
    name: "BENI MELLAL",
    chineseName: "贝尼梅拉尔",
    traditionalName: "貝尼梅拉爾",
    airports: [
      {
        code: "BEM",
        name: "National",
        chineseName: "贝尼迈拉勒机场",
        traditionalName: "貝尼邁拉勒機場",
      },
    ],
  },
  BEN: {
    code: "BEN",
    name: "BENGHAZI",
    chineseName: "班加西",
    traditionalName: "班加西",
    airports: [
      {
        code: "BEN",
        name: "Benina intl",
        chineseName: "贝尼纳国际机场",
        traditionalName: "貝尼納國際機場",
      },
    ],
  },
  BER: {
    code: "BER",
    name: "BERLIN",
    chineseName: "柏林",
    traditionalName: "柏林",
    airports: [
      {
        code: "BER",
        name: "Brandenburg",
        chineseName: "勃兰登堡机场",
        traditionalName: "布蘭登堡機場",
      },
    ],
  },
  BES: {
    code: "BES",
    name: "BREST",
    chineseName: "布雷斯特",
    traditionalName: "布列斯特",
    airports: [
      {
        code: "BES",
        name: "Bretagne",
        chineseName: "布列塔尼机场",
        traditionalName: "布列塔尼機場",
      },
    ],
  },
  BET: {
    code: "BET",
    name: "BETHEL",
    chineseName: "贝塞尔",
    traditionalName: "貝塞爾",
    airports: [
      {
        code: "BET",
        name: "Bethel airport",
        chineseName: "贝塞尔机场",
        traditionalName: "貝塞爾機場",
      },
    ],
  },
  BEU: {
    code: "BEU",
    name: "BEDOURIE",
    chineseName: "贝杜里",
    traditionalName: "貝杜裏",
    airports: [
      {
        code: "BEU",
        name: "Bedourie airport",
        chineseName: "贝杜里机场",
        traditionalName: "貝杜裏機場",
      },
    ],
  },
  BEW: {
    code: "BEW",
    name: "BEIRA",
    chineseName: "贝拉",
    traditionalName: "貝拉",
    airports: [
      {
        code: "BEW",
        name: "Beira airport",
        chineseName: "贝拉机场",
        traditionalName: "貝拉機場",
      },
    ],
  },
  BEY: {
    code: "BEY",
    name: "BEIRUT",
    chineseName: "贝鲁特",
    traditionalName: "貝魯特",
    airports: [
      {
        code: "BEY",
        name: "Rafic hariri intl",
        chineseName: "拉菲克哈里里国际机场",
        traditionalName: "拉菲克哈裏裏國際機場",
      },
    ],
  },
  BEZ: {
    code: "BEZ",
    name: "BERU",
    chineseName: "贝鲁岛",
    traditionalName: "貝魯島",
    airports: [
      {
        code: "BEZ",
        name: "Beru airport",
        chineseName: "贝鲁机场",
        traditionalName: "貝魯機場",
      },
    ],
  },
  BFD: {
    code: "BFD",
    name: "BRADFORD",
    chineseName: "布拉德福德",
    traditionalName: "布拉德福德",
    airports: [
      {
        code: "BFD",
        name: "Bradford reg. airport",
        chineseName: "布拉德福德机场",
        traditionalName: "布拉德福德機場",
      },
    ],
  },
  BFF: {
    code: "BFF",
    name: "SCOTTSBLUFF",
    chineseName: "斯科茨布拉夫",
    traditionalName: "斯科茨布拉夫",
    airports: [
      {
        code: "BFF",
        name: "Western nebraska rgnl",
        chineseName: "斯科茨布拉夫郡机场",
        traditionalName: "斯科茨布拉夫郡機場",
      },
    ],
  },
  BFJ: {
    code: "BFJ",
    name: "BIJIE",
    chineseName: "毕节",
    traditionalName: "畢節",
    airports: [
      {
        code: "BFJ",
        name: "Bijie airport",
        chineseName: "飞雄机场",
        traditionalName: "飛雄機場",
      },
    ],
  },
  BFL: {
    code: "BFL",
    name: "BAKERSFIELD",
    chineseName: "贝克斯菲尔德",
    traditionalName: "貝克斯菲爾德",
    airports: [
      {
        code: "BFL",
        name: "Meadows field",
        chineseName: "梅道斯机场",
        traditionalName: "梅道斯機場",
      },
    ],
  },
  BFN: {
    code: "BFN",
    name: "BLOEMFONTEIN",
    chineseName: "布隆方丹",
    traditionalName: "布隆方丹",
    airports: [
      {
        code: "BFN",
        name: "Bloemfontein intl.",
        chineseName: "布隆方丹国际机场",
        traditionalName: "布隆方丹國際機場",
      },
    ],
  },
  BFS: {
    code: "BFS",
    name: "BELFAST",
    chineseName: "贝尔法斯特",
    traditionalName: "貝爾法斯特",
    airports: [
      {
        code: "BFS",
        name: "Belfast intl.",
        chineseName: "贝尔法斯特国际机场",
        traditionalName: "貝爾法斯特國際機場",
      },
      {
        code: "BHD",
        name: "George best city apt",
        chineseName: "贝尔法斯特市机场",
        traditionalName: "貝爾法斯特市機場",
      },
    ],
  },
  BFU: {
    code: "BFU",
    name: "BENGBU",
    chineseName: "蚌埠",
    traditionalName: "蚌埠",
    airports: [
      {
        code: "BFY",
        name: "Bengbu tenghu",
        chineseName: "蚌埠腾湖机场",
        traditionalName: "蚌埠騰湖機場",
      },
    ],
  },
  BFV: {
    code: "BFV",
    name: "BURIRAM",
    chineseName: "布里兰",
    traditionalName: "布裡蘭",
    airports: [
      {
        code: "BFV",
        name: "Buriram airport",
        chineseName: "武里南机场",
        traditionalName: "武裡南機場",
      },
    ],
  },
  BFX: {
    code: "BFX",
    name: "BAFOUSSAM",
    chineseName: "巴富萨姆",
    traditionalName: "巴庫薩姆",
    airports: [
      {
        code: "BFX",
        name: "Bafoussam airport",
        chineseName: "巴富萨姆机场",
        traditionalName: "巴庫薩姆機場",
      },
    ],
  },
  BGA: {
    code: "BGA",
    name: "BUCARAMANGA",
    chineseName: "布卡拉曼加",
    traditionalName: "布卡拉曼加",
    airports: [
      {
        code: "BGA",
        name: "Palonegro intl",
        chineseName: "帕罗内格罗国际机场",
        traditionalName: "帕羅內格羅國際機場",
      },
    ],
  },
  BGC: {
    code: "BGC",
    name: "BRAGANCA",
    chineseName: "布拉干萨",
    traditionalName: "布拉幹薩",
    airports: [
      {
        code: "BGC",
        name: "Braganca airport",
        chineseName: "布拉干萨机场",
        traditionalName: "布拉幹薩機場",
      },
    ],
  },
  BGF: {
    code: "BGF",
    name: "BANGUI",
    chineseName: "班吉",
    traditionalName: "班基",
    airports: [
      {
        code: "BGF",
        name: "Mpoko intl",
        chineseName: "班吉机场",
        traditionalName: "班基機場",
      },
    ],
  },
  BGG: {
    code: "BGG",
    name: "BINGOL",
    chineseName: "宾格尔",
    traditionalName: "賓格爾",
    airports: [
      {
        code: "BGG",
        name: "Bingol airport",
        chineseName: "宾格尔机场",
        traditionalName: "賓格爾機場",
      },
    ],
  },
  BGI: {
    code: "BGI",
    name: "BRIDGETOWN",
    chineseName: "布里奇顿",
    traditionalName: "橋鎮",
    airports: [
      {
        code: "BGI",
        name: "Grantley adams intl",
        chineseName: "格兰特利亚当斯国际机场",
        traditionalName: "格蘭特利亞當斯國際機場",
      },
    ],
  },
  BGM: {
    code: "BGM",
    name: "BINGHAMTON",
    chineseName: "宾罕顿",
    traditionalName: "賓罕頓",
    airports: [
      {
        code: "BGM",
        name: "Greater binghamton",
        chineseName: "宾厄姆顿机场",
        traditionalName: "賓厄姆頓機場",
      },
    ],
  },
  BGN: {
    code: "BGN",
    name: "BELAYA GORA",
    chineseName: "别拉亚戈拉",
    traditionalName: "別拉亞戈拉",
    airports: [
      {
        code: "BGN",
        name: "Belaya gora airport",
        chineseName: "别拉亚戈拉机场",
        traditionalName: "別拉亞戈拉機場",
      },
    ],
  },
  BGO: {
    code: "BGO",
    name: "BERGEN",
    chineseName: "卑尔根",
    traditionalName: "貝根",
    airports: [
      {
        code: "BGO",
        name: "Flesland",
        chineseName: "弗雷斯兰德机场",
        traditionalName: "弗雷斯蘭德機場",
      },
    ],
  },
  BGR: {
    code: "BGR",
    name: "BANGOR",
    chineseName: "班戈",
    traditionalName: "班戈",
    airports: [
      {
        code: "BGR",
        name: "Bangor intl.",
        chineseName: "班戈国际机场",
        traditionalName: "班戈國際機場",
      },
    ],
  },
  BGS: {
    code: "BGS",
    name: "BOGUCHANY",
    chineseName: "得克萨斯州大斯普林",
    traditionalName: "德克薩斯州大斯普林",
    airports: [
      {
        code: "BGS",
        name: "Boguchany airport",
        chineseName: "大斯普林机场",
        traditionalName: "大斯普林機場",
      },
    ],
  },
  BGW: {
    code: "BGW",
    name: "BAGHDAD",
    chineseName: "巴格达",
    traditionalName: "巴格達",
    airports: [
      {
        code: "BGW",
        name: "Baghdad intl.",
        chineseName: "巴格达国际机场",
        traditionalName: "巴格達國際機場",
      },
    ],
  },
  BHB: {
    code: "BHB",
    name: "BAR HARBOR",
    chineseName: "巴港",
    traditionalName: "巴港",
    airports: [
      {
        code: "BHB",
        name: "Hancock county",
        chineseName: "汉考克县机场",
        traditionalName: "漢考克縣機場",
      },
    ],
  },
  BHE: {
    code: "BHE",
    name: "BLENHEIM",
    chineseName: "布伦海姆",
    traditionalName: "布倫海姆",
    airports: [
      {
        code: "BHE",
        name: "Woodbourne",
        chineseName: "伍德伯恩机场",
        traditionalName: "伍德伯恩機場",
      },
    ],
  },
  BHH: {
    code: "BHH",
    name: "BISHA",
    chineseName: "比沙",
    traditionalName: "比沙",
    airports: [
      {
        code: "BHH",
        name: "Bisha airport",
        chineseName: "比沙机场",
        traditionalName: "比沙機場",
      },
    ],
  },
  BHI: {
    code: "BHI",
    name: "BAHIA BLANCA",
    chineseName: "布兰卡港",
    traditionalName: "布蘭卡港",
    airports: [
      {
        code: "BHI",
        name: "Comandante espora",
        chineseName: "科曼达恩特港机场",
        traditionalName: "科曼達恩特港機場",
      },
    ],
  },
  BHJ: {
    code: "BHJ",
    name: "BHUJ",
    chineseName: "普杰",
    traditionalName: "普傑",
    airports: [
      {
        code: "BHJ",
        name: "Shyamji krishna verma",
        chineseName: "普杰机场",
        traditionalName: "普傑機場",
      },
    ],
  },
  BHK: {
    code: "BHK",
    name: "BUKHARA",
    chineseName: "布哈拉",
    traditionalName: "布哈拉",
    airports: [
      {
        code: "BHK",
        name: "Bukhara intl.",
        chineseName: "布哈拉国际机场",
        traditionalName: "布哈拉國際機場",
      },
    ],
  },
  BHM: {
    code: "BHM",
    name: "BIRMINGHAM",
    chineseName: "伯明翰",
    traditionalName: "伯明罕",
    airports: [
      {
        code: "BHM",
        name: "Shuttlesworth intl",
        chineseName: "沙特尔斯沃思国际机场",
        traditionalName: "沙特爾斯沃思國際機場",
      },
    ],
  },
  BHO: {
    code: "BHO",
    name: "BHOPAL",
    chineseName: "博帕尔",
    traditionalName: "博帕爾",
    airports: [
      {
        code: "BHO",
        name: "Raja bhoj",
        chineseName: "博帕尔机场",
        traditionalName: "博帕爾機場",
      },
    ],
  },
  BHP: {
    code: "BHP",
    name: "BHOJPUR",
    chineseName: "波泽布尔",
    traditionalName: "波澤布林",
    airports: [
      {
        code: "BHP",
        name: "Bhojpur airport",
        chineseName: "博基布尔机场",
        traditionalName: "博基布林機場",
      },
    ],
  },
  BHQ: {
    code: "BHQ",
    name: "BROKEN HILL",
    chineseName: "布罗肯希尔",
    traditionalName: "布羅肯希爾",
    airports: [
      {
        code: "BHQ",
        name: "Broken hill airport",
        chineseName: "布罗肯希尔机场",
        traditionalName: "布羅肯希爾機場",
      },
    ],
  },
  BHR: {
    code: "BHR",
    name: "BHARATPUR",
    chineseName: "珀勒德布尔",
    traditionalName: "珀勒德布林",
    airports: [
      {
        code: "BHR",
        name: "Bharatpur airport",
        chineseName: "珀勒德布尔机场",
        traditionalName: "珀勒德布林機場",
      },
    ],
  },
  BHU: {
    code: "BHU",
    name: "BHAVNAGAR",
    chineseName: "包纳加尔",
    traditionalName: "包納加爾",
    airports: [
      {
        code: "BHU",
        name: "Bhavnagar airport",
        chineseName: "包纳加尔机场",
        traditionalName: "包納加爾機場",
      },
    ],
  },
  BHX: {
    code: "BHX",
    name: "BIRMINGHAM",
    chineseName: "伯明翰",
    traditionalName: "伯明罕",
    airports: [
      {
        code: "BHX",
        name: "Birmingham airport",
        chineseName: "伯明翰机场",
        traditionalName: "伯明罕機場",
      },
    ],
  },
  BHY: {
    code: "BHY",
    name: "BEIHAI",
    chineseName: "北海",
    traditionalName: "北海",
    airports: [
      {
        code: "BHY",
        name: "Fucheng",
        chineseName: "北海福成机场",
        traditionalName: "北海福成機場",
      },
    ],
  },
  BHZ: {
    code: "BHZ",
    name: "BELO HORIZONTE",
    chineseName: "贝洛奥里藏特",
    traditionalName: "貝洛奧裡藏特",
    airports: [
      {
        code: "CNF",
        name: "Tancredo neves intl",
        chineseName: "坦克雷多内弗斯国际机场",
        traditionalName: "坦克雷多內弗斯國際機場",
      },
      {
        code: "PLU",
        name: "Pampulha",
        chineseName: "帕姆普尔哈机场",
        traditionalName: "帕姆普爾哈機場",
      },
    ],
  },
  BIA: {
    code: "BIA",
    name: "BASTIA",
    chineseName: "巴斯蒂亚",
    traditionalName: "巴斯蒂亞",
    airports: [
      {
        code: "BIA",
        name: "Poretta",
        chineseName: "巴斯蒂亚机场",
        traditionalName: "巴斯蒂亞機場",
      },
    ],
  },
  BIB: {
    code: "BIB",
    name: "BAIDOA",
    chineseName: "拜多阿",
    traditionalName: "拜多阿",
    airports: [
      {
        code: "BIB",
        name: "Baidoa airport",
        chineseName: "拜多阿机场",
        traditionalName: "拜多阿機場",
      },
    ],
  },
  BID: {
    code: "BID",
    name: "BLOCK ISLAND",
    chineseName: "布洛克艾兰",
    traditionalName: "布洛克艾蘭",
    airports: [
      {
        code: "BID",
        name: "State",
        chineseName: "布洛克岛州立机场",
        traditionalName: "布洛克島州立機場",
      },
    ],
  },
  BIH: {
    code: "BIH",
    name: "BISHOP",
    chineseName: "加利福尼亚州主教",
    traditionalName: "加利福尼亞州主教",
    airports: [
      {
        code: "BIH",
        name: "Eastern sierra rgnl",
        chineseName: "毕晓普机场",
        traditionalName: "畢曉普機場",
      },
    ],
  },
  BIK: {
    code: "BIK",
    name: "BIAK",
    chineseName: "比亚克",
    traditionalName: "比亞克",
    airports: [
      {
        code: "BIK",
        name: "Frans kaisiepo",
        chineseName: "莫克梅尔机场",
        traditionalName: "莫克梅爾機場",
      },
    ],
  },
  BIL: {
    code: "BIL",
    name: "BILLINGS",
    chineseName: "比林斯",
    traditionalName: "比林斯",
    airports: [
      {
        code: "BIL",
        name: "Logan intl",
        chineseName: "洛根国际机场",
        traditionalName: "洛根國際機場",
      },
    ],
  },
  BIM: {
    code: "BIM",
    name: "BIMINI",
    chineseName: "比米尼",
    traditionalName: "比米尼",
    airports: [
      {
        code: "BIM",
        name: "South bimini",
        chineseName: "比米尼群岛国际机场",
        traditionalName: "比米尼群島國際機場",
      },
      {
        code: "NSB",
        name: "North seaplane base",
        chineseName: "北比米尼机场",
        traditionalName: "北比米尼機場",
      },
    ],
  },
  BIO: {
    code: "BIO",
    name: "BILBAO",
    chineseName: "毕尔巴鄂",
    traditionalName: "畢爾巴鄂",
    airports: [
      {
        code: "BIO",
        name: "Bilbao airport",
        chineseName: "毕尔巴鄂机场",
        traditionalName: "畢爾巴鄂機場",
      },
    ],
  },
  BIQ: {
    code: "BIQ",
    name: "BIARRITZ",
    chineseName: "比亚里茨",
    traditionalName: "比亞裏茨",
    airports: [
      {
        code: "BIQ",
        name: "Pays basque",
        chineseName: "比亚里茨机场",
        traditionalName: "比亞裏茨機場",
      },
    ],
  },
  BIR: {
    code: "BIR",
    name: "BIRATNAGAR",
    chineseName: "比拉德纳格尔",
    traditionalName: "比拉德納格爾",
    airports: [
      {
        code: "BIR",
        name: "Biratnagar airport",
        chineseName: "比拉德纳格尔机场",
        traditionalName: "比拉德納格爾機場",
      },
    ],
  },
  BIS: {
    code: "BIS",
    name: "BISMARCK",
    chineseName: "俾斯麦",
    traditionalName: "俾斯麥",
    airports: [
      {
        code: "BIS",
        name: "Bismarck municipal",
        chineseName: "俾斯麦机场",
        traditionalName: "俾斯麥機場",
      },
    ],
  },
  BJA: {
    code: "BJA",
    name: "BEJAIA",
    chineseName: "贝贾亚",
    traditionalName: "貝賈亞",
    airports: [
      {
        code: "BJA",
        name: "Soummam-abane ramdane",
        chineseName: "贝贾亚机场",
        traditionalName: "貝賈亞機場",
      },
    ],
  },
  BJB: {
    code: "BJB",
    name: "BOJNURD",
    chineseName: "博季诺德",
    traditionalName: "博季諾德",
    airports: [
      {
        code: "BJB",
        name: "Bojnurd airport",
        chineseName: "博季诺德机场",
        traditionalName: "博季諾德機場",
      },
    ],
  },
  BJF: {
    code: "BJF",
    name: "BATSFJORD",
    chineseName: "博茨菲尤尔",
    traditionalName: "博茨菲尤爾",
    airports: [
      {
        code: "BJF",
        name: "Batsfjord airport",
        chineseName: "伯茨菲尤尔机场",
        traditionalName: "伯茨菲尤爾機場",
      },
    ],
  },
  BJI: {
    code: "BJI",
    name: "BEMIDJI",
    chineseName: "伯米吉",
    traditionalName: "伯米吉",
    airports: [
      {
        code: "BJI",
        name: "Bemidji reg. airport",
        chineseName: "伯米吉机场",
        traditionalName: "伯米吉機場",
      },
    ],
  },
  BJL: {
    code: "BJL",
    name: "BANJUL",
    chineseName: "班珠尔",
    traditionalName: "班竹",
    airports: [
      {
        code: "BJL",
        name: "Banjul intl.",
        chineseName: "班珠尔国际机场",
        traditionalName: "班竹國際機場",
      },
    ],
  },
  BJM: {
    code: "BJM",
    name: "BUJUMBURA",
    chineseName: "布琼布拉",
    traditionalName: "布松布拉",
    airports: [
      {
        code: "BJM",
        name: "Bujumbura intl.",
        chineseName: "布琼布拉国际机场",
        traditionalName: "布松布拉國際機場",
      },
    ],
  },
  BJR: {
    code: "BJR",
    name: "BAHAR DAR",
    chineseName: "巴赫达尔",
    traditionalName: "巴赫達爾",
    airports: [
      {
        code: "BJR",
        name: "Bahar dar airport",
        chineseName: "巴赫达尔机场",
        traditionalName: "巴赫達爾機場",
      },
    ],
  },
  BJS: {
    code: "BJS",
    name: "BEIJING",
    chineseName: "北京",
    traditionalName: "北京",
    airports: [
      {
        code: "PEK",
        name: "Capital intl",
        chineseName: "首都国际机场",
        traditionalName: "首都國際機場",
      },
      {
        code: "PKX",
        name: "Daxing intl.",
        chineseName: "大兴国际机场",
        traditionalName: "大興國際機場",
      },
    ],
  },
  BJU: {
    code: "BJU",
    name: "BAJURA",
    chineseName: "巴久拉",
    traditionalName: "巴久拉",
    airports: [
      {
        code: "BJU",
        name: "Bajura airport",
        chineseName: "巴茹拉机场",
        traditionalName: "巴茹拉機場",
      },
    ],
  },
  BJV: {
    code: "BJV",
    name: "BODRUM",
    chineseName: "博德鲁姆",
    traditionalName: "博德魯姆",
    airports: [
      {
        code: "BJV",
        name: "Milas",
        chineseName: "米拉斯机场",
        traditionalName: "米拉斯機場",
      },
    ],
  },
  BJW: {
    code: "BJW",
    name: "BAJAWA",
    chineseName: "巴贾瓦",
    traditionalName: "巴賈瓦",
    airports: [
      {
        code: "BJW",
        name: "Soa",
        chineseName: "巴贾瓦机场",
        traditionalName: "巴賈瓦機場",
      },
    ],
  },
  BJX: {
    code: "BJX",
    name: "LEON/GUANAJUATO",
    chineseName: "里昂/瓜纳华托",
    traditionalName: "里昂/瓜納華托",
    airports: [
      {
        code: "BJX",
        name: "Del bajio intl",
        chineseName: "德尔巴乔国际机场",
        traditionalName: "德爾巴喬國際機場",
      },
    ],
  },
  BJZ: {
    code: "BJZ",
    name: "BADAJOZ",
    chineseName: "巴达霍斯",
    traditionalName: "巴達霍斯",
    airports: [
      {
        code: "BJZ",
        name: "Badajoz airport",
        chineseName: "巴达霍斯机场",
        traditionalName: "巴達霍斯機場",
      },
    ],
  },
  BKA: {
    code: "BKA",
    name: "BAYKIT",
    chineseName: "贝基特",
    traditionalName: "貝基特",
    airports: [
      {
        code: "BKA",
        name: "Baykit airport",
        chineseName: "莫斯科机场",
        traditionalName: "莫斯科機場",
      },
    ],
  },
  BKB: {
    code: "BKB",
    name: "BIKANER",
    chineseName: "比卡内尔",
    traditionalName: "比卡內爾",
    airports: [
      {
        code: "BKB",
        name: "Nal",
        chineseName: "比卡内尔机场",
        traditionalName: "比卡內爾機場",
      },
    ],
  },
  BKC: {
    code: "BKC",
    name: "BUCKLAND",
    chineseName: "巴克兰",
    traditionalName: "巴克蘭",
    airports: [
      {
        code: "BKC",
        name: "Buckland airport",
        chineseName: "巴克兰机场",
        traditionalName: "巴克蘭機場",
      },
    ],
  },
  BKI: {
    code: "BKI",
    name: "KOTA KINABALU",
    chineseName: "沙巴",
    traditionalName: "沙巴",
    airports: [
      {
        code: "BKI",
        name: "Kota kinabalu intl.",
        chineseName: "哥打京那巴鲁国际机场",
        traditionalName: "哥打京那巴魯國際機場",
      },
    ],
  },
  BKK: {
    code: "BKK",
    name: "BANGKOK",
    chineseName: "曼谷",
    traditionalName: "曼谷",
    airports: [
      {
        code: "BKK",
        name: "Suvarnabhumi Airport",
        chineseName: "素万那普机场",
        traditionalName: "素萬那普機場",
      },
      {
        code: "DMK",
        name: "Don mueang int'l",
        chineseName: "廊曼国际机场",
        traditionalName: "廊曼國際機場",
      },
    ],
  },
  BKM: {
    code: "BKM",
    name: "BAKELALAN",
    chineseName: "巴卡拉兰",
    traditionalName: "巴卡拉蘭",
    airports: [
      {
        code: "BKM",
        name: "Bakelalan airport",
        chineseName: "巴卡拉兰机场",
        traditionalName: "巴卡拉蘭機場",
      },
    ],
  },
  BKO: {
    code: "BKO",
    name: "BAMAKO",
    chineseName: "巴马科",
    traditionalName: "巴馬科",
    airports: [
      {
        code: "BKO",
        name: "Senou intl",
        chineseName: "塞诺国际机场",
        traditionalName: "塞諾國際機場",
      },
    ],
  },
  BKQ: {
    code: "BKQ",
    name: "BLACKALL",
    chineseName: "布莱科尔",
    traditionalName: "布萊科爾",
    airports: [
      {
        code: "BKQ",
        name: "Blackall airport",
        chineseName: "布莱科尔机场",
        traditionalName: "布萊科爾機場",
      },
    ],
  },
  BKS: {
    code: "BKS",
    name: "BENGKULU",
    chineseName: "明古鲁",
    traditionalName: "明古魯",
    airports: [
      {
        code: "BKS",
        name: "Fatmawati soekarno",
        chineseName: "明古鲁机场",
        traditionalName: "明古魯機場",
      },
    ],
  },
  BKW: {
    code: "BKW",
    name: "BECKLEY",
    chineseName: "贝克利",
    traditionalName: "貝克利",
    airports: [
      {
        code: "BKW",
        name: "Raleigh county mem.",
        chineseName: "罗利县纪念机场",
        traditionalName: "羅利縣紀念機場",
      },
    ],
  },
  BKY: {
    code: "BKY",
    name: "BUKAVU",
    chineseName: "布卡武",
    traditionalName: "布卡武",
    airports: [
      {
        code: "BKY",
        name: "Kavumu",
        chineseName: "卡武穆机场",
        traditionalName: "卡武穆機場",
      },
    ],
  },
  BKZ: {
    code: "BKZ",
    name: "BUKOBA",
    chineseName: "布科巴",
    traditionalName: "布科巴",
    airports: [
      {
        code: "BKZ",
        name: "Bukoba airport",
        chineseName: "布科巴机场",
        traditionalName: "布科巴機場",
      },
    ],
  },
  BLA: {
    code: "BLA",
    name: "BARCELONA",
    chineseName: "巴塞罗那",
    traditionalName: "巴賽隆納",
    airports: [
      {
        code: "BLA",
        name: "J.a. anzoategui intl",
        chineseName: "何塞安东尼奥安佐阿特圭将军机场",
        traditionalName: "何塞安東尼奧安佐阿特圭將軍機場",
      },
    ],
  },
  BLB: {
    code: "BLB",
    name: "BALBOA",
    chineseName: "巴尔博亚",
    traditionalName: "巴爾博亞",
    airports: [
      {
        code: "BLB",
        name: "Panama pacifico",
        chineseName: "巴拿马太平洋国际机场",
        traditionalName: "巴拿馬太平洋國際機場",
      },
    ],
  },
  BLI: {
    code: "BLI",
    name: "BELLINGHAM",
    chineseName: "贝宁汉",
    traditionalName: "貝寧漢",
    airports: [
      {
        code: "BLI",
        name: "Bellingham intl.",
        chineseName: "贝灵厄姆机场",
        traditionalName: "貝靈厄姆機場",
      },
    ],
  },
  BLJ: {
    code: "BLJ",
    name: "BATNA",
    chineseName: "巴特纳",
    traditionalName: "巴特納",
    airports: [
      {
        code: "BLJ",
        name: "Mostepha ben boulaid",
        chineseName: "巴特纳机场",
        traditionalName: "巴特納機場",
      },
    ],
  },
  BLL: {
    code: "BLL",
    name: "BILLUND",
    chineseName: "比隆德",
    traditionalName: "比隆德",
    airports: [
      {
        code: "BLL",
        name: "Billund airport",
        chineseName: "比隆机场",
        traditionalName: "比隆機場",
      },
    ],
  },
  BLQ: {
    code: "BLQ",
    name: "BOLOGNA",
    chineseName: "博罗尼亚",
    traditionalName: "博羅尼亞",
    airports: [
      {
        code: "BLQ",
        name: "Guglielmo marconi",
        chineseName: "古列尔莫马可尼机场",
        traditionalName: "古列爾莫馬可尼機場",
      },
    ],
  },
  BLR: {
    code: "BLR",
    name: "BENGALURU",
    chineseName: "班加罗尔",
    traditionalName: "班加羅爾",
    airports: [
      {
        code: "BLR",
        name: "Kempegowda intl",
        chineseName: "班加罗尔机场",
        traditionalName: "班加羅爾機場",
      },
    ],
  },
  BLV: {
    code: "BLV",
    name: "BELLEVILLE",
    chineseName: "贝尔维尔",
    traditionalName: "貝爾維爾",
    airports: [
      {
        code: "BLV",
        name: "Midamerica st louis",
        chineseName: "中美圣路易斯机场",
        traditionalName: "中美聖路易斯機場",
      },
    ],
  },
  BLZ: {
    code: "BLZ",
    name: "BLANTYRE",
    chineseName: "布兰太尔",
    traditionalName: "布蘭太爾",
    airports: [
      {
        code: "BLZ",
        name: "Chileka intl",
        chineseName: "奇莱卡国际机场",
        traditionalName: "奇萊卡國際機場",
      },
    ],
  },
  BMB: {
    code: "BMB",
    name: "BUMBA",
    chineseName: "本巴",
    traditionalName: "本巴",
    airports: [
      {
        code: "BMB",
        name: "Bumba airport",
        chineseName: "本巴机场",
        traditionalName: "本巴機場",
      },
    ],
  },
  BME: {
    code: "BME",
    name: "BROOME",
    chineseName: "布鲁姆",
    traditionalName: "布魯姆",
    airports: [
      {
        code: "BME",
        name: "Broome intl.",
        chineseName: "布鲁姆国际机场",
        traditionalName: "布魯姆國際機場",
      },
    ],
  },
  BMG: {
    code: "BMG",
    name: "BLOOMINGTON",
    chineseName: "布卢明顿",
    traditionalName: "布隆明頓",
    airports: [
      {
        code: "BMG",
        name: "Monroe county",
        chineseName: "布卢明顿机场",
        traditionalName: "布隆明頓機場",
      },
    ],
  },
  BMI: {
    code: "BMI",
    name: "BLOOMINGTON/NORMAL",
    chineseName: "布卢明顿",
    traditionalName: "布隆明頓",
    airports: [
      {
        code: "BMI",
        name: "Central illinois rgnl",
        chineseName: "伊利诺伊中心城区机场",
        traditionalName: "伊利諾伊中心城區機場",
      },
    ],
  },
  BMK: {
    code: "BMK",
    name: "BORKUM",
    chineseName: "博尔库姆",
    traditionalName: "博爾庫姆",
    airports: [
      {
        code: "BMK",
        name: "Borkum airport",
        chineseName: "博尔库姆机场",
        traditionalName: "博爾庫姆機場",
      },
    ],
  },
  BMO: {
    code: "BMO",
    name: "BHAMO",
    chineseName: "八莫",
    traditionalName: "八莫",
    airports: [
      {
        code: "BMO",
        name: "Bhamo airport",
        chineseName: "八莫机场",
        traditionalName: "八莫機場",
      },
    ],
  },
  BMU: {
    code: "BMU",
    name: "BIMA",
    chineseName: "比马",
    traditionalName: "比馬",
    airports: [
      {
        code: "BMU",
        name: "Sultan m. salahuddin",
        chineseName: "苏丹穆罕默德萨拉胡丁机场",
        traditionalName: "蘇丹穆罕默德薩拉胡丁機場",
      },
    ],
  },
  BMV: {
    code: "BMV",
    name: "BUON MA THUOT",
    chineseName: "巴摩特",
    traditionalName: "巴摩特",
    airports: [
      {
        code: "BMV",
        name: "Buon ma thuot airport",
        chineseName: "蓬杜克机场",
        traditionalName: "蓬杜克機場",
      },
    ],
  },
  BMW: {
    code: "BMW",
    name: "BORDJ MOKHTAR",
    chineseName: "布尔吉巴吉穆赫塔",
    traditionalName: "布爾吉巴吉穆赫塔",
    airports: [
      {
        code: "BMW",
        name: "Bordj mokhtar airport",
        chineseName: "博基巴基莫克塔机场",
        traditionalName: "博基巴基莫克塔機場",
      },
    ],
  },
  BNA: {
    code: "BNA",
    name: "NASHVILLE",
    chineseName: "纳什维尔",
    traditionalName: "納什維爾",
    airports: [
      {
        code: "BNA",
        name: "Nashville intl.",
        chineseName: "纳什维尔国际机场",
        traditionalName: "納什維爾國際機場",
      },
    ],
  },
  BNB: {
    code: "BNB",
    name: "BOENDE",
    chineseName: "博恩代",
    traditionalName: "博恩代",
    airports: [
      {
        code: "BNB",
        name: "Boende airport",
        chineseName: "博恩代机场",
        traditionalName: "博恩代機場",
      },
    ],
  },
  BNC: {
    code: "BNC",
    name: "BENI",
    chineseName: "贝尼",
    traditionalName: "貝尼",
    airports: [
      {
        code: "BNC",
        name: "Mavivi",
        chineseName: "贝尼机场",
        traditionalName: "貝尼機場",
      },
    ],
  },
  BND: {
    code: "BND",
    name: "BANDAR ABBAS",
    chineseName: "阿巴斯港",
    traditionalName: "阿巴斯港",
    airports: [
      {
        code: "BND",
        name: "Bandar abbas intl.",
        chineseName: "阿巴斯港国际机场",
        traditionalName: "阿巴斯港國際機場",
      },
    ],
  },
  BNE: {
    code: "BNE",
    name: "BRISBANE",
    chineseName: "布里斯班",
    traditionalName: "布里斯班",
    airports: [
      {
        code: "BNE",
        name: "Brisbane intl.",
        chineseName: "布里斯班机场",
        traditionalName: "布里斯班機場",
      },
    ],
  },
  BNI: {
    code: "BNI",
    name: "BENIN CITY",
    chineseName: "贝宁城",
    traditionalName: "貝寧城",
    airports: [
      {
        code: "BNI",
        name: "Benin city airport",
        chineseName: "贝宁城机场",
        traditionalName: "貝寧城機場",
      },
    ],
  },
  BNK: {
    code: "BNK",
    name: "BALLINA",
    chineseName: "巴利纳",
    traditionalName: "巴利納",
    airports: [
      {
        code: "BNK",
        name: "Byron gateway",
        chineseName: "拜隆门机场",
        traditionalName: "拜隆門機場",
      },
    ],
  },
  BNN: {
    code: "BNN",
    name: "BRONNOYSUND",
    chineseName: "布伦讷于",
    traditionalName: "布倫訥於",
    airports: [
      {
        code: "BNN",
        name: "Bronnoy",
        chineseName: "布伦讷于机场",
        traditionalName: "布倫訥於機場",
      },
    ],
  },
  BNS: {
    code: "BNS",
    name: "BARINAS",
    chineseName: "巴里纳斯",
    traditionalName: "巴里納斯",
    airports: [
      {
        code: "BNS",
        name: "Barinas airport",
        chineseName: "巴利纳斯机场",
        traditionalName: "巴厘納斯機場",
      },
    ],
  },
  BNX: {
    code: "BNX",
    name: "BANJA LUKA",
    chineseName: "巴尼亚卢卡",
    traditionalName: "巴尼亞盧卡",
    airports: [
      {
        code: "BNX",
        name: "Banja luka intl.",
        chineseName: "巴尼亚卢卡国际机场",
        traditionalName: "巴尼亞盧卡國際機場",
      },
    ],
  },
  BNY: {
    code: "BNY",
    name: "BELLONA",
    chineseName: "贝罗纳",
    traditionalName: "貝羅納",
    airports: [
      {
        code: "BNY",
        name: "Anua",
        chineseName: "贝洛纳机场",
        traditionalName: "貝洛納機場",
      },
    ],
  },
  BOB: {
    code: "BOB",
    name: "BORA BORA",
    chineseName: "波拉波拉",
    traditionalName: "波拉波拉",
    airports: [
      {
        code: "BOB",
        name: "Motu mute",
        chineseName: "莫图莫特机场",
        traditionalName: "莫圖莫特機場",
      },
    ],
  },
  BOC: {
    code: "BOC",
    name: "BOCAS DEL TORO",
    chineseName: "博卡斯德尔托罗",
    traditionalName: "博卡斯德爾托羅",
    airports: [
      {
        code: "BOC",
        name: "Isla colon intl",
        chineseName: "博卡斯德尔托罗机场",
        traditionalName: "博卡斯德爾托羅機場",
      },
    ],
  },
  BOD: {
    code: "BOD",
    name: "BORDEAUX",
    chineseName: "波尔多",
    traditionalName: "波爾多",
    airports: [
      {
        code: "BOD",
        name: "Merignac",
        chineseName: "梅里纳克机场",
        traditionalName: "梅裏納克機場",
      },
    ],
  },
  BOG: {
    code: "BOG",
    name: "BOGOTA",
    chineseName: "波哥大",
    traditionalName: "波哥大",
    airports: [
      {
        code: "BOG",
        name: "El dorado intl",
        chineseName: "埃尔多拉多机场",
        traditionalName: "埃爾多拉多機場",
      },
    ],
  },
  BOH: {
    code: "BOH",
    name: "BOURNEMOUTH",
    chineseName: "伯恩茅斯",
    traditionalName: "伯恩第斯",
    airports: [
      {
        code: "BOH",
        name: "Bournemouth intl.",
        chineseName: "伯恩茅斯机场",
        traditionalName: "伯恩第斯機場",
      },
    ],
  },
  BOI: {
    code: "BOI",
    name: "BOISE",
    chineseName: "博伊亚",
    traditionalName: "博伊亞",
    airports: [
      {
        code: "BOI",
        name: "Air term. (gowen fld)",
        chineseName: "博伊西机场",
        traditionalName: "博伊西機場",
      },
    ],
  },
  BOJ: {
    code: "BOJ",
    name: "BURGAS",
    chineseName: "布尔加斯",
    traditionalName: "布林加斯",
    airports: [
      {
        code: "BOJ",
        name: "Burgas airport",
        chineseName: "博加斯机场",
        traditionalName: "博加斯機場",
      },
    ],
  },
  BOM: {
    code: "BOM",
    name: "MUMBAI",
    chineseName: "孟买",
    traditionalName: "孟買",
    airports: [
      {
        code: "BOM",
        name: "Chhatrapati s maharaj",
        chineseName: "贾特拉帕蒂希瓦吉机场",
        traditionalName: "賈特拉帕蒂希瓦吉機場",
      },
    ],
  },
  BON: {
    code: "BON",
    name: "BONAIRE",
    chineseName: "博内尔岛",
    traditionalName: "博內爾島",
    airports: [
      {
        code: "BON",
        name: "Flamingo international",
        chineseName: "弗拉明戈国际机场",
        traditionalName: "弗拉明戈國際機場",
      },
    ],
  },
  BOO: {
    code: "BOO",
    name: "BODO",
    chineseName: "博多",
    traditionalName: "博多",
    airports: [
      {
        code: "BOO",
        name: "Bodo airport",
        chineseName: "博德机场",
        traditionalName: "博多機場",
      },
    ],
  },
  BOR: {
    code: "BOR",
    name: "MUANG TON PHEUNG",
    chineseName: "贝尔福",
    traditionalName: "貝爾福",
    airports: [
      {
        code: "BOR",
        name: "Bokeo intl",
        chineseName: "博乔国际机场",
        traditionalName: "博喬國際機場",
      },
    ],
  },
  BOS: {
    code: "BOS",
    name: "BOSTON",
    chineseName: "波士顿",
    traditionalName: "波士頓",
    airports: [
      {
        code: "BOS",
        name: "Edward l. logan intl",
        chineseName: "波士顿洛根国际机场",
        traditionalName: "波士頓洛根國際機場",
      },
      {
        code: "PSM",
        name: "Portsmouth pease intl",
        chineseName: "朴茨茅斯国际机场",
        traditionalName: "朴茨茅斯國際機場",
      },
    ],
  },
  BOY: {
    code: "BOY",
    name: "BOBO DIOULASSO",
    chineseName: "博博迪乌拉索",
    traditionalName: "博博迪烏拉索",
    airports: [
      {
        code: "BOY",
        name: "Bobo dioulasso airport",
        chineseName: "博博迪乌拉索机场",
        traditionalName: "博博迪烏拉索機場",
      },
    ],
  },
  BPA: {
    code: "BPA",
    name: "BORONGAN",
    chineseName: "贝思佩奇",
    traditionalName: "貝思佩奇",
    airports: [
      {
        code: "BPA",
        name: "Borongan airport",
        chineseName: "博龙岸机场",
        traditionalName: "博龍岸機場",
      },
    ],
  },
  BPE: {
    code: "BPE",
    name: "QINHUANGDAO",
    chineseName: "秦皇岛",
    traditionalName: "秦皇島",
    airports: [
      {
        code: "BPE",
        name: "Beidaihe",
        chineseName: "北戴河机场",
        traditionalName: "北戴河機場",
      },
    ],
  },
  BPG: {
    code: "BPG",
    name: "BARRA DO GARCAS",
    chineseName: "巴拉杜加萨",
    traditionalName: "巴拉杜加薩",
    airports: [
      {
        code: "BPG",
        name: "Barra do garcas airport",
        chineseName: "巴拉－杜加萨机场",
        traditionalName: "巴拉－杜加薩機場",
      },
    ],
  },
  BPL: {
    code: "BPL",
    name: "BOLE",
    chineseName: "博乐",
    traditionalName: "博樂",
    airports: [
      {
        code: "BPL",
        name: "Alashankou",
        chineseName: "博乐机场",
        traditionalName: "博樂機場",
      },
    ],
  },
  BPN: {
    code: "BPN",
    name: "BALIKPAPAN",
    chineseName: "巴里巴班",
    traditionalName: "巴裏巴班",
    airports: [
      {
        code: "BPN",
        name: "Sepinggan",
        chineseName: "塞平甘机场",
        traditionalName: "塞平甘機場",
      },
    ],
  },
  BPS: {
    code: "BPS",
    name: "PORTO SEGURO",
    chineseName: "塞古鲁港",
    traditionalName: "塞古魯港",
    airports: [
      {
        code: "BPS",
        name: "Porto seguro airport",
        chineseName: "塞古鲁港机场",
        traditionalName: "塞古魯港機場",
      },
    ],
  },
  BPT: {
    code: "BPT",
    name: "BEAUMONT/PORT ARTHUR",
    chineseName: "博蒙特",
    traditionalName: "博蒙特",
    airports: [
      {
        code: "BPT",
        name: "Jack brooks regional",
        chineseName: "杰弗逊郡机场",
        traditionalName: "傑弗遜郡機場",
      },
    ],
  },
  BPX: {
    code: "BPX",
    name: "QAMDO/CHANGDU",
    chineseName: "昌都",
    traditionalName: "昌都",
    airports: [
      {
        code: "BPX",
        name: "Bamda/bangda",
        chineseName: "邦达机场",
        traditionalName: "邦達機場",
      },
    ],
  },
  BQB: {
    code: "BQB",
    name: "BUSSELTON",
    chineseName: "巴瑟尔顿",
    traditionalName: "巴瑟爾頓",
    airports: [
      {
        code: "BQB",
        name: "Busselton airport",
        chineseName: "巴瑟尔顿机场",
        traditionalName: "巴瑟爾頓機場",
      },
    ],
  },
  BQG: {
    code: "BQG",
    name: "BOGORODSKOYE",
    chineseName: "波格若德斯库伊",
    traditionalName: "波格若德斯庫伊",
    airports: [
      {
        code: "BQG",
        name: "Bogorodskoye airport",
        chineseName: "博戈罗茨科耶",
        traditionalName: "博戈羅茨科耶",
      },
    ],
  },
  BQJ: {
    code: "BQJ",
    name: "BATAGAY",
    chineseName: "巴塔基",
    traditionalName: "巴塔基",
    airports: [
      {
        code: "BQJ",
        name: "Batagay airport",
        chineseName: "巴塔盖",
        traditionalName: "巴塔蓋",
      },
    ],
  },
  BQL: {
    code: "BQL",
    name: "BOULIA",
    chineseName: "布里亚",
    traditionalName: "布裡亞",
    airports: [
      {
        code: "BQL",
        name: "Boulia airport",
        chineseName: "布里亚机场",
        traditionalName: "布裡亞機場",
      },
    ],
  },
  BQN: {
    code: "BQN",
    name: "AGUADILLA",
    chineseName: "阿瓜迪亚",
    traditionalName: "阿瓜迪亞",
    airports: [
      {
        code: "BQN",
        name: "Rafael hernandez",
        chineseName: "拉斐尔埃尔南德斯机场",
        traditionalName: "拉斐爾埃爾南德斯機場",
      },
    ],
  },
  BQS: {
    code: "BQS",
    name: "BLAGOVESHCHENSK",
    chineseName: "布拉戈维申斯克",
    traditionalName: "布拉戈維申斯克",
    airports: [
      {
        code: "BQS",
        name: "Ignatyevo",
        chineseName: "布拉格维申斯科机场",
        traditionalName: "布拉格維申斯科機場",
      },
    ],
  },
  BQT: {
    code: "BQT",
    name: "BREST",
    chineseName: "布雷斯特",
    traditionalName: "布列斯特",
    airports: [
      {
        code: "BQT",
        name: "Brest airport",
        chineseName: "布列斯特机场",
        traditionalName: "布列斯特機場",
      },
    ],
  },
  BQU: {
    code: "BQU",
    name: "BEQUIA",
    chineseName: "伊丽莎白港",
    traditionalName: "伊麗沙伯港",
    airports: [
      {
        code: "BQU",
        name: "J.f. mitchell",
        chineseName: "博奎阿机场",
        traditionalName: "博奎阿機場",
      },
    ],
  },
  BQW: {
    code: "BQW",
    name: "BALGO HILL",
    chineseName: "巴尔戈希尔",
    traditionalName: "巴爾戈希爾",
    airports: [
      {
        code: "BQW",
        name: "Balgo hill airport",
        chineseName: "巴尔戈希尔机场",
        traditionalName: "巴爾戈希爾機場",
      },
    ],
  },
  BRA: {
    code: "BRA",
    name: "BARREIRAS",
    chineseName: "巴雷拉斯",
    traditionalName: "巴雷拉斯",
    airports: [
      {
        code: "BRA",
        name: "Barreiras airport",
        chineseName: "巴雷拉斯机场",
        traditionalName: "巴雷拉斯機場",
      },
    ],
  },
  BRB: {
    code: "BRB",
    name: "BARREIRINHAS",
    chineseName: "巴雷里尼亚斯",
    traditionalName: "巴雷裏尼亞斯",
    airports: [
      {
        code: "BRB",
        name: "Barreirinhas airport",
        chineseName: "巴雷里尼亚斯机场",
        traditionalName: "巴雷裏尼亞斯機場",
      },
    ],
  },
  BRC: {
    code: "BRC",
    name: "SAN CARLOS BARILOCHE",
    chineseName: "圣卡洛斯-德巴里洛切",
    traditionalName: "聖卡洛斯-德巴裏洛切",
    airports: [
      {
        code: "BRC",
        name: "San carlos bariloche airport",
        chineseName: "圣卡洛斯德巴里洛切机场",
        traditionalName: "聖卡洛斯德巴裏洛切機場",
      },
    ],
  },
  BRD: {
    code: "BRD",
    name: "BRAINERD",
    chineseName: "布雷纳德",
    traditionalName: "布雷納德",
    airports: [
      {
        code: "BRD",
        name: "Brainerd lakes rgnl",
        chineseName: "布雷纳德湖地区机场",
        traditionalName: "布雷納德湖地區機場",
      },
    ],
  },
  BRE: {
    code: "BRE",
    name: "BREMEN",
    chineseName: "不来梅",
    traditionalName: "不來梅",
    airports: [
      {
        code: "BRE",
        name: "Bremen airport",
        chineseName: "不来梅机场",
        traditionalName: "不來梅機場",
      },
    ],
  },
  BRI: {
    code: "BRI",
    name: "BARI",
    chineseName: "巴里",
    traditionalName: "巴里",
    airports: [
      {
        code: "BRI",
        name: "Palese",
        chineseName: "帕雷瑟机场",
        traditionalName: "帕雷瑟機場",
      },
    ],
  },
  BRK: {
    code: "BRK",
    name: "BOURKE",
    chineseName: "伯克",
    traditionalName: "伯克",
    airports: [
      {
        code: "BRK",
        name: "Bourke airport",
        chineseName: "伯克机场",
        traditionalName: "伯克機場",
      },
    ],
  },
  BRL: {
    code: "BRL",
    name: "BURLINGTON",
    chineseName: "柏林顿",
    traditionalName: "柏林頓",
    airports: [
      {
        code: "BRL",
        name: "Southeast iowa rgnl",
        chineseName: "伯灵顿机场",
        traditionalName: "伯靈頓機場",
      },
    ],
  },
  BRM: {
    code: "BRM",
    name: "BARQUISIMETO",
    chineseName: "巴基西梅托",
    traditionalName: "巴基西梅托",
    airports: [
      {
        code: "BRM",
        name: "Jacinto lara intl",
        chineseName: "巴基西梅托机场",
        traditionalName: "巴基西梅托機場",
      },
    ],
  },
  BRN: {
    code: "BRN",
    name: "BERN",
    chineseName: "伯尔尼",
    traditionalName: "伯恩",
    airports: [
      {
        code: "BRN",
        name: "Belp",
        chineseName: "贝尔普机场",
        traditionalName: "貝爾普機場",
      },
    ],
  },
  BRO: {
    code: "BRO",
    name: "BROWNSVILLE",
    chineseName: "布朗斯维尔",
    traditionalName: "布朗斯維爾",
    airports: [
      {
        code: "BRO",
        name: "South padre is. intl",
        chineseName: "南帕德雷岛国际机场",
        traditionalName: "南帕德雷島國際機場",
      },
    ],
  },
  BRQ: {
    code: "BRQ",
    name: "BRNO",
    chineseName: "布尔诺",
    traditionalName: "布爾諾",
    airports: [
      {
        code: "BRQ",
        name: "Turany",
        chineseName: "图拉尼机场",
        traditionalName: "圖拉尼機場",
      },
    ],
  },
  BRR: {
    code: "BRR",
    name: "BARRA",
    chineseName: "巴拉",
    traditionalName: "巴拉",
    airports: [
      {
        code: "BRR",
        name: "Barra airport",
        chineseName: "巴拉机场",
        traditionalName: "巴拉機場",
      },
    ],
  },
  BRS: {
    code: "BRS",
    name: "BRISTOL",
    chineseName: "布里斯托尔",
    traditionalName: "布裏斯托爾",
    airports: [
      {
        code: "BRS",
        name: "Bristol airport",
        chineseName: "布里斯托尔机场",
        traditionalName: "布裏斯托爾機場",
      },
    ],
  },
  BRT: {
    code: "BRT",
    name: "BATHURST ISLAND",
    chineseName: "巴瑟斯特岛",
    traditionalName: "巴瑟斯特島",
    airports: [
      {
        code: "BRT",
        name: "Bathurst island airport",
        chineseName: "巴瑟斯特岛机场",
        traditionalName: "巴瑟斯特島機場",
      },
    ],
  },
  BRU: {
    code: "BRU",
    name: "BRUSSELS",
    chineseName: "布鲁塞尔",
    traditionalName: "布魯塞爾",
    airports: [
      {
        code: "BRU",
        name: "Brussels airport",
        chineseName: "布鲁塞尔国际机场",
        traditionalName: "布魯塞爾國際機場",
      },
      {
        code: "CRL",
        name: "Brussels s. charleroi",
        chineseName: "南部沙勒罗瓦机场",
        traditionalName: "南部沙勒羅瓦機場",
      },
    ],
  },
  BRW: {
    code: "BRW",
    name: "UTQIAGVIK BARROW",
    chineseName: "阿拉斯加州巴罗",
    traditionalName: "阿拉斯加州巴羅",
    airports: [
      {
        code: "BRW",
        name: "W.post-w.rogers mem.",
        chineseName: "怀利波斯特威尔罗杰斯纪念机场",
        traditionalName: "懷利波斯特威爾羅傑斯紀念機場",
      },
    ],
  },
  BSA: {
    code: "BSA",
    name: "BOSASO",
    chineseName: "博萨索",
    traditionalName: "博薩索",
    airports: [
      {
        code: "BSA",
        name: "Bosaso intl.",
        chineseName: "博萨索机场",
        traditionalName: "博薩索機場",
      },
    ],
  },
  BSB: {
    code: "BSB",
    name: "BRASILIA",
    chineseName: "巴西利亚",
    traditionalName: "巴西利亞",
    airports: [
      {
        code: "BSB",
        name: "J. kubitschek intl",
        chineseName: "巴西利亚国际机场",
        traditionalName: "巴西利亞國際機場",
      },
    ],
  },
  BSC: {
    code: "BSC",
    name: "BAHIA SOLANO",
    chineseName: "巴希亚索拉诺",
    traditionalName: "巴希亞索拉諾",
    airports: [
      {
        code: "BSC",
        name: "Jose celestino mutis",
        chineseName: "巴亚索拉诺机场",
        traditionalName: "巴亞索拉諾機場",
      },
    ],
  },
  BSD: {
    code: "BSD",
    name: "BAOSHAN",
    chineseName: "保山",
    traditionalName: "保山",
    airports: [
      {
        code: "BSD",
        name: "Baoshan airport",
        chineseName: "保山机场",
        traditionalName: "保山機場",
      },
    ],
  },
  BSG: {
    code: "BSG",
    name: "BATA",
    chineseName: "巴塔",
    traditionalName: "巴塔",
    airports: [
      {
        code: "BSG",
        name: "Bata airport",
        chineseName: "巴塔机场",
        traditionalName: "巴塔機場",
      },
    ],
  },
  BSK: {
    code: "BSK",
    name: "BISKRA",
    chineseName: "比斯克拉",
    traditionalName: "比斯克拉",
    airports: [
      {
        code: "BSK",
        name: "Mohamed khider",
        chineseName: "比斯克拉机场",
        traditionalName: "比斯克拉機場",
      },
    ],
  },
  BSO: {
    code: "BSO",
    name: "BASCO",
    chineseName: "巴士古",
    traditionalName: "巴士古",
    airports: [
      {
        code: "BSO",
        name: "Basco airport",
        chineseName: "巴示戈机场",
        traditionalName: "巴示戈機場",
      },
    ],
  },
  BSR: {
    code: "BSR",
    name: "BASRAH",
    chineseName: "巴士拉",
    traditionalName: "巴士拉",
    airports: [
      {
        code: "BSR",
        name: "Basrah intl.",
        chineseName: "巴士拉国际机场",
        traditionalName: "巴士拉國際機場",
      },
    ],
  },
  BSX: {
    code: "BSX",
    name: "PATHEIN",
    chineseName: "勃生",
    traditionalName: "勃生",
    airports: [
      {
        code: "BSX",
        name: "Pathein airport",
        chineseName: "伯赛恩机场",
        traditionalName: "伯賽恩機場",
      },
    ],
  },
  BTC: {
    code: "BTC",
    name: "BATTICALOA",
    chineseName: "拜蒂克洛",
    traditionalName: "拜蒂克洛",
    airports: [
      {
        code: "BTC",
        name: "Batticaloa airport",
        chineseName: "拜蒂克洛机场",
        traditionalName: "拜蒂克洛機場",
      },
    ],
  },
  BTH: {
    code: "BTH",
    name: "BATAM",
    chineseName: "巴淡岛",
    traditionalName: "巴淡島",
    airports: [
      {
        code: "BTH",
        name: "Hang nadim",
        chineseName: "杭纳迪姆机场",
        traditionalName: "杭納迪姆機場",
      },
    ],
  },
  BTI: {
    code: "BTI",
    name: "BARTER ISLAND",
    chineseName: "巴特岛",
    traditionalName: "巴特島",
    airports: [
      {
        code: "BTI",
        name: "Barter island airport",
        chineseName: "巴特岛机场",
        traditionalName: "巴特島機場",
      },
    ],
  },
  BTJ: {
    code: "BTJ",
    name: "BANDA ACEH",
    chineseName: "班达亚齐",
    traditionalName: "班達亞齊",
    airports: [
      {
        code: "BTJ",
        name: "Sultan iskandar muda",
        chineseName: "班达亚齐机场",
        traditionalName: "班達亞齊機場",
      },
    ],
  },
  BTK: {
    code: "BTK",
    name: "BRATSK",
    chineseName: "布拉茨克",
    traditionalName: "布拉茨克",
    airports: [
      {
        code: "BTK",
        name: "Bratsk airport",
        chineseName: "布拉茨克机场",
        traditionalName: "布拉茨克機場",
      },
    ],
  },
  BTM: {
    code: "BTM",
    name: "BUTTE",
    chineseName: "比尤特",
    traditionalName: "比尤特",
    airports: [
      {
        code: "BTM",
        name: "Bert mooney",
        chineseName: "伯特穆尼机场",
        traditionalName: "伯特穆尼機場",
      },
    ],
  },
  BTR: {
    code: "BTR",
    name: "BATON ROUGE",
    chineseName: "巴吞鲁日",
    traditionalName: "巴吞魯日",
    airports: [
      {
        code: "BTR",
        name: "Metropolitan-ryan fld",
        chineseName: "瑞安机场",
        traditionalName: "里安機場",
      },
    ],
  },
  BTS: {
    code: "BTS",
    name: "BRATISLAVA",
    chineseName: "布拉迪斯拉发",
    traditionalName: "布拉提斯拉瓦",
    airports: [
      {
        code: "BTS",
        name: "M.r. stefanik",
        chineseName: "M.R.斯特法尼科机场",
        traditionalName: "M.R.斯特法尼科機場",
      },
    ],
  },
  BTT: {
    code: "BTT",
    name: "BETTLES",
    chineseName: "贝特尔斯",
    traditionalName: "貝特爾斯",
    airports: [
      {
        code: "BTT",
        name: "Bettles airport",
        chineseName: "贝特尔斯机场",
        traditionalName: "貝特爾斯機場",
      },
    ],
  },
  BTU: {
    code: "BTU",
    name: "BINTULU",
    chineseName: "民都鲁",
    traditionalName: "民都魯",
    airports: [
      {
        code: "BTU",
        name: "Bintulu airport",
        chineseName: "民都鲁机场",
        traditionalName: "民都魯機場",
      },
    ],
  },
  BTV: {
    code: "BTV",
    name: "BURLINGTON",
    chineseName: "伯灵顿",
    traditionalName: "伯靈頓",
    airports: [
      {
        code: "BTV",
        name: "Burlington intl.",
        chineseName: "伯灵顿国际机场",
        traditionalName: "伯靈頓國際機場",
      },
    ],
  },
  BTW: {
    code: "BTW",
    name: "BATU LICIN",
    chineseName: "巴都利金",
    traditionalName: "巴都利金",
    airports: [
      {
        code: "BTW",
        name: "Batu licin airport",
        chineseName: "巴都利金机场",
        traditionalName: "巴都利金機場",
      },
    ],
  },
  BUA: {
    code: "BUA",
    name: "BUKA",
    chineseName: "布卡",
    traditionalName: "布卡",
    airports: [
      {
        code: "BUA",
        name: "Buka airport",
        chineseName: "布卡机场",
        traditionalName: "布卡機場",
      },
    ],
  },
  BUB: {
    code: "BUB",
    name: "BURWELL",
    chineseName: "内布拉斯加州伯韦尔",
    traditionalName: "內布拉斯加州伯韋爾",
    airports: [
      {
        code: "BUB",
        name: "Cram field",
        chineseName: "伯韦尔机场",
        traditionalName: "伯韋爾機場",
      },
    ],
  },
  BUC: {
    code: "BUC",
    name: "BURKETOWN",
    chineseName: "伯克敦",
    traditionalName: "伯克敦",
    airports: [
      {
        code: "BUC",
        name: "Burketown airport",
        chineseName: "伯克敦机场",
        traditionalName: "伯克敦機場",
      },
    ],
  },
  BUD: {
    code: "BUD",
    name: "BUDAPEST",
    chineseName: "布达佩斯",
    traditionalName: "布達佩斯",
    airports: [
      {
        code: "BUD",
        name: "Liszt ferenc int'l",
        chineseName: "李斯特弗朗茨国际机场",
        traditionalName: "李斯特弗朗茨國際機場",
      },
    ],
  },
  BUE: {
    code: "BUE",
    name: "BUENOS AIRES",
    chineseName: "布宜诺斯艾利斯",
    traditionalName: "布宜諾賽勒斯",
    airports: [
      {
        code: "AEP",
        name: "Jorge newbery",
        chineseName: "豪尔赫纽伯里机场",
        traditionalName: "豪爾赫紐伯裏機場",
      },
      {
        code: "EZE",
        name: "Ministro pistarini",
        chineseName: "米尼斯特罗皮斯塔里尼机场",
        traditionalName: "米尼斯特羅皮斯塔裏尼機場",
      },
    ],
  },
  BUF: {
    code: "BUF",
    name: "BUFFALO",
    chineseName: "布法罗",
    traditionalName: "布法羅",
    airports: [
      {
        code: "BUF",
        name: "Niagara international",
        chineseName: "尼亚加拉国际机场",
        traditionalName: "尼亞加拉國際機場",
      },
    ],
  },
  BUH: {
    code: "BUH",
    name: "BUCHAREST",
    chineseName: "布加勒斯特",
    traditionalName: "布加勒斯特",
    airports: [
      {
        code: "BBU",
        name: "Baneasa - aurel vlaicu",
        chineseName: "巴内萨机场",
        traditionalName: "巴內薩機場",
      },
      {
        code: "OTP",
        name: "Henri coanda",
        chineseName: "亨利科安达机场",
        traditionalName: "亨利科安達機場",
      },
    ],
  },
  BUL: {
    code: "BUL",
    name: "BULOLO",
    chineseName: "布洛洛",
    traditionalName: "布洛洛",
    airports: [
      {
        code: "BUL",
        name: "Bulolo airport",
        chineseName: "布洛洛机场",
        traditionalName: "布洛洛機場",
      },
    ],
  },
  BUN: {
    code: "BUN",
    name: "BUENAVENTURA",
    chineseName: "布埃纳文图拉",
    traditionalName: "布埃納文圖拉",
    airports: [
      {
        code: "BUN",
        name: "Gerardo tobar lopez",
        chineseName: "布埃纳文图拉机场",
        traditionalName: "布埃納文圖拉機場",
      },
    ],
  },
  BUP: {
    code: "BUP",
    name: "BATHINDA",
    chineseName: "珀丁达",
    traditionalName: "珀丁達",
    airports: [
      {
        code: "BUP",
        name: "Bathinda airport",
        chineseName: "珀丁达机场",
        traditionalName: "珀丁達機場",
      },
    ],
  },
  BUQ: {
    code: "BUQ",
    name: "BULAWAYO",
    chineseName: "布拉瓦约",
    traditionalName: "布拉瓦約",
    airports: [
      {
        code: "BUQ",
        name: "Joshua m. nkomo intl",
        chineseName: "布拉瓦约机场",
        traditionalName: "布拉瓦約機場",
      },
    ],
  },
  BUR: {
    code: "BUR",
    name: "BURBANK",
    chineseName: "伯班克",
    traditionalName: "伯班克",
    airports: [
      {
        code: "BUR",
        name: "Bob hope",
        chineseName: "鲍勃霍普机场",
        traditionalName: "鮑勃霍普機場",
      },
    ],
  },
  BUS: {
    code: "BUS",
    name: "BATUMI",
    chineseName: "巴统",
    traditionalName: "巴統",
    airports: [
      {
        code: "BUS",
        name: "Batumi airport",
        chineseName: "巴统机场",
        traditionalName: "巴統機場",
      },
    ],
  },
  BUT: {
    code: "BUT",
    name: "JAKAR",
    chineseName: "伯顿伍德",
    traditionalName: "伯頓伍德",
    airports: [
      {
        code: "BUT",
        name: "Bathpalathang",
        chineseName: "巴斯帕拉唐机场",
        traditionalName: "巴斯帕拉唐機場",
      },
    ],
  },
  BUU: {
    code: "BUU",
    name: "MUARA BUNGO",
    chineseName: "布约",
    traditionalName: "布約",
    airports: [
      {
        code: "BUU",
        name: "Muara bungo airport",
        chineseName: "布尤机场",
        traditionalName: "布尤機場",
      },
    ],
  },
  BUW: {
    code: "BUW",
    name: "BAUBAU",
    chineseName: "巴务巴务",
    traditionalName: "巴務巴務",
    airports: [
      {
        code: "BUW",
        name: "Betoambari",
        chineseName: "巴务巴务机场",
        traditionalName: "巴務巴務機場",
      },
    ],
  },
  BUX: {
    code: "BUX",
    name: "BUNIA",
    chineseName: "布尼亚",
    traditionalName: "布尼亞",
    airports: [
      {
        code: "BUX",
        name: "Bunia airport",
        chineseName: "布尼亚机场",
        traditionalName: "布尼亞機場",
      },
    ],
  },
  BUZ: {
    code: "BUZ",
    name: "BUSHEHR",
    chineseName: "布什尔",
    traditionalName: "布希爾",
    airports: [
      {
        code: "BUZ",
        name: "Bushehr airport",
        chineseName: "布什尔机场",
        traditionalName: "布希爾機場",
      },
    ],
  },
  BVB: {
    code: "BVB",
    name: "BOA VISTA",
    chineseName: "博阿维斯塔",
    traditionalName: "博阿維斯塔",
    airports: [
      {
        code: "BVB",
        name: "A.b. cantanhede intl",
        chineseName: "保艾佩蓝卡机场",
        traditionalName: "保艾佩藍卡機場",
      },
    ],
  },
  BVC: {
    code: "BVC",
    name: "BOA VISTA ISLAND",
    chineseName: "博阿维斯塔",
    traditionalName: "博阿維斯塔",
    airports: [
      {
        code: "BVC",
        name: "Rabil",
        chineseName: "拉比尔机场",
        traditionalName: "拉比爾機場",
      },
    ],
  },
  BVE: {
    code: "BVE",
    name: "BRIVE-LA-GAILLARDE",
    chineseName: "布里夫拉盖亚尔德",
    traditionalName: "布裡夫拉蓋亞爾德",
    airports: [
      {
        code: "BVE",
        name: "Vallee de la dordogne",
        chineseName: "布里维拉加拉德机场",
        traditionalName: "布裡維拉加拉德機場",
      },
    ],
  },
  BVG: {
    code: "BVG",
    name: "BERLEVAG",
    chineseName: "贝勒沃格",
    traditionalName: "貝勒沃格",
    airports: [
      {
        code: "BVG",
        name: "Berlevag airport",
        chineseName: "贝勒沃格机场",
        traditionalName: "貝勒沃格機場",
      },
    ],
  },
  BVH: {
    code: "BVH",
    name: "VILHENA",
    chineseName: "维列纳",
    traditionalName: "維列納",
    airports: [
      {
        code: "BVH",
        name: "Brigadeiro camarao",
        chineseName: "维列纳机场",
        traditionalName: "維列納機場",
      },
    ],
  },
  BVI: {
    code: "BVI",
    name: "BIRDSVILLE",
    chineseName: "伯兹维尔",
    traditionalName: "伯茲維爾",
    airports: [
      {
        code: "BVI",
        name: "Birdsville airport",
        chineseName: "伯兹维尔机场",
        traditionalName: "伯茲維爾機場",
      },
    ],
  },
  BVS: {
    code: "BVS",
    name: "BREVES",
    chineseName: "布雷维斯",
    traditionalName: "布雷維斯",
    airports: [
      {
        code: "BVS",
        name: "Breves airport",
        chineseName: "布雷维斯机场",
        traditionalName: "布雷維斯機場",
      },
    ],
  },
  BWA: {
    code: "BWA",
    name: "BHAIRAHAWA",
    chineseName: "帕伊拉瓦",
    traditionalName: "帕伊拉瓦",
    airports: [
      {
        code: "BWA",
        name: "Gautam buddha",
        chineseName: "帕伊拉瓦机场",
        traditionalName: "帕伊拉瓦機場",
      },
    ],
  },
  BWB: {
    code: "BWB",
    name: "BARROW ISLAND",
    chineseName: "巴罗岛",
    traditionalName: "巴羅島",
    airports: [
      {
        code: "BWB",
        name: "Barrow island airport",
        chineseName: "巴罗岛机场",
        traditionalName: "巴羅島機場",
      },
    ],
  },
  BWE: {
    code: "BWE",
    name: "BRAUNSCHWEIG/WOLFSBURG",
    chineseName: "不伦瑞克",
    traditionalName: "布勞恩斯魏克",
    airports: [
      {
        code: "BWE",
        name: "Braunschweig/wolfsburg airport",
        chineseName: "布劳恩史维希机场",
        traditionalName: "布勞恩史維希機場",
      },
    ],
  },
  BWG: {
    code: "BWG",
    name: "BOWLING GREEN",
    chineseName: "博林格林",
    traditionalName: "博林格林",
    airports: [
      {
        code: "BWG",
        name: "Warren county regional",
        chineseName: "鲍灵格林机场",
        traditionalName: "鮑靈格林機場",
      },
    ],
  },
  BWI: {
    code: "BWI",
    name: "BALTIMORE",
    chineseName: "巴尔的摩",
    traditionalName: "巴爾的摩",
    airports: [
      {
        code: "BWI",
        name: "Baltimore/wash. intl",
        chineseName: "巴尔的摩机场",
        traditionalName: "巴爾的摩機場",
      },
    ],
  },
  BWK: {
    code: "BWK",
    name: "BRAC",
    chineseName: "波尔",
    traditionalName: "波爾",
    airports: [
      {
        code: "BWK",
        name: "Bol",
        chineseName: "博尔机场",
        traditionalName: "博爾機場",
      },
    ],
  },
  BWN: {
    code: "BWN",
    name: "BANDAR SERI BEGAWAN",
    chineseName: "斯里巴加湾市",
    traditionalName: "斯裡巴加灣市",
    airports: [
      {
        code: "BWN",
        name: "Brunei international",
        chineseName: "文莱国际机场",
        traditionalName: "汶萊國際機場",
      },
    ],
  },
  BWT: {
    code: "BWT",
    name: "BURNIE",
    chineseName: "伯尼",
    traditionalName: "伯尼",
    airports: [
      {
        code: "BWT",
        name: "Wynyard",
        chineseName: "伯尼机场",
        traditionalName: "伯尼機場",
      },
    ],
  },
  BWX: {
    code: "BWX",
    name: "BANYUWANGI",
    chineseName: "外南梦（巴纽旺宜）",
    traditionalName: "外南夢（巴紐旺宜）",
    airports: [
      {
        code: "BWX",
        name: "Blimbingsari",
        chineseName: "比林姆宾沙里机场",
        traditionalName: "比林姆賓沙裡機場",
      },
    ],
  },
  BXB: {
    code: "BXB",
    name: "IRARUTU",
    chineseName: "巴博",
    traditionalName: "巴博",
    airports: [
      {
        code: "BXB",
        name: "Babo",
        chineseName: "巴博机场",
        traditionalName: "巴博機場",
      },
    ],
  },
  BXG: {
    code: "BXG",
    name: "BENDIGO",
    chineseName: "本迪戈",
    traditionalName: "本迪戈",
    airports: [
      {
        code: "BXG",
        name: "Bendigo airport",
        chineseName: "本迪戈机场",
        traditionalName: "本迪戈機場",
      },
    ],
  },
  BXU: {
    code: "BXU",
    name: "BUTUAN",
    chineseName: "武端",
    traditionalName: "武端",
    airports: [
      {
        code: "BXU",
        name: "Bancasi",
        chineseName: "武端机场",
        traditionalName: "武端機場",
      },
    ],
  },
  BXY: {
    code: "BXY",
    name: "BAYKONUR",
    chineseName: "拜科努尔",
    traditionalName: "拜科努爾",
    airports: [
      {
        code: "BXY",
        name: "Krayniy",
        chineseName: "克里尼机场",
        traditionalName: "克裏尼機場",
      },
    ],
  },
  BYK: {
    code: "BYK",
    name: "BOUAKE",
    chineseName: "布瓦凯",
    traditionalName: "博瓦海",
    airports: [
      {
        code: "BYK",
        name: "Bouake airport",
        chineseName: "布瓦凯机场",
        traditionalName: "博瓦海機場",
      },
    ],
  },
  BYM: {
    code: "BYM",
    name: "BAYAMO",
    chineseName: "巴亚莫",
    traditionalName: "巴亞莫",
    airports: [
      {
        code: "BYM",
        name: "Carlos m. de cespedes",
        chineseName: "卡洛斯曼努埃尔塞斯佩德斯机场",
        traditionalName: "卡洛斯曼努埃爾塞斯佩德斯機場",
      },
    ],
  },
  BYO: {
    code: "BYO",
    name: "BONITO",
    chineseName: "博尼托",
    traditionalName: "博尼托",
    airports: [
      {
        code: "BYO",
        name: "Bonito airport",
        chineseName: "博尼图机场",
        traditionalName: "博尼圖機場",
      },
    ],
  },
  BYP: {
    code: "BYP",
    name: "BARIMUNYA",
    chineseName: "巴里穆亚",
    traditionalName: "巴里穆亞",
    airports: [
      {
        code: "BYP",
        name: "Barimunya airport",
        chineseName: "八日目雅机场",
        traditionalName: "八日目雅機場",
      },
    ],
  },
  BYR: {
    code: "BYR",
    name: "LAESO",
    chineseName: "莱斯岛",
    traditionalName: "萊斯島",
    airports: [
      {
        code: "BYR",
        name: "Laeso airport",
        chineseName: "莱斯岛机场",
        traditionalName: "萊斯島機場",
      },
    ],
  },
  BYW: {
    code: "BYW",
    name: "BLAKELY ISLAND",
    chineseName: "布莱克利岛",
    traditionalName: "布萊克利島",
    airports: [
      {
        code: "BYW",
        name: "Blakely island airport",
        chineseName: "布莱克利岛机场",
        traditionalName: "布萊克利島機場",
      },
    ],
  },
  BZE: {
    code: "BZE",
    name: "BELIZE CITY",
    chineseName: "伯利兹城",
    traditionalName: "貝裡斯城",
    airports: [
      {
        code: "BZE",
        name: "Philip s.w.goldson int",
        chineseName: "菲利普戈尔德森国际机场",
        traditionalName: "菲利普戈爾德森國際機場",
      },
      {
        code: "TZA",
        name: "Belize city municipal",
        chineseName: "伯利兹地方机场",
        traditionalName: "貝裡斯地方機場",
      },
    ],
  },
  BZG: {
    code: "BZG",
    name: "BYDGOSZCZ",
    chineseName: "比得哥什",
    traditionalName: "比得哥什",
    airports: [
      {
        code: "BZG",
        name: "Ignacy jan paderewski",
        chineseName: "伊格纳西帕德雷夫斯基机场",
        traditionalName: "伊格納西帕德雷夫斯基機場",
      },
    ],
  },
  BZL: {
    code: "BZL",
    name: "BARISAL",
    chineseName: "巴里萨尔",
    traditionalName: "巴里薩爾",
    airports: [
      {
        code: "BZL",
        name: "Barisal airport",
        chineseName: "巴里萨尔机场",
        traditionalName: "巴里薩爾機場",
      },
    ],
  },
  BZN: {
    code: "BZN",
    name: "BOZEMAN",
    chineseName: "博兹曼",
    traditionalName: "博茲曼",
    airports: [
      {
        code: "BZN",
        name: "Yellowstone intl",
        chineseName: "博兹曼黄石国际机场",
        traditionalName: "博茲曼黃石國際機場",
      },
    ],
  },
  BZO: {
    code: "BZO",
    name: "BOLZANO/BOZEN",
    chineseName: "博尔扎诺",
    traditionalName: "博爾紮諾",
    airports: [
      {
        code: "BZO",
        name: "Dolomiti",
        chineseName: "博尔扎诺机场",
        traditionalName: "博爾紮諾機場",
      },
    ],
  },
  BZR: {
    code: "BZR",
    name: "BEZIERS",
    chineseName: "贝济耶",
    traditionalName: "貝濟耶",
    airports: [
      {
        code: "BZR",
        name: "Vias",
        chineseName: "维阿斯机场",
        traditionalName: "維阿斯機場",
      },
    ],
  },
  BZV: {
    code: "BZV",
    name: "BRAZZAVILLE",
    chineseName: "布拉柴维尔",
    traditionalName: "布拉柴維爾",
    airports: [
      {
        code: "BZV",
        name: "Maya-maya",
        chineseName: "马亚马亚机场",
        traditionalName: "馬亞馬亞機場",
      },
    ],
  },
  BZX: {
    code: "BZX",
    name: "BAZHONG",
    chineseName: "巴中",
    traditionalName: "巴中",
    airports: [
      {
        code: "BZX",
        name: "Enyang",
        chineseName: "恩阳机场",
        traditionalName: "恩陽機場",
      },
    ],
  },
  CAB: {
    code: "CAB",
    name: "CABINDA",
    chineseName: "卡宾达",
    traditionalName: "卡賓達",
    airports: [
      {
        code: "CAB",
        name: "Cabinda airport",
        chineseName: "卡宾达机场",
        traditionalName: "卡賓達機場",
      },
    ],
  },
  CAC: {
    code: "CAC",
    name: "CASCAVEL",
    chineseName: "卡斯卡韦尔",
    traditionalName: "卡斯卡韋爾",
    airports: [
      {
        code: "CAC",
        name: "A.mendes da silva",
        chineseName: "卡斯卡韦尔机场",
        traditionalName: "卡斯卡韋爾機場",
      },
    ],
  },
  CAE: {
    code: "CAE",
    name: "COLUMBIA",
    chineseName: "哥伦比亚",
    traditionalName: "哥倫比亞",
    airports: [
      {
        code: "CAE",
        name: "Metropolitan apt",
        chineseName: "哥伦比亚大都会机场",
        traditionalName: "哥倫比亞大都會機場",
      },
    ],
  },
  CAG: {
    code: "CAG",
    name: "CAGLIARI",
    chineseName: "卡利亚里",
    traditionalName: "卡利亞里",
    airports: [
      {
        code: "CAG",
        name: "Elmas",
        chineseName: "埃尔马斯机场",
        traditionalName: "埃爾馬斯機場",
      },
    ],
  },
  CAH: {
    code: "CAH",
    name: "CA MAU",
    chineseName: "金瓯",
    traditionalName: "金甌",
    airports: [
      {
        code: "CAH",
        name: "Ca mau airport",
        chineseName: "金瓯机场",
        traditionalName: "金甌機場",
      },
    ],
  },
  CAI: {
    code: "CAI",
    name: "CAIRO",
    chineseName: "开罗",
    traditionalName: "開羅",
    airports: [
      {
        code: "CAI",
        name: "Cairo intl.",
        chineseName: "开罗国际机场",
        traditionalName: "開羅國際機場",
      },
    ],
  },
  CAJ: {
    code: "CAJ",
    name: "CANAIMA",
    chineseName: "卡奈玛",
    traditionalName: "卡奈瑪",
    airports: [
      {
        code: "CAJ",
        name: "Canaima airport",
        chineseName: "卡奈玛机场",
        traditionalName: "卡奈瑪機場",
      },
    ],
  },
  CAK: {
    code: "CAK",
    name: "AKRON/CANTON",
    chineseName: "斯塔克",
    traditionalName: "斯塔克",
    airports: [
      {
        code: "CAK",
        name: "Akron/canton reg. airport",
        chineseName: "阿克伦坎通地区机场",
        traditionalName: "阿克倫坎通地區機場",
      },
    ],
  },
  CAL: {
    code: "CAL",
    name: "CAMPBELTOWN",
    chineseName: "坎贝尔",
    traditionalName: "坎貝爾",
    airports: [
      {
        code: "CAL",
        name: "Campbeltown airport",
        chineseName: "坎贝尔镇机场",
        traditionalName: "坎貝爾鎮機場",
      },
    ],
  },
  CAN: {
    code: "CAN",
    name: "GUANGZHOU",
    chineseName: "广州",
    traditionalName: "廣州",
    airports: [
      {
        code: "CAN",
        name: "Baiyun intl",
        chineseName: "白云国际机场",
        traditionalName: "白雲國際機場",
      },
    ],
  },
  CAP: {
    code: "CAP",
    name: "CAP-HAITIEN",
    chineseName: "海地角",
    traditionalName: "海地角",
    airports: [
      {
        code: "CAP",
        name: "Hugo chavez intl",
        chineseName: "海地角机场",
        traditionalName: "海地角機場",
      },
    ],
  },
  CAT: {
    code: "CAT",
    name: "CASCAIS",
    chineseName: "卡斯凯斯",
    traditionalName: "卡斯凱斯",
    airports: [
      {
        code: "CAT",
        name: "Tires",
        chineseName: "泰尔斯机场",
        traditionalName: "泰爾斯機場",
      },
    ],
  },
  CAU: {
    code: "CAU",
    name: "CARUARU",
    chineseName: "卡鲁阿鲁",
    traditionalName: "卡魯阿魯",
    airports: [
      {
        code: "CAU",
        name: "Oscar laranjeiras",
        chineseName: "卡鲁阿鲁机场",
        traditionalName: "卡魯阿魯機場",
      },
    ],
  },
  CAW: {
    code: "CAW",
    name: "CAMPOS DOS GOYTACAZES",
    chineseName: "坎普斯",
    traditionalName: "坎普斯",
    airports: [
      {
        code: "CAW",
        name: "Bartolomeu lisandro",
        chineseName: "巴托罗莫里桑德罗机场",
        traditionalName: "巴托羅莫裏桑德羅機場",
      },
    ],
  },
  CAY: {
    code: "CAY",
    name: "CAYENNE",
    chineseName: "卡宴",
    traditionalName: "卡宴",
    airports: [
      {
        code: "CAY",
        name: "Felix eboue",
        chineseName: "费利克斯埃布埃机场",
        traditionalName: "菲力克斯埃布埃機場",
      },
    ],
  },
  CAZ: {
    code: "CAZ",
    name: "COBAR",
    chineseName: "科巴",
    traditionalName: "科巴",
    airports: [
      {
        code: "CAZ",
        name: "Cobar airport",
        chineseName: "科巴机场",
        traditionalName: "科巴機場",
      },
    ],
  },
  CBB: {
    code: "CBB",
    name: "COCHABAMBA",
    chineseName: "科恰班巴",
    traditionalName: "科恰班巴",
    airports: [
      {
        code: "CBB",
        name: "Jorge wilstermann intl",
        chineseName: "威尔斯特曼机场",
        traditionalName: "威爾斯特曼機場",
      },
    ],
  },
  CBG: {
    code: "CBG",
    name: "CAMBRIDGE",
    chineseName: "剑桥",
    traditionalName: "劍橋",
    airports: [
      {
        code: "CBG",
        name: "Cambridge airport",
        chineseName: "剑桥机场",
        traditionalName: "劍橋機場",
      },
    ],
  },
  CBH: {
    code: "CBH",
    name: "BECHAR",
    chineseName: "贝沙尔",
    traditionalName: "貝沙爾",
    airports: [
      {
        code: "CBH",
        name: "Boudghene b. ali lotfi",
        chineseName: "贝沙尔机场",
        traditionalName: "貝沙爾機場",
      },
    ],
  },
  CBI: {
    code: "CBI",
    name: "CAPE BARREN ISLAND",
    chineseName: "巴伦角岛",
    traditionalName: "巴倫角島",
    airports: [
      {
        code: "CBI",
        name: "Cape barren island airport",
        chineseName: "巴伦角岛机场",
        traditionalName: "巴倫角島機場",
      },
    ],
  },
  CBL: {
    code: "CBL",
    name: "CIUDAD BOLIVAR",
    chineseName: "玻利瓦尔城",
    traditionalName: "玻利瓦爾城",
    airports: [
      {
        code: "CBL",
        name: "Tomas de heres",
        chineseName: "玻利瓦尔城机场",
        traditionalName: "玻利瓦爾城機場",
      },
    ],
  },
  CBO: {
    code: "CBO",
    name: "COTABATO",
    chineseName: "哥打巴托",
    traditionalName: "哥打巴托",
    airports: [
      {
        code: "CBO",
        name: "Awang",
        chineseName: "阿旺机场",
        traditionalName: "阿旺機場",
      },
    ],
  },
  CBQ: {
    code: "CBQ",
    name: "CALABAR",
    chineseName: "卡拉巴尔",
    traditionalName: "卡拉巴爾",
    airports: [
      {
        code: "CBQ",
        name: "Margaret ekpo intl",
        chineseName: "卡拉巴尔机场",
        traditionalName: "卡拉巴爾機場",
      },
    ],
  },
  CBR: {
    code: "CBR",
    name: "CANBERRA",
    chineseName: "堪培拉",
    traditionalName: "坎培拉",
    airports: [
      {
        code: "CBR",
        name: "Canberra airport",
        chineseName: "堪培拉机场",
        traditionalName: "坎培拉機場",
      },
    ],
  },
  CBT: {
    code: "CBT",
    name: "CATUMBELA",
    chineseName: "卡通贝拉",
    traditionalName: "卡通貝拉",
    airports: [
      {
        code: "CBT",
        name: "Catumbela airport",
        chineseName: "卡图姆贝拉机场",
        traditionalName: "卡圖姆貝拉機場",
      },
    ],
  },
  CCC: {
    code: "CCC",
    name: "CAYO COCO",
    chineseName: "科克岛",
    traditionalName: "科克島",
    airports: [
      {
        code: "CCC",
        name: "Jardines del rey",
        chineseName: "科克岛机场",
        traditionalName: "科克島機場",
      },
    ],
  },
  CCF: {
    code: "CCF",
    name: "CARCASSONNE",
    chineseName: "卡尔卡松机场",
    traditionalName: "卡爾卡松機場",
    airports: [
      {
        code: "CCF",
        name: "Salvaza",
        chineseName: "萨尔瓦扎机场",
        traditionalName: "薩爾瓦紮機場",
      },
    ],
  },
  CCJ: {
    code: "CCJ",
    name: "KOZHIKODE",
    chineseName: "科泽科德",
    traditionalName: "科澤科德",
    airports: [
      {
        code: "CCJ",
        name: "Kozhikode intl.",
        chineseName: "科泽科德机场",
        traditionalName: "科澤科德機場",
      },
    ],
  },
  CCK: {
    code: "CCK",
    name: "COCOS ISLANDS",
    chineseName: "科科斯群岛",
    traditionalName: "科科斯群島",
    airports: [
      {
        code: "CCK",
        name: "Cocos islands airport",
        chineseName: "科科斯群岛机场",
        traditionalName: "科科斯群島機場",
      },
    ],
  },
  CCP: {
    code: "CCP",
    name: "CONCEPCION",
    chineseName: "康塞普西翁",
    traditionalName: "康塞普西翁",
    airports: [
      {
        code: "CCP",
        name: "Carriel sur",
        chineseName: "卡里尔苏尔机场",
        traditionalName: "卡里爾蘇爾機場",
      },
    ],
  },
  CCR: {
    code: "CCR",
    name: "CONCORD",
    chineseName: "加利福尼亚州康科德",
    traditionalName: "加利福尼亞州康科特",
    airports: [
      {
        code: "CCR",
        name: "Buchanan field",
        chineseName: "布查南机场",
        traditionalName: "布查南機場",
      },
    ],
  },
  CCS: {
    code: "CCS",
    name: "CARACAS",
    chineseName: "加拉加斯",
    traditionalName: "卡拉卡斯",
    airports: [
      {
        code: "CCS",
        name: "Simon bolivar intl",
        chineseName: "西蒙玻利瓦尔国际机场",
        traditionalName: "西蒙玻利瓦爾省國際機場",
      },
    ],
  },
  CCU: {
    code: "CCU",
    name: "KOLKATA",
    chineseName: "加尔各答",
    traditionalName: "加爾各答",
    airports: [
      {
        code: "CCU",
        name: "Subhas chandra bose",
        chineseName: "加尔各答机场",
        traditionalName: "加爾各答機場",
      },
    ],
  },
  CCV: {
    code: "CCV",
    name: "CRAIG COVE",
    chineseName: "克雷格湾",
    traditionalName: "克雷格灣",
    airports: [
      {
        code: "CCV",
        name: "Craig cove airport",
        chineseName: "克雷格考夫机场",
        traditionalName: "克雷格考夫機場",
      },
    ],
  },
  CCZ: {
    code: "CCZ",
    name: "CHUB CAY",
    chineseName: "恰波岛",
    traditionalName: "恰波島",
    airports: [
      {
        code: "CCZ",
        name: "Chub cay intl.",
        chineseName: "恰波岛机场",
        traditionalName: "恰波島機場",
      },
    ],
  },
  CDB: {
    code: "CDB",
    name: "COLD BAY",
    chineseName: "科尔德贝",
    traditionalName: "科爾德貝",
    airports: [
      {
        code: "CDB",
        name: "Cold bay airport",
        chineseName: "科尔德贝机场",
        traditionalName: "科爾德貝機場",
      },
    ],
  },
  CDC: {
    code: "CDC",
    name: "CEDAR CITY",
    chineseName: "锡达城",
    traditionalName: "錫達城",
    airports: [
      {
        code: "CDC",
        name: "Cedar city reg. airport",
        chineseName: "锡达城机场",
        traditionalName: "錫達城機場",
      },
    ],
  },
  CDE: {
    code: "CDE",
    name: "CHENGDE",
    chineseName: "承德",
    traditionalName: "承德",
    airports: [
      {
        code: "CDE",
        name: "Puning",
        chineseName: "决定岬直升飞机场",
        traditionalName: "决定岬直升飛機場",
      },
    ],
  },
  CDP: {
    code: "CDP",
    name: "CUDDAPAH",
    chineseName: "古德伯",
    traditionalName: "古德伯",
    airports: [
      {
        code: "CDP",
        name: "Cuddapah airport",
        chineseName: "古德伯机场",
        traditionalName: "古德伯機場",
      },
    ],
  },
  CDR: {
    code: "CDR",
    name: "CHADRON",
    chineseName: "查德隆",
    traditionalName: "查德隆",
    airports: [
      {
        code: "CDR",
        name: "Chadron municipal",
        chineseName: "查德隆机场",
        traditionalName: "查德隆機場",
      },
    ],
  },
  CDT: {
    code: "CDT",
    name: "CASTELLON DE LA PLANA",
    chineseName: "卡斯特利翁-德拉普拉纳",
    traditionalName: "卡斯特利翁-德拉普拉納",
    airports: [
      {
        code: "CDT",
        name: "Castellon de la plana airport",
        chineseName: "卡斯特利翁-德拉普拉纳机场",
        traditionalName: "卡斯特利翁-德拉普拉納機場",
      },
    ],
  },
  CDV: {
    code: "CDV",
    name: "CORDOVA",
    chineseName: "科尔多瓦",
    traditionalName: "科爾多瓦",
    airports: [
      {
        code: "CDV",
        name: "Merle k (mudhole)smith",
        chineseName: "穆德霍勒史密斯机场",
        traditionalName: "穆德霍勒史密斯機場",
      },
    ],
  },
  CDW: {
    code: "CDW",
    name: "CALDWELL",
    chineseName: "新泽西州考德威尔",
    traditionalName: "新澤西州考德威爾",
    airports: [
      {
        code: "CDW",
        name: "Essex county",
        chineseName: "考德威尔机场",
        traditionalName: "考德威爾機場",
      },
    ],
  },
  CEB: {
    code: "CEB",
    name: "CEBU",
    chineseName: "宿雾",
    traditionalName: "宿霧",
    airports: [
      {
        code: "CEB",
        name: "Mactan international",
        chineseName: "马克坦国际机场",
        traditionalName: "馬克坦國際機場",
      },
    ],
  },
  CEC: {
    code: "CEC",
    name: "CRESCENT CITY",
    chineseName: "加利福尼亚州新月",
    traditionalName: "加利福尼亞州新月",
    airports: [
      {
        code: "CEC",
        name: "Del norte county rgnl",
        chineseName: "克雷森特城机场",
        traditionalName: "克雷森特城機場",
      },
    ],
  },
  CED: {
    code: "CED",
    name: "CEDUNA",
    chineseName: "塞杜纳",
    traditionalName: "塞杜納",
    airports: [
      {
        code: "CED",
        name: "Ceduna airport",
        chineseName: "塞杜纳机场",
        traditionalName: "塞杜納機場",
      },
    ],
  },
  CEE: {
    code: "CEE",
    name: "CHEREPOVETS",
    chineseName: "切列波维茨",
    traditionalName: "切列波維茨",
    airports: [
      {
        code: "CEE",
        name: "Cherepovets airport",
        chineseName: "切列波维茨机场",
        traditionalName: "切列波維茨機場",
      },
    ],
  },
  CEG: {
    code: "CEG",
    name: "CHESTER",
    chineseName: "切斯特",
    traditionalName: "賈斯特",
    airports: [
      {
        code: "CEG",
        name: "Hawarden",
        chineseName: "切斯特机场",
        traditionalName: "賈斯特機場",
      },
    ],
  },
  CEI: {
    code: "CEI",
    name: "CHIANG RAI",
    chineseName: "清莱",
    traditionalName: "清萊",
    airports: [
      {
        code: "CEI",
        name: "Mae fah luang intl",
        chineseName: "清莱机场",
        traditionalName: "清萊機場",
      },
    ],
  },
  CEK: {
    code: "CEK",
    name: "CHELYABINSK",
    chineseName: "车里雅宾斯",
    traditionalName: "車裏雅賓斯",
    airports: [
      {
        code: "CEK",
        name: "Balandino",
        chineseName: "车里雅宾斯克机场",
        traditionalName: "車裡雅賓斯克機場",
      },
    ],
  },
  CEM: {
    code: "CEM",
    name: "CENTRAL",
    chineseName: "阿拉斯加市中",
    traditionalName: "阿拉斯加市中",
    airports: [
      {
        code: "CEM",
        name: "Central airport",
        chineseName: "森特勒尔机场",
        traditionalName: "森特勒爾機場",
      },
    ],
  },
  CEN: {
    code: "CEN",
    name: "CIUDAD OBREGON",
    chineseName: "奥夫雷贡城",
    traditionalName: "克夫雷貢城",
    airports: [
      {
        code: "CEN",
        name: "Ciudad obregon intl.",
        chineseName: "奥夫雷贡城机场",
        traditionalName: "克夫雷貢城機場",
      },
    ],
  },
  CEQ: {
    code: "CEQ",
    name: "CANNES",
    chineseName: "戛纳",
    traditionalName: "戛納",
    airports: [
      {
        code: "CEQ",
        name: "Mandelieu",
        chineseName: "戛纳机场",
        traditionalName: "戛納機場",
      },
    ],
  },
  CEZ: {
    code: "CEZ",
    name: "CORTEZ",
    chineseName: "科尔特斯",
    traditionalName: "科爾特斯",
    airports: [
      {
        code: "CEZ",
        name: "Cortez municipal",
        chineseName: "科特斯机场",
        traditionalName: "科特斯機場",
      },
    ],
  },
  CFB: {
    code: "CFB",
    name: "CABO FRIO",
    chineseName: "卡布弗里乌",
    traditionalName: "卡布弗裏烏",
    airports: [
      {
        code: "CFB",
        name: "Cabo frio intl.",
        chineseName: "卡布弗里乌机场",
        traditionalName: "卡布弗裏烏機場",
      },
    ],
  },
  CFE: {
    code: "CFE",
    name: "CLERMONT-FERRAND",
    chineseName: "克莱蒙费朗市",
    traditionalName: "克萊蒙費朗市",
    airports: [
      {
        code: "CFE",
        name: "Auvergne",
        chineseName: "奥弗涅机场",
        traditionalName: "奧弗涅機場",
      },
    ],
  },
  CFG: {
    code: "CFG",
    name: "CIENFUEGOS",
    chineseName: "西恩富戈斯",
    traditionalName: "西恩富戈斯",
    airports: [
      {
        code: "CFG",
        name: "Jaime gonzalez",
        chineseName: "杰米冈萨雷斯机场",
        traditionalName: "傑米岡薩雷斯機場",
      },
    ],
  },
  CFK: {
    code: "CFK",
    name: "CHLEF",
    chineseName: "谢里夫",
    traditionalName: "謝裡夫",
    airports: [
      {
        code: "CFK",
        name: "Aboubakr belkaid",
        chineseName: "奇莱夫机场",
        traditionalName: "奇萊夫機場",
      },
    ],
  },
  CFN: {
    code: "CFN",
    name: "DONEGAL",
    chineseName: "多尼戈尔",
    traditionalName: "多尼戈爾",
    airports: [
      {
        code: "CFN",
        name: "Donegal airport",
        chineseName: "多尼戈尔机场",
        traditionalName: "多尼戈爾機場",
      },
    ],
  },
  CFR: {
    code: "CFR",
    name: "CAEN",
    chineseName: "卡昂",
    traditionalName: "卡昂",
    airports: [
      {
        code: "CFR",
        name: "Carpiquet",
        chineseName: "卡匹克机场",
        traditionalName: "卡匹克機場",
      },
    ],
  },
  CFS: {
    code: "CFS",
    name: "COFFS HARBOUR",
    chineseName: "科夫斯港",
    traditionalName: "科夫斯港",
    airports: [
      {
        code: "CFS",
        name: "Coffs harbour airport",
        chineseName: "科夫斯港机场",
        traditionalName: "科夫斯港機場",
      },
    ],
  },
  CFU: {
    code: "CFU",
    name: "KERKYRA",
    chineseName: "克基拉岛",
    traditionalName: "克基拉島",
    airports: [
      {
        code: "CFU",
        name: "Ioannis kapodistrias",
        chineseName: "卡波迪斯特里阿斯机场",
        traditionalName: "卡波迪斯特裡阿斯機場",
      },
    ],
  },
  CGA: {
    code: "CGA",
    name: "CRAIG",
    chineseName: "克雷格",
    traditionalName: "克雷格",
    airports: [
      {
        code: "CGA",
        name: "Sea plane base",
        chineseName: "克雷格水上飞机基地",
        traditionalName: "克雷格水上飛機基地",
      },
    ],
  },
  CGB: {
    code: "CGB",
    name: "CUIABA",
    chineseName: "库亚巴",
    traditionalName: "庫亞巴",
    airports: [
      {
        code: "CGB",
        name: "Marechal rondon intl",
        chineseName: "马雷夏尔隆登机场",
        traditionalName: "馬雷夏爾隆登機場",
      },
    ],
  },
  CGD: {
    code: "CGD",
    name: "CHANGDE",
    chineseName: "常德",
    traditionalName: "常德",
    airports: [
      {
        code: "CGD",
        name: "Taohuayuan",
        chineseName: "桃花源机场",
        traditionalName: "桃花源機場",
      },
    ],
  },
  CGI: {
    code: "CGI",
    name: "CAPE GIRARDEAU",
    chineseName: "开普吉拉多",
    traditionalName: "開普吉拉多",
    airports: [
      {
        code: "CGI",
        name: "Cape girardeau reg. airport",
        chineseName: "开普吉拉多机场",
        traditionalName: "開普吉拉多機場",
      },
    ],
  },
  CGM: {
    code: "CGM",
    name: "CAMIGUIN ISLAND",
    chineseName: "曼巴豪",
    traditionalName: "曼巴豪",
    airports: [
      {
        code: "CGM",
        name: "Mambajao",
        chineseName: "马姆巴尧机场",
        traditionalName: "馬姆巴堯機場",
      },
    ],
  },
  CGN: {
    code: "CGN",
    name: "COLOGNE/BONN",
    chineseName: "科隆",
    traditionalName: "科隆",
    airports: [
      {
        code: "CGN",
        name: "Cologne/bonn airport",
        chineseName: "科隆机场",
        traditionalName: "科隆機場",
      },
    ],
  },
  CGO: {
    code: "CGO",
    name: "ZHENGZHOU",
    chineseName: "郑州",
    traditionalName: "鄭州",
    airports: [
      {
        code: "CGO",
        name: "Xinzheng intl",
        chineseName: "郑州新郑国际机场",
        traditionalName: "鄭州新鄭國際機場",
      },
    ],
  },
  CGP: {
    code: "CGP",
    name: "CHITTAGONG",
    chineseName: "吉大港",
    traditionalName: "吉大港",
    airports: [
      {
        code: "CGP",
        name: "Shah amanat intl",
        chineseName: "吉大港机场",
        traditionalName: "吉大港機場",
      },
    ],
  },
  CGQ: {
    code: "CGQ",
    name: "CHANGCHUN",
    chineseName: "长春",
    traditionalName: "長春",
    airports: [
      {
        code: "CGQ",
        name: "Longjia intl",
        chineseName: "龙嘉国际机场",
        traditionalName: "龍嘉國際機場",
      },
    ],
  },
  CGR: {
    code: "CGR",
    name: "CAMPO GRANDE",
    chineseName: "大坎普",
    traditionalName: "大坎普",
    airports: [
      {
        code: "CGR",
        name: "Campo grande intl.",
        chineseName: "大坎普国际机场",
        traditionalName: "大坎普國際機場",
      },
    ],
  },
  CGY: {
    code: "CGY",
    name: "CAGAYAN DE ORO",
    chineseName: "卡加延德奥罗",
    traditionalName: "卡加延德奧羅",
    airports: [
      {
        code: "CGY",
        name: "Laguindingan intl",
        chineseName: "Laguindingan国际机场",
        traditionalName: "Laguindingan國際機場",
      },
    ],
  },
  CHA: {
    code: "CHA",
    name: "CHATTANOOGA",
    chineseName: "查塔努加",
    traditionalName: "查塔努加",
    airports: [
      {
        code: "CHA",
        name: "Metropolitan apt",
        chineseName: "查塔努加大都会机场",
        traditionalName: "查塔努加大都會機場",
      },
    ],
  },
  CHC: {
    code: "CHC",
    name: "CHRISTCHURCH",
    chineseName: "基督城",
    traditionalName: "基督城",
    airports: [
      {
        code: "CHC",
        name: "Christchurch intl.",
        chineseName: "克赖斯特彻奇国际机场",
        traditionalName: "克賴斯特徹奇國際機場",
      },
    ],
  },
  CHG: {
    code: "CHG",
    name: "CHAOYANG (LIAONING)",
    chineseName: "朝阳",
    traditionalName: "朝陽",
    airports: [
      {
        code: "CHG",
        name: "Chaoyang",
        chineseName: "朝阳机场",
        traditionalName: "朝陽機場",
      },
    ],
  },
  CHH: {
    code: "CHH",
    name: "CHACHAPOYAS",
    chineseName: "查查波亚斯",
    traditionalName: "查查波亞斯",
    airports: [
      {
        code: "CHH",
        name: "Chachapoyas airport",
        chineseName: "查查波亚斯机场",
        traditionalName: "查查波亞斯機場",
      },
    ],
  },
  CHI: {
    code: "CHI",
    name: "CHICAGO",
    chineseName: "芝加哥",
    traditionalName: "芝加哥",
    airports: [
      {
        code: "DPA",
        name: "Dupage",
        chineseName: "杜佩奇机场",
        traditionalName: "杜佩奇機場",
      },
      {
        code: "MDW",
        name: "Midway international",
        chineseName: "米德威国际机场",
        traditionalName: "米德威國際機場",
      },
      {
        code: "ORD",
        name: "O'hare international",
        chineseName: "奥黑尔国际机场",
        traditionalName: "奧黑爾國際機場",
      },
      {
        code: "RFD",
        name: "Chicago/rockford intl",
        chineseName: "罗克福德国际机场",
        traditionalName: "羅克福德國際機場",
      },
    ],
  },
  CHO: {
    code: "CHO",
    name: "CHARLOTTESVILLE",
    chineseName: "夏洛茨维尔",
    traditionalName: "夏洛茨維爾",
    airports: [
      {
        code: "CHO",
        name: "Albemarle",
        chineseName: "阿尔伯马尔机场",
        traditionalName: "阿爾伯馬爾機場",
      },
    ],
  },
  CHQ: {
    code: "CHQ",
    name: "CHANIA",
    chineseName: "干尼亚",
    traditionalName: "干尼亞",
    airports: [
      {
        code: "CHQ",
        name: "Ioannis daskalogiannis",
        chineseName: "索达机场",
        traditionalName: "索達機場",
      },
    ],
  },
  CHS: {
    code: "CHS",
    name: "CHARLESTON",
    chineseName: "查尔斯顿",
    traditionalName: "查爾斯頓",
    airports: [
      {
        code: "CHS",
        name: "International/afb",
        chineseName: "查尔斯顿国际机场",
        traditionalName: "查爾斯頓國際機場",
      },
    ],
  },
  CHT: {
    code: "CHT",
    name: "CHATHAM ISLAND",
    chineseName: "查塔姆群岛",
    traditionalName: "查塔姆群島",
    airports: [
      {
        code: "CHT",
        name: "Tuuta",
        chineseName: "卡雷瓦机场",
        traditionalName: "卡雷瓦機場",
      },
    ],
  },
  CHU: {
    code: "CHU",
    name: "CHUATHBALUK",
    chineseName: "阿拉斯加州城市Chuathbalu",
    traditionalName: "阿拉斯加州都市Chuathbalu",
    airports: [
      {
        code: "CHU",
        name: "Chuathbaluk airport",
        chineseName: "乔阿特巴芦克机场",
        traditionalName: "喬阿特巴蘆克機場",
      },
    ],
  },
  CHX: {
    code: "CHX",
    name: "CHANGUINOLA",
    chineseName: "钱吉诺拉",
    traditionalName: "錢吉諾拉",
    airports: [
      {
        code: "CHX",
        name: "Manuel nino intl",
        chineseName: "钱吉诺拉机场",
        traditionalName: "錢吉諾拉機場",
      },
    ],
  },
  CHY: {
    code: "CHY",
    name: "CHOISEUL BAY",
    chineseName: "舒瓦瑟尔湾",
    traditionalName: "舒瓦瑟爾灣",
    airports: [
      {
        code: "CHY",
        name: "Choiseul bay airport",
        chineseName: "舒瓦瑟尔贝机场",
        traditionalName: "舒瓦瑟爾貝機場",
      },
    ],
  },
  CID: {
    code: "CID",
    name: "CEDAR RAPIDS",
    chineseName: "锡达拉皮兹",
    traditionalName: "錫達拉皮茲",
    airports: [
      {
        code: "CID",
        name: "The eastern iowa",
        chineseName: "东爱荷华机场",
        traditionalName: "東愛荷華機場",
      },
    ],
  },
  CIF: {
    code: "CIF",
    name: "CHIFENG",
    chineseName: "赤峰",
    traditionalName: "赤峰",
    airports: [
      {
        code: "CIF",
        name: "Yulong",
        chineseName: "赤峰玉龙机场",
        traditionalName: "赤峰玉龍機場",
      },
    ],
  },
  CIH: {
    code: "CIH",
    name: "CHANGZHI",
    chineseName: "长治",
    traditionalName: "長治",
    airports: [
      {
        code: "CIH",
        name: "Wangcun",
        chineseName: "长治机场",
        traditionalName: "長治機場",
      },
    ],
  },
  CIJ: {
    code: "CIJ",
    name: "COBIJA",
    chineseName: "科维哈",
    traditionalName: "科維哈",
    airports: [
      {
        code: "CIJ",
        name: "Capitan anibal arab",
        chineseName: "阿尼瓦尔阿拉布上尉机场",
        traditionalName: "阿尼瓦爾阿拉布上尉機場",
      },
    ],
  },
  CIK: {
    code: "CIK",
    name: "CHALKYITSIK",
    chineseName: "阿拉斯加州查尔基茨克",
    traditionalName: "阿拉斯加州查爾基茨克",
    airports: [
      {
        code: "CIK",
        name: "Chalkyitsik airport",
        chineseName: "查尔基奇克机场",
        traditionalName: "查爾基奇克機場",
      },
    ],
  },
  CIT: {
    code: "CIT",
    name: "SHYMKENT",
    chineseName: "奇姆肯特",
    traditionalName: "奇姆肯特",
    airports: [
      {
        code: "CIT",
        name: "Shymkent intl.",
        chineseName: "希姆肯特国际机场",
        traditionalName: "希姆肯特國際機場",
      },
    ],
  },
  CIX: {
    code: "CIX",
    name: "CHICLAYO",
    chineseName: "奇克拉约",
    traditionalName: "奇克拉約",
    airports: [
      {
        code: "CIX",
        name: "J.a. quinones gonzalez",
        chineseName: "奇克拉约机场",
        traditionalName: "奇克拉約機場",
      },
    ],
  },
  CIY: {
    code: "CIY",
    name: "COMISO",
    chineseName: "科米索",
    traditionalName: "科米索",
    airports: [
      {
        code: "CIY",
        name: "Vincenzo magliocco",
        chineseName: "科米索机场",
        traditionalName: "科米索機場",
      },
    ],
  },
  CIZ: {
    code: "CIZ",
    name: "COARI",
    chineseName: "科阿里",
    traditionalName: "科阿裏",
    airports: [
      {
        code: "CIZ",
        name: "Coari airport",
        chineseName: "科阿里机场",
        traditionalName: "科阿裡機場",
      },
    ],
  },
  CJA: {
    code: "CJA",
    name: "CAJAMARCA",
    chineseName: "卡哈马卡",
    traditionalName: "卡哈馬卡",
    airports: [
      {
        code: "CJA",
        name: "Armando r. iglesias",
        chineseName: "卡哈马卡机场",
        traditionalName: "卡哈馬卡機場",
      },
    ],
  },
  CJB: {
    code: "CJB",
    name: "COIMBATORE",
    chineseName: "哥印拜陀",
    traditionalName: "哥印拜陀",
    airports: [
      {
        code: "CJB",
        name: "Coimbatore intl.",
        chineseName: "哥印拜陀国际机场",
        traditionalName: "哥印拜陀國際機場",
      },
    ],
  },
  CJC: {
    code: "CJC",
    name: "CALAMA",
    chineseName: "卡拉马",
    traditionalName: "卡拉馬",
    airports: [
      {
        code: "CJC",
        name: "El loa",
        chineseName: "埃尔罗阿机场",
        traditionalName: "埃爾羅阿機場",
      },
    ],
  },
  CJF: {
    code: "CJF",
    name: "COONDEWANNA",
    chineseName: "纽曼",
    traditionalName: "紐曼",
    airports: [
      {
        code: "CJF",
        name: "Coondewanna airport",
        chineseName: "库德旺纳",
        traditionalName: "庫德旺納",
      },
    ],
  },
  CJJ: {
    code: "CJJ",
    name: "CHEONGJU",
    chineseName: "清州",
    traditionalName: "清州",
    airports: [
      {
        code: "CJJ",
        name: "Cheongju intl.",
        chineseName: "清州国际机场",
        traditionalName: "清州國際機場",
      },
    ],
  },
  CJM: {
    code: "CJM",
    name: "CHUMPHON",
    chineseName: "春蓬",
    traditionalName: "春蓬",
    airports: [
      {
        code: "CJM",
        name: "Chumphon airport",
        chineseName: "春蓬机场",
        traditionalName: "春蓬機場",
      },
    ],
  },
  CJN: {
    code: "CJN",
    name: "CIJULANG",
    chineseName: "加利福尼亚州El Cajon",
    traditionalName: "加利福尼亞州El Cajon",
    airports: [
      {
        code: "CJN",
        name: "Nusawiru",
        chineseName: "El Cajon机场",
        traditionalName: "El Cajon機場",
      },
    ],
  },
  CJS: {
    code: "CJS",
    name: "CIUDAD JUAREZ",
    chineseName: "华雷斯",
    traditionalName: "華雷斯",
    airports: [
      {
        code: "CJS",
        name: "Abraham gonzalez intl",
        chineseName: "亚伯拉罕冈萨雷斯国际机场",
        traditionalName: "亞伯拉罕岡薩雷斯國際機場",
      },
    ],
  },
  CJU: {
    code: "CJU",
    name: "JEJU",
    chineseName: "济州岛",
    traditionalName: "濟州島",
    airports: [
      {
        code: "CJU",
        name: "Jeju intl.",
        chineseName: "济州国际机场",
        traditionalName: "濟州國際機場",
      },
    ],
  },
  CJZ: {
    code: "CJZ",
    name: "CAJAZEIRAS",
    chineseName: "卡贾泽拉斯",
    traditionalName: "卡賈澤拉斯",
    airports: [
      {
        code: "CJZ",
        name: "Cajazeiras airport",
        chineseName: "CAJAZEIRAS机场",
        traditionalName: "Cajazeiras機場",
      },
    ],
  },
  CKB: {
    code: "CKB",
    name: "CLARKSBURG",
    chineseName: "克拉克斯堡",
    traditionalName: "克拉克斯堡",
    airports: [
      {
        code: "CKB",
        name: "North central w.v.",
        chineseName: "北方中西部弗吉尼亚机场",
        traditionalName: "北方中西部維吉尼亞機場",
      },
    ],
  },
  CKD: {
    code: "CKD",
    name: "CROOKED CREEK",
    chineseName: "克鲁克德克里克",
    traditionalName: "克魯克德克裏克",
    airports: [
      {
        code: "CKD",
        name: "Crooked creek airport",
        chineseName: "克鲁克德克里克机场",
        traditionalName: "克魯克德克裏克機場",
      },
    ],
  },
  CKG: {
    code: "CKG",
    name: "CHONGQING",
    chineseName: "重庆",
    traditionalName: "重慶",
    airports: [
      {
        code: "CKG",
        name: "Jiangbei intl",
        chineseName: "江北国际机场",
        traditionalName: "江北國際機場",
      },
    ],
  },
  CKH: {
    code: "CKH",
    name: "CHOKURDAKH",
    chineseName: "乔库尔达",
    traditionalName: "喬庫爾達",
    airports: [
      {
        code: "CKH",
        name: "Chokurdakh airport",
        chineseName: "乔科达机场",
        traditionalName: "喬科達機場",
      },
    ],
  },
  CKI: {
    code: "CKI",
    name: "CROKER ISLAND",
    chineseName: "克罗克岛",
    traditionalName: "克羅克島",
    airports: [
      {
        code: "CKI",
        name: "Croker island airport",
        chineseName: "克罗克岛机场",
        traditionalName: "克羅克島機場",
      },
    ],
  },
  CKS: {
    code: "CKS",
    name: "PARAUAPEBAS",
    chineseName: "卡拉加斯",
    traditionalName: "卡拉加斯",
    airports: [
      {
        code: "CKS",
        name: "Carajas",
        chineseName: "加拉杰斯机场",
        traditionalName: "加拉傑斯機場",
      },
    ],
  },
  CKX: {
    code: "CKX",
    name: "CHICKEN",
    chineseName: "奇金",
    traditionalName: "奇金",
    airports: [
      {
        code: "CKX",
        name: "Chicken airport",
        chineseName: "奇金机场",
        traditionalName: "奇金機場",
      },
    ],
  },
  CKY: {
    code: "CKY",
    name: "CONAKRY",
    chineseName: "科纳克里",
    traditionalName: "柯那克里",
    airports: [
      {
        code: "CKY",
        name: "Conakry intl.",
        chineseName: "科纳克里机场",
        traditionalName: "柯那克里機場",
      },
    ],
  },
  CKZ: {
    code: "CKZ",
    name: "CANAKKALE",
    chineseName: "恰纳卡莱",
    traditionalName: "恰納卡萊",
    airports: [
      {
        code: "CKZ",
        name: "Canakkale airport",
        chineseName: "恰纳卡莱机场",
        traditionalName: "恰納卡萊機場",
      },
    ],
  },
  CLE: {
    code: "CLE",
    name: "CLEVELAND",
    chineseName: "克利夫兰",
    traditionalName: "克利夫蘭",
    airports: [
      {
        code: "CLE",
        name: "Hopkins international",
        chineseName: "克利夫兰机场",
        traditionalName: "克利夫蘭機場",
      },
    ],
  },
  CLJ: {
    code: "CLJ",
    name: "CLUJ-NAPOCA",
    chineseName: "克鲁日",
    traditionalName: "克魯日",
    airports: [
      {
        code: "CLJ",
        name: "Cluj-napoca airport",
        chineseName: "克鲁拿波卡机场",
        traditionalName: "克魯拿波卡機場",
      },
    ],
  },
  CLL: {
    code: "CLL",
    name: "COLLEGE STATION",
    chineseName: "布拉索斯",
    traditionalName: "布拉索斯",
    airports: [
      {
        code: "CLL",
        name: "Easterwood field",
        chineseName: "伊斯特伍德机场",
        traditionalName: "伊斯特伍德機場",
      },
    ],
  },
  CLO: {
    code: "CLO",
    name: "CALI",
    chineseName: "卡利",
    traditionalName: "卡利",
    airports: [
      {
        code: "CLO",
        name: "Alfonso b. aragon intl",
        chineseName: "阿方索阿拉贡机场",
        traditionalName: "阿方索阿拉貢機場",
      },
    ],
  },
  CLP: {
    code: "CLP",
    name: "CLARKS POINT",
    chineseName: "阿拉斯加市克拉克",
    traditionalName: "阿拉斯加市克拉克",
    airports: [
      {
        code: "CLP",
        name: "Clarks point airport",
        chineseName: "克拉克斯波因特机场",
        traditionalName: "克拉克斯波因特機場",
      },
    ],
  },
  CLQ: {
    code: "CLQ",
    name: "COLIMA",
    chineseName: "科利马",
    traditionalName: "科利馬",
    airports: [
      {
        code: "CLQ",
        name: "Miguel de la madrid",
        chineseName: "米盖尔德拉马德里机场",
        traditionalName: "米蓋爾德拉馬德里機場",
      },
    ],
  },
  CLT: {
    code: "CLT",
    name: "CHARLOTTE",
    chineseName: "夏洛特",
    traditionalName: "夏洛特",
    airports: [
      {
        code: "CLT",
        name: "Douglas intl",
        chineseName: "道格拉斯国际机场",
        traditionalName: "道格拉斯國際機場",
      },
    ],
  },
  CLV: {
    code: "CLV",
    name: "CALDAS NOVAS",
    chineseName: "新卡尔达斯",
    traditionalName: "新卡爾達斯",
    airports: [
      {
        code: "CLV",
        name: "Nelson r. guimaraes",
        chineseName: "新卡尔达斯机场",
        traditionalName: "新卡爾達斯機場",
      },
    ],
  },
  CLY: {
    code: "CLY",
    name: "CALVI",
    chineseName: "卡尔维",
    traditionalName: "卡爾維",
    airports: [
      {
        code: "CLY",
        name: "Ste catherine",
        chineseName: "圣凯瑟琳机场",
        traditionalName: "聖凱薩琳機場",
      },
    ],
  },
  CMA: {
    code: "CMA",
    name: "CUNNAMULLA",
    chineseName: "坎纳马拉",
    traditionalName: "坎納馬拉",
    airports: [
      {
        code: "CMA",
        name: "Cunnamulla airport",
        chineseName: "坎纳马拉机场",
        traditionalName: "坎納馬拉機場",
      },
    ],
  },
  CMB: {
    code: "CMB",
    name: "COLOMBO",
    chineseName: "科伦坡",
    traditionalName: "可倫坡",
    airports: [
      {
        code: "CMB",
        name: "Bandaranaike intl",
        chineseName: "班达拉奈克国际机场",
        traditionalName: "班達拉尼克國際機場",
      },
      {
        code: "DGM",
        name: "Dandugama spb",
        chineseName: "科伦坡机场",
        traditionalName: "可倫坡機場",
      },
    ],
  },
  CME: {
    code: "CME",
    name: "CIUDAD DEL CARMEN",
    chineseName: "卡门城",
    traditionalName: "卡門城",
    airports: [
      {
        code: "CME",
        name: "Ciudad del carmen intl.",
        chineseName: "卡门城国际机场",
        traditionalName: "卡門城國際機場",
      },
    ],
  },
  CMF: {
    code: "CMF",
    name: "CHAMBERY/AIX-LES-BAINS",
    chineseName: "尚贝里",
    traditionalName: "尚貝里",
    airports: [
      {
        code: "CMF",
        name: "Chambery/aix-les-bains airport",
        chineseName: "尚贝里机场",
        traditionalName: "尚貝里機場",
      },
    ],
  },
  CMG: {
    code: "CMG",
    name: "CORUMBA",
    chineseName: "科伦巴",
    traditionalName: "科倫巴",
    airports: [
      {
        code: "CMG",
        name: "Corumba intl.",
        chineseName: "科伦巴机场",
        traditionalName: "科倫巴機場",
      },
    ],
  },
  CMH: {
    code: "CMH",
    name: "COLUMBUS",
    chineseName: "哥伦布",
    traditionalName: "哥倫布",
    airports: [
      {
        code: "CMH",
        name: "John glenn intl",
        chineseName: "哥伦布机场",
        traditionalName: "哥倫布機場",
      },
      {
        code: "LCK",
        name: "Rickenbacker intl",
        chineseName: "利肯巴克尔国际机场",
        traditionalName: "利肯巴克爾國際機場",
      },
    ],
  },
  CMI: {
    code: "CMI",
    name: "CHAMPAIGN/URBANA",
    chineseName: "尚佩恩",
    traditionalName: "尚佩恩",
    airports: [
      {
        code: "CMI",
        name: "University of illinois",
        chineseName: "伊利诺伊大学维拉德机场",
        traditionalName: "伊利諾伊大學維拉德機場",
      },
    ],
  },
  CMJ: {
    code: "CMJ",
    name: "QIMEI",
    chineseName: "七美",
    traditionalName: "七美",
    airports: [
      {
        code: "CMJ",
        name: "Qimei airport",
        chineseName: "七美机场",
        traditionalName: "七美機場",
      },
    ],
  },
  CMN: {
    code: "CMN",
    name: "CASABLANCA",
    chineseName: "卡萨布兰卡",
    traditionalName: "卡薩布蘭卡",
    airports: [
      {
        code: "CMN",
        name: "Mohammed v",
        chineseName: "穆罕默德机场",
        traditionalName: "穆罕默德機場",
      },
    ],
  },
  CMW: {
    code: "CMW",
    name: "CAMAGUEY",
    chineseName: "卡马圭",
    traditionalName: "卡馬圭",
    airports: [
      {
        code: "CMW",
        name: "Ignacio agramonte intl",
        chineseName: "伊格纳西奥阿格拉蒙特国际机场",
        traditionalName: "伊格納西奧阿格拉蒙特國際機場",
      },
    ],
  },
  CMX: {
    code: "CMX",
    name: "HANCOCK",
    chineseName: "汉考克",
    traditionalName: "漢考克",
    airports: [
      {
        code: "CMX",
        name: "Houghton county mem.",
        chineseName: "豪登郡机场",
        traditionalName: "豪登郡機場",
      },
    ],
  },
  CNC: {
    code: "CNC",
    name: "COCONUT ISLAND",
    chineseName: "椰岛",
    traditionalName: "椰島",
    airports: [
      {
        code: "CNC",
        name: "Coconut island airport",
        chineseName: "可可纳特岛机场",
        traditionalName: "可哥納特島機場",
      },
    ],
  },
  CND: {
    code: "CND",
    name: "CONSTANTA",
    chineseName: "康斯坦察",
    traditionalName: "康斯坦察",
    airports: [
      {
        code: "CND",
        name: "Mihail kogalniceanu",
        chineseName: "科贾尔尼希努机场",
        traditionalName: "科賈爾尼希努機場",
      },
    ],
  },
  CNJ: {
    code: "CNJ",
    name: "CLONCURRY",
    chineseName: "克朗克里",
    traditionalName: "克朗克裏",
    airports: [
      {
        code: "CNJ",
        name: "Cloncurry airport",
        chineseName: "克朗克里机场",
        traditionalName: "克朗克裏機場",
      },
    ],
  },
  CNM: {
    code: "CNM",
    name: "CARLSBAD",
    chineseName: "卡尔斯巴德",
    traditionalName: "卡爾斯巴德",
    airports: [
      {
        code: "CNM",
        name: "Cavern city air term.",
        chineseName: "卡尔斯巴德机场",
        traditionalName: "卡爾斯巴德機場",
      },
    ],
  },
  CNN: {
    code: "CNN",
    name: "KANNUR",
    chineseName: "楚尔曼",
    traditionalName: "楚爾曼",
    airports: [
      {
        code: "CNN",
        name: "Kannur intl.",
        chineseName: "坎纳诺尔机场",
        traditionalName: "坎納諾爾機場",
      },
    ],
  },
  CNP: {
    code: "CNP",
    name: "NEERLERIT INAAT",
    chineseName: "尼尔莱里特因阿特",
    traditionalName: "尼爾萊裏特因阿特",
    airports: [
      {
        code: "CNP",
        name: "Neerlerit inaat airport",
        chineseName: "尼尔莱里特因阿特机场",
        traditionalName: "尼爾萊裏特因阿特機場",
      },
    ],
  },
  CNQ: {
    code: "CNQ",
    name: "CORRIENTES",
    chineseName: "科连特斯",
    traditionalName: "科達特斯",
    airports: [
      {
        code: "CNQ",
        name: "Corrientes airport",
        chineseName: "科连特斯机场",
        traditionalName: "科達特斯機場",
      },
    ],
  },
  CNS: {
    code: "CNS",
    name: "CAIRNS",
    chineseName: "凯恩斯",
    traditionalName: "凱恩斯",
    airports: [
      {
        code: "CNS",
        name: "Cairns intl.",
        chineseName: "凯恩斯国际机场",
        traditionalName: "凱恩斯國際機場",
      },
    ],
  },
  CNX: {
    code: "CNX",
    name: "CHIANG MAI",
    chineseName: "清迈",
    traditionalName: "清邁",
    airports: [
      {
        code: "CNX",
        name: "Chiang mai intl.",
        chineseName: "清迈国际机场",
        traditionalName: "清邁國際機場",
      },
    ],
  },
  CNY: {
    code: "CNY",
    name: "MOAB",
    chineseName: "莫阿布",
    traditionalName: "莫阿布",
    airports: [
      {
        code: "CNY",
        name: "Canyonlands field",
        chineseName: "卡尼昂兰兹机场",
        traditionalName: "卡尼昂蘭茲機場",
      },
    ],
  },
  COD: {
    code: "COD",
    name: "CODY",
    chineseName: "科迪",
    traditionalName: "科迪",
    airports: [
      {
        code: "COD",
        name: "Yellowstone regional",
        chineseName: "黄石地区机场",
        traditionalName: "黃石地區機場",
      },
    ],
  },
  COG: {
    code: "COG",
    name: "CONDOTO",
    chineseName: "康多托",
    traditionalName: "康多托",
    airports: [
      {
        code: "COG",
        name: "Mandinga",
        chineseName: "曼丁加机机场",
        traditionalName: "曼丁加機機場",
      },
    ],
  },
  COH: {
    code: "COH",
    name: "COOCH BEHAR",
    chineseName: "库奇比哈尔",
    traditionalName: "庫奇比哈爾",
    airports: [
      {
        code: "COH",
        name: "Cooch behar airport",
        chineseName: "库奇贝哈机场",
        traditionalName: "庫奇貝哈機場",
      },
    ],
  },
  COK: {
    code: "COK",
    name: "KOCHI",
    chineseName: "科钦",
    traditionalName: "科欽",
    airports: [
      {
        code: "COK",
        name: "Kochi intl.",
        chineseName: "库奇机场",
        traditionalName: "庫奇機場",
      },
    ],
  },
  COL: {
    code: "COL",
    name: "COLL ISLAND",
    chineseName: "科尔岛",
    traditionalName: "科爾島",
    airports: [
      {
        code: "COL",
        name: "Coll island airport",
        chineseName: "科尔岛机场",
        traditionalName: "科爾島機場",
      },
    ],
  },
  COO: {
    code: "COO",
    name: "COTONOU",
    chineseName: "科托努",
    traditionalName: "科托努",
    airports: [
      {
        code: "COO",
        name: "Cadjehoun",
        chineseName: "卡杰杭机场",
        traditionalName: "卡傑杭機場",
      },
    ],
  },
  COR: {
    code: "COR",
    name: "CORDOBA",
    chineseName: "科尔多瓦",
    traditionalName: "科爾多瓦",
    airports: [
      {
        code: "COR",
        name: "A.l.v. taravella",
        chineseName: "特拉维拉机场",
        traditionalName: "特拉維拉機場",
      },
    ],
  },
  COS: {
    code: "COS",
    name: "COLORADO SPRINGS",
    chineseName: "科罗拉多泉",
    traditionalName: "科羅拉多泉",
    airports: [
      {
        code: "COS",
        name: "Colorado springs municipal",
        chineseName: "科罗拉多斯普林机场",
        traditionalName: "科羅拉多斯普林機場",
      },
    ],
  },
  COU: {
    code: "COU",
    name: "COLUMBIA",
    chineseName: "哥伦比亚",
    traditionalName: "哥倫比亞",
    airports: [
      {
        code: "COU",
        name: "Columbia reg. airport",
        chineseName: "哥伦比亚地区机场",
        traditionalName: "哥倫比亞地區機場",
      },
    ],
  },
  CPC: {
    code: "CPC",
    name: "SAN MARTIN LOS ANDES",
    chineseName: "圣米格尔-德图库曼",
    traditionalName: "聖米格爾-德圖庫曼",
    airports: [
      {
        code: "CPC",
        name: "Aviador carlos campos",
        chineseName: "查佩尔克机场",
        traditionalName: "查佩爾克機場",
      },
    ],
  },
  CPD: {
    code: "CPD",
    name: "COOBER PEDY",
    chineseName: "库伯佩迪",
    traditionalName: "庫伯佩迪",
    airports: [
      {
        code: "CPD",
        name: "Coober pedy airport",
        chineseName: "库伯佩地机场",
        traditionalName: "庫伯佩地機場",
      },
    ],
  },
  CPE: {
    code: "CPE",
    name: "CAMPECHE",
    chineseName: "坎佩切",
    traditionalName: "坎佩切",
    airports: [
      {
        code: "CPE",
        name: "A.acuna ongay intl",
        chineseName: "坎佩切国际机场",
        traditionalName: "坎佩切國際機場",
      },
    ],
  },
  CPH: {
    code: "CPH",
    name: "COPENHAGEN",
    chineseName: "哥本哈根",
    traditionalName: "哥本哈根",
    airports: [
      {
        code: "CPH",
        name: "Kastrup",
        chineseName: "哥本哈根机场",
        traditionalName: "哥本哈根機場",
      },
      {
        code: "RKE",
        name: "Roskilde",
        chineseName: "罗斯基尔德机场",
        traditionalName: "羅斯基爾德機場",
      },
    ],
  },
  CPO: {
    code: "CPO",
    name: "COPIAPO",
    chineseName: "科皮亚波",
    traditionalName: "科皮亞波",
    airports: [
      {
        code: "CPO",
        name: "Desierto de atacama",
        chineseName: "科皮亚波机场",
        traditionalName: "科皮亞波機場",
      },
    ],
  },
  CPR: {
    code: "CPR",
    name: "CASPER",
    chineseName: "怀俄明州卡斯珀",
    traditionalName: "懷俄明州卡斯帕",
    airports: [
      {
        code: "CPR",
        name: "Natrona county intl",
        chineseName: "卡斯珀机场",
        traditionalName: "卡斯帕機場",
      },
    ],
  },
  CPT: {
    code: "CPT",
    name: "CAPE TOWN",
    chineseName: "开普敦",
    traditionalName: "開普敦",
    airports: [
      {
        code: "CPT",
        name: "Cape town intl.",
        chineseName: "开普敦国际机场",
        traditionalName: "開普敦國際機場",
      },
    ],
  },
  CPV: {
    code: "CPV",
    name: "CAMPINA GRANDE",
    chineseName: "坎皮纳格兰德",
    traditionalName: "坎皮納格蘭德",
    airports: [
      {
        code: "CPV",
        name: "Joao suassuna",
        chineseName: "若奥苏阿苏纳机场",
        traditionalName: "若奧蘇阿蘇納機場",
      },
    ],
  },
  CPX: {
    code: "CPX",
    name: "CULEBRA",
    chineseName: "库莱布拉岛",
    traditionalName: "庫萊布拉島",
    airports: [
      {
        code: "CPX",
        name: "Benjamin riveranoriega",
        chineseName: "库莱布拉机场",
        traditionalName: "庫萊布拉機場",
      },
    ],
  },
  CQD: {
    code: "CQD",
    name: "SHAHRE KORD",
    chineseName: "Shahre Kord",
    traditionalName: "Shahre Kord",
    airports: [
      {
        code: "CQD",
        name: "Shahre kord airport",
        chineseName: "夏赫雷－科德机场",
        traditionalName: "夏赫雷－科德機場",
      },
    ],
  },
  CQW: {
    code: "CQW",
    name: "WULONG",
    chineseName: "武隆",
    traditionalName: "武隆",
    airports: [
      {
        code: "CQW",
        name: "Chongqing xiannvshan",
        chineseName: "重庆仙女山机场",
        traditionalName: "重慶仙女山機場",
      },
    ],
  },
  CRA: {
    code: "CRA",
    name: "CRAIOVA",
    chineseName: "克拉约瓦",
    traditionalName: "克拉約瓦",
    airports: [
      {
        code: "CRA",
        name: "Craiova airport",
        chineseName: "克拉奥华机场",
        traditionalName: "克拉奧華機場",
      },
    ],
  },
  CRC: {
    code: "CRC",
    name: "CARTAGO",
    chineseName: "卡塔戈",
    traditionalName: "卡塔戈",
    airports: [
      {
        code: "CRC",
        name: "Santa ana",
        chineseName: "卡塔戈机场",
        traditionalName: "卡塔戈機場",
      },
    ],
  },
  CRD: {
    code: "CRD",
    name: "COMODORO RIVADAVIA",
    chineseName: "里瓦达维亚",
    traditionalName: "裏瓦達維亞",
    airports: [
      {
        code: "CRD",
        name: "General e. mosconi",
        chineseName: "里瓦达维亚海军准将城机场",
        traditionalName: "裡瓦達維亞海軍準將城機場",
      },
    ],
  },
  CRI: {
    code: "CRI",
    name: "CROOKED ISLAND",
    chineseName: "克鲁克德岛",
    traditionalName: "克魯克德島",
    airports: [
      {
        code: "CRI",
        name: "Colonel hill",
        chineseName: "克鲁克德岛机场",
        traditionalName: "克魯克德島機場",
      },
    ],
  },
  CRK: {
    code: "CRK",
    name: "ANGELES/MABALACAT",
    chineseName: "克拉克",
    traditionalName: "克拉克",
    airports: [
      {
        code: "CRK",
        name: "Clark intl",
        chineseName: "克拉克国际机场",
        traditionalName: "克拉克國際機場",
      },
    ],
  },
  CRM: {
    code: "CRM",
    name: "CATARMAN",
    chineseName: "卡塔曼",
    traditionalName: "卡塔曼",
    airports: [
      {
        code: "CRM",
        name: "National",
        chineseName: "国家机场",
        traditionalName: "國家機場",
      },
    ],
  },
  CRP: {
    code: "CRP",
    name: "CORPUS CHRISTI",
    chineseName: "科珀斯克里斯蒂",
    traditionalName: "科珀斯克利斯蒂",
    airports: [
      {
        code: "CRP",
        name: "Corpus christi intl.",
        chineseName: "科珀斯克里斯蒂国际机场",
        traditionalName: "科珀斯克利斯蒂國際機場",
      },
    ],
  },
  CRU: {
    code: "CRU",
    name: "CARRIACOU",
    chineseName: "卡里亚库岛",
    traditionalName: "卡裡亞庫島",
    airports: [
      {
        code: "CRU",
        name: "Carriacou airport",
        chineseName: "劳瑞斯顿机场",
        traditionalName: "勞瑞斯頓機場",
      },
    ],
  },
  CRV: {
    code: "CRV",
    name: "CROTONE",
    chineseName: "克罗托内",
    traditionalName: "克羅托內",
    airports: [
      {
        code: "CRV",
        name: "Crotone airport",
        chineseName: "克罗托内机场",
        traditionalName: "克羅托內機場",
      },
    ],
  },
  CRW: {
    code: "CRW",
    name: "CHARLESTON",
    chineseName: "查尔斯顿",
    traditionalName: "查爾斯頓",
    airports: [
      {
        code: "CRW",
        name: "Yeager",
        chineseName: "查尔斯顿机场",
        traditionalName: "查爾斯頓機場",
      },
    ],
  },
  CRZ: {
    code: "CRZ",
    name: "TURKMENABAT",
    chineseName: "土库曼纳巴德",
    traditionalName: "土庫曼納巴德",
    airports: [
      {
        code: "CRZ",
        name: "Turkmenabat airport",
        chineseName: "土库曼阿巴德机场",
        traditionalName: "土庫曼阿巴德機場",
      },
    ],
  },
  CSA: {
    code: "CSA",
    name: "COLONSAY",
    chineseName: "科伦塞岛",
    traditionalName: "科倫塞島",
    airports: [
      {
        code: "CSA",
        name: "Colonsay airport",
        chineseName: "科伦塞岛机场",
        traditionalName: "科倫塞島機場",
      },
    ],
  },
  CSG: {
    code: "CSG",
    name: "COLUMBUS",
    chineseName: "哥伦布",
    traditionalName: "哥倫布",
    airports: [
      {
        code: "CSG",
        name: "Columbus apt",
        chineseName: "哥伦布机场",
        traditionalName: "哥倫布機場",
      },
    ],
  },
  CSK: {
    code: "CSK",
    name: "CAP SKIRING",
    chineseName: "卡布斯克伦",
    traditionalName: "卡布斯克倫",
    airports: [
      {
        code: "CSK",
        name: "Cap skiring airport",
        chineseName: "斯克林角机场",
        traditionalName: "斯克林角機場",
      },
    ],
  },
  CSU: {
    code: "CSU",
    name: "SANTA CRUZ DO SUL",
    chineseName: "桑塔克鲁斯",
    traditionalName: "桑塔克魯斯",
    airports: [
      {
        code: "CSU",
        name: "Santa cruz do sul airport",
        chineseName: "桑塔克鲁斯机场",
        traditionalName: "桑塔克魯斯機場",
      },
    ],
  },
  CSX: {
    code: "CSX",
    name: "CHANGSHA",
    chineseName: "长沙",
    traditionalName: "長沙",
    airports: [
      {
        code: "CSX",
        name: "Huanghua international",
        chineseName: "黄花国际机场",
        traditionalName: "黃花國際機場",
      },
    ],
  },
  CSY: {
    code: "CSY",
    name: "CHEBOKSARY",
    chineseName: "切博克萨雷",
    traditionalName: "切博克薩雷",
    airports: [
      {
        code: "CSY",
        name: "Cheboksary airport",
        chineseName: "切博克萨雷机场",
        traditionalName: "切博克薩雷機場",
      },
    ],
  },
  CTA: {
    code: "CTA",
    name: "CATANIA",
    chineseName: "卡塔尼亚",
    traditionalName: "卡塔尼亞",
    airports: [
      {
        code: "CTA",
        name: "Fontanarossa",
        chineseName: "方塔纳罗萨机场",
        traditionalName: "方塔納羅薩機場",
      },
    ],
  },
  CTC: {
    code: "CTC",
    name: "CATAMARCA",
    chineseName: "卡塔马卡",
    traditionalName: "卡塔馬卡",
    airports: [
      {
        code: "CTC",
        name: "Catamarca airport",
        chineseName: "卡塔马卡机场",
        traditionalName: "卡塔馬卡機場",
      },
    ],
  },
  CTD: {
    code: "CTD",
    name: "CHITRE",
    chineseName: "奇特雷",
    traditionalName: "奇特雷",
    airports: [
      {
        code: "CTD",
        name: "Alonso valderrama",
        chineseName: "阿隆索瓦德拉玛机场",
        traditionalName: "阿隆索瓦德拉瑪機場",
      },
    ],
  },
  CTG: {
    code: "CTG",
    name: "CARTAGENA",
    chineseName: "卡塔赫纳",
    traditionalName: "卡塔赫納",
    airports: [
      {
        code: "CTG",
        name: "Rafael nunez intl",
        chineseName: "拉法厄尔努内兹机场",
        traditionalName: "拉法厄爾努內茲機場",
      },
    ],
  },
  CTL: {
    code: "CTL",
    name: "CHARLEVILLE",
    chineseName: "查尔斯维尔",
    traditionalName: "查爾斯維爾",
    airports: [
      {
        code: "CTL",
        name: "Charleville airport",
        chineseName: "查尔斯维尔机场",
        traditionalName: "查理斯維爾機場",
      },
    ],
  },
  CTM: {
    code: "CTM",
    name: "CHETUMAL",
    chineseName: "切图马尔",
    traditionalName: "切圖馬爾",
    airports: [
      {
        code: "CTM",
        name: "Chetumal intl.",
        chineseName: "切图马尔国际机场",
        traditionalName: "切圖馬爾國際機場",
      },
    ],
  },
  CTN: {
    code: "CTN",
    name: "COOKTOWN",
    chineseName: "库克敦",
    traditionalName: "庫克敦",
    airports: [
      {
        code: "CTN",
        name: "Cooktown airport",
        chineseName: "库克敦机场",
        traditionalName: "庫克敦機場",
      },
    ],
  },
  CTU: {
    code: "CTU",
    name: "CHENGDU",
    chineseName: "成都",
    traditionalName: "成都",
    airports: [
      {
        code: "CTU",
        name: "Shuangliu intl",
        chineseName: "成都双流国际机场",
        traditionalName: "成都雙流國際機場",
      },
      {
        code: "TFU",
        name: "Tianfu international",
        chineseName: "成都天府国际机场",
        traditionalName: "成都天府國際機場",
      },
    ],
  },
  CUC: {
    code: "CUC",
    name: "CUCUTA",
    chineseName: "库库塔",
    traditionalName: "庫庫塔",
    airports: [
      {
        code: "CUC",
        name: "Camilo daza",
        chineseName: "卡米罗达佐机场",
        traditionalName: "卡米羅達佐機場",
      },
    ],
  },
  CUE: {
    code: "CUE",
    name: "CUENCA",
    chineseName: "昆卡",
    traditionalName: "昆卡",
    airports: [
      {
        code: "CUE",
        name: "Mariscal lamar intl",
        chineseName: "昆卡机场",
        traditionalName: "昆卡機場",
      },
    ],
  },
  CUF: {
    code: "CUF",
    name: "CUNEO",
    chineseName: "库内奥",
    traditionalName: "庫內奧",
    airports: [
      {
        code: "CUF",
        name: "Levaldigi",
        chineseName: "雷瓦尔蒂吉机场",
        traditionalName: "雷瓦爾蒂吉機場",
      },
    ],
  },
  CUK: {
    code: "CUK",
    name: "CAYE CAULKER",
    chineseName: "恰耶考尔克",
    traditionalName: "恰耶考爾克",
    airports: [
      {
        code: "CUK",
        name: "Caye caulker airport",
        chineseName: "恰耶－考尔克机场",
        traditionalName: "恰耶－考爾克機場",
      },
    ],
  },
  CUL: {
    code: "CUL",
    name: "CULIACAN",
    chineseName: "库利亚坎",
    traditionalName: "庫利亞坎",
    airports: [
      {
        code: "CUL",
        name: "Fed. de bachigualato",
        chineseName: "费德尔迪巴奇瓜拉托机场",
        traditionalName: "費德爾迪巴奇瓜拉托機場",
      },
    ],
  },
  CUM: {
    code: "CUM",
    name: "CUMANA",
    chineseName: "库马纳",
    traditionalName: "庫馬納",
    airports: [
      {
        code: "CUM",
        name: "Antonio jose de sucre",
        chineseName: "库马纳机场",
        traditionalName: "庫馬納機場",
      },
    ],
  },
  CUN: {
    code: "CUN",
    name: "CANCUN",
    chineseName: "坎昆",
    traditionalName: "坎昆",
    airports: [
      {
        code: "CUN",
        name: "Cancun intl.",
        chineseName: "坎昆国际机场",
        traditionalName: "坎昆國際機場",
      },
    ],
  },
  CUP: {
    code: "CUP",
    name: "CARUPANO",
    chineseName: "卡鲁帕诺",
    traditionalName: "卡魯帕諾",
    airports: [
      {
        code: "CUP",
        name: "Jose f. bermudez",
        chineseName: "卡鲁帕诺机场",
        traditionalName: "卡魯帕諾機場",
      },
    ],
  },
  CUQ: {
    code: "CUQ",
    name: "COEN",
    chineseName: "科恩",
    traditionalName: "科恩",
    airports: [
      {
        code: "CUQ",
        name: "Coen airport",
        chineseName: "科恩机场",
        traditionalName: "科恩機場",
      },
    ],
  },
  CUR: {
    code: "CUR",
    name: "CURACAO",
    chineseName: "库拉索",
    traditionalName: "庫拉索",
    airports: [
      {
        code: "CUR",
        name: "Hato intl",
        chineseName: "哈托国际机场",
        traditionalName: "哈托國際機場",
      },
    ],
  },
  CUU: {
    code: "CUU",
    name: "CHIHUAHUA",
    chineseName: "奇瓦瓦",
    traditionalName: "奇瓦瓦",
    airports: [
      {
        code: "CUU",
        name: "R. fierro villalobos",
        chineseName: "罗伯托菲耶罗比利亚洛沃斯将军国际机场",
        traditionalName: "羅伯托菲耶羅比利亞洛沃斯將軍國際機場",
      },
    ],
  },
  CUZ: {
    code: "CUZ",
    name: "CUSCO",
    chineseName: "库斯科",
    traditionalName: "庫斯科",
    airports: [
      {
        code: "CUZ",
        name: "A.velasco astete intl",
        chineseName: "维拉兹克阿斯特特机场",
        traditionalName: "維拉茲克阿斯特特機場",
      },
    ],
  },
  CVG: {
    code: "CVG",
    name: "CINCINNATI",
    chineseName: "辛辛那提",
    traditionalName: "辛辛那堤",
    airports: [
      {
        code: "CVG",
        name: "Northern kentucky intl",
        chineseName: "北肯塔基国际机场",
        traditionalName: "北肯塔基國際機場",
      },
      {
        code: "LUK",
        name: "Municipal (lunken fld)",
        chineseName: "辛辛那提地方机场",
        traditionalName: "辛辛那堤地方機場",
      },
    ],
  },
  CVN: {
    code: "CVN",
    name: "CLOVIS",
    chineseName: "克洛维斯",
    traditionalName: "克洛維斯",
    airports: [
      {
        code: "CVN",
        name: "Clovis municipal",
        chineseName: "克洛维斯地方机场",
        traditionalName: "克洛維斯地方機場",
      },
    ],
  },
  CVQ: {
    code: "CVQ",
    name: "CARNARVON",
    chineseName: "卡那封",
    traditionalName: "卡那封",
    airports: [
      {
        code: "CVQ",
        name: "Carnarvon airport",
        chineseName: "卡纳尔芬机场",
        traditionalName: "卡納爾芬機場",
      },
    ],
  },
  CVT: {
    code: "CVT",
    name: "COVENTRY",
    chineseName: "考文垂",
    traditionalName: "考文垂",
    airports: [
      {
        code: "CVT",
        name: "Coventry airport",
        chineseName: "考文垂机场",
        traditionalName: "考文垂機場",
      },
    ],
  },
  CVU: {
    code: "CVU",
    name: "CORVO ISLAND",
    chineseName: "科尔沃岛",
    traditionalName: "科爾沃島",
    airports: [
      {
        code: "CVU",
        name: "Corvo island airport",
        chineseName: "科尔武岛机场",
        traditionalName: "科爾武島機場",
      },
    ],
  },
  CWB: {
    code: "CWB",
    name: "CURITIBA",
    chineseName: "库里蒂巴",
    traditionalName: "庫里蒂巴",
    airports: [
      {
        code: "CWB",
        name: "Afonso pena intl",
        chineseName: "阿丰索佩纳国际机场",
        traditionalName: "阿豐索佩納國際機場",
      },
    ],
  },
  CWJ: {
    code: "CWJ",
    name: "CANGYUAN",
    chineseName: "沧源",
    traditionalName: "滄源",
    airports: [
      {
        code: "CWJ",
        name: "Washan",
        chineseName: "佤山机场",
        traditionalName: "佤山機場",
      },
    ],
  },
  CWK: {
    code: "CWK",
    name: "CHITRAKOOT",
    chineseName: "奇特拉科特",
    traditionalName: "奇特拉科特",
    airports: [
      {
        code: "CWK",
        name: "Chitrakoot airport",
        chineseName: "奇特拉科特机场",
        traditionalName: "奇特拉科特機場",
      },
    ],
  },
  CWL: {
    code: "CWL",
    name: "CARDIFF",
    chineseName: "加的夫",
    traditionalName: "加的夫",
    airports: [
      {
        code: "CWL",
        name: "Cardiff airport",
        chineseName: "卡迪夫机场",
        traditionalName: "卡迪夫機場",
      },
    ],
  },
  CXB: {
    code: "CXB",
    name: "COX'S BAZAR",
    chineseName: "科克斯巴扎尔",
    traditionalName: "科克斯巴紮爾",
    airports: [
      {
        code: "CXB",
        name: "Cox's bazar airport",
        chineseName: "科克斯巴扎尔机场",
        traditionalName: "科克斯巴紮爾機場",
      },
    ],
  },
  CXI: {
    code: "CXI",
    name: "KIRITIMATI",
    chineseName: "圣诞岛",
    traditionalName: "聖誕島",
    airports: [
      {
        code: "CXI",
        name: "Cassidy intl",
        chineseName: "卡西迪国际机场",
        traditionalName: "凱西迪國際機場",
      },
    ],
  },
  CXJ: {
    code: "CXJ",
    name: "CAXIAS DO SUL",
    chineseName: "南卡希亚斯",
    traditionalName: "南卡希亞斯",
    airports: [
      {
        code: "CXJ",
        name: "Hugo cantergiani",
        chineseName: "南卡希亚斯机场",
        traditionalName: "南卡希亞斯機場",
      },
    ],
  },
  CXT: {
    code: "CXT",
    name: "CHARTERS TOWERS",
    chineseName: "查特斯堡",
    traditionalName: "查特斯堡",
    airports: [
      {
        code: "CXT",
        name: "Charters towers airport",
        chineseName: "查特斯堡机场",
        traditionalName: "查特斯堡機場",
      },
    ],
  },
  CXY: {
    code: "CXY",
    name: "CAT CAYS",
    chineseName: "凯特凯斯",
    traditionalName: "凱特凱斯",
    airports: [
      {
        code: "CXY",
        name: "Cat cays airport",
        chineseName: "凯特凯斯机场",
        traditionalName: "凱特凱斯機場",
      },
    ],
  },
  CYA: {
    code: "CYA",
    name: "LES CAYES",
    chineseName: "莱凯",
    traditionalName: "萊凱",
    airports: [
      {
        code: "CYA",
        name: "Antoine-simon",
        chineseName: "莱凯机场",
        traditionalName: "萊凱機場",
      },
    ],
  },
  CYB: {
    code: "CYB",
    name: "CAYMAN BRAC",
    chineseName: "开曼布拉克岛",
    traditionalName: "開曼布拉克島",
    airports: [
      {
        code: "CYB",
        name: "C. kirkconnell intl",
        chineseName: "查尔斯基尔克康内尔国际机场",
        traditionalName: "查爾斯基爾克康內爾國際機場",
      },
    ],
  },
  CYC: {
    code: "CYC",
    name: "CAYE CHAPEL",
    chineseName: "卡耶查帕尔",
    traditionalName: "卡耶查帕爾",
    airports: [
      {
        code: "CYC",
        name: "Caye chapel airport",
        chineseName: "恰耶－恰佩尔机场",
        traditionalName: "恰耶－恰佩爾機場",
      },
    ],
  },
  CYF: {
    code: "CYF",
    name: "CHEFORNAK",
    chineseName: "切福纳克",
    traditionalName: "切福納克",
    airports: [
      {
        code: "CYF",
        name: "Chefornak airport",
        chineseName: "切福纳克水上飞机基地",
        traditionalName: "切福納克水上飛機基地",
      },
    ],
  },
  CYI: {
    code: "CYI",
    name: "CHIAYI",
    chineseName: "嘉义",
    traditionalName: "嘉義",
    airports: [
      {
        code: "CYI",
        name: "Chiayi airport",
        chineseName: "嘉义机场",
        traditionalName: "嘉義機場",
      },
    ],
  },
  CYO: {
    code: "CYO",
    name: "CAYO LARGO DEL SUR",
    chineseName: "拉戈德尔苏尔岛",
    traditionalName: "拉戈德爾蘇爾島",
    airports: [
      {
        code: "CYO",
        name: "Vilo acuna intl",
        chineseName: "拉戈德尔苏尔岛机场",
        traditionalName: "拉戈德爾蘇爾島機場",
      },
    ],
  },
  CYP: {
    code: "CYP",
    name: "CALBAYOG",
    chineseName: "甲描育",
    traditionalName: "甲描育",
    airports: [
      {
        code: "CYP",
        name: "Calbayog airport",
        chineseName: "甲描育机场",
        traditionalName: "甲描育機場",
      },
    ],
  },
  CYS: {
    code: "CYS",
    name: "CHEYENNE",
    chineseName: "夏延",
    traditionalName: "夏延",
    airports: [
      {
        code: "CYS",
        name: "Cheyenne reg. airport",
        chineseName: "夏延机场",
        traditionalName: "夏延機場",
      },
    ],
  },
  CYX: {
    code: "CYX",
    name: "CHERSKY",
    chineseName: "切尔斯基",
    traditionalName: "切爾斯基",
    airports: [
      {
        code: "CYX",
        name: "Chersky airport",
        chineseName: "切尔斯基机场",
        traditionalName: "切爾斯基機場",
      },
    ],
  },
  CYZ: {
    code: "CYZ",
    name: "CAUAYAN",
    chineseName: "卡瓦延",
    traditionalName: "卡瓦延",
    airports: [
      {
        code: "CYZ",
        name: "Cauayan airport",
        chineseName: "卡瓦廷机场",
        traditionalName: "卡瓦廷機場",
      },
    ],
  },
  CZH: {
    code: "CZH",
    name: "COROZAL",
    chineseName: "科罗萨尔",
    traditionalName: "科羅薩爾",
    airports: [
      {
        code: "CZH",
        name: "Corozal airport",
        chineseName: "科罗萨尔机场",
        traditionalName: "科羅薩爾機場",
      },
    ],
  },
  CZL: {
    code: "CZL",
    name: "CONSTANTINE",
    chineseName: "康斯坦丁",
    traditionalName: "康斯坦丁",
    airports: [
      {
        code: "CZL",
        name: "Mohamed boudiaf",
        chineseName: "穆罕默德布迪亚夫机场",
        traditionalName: "穆罕默德布迪亞夫機場",
      },
    ],
  },
  CZM: {
    code: "CZM",
    name: "COZUMEL",
    chineseName: "科苏梅尔",
    traditionalName: "科蘇梅爾",
    airports: [
      {
        code: "CZM",
        name: "Cozumel intl.",
        chineseName: "科苏美尔国际机场",
        traditionalName: "科蘇美爾國際機場",
      },
    ],
  },
  CZN: {
    code: "CZN",
    name: "CHISANA",
    chineseName: "奇萨纳",
    traditionalName: "奇薩納",
    airports: [
      {
        code: "CZN",
        name: "Chisana airport",
        chineseName: "奇萨纳机场",
        traditionalName: "奇薩納機場",
      },
    ],
  },
  CZR: {
    code: "CZR",
    name: "CHARA",
    chineseName: "查拉",
    traditionalName: "查拉",
    airports: [
      {
        code: "CZR",
        name: "Chara airport",
        chineseName: "查拉机场",
        traditionalName: "查拉機場",
      },
    ],
  },
  CZS: {
    code: "CZS",
    name: "CRUZEIRO DO SUL",
    chineseName: "南克鲁塞罗",
    traditionalName: "南克魯塞羅",
    airports: [
      {
        code: "CZS",
        name: "Cruzeiro do sul intl.",
        chineseName: "克鲁赛罗国际机场",
        traditionalName: "克魯賽羅國際機場",
      },
    ],
  },
  CZU: {
    code: "CZU",
    name: "COROZAL",
    chineseName: "科罗萨尔",
    traditionalName: "科羅薩爾",
    airports: [
      {
        code: "CZU",
        name: "Las brujas",
        chineseName: "科罗萨尔机场",
        traditionalName: "科羅薩爾機場",
      },
    ],
  },
  CZX: {
    code: "CZX",
    name: "CHANGZHOU",
    chineseName: "常州",
    traditionalName: "常州",
    airports: [
      {
        code: "CZX",
        name: "Benniu",
        chineseName: "奔牛机场",
        traditionalName: "奔牛機場",
      },
    ],
  },
  DAB: {
    code: "DAB",
    name: "DAYTONA BEACH",
    chineseName: "代托纳比奇",
    traditionalName: "代托納比奇",
    airports: [
      {
        code: "DAB",
        name: "Daytona beach intl.",
        chineseName: "代托纳比奇国际机场",
        traditionalName: "代托納比奇國際機場",
      },
    ],
  },
  DAC: {
    code: "DAC",
    name: "DHAKA",
    chineseName: "达卡",
    traditionalName: "達卡",
    airports: [
      {
        code: "DAC",
        name: "Hazrat shahjalal intl",
        chineseName: "阿贾拉勒沙迦拉国际机场",
        traditionalName: "阿賈拉勒沙迦拉國際機場",
      },
    ],
  },
  DAD: {
    code: "DAD",
    name: "DA NANG",
    chineseName: "岘港",
    traditionalName: "峴港",
    airports: [
      {
        code: "DAD",
        name: "Da nang intl.",
        chineseName: "岘港国际机场",
        traditionalName: "峴港國際機場",
      },
    ],
  },
  DAM: {
    code: "DAM",
    name: "DAMASCUS",
    chineseName: "大马士革",
    traditionalName: "大馬士革",
    airports: [
      {
        code: "DAM",
        name: "Damascus intl.",
        chineseName: "大马士革国际机场",
        traditionalName: "大馬士革國際機場",
      },
    ],
  },
  DAR: {
    code: "DAR",
    name: "DAR ES SALAAM",
    chineseName: "达累斯萨拉姆",
    traditionalName: "沙蘭港",
    airports: [
      {
        code: "DAR",
        name: "Julius nyerere intl",
        chineseName: "朱利叶斯尼雷尔国际机场",
        traditionalName: "朱利葉斯尼雷爾國際機場",
      },
    ],
  },
  DAT: {
    code: "DAT",
    name: "DATONG",
    chineseName: "大同",
    traditionalName: "大同",
    airports: [
      {
        code: "DAT",
        name: "Beijiazao",
        chineseName: "云冈机场",
        traditionalName: "雲岡機場",
      },
    ],
  },
  DAU: {
    code: "DAU",
    name: "DARU",
    chineseName: "达鲁",
    traditionalName: "達魯",
    airports: [
      {
        code: "DAU",
        name: "Daru airport",
        chineseName: "达鲁机场",
        traditionalName: "達魯機場",
      },
    ],
  },
  DAV: {
    code: "DAV",
    name: "DAVID",
    chineseName: "大卫",
    traditionalName: "大衛",
    airports: [
      {
        code: "DAV",
        name: "Enrique malek intl",
        chineseName: "恩里克马雷克国际机场",
        traditionalName: "恩裏克馬雷克國際機場",
      },
    ],
  },
  DAX: {
    code: "DAX",
    name: "DAZHOU",
    chineseName: "达州",
    traditionalName: "達州",
    airports: [
      {
        code: "DZH",
        name: "Dazhou jinya",
        chineseName: "金垭机场",
        traditionalName: "金埡機場",
      },
    ],
  },
  DAY: {
    code: "DAY",
    name: "DAYTON",
    chineseName: "代顿",
    traditionalName: "代頓",
    airports: [
      {
        code: "DAY",
        name: "James m. cox intl",
        chineseName: "詹姆斯考克斯国际机场",
        traditionalName: "詹姆斯考克斯國際機場",
      },
    ],
  },
  DBB: {
    code: "DBB",
    name: "DABAH",
    chineseName: "达巴赫",
    traditionalName: "達巴赫",
    airports: [
      {
        code: "DBB",
        name: "Al alamain intl",
        chineseName: "达巴赫机场",
        traditionalName: "達巴赫機場",
      },
    ],
  },
  DBC: {
    code: "DBC",
    name: "BAICHENG",
    chineseName: "白城",
    traditionalName: "白城",
    airports: [
      {
        code: "DBC",
        name: "Chang'an",
        chineseName: "长安机场",
        traditionalName: "長安機場",
      },
    ],
  },
  DBO: {
    code: "DBO",
    name: "DUBBO",
    chineseName: "达博",
    traditionalName: "達博",
    airports: [
      {
        code: "DBO",
        name: "City airport",
        chineseName: "达博城市机场",
        traditionalName: "達博都市機場",
      },
    ],
  },
  DBQ: {
    code: "DBQ",
    name: "DUBUQUE",
    chineseName: "迪比克",
    traditionalName: "迪比克",
    airports: [
      {
        code: "DBQ",
        name: "Dubuque reg. airport",
        chineseName: "迪比克地方机场",
        traditionalName: "迪比克地方機場",
      },
    ],
  },
  DBR: {
    code: "DBR",
    name: "DARBHANGA",
    chineseName: "Darbhanga",
    traditionalName: "Darbhanga",
    airports: [
      {
        code: "DBR",
        name: "Darbhanga airport",
        chineseName: "达尔彭加机场",
        traditionalName: "達爾彭加機場",
      },
    ],
  },
  DBV: {
    code: "DBV",
    name: "DUBROVNIK",
    chineseName: "杜布罗夫尼克",
    traditionalName: "杜布羅夫尼克",
    airports: [
      {
        code: "DBV",
        name: "Dubrovnik airport",
        chineseName: "杜布罗夫尼克机场",
        traditionalName: "杜布羅夫尼克機場",
      },
    ],
  },
  DCM: {
    code: "DCM",
    name: "CASTRES",
    chineseName: "卡斯特尔",
    traditionalName: "卡斯特爾",
    airports: [
      {
        code: "DCM",
        name: "Mazamet",
        chineseName: "马扎梅特机场",
        traditionalName: "馬紮梅特機場",
      },
    ],
  },
  DCY: {
    code: "DCY",
    name: "DAOCHENG",
    chineseName: "稻城",
    traditionalName: "稻城",
    airports: [
      {
        code: "DCY",
        name: "Yading",
        chineseName: "亚丁机场",
        traditionalName: "亞丁機場",
      },
    ],
  },
  DDC: {
    code: "DDC",
    name: "DODGE CITY",
    chineseName: "道奇城",
    traditionalName: "道奇城",
    airports: [
      {
        code: "DDC",
        name: "Dodge city reg. airport",
        chineseName: "道奇城地方机场",
        traditionalName: "道奇城地方機場",
      },
    ],
  },
  DDD: {
    code: "DDD",
    name: "KUDAHUVADHOO",
    chineseName: "库达胡瓦多霍",
    traditionalName: "庫達胡瓦多霍",
    airports: [
      {
        code: "DDD",
        name: "Dhaalu atoll",
        chineseName: "杜哈鲁机场",
        traditionalName: "杜哈魯機場",
      },
    ],
  },
  DDG: {
    code: "DDG",
    name: "DANDONG",
    chineseName: "丹东",
    traditionalName: "丹東",
    airports: [
      {
        code: "DDG",
        name: "Langtou",
        chineseName: "浪头机场",
        traditionalName: "浪頭機場",
      },
    ],
  },
  DDR: {
    code: "DDR",
    name: "XIGAZE",
    chineseName: "日喀则",
    traditionalName: "日喀則",
    airports: [
      {
        code: "DDR",
        name: "Xigaze dingri",
        chineseName: "定日机场",
        traditionalName: "定日機場",
      },
    ],
  },
  DEB: {
    code: "DEB",
    name: "DEBRECEN",
    chineseName: "德布勒森",
    traditionalName: "德布勒森",
    airports: [
      {
        code: "DEB",
        name: "Debrecen airport",
        chineseName: "德布勒森机场",
        traditionalName: "德布勒森機場",
      },
    ],
  },
  DEC: {
    code: "DEC",
    name: "DECATUR",
    chineseName: "迪凯特",
    traditionalName: "迪凱特",
    airports: [
      {
        code: "DEC",
        name: "Decatur airport",
        chineseName: "迪凯特机场",
        traditionalName: "迪凱特機場",
      },
    ],
  },
  DED: {
    code: "DED",
    name: "DEHRA DUN",
    chineseName: "台拉登",
    traditionalName: "臺拉登",
    airports: [
      {
        code: "DED",
        name: "Jolly grant",
        chineseName: "台拉登机场",
        traditionalName: "臺拉登機場",
      },
    ],
  },
  DEE: {
    code: "DEE",
    name: "YUZHNO-KURILSK",
    chineseName: "库纳施尔岛",
    traditionalName: "庫納施爾島",
    airports: [
      {
        code: "DEE",
        name: "Mendeleyevo",
        chineseName: "南库里尔斯克机场",
        traditionalName: "南庫裡爾斯克機場",
      },
    ],
  },
  DEF: {
    code: "DEF",
    name: "DEZFUL",
    chineseName: "迪兹富勒",
    traditionalName: "迪茲富勒",
    airports: [
      {
        code: "DEF",
        name: "Dezful airport",
        chineseName: "迪兹富勒机场",
        traditionalName: "迪茲富勒機場",
      },
    ],
  },
  DEL: {
    code: "DEL",
    name: "DELHI",
    chineseName: "新德里",
    traditionalName: "新德里",
    airports: [
      {
        code: "DEL",
        name: "Indira gandhi intl",
        chineseName: "英迪拉甘地国际机场",
        traditionalName: "英迪拉甘地國際機場",
      },
    ],
  },
  DEM: {
    code: "DEM",
    name: "DEMBI DOLO",
    chineseName: "登比多洛",
    traditionalName: "登比多洛",
    airports: [
      {
        code: "DEM",
        name: "Dembi dolo airport",
        chineseName: "登比多洛机场",
        traditionalName: "登比多洛機場",
      },
    ],
  },
  DEN: {
    code: "DEN",
    name: "DENVER",
    chineseName: "丹佛",
    traditionalName: "丹佛",
    airports: [
      {
        code: "APA",
        name: "Centennial",
        chineseName: "CENTENNIAL机场",
        traditionalName: "CENTENNIAL機場",
      },
      {
        code: "BJC",
        name: "Rocky mountain metrop.",
        chineseName: "洛基山首都机场",
        traditionalName: "洛基山首都機場",
      },
      {
        code: "DEN",
        name: "Denver intl.",
        chineseName: "丹佛国际机场",
        traditionalName: "丹佛國際機場",
      },
    ],
  },
  DEX: {
    code: "DEX",
    name: "YAHUKIMO",
    chineseName: "叶户基摩",
    traditionalName: "葉戶基摩",
    airports: [
      {
        code: "DEX",
        name: "Nop goliath",
        chineseName: "雅胡基摩机场",
        traditionalName: "雅胡基摩機場",
      },
    ],
  },
  DFW: {
    code: "DFW",
    name: "DALLAS",
    chineseName: "达拉斯",
    traditionalName: "達拉斯",
    airports: [
      {
        code: "ADS",
        name: "Addison",
        chineseName: "达拉斯机场",
        traditionalName: "達拉斯機場",
      },
      {
        code: "DAL",
        name: "Love field",
        chineseName: "达拉斯爱田机场",
        traditionalName: "達拉斯愛田機場",
      },
      {
        code: "DFW",
        name: "Dallas/ft worth intl",
        chineseName: "达拉斯沃斯堡机场",
        traditionalName: "達拉斯沃斯堡機場",
      },
    ],
  },
  DGA: {
    code: "DGA",
    name: "DANGRIGA",
    chineseName: "丹格里加",
    traditionalName: "丹格里加",
    airports: [
      {
        code: "DGA",
        name: "Dangriga airport",
        chineseName: "丹格里加机场",
        traditionalName: "丹格里加機場",
      },
    ],
  },
  DGE: {
    code: "DGE",
    name: "MUDGEE",
    chineseName: "马奇",
    traditionalName: "馬奇",
    airports: [
      {
        code: "DGE",
        name: "Mudgee airport",
        chineseName: "马奇机场",
        traditionalName: "馬奇機場",
      },
    ],
  },
  DGH: {
    code: "DGH",
    name: "DEOGHAR",
    chineseName: "Deoghar",
    traditionalName: "Deoghar",
    airports: [
      {
        code: "DGH",
        name: "Deoghar international",
        chineseName: "代奥克尔国际机场",
        traditionalName: "代奧克爾國際機場",
      },
    ],
  },
  DGO: {
    code: "DGO",
    name: "DURANGO",
    chineseName: "杜兰戈",
    traditionalName: "杜蘭戈",
    airports: [
      {
        code: "DGO",
        name: "Guadalupe victoria int",
        chineseName: "瓜达卢普维多利亚机场",
        traditionalName: "瓜達盧普維多利亞機場",
      },
    ],
  },
  DGT: {
    code: "DGT",
    name: "DUMAGUETE",
    chineseName: "杜马格特",
    traditionalName: "杜馬格特",
    airports: [
      {
        code: "DGT",
        name: "Sibulan",
        chineseName: "锡布兰机场",
        traditionalName: "錫布蘭機場",
      },
    ],
  },
  DHG: {
    code: "DHG",
    name: "DALNEGORSK",
    chineseName: "达尔内戈尔斯克",
    traditionalName: "達爾內戈爾斯克",
    airports: [
      {
        code: "DHG",
        name: "Dalnegorsk airport",
        chineseName: "达利涅戈尔斯克机场",
        traditionalName: "達利涅戈爾斯克機場",
      },
    ],
  },
  DHI: {
    code: "DHI",
    name: "DHANGARHI",
    chineseName: "滕格里",
    traditionalName: "滕格裏",
    airports: [
      {
        code: "DHI",
        name: "Dhangarhi airport",
        chineseName: "滕格里机场",
        traditionalName: "滕格裏機場",
      },
    ],
  },
  DHM: {
    code: "DHM",
    name: "DHARAMSALA",
    chineseName: "达兰萨拉",
    traditionalName: "達蘭薩拉",
    airports: [
      {
        code: "DHM",
        name: "Kangra",
        chineseName: "康格拉机场",
        traditionalName: "康格拉機場",
      },
    ],
  },
  DHN: {
    code: "DHN",
    name: "DOTHAN",
    chineseName: "多森",
    traditionalName: "多森",
    airports: [
      {
        code: "DHN",
        name: "Dothan reg. airport",
        chineseName: "多森机场",
        traditionalName: "多森機場",
      },
    ],
  },
  DHX: {
    code: "DHX",
    name: "KEDIRI",
    chineseName: "凯迪里",
    traditionalName: "凱迪裏",
    airports: [
      {
        code: "DHX",
        name: "Dhoho international",
        chineseName: "多哈国际机场",
        traditionalName: "杜哈國際機場",
      },
    ],
  },
  DIB: {
    code: "DIB",
    name: "DIBRUGARH",
    chineseName: "迪布鲁格尔",
    traditionalName: "迪布魯格爾",
    airports: [
      {
        code: "DIB",
        name: "Mohanbari",
        chineseName: "迪布鲁格尔机场",
        traditionalName: "迪布魯格爾機場",
      },
    ],
  },
  DIE: {
    code: "DIE",
    name: "ANTSIRANANA",
    chineseName: "安齐拉纳纳",
    traditionalName: "安齊拉納納",
    airports: [
      {
        code: "DIE",
        name: "Arrachart",
        chineseName: "阿拉查特机场",
        traditionalName: "阿拉查特機場",
      },
    ],
  },
  DIG: {
    code: "DIG",
    name: "DIQING",
    chineseName: "迪庆",
    traditionalName: "迪慶",
    airports: [
      {
        code: "DIG",
        name: "Shangri-la",
        chineseName: "香格里拉机场",
        traditionalName: "香格里拉機場",
      },
    ],
  },
  DIK: {
    code: "DIK",
    name: "DICKINSON",
    chineseName: "北达科他州迪金森",
    traditionalName: "北達科他州迪金遜",
    airports: [
      {
        code: "DIK",
        name: "T.roosevelt regional",
        chineseName: "迪金森机场",
        traditionalName: "迪金遜機場",
      },
    ],
  },
  DIL: {
    code: "DIL",
    name: "DILI",
    chineseName: "帝力",
    traditionalName: "帝利",
    airports: [
      {
        code: "DIL",
        name: "Pres. nicolau lobato",
        chineseName: "尼古劳洛巴托总统机场",
        traditionalName: "尼古勞洛巴托總統機場",
      },
    ],
  },
  DIN: {
    code: "DIN",
    name: "DIEN BIEN PHU",
    chineseName: "奠边府",
    traditionalName: "奠邊府",
    airports: [
      {
        code: "DIN",
        name: "Dien bien phu airport",
        chineseName: "奠边府机场",
        traditionalName: "奠邊府機場",
      },
    ],
  },
  DIQ: {
    code: "DIQ",
    name: "DIVINOPOLIS",
    chineseName: "迪维诺波利斯",
    traditionalName: "迪維諾波利斯",
    airports: [
      {
        code: "DIQ",
        name: "Brigadeiro cabral",
        chineseName: "迪维诺波利斯机场",
        traditionalName: "迪維諾波利斯機場",
      },
    ],
  },
  DIR: {
    code: "DIR",
    name: "DIRE DAWA",
    chineseName: "德雷达瓦",
    traditionalName: "德雷達瓦",
    airports: [
      {
        code: "DIR",
        name: "Aba tenna d yilma intl",
        chineseName: "阿巴泰纳伊尔马机场",
        traditionalName: "阿巴泰納伊爾馬機場",
      },
    ],
  },
  DIU: {
    code: "DIU",
    name: "DIU",
    chineseName: "第乌",
    traditionalName: "第烏",
    airports: [
      {
        code: "DIU",
        name: "Diu airport",
        chineseName: "第乌机场",
        traditionalName: "第烏機場",
      },
    ],
  },
  DIY: {
    code: "DIY",
    name: "DIYARBAKIR",
    chineseName: "迪亚巴克尔",
    traditionalName: "迪亞巴克爾",
    airports: [
      {
        code: "DIY",
        name: "Diyarbakir airport",
        chineseName: "迪亚巴克尔机场",
        traditionalName: "迪亞巴克爾機場",
      },
    ],
  },
  DJB: {
    code: "DJB",
    name: "JAMBI",
    chineseName: "占碑",
    traditionalName: "占碑",
    airports: [
      {
        code: "DJB",
        name: "Sultan thaha",
        chineseName: "苏丹塔哈机场",
        traditionalName: "蘇丹塔哈機場",
      },
    ],
  },
  DJE: {
    code: "DJE",
    name: "DJERBA",
    chineseName: "杰尔巴",
    traditionalName: "傑爾巴",
    airports: [
      {
        code: "DJE",
        name: "Zarzis",
        chineseName: "杰尔吉斯国际机场",
        traditionalName: "傑爾吉斯國際機場",
      },
    ],
  },
  DJG: {
    code: "DJG",
    name: "DJANET",
    chineseName: "贾奈特",
    traditionalName: "賈奈特",
    airports: [
      {
        code: "DJG",
        name: "Tiska",
        chineseName: "迪斯卡机场",
        traditionalName: "迪斯卡機場",
      },
    ],
  },
  DJJ: {
    code: "DJJ",
    name: "JAYAPURA",
    chineseName: "查亚普拉",
    traditionalName: "查亞普拉",
    airports: [
      {
        code: "DJJ",
        name: "Sentani",
        chineseName: "圣塔尼机场",
        traditionalName: "聖塔尼機場",
      },
    ],
  },
  DKA: {
    code: "DKA",
    name: "KATSINA",
    chineseName: "卡齐纳",
    traditionalName: "卡齊納",
    airports: [
      {
        code: "DKA",
        name: "Katsina airport",
        chineseName: "卡齐纳机场",
        traditionalName: "卡齊納機場",
      },
    ],
  },
  DKR: {
    code: "DKR",
    name: "DAKAR",
    chineseName: "达喀尔",
    traditionalName: "達喀爾",
    airports: [
      {
        code: "DKR",
        name: "Leopold sedar senghor",
        chineseName: "达喀尔－约夫－利奥波德·塞达尔·桑戈尔国际机场",
        traditionalName: "達喀爾－約夫－利奧波德·塞達爾·桑戈爾國際機場",
      },
      {
        code: "DSS",
        name: "Blaise diagne intl",
        chineseName: "布莱斯迪亚涅国际机场",
        traditionalName: "布萊斯迪亞涅國際機場",
      },
    ],
  },
  DKS: {
    code: "DKS",
    name: "DIKSON",
    chineseName: "迪克森",
    traditionalName: "迪克森",
    airports: [
      {
        code: "DKS",
        name: "Dikson airport",
        chineseName: "迪克森机场",
        traditionalName: "迪克森機場",
      },
    ],
  },
  DLA: {
    code: "DLA",
    name: "DOUALA",
    chineseName: "杜阿拉",
    traditionalName: "杜阿拉",
    airports: [
      {
        code: "DLA",
        name: "Douala intl.",
        chineseName: "杜阿拉机场",
        traditionalName: "杜阿拉機場",
      },
    ],
  },
  DLC: {
    code: "DLC",
    name: "DALIAN",
    chineseName: "大连",
    traditionalName: "大連",
    airports: [
      {
        code: "DLC",
        name: "Zhoushuizi intl",
        chineseName: "周水子国际机场",
        traditionalName: "周水子國際機場",
      },
    ],
  },
  DLE: {
    code: "DLE",
    name: "DOLE",
    chineseName: "多尔",
    traditionalName: "多爾",
    airports: [
      {
        code: "DLE",
        name: "Tavaux",
        chineseName: "塔瓦乌克斯机场",
        traditionalName: "塔瓦烏克斯機場",
      },
    ],
  },
  DLG: {
    code: "DLG",
    name: "DILLINGHAM",
    chineseName: "迪林厄姆",
    traditionalName: "迪林厄姆",
    airports: [
      {
        code: "DLG",
        name: "Dillingham airport",
        chineseName: "迪灵汉姆机场",
        traditionalName: "迪靈漢姆機場",
      },
    ],
  },
  DLH: {
    code: "DLH",
    name: "DULUTH",
    chineseName: "德卢斯",
    traditionalName: "德盧斯",
    airports: [
      {
        code: "DLH",
        name: "Duluth intl.",
        chineseName: "德卢斯国际机场",
        traditionalName: "德盧斯國際機場",
      },
    ],
  },
  DLI: {
    code: "DLI",
    name: "DA LAT",
    chineseName: "大叻",
    traditionalName: "大叻",
    airports: [
      {
        code: "DLI",
        name: "Lien khuong",
        chineseName: "连科杭机场",
        traditionalName: "連科杭機場",
      },
    ],
  },
  DLM: {
    code: "DLM",
    name: "DALAMAN",
    chineseName: "达拉曼",
    traditionalName: "達拉曼",
    airports: [
      {
        code: "DLM",
        name: "Dalaman airport",
        chineseName: "达拉曼机场",
        traditionalName: "達拉曼機場",
      },
    ],
  },
  DLU: {
    code: "DLU",
    name: "DALI",
    chineseName: "大理",
    traditionalName: "大理",
    airports: [
      {
        code: "DLU",
        name: "Dali airport",
        chineseName: "凤仪机场",
        traditionalName: "鳳儀機場",
      },
    ],
  },
  DLY: {
    code: "DLY",
    name: "DILLON'S BAY",
    chineseName: "狄龙湾",
    traditionalName: "狄龍灣",
    airports: [
      {
        code: "DLY",
        name: "Dillon's bay airport",
        chineseName: "狄龙贝机场",
        traditionalName: "狄龍貝機場",
      },
    ],
  },
  DLZ: {
    code: "DLZ",
    name: "DALANZADGAD",
    chineseName: "达兰扎达嘎德",
    traditionalName: "達蘭紮達嘎德",
    airports: [
      {
        code: "DLZ",
        name: "Gurvan saikhan",
        chineseName: "达兰扎德嘎德机场",
        traditionalName: "達蘭紮德嘎德機場",
      },
    ],
  },
  DMB: {
    code: "DMB",
    name: "TARAZ",
    chineseName: "塔拉兹",
    traditionalName: "塔拉茲",
    airports: [
      {
        code: "DMB",
        name: "Taraz airport",
        chineseName: "塔拉兹机场",
        traditionalName: "塔拉茲機場",
      },
    ],
  },
  DMD: {
    code: "DMD",
    name: "DOOMADGEE",
    chineseName: "杜马吉",
    traditionalName: "杜馬吉",
    airports: [
      {
        code: "DMD",
        name: "Doomadgee airport",
        chineseName: "杜马德吉机场",
        traditionalName: "杜馬德吉機場",
      },
    ],
  },
  DMM: {
    code: "DMM",
    name: "DAMMAM",
    chineseName: "达曼",
    traditionalName: "達曼",
    airports: [
      {
        code: "DMM",
        name: "King fahd intl",
        chineseName: "法赫德国王国际机场",
        traditionalName: "法赫德國王國際機場",
      },
    ],
  },
  DMU: {
    code: "DMU",
    name: "DIMAPUR",
    chineseName: "迪马布尔",
    traditionalName: "迪馬布爾",
    airports: [
      {
        code: "DMU",
        name: "Dimapur airport",
        chineseName: "迪马珀机场",
        traditionalName: "迪馬珀機場",
      },
    ],
  },
  DND: {
    code: "DND",
    name: "DUNDEE",
    chineseName: "邓迪",
    traditionalName: "鄧迪",
    airports: [
      {
        code: "DND",
        name: "Dundee airport",
        chineseName: "邓迪机场",
        traditionalName: "鄧迪機場",
      },
    ],
  },
  DNH: {
    code: "DNH",
    name: "DUNHUANG",
    chineseName: "敦煌",
    traditionalName: "敦煌",
    airports: [
      {
        code: "DNH",
        name: "Dunhuang airport",
        chineseName: "敦煌机场",
        traditionalName: "敦煌機場",
      },
    ],
  },
  DNP: {
    code: "DNP",
    name: "DANG",
    chineseName: "达恩",
    traditionalName: "達恩",
    airports: [
      {
        code: "DNP",
        name: "Tribhuvannagar",
        chineseName: "达恩机场",
        traditionalName: "達恩機場",
      },
    ],
  },
  DNR: {
    code: "DNR",
    name: "DINARD/ST-MALO",
    chineseName: "迪纳尔",
    traditionalName: "迪納爾",
    airports: [
      {
        code: "DNR",
        name: "Pleurtuit",
        chineseName: "普勒图伊特机场",
        traditionalName: "普勒圖伊特機場",
      },
    ],
  },
  DNV: {
    code: "DNV",
    name: "DANVILLE",
    chineseName: "丹维尔",
    traditionalName: "丹維爾",
    airports: [
      {
        code: "DNV",
        name: "Vermilion regional",
        chineseName: "丹维尔机场",
        traditionalName: "丹維爾機場",
      },
    ],
  },
  DNZ: {
    code: "DNZ",
    name: "DENIZLI",
    chineseName: "德尼兹利",
    traditionalName: "德尼茲利",
    airports: [
      {
        code: "DNZ",
        name: "Cardak",
        chineseName: "卡尔达克机场",
        traditionalName: "卡爾達克機場",
      },
    ],
  },
  DOB: {
    code: "DOB",
    name: "DOBO",
    chineseName: "多博",
    traditionalName: "多博",
    airports: [
      {
        code: "DOB",
        name: "Rar gwamar",
        chineseName: "多波机场",
        traditionalName: "多波機場",
      },
    ],
  },
  DOD: {
    code: "DOD",
    name: "DODOMA",
    chineseName: "多多马",
    traditionalName: "杜篤瑪",
    airports: [
      {
        code: "DOD",
        name: "Dodoma airport",
        chineseName: "多多马机场",
        traditionalName: "杜篤瑪機場",
      },
    ],
  },
  DOG: {
    code: "DOG",
    name: "DONGOLA",
    chineseName: "栋古拉",
    traditionalName: "棟古拉",
    airports: [
      {
        code: "DOG",
        name: "Dongola airport",
        chineseName: "栋古拉机场",
        traditionalName: "棟古拉機場",
      },
    ],
  },
  DOH: {
    code: "DOH",
    name: "DOHA",
    chineseName: "多哈",
    traditionalName: "杜哈",
    airports: [
      {
        code: "DOH",
        name: "Hamad international",
        chineseName: "多哈哈马德国际机场",
        traditionalName: "杜哈哈馬德國際機場",
      },
    ],
  },
  DOL: {
    code: "DOL",
    name: "DEAUVILLE",
    chineseName: "多维尔",
    traditionalName: "多維爾",
    airports: [
      {
        code: "DOL",
        name: "St gatien",
        chineseName: "圣加迪恩机场",
        traditionalName: "聖加迪恩機場",
      },
    ],
  },
  DOM: {
    code: "DOM",
    name: "DOMINICA",
    chineseName: "马里戈",
    traditionalName: "馬裏戈",
    airports: [
      {
        code: "DOM",
        name: "Melville hall",
        chineseName: "道格拉斯查尔斯机场",
        traditionalName: "道格拉斯查爾斯機場",
      },
    ],
  },
  DOP: {
    code: "DOP",
    name: "DOLPA",
    chineseName: "多尔帕",
    traditionalName: "多爾帕",
    airports: [
      {
        code: "DOP",
        name: "Dolpa airport",
        chineseName: "多尔帕机场",
        traditionalName: "多爾帕機場",
      },
    ],
  },
  DOY: {
    code: "DOY",
    name: "DONGYING",
    chineseName: "东营",
    traditionalName: "東營",
    airports: [
      {
        code: "DOY",
        name: "Shengli",
        chineseName: "胜利机场",
        traditionalName: "勝利機場",
      },
    ],
  },
  DPL: {
    code: "DPL",
    name: "DIPOLOG",
    chineseName: "第波罗",
    traditionalName: "第波羅",
    airports: [
      {
        code: "DPL",
        name: "Dipolog airport",
        chineseName: "第波罗机场",
        traditionalName: "第波羅機場",
      },
    ],
  },
  DPO: {
    code: "DPO",
    name: "DEVONPORT",
    chineseName: "德文波特",
    traditionalName: "德文波特",
    airports: [
      {
        code: "DPO",
        name: "Devonport airport",
        chineseName: "德文波特机场",
        traditionalName: "德文波特機場",
      },
    ],
  },
  DPS: {
    code: "DPS",
    name: "Bali-Island",
    chineseName: "巴厘岛",
    traditionalName: "巴厘島",
    airports: [
      {
        code: "DPS",
        name: "Ngurah rai",
        chineseName: "努拉莱伊机场",
        traditionalName: "努拉萊伊機場",
      },
    ],
  },
  DPT: {
    code: "DPT",
    name: "DEPUTATSKY",
    chineseName: "杰普塔茨基",
    traditionalName: "傑普塔茨基",
    airports: [
      {
        code: "DPT",
        name: "Deputatsky airport",
        chineseName: "杰普塔茨基机场",
        traditionalName: "傑普塔茨基機場",
      },
    ],
  },
  DQA: {
    code: "DQA",
    name: "DAQING",
    chineseName: "大庆",
    traditionalName: "大慶",
    airports: [
      {
        code: "DQA",
        name: "Sartu",
        chineseName: "萨尔图机场",
        traditionalName: "薩爾圖機場",
      },
    ],
  },
  DQM: {
    code: "DQM",
    name: "DUQM",
    chineseName: "杜库姆",
    traditionalName: "杜庫姆",
    airports: [
      {
        code: "DQM",
        name: "Duqm intl.",
        chineseName: "杜丘国际机场",
        traditionalName: "杜丘國際機場",
      },
    ],
  },
  DRB: {
    code: "DRB",
    name: "DERBY",
    chineseName: "德比",
    traditionalName: "德比",
    airports: [
      {
        code: "DRB",
        name: "Derby airport",
        chineseName: "德比机场",
        traditionalName: "德比機場",
      },
    ],
  },
  DRG: {
    code: "DRG",
    name: "DEERING",
    chineseName: "迪灵",
    traditionalName: "迪靈",
    airports: [
      {
        code: "DRG",
        name: "Deering airport",
        chineseName: "迪灵机场",
        traditionalName: "迪靈機場",
      },
    ],
  },
  DRJ: {
    code: "DRJ",
    name: "DRIETABBETJE",
    chineseName: "德里塔贝杰",
    traditionalName: "德里塔貝傑",
    airports: [
      {
        code: "DRJ",
        name: "Drietabbetje airport",
        chineseName: "德里塔博杰机场",
        traditionalName: "德里塔博傑機場",
      },
    ],
  },
  DRK: {
    code: "DRK",
    name: "DRAKE BAY",
    chineseName: "德雷克湾",
    traditionalName: "德雷克灣",
    airports: [
      {
        code: "DRK",
        name: "Drake bay airport",
        chineseName: "德雷克斯湾机场",
        traditionalName: "德雷克斯灣機場",
      },
    ],
  },
  DRO: {
    code: "DRO",
    name: "DURANGO",
    chineseName: "杜兰戈",
    traditionalName: "杜蘭戈",
    airports: [
      {
        code: "DRO",
        name: "La plata county",
        chineseName: "拉普拉塔机场",
        traditionalName: "拉普拉塔機場",
      },
    ],
  },
  DRP: {
    code: "DRP",
    name: "DARAGA",
    chineseName: "达拉加",
    traditionalName: "達拉加",
    airports: [
      {
        code: "DRP",
        name: "Bicol",
        chineseName: "比科尔国际机场",
        traditionalName: "比科爾國際機場",
      },
    ],
  },
  DRS: {
    code: "DRS",
    name: "DRESDEN",
    chineseName: "德累斯顿",
    traditionalName: "德勒斯登",
    airports: [
      {
        code: "DRS",
        name: "Dresden airport",
        chineseName: "德累斯顿机场",
        traditionalName: "德勒斯登機場",
      },
    ],
  },
  DRV: {
    code: "DRV",
    name: "DHARAVANDHOO ISLAND",
    chineseName: "达拉万杜岛",
    traditionalName: "達拉萬杜島",
    airports: [
      {
        code: "DRV",
        name: "Dharavandhoo island airport",
        chineseName: "达拉万杜岛机场",
        traditionalName: "達拉萬杜島機場",
      },
    ],
  },
  DRW: {
    code: "DRW",
    name: "DARWIN",
    chineseName: "达尔文",
    traditionalName: "達爾文",
    airports: [
      {
        code: "DRW",
        name: "Darwin intl.",
        chineseName: "达尔文国际机场",
        traditionalName: "達爾文國際機場",
      },
    ],
  },
  DSA: {
    code: "DSA",
    name: "DONCASTER/SHEFFIELD",
    chineseName: "唐克斯特",
    traditionalName: "唐克斯特",
    airports: [
      {
        code: "DSA",
        name: "Robin hood",
        chineseName: "谢菲尔德机场",
        traditionalName: "謝菲爾德機場",
      },
    ],
  },
  DSE: {
    code: "DSE",
    name: "DESSIE",
    chineseName: "德希",
    traditionalName: "德希",
    airports: [
      {
        code: "DSE",
        name: "Kombolcha",
        chineseName: "科姆博尔查机场",
        traditionalName: "科姆博爾查機場",
      },
    ],
  },
  DSM: {
    code: "DSM",
    name: "DES MOINES",
    chineseName: "得梅因",
    traditionalName: "得梅因",
    airports: [
      {
        code: "DSM",
        name: "Des moines intl.",
        chineseName: "德梅因国际机场",
        traditionalName: "德梅因國際機場",
      },
    ],
  },
  DSN: {
    code: "DSN",
    name: "ORDOS",
    chineseName: "鄂尔多斯",
    traditionalName: "鄂爾多斯",
    airports: [
      {
        code: "DSN",
        name: "Ejin horo",
        chineseName: "鄂尔多斯机场",
        traditionalName: "鄂爾多斯機場",
      },
    ],
  },
  DTB: {
    code: "DTB",
    name: "SIBORONG-BORONG",
    chineseName: "四勃龙",
    traditionalName: "四勃龍",
    airports: [
      {
        code: "DTB",
        name: "Silangit",
        chineseName: "西朗伊机场",
        traditionalName: "西朗伊機場",
      },
    ],
  },
  DTM: {
    code: "DTM",
    name: "DORTMUND",
    chineseName: "多特蒙德",
    traditionalName: "多特蒙德",
    airports: [
      {
        code: "DTM",
        name: "Dortmund airport",
        chineseName: "多特蒙德机场",
        traditionalName: "多特蒙德機場",
      },
    ],
  },
  DTT: {
    code: "DTT",
    name: "DETROIT",
    chineseName: "底特律",
    traditionalName: "底特律",
    airports: [
      {
        code: "DTW",
        name: "Metropolitan wayne co.",
        chineseName: "底特律都会韦恩县机场",
        traditionalName: "底特律都會韋恩縣機場",
      },
    ],
  },
  DTU: {
    code: "DTU",
    name: "WUDALIANCHI",
    chineseName: "五大连池",
    traditionalName: "五大連池",
    airports: [
      {
        code: "DTU",
        name: "Dedu",
        chineseName: "德都机场",
        traditionalName: "德都機場",
      },
    ],
  },
  DUB: {
    code: "DUB",
    name: "DUBLIN",
    chineseName: "都柏林",
    traditionalName: "都柏林",
    airports: [
      {
        code: "DUB",
        name: "Dublin intl.",
        chineseName: "都柏林机场",
        traditionalName: "都柏林機場",
      },
    ],
  },
  DUD: {
    code: "DUD",
    name: "DUNEDIN",
    chineseName: "达尼丁",
    traditionalName: "達尼丁",
    airports: [
      {
        code: "DUD",
        name: "Dunedin intl.",
        chineseName: "达尼丁机场",
        traditionalName: "達尼丁機場",
      },
    ],
  },
  DUE: {
    code: "DUE",
    name: "DUNDO",
    chineseName: "邓杜",
    traditionalName: "鄧杜",
    airports: [
      {
        code: "DUE",
        name: "Dundo airport",
        chineseName: "邓杜机场",
        traditionalName: "鄧杜機場",
      },
    ],
  },
  DUJ: {
    code: "DUJ",
    name: "DUBOIS",
    chineseName: "宾夕法尼亚州杜波依斯",
    traditionalName: "賓夕法尼亞州杜波依斯",
    airports: [
      {
        code: "DUJ",
        name: "Dubois reg. airport",
        chineseName: "杜波依斯机场",
        traditionalName: "杜波依斯機場",
      },
    ],
  },
  DUR: {
    code: "DUR",
    name: "DURBAN",
    chineseName: "德班",
    traditionalName: "德班",
    airports: [
      {
        code: "DUR",
        name: "King shaka intl",
        chineseName: "沙卡国王国际机场",
        traditionalName: "沙卡國王國際機場",
      },
    ],
  },
  DUS: {
    code: "DUS",
    name: "DUESSELDORF",
    chineseName: "杜塞尔多夫",
    traditionalName: "杜塞爾多夫",
    airports: [
      {
        code: "DUS",
        name: "Duesseldorf airport",
        chineseName: "杜塞尔多夫机场",
        traditionalName: "杜塞爾多夫機場",
      },
      {
        code: "MGL",
        name: "Moenchengladbach",
        chineseName: "门兴格拉德巴赫机场",
        traditionalName: "門興格拉德巴赫機場",
      },
      {
        code: "NRN",
        name: "Weeze",
        chineseName: "韦策机场",
        traditionalName: "韋策機場",
      },
    ],
  },
  DUT: {
    code: "DUT",
    name: "DUTCH HARBOR",
    chineseName: "荷兰港",
    traditionalName: "荷蘭港",
    airports: [
      {
        code: "DUT",
        name: "Driftwood bay afs",
        chineseName: "荷兰港机场",
        traditionalName: "荷蘭港機場",
      },
    ],
  },
  DVL: {
    code: "DVL",
    name: "DEVILS LAKE",
    chineseName: "北达科他州魔鬼",
    traditionalName: "北達科他州魔鬼",
    airports: [
      {
        code: "DVL",
        name: "Devils lake reg. airport",
        chineseName: "德弗尔斯莱克机场",
        traditionalName: "德弗爾斯萊克機場",
      },
    ],
  },
  DVO: {
    code: "DVO",
    name: "DAVAO",
    chineseName: "达沃",
    traditionalName: "達沃",
    airports: [
      {
        code: "DVO",
        name: "Francisco bangoy intl",
        chineseName: "达沃机场",
        traditionalName: "達沃機場",
      },
    ],
  },
  DWD: {
    code: "DWD",
    name: "DAWADMI",
    chineseName: "达瓦达米",
    traditionalName: "達瓦達米",
    airports: [
      {
        code: "DWD",
        name: "Aldawadmi",
        chineseName: "代瓦迪米机场",
        traditionalName: "代瓦迪米機場",
      },
    ],
  },
  DXB: {
    code: "DXB",
    name: "DUBAI",
    chineseName: "迪拜",
    traditionalName: "迪拜",
    airports: [
      {
        code: "DWC",
        name: "Al maktoum intl",
        chineseName: "阿勒马克图姆国际机场",
        traditionalName: "阿勒馬克圖姆國際機場",
      },
      {
        code: "DXB",
        name: "Dubai International Airport",
        chineseName: "迪拜国际机场",
        traditionalName: "迪拜國際機場",
      },
      {
        code: "XNB",
        name: "Dubai Bus Station Airport",
        chineseName: "杜拜机场",
        traditionalName: "杜拜國際機場",
      },
    ],
  },
  DXJ: {
    code: "DXJ",
    name: "BIANCHENG",
    chineseName: "边城",
    traditionalName: "邊城",
    airports: [
      {
        code: "DXJ",
        name: "Xiangxi biancheng",
        chineseName: "边城机场",
        traditionalName: "邊城機場",
      },
    ],
  },
  DYG: {
    code: "DYG",
    name: "ZHANGJIAJIE",
    chineseName: "张家界",
    traditionalName: "張家界",
    airports: [
      {
        code: "DYG",
        name: "Hehua",
        chineseName: "荷花机场",
        traditionalName: "荷花機場",
      },
    ],
  },
  DYR: {
    code: "DYR",
    name: "ANADYR",
    chineseName: "阿纳德尔",
    traditionalName: "阿納德爾",
    airports: [
      {
        code: "DYR",
        name: "Ugolny",
        chineseName: "阿纳德尔机场",
        traditionalName: "阿納德爾機場",
      },
    ],
  },
  DYU: {
    code: "DYU",
    name: "DUSHANBE",
    chineseName: "杜尚别",
    traditionalName: "杜桑貝",
    airports: [
      {
        code: "DYU",
        name: "Dushanbe intl.",
        chineseName: "杜尚别机场",
        traditionalName: "杜桑貝機場",
      },
    ],
  },
  DZA: {
    code: "DZA",
    name: "DZAOUDZI",
    chineseName: "藻德济",
    traditionalName: "藻德濟",
    airports: [
      {
        code: "DZA",
        name: "Pamandzi intl",
        chineseName: "帕曼德吉国际机场",
        traditionalName: "帕曼德吉國際機場",
      },
    ],
  },
  DZN: {
    code: "DZN",
    name: "ZHEZKAZGAN",
    chineseName: "热兹卡兹干",
    traditionalName: "熱茲卡茲幹",
    airports: [
      {
        code: "DZN",
        name: "Zhezkazgan airport",
        chineseName: "杰兹卡兹甘机场",
        traditionalName: "傑茲卡茲甘機場",
      },
    ],
  },
  EAA: {
    code: "EAA",
    name: "EAGLE",
    chineseName: "阿拉斯加州鹰",
    traditionalName: "阿拉斯加州鷹",
    airports: [
      {
        code: "EAA",
        name: "Eagle airport",
        chineseName: "伊格尔机场",
        traditionalName: "伊格爾機場",
      },
    ],
  },
  EAL: {
    code: "EAL",
    name: "ELENAK",
    chineseName: "夸贾林环礁",
    traditionalName: "誇賈林環礁",
    airports: [
      {
        code: "EAL",
        name: "Elenak airport",
        chineseName: "夸贾林群岛机场",
        traditionalName: "誇賈林群島機場",
      },
    ],
  },
  EAM: {
    code: "EAM",
    name: "NEJRAN",
    chineseName: "奈杰兰",
    traditionalName: "奈傑蘭",
    airports: [
      {
        code: "EAM",
        name: "Nejran airport",
        chineseName: "内奇兰机场",
        traditionalName: "內奇蘭機場",
      },
    ],
  },
  EAP: {
    code: "EAP",
    name: "MULHOUSE/BASEL",
    chineseName: "穆尔豪斯/巴塞尔",
    traditionalName: "莫爾豪斯/巴塞爾",
    airports: [
      {
        code: "BSL",
        name: "Euroairport swiss",
        chineseName: "巴塞尔米卢斯弗赖堡欧洲机场",
        traditionalName: "巴塞爾米盧斯弗賴堡歐洲機場",
      },
      {
        code: "MLH",
        name: "Euroairport french  fr",
        chineseName: "巴塞尔米卢斯弗赖堡欧洲机场",
        traditionalName: "巴塞爾米盧斯弗賴堡歐洲機場",
      },
    ],
  },
  EAR: {
    code: "EAR",
    name: "KEARNEY",
    chineseName: "卡尼",
    traditionalName: "卡尼",
    airports: [
      {
        code: "EAR",
        name: "Kearney reg. airport",
        chineseName: "卡尼机场",
        traditionalName: "卡尼機場",
      },
    ],
  },
  EAS: {
    code: "EAS",
    name: "SAN SEBASTIAN",
    chineseName: "圣塞瓦斯蒂安",
    traditionalName: "聖塞瓦斯蒂安",
    airports: [
      {
        code: "EAS",
        name: "San sebastian airport",
        chineseName: "圣塞瓦斯蒂安机场",
        traditionalName: "聖塞瓦斯蒂安機場",
      },
    ],
  },
  EAT: {
    code: "EAT",
    name: "WENATCHEE",
    chineseName: "韦纳奇",
    traditionalName: "韋納奇",
    airports: [
      {
        code: "EAT",
        name: "Pangborn memorial",
        chineseName: "庞伯恩机场",
        traditionalName: "龐伯恩機場",
      },
    ],
  },
  EAU: {
    code: "EAU",
    name: "EAU CLAIRE",
    chineseName: "欧克莱尔",
    traditionalName: "歐克萊爾",
    airports: [
      {
        code: "EAU",
        name: "Chippewa valley rgnl",
        chineseName: "齐佩瓦山谷地区机场",
        traditionalName: "齊佩瓦山谷地區機場",
      },
    ],
  },
  EBB: {
    code: "EBB",
    name: "ENTEBBE",
    chineseName: "恩德培",
    traditionalName: "恩德培",
    airports: [
      {
        code: "EBB",
        name: "Entebbe intl.",
        chineseName: "恩德培国际机场",
        traditionalName: "恩德培國際機場",
      },
    ],
  },
  EBG: {
    code: "EBG",
    name: "EL BAGRE",
    chineseName: "埃尔巴格莱",
    traditionalName: "埃爾巴格萊",
    airports: [
      {
        code: "EBG",
        name: "El bagre airport",
        chineseName: "埃尔巴格尔机场",
        traditionalName: "埃爾巴格爾機場",
      },
    ],
  },
  EBH: {
    code: "EBH",
    name: "EL BAYADH",
    chineseName: "巴亚兹",
    traditionalName: "巴亞茲",
    airports: [
      {
        code: "EBH",
        name: "El bayadh airport",
        chineseName: "巴亚兹省",
        traditionalName: "巴亞茲省",
      },
    ],
  },
  EBJ: {
    code: "EBJ",
    name: "ESBJERG",
    chineseName: "埃斯比约",
    traditionalName: "埃斯比約",
    airports: [
      {
        code: "EBJ",
        name: "Esbjerg airport",
        chineseName: "埃斯比约机场",
        traditionalName: "埃斯比約機場",
      },
    ],
  },
  EBL: {
    code: "EBL",
    name: "ERBIL",
    chineseName: "阿尔贝拉",
    traditionalName: "阿爾貝拉",
    airports: [
      {
        code: "EBL",
        name: "Erbil intl.",
        chineseName: "埃尔比勒国际机场",
        traditionalName: "埃爾比勒國際機場",
      },
    ],
  },
  EBM: {
    code: "EBM",
    name: "EL BORMA",
    chineseName: "博尔马",
    traditionalName: "博爾馬",
    airports: [
      {
        code: "EBM",
        name: "El borma airport",
        chineseName: "埃尔博马机场",
        traditionalName: "埃爾博馬機場",
      },
    ],
  },
  ECN: {
    code: "ECN",
    name: "ERCAN",
    chineseName: "厄尔坎",
    traditionalName: "厄爾坎",
    airports: [
      {
        code: "ECN",
        name: "Ercan airport",
        chineseName: "厄尔坎机场",
        traditionalName: "厄爾坎機場",
      },
    ],
  },
  ECP: {
    code: "ECP",
    name: "PANAMA CITY",
    chineseName: "巴拿马城",
    traditionalName: "巴拿馬城",
    airports: [
      {
        code: "ECP",
        name: "Nw florida beaches int",
        chineseName: "西北佛罗里达海滩国际机场",
        traditionalName: "西北佛羅里達海灘國際機場",
      },
    ],
  },
  EDA: {
    code: "EDA",
    name: "EDNA BAY",
    chineseName: "埃德纳贝",
    traditionalName: "埃德納貝",
    airports: [
      {
        code: "EDA",
        name: "Sea plane base",
        chineseName: "埃德纳贝水上飞机基地",
        traditionalName: "埃德納貝水上飛機基地",
      },
    ],
  },
  EDI: {
    code: "EDI",
    name: "EDINBURGH",
    chineseName: "爱丁堡",
    traditionalName: "愛丁堡",
    airports: [
      {
        code: "EDI",
        name: "Edinburgh airport",
        chineseName: "爱丁堡机场",
        traditionalName: "愛丁堡機場",
      },
    ],
  },
  EDL: {
    code: "EDL",
    name: "ELDORET",
    chineseName: "埃尔多雷特",
    traditionalName: "埃爾多雷特",
    airports: [
      {
        code: "EDL",
        name: "Eldoret intl.",
        chineseName: "埃尔多雷特国际机场",
        traditionalName: "埃爾多雷特國際機場",
      },
    ],
  },
  EDN: {
    code: "EDN",
    name: "YEDINKA",
    chineseName: "叶廷卡",
    traditionalName: "葉廷卡",
    airports: [
      {
        code: "EDN",
        name: "Yedinka airport",
        chineseName: "埃德纳贝机场",
        traditionalName: "埃德納貝機場",
      },
    ],
  },
  EDO: {
    code: "EDO",
    name: "EDREMIT",
    chineseName: "埃德雷米特",
    traditionalName: "埃德雷米特",
    airports: [
      {
        code: "EDO",
        name: "Koca seyit",
        chineseName: "埃德米特机场",
        traditionalName: "埃德米特機場",
      },
    ],
  },
  EDR: {
    code: "EDR",
    name: "PORMPURAAW",
    chineseName: "泼姆普勒",
    traditionalName: "潑姆普勒",
    airports: [
      {
        code: "EDR",
        name: "Pormpuraaw airport",
        chineseName: "爱德华里弗机场",
        traditionalName: "愛德華裏弗機場",
      },
    ],
  },
  EEA: {
    code: "EEA",
    name: "CORREIA",
    chineseName: "科雷亚",
    traditionalName: "科雷亞",
    airports: [
      {
        code: "EEA",
        name: "Reg do planalto serano",
        chineseName: "普拉纳尔托塞拉诺地区机场",
        traditionalName: "普拉納爾托塞拉諾地區機場",
      },
    ],
  },
  EEK: {
    code: "EEK",
    name: "EEK",
    chineseName: "阿拉斯加城市艾",
    traditionalName: "阿拉斯加都市艾",
    airports: [
      {
        code: "EEK",
        name: "Eek airport",
        chineseName: "埃克机场",
        traditionalName: "埃克機場",
      },
    ],
  },
  EFL: {
    code: "EFL",
    name: "KEFALLINIA",
    chineseName: "凯法利尼亚",
    traditionalName: "凱法利尼亞",
    airports: [
      {
        code: "EFL",
        name: "Kefallinia airport",
        chineseName: "凯法利尼亚机场",
        traditionalName: "凱法利尼亞機場",
      },
    ],
  },
  EGC: {
    code: "EGC",
    name: "BERGERAC",
    chineseName: "贝尔热拉克",
    traditionalName: "貝爾熱拉克",
    airports: [
      {
        code: "EGC",
        name: "Roumaniere",
        chineseName: "罗马尼雷斯机场",
        traditionalName: "羅馬尼雷斯機場",
      },
    ],
  },
  EGE: {
    code: "EGE",
    name: "VAIL/EAGLE",
    chineseName: "范尔",
    traditionalName: "範爾",
    airports: [
      {
        code: "EGE",
        name: "Eagle county regional",
        chineseName: "伊格尔郡机场",
        traditionalName: "伊格爾郡機場",
      },
    ],
  },
  EGM: {
    code: "EGM",
    name: "SEGHE",
    chineseName: "Sege",
    traditionalName: "Sege",
    airports: [
      {
        code: "EGM",
        name: "Seghe airport",
        chineseName: "塞格机场",
        traditionalName: "塞格機場",
      },
    ],
  },
  EGS: {
    code: "EGS",
    name: "EGILSSTADIR",
    chineseName: "埃吉尔斯塔第尔",
    traditionalName: "埃吉爾斯塔第爾",
    airports: [
      {
        code: "EGS",
        name: "Egilsstadir airport",
        chineseName: "埃伊尔斯塔济机场",
        traditionalName: "埃伊爾斯塔濟機場",
      },
    ],
  },
  EGX: {
    code: "EGX",
    name: "EGEGIK",
    chineseName: "伊杰吉克",
    traditionalName: "伊傑吉克",
    airports: [
      {
        code: "EGX",
        name: "Egegik airport",
        chineseName: "伊杰吉克机场",
        traditionalName: "伊傑吉克機場",
      },
    ],
  },
  EHU: {
    code: "EHU",
    name: "EZHOU",
    chineseName: "鄂州",
    traditionalName: "鄂州",
    airports: [
      {
        code: "EHU",
        name: "Ezhou huahu",
        chineseName: "花湖机场",
        traditionalName: "花湖機場",
      },
    ],
  },
  EIN: {
    code: "EIN",
    name: "EINDHOVEN",
    chineseName: "恩和芬",
    traditionalName: "恩和芬",
    airports: [
      {
        code: "EIN",
        name: "Eindhoven airport",
        chineseName: "爱因霍温机场",
        traditionalName: "愛因霍溫機場",
      },
    ],
  },
  EJA: {
    code: "EJA",
    name: "BARRANCABERMEJA",
    chineseName: "巴兰卡韦梅哈",
    traditionalName: "巴蘭卡韋梅哈",
    airports: [
      {
        code: "EJA",
        name: "Yariguies",
        chineseName: "瓦里圭厄斯机场",
        traditionalName: "瓦裡圭厄斯機場",
      },
    ],
  },
  EJT: {
    code: "EJT",
    name: "ENEJET ISLAND",
    chineseName: "米利环礁",
    traditionalName: "米利環礁",
    airports: [
      {
        code: "EJT",
        name: "Enejet island airport",
        chineseName: "米利环礁机场",
        traditionalName: "米利環礁機場",
      },
    ],
  },
  EKO: {
    code: "EKO",
    name: "ELKO",
    chineseName: "埃尔科",
    traditionalName: "埃爾科",
    airports: [
      {
        code: "EKO",
        name: "Elko reg. airport",
        chineseName: "埃尔科机场",
        traditionalName: "埃爾科機場",
      },
    ],
  },
  EKS: {
    code: "EKS",
    name: "SHAKHTERSK",
    chineseName: "沙赫乔尔斯克",
    traditionalName: "沙赫喬爾斯克",
    airports: [
      {
        code: "EKS",
        name: "Shakhtersk airport",
        chineseName: "沙赫乔特斯克",
        traditionalName: "沙赫喬特斯克",
      },
    ],
  },
  ELC: {
    code: "ELC",
    name: "ELCHO ISLAND",
    chineseName: "埃尔科岛",
    traditionalName: "埃爾科島",
    airports: [
      {
        code: "ELC",
        name: "Elcho island airport",
        chineseName: "埃尔科岛机场",
        traditionalName: "埃爾科島機場",
      },
    ],
  },
  ELD: {
    code: "ELD",
    name: "EL DORADO",
    chineseName: "阿肯色州埃尔多拉多",
    traditionalName: "阿肯色州埃爾多拉多",
    airports: [
      {
        code: "ELD",
        name: "South arkansas rgnl",
        chineseName: "南阿肯色地区机场",
        traditionalName: "南阿肯色地區機場",
      },
    ],
  },
  ELG: {
    code: "ELG",
    name: "EL GOLEA",
    chineseName: "古莱阿",
    traditionalName: "古萊阿",
    airports: [
      {
        code: "ELG",
        name: "El golea airport",
        chineseName: "埃尔果累阿机场",
        traditionalName: "埃爾果累阿機場",
      },
    ],
  },
  ELH: {
    code: "ELH",
    name: "NORTH ELEUTHERA",
    chineseName: "北伊柳塞拉",
    traditionalName: "北伊柳塞拉",
    airports: [
      {
        code: "ELH",
        name: "North eleuthera airport",
        chineseName: "北埃卢萨拉国际机场",
        traditionalName: "北埃盧薩拉國際機場",
      },
    ],
  },
  ELI: {
    code: "ELI",
    name: "ELIM",
    chineseName: "阿拉斯加州城市以",
    traditionalName: "阿拉斯加州都市以",
    airports: [
      {
        code: "ELI",
        name: "Elim airport",
        chineseName: "埃利姆机场",
        traditionalName: "埃利姆機場",
      },
    ],
  },
  ELM: {
    code: "ELM",
    name: "ELMIRA/CORNING",
    chineseName: "埃尔迈拉",
    traditionalName: "埃爾邁拉",
    airports: [
      {
        code: "ELM",
        name: "Regional",
        chineseName: "埃尔迈拉地区机场",
        traditionalName: "埃爾邁拉地區機場",
      },
    ],
  },
  ELP: {
    code: "ELP",
    name: "EL PASO",
    chineseName: "埃尔帕索",
    traditionalName: "埃爾帕索",
    airports: [
      {
        code: "ELP",
        name: "El paso intl.",
        chineseName: "埃尔帕索国际机场",
        traditionalName: "埃爾帕索國際機場",
      },
    ],
  },
  ELQ: {
    code: "ELQ",
    name: "GASSIM",
    chineseName: "卡西姆",
    traditionalName: "凱西姆",
    airports: [
      {
        code: "ELQ",
        name: "Gassim airport",
        chineseName: "加希姆机场",
        traditionalName: "加希姆機場",
      },
    ],
  },
  ELS: {
    code: "ELS",
    name: "EAST LONDON",
    chineseName: "东伦敦",
    traditionalName: "東倫敦",
    airports: [
      {
        code: "ELS",
        name: "East london airport",
        chineseName: "东伦敦机场",
        traditionalName: "東倫敦機場",
      },
    ],
  },
  ELU: {
    code: "ELU",
    name: "EL OUED",
    chineseName: "瓦德",
    traditionalName: "瓦德",
    airports: [
      {
        code: "ELU",
        name: "Guemar",
        chineseName: "圭尔马机场",
        traditionalName: "圭爾馬機場",
      },
    ],
  },
  ELV: {
    code: "ELV",
    name: "ELFIN COVE",
    chineseName: "阿拉斯加市埃尔芬",
    traditionalName: "阿拉斯加市埃爾芬",
    airports: [
      {
        code: "ELV",
        name: "Sea plane base",
        chineseName: "埃尔芬科夫水上飞机基地",
        traditionalName: "埃爾芬科夫水上飛機基地",
      },
    ],
  },
  EMD: {
    code: "EMD",
    name: "EMERALD",
    chineseName: "埃默拉尔德",
    traditionalName: "埃默拉爾德",
    airports: [
      {
        code: "EMD",
        name: "Emerald airport",
        chineseName: "埃默拉尔德机场",
        traditionalName: "埃默拉爾德機場",
      },
    ],
  },
  EME: {
    code: "EME",
    name: "EMDEN",
    chineseName: "埃姆登",
    traditionalName: "埃姆登",
    airports: [
      {
        code: "EME",
        name: "Emden airport",
        chineseName: "埃姆登机场",
        traditionalName: "埃姆登機場",
      },
    ],
  },
  EMK: {
    code: "EMK",
    name: "EMMONAK",
    chineseName: "埃莫纳克",
    traditionalName: "埃莫納克",
    airports: [
      {
        code: "EMK",
        name: "Emmonak airport",
        chineseName: "埃蒙纳克机场",
        traditionalName: "埃蒙納克機場",
      },
    ],
  },
  EMN: {
    code: "EMN",
    name: "NEMA",
    chineseName: "内马",
    traditionalName: "內馬",
    airports: [
      {
        code: "EMN",
        name: "Nema airport",
        chineseName: "内马机场",
        traditionalName: "內馬機場",
      },
    ],
  },
  ENA: {
    code: "ENA",
    name: "KENAI",
    chineseName: "基奈",
    traditionalName: "基奈",
    airports: [
      {
        code: "ENA",
        name: "Kenai municipal",
        chineseName: "基奈机场",
        traditionalName: "基奈機場",
      },
    ],
  },
  ENE: {
    code: "ENE",
    name: "ENDE",
    chineseName: "英德",
    traditionalName: "英德",
    airports: [
      {
        code: "ENE",
        name: "H.hasan aroeboesman",
        chineseName: "英德机场",
        traditionalName: "英德機場",
      },
    ],
  },
  ENH: {
    code: "ENH",
    name: "ENSHI",
    chineseName: "恩施",
    traditionalName: "恩施",
    airports: [
      {
        code: "ENH",
        name: "Xujiaping",
        chineseName: "许家坪机场",
        traditionalName: "許家坪機場",
      },
    ],
  },
  ENI: {
    code: "ENI",
    name: "EL NIDO",
    chineseName: "埃尔尼多",
    traditionalName: "埃爾尼多",
    airports: [
      {
        code: "ENI",
        name: "El nido airport",
        chineseName: "爱妮岛机场",
        traditionalName: "愛妮島機場",
      },
    ],
  },
  ENS: {
    code: "ENS",
    name: "ENSCHEDE",
    chineseName: "恩斯赫德",
    traditionalName: "恩斯赫德",
    airports: [
      {
        code: "ENS",
        name: "Twenthe",
        chineseName: "特温特机场",
        traditionalName: "特溫特機場",
      },
    ],
  },
  ENU: {
    code: "ENU",
    name: "ENUGU",
    chineseName: "埃努古",
    traditionalName: "埃努古",
    airports: [
      {
        code: "ENU",
        name: "Akanu ibiam intl",
        chineseName: "埃努古机场",
        traditionalName: "埃努古機場",
      },
    ],
  },
  ENY: {
    code: "ENY",
    name: "YAN'AN",
    chineseName: "延安",
    traditionalName: "延安",
    airports: [
      {
        code: "ENY",
        name: "Nanniwan",
        chineseName: "南泥湾机场",
        traditionalName: "南泥灣機場",
      },
    ],
  },
  EPR: {
    code: "EPR",
    name: "ESPERANCE",
    chineseName: "埃斯佩兰斯",
    traditionalName: "埃斯佩蘭斯",
    airports: [
      {
        code: "EPR",
        name: "Esperance airport",
        chineseName: "埃斯佩兰斯机场",
        traditionalName: "埃斯佩蘭斯機場",
      },
    ],
  },
  EPU: {
    code: "EPU",
    name: "PARNU",
    chineseName: "派尔努",
    traditionalName: "派爾努",
    airports: [
      {
        code: "EPU",
        name: "Parnu airport",
        chineseName: "帕尔努机场",
        traditionalName: "帕爾努機場",
      },
    ],
  },
  EQS: {
    code: "EQS",
    name: "ESQUEL",
    chineseName: "埃斯克尔",
    traditionalName: "埃斯克爾",
    airports: [
      {
        code: "EQS",
        name: "Esquel airport",
        chineseName: "埃斯克尔机场",
        traditionalName: "埃斯克爾機場",
      },
    ],
  },
  ERC: {
    code: "ERC",
    name: "ERZINCAN",
    chineseName: "埃尔津詹",
    traditionalName: "埃爾津詹",
    airports: [
      {
        code: "ERC",
        name: "Erzincan airport",
        chineseName: "埃尔津詹机场",
        traditionalName: "埃爾津詹機場",
      },
    ],
  },
  ERF: {
    code: "ERF",
    name: "ERFURT",
    chineseName: "埃尔福特",
    traditionalName: "埃爾福特",
    airports: [
      {
        code: "ERF",
        name: "Erfurt-weimar",
        chineseName: "埃尔福特机场",
        traditionalName: "埃爾福特機場",
      },
    ],
  },
  ERG: {
    code: "ERG",
    name: "YERBOGACHEN",
    chineseName: "叶尔博加琼",
    traditionalName: "葉爾博加瓊",
    airports: [
      {
        code: "ERG",
        name: "Yerbogachen airport",
        chineseName: "叶尔博加琼",
        traditionalName: "葉爾博加瓊",
      },
    ],
  },
  ERH: {
    code: "ERH",
    name: "ERRACHIDIA",
    chineseName: "埃拉契迪亚",
    traditionalName: "埃拉契迪亞",
    airports: [
      {
        code: "ERH",
        name: "Moulay ali cherif",
        chineseName: "拉希迪耶机场",
        traditionalName: "拉希迪耶機場",
      },
    ],
  },
  ERI: {
    code: "ERI",
    name: "ERIE",
    chineseName: "伊利",
    traditionalName: "伊利",
    airports: [
      {
        code: "ERI",
        name: "Erie intl.",
        chineseName: "伊利国际机场",
        traditionalName: "伊利國際機場",
      },
    ],
  },
  ERL: {
    code: "ERL",
    name: "ERENHOT",
    chineseName: "二连浩特",
    traditionalName: "二連浩特",
    airports: [
      {
        code: "ERL",
        name: "Saiwusu intl",
        chineseName: "二连浩特赛乌素机场",
        traditionalName: "二連浩特賽烏素機場",
      },
    ],
  },
  ERN: {
    code: "ERN",
    name: "EIRUNEPE",
    chineseName: "埃鲁内佩",
    traditionalName: "埃魯內佩",
    airports: [
      {
        code: "ERN",
        name: "Amaury feitosa tomaz",
        chineseName: "阿毛里费托萨托马机场",
        traditionalName: "阿毛裏費托薩托馬機場",
      },
    ],
  },
  ERZ: {
    code: "ERZ",
    name: "ERZURUM",
    chineseName: "埃尔祖鲁姆",
    traditionalName: "埃爾祖魯姆",
    airports: [
      {
        code: "ERZ",
        name: "Erzurum airport",
        chineseName: "埃尔祖鲁姆机场",
        traditionalName: "埃爾祖魯姆機場",
      },
    ],
  },
  ESC: {
    code: "ESC",
    name: "ESCANABA",
    chineseName: "埃斯卡纳巴",
    traditionalName: "埃斯卡納巴",
    airports: [
      {
        code: "ESC",
        name: "Delta county",
        chineseName: "德尔塔郡机场",
        traditionalName: "德爾塔郡機場",
      },
    ],
  },
  ESD: {
    code: "ESD",
    name: "EASTSOUND",
    chineseName: "伊斯特桑德",
    traditionalName: "伊斯特桑德",
    airports: [
      {
        code: "ESD",
        name: "Orcas island",
        chineseName: "奥卡斯岛机场",
        traditionalName: "奧卡斯島機場",
      },
    ],
  },
  ESK: {
    code: "ESK",
    name: "ESKISEHIR",
    chineseName: "埃斯基谢希尔",
    traditionalName: "埃斯基謝希爾",
    airports: [
      {
        code: "AOE",
        name: "Anadolu",
        chineseName: "阿纳多鲁机场",
        traditionalName: "阿納多魯機場",
      },
    ],
  },
  ESL: {
    code: "ESL",
    name: "ELISTA",
    chineseName: "埃利斯塔",
    traditionalName: "艾理斯塔",
    airports: [
      {
        code: "ESL",
        name: "Elista airport",
        chineseName: "埃利斯塔机场",
        traditionalName: "艾理斯塔機場",
      },
    ],
  },
  ESM: {
    code: "ESM",
    name: "ESMERALDAS",
    chineseName: "埃斯美拉达斯",
    traditionalName: "埃斯美拉達斯",
    airports: [
      {
        code: "ESM",
        name: "C.concha torres intl",
        chineseName: "卡洛斯孔查托雷斯国际机场",
        traditionalName: "卡洛斯孔查托雷斯國際機場",
      },
    ],
  },
  ESR: {
    code: "ESR",
    name: "EL SALVADOR",
    chineseName: "萨尔瓦多",
    traditionalName: "薩爾瓦多",
    airports: [
      {
        code: "ESR",
        name: "Ricardo garcia posada",
        chineseName: "萨尔瓦多机场",
        traditionalName: "薩爾瓦多機場",
      },
    ],
  },
  ESU: {
    code: "ESU",
    name: "ESSAOUIRA",
    chineseName: "索维拉",
    traditionalName: "索維拉",
    airports: [
      {
        code: "ESU",
        name: "Mogador",
        chineseName: "莫加多尔机场",
        traditionalName: "莫加多爾機場",
      },
    ],
  },
  ETH: {
    code: "ETH",
    name: "EILAT",
    chineseName: "埃拉特",
    traditionalName: "埃拉特",
    airports: [
      {
        code: "ETM",
        name: "Ramon international",
        chineseName: "拉蒙机场",
        traditionalName: "拉蒙機場",
      },
    ],
  },
  ETL: {
    code: "ETL",
    name: "SVETLAYA",
    chineseName: "斯维特拉亚",
    traditionalName: "斯維特拉亞",
    airports: [
      {
        code: "ETL",
        name: "Svetlaya airport",
        chineseName: "斯维特拉亚机场",
        traditionalName: "斯維特拉亞機場",
      },
    ],
  },
  ETR: {
    code: "ETR",
    name: "SANTA ROSA",
    chineseName: "圣罗莎",
    traditionalName: "聖羅莎",
    airports: [
      {
        code: "ETR",
        name: "Santa rosa intl.",
        chineseName: "圣罗莎国际机场",
        traditionalName: "聖羅莎國際機場",
      },
    ],
  },
  ETZ: {
    code: "ETZ",
    name: "METZ/NANCY",
    chineseName: "梅斯",
    traditionalName: "梅斯",
    airports: [
      {
        code: "ETZ",
        name: "Lorraine",
        chineseName: "罗莱纳机场",
        traditionalName: "羅萊納機場",
      },
    ],
  },
  EUA: {
    code: "EUA",
    name: "EUA",
    chineseName: "尤亚",
    traditionalName: "尤亞",
    airports: [
      {
        code: "EUA",
        name: "Kaufana",
        chineseName: "尤阿机场",
        traditionalName: "尤阿機場",
      },
    ],
  },
  EUG: {
    code: "EUG",
    name: "EUGENE",
    chineseName: "尤金",
    traditionalName: "尤金",
    airports: [
      {
        code: "EUG",
        name: "Mahlon sweet field",
        chineseName: "尤金机场",
        traditionalName: "尤金機場",
      },
    ],
  },
  EUN: {
    code: "EUN",
    name: "LAAYOUNE",
    chineseName: "阿尤恩",
    traditionalName: "阿尤恩",
    airports: [
      {
        code: "EUN",
        name: "Hassan i",
        chineseName: "哈桑机场",
        traditionalName: "哈桑機場",
      },
    ],
  },
  EUQ: {
    code: "EUQ",
    name: "ANTIQUE",
    chineseName: "古",
    traditionalName: "古",
    airports: [
      {
        code: "EUQ",
        name: "Evelio javier",
        chineseName: "埃弗里奥加维厄机场",
        traditionalName: "埃弗裏奧加維厄機場",
      },
    ],
  },
  EUX: {
    code: "EUX",
    name: "ST EUSTATIUS",
    chineseName: "奥拉涅斯塔德",
    traditionalName: "奧拉涅斯塔克",
    airports: [
      {
        code: "EUX",
        name: "F.d. roosevelt",
        chineseName: "罗斯福机场",
        traditionalName: "羅斯福機場",
      },
    ],
  },
  EVE: {
    code: "EVE",
    name: "HARSTAD/NARVIK",
    chineseName: "伊文内斯",
    traditionalName: "伊文內斯",
    airports: [
      {
        code: "EVE",
        name: "Evenes",
        chineseName: "伊文内斯机场",
        traditionalName: "伊文內斯機場",
      },
    ],
  },
  EVG: {
    code: "EVG",
    name: "SVEG",
    chineseName: "斯韦格",
    traditionalName: "斯韋格",
    airports: [
      {
        code: "EVG",
        name: "Sveg airport",
        chineseName: "斯韦格机场",
        traditionalName: "斯韋格機場",
      },
    ],
  },
  EVN: {
    code: "EVN",
    name: "YEREVAN",
    chineseName: "埃里温",
    traditionalName: "葉里溫",
    airports: [
      {
        code: "EVN",
        name: "Zvartnots intl",
        chineseName: "兹瓦尔特诺茨国际机场",
        traditionalName: "茲瓦爾特諾茨國際機場",
      },
    ],
  },
  EVV: {
    code: "EVV",
    name: "EVANSVILLE",
    chineseName: "埃文斯维尔",
    traditionalName: "埃文斯維爾",
    airports: [
      {
        code: "EVV",
        name: "Evansville reg. airport",
        chineseName: "埃文斯维尔地区机场",
        traditionalName: "埃文斯維爾地區機場",
      },
    ],
  },
  EWB: {
    code: "EWB",
    name: "NEW BEDFORD/FALL RIVER",
    chineseName: "新贝尔福特",
    traditionalName: "新貝爾福特",
    airports: [
      {
        code: "EWB",
        name: "New bedford regional",
        chineseName: "新贝德福德机场",
        traditionalName: "新貝德福德機場",
      },
    ],
  },
  EWE: {
    code: "EWE",
    name: "EWER",
    chineseName: "尤瓦尔",
    traditionalName: "尤瓦爾",
    airports: [
      {
        code: "EWE",
        name: "Ewer airport",
        chineseName: "尤瓦尔机场",
        traditionalName: "尤瓦爾機場",
      },
    ],
  },
  EWN: {
    code: "EWN",
    name: "NEW BERN",
    chineseName: "新伯尔尼",
    traditionalName: "新伯爾尼",
    airports: [
      {
        code: "EWN",
        name: "Coastal carolina rgnl",
        chineseName: "卡罗来纳海岸地区机场",
        traditionalName: "卡羅來納海岸地區機場",
      },
    ],
  },
  EXT: {
    code: "EXT",
    name: "EXETER",
    chineseName: "埃克塞特",
    traditionalName: "埃克塞特",
    airports: [
      {
        code: "EXT",
        name: "Exeter airport",
        chineseName: "埃克塞特机场",
        traditionalName: "埃克塞特機場",
      },
    ],
  },
  EYA: {
    code: "EYA",
    name: "ZEYA",
    chineseName: "泽雅",
    traditionalName: "澤雅",
    airports: [
      {
        code: "EYA",
        name: "Zeya airport",
        chineseName: "泽亚机场",
        traditionalName: "澤亞機場",
      },
    ],
  },
  EYK: {
    code: "EYK",
    name: "BELOYARSKY",
    chineseName: "别洛列茨克",
    traditionalName: "別洛列茨克",
    airports: [
      {
        code: "EYK",
        name: "Beloyarsky airport",
        chineseName: "别洛亚尔斯克",
        traditionalName: "別洛亞爾斯克",
      },
    ],
  },
  EYP: {
    code: "EYP",
    name: "YOPAL",
    chineseName: "约帕尔",
    traditionalName: "約帕爾",
    airports: [
      {
        code: "EYP",
        name: "El alcaravan",
        chineseName: "埃尔约帕尔机场",
        traditionalName: "埃爾約帕爾機場",
      },
    ],
  },
  EYW: {
    code: "EYW",
    name: "KEY WEST",
    chineseName: "基韦斯特",
    traditionalName: "基韋斯特",
    airports: [
      {
        code: "EYW",
        name: "Key west intl.",
        chineseName: "基韦斯特国际机场",
        traditionalName: "基韋斯特國際機場",
      },
    ],
  },
  EZS: {
    code: "EZS",
    name: "ELAZIG",
    chineseName: "埃拉泽",
    traditionalName: "埃拉澤",
    airports: [
      {
        code: "EZS",
        name: "Elazig airport",
        chineseName: "埃拉泽机场",
        traditionalName: "埃拉澤機場",
      },
    ],
  },
  EZV: {
    code: "EZV",
    name: "BEREZOVO",
    chineseName: "贝里奥佐沃",
    traditionalName: "貝裏奧佐沃",
    airports: [
      {
        code: "EZV",
        name: "Berezovo airport",
        chineseName: "别洛亚尔斯克机场",
        traditionalName: "別洛亞爾斯克機場",
      },
    ],
  },
  FAB: {
    code: "FAB",
    name: "FARNBOROUGH",
    chineseName: "法恩伯勒",
    traditionalName: "法恩伯勒",
    airports: [
      {
        code: "FAB",
        name: "Farnborough airport",
        chineseName: "法恩伯勒机场",
        traditionalName: "法恩伯勒機場",
      },
    ],
  },
  FAC: {
    code: "FAC",
    name: "FAAITE",
    chineseName: "法埃特",
    traditionalName: "法埃特",
    airports: [
      {
        code: "FAC",
        name: "Faaite airport",
        chineseName: "法埃特机场",
        traditionalName: "法埃特機場",
      },
    ],
  },
  FAE: {
    code: "FAE",
    name: "FAROE ISLANDS",
    chineseName: "法罗群岛",
    traditionalName: "法羅群島",
    airports: [
      {
        code: "FAE",
        name: "Vagar",
        chineseName: "瓦加尔机场",
        traditionalName: "瓦加爾機場",
      },
    ],
  },
  FAI: {
    code: "FAI",
    name: "FAIRBANKS",
    chineseName: "费尔班克斯",
    traditionalName: "費爾班克斯",
    airports: [
      {
        code: "FAI",
        name: "Fairbanks intl.",
        chineseName: "费尔班克斯国际机场",
        traditionalName: "費爾班克斯國際機場",
      },
    ],
  },
  FAO: {
    code: "FAO",
    name: "FARO",
    chineseName: "法罗",
    traditionalName: "法羅",
    airports: [
      {
        code: "FAO",
        name: "Faro airport",
        chineseName: "法鲁机场",
        traditionalName: "法魯機場",
      },
    ],
  },
  FAR: {
    code: "FAR",
    name: "FARGO",
    chineseName: "法戈",
    traditionalName: "法戈",
    airports: [
      {
        code: "FAR",
        name: "Hector intl",
        chineseName: "赫克特尔国际机场",
        traditionalName: "赫克特爾國際機場",
      },
    ],
  },
  FAT: {
    code: "FAT",
    name: "FRESNO",
    chineseName: "弗雷斯诺",
    traditionalName: "弗雷斯諾",
    airports: [
      {
        code: "FAT",
        name: "Yosemite intl",
        chineseName: "优胜美地国际机场",
        traditionalName: "優勝美地國際機場",
      },
    ],
  },
  FAU: {
    code: "FAU",
    name: "FAHUD",
    chineseName: "法赫德",
    traditionalName: "法赫德",
    airports: [
      {
        code: "FAU",
        name: "Fahud airport",
        chineseName: "费胡德机场",
        traditionalName: "費胡德機場",
      },
    ],
  },
  FAV: {
    code: "FAV",
    name: "FAKARAVA",
    chineseName: "法卡拉瓦",
    traditionalName: "法卡拉瓦",
    airports: [
      {
        code: "FAV",
        name: "Fakarava airport",
        chineseName: "法卡拉瓦机场",
        traditionalName: "法卡拉瓦機場",
      },
    ],
  },
  FAY: {
    code: "FAY",
    name: "FAYETTEVILLE",
    chineseName: "费耶特维尔",
    traditionalName: "費耶特維爾",
    airports: [
      {
        code: "FAY",
        name: "Regional (grannis fld)",
        chineseName: "费耶特维尔地方机场",
        traditionalName: "費耶特維爾地方機場",
      },
    ],
  },
  FBM: {
    code: "FBM",
    name: "LUBUMBASHI",
    chineseName: "卢本巴希",
    traditionalName: "盧本巴希",
    airports: [
      {
        code: "FBM",
        name: "Luano intl",
        chineseName: "卢阿诺机场",
        traditionalName: "盧阿諾機場",
      },
    ],
  },
  FCA: {
    code: "FCA",
    name: "KALISPELL",
    chineseName: "卡利斯佩尔",
    traditionalName: "卡利斯佩爾",
    airports: [
      {
        code: "FCA",
        name: "Glacier park intl",
        chineseName: "格雷希尔公园国际机场",
        traditionalName: "格雷希爾公園國際機場",
      },
    ],
  },
  FCN: {
    code: "FCN",
    name: "CUXHAVEN",
    chineseName: "库克斯港",
    traditionalName: "庫克斯港",
    airports: [
      {
        code: "FCN",
        name: "Nordholz",
        chineseName: "诺德霍尔茨机场",
        traditionalName: "諾德霍爾茨機場",
      },
    ],
  },
  FDE: {
    code: "FDE",
    name: "FORDE",
    chineseName: "福德",
    traditionalName: "福德",
    airports: [
      {
        code: "FDE",
        name: "Bringeland",
        chineseName: "布林格兰德机场",
        traditionalName: "布林格蘭德機場",
      },
    ],
  },
  FDF: {
    code: "FDF",
    name: "FORT-DE-FRANCE",
    chineseName: "福特法",
    traditionalName: "福特法",
    airports: [
      {
        code: "FDF",
        name: "Martinique a. cesaire",
        chineseName: "马提尼克艾梅塞泽尔机场",
        traditionalName: "馬提尼克艾梅塞澤爾機場",
      },
    ],
  },
  FDH: {
    code: "FDH",
    name: "FRIEDRICHSHAFEN",
    chineseName: "腓特烈港",
    traditionalName: "腓特烈港",
    airports: [
      {
        code: "FDH",
        name: "Friedrichshafen airport",
        chineseName: "腓特烈斯港机场",
        traditionalName: "腓特烈斯港機場",
      },
    ],
  },
  FDU: {
    code: "FDU",
    name: "BANDUNDU",
    chineseName: "班顿杜",
    traditionalName: "班頓杜",
    airports: [
      {
        code: "FDU",
        name: "Bandundu airport",
        chineseName: "班顿杜机场",
        traditionalName: "班頓杜機場",
      },
    ],
  },
  FEG: {
    code: "FEG",
    name: "FERGANA",
    chineseName: "费尔干纳",
    traditionalName: "費爾幹納",
    airports: [
      {
        code: "FEG",
        name: "Fergana intl.",
        chineseName: "费尔干纳机场",
        traditionalName: "費爾幹納機場",
      },
    ],
  },
  FEN: {
    code: "FEN",
    name: "FERNANDO DE NORONHA",
    chineseName: "费尔南多·迪诺罗尼亚群岛",
    traditionalName: "費爾南多·迪諾羅尼亞群島",
    airports: [
      {
        code: "FEN",
        name: "Fernando de noronha airport",
        chineseName: "费尔南多迪诺罗尼亚机场",
        traditionalName: "費爾南多迪諾羅尼亞機場",
      },
    ],
  },
  FEZ: {
    code: "FEZ",
    name: "FES",
    chineseName: "非斯",
    traditionalName: "非斯",
    airports: [
      {
        code: "FEZ",
        name: "Saiss",
        chineseName: "塞斯机场",
        traditionalName: "塞斯機場",
      },
    ],
  },
  FGU: {
    code: "FGU",
    name: "FANGATAU",
    chineseName: "方阿陶",
    traditionalName: "方阿陶",
    airports: [
      {
        code: "FGU",
        name: "Fangatau airport",
        chineseName: "方阿陶机场",
        traditionalName: "方阿陶機場",
      },
    ],
  },
  FHZ: {
    code: "FHZ",
    name: "FAKAHINA",
    chineseName: "法卡希纳",
    traditionalName: "法卡希納",
    airports: [
      {
        code: "FHZ",
        name: "Fakahina airport",
        chineseName: "法卡希纳机场",
        traditionalName: "法卡希納機場",
      },
    ],
  },
  FIE: {
    code: "FIE",
    name: "FAIR ISLE",
    chineseName: "费尔岛",
    traditionalName: "費爾島",
    airports: [
      {
        code: "FIE",
        name: "Fair isle airport",
        chineseName: "费尔岛机场",
        traditionalName: "費爾島機場",
      },
    ],
  },
  FIH: {
    code: "FIH",
    name: "KINSHASA",
    chineseName: "金沙萨",
    traditionalName: "金夏沙",
    airports: [
      {
        code: "FIH",
        name: "N'djili intl",
        chineseName: "内德吉里机场",
        traditionalName: "內德吉裏機場",
      },
      {
        code: "NLO",
        name: "N'dolo",
        chineseName: "讷斗罗机场",
        traditionalName: "訥鬥羅機場",
      },
    ],
  },
  FIZ: {
    code: "FIZ",
    name: "FITZROY CROSSING",
    chineseName: "菲茨罗伊克罗辛",
    traditionalName: "菲茨羅伊克羅辛",
    airports: [
      {
        code: "FIZ",
        name: "Fitzroy crossing airport",
        chineseName: "费茨罗伊科罗辛机场",
        traditionalName: "費茨羅伊科羅辛機場",
      },
    ],
  },
  FJR: {
    code: "FJR",
    name: "FUJAIRAH",
    chineseName: "富查伊拉",
    traditionalName: "富查伊拉",
    airports: [
      {
        code: "FJR",
        name: "Fujairah intl.",
        chineseName: "富查伊拉国际机场",
        traditionalName: "富查伊拉國際機場",
      },
    ],
  },
  FKB: {
    code: "FKB",
    name: "KARLSRUHE/BADEN-BADEN",
    chineseName: "卡尔斯鲁厄/巴登巴登",
    traditionalName: "卡爾斯魯厄/巴登巴登",
    airports: [
      {
        code: "FKB",
        name: "Baden airpark",
        chineseName: "巴登机场",
        traditionalName: "巴登機場",
      },
    ],
  },
  FKI: {
    code: "FKI",
    name: "KISANGANI",
    chineseName: "基桑加尼",
    traditionalName: "基桑加尼",
    airports: [
      {
        code: "FKI",
        name: "Bangoka intl",
        chineseName: "班果卡国际机场",
        traditionalName: "班果卡國際機場",
      },
    ],
  },
  FKQ: {
    code: "FKQ",
    name: "FAK FAK",
    chineseName: "法克法克",
    traditionalName: "法克法克",
    airports: [
      {
        code: "FKQ",
        name: "Torea",
        chineseName: "法克法克机场",
        traditionalName: "法克法克機場",
      },
    ],
  },
  FKS: {
    code: "FKS",
    name: "FUKUSHIMA",
    chineseName: "福岛",
    traditionalName: "福島",
    airports: [
      {
        code: "FKS",
        name: "Fukushima airport",
        chineseName: "福岛机场",
        traditionalName: "福島機場",
      },
    ],
  },
  FLA: {
    code: "FLA",
    name: "FLORENCIA",
    chineseName: "佛罗伦西亚",
    traditionalName: "佛羅倫西亞",
    airports: [
      {
        code: "FLA",
        name: "Gustavo a. paredes",
        chineseName: "古斯塔沃帕雷德斯机场",
        traditionalName: "古斯塔沃帕雷德斯機場",
      },
    ],
  },
  FLL: {
    code: "FLL",
    name: "FORT LAUDERDALE",
    chineseName: "劳德代尔堡",
    traditionalName: "勞德代爾堡",
    airports: [
      {
        code: "FLL",
        name: "Fort lauderdale intl.",
        chineseName: "劳德代尔堡机场",
        traditionalName: "勞德代爾堡機場",
      },
      {
        code: "FXE",
        name: "Executive",
        chineseName: "劳德代尔堡机场",
        traditionalName: "勞德代爾堡機場",
      },
    ],
  },
  FLN: {
    code: "FLN",
    name: "FLORIANOPOLIS",
    chineseName: "佛洛莉亚诺波里斯",
    traditionalName: "佛洛莉亞諾波里斯",
    airports: [
      {
        code: "FLN",
        name: "Hercilio luz intl",
        chineseName: "埃尔西利乌鲁兹国际机场",
        traditionalName: "埃爾西利烏魯茲國際機場",
      },
    ],
  },
  FLO: {
    code: "FLO",
    name: "FLORENCE",
    chineseName: "弗洛伦斯",
    traditionalName: "弗洛倫斯",
    airports: [
      {
        code: "FLO",
        name: "Florence reg. airport",
        chineseName: "弗洛伦斯机场",
        traditionalName: "弗洛倫斯機場",
      },
    ],
  },
  FLR: {
    code: "FLR",
    name: "FLORENCE",
    chineseName: "佛罗伦萨",
    traditionalName: "翡冷翠",
    airports: [
      {
        code: "FLR",
        name: "Peretola",
        chineseName: "佩雷托拉机场",
        traditionalName: "佩雷托拉機場",
      },
    ],
  },
  FLS: {
    code: "FLS",
    name: "FLINDERS ISLAND",
    chineseName: "弗林德斯岛",
    traditionalName: "弗林德斯島",
    airports: [
      {
        code: "FLS",
        name: "Flinders island airport",
        chineseName: "弗林德斯岛机场",
        traditionalName: "弗林德斯島機場",
      },
    ],
  },
  FLW: {
    code: "FLW",
    name: "FLORES ISLAND",
    chineseName: "弗洛雷斯",
    traditionalName: "弗洛雷斯",
    airports: [
      {
        code: "FLW",
        name: "Flores island airport",
        chineseName: "弗洛雷斯岛机场",
        traditionalName: "弗洛雷斯島機場",
      },
    ],
  },
  FLZ: {
    code: "FLZ",
    name: "SIBOLGA",
    chineseName: "实武牙",
    traditionalName: "實武牙",
    airports: [
      {
        code: "FLZ",
        name: "Ferdinand lumbantobing",
        chineseName: "费迪南德·伦班·托宾机场",
        traditionalName: "費迪南德·倫班·托賓機場",
      },
    ],
  },
  FMA: {
    code: "FMA",
    name: "FORMOSA",
    chineseName: "福莫萨",
    traditionalName: "福莫薩",
    airports: [
      {
        code: "FMA",
        name: "Formosa airport",
        chineseName: "福莫萨机场",
        traditionalName: "福莫薩機場",
      },
    ],
  },
  FMI: {
    code: "FMI",
    name: "KALEMIE",
    chineseName: "卡勒米",
    traditionalName: "卡勒米",
    airports: [
      {
        code: "FMI",
        name: "Kalemie airport",
        chineseName: "卡莱米机场",
        traditionalName: "卡萊米機場",
      },
    ],
  },
  FMM: {
    code: "FMM",
    name: "MEMMINGEN",
    chineseName: "梅明根",
    traditionalName: "梅明根",
    airports: [
      {
        code: "FMM",
        name: "Allgaeu",
        chineseName: "梅明根机场",
        traditionalName: "梅明根機場",
      },
    ],
  },
  FMO: {
    code: "FMO",
    name: "MUENSTER/OSNABRUECK",
    chineseName: "蒙斯特",
    traditionalName: "蒙斯特",
    airports: [
      {
        code: "FMO",
        name: "Muenster/osnabrueck intl.",
        chineseName: "蒙斯特国际机场",
        traditionalName: "蒙斯特國際機場",
      },
    ],
  },
  FMT: {
    code: "FMT",
    name: "FARESMATHODA",
    chineseName: "票价城",
    traditionalName: "票價城",
    airports: [
      {
        code: "FMT",
        name: "Faresmathoda airport",
        chineseName: "法雷斯马多达机场",
        traditionalName: "法雷斯馬多達機場",
      },
    ],
  },
  FMY: {
    code: "FMY",
    name: "FORT MYERS",
    chineseName: "迈尔斯堡",
    traditionalName: "邁爾斯堡",
    airports: [
      {
        code: "RSW",
        name: "Southwest florida intl",
        chineseName: "西南佛罗里达国际机场",
        traditionalName: "西南佛羅里達國際機場",
      },
    ],
  },
  FNA: {
    code: "FNA",
    name: "FREETOWN",
    chineseName: "弗里敦",
    traditionalName: "弗裏敦",
    airports: [
      {
        code: "FNA",
        name: "Lungi international",
        chineseName: "伦吉国际机场",
        traditionalName: "倫吉國際機場",
      },
    ],
  },
  FNC: {
    code: "FNC",
    name: "FUNCHAL",
    chineseName: "马德拉",
    traditionalName: "馬德拉",
    airports: [
      {
        code: "FNC",
        name: "Madeira",
        chineseName: "克里斯蒂亚诺·罗纳尔多国际机场",
        traditionalName: "克利斯蒂亞諾·羅納爾多國際機場",
      },
    ],
  },
  FND: {
    code: "FND",
    name: "FUNADHOO",
    chineseName: "Funadhoo",
    traditionalName: "Funadhoo",
    airports: [
      {
        code: "FND",
        name: "Funadhoo airport",
        chineseName: "FUNADHOO机场",
        traditionalName: "Funadhoo機場",
      },
    ],
  },
  FNI: {
    code: "FNI",
    name: "NIMES",
    chineseName: "尼姆",
    traditionalName: "尼姆",
    airports: [
      {
        code: "FNI",
        name: "Garons",
        chineseName: "加隆斯机场",
        traditionalName: "加隆斯機場",
      },
    ],
  },
  FNJ: {
    code: "FNJ",
    name: "PYONGYANG",
    chineseName: "平壤",
    traditionalName: "平壤",
    airports: [
      {
        code: "FNJ",
        name: "Sunan intl",
        chineseName: "顺安机场",
        traditionalName: "順安機場",
      },
    ],
  },
  FNL: {
    code: "FNL",
    name: "FORT COLLINS/LOVELAND",
    chineseName: "科罗拉多州柯林斯堡/洛夫兰",
    traditionalName: "科羅拉多州柯林斯堡/洛夫蘭",
    airports: [
      {
        code: "FNL",
        name: "Northern colorado regional",
        chineseName: "柯林斯堡/拉夫兰机场",
        traditionalName: "柯林斯堡/拉夫蘭機場",
      },
    ],
  },
  FNT: {
    code: "FNT",
    name: "FLINT",
    chineseName: "弗林特",
    traditionalName: "弗林特",
    airports: [
      {
        code: "FNT",
        name: "Bishop intl",
        chineseName: "毕晓普国际机场",
        traditionalName: "畢曉普國際機場",
      },
    ],
  },
  FOA: {
    code: "FOA",
    name: "FOULA",
    chineseName: "富拉",
    traditionalName: "富拉",
    airports: [
      {
        code: "FOA",
        name: "Foula airport",
        chineseName: "富拉岛机场",
        traditionalName: "富拉島機場",
      },
    ],
  },
  FOC: {
    code: "FOC",
    name: "FUZHOU",
    chineseName: "福州",
    traditionalName: "福州",
    airports: [
      {
        code: "FOC",
        name: "Changle intl",
        chineseName: "长乐国际机场",
        traditionalName: "長樂國際機場",
      },
    ],
  },
  FOD: {
    code: "FOD",
    name: "FORT DODGE",
    chineseName: "道奇堡",
    traditionalName: "道奇堡",
    airports: [
      {
        code: "FOD",
        name: "Fort dodge reg. airport",
        chineseName: "道奇堡机场",
        traditionalName: "道奇堡機場",
      },
    ],
  },
  FOG: {
    code: "FOG",
    name: "FOGGIA",
    chineseName: "福贾",
    traditionalName: "福賈",
    airports: [
      {
        code: "FOG",
        name: "Gino lisa",
        chineseName: "吉诺利萨机场",
        traditionalName: "吉諾利薩機場",
      },
    ],
  },
  FON: {
    code: "FON",
    name: "FORTUNA",
    chineseName: "福图纳",
    traditionalName: "福圖納",
    airports: [
      {
        code: "FON",
        name: "Arenal",
        chineseName: "福图纳机场",
        traditionalName: "福圖納機場",
      },
    ],
  },
  FOR: {
    code: "FOR",
    name: "FORTALEZA",
    chineseName: "福特莱萨",
    traditionalName: "福特萊薩",
    airports: [
      {
        code: "FOR",
        name: "Pinto martins intl",
        chineseName: "平托马丁斯国际机场",
        traditionalName: "平托馬丁斯國際機場",
      },
    ],
  },
  FPO: {
    code: "FPO",
    name: "FREEPORT",
    chineseName: "弗里波特",
    traditionalName: "弗裏波特",
    airports: [
      {
        code: "FPO",
        name: "Grand bahama intl",
        chineseName: "格兰德巴哈马国际机场",
        traditionalName: "格蘭德巴哈馬國際機場",
      },
    ],
  },
  FRA: {
    code: "FRA",
    name: "FRANKFURT",
    chineseName: "法兰克福",
    traditionalName: "法蘭克福",
    airports: [
      {
        code: "FRA",
        name: "Frankfurt intl.",
        chineseName: "法兰克福国际机场",
        traditionalName: "法蘭克福國際機場",
      },
      {
        code: "HHN",
        name: "Hahn",
        chineseName: "哈恩机场",
        traditionalName: "哈恩機場",
      },
    ],
  },
  FRD: {
    code: "FRD",
    name: "FRIDAY HARBOR",
    chineseName: "星期五港",
    traditionalName: "星期五港",
    airports: [
      {
        code: "FRD",
        name: "Friday harbor airport",
        chineseName: "星期五港机场",
        traditionalName: "星期五港機場",
      },
    ],
  },
  FRE: {
    code: "FRE",
    name: "FERA ISLAND",
    chineseName: "费拉岛",
    traditionalName: "費拉島",
    airports: [
      {
        code: "FRE",
        name: "Fera island airport",
        chineseName: "费拉岛机场",
        traditionalName: "費拉島機場",
      },
    ],
  },
  FRL: {
    code: "FRL",
    name: "FORLI",
    chineseName: "弗利",
    traditionalName: "弗利",
    airports: [
      {
        code: "FRL",
        name: "Luigi ridolfi",
        chineseName: "弗利机场",
        traditionalName: "弗利機場",
      },
    ],
  },
  FRO: {
    code: "FRO",
    name: "FLORO",
    chineseName: "弗卢勒",
    traditionalName: "弗盧勒",
    airports: [
      {
        code: "FRO",
        name: "Floro airport",
        chineseName: "弗卢勒机场",
        traditionalName: "弗盧勒機場",
      },
    ],
  },
  FRS: {
    code: "FRS",
    name: "FLORES",
    chineseName: "弗洛雷斯",
    traditionalName: "弗洛雷斯",
    airports: [
      {
        code: "FRS",
        name: "Mundo maya intl",
        chineseName: "马雅世界国际机场",
        traditionalName: "馬雅世界國際機場",
      },
    ],
  },
  FRU: {
    code: "FRU",
    name: "BISHKEK",
    chineseName: "比什凯克",
    traditionalName: "比什凱克",
    airports: [
      {
        code: "FRU",
        name: "Manas intl",
        chineseName: "玛纳斯国际机场",
        traditionalName: "瑪納斯國際機場",
      },
    ],
  },
  FRW: {
    code: "FRW",
    name: "FRANCISTOWN",
    chineseName: "弗朗西斯敦",
    traditionalName: "弗朗西斯敦",
    airports: [
      {
        code: "FRW",
        name: "Francistown airport",
        chineseName: "弗朗西斯敦机场",
        traditionalName: "弗朗西斯敦機場",
      },
    ],
  },
  FSC: {
    code: "FSC",
    name: "FIGARI",
    chineseName: "费加里",
    traditionalName: "費加裏",
    airports: [
      {
        code: "FSC",
        name: "Sud-corse",
        chineseName: "苏德考尔斯机场",
        traditionalName: "蘇德考爾斯機場",
      },
    ],
  },
  FSD: {
    code: "FSD",
    name: "SIOUX FALLS",
    chineseName: "苏福尔斯",
    traditionalName: "蘇福爾斯",
    airports: [
      {
        code: "FSD",
        name: "Joe foss field",
        chineseName: "苏瀑地区机场",
        traditionalName: "蘇瀑地區機場",
      },
    ],
  },
  FSM: {
    code: "FSM",
    name: "FORT SMITH",
    chineseName: "史密斯堡",
    traditionalName: "史密斯堡",
    airports: [
      {
        code: "FSM",
        name: "Fort smith reg. airport",
        chineseName: "史密斯堡地方机场",
        traditionalName: "史密斯堡地方機場",
      },
    ],
  },
  FSP: {
    code: "FSP",
    name: "ST-PIERRE",
    chineseName: "圣皮埃尔",
    traditionalName: "聖皮爾",
    airports: [
      {
        code: "FSP",
        name: "St-pierre airport",
        chineseName: "圣皮埃尔机场",
        traditionalName: "聖皮爾機場",
      },
    ],
  },
  FSZ: {
    code: "FSZ",
    name: "SHIZUOKA",
    chineseName: "静冈",
    traditionalName: "靜岡",
    airports: [
      {
        code: "FSZ",
        name: "Mount fuji",
        chineseName: "富士山机场",
        traditionalName: "富士山機場",
      },
    ],
  },
  FTA: {
    code: "FTA",
    name: "FUTUNA ISLAND",
    chineseName: "福杜纳岛",
    traditionalName: "福杜納島",
    airports: [
      {
        code: "FTA",
        name: "Futuna island airport",
        chineseName: "富图纳机场",
        traditionalName: "富圖納機場",
      },
    ],
  },
  FTE: {
    code: "FTE",
    name: "EL CALAFATE",
    chineseName: "埃尔卡拉法特",
    traditionalName: "埃爾卡拉法特",
    airports: [
      {
        code: "FTE",
        name: "Comandante a. tola",
        chineseName: "埃尔卡拉法特机场",
        traditionalName: "埃爾卡拉法特機場",
      },
    ],
  },
  FTI: {
    code: "FTI",
    name: "FITIUTA",
    chineseName: "尤塔",
    traditionalName: "尤塔",
    airports: [
      {
        code: "FTI",
        name: "Fitiuta airport",
        chineseName: "费图伊塔机场",
        traditionalName: "費圖伊塔機場",
      },
    ],
  },
  FTU: {
    code: "FTU",
    name: "TOLANARO",
    chineseName: "多凡堡",
    traditionalName: "多凡堡",
    airports: [
      {
        code: "FTU",
        name: "Marillac",
        chineseName: "马里拉克机场",
        traditionalName: "馬裏拉克機場",
      },
    ],
  },
  FTW: {
    code: "FTW",
    name: "FORT WORTH",
    chineseName: "沃思堡",
    traditionalName: "沃思堡",
    airports: [
      {
        code: "AFW",
        name: "Alliance",
        chineseName: "沃思堡机场",
        traditionalName: "沃思堡機場",
      },
    ],
  },
  FUE: {
    code: "FUE",
    name: "FUERTEVENTURA",
    chineseName: "富埃特文图拉岛",
    traditionalName: "富埃特文圖拉島",
    airports: [
      {
        code: "FUE",
        name: "Fuerteventura airport",
        chineseName: "富埃特文图拉机场",
        traditionalName: "富埃特文圖拉機場",
      },
    ],
  },
  FUG: {
    code: "FUG",
    name: "FUYANG",
    chineseName: "阜阳",
    traditionalName: "阜陽",
    airports: [
      {
        code: "FUG",
        name: "Xiguan",
        chineseName: "西关机场",
        traditionalName: "西關機場",
      },
    ],
  },
  FUJ: {
    code: "FUJ",
    name: "FUKUE",
    chineseName: "福江",
    traditionalName: "福江",
    airports: [
      {
        code: "FUJ",
        name: "Goto-fukue",
        chineseName: "福江机场",
        traditionalName: "福江機場",
      },
    ],
  },
  FUK: {
    code: "FUK",
    name: "FUKUOKA",
    chineseName: "福冈",
    traditionalName: "福岡",
    airports: [
      {
        code: "FUK",
        name: "Fukuoka airport",
        chineseName: "福冈机场",
        traditionalName: "福岡機場",
      },
    ],
  },
  FUN: {
    code: "FUN",
    name: "FUNAFUTI",
    chineseName: "富纳富提环礁",
    traditionalName: "福納佛提環礁",
    airports: [
      {
        code: "FUN",
        name: "Funafuti intl.",
        chineseName: "富纳富提环礁国际机场",
        traditionalName: "福納佛提環礁國際機場",
      },
    ],
  },
  FUO: {
    code: "FUO",
    name: "FOSHAN",
    chineseName: "佛山",
    traditionalName: "佛山",
    airports: [
      {
        code: "FUO",
        name: "Shadi",
        chineseName: "沙堤机场",
        traditionalName: "沙堤機場",
      },
    ],
  },
  FUT: {
    code: "FUT",
    name: "FUTUNA ISLAND",
    chineseName: "富图纳岛",
    traditionalName: "富圖納島",
    airports: [
      {
        code: "FUT",
        name: "Pointe vele",
        chineseName: "富图纳岛机场",
        traditionalName: "富圖納島機場",
      },
    ],
  },
  FVM: {
    code: "FVM",
    name: "FUVAHMULAK ISLAND",
    chineseName: "浮梦那岛",
    traditionalName: "浮夢那島",
    airports: [
      {
        code: "FVM",
        name: "Fuvahmulak island airport",
        chineseName: "弗阿穆拉机场",
        traditionalName: "弗阿穆拉機場",
      },
    ],
  },
  FWA: {
    code: "FWA",
    name: "FORT WAYNE",
    chineseName: "韦恩堡",
    traditionalName: "韋恩堡",
    airports: [
      {
        code: "FWA",
        name: "Fort wayne intl.",
        chineseName: "韦恩堡国际机场",
        traditionalName: "韋恩堡國際機場",
      },
    ],
  },
  FYJ: {
    code: "FYJ",
    name: "FUYUAN",
    chineseName: "抚远",
    traditionalName: "撫遠",
    airports: [
      {
        code: "FYJ",
        name: "Fuyuan airport",
        chineseName: "东极机场",
        traditionalName: "東極機場",
      },
    ],
  },
  FYN: {
    code: "FYN",
    name: "FUYUN",
    chineseName: "富蕴",
    traditionalName: "富蘊",
    airports: [
      {
        code: "FYN",
        name: "Fuyun airport",
        chineseName: "可可托海机场",
        traditionalName: "可哥托海機場",
      },
    ],
  },
  FYU: {
    code: "FYU",
    name: "FORT YUKON",
    chineseName: "育空堡",
    traditionalName: "育空堡",
    airports: [
      {
        code: "FYU",
        name: "Fort yukon airport",
        chineseName: "育空堡机场",
        traditionalName: "育空堡機場",
      },
    ],
  },
  FYV: {
    code: "FYV",
    name: "FAYETTEVILLE/SPRINGD.",
    chineseName: "费耶特维尔/斯普林德。城",
    traditionalName: "費耶特維爾/斯普林德。 城",
    airports: [
      {
        code: "XNA",
        name: "Northwest arkansas rgn",
        chineseName: "阿肯色西北地区机场",
        traditionalName: "阿肯色西北地方機場",
      },
    ],
  },
  GAJ: {
    code: "GAJ",
    name: "YAMAGATA",
    chineseName: "山形",
    traditionalName: "山形",
    airports: [
      {
        code: "GAJ",
        name: "Yamagata airport",
        chineseName: "山形机场",
        traditionalName: "山形機場",
      },
    ],
  },
  GAL: {
    code: "GAL",
    name: "GALENA",
    chineseName: "阿拉斯加州加利纳",
    traditionalName: "阿拉斯加州加利納",
    airports: [
      {
        code: "GAL",
        name: "Edward g. pitka sr.",
        chineseName: "加利纳机场",
        traditionalName: "加利納機場",
      },
    ],
  },
  GAM: {
    code: "GAM",
    name: "GAMBELL",
    chineseName: "甘伯尔",
    traditionalName: "甘伯爾",
    airports: [
      {
        code: "GAM",
        name: "Gambell airport",
        chineseName: "甘伯尔机场",
        traditionalName: "甘伯爾機場",
      },
    ],
  },
  GAN: {
    code: "GAN",
    name: "GAN ISLAND",
    chineseName: "甘岛",
    traditionalName: "甘島",
    airports: [
      {
        code: "GAN",
        name: "Gan island intl.",
        chineseName: "甘岛国际机场",
        traditionalName: "甘島國際機場",
      },
    ],
  },
  GAO: {
    code: "GAO",
    name: "GUANTANAMO",
    chineseName: "关塔那摩",
    traditionalName: "關塔那摩",
    airports: [
      {
        code: "GAO",
        name: "Mariana grajales",
        chineseName: "关塔那摩机场",
        traditionalName: "關塔那摩機場",
      },
      {
        code: "NBW",
        name: "Guantanamo bay ns",
        chineseName: "玛丽亚娜格拉哈莱斯机场",
        traditionalName: "瑪麗亞娜格拉哈萊斯機場",
      },
    ],
  },
  GAQ: {
    code: "GAQ",
    name: "GAO",
    chineseName: "加奥",
    traditionalName: "加奧",
    airports: [
      {
        code: "GAQ",
        name: "Korogoussou",
        chineseName: "加奥机场",
        traditionalName: "加奧機場",
      },
    ],
  },
  GAS: {
    code: "GAS",
    name: "GARISSA",
    chineseName: "加里萨",
    traditionalName: "加里薩",
    airports: [
      {
        code: "GAS",
        name: "Garissa airport",
        chineseName: "加里萨机场",
        traditionalName: "加里薩機場",
      },
    ],
  },
  GAU: {
    code: "GAU",
    name: "GUWAHATI",
    chineseName: "古瓦哈提",
    traditionalName: "古瓦哈提",
    airports: [
      {
        code: "GAU",
        name: "Gopinath bordoloi intl",
        chineseName: "戈皮纳思博多洛伊国际机场",
        traditionalName: "戈皮納思博多洛伊國際機場",
      },
    ],
  },
  GAX: {
    code: "GAX",
    name: "GAMBA",
    chineseName: "甘巴",
    traditionalName: "甘巴",
    airports: [
      {
        code: "GAX",
        name: "Yenzi",
        chineseName: "甘巴机场",
        traditionalName: "甘巴機場",
      },
    ],
  },
  GAY: {
    code: "GAY",
    name: "GAYA",
    chineseName: "格雅",
    traditionalName: "格雅",
    airports: [
      {
        code: "GAY",
        name: "Gaya airport",
        chineseName: "伽耶机场",
        traditionalName: "伽耶機場",
      },
    ],
  },
  GBE: {
    code: "GBE",
    name: "GABORONE",
    chineseName: "哈博罗内",
    traditionalName: "嘉柏隆里",
    airports: [
      {
        code: "GBE",
        name: "Sir seretse khama intl",
        chineseName: "塞雷策卡马爵士国际机场",
        traditionalName: "塞雷策卡馬爵士國際機場",
      },
    ],
  },
  GBI: {
    code: "GBI",
    name: "GULBARGA",
    chineseName: " 巴哈马大区",
    traditionalName: "巴哈馬大區",
    airports: [
      {
        code: "GBI",
        name: "Kalaburagi",
        chineseName: "卡拉布拉吉机场",
        traditionalName: "卡拉布拉吉機場",
      },
    ],
  },
  GBJ: {
    code: "GBJ",
    name: "MARIE-GALANTE",
    chineseName: "玛丽-加朗特岛",
    traditionalName: "瑪麗-加朗特島",
    airports: [
      {
        code: "GBJ",
        name: "Marie-galante airport",
        chineseName: "玛丽-加朗特岛机场",
        traditionalName: "瑪麗-加朗特島機場",
      },
    ],
  },
  GBL: {
    code: "GBL",
    name: "SOUTH GOULBURN ISLAND",
    chineseName: "古尔本岛",
    traditionalName: "古爾本島",
    airports: [
      {
        code: "GBL",
        name: "South goulburn island airport",
        chineseName: "古尔本岛机场",
        traditionalName: "古爾本島機場",
      },
    ],
  },
  GBT: {
    code: "GBT",
    name: "GORGAN",
    chineseName: "戈尔贡",
    traditionalName: "戈爾貢",
    airports: [
      {
        code: "GBT",
        name: "Gorgan airport",
        chineseName: "戈尔甘机场",
        traditionalName: "戈爾甘機場",
      },
    ],
  },
  GBZ: {
    code: "GBZ",
    name: "GREAT BARRIER ISLAND",
    chineseName: "大屏障岛",
    traditionalName: "大屏障島",
    airports: [
      {
        code: "GBZ",
        name: "Great barrier island airport",
        chineseName: "大屏障岛机场",
        traditionalName: "大屏障島機場",
      },
    ],
  },
  GCC: {
    code: "GCC",
    name: "GILLETTE",
    chineseName: "怀俄明州吉列",
    traditionalName: "懷俄明州吉列",
    airports: [
      {
        code: "GCC",
        name: "Campbell county",
        chineseName: "坎贝尔郡机场",
        traditionalName: "坎貝爾郡機場",
      },
    ],
  },
  GCH: {
    code: "GCH",
    name: "GACHSARAN",
    chineseName: "加奇萨兰",
    traditionalName: "加奇薩蘭",
    airports: [
      {
        code: "GCH",
        name: "Gachsaran airport",
        chineseName: "加奇萨兰机场",
        traditionalName: "加奇薩蘭機場",
      },
    ],
  },
  GCI: {
    code: "GCI",
    name: "GUERNSEY",
    chineseName: "根西岛",
    traditionalName: "根西島",
    airports: [
      {
        code: "GCI",
        name: "Guernsey airport",
        chineseName: "根西岛机场",
        traditionalName: "根西島機場",
      },
    ],
  },
  GCK: {
    code: "GCK",
    name: "GARDEN CITY",
    chineseName: "加登城",
    traditionalName: "加登城",
    airports: [
      {
        code: "GCK",
        name: "Garden city reg. airport",
        chineseName: "加登城地方机场",
        traditionalName: "加登城地方機場",
      },
    ],
  },
  GCM: {
    code: "GCM",
    name: "GRAND CAYMAN",
    chineseName: "大开曼岛",
    traditionalName: "大開曼島",
    airports: [
      {
        code: "GCM",
        name: "Owen roberts intl",
        chineseName: "欧文罗伯茨国际机场",
        traditionalName: "歐文羅伯茨國際機場",
      },
    ],
  },
  GCN: {
    code: "GCN",
    name: "GRAND CANYON",
    chineseName: "大峡谷",
    traditionalName: "大峽谷",
    airports: [
      {
        code: "FLG",
        name: "Flagstaff pulliam",
        chineseName: "费拉格斯塔夫普里阿姆机场",
        traditionalName: "費拉格斯塔夫普裡阿姆機場",
      },
      {
        code: "GCN",
        name: "National park",
        chineseName: "大峡谷机场",
        traditionalName: "大峽谷機場",
      },
    ],
  },
  GCW: {
    code: "GCW",
    name: "GRAND CANYON WEST",
    chineseName: "亚利桑那州Peach Springs",
    traditionalName: "亞利桑那州Peach Springs",
    airports: [
      {
        code: "GCW",
        name: "Grand canyon west airport",
        chineseName: "大峡谷西机场",
        traditionalName: "大峽谷西機場",
      },
    ],
  },
  GDB: {
    code: "GDB",
    name: "GONDIA",
    chineseName: "贡迪亚",
    traditionalName: "貢迪亞",
    airports: [
      {
        code: "GDB",
        name: "Birsi",
        chineseName: "比尔西机场",
        traditionalName: "比爾西機場",
      },
    ],
  },
  GDE: {
    code: "GDE",
    name: "GODE",
    chineseName: "戈德/伊迪多勒",
    traditionalName: "戈德/伊迪多勒",
    airports: [
      {
        code: "GDE",
        name: "Gode airport",
        chineseName: "戈德机场",
        traditionalName: "戈德機場",
      },
    ],
  },
  GDL: {
    code: "GDL",
    name: "GUADALAJARA",
    chineseName: "瓜达拉哈拉",
    traditionalName: "瓜達拉哈拉",
    airports: [
      {
        code: "GDL",
        name: "Miguel hidalgo intl",
        chineseName: "米盖尔伊达尔戈国际机场",
        traditionalName: "米蓋爾伊達爾戈國際機場",
      },
    ],
  },
  GDN: {
    code: "GDN",
    name: "GDANSK",
    chineseName: "格但斯克",
    traditionalName: "格但斯克",
    airports: [
      {
        code: "GDN",
        name: "Lech walesa",
        chineseName: "莱赫瓦文萨机场",
        traditionalName: "萊赫瓦文薩機場",
      },
    ],
  },
  GDQ: {
    code: "GDQ",
    name: "GONDER",
    chineseName: "贡达尔",
    traditionalName: "貢達爾",
    airports: [
      {
        code: "GDQ",
        name: "Azezo",
        chineseName: "贡德尔机场",
        traditionalName: "貢德爾機場",
      },
    ],
  },
  GDT: {
    code: "GDT",
    name: "GRAND TURK",
    chineseName: "大特克岛",
    traditionalName: "大特克島",
    airports: [
      {
        code: "GDT",
        name: "J.a.g.s. mccartney int",
        chineseName: "大特克岛机场",
        traditionalName: "大特克島機場",
      },
    ],
  },
  GDV: {
    code: "GDV",
    name: "GLENDIVE",
    chineseName: "格伦代夫",
    traditionalName: "葛籣代夫",
    airports: [
      {
        code: "GDV",
        name: "Dawson community",
        chineseName: "道森社区机场",
        traditionalName: "道森社區機場",
      },
    ],
  },
  GDX: {
    code: "GDX",
    name: "MAGADAN",
    chineseName: "马加丹",
    traditionalName: "馬加丹",
    airports: [
      {
        code: "GDX",
        name: "Sokol",
        chineseName: "索科机场",
        traditionalName: "索科機場",
      },
    ],
  },
  GEG: {
    code: "GEG",
    name: "SPOKANE",
    chineseName: "斯波坎",
    traditionalName: "斯波坎",
    airports: [
      {
        code: "GEG",
        name: "Spokane intl.",
        chineseName: "斯博肯国际机场",
        traditionalName: "斯博肯國際機場",
      },
    ],
  },
  GEL: {
    code: "GEL",
    name: "SANTO ANGELO",
    chineseName: "圣安格罗",
    traditionalName: "聖安格羅",
    airports: [
      {
        code: "GEL",
        name: "Sepe tiaraju",
        chineseName: "塞普提阿拉乔机场",
        traditionalName: "塞普提阿拉喬機場",
      },
    ],
  },
  GEM: {
    code: "GEM",
    name: "MONGOMO",
    chineseName: "蒙戈莫",
    traditionalName: "蒙戈莫",
    airports: [
      {
        code: "GEM",
        name: "Mongomeyen",
        chineseName: "蒙戈莫亚机场",
        traditionalName: "蒙戈莫亞機場",
      },
    ],
  },
  GEO: {
    code: "GEO",
    name: "GEORGETOWN",
    chineseName: "乔治敦",
    traditionalName: "喬治城",
    airports: [
      {
        code: "GEO",
        name: "Cheddi jagan intl",
        chineseName: "乔治敦国际机场",
        traditionalName: "喬治城國際機場",
      },
      {
        code: "OGL",
        name: "Ogle",
        chineseName: "欧格勒机场",
        traditionalName: "歐格勒機場",
      },
    ],
  },
  GER: {
    code: "GER",
    name: "NUEVA GERONA",
    chineseName: "新赫罗纳",
    traditionalName: "新赫羅納",
    airports: [
      {
        code: "GER",
        name: "Rafael cabrera",
        chineseName: "拉费尔卡布雷拉机场",
        traditionalName: "拉費爾卡布雷拉機場",
      },
    ],
  },
  GES: {
    code: "GES",
    name: "GENERAL SANTOS",
    chineseName: "桑托斯将军城",
    traditionalName: "桑托斯將軍城",
    airports: [
      {
        code: "GES",
        name: "General santos intl.",
        chineseName: "桑托斯将军城机场",
        traditionalName: "桑托斯將軍城機場",
      },
    ],
  },
  GET: {
    code: "GET",
    name: "GERALDTON",
    chineseName: "杰拉尔顿",
    traditionalName: "傑拉爾頓",
    airports: [
      {
        code: "GET",
        name: "Geraldton airport",
        chineseName: "杰拉尔顿机场",
        traditionalName: "傑拉爾頓機場",
      },
    ],
  },
  GEV: {
    code: "GEV",
    name: "GALLIVARE",
    chineseName: "耶利瓦勒",
    traditionalName: "耶利瓦勒",
    airports: [
      {
        code: "GEV",
        name: "Gallivare airport",
        chineseName: "耶利瓦勒机场",
        traditionalName: "耶利瓦勒機場",
      },
    ],
  },
  GFF: {
    code: "GFF",
    name: "GRIFFITH",
    chineseName: "格里菲斯",
    traditionalName: "格里菲斯",
    airports: [
      {
        code: "GFF",
        name: "Griffith airport",
        chineseName: "格里菲斯机场",
        traditionalName: "格里菲斯機場",
      },
    ],
  },
  GFK: {
    code: "GFK",
    name: "GRAND FORKS",
    chineseName: "大福克斯",
    traditionalName: "大福克斯",
    airports: [
      {
        code: "GFK",
        name: "Grand forks intl.",
        chineseName: "大福克斯国际机场",
        traditionalName: "大福克斯國際機場",
      },
    ],
  },
  GGG: {
    code: "GGG",
    name: "LONGVIEW",
    chineseName: "朗维尤",
    traditionalName: "朗維尤",
    airports: [
      {
        code: "GGG",
        name: "East texas regional",
        chineseName: "德克萨斯东部地区机场",
        traditionalName: "德克薩斯東部地區機場",
      },
    ],
  },
  GGJ: {
    code: "GGJ",
    name: "GUAIRA",
    chineseName: "瓜伊拉",
    traditionalName: "瓜伊拉",
    airports: [
      {
        code: "GGJ",
        name: "Guaira airport",
        chineseName: "瓜伊拉机场",
        traditionalName: "瓜伊拉機場",
      },
    ],
  },
  GGM: {
    code: "GGM",
    name: "KAKAMEGA",
    chineseName: "卡卡梅加",
    traditionalName: "卡卡梅加",
    airports: [
      {
        code: "GGM",
        name: "Kakamega airport",
        chineseName: "卡卡梅加机场",
        traditionalName: "卡卡梅加機場",
      },
    ],
  },
  GGR: {
    code: "GGR",
    name: "GAROWE",
    chineseName: "加洛威",
    traditionalName: "加洛威",
    airports: [
      {
        code: "GGR",
        name: "Garowe airport",
        chineseName: "加罗机场",
        traditionalName: "加羅機場",
      },
    ],
  },
  GGT: {
    code: "GGT",
    name: "GEORGE TOWN",
    chineseName: "乔治镇",
    traditionalName: "喬治鎮",
    airports: [
      {
        code: "GGT",
        name: "Exuma international",
        chineseName: "伊苏马国际机场",
        traditionalName: "伊蘇馬國際機場",
      },
    ],
  },
  GGW: {
    code: "GGW",
    name: "GLASGOW",
    chineseName: "格拉斯哥",
    traditionalName: "格拉斯哥",
    airports: [
      {
        code: "GGW",
        name: "Glasgow intl.",
        chineseName: "格拉斯哥国际机场",
        traditionalName: "格拉斯哥國際機場",
      },
    ],
  },
  GHA: {
    code: "GHA",
    name: "GHARDAIA",
    chineseName: "盖尔达耶",
    traditionalName: "蓋爾特耶",
    airports: [
      {
        code: "GHA",
        name: "Noumerat",
        chineseName: "诺梅拉特机场",
        traditionalName: "諾梅拉特機場",
      },
    ],
  },
  GHB: {
    code: "GHB",
    name: "GOVERNOR'S HARBOUR",
    chineseName: "总督港",
    traditionalName: "總督港",
    airports: [
      {
        code: "GHB",
        name: "Governor's harbour airport",
        chineseName: "戈韦诺港机场",
        traditionalName: "戈韋諾港機場",
      },
    ],
  },
  GHC: {
    code: "GHC",
    name: "GREAT HARBOUR CAY",
    chineseName: "大港岛",
    traditionalName: "大港島",
    airports: [
      {
        code: "GHC",
        name: "Great harbour cay airport",
        chineseName: "大港岛机场",
        traditionalName: "大港島機場",
      },
    ],
  },
  GHS: {
    code: "GHS",
    name: "WEST KUTAI",
    chineseName: "西库泰",
    traditionalName: "西庫泰",
    airports: [
      {
        code: "GHS",
        name: "Melalan",
        chineseName: "马六甲机场",
        traditionalName: "麻六甲機場",
      },
    ],
  },
  GHV: {
    code: "GHV",
    name: "BRASOV",
    chineseName: "布拉索夫",
    traditionalName: "布拉索夫",
    airports: [
      {
        code: "GHV",
        name: "Ghimbav brasov",
        chineseName: "布拉索夫-金巴夫国际机场",
        traditionalName: "布拉索夫-金巴夫國際機場",
      },
    ],
  },
  GIB: {
    code: "GIB",
    name: "GIBRALTAR",
    chineseName: "直布罗陀",
    traditionalName: "直布羅陀",
    airports: [
      {
        code: "GIB",
        name: "Gibraltar airport",
        chineseName: "直布罗陀机场",
        traditionalName: "直布羅陀機場",
      },
    ],
  },
  GIC: {
    code: "GIC",
    name: "BOIGU ISLAND",
    chineseName: "博伊古岛",
    traditionalName: "博伊古島",
    airports: [
      {
        code: "GIC",
        name: "Boigu island airport",
        chineseName: "博伊古岛机场",
        traditionalName: "博伊古島機場",
      },
    ],
  },
  GII: {
    code: "GII",
    name: "SIGUIRI",
    chineseName: "锡吉里",
    traditionalName: "錫吉裡",
    airports: [
      {
        code: "GII",
        name: "Siguiri airport",
        chineseName: "锡吉里机场",
        traditionalName: "錫吉裡機場",
      },
    ],
  },
  GIL: {
    code: "GIL",
    name: "GILGIT",
    chineseName: "吉尔吉特",
    traditionalName: "吉爾吉特",
    airports: [
      {
        code: "GIL",
        name: "Gilgit airport",
        chineseName: "吉尔吉特机场",
        traditionalName: "吉爾吉特機場",
      },
    ],
  },
  GIS: {
    code: "GIS",
    name: "GISBORNE",
    chineseName: "吉斯伯恩",
    traditionalName: "吉斯伯恩",
    airports: [
      {
        code: "GIS",
        name: "Gisborne airport",
        chineseName: "吉斯伯恩机场",
        traditionalName: "吉斯伯恩機場",
      },
    ],
  },
  GIT: {
    code: "GIT",
    name: "GEITA",
    chineseName: "盖塔",
    traditionalName: "蓋塔",
    airports: [
      {
        code: "GIT",
        name: "Geita airport",
        chineseName: "盖塔机场",
        traditionalName: "蓋塔機場",
      },
    ],
  },
  GIU: {
    code: "GIU",
    name: "SIGIRIYA",
    chineseName: "锡吉里耶",
    traditionalName: "錫吉裏耶",
    airports: [
      {
        code: "GIU",
        name: "Sigiriya airport",
        chineseName: "锡吉里耶机场",
        traditionalName: "錫吉裡耶機場",
      },
    ],
  },
  GIZ: {
    code: "GIZ",
    name: "GIZAN",
    chineseName: "贾赞",
    traditionalName: "賈贊",
    airports: [
      {
        code: "GIZ",
        name: "Gizan airport",
        chineseName: "吉赞机场",
        traditionalName: "吉贊機場",
      },
    ],
  },
  GJA: {
    code: "GJA",
    name: "GUANAJA",
    chineseName: "瓜纳贾",
    traditionalName: "瓜納賈",
    airports: [
      {
        code: "GJA",
        name: "Guanaja airport",
        chineseName: "瓜纳哈机场",
        traditionalName: "瓜納哈機場",
      },
    ],
  },
  GJL: {
    code: "GJL",
    name: "JIJEL",
    chineseName: "吉杰勒",
    traditionalName: "吉傑勒",
    airports: [
      {
        code: "GJL",
        name: "Ferhat abbas",
        chineseName: "费尔哈特阿巴斯机场",
        traditionalName: "費爾哈特阿巴斯機場",
      },
    ],
  },
  GJT: {
    code: "GJT",
    name: "GRAND JUNCTION",
    chineseName: "大章克申",
    traditionalName: "大章克興",
    airports: [
      {
        code: "GJT",
        name: "Grand junction reg. airport",
        chineseName: "大章克申机场",
        traditionalName: "大章克興機場",
      },
    ],
  },
  GKA: {
    code: "GKA",
    name: "GOROKA",
    chineseName: "戈罗卡",
    traditionalName: "戈羅卡",
    airports: [
      {
        code: "GKA",
        name: "Goroka airport",
        chineseName: "戈罗卡机场",
        traditionalName: "戈羅卡機場",
      },
    ],
  },
  GKE: {
    code: "GKE",
    name: "GEILENKIRCHEN",
    chineseName: "盖伦基兴",
    traditionalName: "蓋倫基興",
    airports: [
      {
        code: "GKE",
        name: "Air base",
        chineseName: "盖伦基兴机场",
        traditionalName: "蓋倫基興機場",
      },
    ],
  },
  GKK: {
    code: "GKK",
    name: "KOODDOO ISLAND",
    chineseName: "库兜岛",
    traditionalName: "庫兜島",
    airports: [
      {
        code: "GKK",
        name: "Kooddoo island airport",
        chineseName: "库多机场",
        traditionalName: "庫多機場",
      },
    ],
  },
  GKN: {
    code: "GKN",
    name: "GULKANA",
    chineseName: "格尔卡纳",
    traditionalName: "格爾卡納",
    airports: [
      {
        code: "GKN",
        name: "Gulkana airport",
        chineseName: "格尔卡纳机场",
        traditionalName: "格爾卡納機場",
      },
    ],
  },
  GLA: {
    code: "GLA",
    name: "GLASGOW",
    chineseName: "格拉斯哥",
    traditionalName: "格拉斯哥",
    airports: [
      {
        code: "GLA",
        name: "Glasgow intl.",
        chineseName: "格拉斯哥机场",
        traditionalName: "格拉斯哥機場",
      },
      {
        code: "PIK",
        name: "Prestwick",
        chineseName: "普雷斯特维克机场",
        traditionalName: "普雷斯特維克機場",
      },
    ],
  },
  GLF: {
    code: "GLF",
    name: "GOLFITO",
    chineseName: "戈尔菲托机场",
    traditionalName: "戈爾菲托機場",
    airports: [
      {
        code: "GLF",
        name: "Golfito airport",
        chineseName: "戈尔菲托机场",
        traditionalName: "戈爾菲托機場",
      },
    ],
  },
  GLH: {
    code: "GLH",
    name: "GREENVILLE",
    chineseName: "格林维尔",
    traditionalName: "格林維爾",
    airports: [
      {
        code: "GLH",
        name: "Mid-delta",
        chineseName: "格林维尔机场",
        traditionalName: "格林維爾機場",
      },
    ],
  },
  GLK: {
    code: "GLK",
    name: "GALCAIO",
    chineseName: "加勒卡约",
    traditionalName: "加勒卡約",
    airports: [
      {
        code: "GLK",
        name: "Galcaio airport",
        chineseName: "加尔卡尤机场",
        traditionalName: "加爾卡尤機場",
      },
    ],
  },
  GLN: {
    code: "GLN",
    name: "GUELMIME",
    chineseName: "古利明",
    traditionalName: "古利明",
    airports: [
      {
        code: "GLN",
        name: "Guelmime airport",
        chineseName: "盖勒敏机场",
        traditionalName: "蓋勒敏機場",
      },
    ],
  },
  GLO: {
    code: "GLO",
    name: "GLOUCESTER/CHELTENHAM",
    chineseName: "格洛斯特",
    traditionalName: "格洛斯特",
    airports: [
      {
        code: "GLO",
        name: "Gloucestershire",
        chineseName: "格洛斯特郡机场",
        traditionalName: "格洛斯特郡機場",
      },
    ],
  },
  GLT: {
    code: "GLT",
    name: "GLADSTONE",
    chineseName: "格拉德斯通",
    traditionalName: "格拉德斯通",
    airports: [
      {
        code: "GLT",
        name: "Gladstone airport",
        chineseName: "格拉德斯通机场",
        traditionalName: "格拉德斯通機場",
      },
    ],
  },
  GLU: {
    code: "GLU",
    name: "GELEPHU",
    chineseName: "格勒铺",
    traditionalName: "格勒鋪",
    airports: [
      {
        code: "GLU",
        name: "Gelephu airport",
        chineseName: "吉列普机场",
        traditionalName: "吉列普機場",
      },
    ],
  },
  GLV: {
    code: "GLV",
    name: "GOLOVIN",
    chineseName: "阿拉斯加州戈洛温",
    traditionalName: "阿拉斯加州戈洛溫",
    airports: [
      {
        code: "GLV",
        name: "Golovin airport",
        chineseName: "戈洛文机场",
        traditionalName: "戈洛文機場",
      },
    ],
  },
  GMA: {
    code: "GMA",
    name: "GEMENA",
    chineseName: "盖梅纳",
    traditionalName: "蓋梅納",
    airports: [
      {
        code: "GMA",
        name: "Gemena airport",
        chineseName: "盖梅纳机场",
        traditionalName: "蓋梅納機場",
      },
    ],
  },
  GMB: {
    code: "GMB",
    name: "GAMBELA",
    chineseName: "甘贝拉",
    traditionalName: "甘貝拉",
    airports: [
      {
        code: "GMB",
        name: "Gambela airport",
        chineseName: "甘贝拉机场",
        traditionalName: "甘貝拉機場",
      },
    ],
  },
  GME: {
    code: "GME",
    name: "GOMEL",
    chineseName: "戈梅尔",
    traditionalName: "戈梅爾",
    airports: [
      {
        code: "GME",
        name: "Gomel airport",
        chineseName: "戈梅利机场",
        traditionalName: "戈梅利機場",
      },
    ],
  },
  GMO: {
    code: "GMO",
    name: "GOMBE",
    chineseName: "贡贝拉旺提",
    traditionalName: "貢貝拉旺提",
    airports: [
      {
        code: "GMO",
        name: "Lawanti",
        chineseName: "拉旺提机场",
        traditionalName: "拉旺提機場",
      },
    ],
  },
  GMQ: {
    code: "GMQ",
    name: "GOLOG",
    chineseName: "果洛",
    traditionalName: "果洛",
    airports: [
      {
        code: "GMQ",
        name: "Maqin",
        chineseName: "玛沁机场",
        traditionalName: "瑪沁機場",
      },
    ],
  },
  GMR: {
    code: "GMR",
    name: "GAMBIER",
    chineseName: "甘比尔岛",
    traditionalName: "甘比爾島",
    airports: [
      {
        code: "GMR",
        name: "Totegegie",
        chineseName: "托特格杰岛机场",
        traditionalName: "托特格傑島機場",
      },
    ],
  },
  GMZ: {
    code: "GMZ",
    name: "SAN SEBASTIAN/GOMERA",
    chineseName: "圣塞巴斯蒂安/哥麦那岛",
    traditionalName: "聖塞巴斯蒂安/哥麥那島",
    airports: [
      {
        code: "GMZ",
        name: "La gomera",
        chineseName: "拉戈梅拉机场",
        traditionalName: "拉戈梅拉機場",
      },
    ],
  },
  GND: {
    code: "GND",
    name: "GRENADA",
    chineseName: "圣乔治",
    traditionalName: "聖喬治",
    airports: [
      {
        code: "GND",
        name: "Maurice bishop intl",
        chineseName: "莫里斯比绍普国际机场",
        traditionalName: "莫里斯比索普國際機場",
      },
    ],
  },
  GNI: {
    code: "GNI",
    name: "LYUDAO (GREEN ISLAND)",
    chineseName: "绿岛",
    traditionalName: "綠島",
    airports: [
      {
        code: "GNI",
        name: "Lyudao (green island) airport",
        chineseName: "绿岛机场",
        traditionalName: "綠島機場",
      },
    ],
  },
  GNM: {
    code: "GNM",
    name: "GUANAMBI",
    chineseName: "瓜南比",
    traditionalName: "瓜南比",
    airports: [
      {
        code: "GNM",
        name: "Guanambi airport",
        chineseName: "瓜南比瓜南比机场",
        traditionalName: "瓜南比瓜南比機場",
      },
    ],
  },
  GNS: {
    code: "GNS",
    name: "GUNUNG SITOLI",
    chineseName: "古农西托利",
    traditionalName: "古農西托利",
    airports: [
      {
        code: "GNS",
        name: "Binaka",
        chineseName: "古农西托利机场",
        traditionalName: "古農西托利機場",
      },
    ],
  },
  GNU: {
    code: "GNU",
    name: "GOODNEWS BAY",
    chineseName: "古德纽斯贝",
    traditionalName: "古德紐斯貝",
    airports: [
      {
        code: "GNU",
        name: "Goodnews bay airport",
        chineseName: "古德纽斯贝机场",
        traditionalName: "古德紐斯貝機場",
      },
    ],
  },
  GNV: {
    code: "GNV",
    name: "GAINESVILLE",
    chineseName: "盖恩斯维尔",
    traditionalName: "基因斯維爾",
    airports: [
      {
        code: "GNV",
        name: "Gainesville reg. airport",
        chineseName: "盖恩斯维尔地区机场",
        traditionalName: "基因斯維爾地區機場",
      },
    ],
  },
  GOA: {
    code: "GOA",
    name: "GENOA",
    chineseName: "热那亚",
    traditionalName: "熱那亞",
    airports: [
      {
        code: "GOA",
        name: "Cristoforo colombo",
        chineseName: "克里斯托弗哥伦布国际机场",
        traditionalName: "克裏斯托弗哥倫布國際機場",
      },
    ],
  },
  GOB: {
    code: "GOB",
    name: "GOBA",
    chineseName: "戈巴",
    traditionalName: "戈巴",
    airports: [
      {
        code: "GOB",
        name: "Robe",
        chineseName: "戈巴机场",
        traditionalName: "戈巴機場",
      },
    ],
  },
  GOH: {
    code: "GOH",
    name: "NUUK",
    chineseName: "努克",
    traditionalName: "努克",
    airports: [
      {
        code: "GOH",
        name: "Nuuk airport",
        chineseName: "努特机场",
        traditionalName: "努特機場",
      },
    ],
  },
  GOI: {
    code: "GOI",
    name: "GOA",
    chineseName: "果阿",
    traditionalName: "果阿",
    airports: [
      {
        code: "GOI",
        name: "Dabolim",
        chineseName: "达博里姆机场",
        traditionalName: "達博裏姆機場",
      },
      {
        code: "GOX",
        name: "Mopa airport",
        chineseName: "莫帕机场",
        traditionalName: "莫帕機場",
      },
    ],
  },
  GOJ: {
    code: "GOJ",
    name: "NIZHNY NOVGOROD",
    chineseName: "下诺夫哥罗德",
    traditionalName: "下諾夫哥羅德",
    airports: [
      {
        code: "GOJ",
        name: "Strigino",
        chineseName: "下诺夫哥罗德机场",
        traditionalName: "下諾夫哥羅德機場",
      },
    ],
  },
  GOM: {
    code: "GOM",
    name: "GOMA",
    chineseName: "戈马",
    traditionalName: "戈馬",
    airports: [
      {
        code: "GOM",
        name: "Goma intl.",
        chineseName: "戈马国际机场",
        traditionalName: "戈馬國際機場",
      },
    ],
  },
  GOP: {
    code: "GOP",
    name: "GORAKHPUR",
    chineseName: "戈勒克布尔",
    traditionalName: "戈勒克布林",
    airports: [
      {
        code: "GOP",
        name: "Gorakhpur airport",
        chineseName: "戈勒克布尔机场",
        traditionalName: "戈勒克布林機場",
      },
    ],
  },
  GOQ: {
    code: "GOQ",
    name: "GOLMUD",
    chineseName: "格尔木",
    traditionalName: "格爾木",
    airports: [
      {
        code: "GOQ",
        name: "Golmud airport",
        chineseName: "格尔木机场",
        traditionalName: "格爾木機場",
      },
    ],
  },
  GOT: {
    code: "GOT",
    name: "GOTEBORG",
    chineseName: "哥德堡",
    traditionalName: "哥德堡",
    airports: [
      {
        code: "GOT",
        name: "Landvetter",
        chineseName: "哥德堡机场",
        traditionalName: "哥德堡機場",
      },
      {
        code: "GSE",
        name: "City airport",
        chineseName: "歌德堡城机场",
        traditionalName: "歌德堡城機場",
      },
    ],
  },
  GOU: {
    code: "GOU",
    name: "GAROUA",
    chineseName: "加鲁阿",
    traditionalName: "加魯阿",
    airports: [
      {
        code: "GOU",
        name: "Garoua intl.",
        chineseName: "加鲁阿国际机场",
        traditionalName: "加魯阿國際機場",
      },
    ],
  },
  GOV: {
    code: "GOV",
    name: "NHULUNBUY",
    chineseName: "戈夫",
    traditionalName: "戈夫",
    airports: [
      {
        code: "GOV",
        name: "Gove",
        chineseName: "戈夫机场",
        traditionalName: "戈夫機場",
      },
    ],
  },
  GOY: {
    code: "GOY",
    name: "TURA",
    chineseName: "图拉",
    traditionalName: "圖拉",
    airports: [
      {
        code: "GOY",
        name: "Tura gornij",
        chineseName: "加尔河机场",
        traditionalName: "加爾河機場",
      },
    ],
  },
  GPA: {
    code: "GPA",
    name: "PATRAI",
    chineseName: "帕特雷",
    traditionalName: "派特雷",
    airports: [
      {
        code: "GPA",
        name: "Araxos",
        chineseName: "阿拉克绍斯机场",
        traditionalName: "阿拉克紹斯機場",
      },
    ],
  },
  GPB: {
    code: "GPB",
    name: "GUARAPUAVA",
    chineseName: "瓜拉普阿瓦",
    traditionalName: "瓜拉普阿瓦",
    airports: [
      {
        code: "GPB",
        name: "T.thomas de faria",
        chineseName: "瓜拉普阿瓦机场",
        traditionalName: "瓜拉普阿瓦機場",
      },
    ],
  },
  GPI: {
    code: "GPI",
    name: "GUAPI",
    chineseName: "瓜比",
    traditionalName: "瓜比",
    airports: [
      {
        code: "GPI",
        name: "Juan casiano",
        chineseName: "瓜比机场",
        traditionalName: "瓜比機場",
      },
    ],
  },
  GPN: {
    code: "GPN",
    name: "GARDEN POINT",
    chineseName: "加登波因特",
    traditionalName: "加登波因特",
    airports: [
      {
        code: "GPN",
        name: "Garden point airport",
        chineseName: "加登波因特机场",
        traditionalName: "加登波因特機場",
      },
    ],
  },
  GPS: {
    code: "GPS",
    name: "BALTRA ISLAND",
    chineseName: "巴尔特拉岛",
    traditionalName: "巴爾特拉島",
    airports: [
      {
        code: "GPS",
        name: "Seymour",
        chineseName: "西摩机场",
        traditionalName: "西摩機場",
      },
    ],
  },
  GPT: {
    code: "GPT",
    name: "GULFPORT/BILOXI",
    chineseName: "格尔夫波特",
    traditionalName: "格爾夫波特",
    airports: [
      {
        code: "GPT",
        name: "Gulfport/biloxi intl.",
        chineseName: "格尔夫波特比罗西国际机场",
        traditionalName: "格爾夫波特比羅西國際機場",
      },
    ],
  },
  GRB: {
    code: "GRB",
    name: "GREEN BAY",
    chineseName: "格林贝",
    traditionalName: "格林貝",
    airports: [
      {
        code: "GRB",
        name: "Austin straubel intl",
        chineseName: "奥斯汀斯特劳贝尔机场",
        traditionalName: "奧斯汀斯特勞貝爾機場",
      },
    ],
  },
  GRI: {
    code: "GRI",
    name: "GRAND ISLAND",
    chineseName: "格兰德岛",
    traditionalName: "格蘭德島",
    airports: [
      {
        code: "GRI",
        name: "Central nebraska rgnl",
        chineseName: "内布拉斯加中央机场",
        traditionalName: "內布拉斯加中央機場",
      },
    ],
  },
  GRJ: {
    code: "GRJ",
    name: "GEORGE",
    chineseName: "南非乔治",
    traditionalName: "南非喬治",
    airports: [
      {
        code: "GRJ",
        name: "George airport",
        chineseName: "乔治机场",
        traditionalName: "喬治機場",
      },
    ],
  },
  GRL: {
    code: "GRL",
    name: "GARASA",
    chineseName: "加拉萨",
    traditionalName: "加拉薩",
    airports: [
      {
        code: "GRL",
        name: "Garasa airport",
        chineseName: "加拉萨机场",
        traditionalName: "加拉薩機場",
      },
    ],
  },
  GRO: {
    code: "GRO",
    name: "GIRONA",
    chineseName: "赫罗纳",
    traditionalName: "赫羅納",
    airports: [
      {
        code: "GRO",
        name: "Costa brava",
        chineseName: "科斯塔布拉瓦机场",
        traditionalName: "科斯塔布拉瓦機場",
      },
    ],
  },
  GRQ: {
    code: "GRQ",
    name: "GRONINGEN",
    chineseName: "格罗宁根",
    traditionalName: "格羅寧根",
    airports: [
      {
        code: "GRQ",
        name: "Eelde",
        chineseName: "埃尔德机场",
        traditionalName: "埃爾德機場",
      },
    ],
  },
  GRR: {
    code: "GRR",
    name: "GRAND RAPIDS",
    chineseName: "大溪城",
    traditionalName: "大溪城",
    airports: [
      {
        code: "GRR",
        name: "Gerald r. ford intl",
        chineseName: "杰拉德福特国际机场",
        traditionalName: "傑拉德福特國際機場",
      },
    ],
  },
  GRV: {
    code: "GRV",
    name: "GROZNY",
    chineseName: "格罗兹尼",
    traditionalName: "格羅茲尼",
    airports: [
      {
        code: "GRV",
        name: "Grozny airport",
        chineseName: "格罗兹尼机场",
        traditionalName: "格羅茲尼機場",
      },
    ],
  },
  GRW: {
    code: "GRW",
    name: "GRACIOSA ISLAND",
    chineseName: "格拉西奥萨岛",
    traditionalName: "格拉西奧薩島",
    airports: [
      {
        code: "GRW",
        name: "Graciosa island airport",
        chineseName: "格拉西奥萨岛机场",
        traditionalName: "格拉西奧薩島機場",
      },
    ],
  },
  GRX: {
    code: "GRX",
    name: "GRANADA",
    chineseName: "格拉纳达",
    traditionalName: "格拉納達",
    airports: [
      {
        code: "GRX",
        name: "Federico garcia lorca",
        chineseName: "格拉纳达机场",
        traditionalName: "格拉納達機場",
      },
    ],
  },
  GRZ: {
    code: "GRZ",
    name: "GRAZ",
    chineseName: "格拉茨",
    traditionalName: "格拉茨",
    airports: [
      {
        code: "GRZ",
        name: "Graz airport",
        chineseName: "格拉兹机场",
        traditionalName: "格拉茲機場",
      },
    ],
  },
  GSM: {
    code: "GSM",
    name: "GHESHM ISLAND",
    chineseName: "格什姆岛",
    traditionalName: "格什姆島",
    airports: [
      {
        code: "GSM",
        name: "Dayrestan",
        chineseName: "格施姆机场",
        traditionalName: "格施姆機場",
      },
    ],
  },
  GSO: {
    code: "GSO",
    name: "GREENSBORO/HIGH POINT",
    chineseName: "格林斯伯勒",
    traditionalName: "格林斯伯勒",
    airports: [
      {
        code: "GSO",
        name: "Piedmont triad intl",
        chineseName: "皮德蒙特国际机场",
        traditionalName: "皮德蒙特國際機場",
      },
    ],
  },
  GSP: {
    code: "GSP",
    name: "GREENVILLE/SPARTANBURG",
    chineseName: "格林维尔",
    traditionalName: "格林維爾",
    airports: [
      {
        code: "GSP",
        name: "Greenville/spartanburg intl.",
        chineseName: "格林威尔机场",
        traditionalName: "格林威爾機場",
      },
    ],
  },
  GST: {
    code: "GST",
    name: "GUSTAVUS",
    chineseName: "古斯塔夫斯",
    traditionalName: "古斯塔夫斯",
    airports: [
      {
        code: "GST",
        name: "Gustavus airport",
        chineseName: "古斯塔夫斯机场",
        traditionalName: "古斯塔夫斯機場",
      },
    ],
  },
  GTE: {
    code: "GTE",
    name: "GROOTE EYLANDT",
    chineseName: "格鲁特岛",
    traditionalName: "格魯特島",
    airports: [
      {
        code: "GTE",
        name: "Groote eylandt airport",
        chineseName: "格鲁特岛机场",
        traditionalName: "格魯特島機場",
      },
    ],
  },
  GTF: {
    code: "GTF",
    name: "GREAT FALLS",
    chineseName: "格雷特瀑布",
    traditionalName: "格雷特瀑布",
    airports: [
      {
        code: "GTF",
        name: "Great falls intl.",
        chineseName: "大瀑布城国际机场",
        traditionalName: "大瀑布城國際機場",
      },
    ],
  },
  GTO: {
    code: "GTO",
    name: "GORONTALO",
    chineseName: "哥伦打洛",
    traditionalName: "哥倫打洛",
    airports: [
      {
        code: "GTO",
        name: "Djalaluddin",
        chineseName: "特洛提奥机场",
        traditionalName: "特洛提奧機場",
      },
    ],
  },
  GTP: {
    code: "GTP",
    name: "GRANTS PASS",
    chineseName: "格兰茨帕斯",
    traditionalName: "格蘭茨帕斯",
    airports: [
      {
        code: "GTP",
        name: "Grants pass airport",
        chineseName: "格兰茨帕斯机场",
        traditionalName: "格蘭茨帕斯機場",
      },
    ],
  },
  GTS: {
    code: "GTS",
    name: "THE GRANITES",
    chineseName: "格兰特维尔",
    traditionalName: "格蘭特維爾",
    airports: [
      {
        code: "GTS",
        name: "The granites airport",
        chineseName: "格拉尼特斯机场",
        traditionalName: "格拉尼特斯機場",
      },
    ],
  },
  GTZ: {
    code: "GTZ",
    name: "GRUMETI",
    chineseName: "格鲁美地",
    traditionalName: "格魯美地",
    airports: [
      {
        code: "GTZ",
        name: "Kirawira b",
        chineseName: "Kirawira B机场",
        traditionalName: "Kirawira B機場",
      },
    ],
  },
  GUA: {
    code: "GUA",
    name: "GUATEMALA CITY",
    chineseName: "危地马拉城",
    traditionalName: "瓜地馬拉城",
    airports: [
      {
        code: "GUA",
        name: "La aurora intl",
        chineseName: "拉奥罗拉国际机场",
        traditionalName: "拉奧羅拉國際機場",
      },
    ],
  },
  GUC: {
    code: "GUC",
    name: "GUNNISON",
    chineseName: "甘尼森",
    traditionalName: "甘尼森",
    airports: [
      {
        code: "GUC",
        name: "Gunnison-crested butte",
        chineseName: "甘尼森机场",
        traditionalName: "甘尼森機場",
      },
    ],
  },
  GUF: {
    code: "GUF",
    name: "GULF SHORES",
    chineseName: "格尔夫肖尔斯",
    traditionalName: "格爾夫肖爾斯",
    airports: [
      {
        code: "GUF",
        name: "Jack edwards",
        chineseName: "格尔夫绍尔斯机场",
        traditionalName: "格爾夫紹爾斯機場",
      },
    ],
  },
  GUM: {
    code: "GUM",
    name: "GUAM",
    chineseName: "关岛",
    traditionalName: "關島",
    airports: [
      {
        code: "GUM",
        name: "A.b. won pat intl",
        chineseName: "安东尼奥汪帕特国际机场",
        traditionalName: "安東尼奧汪派特國際機場",
      },
    ],
  },
  GUO: {
    code: "GUO",
    name: "GURIEL",
    chineseName: "瓜拉科",
    traditionalName: "瓜拉科",
    airports: [
      {
        code: "GUO",
        name: "Guriel airport",
        chineseName: "古里艾机场",
        traditionalName: "古裡艾機場",
      },
    ],
  },
  GUP: {
    code: "GUP",
    name: "GALLUP",
    chineseName: "盖洛普",
    traditionalName: "蓋洛普",
    airports: [
      {
        code: "GUP",
        name: "Gallup municipal",
        chineseName: "盖洛普机场",
        traditionalName: "蓋洛普機場",
      },
    ],
  },
  GUR: {
    code: "GUR",
    name: "ALOTAU",
    chineseName: "阿洛陶",
    traditionalName: "阿洛陶",
    airports: [
      {
        code: "GUR",
        name: "Gurney",
        chineseName: "古尔内机场",
        traditionalName: "古爾內機場",
      },
    ],
  },
  GUW: {
    code: "GUW",
    name: "ATYRAU",
    chineseName: "阿特劳",
    traditionalName: "阿特勞",
    airports: [
      {
        code: "GUW",
        name: "Atyrau airport",
        chineseName: "阿特劳机场",
        traditionalName: "阿特勞機場",
      },
    ],
  },
  GVA: {
    code: "GVA",
    name: "GENEVA",
    chineseName: "日内瓦",
    traditionalName: "日內瓦",
    airports: [
      {
        code: "GVA",
        name: "Geneva intl.",
        chineseName: "日内瓦机场",
        traditionalName: "日內瓦機場",
      },
    ],
  },
  GVN: {
    code: "GVN",
    name: "SOVETSKAYA GAVAN",
    chineseName: "Sovetskaya加万",
    traditionalName: "Sovetskaya加萬",
    airports: [
      {
        code: "GVN",
        name: "May-gatka",
        chineseName: "索维斯卡亚格万机场",
        traditionalName: "索維斯卡亞格萬機場",
      },
    ],
  },
  GVR: {
    code: "GVR",
    name: "GOVERNADOR VALADARES",
    chineseName: "瓦拉达里斯州长市",
    traditionalName: "瓦拉達裡斯州長市",
    airports: [
      {
        code: "GVR",
        name: "A.machado oliveira",
        chineseName: "瓦拉达里斯州长市机场",
        traditionalName: "瓦拉達裡斯州長市機場",
      },
    ],
  },
  GWD: {
    code: "GWD",
    name: "GWADAR",
    chineseName: "瓜德尔",
    traditionalName: "瓜德爾",
    airports: [
      {
        code: "GWD",
        name: "Gwadar intl.",
        chineseName: "瓜德尔机场",
        traditionalName: "瓜德爾機場",
      },
    ],
  },
  GWL: {
    code: "GWL",
    name: "GWALIOR",
    chineseName: "瓜廖尔",
    traditionalName: "瓜廖爾",
    airports: [
      {
        code: "GWL",
        name: "Gwalior airport",
        chineseName: "瓜廖尔机场",
        traditionalName: "瓜廖爾機場",
      },
    ],
  },
  GWT: {
    code: "GWT",
    name: "WESTERLAND",
    chineseName: "叙尔特岛",
    traditionalName: "敘爾特島",
    airports: [
      {
        code: "GWT",
        name: "Sylt",
        chineseName: "希尔特机场",
        traditionalName: "希爾特機場",
      },
    ],
  },
  GXA: {
    code: "GXA",
    name: "MUARA TEWEH",
    chineseName: "Muara Teweh",
    traditionalName: "Muara Teweh",
    airports: [
      {
        code: "HMS",
        name: "Haji muhammad sidik",
        chineseName: "Homeshore Airport机场",
        traditionalName: "Homeshore Airport機場",
      },
    ],
  },
  GXF: {
    code: "GXF",
    name: "SAYUN",
    chineseName: "萨云",
    traditionalName: "薩雲",
    airports: [
      {
        code: "GXF",
        name: "Sayun airport",
        chineseName: "塞云机场",
        traditionalName: "塞雲機場",
      },
    ],
  },
  GXH: {
    code: "GXH",
    name: "XIAHE",
    chineseName: "甘南",
    traditionalName: "甘南",
    airports: [
      {
        code: "GXH",
        name: "Gannan xiahe",
        chineseName: "甘南夏河机场",
        traditionalName: "甘南夏河機場",
      },
    ],
  },
  GYA: {
    code: "GYA",
    name: "GUAYARAMERIN",
    chineseName: "瓜亚拉梅林",
    traditionalName: "瓜亞拉梅林",
    airports: [
      {
        code: "GYA",
        name: "Guayaramerin airport",
        chineseName: "瓜亚拉梅林机场",
        traditionalName: "瓜亞拉梅林機場",
      },
    ],
  },
  GYE: {
    code: "GYE",
    name: "GUAYAQUIL",
    chineseName: "瓜亚基尔",
    traditionalName: "瓜亞基爾",
    airports: [
      {
        code: "GYE",
        name: "Jose joaquin de olmedo",
        chineseName: "何塞华金奥尔梅多国际机场",
        traditionalName: "何塞華金奧爾梅多國際機場",
      },
    ],
  },
  GYL: {
    code: "GYL",
    name: "ARGYLE",
    chineseName: "阿尔吉勒",
    traditionalName: "阿爾吉勒",
    airports: [
      {
        code: "GYL",
        name: "Argyle airport",
        chineseName: "阿盖尔机场",
        traditionalName: "阿蓋爾機場",
      },
    ],
  },
  GYN: {
    code: "GYN",
    name: "GOIANIA",
    chineseName: "戈亚尼亚",
    traditionalName: "戈亞納",
    airports: [
      {
        code: "GYN",
        name: "Santa genoveva",
        chineseName: "圣塔格诺维瓦机场",
        traditionalName: "聖塔格諾維瓦機場",
      },
    ],
  },
  GYS: {
    code: "GYS",
    name: "GUANGYUAN",
    chineseName: "广元",
    traditionalName: "廣元",
    airports: [
      {
        code: "GYS",
        name: "Panlong",
        chineseName: "盘龙机场",
        traditionalName: "盤龍機場",
      },
    ],
  },
  GYU: {
    code: "GYU",
    name: "GUYUAN",
    chineseName: "固原",
    traditionalName: "固原",
    airports: [
      {
        code: "GYU",
        name: "Liupanshan",
        chineseName: "六盘山机场",
        traditionalName: "六盤山機場",
      },
    ],
  },
  GYZ: {
    code: "GYZ",
    name: "GRUYERE",
    chineseName: "格鲁耶尔",
    traditionalName: "格魯耶爾",
    airports: [
      {
        code: "GYZ",
        name: "Gruyere mine site",
        chineseName: "GRUYERE矿场机场",
        traditionalName: "GRUYERE礦場機場",
      },
    ],
  },
  GZG: {
    code: "GZG",
    name: "GANZI",
    chineseName: "甘孜",
    traditionalName: "甘孜",
    airports: [
      {
        code: "GZG",
        name: "Gesaer",
        chineseName: "甘孜格萨尔机场",
        traditionalName: "甘孜格薩爾機場",
      },
    ],
  },
  GZO: {
    code: "GZO",
    name: "GIZO",
    chineseName: "吉佐",
    traditionalName: "吉佐",
    airports: [
      {
        code: "GZO",
        name: "Nusatupe",
        chineseName: "吉佐机场",
        traditionalName: "吉佐機場",
      },
    ],
  },
  GZP: {
    code: "GZP",
    name: "GAZIPASA",
    chineseName: "加济帕夏",
    traditionalName: "加濟帕夏",
    airports: [
      {
        code: "GZP",
        name: "Gazipasa alanya",
        chineseName: "加齐帕萨机场",
        traditionalName: "加齊帕薩機場",
      },
    ],
  },
  GZT: {
    code: "GZT",
    name: "GAZIANTEP",
    chineseName: "加济安泰普",
    traditionalName: "加濟安泰普",
    airports: [
      {
        code: "GZT",
        name: "Oguzeli",
        chineseName: "奥古兹利机场",
        traditionalName: "奧古茲利機場",
      },
    ],
  },
  HAA: {
    code: "HAA",
    name: "HASVIK",
    chineseName: "哈斯维克",
    traditionalName: "哈斯維克",
    airports: [
      {
        code: "HAA",
        name: "Hasvik airport",
        chineseName: "哈斯维克机场",
        traditionalName: "哈斯維克機場",
      },
    ],
  },
  HAC: {
    code: "HAC",
    name: "HACHIJOJIMA",
    chineseName: "八丈岛",
    traditionalName: "八丈島",
    airports: [
      {
        code: "HAC",
        name: "Hachijojima airport",
        chineseName: "八丈岛机场",
        traditionalName: "八丈島機場",
      },
    ],
  },
  HAD: {
    code: "HAD",
    name: "HALMSTAD",
    chineseName: "哈尔姆斯塔德",
    traditionalName: "哈爾姆斯塔德",
    airports: [
      {
        code: "HAD",
        name: "Halmstad airport",
        chineseName: "哈尔姆斯塔德机场",
        traditionalName: "哈爾姆斯塔德機場",
      },
    ],
  },
  HAJ: {
    code: "HAJ",
    name: "HANNOVER",
    chineseName: "汉诺威",
    traditionalName: "漢諾威",
    airports: [
      {
        code: "HAJ",
        name: "Hannover airport",
        chineseName: "汉诺威机场",
        traditionalName: "漢諾威機場",
      },
    ],
  },
  HAK: {
    code: "HAK",
    name: "HAIKOU",
    chineseName: "海口",
    traditionalName: "海口",
    airports: [
      {
        code: "HAK",
        name: "Meilan intl",
        chineseName: "美兰国际机场",
        traditionalName: "美蘭國際機場",
      },
    ],
  },
  HAM: {
    code: "HAM",
    name: "HAMBURG",
    chineseName: "汉堡",
    traditionalName: "漢堡",
    airports: [
      {
        code: "HAM",
        name: "Hamburg airport",
        chineseName: "汉堡国际机场",
        traditionalName: "漢堡國際機場",
      },
      {
        code: "XFW",
        name: "Finkenwerder",
        chineseName: "芬肯维尔德机场",
        traditionalName: "芬肯維爾德機場",
      },
    ],
  },
  HAN: {
    code: "HAN",
    name: "HANOI",
    chineseName: "河内",
    traditionalName: "河內",
    airports: [
      {
        code: "HAN",
        name: "Noi bai intl",
        chineseName: "内排国际机场",
        traditionalName: "內排國際機場",
      },
    ],
  },
  HAQ: {
    code: "HAQ",
    name: "HANIMAADHOO ISLAND",
    chineseName: "哈霓玛阿都",
    traditionalName: "哈霓瑪阿都",
    airports: [
      {
        code: "HAQ",
        name: "Hanimaadhoo island airport",
        chineseName: "哈尼马德胡机场",
        traditionalName: "哈尼馬德胡機場",
      },
    ],
  },
  HAR: {
    code: "HAR",
    name: "HARRISBURG",
    chineseName: "哈里斯堡",
    traditionalName: "哈里斯堡",
    airports: [
      {
        code: "MDT",
        name: "Harrisburg intl.",
        chineseName: "哈里斯堡国际机场",
        traditionalName: "哈里斯堡國際機場",
      },
    ],
  },
  HAS: {
    code: "HAS",
    name: "HAIL",
    chineseName: "哈伊勒",
    traditionalName: "哈伊勒",
    airports: [
      {
        code: "HAS",
        name: "Hail airport",
        chineseName: "哈伊勒机场",
        traditionalName: "哈伊勒機場",
      },
    ],
  },
  HAU: {
    code: "HAU",
    name: "HAUGESUND",
    chineseName: "海于格松",
    traditionalName: "海於格松",
    airports: [
      {
        code: "HAU",
        name: "Karmoy",
        chineseName: "海于格松机场",
        traditionalName: "海於格松機場",
      },
    ],
  },
  HAV: {
    code: "HAV",
    name: "HAVANA",
    chineseName: "哈瓦那",
    traditionalName: "哈瓦那",
    airports: [
      {
        code: "HAV",
        name: "Jose marti intl",
        chineseName: "何塞马蒂国际机场",
        traditionalName: "何塞馬蒂國際機場",
      },
    ],
  },
  HAY: {
    code: "HAY",
    name: "AGUACHICA",
    chineseName: "海考克",
    traditionalName: "海考克",
    airports: [
      {
        code: "HAY",
        name: "Hacaritama",
        chineseName: "海考克机场",
        traditionalName: "海考克機場",
      },
    ],
  },
  HBA: {
    code: "HBA",
    name: "HOBART",
    chineseName: "霍巴特",
    traditionalName: "霍巴特",
    airports: [
      {
        code: "HBA",
        name: "Hobart intl.",
        chineseName: "霍巴特机场",
        traditionalName: "霍巴特機場",
      },
    ],
  },
  HBQ: {
    code: "HBQ",
    name: "QILIAN",
    chineseName: "祁连",
    traditionalName: "祁連",
    airports: [
      {
        code: "HBQ",
        name: "Haibei",
        chineseName: "海北祁连机场",
        traditionalName: "海北祁連機場",
      },
    ],
  },
  HBX: {
    code: "HBX",
    name: "HUBLI",
    chineseName: "胡布利",
    traditionalName: "胡布利",
    airports: [
      {
        code: "HBX",
        name: "Hubli airport",
        chineseName: "胡布利机场",
        traditionalName: "胡布利機場",
      },
    ],
  },
  HCJ: {
    code: "HCJ",
    name: "HECHI",
    chineseName: "河池",
    traditionalName: "河池",
    airports: [
      {
        code: "HCJ",
        name: "Jin cheng jiang",
        chineseName: "金城江机场",
        traditionalName: "金城江機場",
      },
    ],
  },
  HCQ: {
    code: "HCQ",
    name: "HALLS CREEK",
    chineseName: "霍尔斯克里克",
    traditionalName: "霍爾斯克裏克",
    airports: [
      {
        code: "HCQ",
        name: "Halls creek airport",
        chineseName: "霍尔斯克里克机场",
        traditionalName: "霍爾斯克裏克機場",
      },
    ],
  },
  HCR: {
    code: "HCR",
    name: "HOLY CROSS",
    chineseName: "霍利克劳斯",
    traditionalName: "霍利克勞斯",
    airports: [
      {
        code: "HCR",
        name: "Holy cross airport",
        chineseName: "霍利克劳斯机场",
        traditionalName: "霍利克勞斯機場",
      },
    ],
  },
  HDF: {
    code: "HDF",
    name: "HERINGSDORF",
    chineseName: "赫林斯多夫",
    traditionalName: "赫林斯多夫",
    airports: [
      {
        code: "HDF",
        name: "Heringsdorf airport",
        chineseName: "黑林斯多夫机场",
        traditionalName: "黑林斯多夫機場",
      },
    ],
  },
  HDG: {
    code: "HDG",
    name: "HANDAN",
    chineseName: "邯郸",
    traditionalName: "邯鄲",
    airports: [
      {
        code: "HDG",
        name: "Handan airport",
        chineseName: "邯郸机场",
        traditionalName: "邯鄲機場",
      },
    ],
  },
  HDK: {
    code: "HDK",
    name: "KULHUDHUFFUSHI",
    chineseName: "库尔胡德胡夫什",
    traditionalName: "庫爾胡德胡夫什",
    airports: [
      {
        code: "HDK",
        name: "Kulhudhuffushi airport",
        chineseName: "KULHUDHUFFUSHI机场",
        traditionalName: "KULHUDHUFFUSHI機場",
      },
    ],
  },
  HDN: {
    code: "HDN",
    name: "HAYDEN",
    chineseName: "海登",
    traditionalName: "海頓",
    airports: [
      {
        code: "HDN",
        name: "Yampa valley",
        chineseName: "亚姆帕瓦雷机场",
        traditionalName: "亞姆帕瓦雷機場",
      },
    ],
  },
  HDO: {
    code: "HDO",
    name: "GHAZIABAD",
    chineseName: "加济阿巴德",
    traditionalName: "加濟阿巴德",
    airports: [
      {
        code: "HDO",
        name: "Hindon",
        chineseName: "欣登机场",
        traditionalName: "欣登機場",
      },
    ],
  },
  HDS: {
    code: "HDS",
    name: "HOEDSPRUIT",
    chineseName: "荷兹普鲁伊特",
    traditionalName: "荷茲普魯伊特",
    airports: [
      {
        code: "HDS",
        name: "Afb",
        chineseName: "胡德斯普雷特机场",
        traditionalName: "胡德斯普雷特機場",
      },
    ],
  },
  HDY: {
    code: "HDY",
    name: "HAT YAI",
    chineseName: "合艾",
    traditionalName: "合艾",
    airports: [
      {
        code: "HDY",
        name: "Hat yai intl.",
        chineseName: "合艾国际机场",
        traditionalName: "合艾國際機場",
      },
    ],
  },
  HEA: {
    code: "HEA",
    name: "HERAT",
    chineseName: "赫拉特",
    traditionalName: "赫拉特",
    airports: [
      {
        code: "HEA",
        name: "Herat airport",
        chineseName: "赫拉特机场",
        traditionalName: "赫拉特機場",
      },
    ],
  },
  HEH: {
    code: "HEH",
    name: "HEHO",
    chineseName: "海霍",
    traditionalName: "海霍",
    airports: [
      {
        code: "HEH",
        name: "Heho airport",
        chineseName: "海霍机场",
        traditionalName: "海霍機場",
      },
    ],
  },
  HEI: {
    code: "HEI",
    name: "HEIDE/BUESUM",
    chineseName: "海德布埃苏姆",
    traditionalName: "海德布埃蘇姆",
    airports: [
      {
        code: "HEI",
        name: "Heide/buesum airport",
        chineseName: "海特比苏姆机场",
        traditionalName: "海特比蘇姆機場",
      },
    ],
  },
  HEK: {
    code: "HEK",
    name: "HEIHE",
    chineseName: "黑河",
    traditionalName: "黑河",
    airports: [
      {
        code: "HEK",
        name: "Heihe airport",
        chineseName: "黑河机场",
        traditionalName: "黑河機場",
      },
    ],
  },
  HEL: {
    code: "HEL",
    name: "HELSINKI",
    chineseName: "赫尔辛基",
    traditionalName: "赫爾辛基",
    airports: [
      {
        code: "HEL",
        name: "Helsinki-vantaa",
        chineseName: "赫尔辛基机场",
        traditionalName: "赫爾辛基機場",
      },
    ],
  },
  HER: {
    code: "HER",
    name: "IRAKLEION",
    chineseName: "伊拉克利翁",
    traditionalName: "伊拉克利翁",
    airports: [
      {
        code: "HER",
        name: "Nikos kazantzakis",
        chineseName: "卡赞查基斯机场",
        traditionalName: "卡贊查基斯機場",
      },
    ],
  },
  HET: {
    code: "HET",
    name: "HOHHOT",
    chineseName: "呼和浩特",
    traditionalName: "呼和浩特",
    airports: [
      {
        code: "HET",
        name: "Baita intl",
        chineseName: "白塔国际机场",
        traditionalName: "白塔國際機場",
      },
    ],
  },
  HFA: {
    code: "HFA",
    name: "HAIFA",
    chineseName: "海法",
    traditionalName: "海法",
    airports: [
      {
        code: "HFA",
        name: "Haifa airport",
        chineseName: "海法机场",
        traditionalName: "海法機場",
      },
    ],
  },
  HFD: {
    code: "HFD",
    name: "HARTFORD",
    chineseName: "哈特福德",
    traditionalName: "哈特福德",
    airports: [
      {
        code: "BDL",
        name: "Bradley international",
        chineseName: "布莱德雷国际机场",
        traditionalName: "布萊德雷國際機場",
      },
    ],
  },
  HFE: {
    code: "HFE",
    name: "HEFEI",
    chineseName: "合肥",
    traditionalName: "合肥",
    airports: [
      {
        code: "HFE",
        name: "Xinqiao intl",
        chineseName: "合肥新桥国际机场",
        traditionalName: "合肥新橋國際機場",
      },
    ],
  },
  HFN: {
    code: "HFN",
    name: "HORNAFJORDUR",
    chineseName: "霍纳夫约杜尔",
    traditionalName: "霍納夫約杜爾",
    airports: [
      {
        code: "HFN",
        name: "Hofn",
        chineseName: "赫本机场",
        traditionalName: "赫本機場",
      },
    ],
  },
  HFS: {
    code: "HFS",
    name: "HAGFORS",
    chineseName: "哈格福什",
    traditionalName: "哈格福什",
    airports: [
      {
        code: "HFS",
        name: "Hagfors airport",
        chineseName: "哈格福什机场",
        traditionalName: "哈格福什機場",
      },
    ],
  },
  HFT: {
    code: "HFT",
    name: "HAMMERFEST",
    chineseName: "哈默菲斯特",
    traditionalName: "哈默菲斯特",
    airports: [
      {
        code: "HFT",
        name: "Hammerfest airport",
        chineseName: "哈默弗斯特机场",
        traditionalName: "哈默弗斯特機場",
      },
    ],
  },
  HGA: {
    code: "HGA",
    name: "HARGEISA",
    chineseName: "哈尔格萨",
    traditionalName: "哈爾格薩",
    airports: [
      {
        code: "HGA",
        name: "Egal intl",
        chineseName: "哈尔格萨机场",
        traditionalName: "哈爾格薩機場",
      },
    ],
  },
  HGD: {
    code: "HGD",
    name: "HUGHENDEN",
    chineseName: "休恩登",
    traditionalName: "休恩登",
    airports: [
      {
        code: "HGD",
        name: "Hughenden airport",
        chineseName: "休恩登机场",
        traditionalName: "休恩登機場",
      },
    ],
  },
  HGH: {
    code: "HGH",
    name: "HANGZHOU",
    chineseName: "杭州",
    traditionalName: "杭州",
    airports: [
      {
        code: "HGH",
        name: "Xiaoshan intl",
        chineseName: "萧山国际机场",
        traditionalName: "蕭山國際機場",
      },
    ],
  },
  HGI: {
    code: "HGI",
    name: "ITANAGAR",
    chineseName: "Itanagar",
    traditionalName: "Itanagar",
    airports: [
      {
        code: "HGI",
        name: "Hollongi",
        chineseName: "黑格里机场",
        traditionalName: "黑格裡機場",
      },
    ],
  },
  HGL: {
    code: "HGL",
    name: "HELGOLAND",
    chineseName: "黑尔戈兰岛",
    traditionalName: "黑爾戈蘭島",
    airports: [
      {
        code: "HGL",
        name: "Duene",
        chineseName: "黑尔戈兰岛机场",
        traditionalName: "黑爾戈蘭島機場",
      },
    ],
  },
  HGN: {
    code: "HGN",
    name: "MAE HONG SON",
    chineseName: "夜丰颂",
    traditionalName: "夜豐頌",
    airports: [
      {
        code: "HGN",
        name: "Mae hong son airport",
        chineseName: "夜丰颂机场",
        traditionalName: "夜豐頌機場",
      },
    ],
  },
  HGO: {
    code: "HGO",
    name: "KORHOGO",
    chineseName: "科霍戈",
    traditionalName: "科爾戈",
    airports: [
      {
        code: "HGO",
        name: "Korhogo airport",
        chineseName: "科霍戈机场",
        traditionalName: "科爾戈機場",
      },
    ],
  },
  HGR: {
    code: "HGR",
    name: "HAGERSTOWN",
    chineseName: "黑格斯敦",
    traditionalName: "黑格斯敦",
    airports: [
      {
        code: "HGR",
        name: "Hagerstown reg. airport",
        chineseName: "黑格斯敦地区机场",
        traditionalName: "黑格斯敦地區機場",
      },
    ],
  },
  HGU: {
    code: "HGU",
    name: "MOUNT HAGEN",
    chineseName: "芒特哈根",
    traditionalName: "芒特希根",
    airports: [
      {
        code: "HGU",
        name: "Kagamuga",
        chineseName: "卡加姆加机场",
        traditionalName: "卡加姆加機場",
      },
    ],
  },
  HHH: {
    code: "HHH",
    name: "HILTON HEAD ISLAND",
    chineseName: "希尔顿黑德",
    traditionalName: "希爾頓黑德",
    airports: [
      {
        code: "HHH",
        name: "Hilton head",
        chineseName: "希尔顿黑德机场",
        traditionalName: "希爾頓黑德機場",
      },
    ],
  },
  HHQ: {
    code: "HHQ",
    name: "HUA HIN",
    chineseName: "华欣",
    traditionalName: "華欣",
    airports: [
      {
        code: "HHQ",
        name: "Hua hin airport",
        chineseName: "华欣机场",
        traditionalName: "華欣機場",
      },
    ],
  },
  HHR: {
    code: "HHR",
    name: "HAWTHORNE",
    chineseName: "霍桑",
    traditionalName: "霍桑",
    airports: [
      {
        code: "HHR",
        name: "Hawthorne municipal",
        chineseName: "霍桑机场",
        traditionalName: "霍桑機場",
      },
    ],
  },
  HHZ: {
    code: "HHZ",
    name: "HIKUERU",
    chineseName: "希库埃鲁",
    traditionalName: "希庫埃魯",
    airports: [
      {
        code: "HHZ",
        name: "Hikueru airport",
        chineseName: "希库埃鲁机场",
        traditionalName: "希庫埃魯機場",
      },
    ],
  },
  HIA: {
    code: "HIA",
    name: "HUAI'AN",
    chineseName: "淮安",
    traditionalName: "淮安",
    airports: [
      {
        code: "HIA",
        name: "Lianshui",
        chineseName: "涟水机场",
        traditionalName: "漣水機場",
      },
    ],
  },
  HIB: {
    code: "HIB",
    name: "HIBBING/CHISHOLM",
    chineseName: "明尼苏达州希宾",
    traditionalName: "明尼蘇達州希賓",
    airports: [
      {
        code: "HIB",
        name: "Range regional",
        chineseName: "奇绍尔姆西宾机场",
        traditionalName: "奇紹爾姆西賓機場",
      },
    ],
  },
  HID: {
    code: "HID",
    name: "HORN ISLAND",
    chineseName: "霍恩岛",
    traditionalName: "霍恩島",
    airports: [
      {
        code: "HID",
        name: "Horn island airport",
        chineseName: "霍恩岛机场",
        traditionalName: "霍恩島機場",
      },
    ],
  },
  HIJ: {
    code: "HIJ",
    name: "HIROSHIMA",
    chineseName: "广岛",
    traditionalName: "廣島",
    airports: [
      {
        code: "HIJ",
        name: "Hiroshima airport",
        chineseName: "广岛机场",
        traditionalName: "廣島機場",
      },
    ],
  },
  HIN: {
    code: "HIN",
    name: "JINJU",
    chineseName: "晋州",
    traditionalName: "晋州",
    airports: [
      {
        code: "HIN",
        name: "Sacheon",
        chineseName: "蛇川机场",
        traditionalName: "蛇川機場",
      },
    ],
  },
  HIR: {
    code: "HIR",
    name: "HONIARA",
    chineseName: "霍尼亚拉",
    traditionalName: "荷尼阿拉",
    airports: [
      {
        code: "HIR",
        name: "Honiara intl.",
        chineseName: "霍尼亚拉国际机场",
        traditionalName: "荷尼阿拉國際機場",
      },
    ],
  },
  HJJ: {
    code: "HJJ",
    name: "HUAIHUA",
    chineseName: "怀化",
    traditionalName: "懷化",
    airports: [
      {
        code: "HJJ",
        name: "Zhijiang",
        chineseName: "芷江机场",
        traditionalName: "芷江機場",
      },
    ],
  },
  HJR: {
    code: "HJR",
    name: "KHAJURAHO",
    chineseName: "克久拉霍",
    traditionalName: "克久拉霍",
    airports: [
      {
        code: "HJR",
        name: "Khajuraho airport",
        chineseName: "克久拉霍机场",
        traditionalName: "克久拉霍機場",
      },
    ],
  },
  HKD: {
    code: "HKD",
    name: "HAKODATE",
    chineseName: "函馆",
    traditionalName: "函館",
    airports: [
      {
        code: "HKD",
        name: "Hakodate airport",
        chineseName: "函馆机场",
        traditionalName: "函館機場",
      },
    ],
  },
  HKG: {
    code: "HKG",
    name: "HONG KONG",
    chineseName: "香港",
    traditionalName: "香港",
    airports: [
      {
        code: "HKG",
        name: "Hong kong intl.",
        chineseName: "香港国际机场",
        traditionalName: "香港國際機場",
      },
    ],
  },
  HKK: {
    code: "HKK",
    name: "HOKITIKA",
    chineseName: "霍基蒂卡",
    traditionalName: "霍基蒂卡",
    airports: [
      {
        code: "HKK",
        name: "Hokitika airport",
        chineseName: "霍基蒂卡机场",
        traditionalName: "霍基蒂卡機場",
      },
    ],
  },
  HKN: {
    code: "HKN",
    name: "HOSKINS",
    chineseName: "霍斯金斯",
    traditionalName: "霍斯金斯",
    airports: [
      {
        code: "HKN",
        name: "Hoskins airport",
        chineseName: "霍斯金斯机场",
        traditionalName: "霍斯金斯機場",
      },
    ],
  },
  HKT: {
    code: "HKT",
    name: "PHUKET",
    chineseName: "普吉岛",
    traditionalName: "普吉島",
    airports: [
      {
        code: "HKT",
        name: "Phuket intl.",
        chineseName: "普吉国际机场",
        traditionalName: "普吉國際機場",
      },
    ],
  },
  HLD: {
    code: "HLD",
    name: "HAILAR",
    chineseName: "海拉尔",
    traditionalName: "海拉爾",
    airports: [
      {
        code: "HLD",
        name: "Dongshan",
        chineseName: "海拉尔机场",
        traditionalName: "海拉爾機場",
      },
    ],
  },
  HLE: {
    code: "HLE",
    name: "JAMESTOWN",
    chineseName: "詹姆士镇",
    traditionalName: "詹姆士鎮",
    airports: [
      {
        code: "HLE",
        name: "Saint helena",
        chineseName: "圣赫勒拿机场",
        traditionalName: "聖赫倫那機場",
      },
    ],
  },
  HLH: {
    code: "HLH",
    name: "ULANHOT",
    chineseName: "乌兰浩特",
    traditionalName: "烏蘭浩特",
    airports: [
      {
        code: "HLH",
        name: "Ulanhot airport",
        chineseName: "乌兰浩特机场",
        traditionalName: "烏蘭浩特機場",
      },
    ],
  },
  HLN: {
    code: "HLN",
    name: "HELENA",
    chineseName: "海伦娜",
    traditionalName: "海倫娜",
    airports: [
      {
        code: "HLN",
        name: "Helena reg. airport",
        chineseName: "海伦娜机场",
        traditionalName: "海倫娜機場",
      },
    ],
  },
  HLZ: {
    code: "HLZ",
    name: "HAMILTON",
    chineseName: "哈密尔顿",
    traditionalName: "漢米爾頓",
    airports: [
      {
        code: "HLZ",
        name: "Hamilton intl.",
        chineseName: "汉密尔顿国际机场",
        traditionalName: "漢密爾頓國際機場",
      },
    ],
  },
  HMA: {
    code: "HMA",
    name: "KHANTY-MANSIYSK",
    chineseName: "汉特-曼西斯克",
    traditionalName: "漢特-曼西斯克",
    airports: [
      {
        code: "HMA",
        name: "Khanty-mansiysk airport",
        chineseName: "汉特－曼西斯特机场",
        traditionalName: "漢特－曼西斯特機場",
      },
    ],
  },
  HMB: {
    code: "HMB",
    name: "SOHAG",
    chineseName: "索哈格",
    traditionalName: "索哈格",
    airports: [
      {
        code: "HMB",
        name: "Sohag intl.",
        chineseName: "索哈格国际机场",
        traditionalName: "索哈格國際機場",
      },
    ],
  },
  HME: {
    code: "HME",
    name: "HASSI MESSAOUD",
    chineseName: "哈西迈萨乌德",
    traditionalName: "哈西邁薩烏德",
    airports: [
      {
        code: "HME",
        name: "Oued irara",
        chineseName: "欧埃德伊拉拉机场",
        traditionalName: "歐埃德伊拉拉機場",
      },
    ],
  },
  HMI: {
    code: "HMI",
    name: "HAMI",
    chineseName: "哈密",
    traditionalName: "哈密",
    airports: [
      {
        code: "HMI",
        name: "Hami airport",
        chineseName: "哈密机场",
        traditionalName: "哈密機場",
      },
    ],
  },
  HMO: {
    code: "HMO",
    name: "HERMOSILLO",
    chineseName: "埃莫西约",
    traditionalName: "埃莫西約",
    airports: [
      {
        code: "HMO",
        name: "I.pesqueira garcia",
        chineseName: "伊格纳西奥培思逵洛加西亚机场",
        traditionalName: "伊格納西奧培思逵洛加西亞機場",
      },
    ],
  },
  HMV: {
    code: "HMV",
    name: "HEMAVAN/TARNABY",
    chineseName: "赫马凡",
    traditionalName: "赫馬凡",
    airports: [
      {
        code: "HMV",
        name: "Hemavan/tarnaby airport",
        chineseName: "赫马凡机场",
        traditionalName: "赫馬凡機場",
      },
    ],
  },
  HNA: {
    code: "HNA",
    name: "HANAMAKI",
    chineseName: "花卷",
    traditionalName: "花卷",
    airports: [
      {
        code: "HNA",
        name: "Hanamaki airport",
        chineseName: "花卷机场",
        traditionalName: "花卷機場",
      },
    ],
  },
  HNH: {
    code: "HNH",
    name: "HOONAH",
    chineseName: "胡纳",
    traditionalName: "胡納",
    airports: [
      {
        code: "HNH",
        name: "Hoonah airport",
        chineseName: "霍纳机场",
        traditionalName: "霍納機場",
      },
    ],
  },
  HNL: {
    code: "HNL",
    name: "HONOLULU",
    chineseName: "火奴鲁鲁",
    traditionalName: "火奴魯魯",
    airports: [
      {
        code: "HNL",
        name: "Daniel k. inouye intl",
        chineseName: "火奴鲁鲁国际机场",
        traditionalName: "火奴魯魯國際機場",
      },
    ],
  },
  HNM: {
    code: "HNM",
    name: "HANA",
    chineseName: "哈纳",
    traditionalName: "哈納",
    airports: [
      {
        code: "HNM",
        name: "Hana airport",
        chineseName: "哈纳机场",
        traditionalName: "哈納機場",
      },
    ],
  },
  HNN: {
    code: "HNN",
    name: "HONINABI",
    chineseName: "霍尼纳比",
    traditionalName: "霍尼納比",
    airports: [
      {
        code: "HNN",
        name: "Honinabi airport",
        chineseName: "霍尼纳比机场",
        traditionalName: "霍尼納比機場",
      },
    ],
  },
  HNS: {
    code: "HNS",
    name: "HAINES",
    chineseName: "海恩斯",
    traditionalName: "海恩斯",
    airports: [
      {
        code: "HNS",
        name: "Haines airport",
        chineseName: "海恩斯机场",
        traditionalName: "海恩斯機場",
      },
    ],
  },
  HNY: {
    code: "HNY",
    name: "HENGYANG",
    chineseName: "衡阳",
    traditionalName: "衡陽",
    airports: [
      {
        code: "HNY",
        name: "Bajialing",
        chineseName: "南岳机场",
        traditionalName: "南嶽機場",
      },
    ],
  },
  HOB: {
    code: "HOB",
    name: "HOBBS",
    chineseName: "霍布斯",
    traditionalName: "霍布斯",
    airports: [
      {
        code: "HOB",
        name: "Lea county regional",
        chineseName: "利阿郡机场",
        traditionalName: "利阿郡機場",
      },
    ],
  },
  HOD: {
    code: "HOD",
    name: "HODEIDAH",
    chineseName: "荷台达",
    traditionalName: "荷台達",
    airports: [
      {
        code: "HOD",
        name: "Hodeidah intl.",
        chineseName: "荷台达国际机场",
        traditionalName: "荷台達國際機場",
      },
    ],
  },
  HOF: {
    code: "HOF",
    name: "HOFUF",
    chineseName: "胡富夫",
    traditionalName: "胡富夫",
    airports: [
      {
        code: "HOF",
        name: "Al-ahsa",
        chineseName: "阿拉萨机场",
        traditionalName: "阿拉薩機場",
      },
    ],
  },
  HOG: {
    code: "HOG",
    name: "HOLGUIN",
    chineseName: "奥尔金",
    traditionalName: "奧爾金",
    airports: [
      {
        code: "HOG",
        name: "Frank pais intl",
        chineseName: "弗兰克帕里斯机场",
        traditionalName: "弗蘭克帕里斯機場",
      },
    ],
  },
  HOH: {
    code: "HOH",
    name: "HOHENEMS/DORNBIRN",
    chineseName: "霍恩埃姆斯",
    traditionalName: "霍恩埃姆斯",
    airports: [
      {
        code: "HOH",
        name: "Hohenems/dornbirn airport",
        chineseName: "霍恩埃姆斯机场",
        traditionalName: "霍恩埃姆斯機場",
      },
    ],
  },
  HOI: {
    code: "HOI",
    name: "HAO",
    chineseName: "豪岛",
    traditionalName: "豪島",
    airports: [
      {
        code: "HOI",
        name: "Hao airport",
        chineseName: "豪岛机场",
        traditionalName: "豪島機場",
      },
    ],
  },
  HOM: {
    code: "HOM",
    name: "HOMER",
    chineseName: "荷马",
    traditionalName: "荷馬",
    airports: [
      {
        code: "HOM",
        name: "Homer airport",
        chineseName: "荷马机场",
        traditionalName: "荷馬機場",
      },
    ],
  },
  HOR: {
    code: "HOR",
    name: "HORTA",
    chineseName: "霍塔",
    traditionalName: "霍塔",
    airports: [
      {
        code: "HOR",
        name: "Horta airport",
        chineseName: "奥尔塔机场",
        traditionalName: "奧爾塔機場",
      },
    ],
  },
  HOT: {
    code: "HOT",
    name: "HOT SPRINGS",
    chineseName: "阿肯色州温泉",
    traditionalName: "阿肯色州溫泉",
    airports: [
      {
        code: "HOT",
        name: "Memorial field",
        chineseName: "梅莫里阿尔机场",
        traditionalName: "梅莫裏阿爾機場",
      },
    ],
  },
  HOU: {
    code: "HOU",
    name: "HOUSTON",
    chineseName: "休斯顿",
    traditionalName: "休斯頓",
    airports: [
      {
        code: "HOU",
        name: "William p. hobby",
        chineseName: "休斯敦城市机场",
        traditionalName: "休士頓都市機場",
      },
      {
        code: "IAH",
        name: "George bush intercont.",
        chineseName: "乔治布什国际机场",
        traditionalName: "喬治布什國際機場",
      },
    ],
  },
  HOV: {
    code: "HOV",
    name: "ORSTA/VOLDA",
    chineseName: "霍夫登",
    traditionalName: "霍夫登",
    airports: [
      {
        code: "HOV",
        name: "Hovden",
        chineseName: "霍夫登机场",
        traditionalName: "霍夫登機場",
      },
    ],
  },
  HOX: {
    code: "HOX",
    name: "HOMALIN",
    chineseName: "霍马林",
    traditionalName: "霍馬林",
    airports: [
      {
        code: "HOX",
        name: "Homalin airport",
        chineseName: "霍马林机场",
        traditionalName: "霍馬林機場",
      },
    ],
  },
  HPA: {
    code: "HPA",
    name: "HA'APAI",
    chineseName: "哈派",
    traditionalName: "哈派",
    airports: [
      {
        code: "HPA",
        name: "Lifuka",
        chineseName: "利富卡岛机场",
        traditionalName: "利富卡島機場",
      },
    ],
  },
  HPB: {
    code: "HPB",
    name: "HOOPER BAY",
    chineseName: "胡珀贝",
    traditionalName: "胡珀貝",
    airports: [
      {
        code: "HPB",
        name: "Hooper bay airport",
        chineseName: "胡珀贝机场",
        traditionalName: "胡珀貝機場",
      },
    ],
  },
  HPG: {
    code: "HPG",
    name: "SHENNONGJIA",
    chineseName: "神农架",
    traditionalName: "神農架",
    airports: [
      {
        code: "HPG",
        name: "Hongping",
        chineseName: "红坪机场",
        traditionalName: "紅坪機場",
      },
    ],
  },
  HPH: {
    code: "HPH",
    name: "HAIPHONG",
    chineseName: "海防",
    traditionalName: "海防",
    airports: [
      {
        code: "HPH",
        name: "Cat bi intl",
        chineseName: "吉碑国际机场",
        traditionalName: "吉碑國際機場",
      },
    ],
  },
  HPN: {
    code: "HPN",
    name: "WHITE PLAINS",
    chineseName: "维斯特切斯特郡",
    traditionalName: "維斯特切斯特郡",
    airports: [
      {
        code: "HPN",
        name: "Westchester county",
        chineseName: "维斯特切斯特郡机场",
        traditionalName: "維斯特切斯特郡機場",
      },
    ],
  },
  HQL: {
    code: "HQL",
    name: "TASHIKUERGAN",
    chineseName: "塔希库尔干",
    traditionalName: "塔希庫爾幹",
    airports: [
      {
        code: "HQL",
        name: "Hongqilafu",
        chineseName: "红其拉甫机场",
        traditionalName: "紅其拉甫機場",
      },
    ],
  },
  HRB: {
    code: "HRB",
    name: "HARBIN",
    chineseName: "哈尔滨",
    traditionalName: "哈爾濱",
    airports: [
      {
        code: "HRB",
        name: "Taiping intl",
        chineseName: "哈尔滨太平国际机场",
        traditionalName: "哈爾濱太平國際機場",
      },
    ],
  },
  HRE: {
    code: "HRE",
    name: "HARARE",
    chineseName: "哈拉雷",
    traditionalName: "哈拉雷",
    airports: [
      {
        code: "HRE",
        name: "R.g. mugabe intl",
        chineseName: "哈拉雷国际机场",
        traditionalName: "哈拉雷國際機場",
      },
    ],
  },
  HRF: {
    code: "HRF",
    name: "HOARAFUSHI",
    chineseName: "霍拉富",
    traditionalName: "霍拉富",
    airports: [
      {
        code: "HRF",
        name: "Hoarafushi airport",
        chineseName: "HOARAFUSHI机场",
        traditionalName: "Hoarafushi機場",
      },
    ],
  },
  HRG: {
    code: "HRG",
    name: "HURGHADA",
    chineseName: "赫尔格达",
    traditionalName: "赫爾格達",
    airports: [
      {
        code: "HRG",
        name: "Hurghada intl.",
        chineseName: "赫尔格达国际机场",
        traditionalName: "赫爾格達國際機場",
      },
    ],
  },
  HRH: {
    code: "HRH",
    name: "ALIGARH",
    chineseName: "阿里格尔",
    traditionalName: "阿裡格爾",
    airports: [
      {
        code: "HRH",
        name: "Aligarh airport",
        chineseName: "Aligarh机场",
        traditionalName: "Aligarh機場",
      },
    ],
  },
  HRI: {
    code: "HRI",
    name: "HAMBANTOTA",
    chineseName: "汉班托塔",
    traditionalName: "漢班托塔",
    airports: [
      {
        code: "HRI",
        name: "Mattala rajapaksa intl",
        chineseName: "汉班托特国际机场",
        traditionalName: "漢班托特國際機場",
      },
    ],
  },
  HRL: {
    code: "HRL",
    name: "HARLINGEN",
    chineseName: "哈灵根",
    traditionalName: "哈靈根",
    airports: [
      {
        code: "HRL",
        name: "Valley international",
        chineseName: "瓦雷国际机场",
        traditionalName: "瓦雷國際機場",
      },
    ],
  },
  HRO: {
    code: "HRO",
    name: "HARRISON",
    chineseName: "哈里森",
    traditionalName: "哈里森",
    airports: [
      {
        code: "HRO",
        name: "Boone county",
        chineseName: "布恩郡机场",
        traditionalName: "布恩郡機場",
      },
    ],
  },
  HSA: {
    code: "HSA",
    name: "TURKISTAN",
    chineseName: "突厥斯坦",
    traditionalName: "突厥斯坦",
    airports: [
      {
        code: "HSA",
        name: "Turkistan international",
        chineseName: "哈兹拉特苏丹国际机场",
        traditionalName: "哈茲拉特蘇丹國際機場",
      },
    ],
  },
  HSC: {
    code: "HSC",
    name: "SHAOGUAN",
    chineseName: "韶关",
    traditionalName: "韶關",
    airports: [
      {
        code: "HSC",
        name: "Danxia",
        chineseName: "韶关丹霞机场",
        traditionalName: "韶關丹霞機場",
      },
    ],
  },
  HSG: {
    code: "HSG",
    name: "SAGA",
    chineseName: "佐贺",
    traditionalName: "佐賀",
    airports: [
      {
        code: "HSG",
        name: "Saga airport",
        chineseName: "佐贺机场",
        traditionalName: "佐賀機場",
      },
    ],
  },
  HSL: {
    code: "HSL",
    name: "HUSLIA",
    chineseName: "阿拉斯加州Huslia",
    traditionalName: "阿拉斯加州Huslia",
    airports: [
      {
        code: "HSL",
        name: "Huslia airport",
        chineseName: "胡斯利亚机场",
        traditionalName: "胡斯利亞機場",
      },
    ],
  },
  HSN: {
    code: "HSN",
    name: "ZHOUSHAN",
    chineseName: "舟山",
    traditionalName: "舟山",
    airports: [
      {
        code: "HSN",
        name: "Putuoshan",
        chineseName: "普陀山机场",
        traditionalName: "普陀山機場",
      },
    ],
  },
  HSR: {
    code: "HSR",
    name: "HIRASAR",
    chineseName: "平萨尔",
    traditionalName: "平薩爾",
    airports: [
      {
        code: "HSR",
        name: "Rajkot international airport",
        chineseName: "希拉萨尔机场",
        traditionalName: "希拉薩爾機場",
      },
    ],
  },
  HSV: {
    code: "HSV",
    name: "HUNTSVILLE",
    chineseName: "亨茨维尔",
    traditionalName: "亨茨維爾",
    airports: [
      {
        code: "HSV",
        name: "Intl-carl t.jones fld",
        chineseName: "汉斯威尔国际机场",
        traditionalName: "漢斯威爾國際機場",
      },
    ],
  },
  HTA: {
    code: "HTA",
    name: "CHITA",
    chineseName: "赤塔",
    traditionalName: "赤塔",
    airports: [
      {
        code: "HTA",
        name: "Kadala",
        chineseName: "卡达拉机场",
        traditionalName: "卡達拉機場",
      },
    ],
  },
  HTG: {
    code: "HTG",
    name: "KHATANGA",
    chineseName: "哈坦加",
    traditionalName: "哈坦加",
    airports: [
      {
        code: "HTG",
        name: "Khatanga airport",
        chineseName: "哈坦加机场",
        traditionalName: "哈坦加機場",
      },
    ],
  },
  HTI: {
    code: "HTI",
    name: "HAMILTON ISLAND",
    chineseName: "哈密尔顿岛",
    traditionalName: "漢米爾頓島",
    airports: [
      {
        code: "HTI",
        name: "Great barrier reef",
        chineseName: "大堡礁机场",
        traditionalName: "大堡礁機場",
      },
    ],
  },
  HTN: {
    code: "HTN",
    name: "HOTAN",
    chineseName: "和田",
    traditionalName: "和田",
    airports: [
      {
        code: "HTN",
        name: "Hotan airport",
        chineseName: "昆冈机场",
        traditionalName: "昆岡機場",
      },
    ],
  },
  HTR: {
    code: "HTR",
    name: "HATERUMA",
    chineseName: "波照间",
    traditionalName: "波照間",
    airports: [
      {
        code: "HTR",
        name: "Hateruma airport",
        chineseName: "波照间机场",
        traditionalName: "波照間機場",
      },
    ],
  },
  HTS: {
    code: "HTS",
    name: "HUNTINGTON",
    chineseName: "亨廷顿",
    traditionalName: "亨廷頓",
    airports: [
      {
        code: "HTS",
        name: "Tri-state",
        chineseName: "特里史代特机场",
        traditionalName: "特裏史代特機場",
      },
    ],
  },
  HTT: {
    code: "HTT",
    name: "HUATUGOU",
    chineseName: "花土沟",
    traditionalName: "花土溝",
    airports: [
      {
        code: "HTT",
        name: "Huatugou airport",
        chineseName: "花土沟机场",
        traditionalName: "花土溝機場",
      },
    ],
  },
  HTY: {
    code: "HTY",
    name: "HATAY",
    chineseName: "安塔基亚",
    traditionalName: "安塔基亞",
    airports: [
      {
        code: "HTY",
        name: "Hatay airport",
        chineseName: "哈塔伊机场",
        traditionalName: "哈塔伊機場",
      },
    ],
  },
  HUH: {
    code: "HUH",
    name: "HUAHINE",
    chineseName: "华希讷",
    traditionalName: "華希訥",
    airports: [
      {
        code: "HUH",
        name: "Fare",
        chineseName: "胡阿希内岛机场",
        traditionalName: "胡阿希內島機場",
      },
    ],
  },
  HUI: {
    code: "HUI",
    name: "HUE",
    chineseName: "顺化",
    traditionalName: "順化",
    airports: [
      {
        code: "HUI",
        name: "Phu bai intl",
        chineseName: "普拜国际机场",
        traditionalName: "普拜國際機場",
      },
    ],
  },
  HUN: {
    code: "HUN",
    name: "HUALIEN",
    chineseName: "花莲",
    traditionalName: "花蓮",
    airports: [
      {
        code: "HUN",
        name: "Hualien airport",
        chineseName: "花莲机场",
        traditionalName: "花蓮機場",
      },
    ],
  },
  HUO: {
    code: "HUO",
    name: "HUOLINGUOLE",
    chineseName: "霍林郭勒",
    traditionalName: "霍林郭勒",
    airports: [
      {
        code: "HUO",
        name: "Huolinhe",
        chineseName: "霍林河机场",
        traditionalName: "霍林河機場",
      },
    ],
  },
  HUS: {
    code: "HUS",
    name: "HUGHES",
    chineseName: "阿拉斯加州休斯",
    traditionalName: "阿拉斯加州休斯",
    airports: [
      {
        code: "HUS",
        name: "Hughes airport",
        chineseName: "休斯机场",
        traditionalName: "休斯機場",
      },
    ],
  },
  HUU: {
    code: "HUU",
    name: "HUANUCO",
    chineseName: "瓦努科",
    traditionalName: "瓦努科",
    airports: [
      {
        code: "HUU",
        name: "David f. fernandini",
        chineseName: "瓦努科机场",
        traditionalName: "瓦努科機場",
      },
    ],
  },
  HUV: {
    code: "HUV",
    name: "HUDIKSVALL",
    chineseName: "胡迪克斯瓦尔",
    traditionalName: "胡迪克斯瓦爾",
    airports: [
      {
        code: "HUV",
        name: "Hudiksvall airport",
        chineseName: "胡迪克维瓦尔机场",
        traditionalName: "胡迪克維瓦爾機場",
      },
    ],
  },
  HUX: {
    code: "HUX",
    name: "HUATULCO",
    chineseName: "瓦图尔科",
    traditionalName: "瓦圖爾科",
    airports: [
      {
        code: "HUX",
        name: "Bahias de huatulco int",
        chineseName: "瓦图尔科国际机场",
        traditionalName: "瓦圖爾科國際機場",
      },
    ],
  },
  HUY: {
    code: "HUY",
    name: "HUMBERSIDE",
    chineseName: "亨伯赛德",
    traditionalName: "亨伯賽德",
    airports: [
      {
        code: "HUY",
        name: "Humberside airport",
        chineseName: "汉伯塞机场",
        traditionalName: "漢伯塞機場",
      },
    ],
  },
  HUZ: {
    code: "HUZ",
    name: "HUIZHOU",
    chineseName: "惠州",
    traditionalName: "惠州",
    airports: [
      {
        code: "HUZ",
        name: "Huizhou airport",
        chineseName: "平潭机场",
        traditionalName: "平潭機場",
      },
    ],
  },
  HVB: {
    code: "HVB",
    name: "HERVEY BAY",
    chineseName: "赫维贝",
    traditionalName: "赫維貝",
    airports: [
      {
        code: "HVB",
        name: "Hervey bay airport",
        chineseName: "赫维贝机场",
        traditionalName: "赫維貝機場",
      },
    ],
  },
  HVD: {
    code: "HVD",
    name: "KHOVD",
    chineseName: "科布多",
    traditionalName: "科布多",
    airports: [
      {
        code: "HVD",
        name: "Khovd airport",
        chineseName: "科布多机场",
        traditionalName: "科布多機場",
      },
    ],
  },
  HVG: {
    code: "HVG",
    name: "HONNINGSVAG",
    chineseName: "瓦伦",
    traditionalName: "瓦倫",
    airports: [
      {
        code: "HVG",
        name: "Valan",
        chineseName: "瓦伦机场",
        traditionalName: "瓦倫機場",
      },
    ],
  },
  HVN: {
    code: "HVN",
    name: "NEW HAVEN",
    chineseName: "纽黑文",
    traditionalName: "紐哈芬",
    airports: [
      {
        code: "HVN",
        name: "Tweed",
        chineseName: "纽黑文机场",
        traditionalName: "紐哈芬機場",
      },
    ],
  },
  HVR: {
    code: "HVR",
    name: "HAVRE",
    chineseName: "哈佛",
    traditionalName: "哈佛",
    airports: [
      {
        code: "HVR",
        name: "City-county",
        chineseName: "哈佛城郡机场",
        traditionalName: "哈佛城郡機場",
      },
    ],
  },
  HWD: {
    code: "HWD",
    name: "HAYWARD",
    chineseName: "海沃德",
    traditionalName: "海沃德",
    airports: [
      {
        code: "HWD",
        name: "Executive",
        chineseName: "海沃德机场",
        traditionalName: "海沃德機場",
      },
    ],
  },
  HWN: {
    code: "HWN",
    name: "HWANGE NATIONAL PARK",
    chineseName: "万盖国家公园",
    traditionalName: "萬蓋國家公園",
    airports: [
      {
        code: "HWN",
        name: "Hwange national park airport",
        chineseName: "万盖国家公园机场",
        traditionalName: "萬蓋國家公園機場",
      },
    ],
  },
  HXD: {
    code: "HXD",
    name: "DELINGHA",
    chineseName: "德令哈",
    traditionalName: "德令哈",
    airports: [
      {
        code: "HXD",
        name: "Delingha airport",
        chineseName: "德令哈机场",
        traditionalName: "德令哈機場",
      },
    ],
  },
  HYA: {
    code: "HYA",
    name: "HYANNIS",
    chineseName: "海恩尼斯",
    traditionalName: "海恩尼斯",
    airports: [
      {
        code: "HYA",
        name: "Barnstable municipal",
        chineseName: "巴恩斯塔贝尔机场",
        traditionalName: "巴恩斯塔貝爾機場",
      },
    ],
  },
  HYD: {
    code: "HYD",
    name: "HYDERABAD",
    chineseName: "海德拉巴",
    traditionalName: "海德拉巴",
    airports: [
      {
        code: "HYD",
        name: "Rajiv gandhi int'l",
        chineseName: "海德拉巴国际机场",
        traditionalName: "海德拉巴國際機場",
      },
    ],
  },
  HYG: {
    code: "HYG",
    name: "HYDABURG",
    chineseName: "阿拉斯加州海达堡",
    traditionalName: "阿拉斯加州海達堡",
    airports: [
      {
        code: "HYG",
        name: "Sea plane base",
        chineseName: "海达堡水上飞机基地",
        traditionalName: "海達堡水上飛機基地",
      },
    ],
  },
  HYN: {
    code: "HYN",
    name: "TAIZHOU",
    chineseName: "台州",
    traditionalName: "台州",
    airports: [
      {
        code: "HYN",
        name: "Luqiao",
        chineseName: "路桥机场",
        traditionalName: "路橋機場",
      },
    ],
  },
  HYS: {
    code: "HYS",
    name: "HAYS",
    chineseName: "海斯",
    traditionalName: "海斯",
    airports: [
      {
        code: "HYS",
        name: "Hays reg. airport",
        chineseName: "海斯地方机场",
        traditionalName: "海斯地方機場",
      },
    ],
  },
  HZA: {
    code: "HZA",
    name: "HEZE",
    chineseName: "菏泽",
    traditionalName: "菏澤",
    airports: [
      {
        code: "HZA",
        name: "Heze mudan",
        chineseName: "菏泽牡丹机场",
        traditionalName: "菏澤牡丹機場",
      },
    ],
  },
  HZG: {
    code: "HZG",
    name: "HANZHONG",
    chineseName: "汉中",
    traditionalName: "漢中",
    airports: [
      {
        code: "HZG",
        name: "Chenggu",
        chineseName: "城固机场",
        traditionalName: "城固機場",
      },
    ],
  },
  IAA: {
    code: "IAA",
    name: "IGARKA",
    chineseName: "伊加尔卡",
    traditionalName: "伊加爾卡",
    airports: [
      {
        code: "IAA",
        name: "Igarka airport",
        chineseName: "伊加尔卡机场",
        traditionalName: "伊加爾卡機場",
      },
    ],
  },
  IAG: {
    code: "IAG",
    name: "NIAGARA FALLS",
    chineseName: "尼亚加拉瀑布",
    traditionalName: "尼亞加拉瀑布",
    airports: [
      {
        code: "IAG",
        name: "Niagara falls intl.",
        chineseName: "尼亚加拉瀑布国际机场",
        traditionalName: "尼亞加拉瀑布國際機場",
      },
    ],
  },
  IAL: {
    code: "IAL",
    name: "SALINAS",
    chineseName: "萨利纳斯",
    traditionalName: "薩利納斯",
    airports: [
      {
        code: "IAL",
        name: "Aeroporto municipal de salinas",
        chineseName: "萨利纳斯机场",
        traditionalName: "薩利納斯機場",
      },
    ],
  },
  IAM: {
    code: "IAM",
    name: "IN AMENAS",
    chineseName: "因阿迈纳斯",
    traditionalName: "因阿邁納斯",
    airports: [
      {
        code: "IAM",
        name: "Zarzaitine",
        chineseName: "因阿迈纳斯机场",
        traditionalName: "因阿邁納斯機場",
      },
    ],
  },
  IAN: {
    code: "IAN",
    name: "KIANA",
    chineseName: "凯厄纳",
    traditionalName: "凱厄納",
    airports: [
      {
        code: "IAN",
        name: "Bob baker memorial",
        chineseName: "鲍勃巴克－梅莫里阿尔机场",
        traditionalName: "鮑勃巴克－梅莫裏阿爾機場",
      },
    ],
  },
  IAO: {
    code: "IAO",
    name: "DEL CARMEN (SIARGAO)",
    chineseName: "锡亚高",
    traditionalName: "錫亞高",
    airports: [
      {
        code: "IAO",
        name: "Sayak",
        chineseName: "锡亚高机场",
        traditionalName: "錫亞高機場",
      },
    ],
  },
  IAR: {
    code: "IAR",
    name: "YAROSLAVL",
    chineseName: "雅罗斯拉夫尔",
    traditionalName: "雅羅斯拉夫爾",
    airports: [
      {
        code: "IAR",
        name: "Tunoshna",
        chineseName: "托诺西那机场",
        traditionalName: "托諾西那機場",
      },
    ],
  },
  IAS: {
    code: "IAS",
    name: "IASI",
    chineseName: "雅西",
    traditionalName: "雅西",
    airports: [
      {
        code: "IAS",
        name: "Iasi airport",
        chineseName: "雅西机场",
        traditionalName: "雅西機場",
      },
    ],
  },
  IBA: {
    code: "IBA",
    name: "IBADAN",
    chineseName: "伊巴丹",
    traditionalName: "伊巴丹",
    airports: [
      {
        code: "IBA",
        name: "Ibadan airport",
        chineseName: "伊巴丹机场",
        traditionalName: "伊巴丹機場",
      },
    ],
  },
  IBB: {
    code: "IBB",
    name: "ISABELA ISLAND",
    chineseName: "伊莎贝拉岛城",
    traditionalName: "伊莎貝拉島城",
    airports: [
      {
        code: "IBB",
        name: "General villamil",
        chineseName: "伊莎贝拉岛机场",
        traditionalName: "伊莎貝拉島機場",
      },
    ],
  },
  IBE: {
    code: "IBE",
    name: "IBAGUE",
    chineseName: "伊瓦格",
    traditionalName: "伊瓦格",
    airports: [
      {
        code: "IBE",
        name: "Perales",
        chineseName: "佩拉莱斯机场",
        traditionalName: "佩拉萊斯機場",
      },
    ],
  },
  IBR: {
    code: "IBR",
    name: "IBARAKI",
    chineseName: "茨城",
    traditionalName: "茨城",
    airports: [
      {
        code: "IBR",
        name: "Ibaraki airport",
        chineseName: "茨城机场",
        traditionalName: "茨城機場",
      },
    ],
  },
  IBZ: {
    code: "IBZ",
    name: "IBIZA",
    chineseName: "伊比萨岛",
    traditionalName: "伊比薩島",
    airports: [
      {
        code: "IBZ",
        name: "Ibiza airport",
        chineseName: "伊比萨机场",
        traditionalName: "伊比薩機場",
      },
    ],
  },
  ICI: {
    code: "ICI",
    name: "CICIA ISLAND",
    chineseName: "西西亚",
    traditionalName: "西西亞",
    airports: [
      {
        code: "ICI",
        name: "Cicia island airport",
        chineseName: "西西亚机场",
        traditionalName: "西西亞機場",
      },
    ],
  },
  ICT: {
    code: "ICT",
    name: "WICHITA",
    chineseName: "威奇托",
    traditionalName: "威奇托",
    airports: [
      {
        code: "ICT",
        name: "Dwight d. eisenhower",
        chineseName: "米德康提嫩特机场",
        traditionalName: "米德康提嫩特機場",
      },
    ],
  },
  IDA: {
    code: "IDA",
    name: "IDAHO FALLS",
    chineseName: "爱达福尔斯",
    traditionalName: "愛達福爾斯",
    airports: [
      {
        code: "IDA",
        name: "Idaho falls reg. airport",
        chineseName: "爱达荷福尔斯机场",
        traditionalName: "愛德荷福爾斯機場",
      },
    ],
  },
  IDR: {
    code: "IDR",
    name: "INDORE",
    chineseName: "印多尔",
    traditionalName: "印多爾",
    airports: [
      {
        code: "IDR",
        name: "Devi ahilya bai holkar",
        chineseName: "戴维阿喜亚拜霍尔卡机场",
        traditionalName: "大衛阿喜亞拜霍爾卡機場",
      },
    ],
  },
  IEG: {
    code: "IEG",
    name: "ZIELONA GORA",
    chineseName: "巴比莫斯特",
    traditionalName: "巴比莫斯特",
    airports: [
      {
        code: "IEG",
        name: "Babimost",
        chineseName: "巴比莫斯特机场",
        traditionalName: "巴比莫斯特機場",
      },
    ],
  },
  IEV: {
    code: "IEV",
    name: "KYIV",
    chineseName: "基辅",
    traditionalName: "基輔",
    airports: [
      {
        code: "IEV",
        name: "Zhuliany intl",
        chineseName: "伊戈尔·西科尔斯基基辅国际机场",
        traditionalName: "伊戈爾·西科爾斯基基輔國際機場",
      },
      {
        code: "KBP",
        name: "Boryspil intl",
        chineseName: "鲍里斯波尔国际机场",
        traditionalName: "鮑裏斯波爾國際機場",
      },
    ],
  },
  IFJ: {
    code: "IFJ",
    name: "ISAFJORDUR",
    chineseName: "伊萨菲尔德",
    traditionalName: "伊薩菲爾德",
    airports: [
      {
        code: "IFJ",
        name: "Isafjordur airport",
        chineseName: "伊萨菲尔德机场",
        traditionalName: "伊薩菲爾德機場",
      },
    ],
  },
  IFN: {
    code: "IFN",
    name: "ESFAHAN",
    chineseName: "伊斯法罕",
    traditionalName: "伊斯法罕",
    airports: [
      {
        code: "IFN",
        name: "Shahid beheshti intl",
        chineseName: "伊斯法罕机场",
        traditionalName: "伊斯法罕機場",
      },
    ],
  },
  IFP: {
    code: "IFP",
    name: "BULLHEAD CITY",
    chineseName: "亚利桑那州布尔海德",
    traditionalName: "亞利桑那州布林海德",
    airports: [
      {
        code: "IFP",
        name: "Laughlin/bullhead intl",
        chineseName: "布尔黑德城机场",
        traditionalName: "布林黑德城機場",
      },
    ],
  },
  IFU: {
    code: "IFU",
    name: "IFURU",
    chineseName: "伊瑚鲁",
    traditionalName: "伊瑚魯",
    airports: [
      {
        code: "IFU",
        name: "Ifuru airport",
        chineseName: "伊瑚鲁机场",
        traditionalName: "伊瑚魯機場",
      },
    ],
  },
  IGA: {
    code: "IGA",
    name: "INAGUA",
    chineseName: "马特维城",
    traditionalName: "馬特維城",
    airports: [
      {
        code: "IGA",
        name: "Matthew town",
        chineseName: "伊纳瓜群岛机场",
        traditionalName: "伊納瓜群島機場",
      },
    ],
  },
  IGD: {
    code: "IGD",
    name: "IGDIR",
    chineseName: "厄德尔",
    traditionalName: "厄德爾",
    airports: [
      {
        code: "IGD",
        name: "Igdir airport",
        chineseName: "厄德尔",
        traditionalName: "厄德爾",
      },
    ],
  },
  IGG: {
    code: "IGG",
    name: "IGIUGIG",
    chineseName: "阿拉斯加市伊吉吉",
    traditionalName: "阿拉斯加市伊吉吉",
    airports: [
      {
        code: "IGG",
        name: "Igiugig airport",
        chineseName: "伊久吉格机场",
        traditionalName: "伊久吉格機場",
      },
    ],
  },
  IGR: {
    code: "IGR",
    name: "IGUAZU",
    chineseName: "伊瓜苏",
    traditionalName: "伊瓜蘇",
    airports: [
      {
        code: "IGR",
        name: "Cataratas del iguazu",
        chineseName: "伊瓜苏瀑布国际机场",
        traditionalName: "伊瓜蘇瀑布國際機場",
      },
    ],
  },
  IGU: {
    code: "IGU",
    name: "FOZ DO IGUACU",
    chineseName: "福斯杜伊瓜苏",
    traditionalName: "福斯杜伊瓜蘇",
    airports: [
      {
        code: "IGU",
        name: "Cataratas intl",
        chineseName: "福斯伊瓜苏国际机场",
        traditionalName: "福斯伊瓜蘇國際機場",
      },
    ],
  },
  IHR: {
    code: "IHR",
    name: "IRANSHAHR",
    chineseName: "伊朗沙赫尔",
    traditionalName: "伊朗沙赫爾",
    airports: [
      {
        code: "IHR",
        name: "Iranshahr airport",
        chineseName: "伊朗沙赫尔机场",
        traditionalName: "伊朗沙赫爾機場",
      },
    ],
  },
  IIA: {
    code: "IIA",
    name: "INISHMAAN",
    chineseName: "伊尼什曼岛",
    traditionalName: "伊尼什曼島",
    airports: [
      {
        code: "IIA",
        name: "Inishmaan airport",
        chineseName: "伊尼什曼岛机场",
        traditionalName: "伊尼什曼島機場",
      },
    ],
  },
  IIL: {
    code: "IIL",
    name: "ILAM",
    chineseName: "伊拉姆",
    traditionalName: "伊拉姆",
    airports: [
      {
        code: "IIL",
        name: "Ilam airport",
        chineseName: "伊拉姆机场",
        traditionalName: "伊拉姆機場",
      },
    ],
  },
  IJK: {
    code: "IJK",
    name: "IZHEVSK",
    chineseName: "伊热夫斯克",
    traditionalName: "伊熱夫斯克",
    airports: [
      {
        code: "IJK",
        name: "Izhevsk airport",
        chineseName: "伊热夫斯克机场",
        traditionalName: "伊熱夫斯克機場",
      },
    ],
  },
  IKI: {
    code: "IKI",
    name: "IKI",
    chineseName: "壹岐",
    traditionalName: "壹岐",
    airports: [
      {
        code: "IKI",
        name: "Iki airport",
        chineseName: "壹歧机场",
        traditionalName: "壹歧機場",
      },
    ],
  },
  IKO: {
    code: "IKO",
    name: "NIKOLSKI",
    chineseName: "阿拉斯加州尼科尔斯基",
    traditionalName: "阿拉斯加州尼科爾斯基",
    airports: [
      {
        code: "IKO",
        name: "Air station",
        chineseName: "尼古尔斯基机场",
        traditionalName: "尼古爾斯基機場",
      },
    ],
  },
  IKS: {
    code: "IKS",
    name: "TIKSI",
    chineseName: "蒂克西",
    traditionalName: "蒂克西",
    airports: [
      {
        code: "IKS",
        name: "Tiksi airport",
        chineseName: "季克西机场",
        traditionalName: "季克西機場",
      },
    ],
  },
  IKT: {
    code: "IKT",
    name: "IRKUTSK",
    chineseName: "伊尔库茨克",
    traditionalName: "伊爾庫茨克",
    airports: [
      {
        code: "IKT",
        name: "Irkutsk airport",
        chineseName: "伊尔库茨克机场",
        traditionalName: "伊爾庫茨克機場",
      },
    ],
  },
  IKU: {
    code: "IKU",
    name: "TAMCHY",
    chineseName: "坦奇",
    traditionalName: "坦奇",
    airports: [
      {
        code: "IKU",
        name: "Issyk-kul",
        chineseName: "伊塞克机场",
        traditionalName: "伊塞克機場",
      },
    ],
  },
  ILD: {
    code: "ILD",
    name: "LLEIDA",
    chineseName: "莱里达",
    traditionalName: "萊裡達",
    airports: [
      {
        code: "ILD",
        name: "Alguaire",
        chineseName: "莱里达-阿尔瓜伊雷机场",
        traditionalName: "萊裡達-阿爾瓜伊雷機場",
      },
    ],
  },
  ILE: {
    code: "ILE",
    name: "KILLEEN/FORT HOOD",
    chineseName: "基林/胡德堡",
    traditionalName: "基林/胡德堡",
    airports: [
      {
        code: "GRK",
        name: "Regional/r.gray aaf",
        chineseName: "格雷军用机场",
        traditionalName: "格雷軍用機場",
      },
    ],
  },
  ILG: {
    code: "ILG",
    name: "WILMINGTON",
    chineseName: "威尔明顿",
    traditionalName: "威爾明頓",
    airports: [
      {
        code: "ILG",
        name: "New castle",
        chineseName: "纽卡斯尔机场",
        traditionalName: "紐卡斯爾機場",
      },
    ],
  },
  ILI: {
    code: "ILI",
    name: "ILIAMNA",
    chineseName: "伊利亚姆纳",
    traditionalName: "伊利亞姆納",
    airports: [
      {
        code: "ILI",
        name: "Iliamna airport",
        chineseName: "伊里亚姆纳机场",
        traditionalName: "伊裏亞姆納機場",
      },
    ],
  },
  ILM: {
    code: "ILM",
    name: "WILMINGTON",
    chineseName: "威尔明顿",
    traditionalName: "威爾明頓",
    airports: [
      {
        code: "ILM",
        name: "Wilmington intl.",
        chineseName: "威尔明顿国际机场",
        traditionalName: "威爾明頓國際機場",
      },
    ],
  },
  ILN: {
    code: "ILN",
    name: "WILMINGTON",
    chineseName: "威尔明顿",
    traditionalName: "威爾明頓",
    airports: [
      {
        code: "ILN",
        name: "Air park",
        chineseName: "威明顿市机场",
        traditionalName: "威明頓市機場",
      },
    ],
  },
  ILO: {
    code: "ILO",
    name: "ILOILO",
    chineseName: "伊洛伊洛",
    traditionalName: "伊洛伊洛",
    airports: [
      {
        code: "ILO",
        name: "Iloilo intl.",
        chineseName: "伊洛伊洛国际机场",
        traditionalName: "伊洛伊洛國際機場",
      },
    ],
  },
  ILP: {
    code: "ILP",
    name: "ILE DES PINS",
    chineseName: "松树岛",
    traditionalName: "松樹島",
    airports: [
      {
        code: "ILP",
        name: "Moue",
        chineseName: "松树岛机场",
        traditionalName: "松樹島機場",
      },
    ],
  },
  ILR: {
    code: "ILR",
    name: "ILORIN",
    chineseName: "伊洛林",
    traditionalName: "伊哈林",
    airports: [
      {
        code: "ILR",
        name: "Ilorin intl.",
        chineseName: "伊洛林机场",
        traditionalName: "伊哈林機場",
      },
    ],
  },
  ILY: {
    code: "ILY",
    name: "ISLAY",
    chineseName: "艾莱",
    traditionalName: "艾萊",
    airports: [
      {
        code: "ILY",
        name: "Islay airport",
        chineseName: "艾莱岛机场",
        traditionalName: "艾萊島機場",
      },
    ],
  },
  IMF: {
    code: "IMF",
    name: "IMPHAL",
    chineseName: "英帕尔",
    traditionalName: "恩帕爾",
    airports: [
      {
        code: "IMF",
        name: "Imphal airport",
        chineseName: "英帕尔机场",
        traditionalName: "恩帕爾機場",
      },
    ],
  },
  IMK: {
    code: "IMK",
    name: "SIMIKOT",
    chineseName: "希米科特",
    traditionalName: "希米科特",
    airports: [
      {
        code: "IMK",
        name: "Simikot airport",
        chineseName: "希米科特机场",
        traditionalName: "希米科特機場",
      },
    ],
  },
  IMP: {
    code: "IMP",
    name: "IMPERATRIZ",
    chineseName: "因佩拉特里斯",
    traditionalName: "因佩拉特里斯",
    airports: [
      {
        code: "IMP",
        name: "Renato moreira",
        chineseName: "因佩拉特里斯机场",
        traditionalName: "因佩拉特里斯機場",
      },
    ],
  },
  IMQ: {
    code: "IMQ",
    name: "MAKU",
    chineseName: "马库",
    traditionalName: "馬庫",
    airports: [
      {
        code: "IMQ",
        name: "Maku airport",
        chineseName: "马库机场",
        traditionalName: "馬庫機場",
      },
    ],
  },
  IMT: {
    code: "IMT",
    name: "IRON MOUNTAIN/KINGSFD.",
    chineseName: "艾恩芒廷",
    traditionalName: "艾恩芒廷",
    airports: [
      {
        code: "IMT",
        name: "Ford",
        chineseName: "福德机场",
        traditionalName: "福德機場",
      },
    ],
  },
  INB: {
    code: "INB",
    name: "INDEPENDENCE",
    chineseName: "印地潘登斯",
    traditionalName: "印地潘登斯",
    airports: [
      {
        code: "INB",
        name: "Independence airport",
        chineseName: "独立城机场",
        traditionalName: "獨立城機場",
      },
    ],
  },
  INC: {
    code: "INC",
    name: "YINCHUAN",
    chineseName: "银川",
    traditionalName: "銀川",
    airports: [
      {
        code: "INC",
        name: "Hedong",
        chineseName: "河东机场",
        traditionalName: "河東機場",
      },
    ],
  },
  IND: {
    code: "IND",
    name: "INDIANAPOLIS",
    chineseName: "印第安纳波利斯",
    traditionalName: "印弟安納波里斯",
    airports: [
      {
        code: "IND",
        name: "Indianapolis intl.",
        chineseName: "印第安纳波利斯国际机场",
        traditionalName: "印弟安納波里斯國際機場",
      },
    ],
  },
  INF: {
    code: "INF",
    name: "IN GUEZZAM",
    chineseName: "因盖扎姆",
    traditionalName: "因蓋紮姆",
    airports: [
      {
        code: "INF",
        name: "In guezzam airport",
        chineseName: "因盖扎姆机场",
        traditionalName: "因蓋紮姆機場",
      },
    ],
  },
  INH: {
    code: "INH",
    name: "INHAMBANE",
    chineseName: "伊尼扬巴内",
    traditionalName: "伊尼揚巴內",
    airports: [
      {
        code: "INH",
        name: "Inhambane airport",
        chineseName: "伊尼扬巴内机场",
        traditionalName: "伊尼揚巴內機場",
      },
    ],
  },
  INI: {
    code: "INI",
    name: "NIS",
    chineseName: "尼什",
    traditionalName: "尼什",
    airports: [
      {
        code: "INI",
        name: "Konstantin veliki",
        chineseName: "尼什机场",
        traditionalName: "尼什機場",
      },
    ],
  },
  INL: {
    code: "INL",
    name: "INTERNATIONAL FALLS",
    chineseName: "明尼苏达州国际瀑布",
    traditionalName: "明尼蘇達州國際瀑布",
    airports: [
      {
        code: "INL",
        name: "Falls international",
        chineseName: "国际瀑布城机场",
        traditionalName: "國際瀑布城機場",
      },
    ],
  },
  INN: {
    code: "INN",
    name: "INNSBRUCK",
    chineseName: "因斯布鲁克",
    traditionalName: "因斯布魯克",
    airports: [
      {
        code: "INN",
        name: "Innsbruck airport",
        chineseName: "因斯布鲁克机场",
        traditionalName: "因斯布魯克機場",
      },
    ],
  },
  INO: {
    code: "INO",
    name: "INONGO",
    chineseName: "伊农戈",
    traditionalName: "伊農戈",
    airports: [
      {
        code: "INO",
        name: "Inongo airport",
        chineseName: "伊农戈机场",
        traditionalName: "伊農戈機場",
      },
    ],
  },
  INQ: {
    code: "INQ",
    name: "INISHEER",
    chineseName: "伊尼希尔岛",
    traditionalName: "伊尼希爾島",
    airports: [
      {
        code: "INQ",
        name: "Inisheer airport",
        chineseName: "伊尼希尔岛机场",
        traditionalName: "伊尼希爾島機場",
      },
    ],
  },
  INU: {
    code: "INU",
    name: "NAURU ISLAND",
    chineseName: "瑙鲁岛",
    traditionalName: "瑙魯島",
    airports: [
      {
        code: "INU",
        name: "Nauru island intl.",
        chineseName: "瑙鲁岛国际机场",
        traditionalName: "瑙魯島國際機場",
      },
    ],
  },
  INV: {
    code: "INV",
    name: "INVERNESS",
    chineseName: "因弗内斯",
    traditionalName: "因弗內斯",
    airports: [
      {
        code: "INV",
        name: "Inverness airport",
        chineseName: "因纹内丝机场",
        traditionalName: "因紋內絲機場",
      },
    ],
  },
  INZ: {
    code: "INZ",
    name: "IN SALAH",
    chineseName: "因萨拉赫",
    traditionalName: "因薩拉赫",
    airports: [
      {
        code: "INZ",
        name: "In salah airport",
        chineseName: "因萨拉赫机场",
        traditionalName: "因薩拉赫機場",
      },
    ],
  },
  IOA: {
    code: "IOA",
    name: "IOANNINA",
    chineseName: "约阿尼纳",
    traditionalName: "約阿尼納",
    airports: [
      {
        code: "IOA",
        name: "King pyrros",
        chineseName: "约阿尼纳机场",
        traditionalName: "約阿尼納機場",
      },
    ],
  },
  IOM: {
    code: "IOM",
    name: "ISLE OF MAN",
    chineseName: "马恩岛机场",
    traditionalName: "曼島機場",
    airports: [
      {
        code: "IOM",
        name: "Ronaldsway",
        chineseName: "罗纳尔兹威机场",
        traditionalName: "羅納爾茲威機場",
      },
    ],
  },
  ION: {
    code: "ION",
    name: "IMPFONDO",
    chineseName: "因普丰多",
    traditionalName: "因普豐多",
    airports: [
      {
        code: "ION",
        name: "Impfondo airport",
        chineseName: "因普丰多机场",
        traditionalName: "因普豐多機場",
      },
    ],
  },
  IOR: {
    code: "IOR",
    name: "INISHMORE",
    chineseName: "伊尼什莫尔岛",
    traditionalName: "伊尼什莫爾島",
    airports: [
      {
        code: "IOR",
        name: "Kilronan",
        chineseName: "伊尼什莫尔岛机场",
        traditionalName: "伊尼什莫爾島機場",
      },
    ],
  },
  IOS: {
    code: "IOS",
    name: "ILHEUS",
    chineseName: "伊列乌斯",
    traditionalName: "伊列烏斯",
    airports: [
      {
        code: "IOS",
        name: "Jorge amado",
        chineseName: "豪尔赫阿马多机场",
        traditionalName: "豪爾赫阿馬多機場",
      },
    ],
  },
  IPA: {
    code: "IPA",
    name: "IPOTA",
    chineseName: "伊波塔",
    traditionalName: "伊波塔",
    airports: [
      {
        code: "IPA",
        name: "Ipota airport",
        chineseName: "伊波塔机场",
        traditionalName: "伊波塔機場",
      },
    ],
  },
  IPC: {
    code: "IPC",
    name: "EASTER ISLAND",
    chineseName: "复活节岛",
    traditionalName: "復活節島",
    airports: [
      {
        code: "IPC",
        name: "Mataveri intl",
        chineseName: "马塔维利国际机场",
        traditionalName: "馬塔維利國際機場",
      },
    ],
  },
  IPH: {
    code: "IPH",
    name: "IPOH",
    chineseName: "怡保",
    traditionalName: "怡保",
    airports: [
      {
        code: "IPH",
        name: "Sultan azlan shah",
        chineseName: "怡保机场",
        traditionalName: "怡保機場",
      },
    ],
  },
  IPI: {
    code: "IPI",
    name: "IPIALES",
    chineseName: "怡皮阿尔斯",
    traditionalName: "怡皮阿爾斯",
    airports: [
      {
        code: "IPI",
        name: "San luis",
        chineseName: "圣路易斯机场",
        traditionalName: "聖路易斯機場",
      },
    ],
  },
  IPL: {
    code: "IPL",
    name: "IMPERIAL/EL CENTRO",
    chineseName: "因皮里尔",
    traditionalName: "因皮裏爾",
    airports: [
      {
        code: "IPL",
        name: "Imperial county",
        chineseName: "因皮里尔郡机场",
        traditionalName: "因皮里爾郡機場",
      },
    ],
  },
  IPN: {
    code: "IPN",
    name: "IPATINGA",
    chineseName: "伊帕廷加",
    traditionalName: "伊帕廷加",
    airports: [
      {
        code: "IPN",
        name: "Usiminas",
        chineseName: "尤西米纳斯机场",
        traditionalName: "尤西米納斯機場",
      },
    ],
  },
  IPT: {
    code: "IPT",
    name: "WILLIAMSPORT",
    chineseName: "威廉斯波特",
    traditionalName: "威廉斯波特",
    airports: [
      {
        code: "IPT",
        name: "Williamsport reg. airport",
        chineseName: "威廉斯波特机场",
        traditionalName: "威廉斯波特機場",
      },
    ],
  },
  IQA: {
    code: "IQA",
    name: "AL ASAD",
    chineseName: "阿萨德",
    traditionalName: "阿塞德",
    airports: [
      {
        code: "IQA",
        name: "Air base",
        chineseName: "艾尔阿萨德空军基地机场",
        traditionalName: "艾爾阿薩德空軍基地機場",
      },
    ],
  },
  IQM: {
    code: "IQM",
    name: "QIEMO",
    chineseName: "且末",
    traditionalName: "且末",
    airports: [
      {
        code: "IQM",
        name: "Qiemo airport",
        chineseName: "且末机场",
        traditionalName: "且末機場",
      },
    ],
  },
  IQN: {
    code: "IQN",
    name: "QINGYANG",
    chineseName: "庆阳",
    traditionalName: "慶陽",
    airports: [
      {
        code: "IQN",
        name: "Qingyang airport",
        chineseName: "庆阳机场",
        traditionalName: "慶陽機場",
      },
    ],
  },
  IQQ: {
    code: "IQQ",
    name: "IQUIQUE",
    chineseName: "伊基克",
    traditionalName: "伊基克",
    airports: [
      {
        code: "IQQ",
        name: "Diego aracena",
        chineseName: "迭戈阿拉塞纳国际机场",
        traditionalName: "迭戈阿拉塞納國際機場",
      },
    ],
  },
  IQT: {
    code: "IQT",
    name: "IQUITOS",
    chineseName: "伊基托斯",
    traditionalName: "伊基托斯",
    airports: [
      {
        code: "IQT",
        name: "F.secada vignetta",
        chineseName: "塞卡达机场",
        traditionalName: "塞卡達機場",
      },
    ],
  },
  IRA: {
    code: "IRA",
    name: "KIRAKIRA",
    chineseName: "基拉基拉",
    traditionalName: "基拉基拉",
    airports: [
      {
        code: "IRA",
        name: "Kirakira airport",
        chineseName: "基拉基拉机场",
        traditionalName: "基拉基拉機場",
      },
    ],
  },
  IRC: {
    code: "IRC",
    name: "CIRCLE",
    chineseName: "阿拉斯加州城市Circl",
    traditionalName: "阿拉斯加州都市Circl",
    airports: [
      {
        code: "IRC",
        name: "Circle city",
        chineseName: "瑟克尔市机场",
        traditionalName: "瑟克爾市機場",
      },
    ],
  },
  IRG: {
    code: "IRG",
    name: "LOCKHART RIVER",
    chineseName: "洛克哈特河",
    traditionalName: "洛克哈特河",
    airports: [
      {
        code: "IRG",
        name: "Lockhart river airport",
        chineseName: "洛克哈特河机场",
        traditionalName: "洛克哈特河機場",
      },
    ],
  },
  IRI: {
    code: "IRI",
    name: "IRINGA",
    chineseName: "伊林加",
    traditionalName: "伊林加",
    airports: [
      {
        code: "IRI",
        name: "Iringa airport",
        chineseName: "伊林加机场",
        traditionalName: "伊林加機場",
      },
    ],
  },
  IRJ: {
    code: "IRJ",
    name: "LA RIOJA",
    chineseName: "拉里奥哈",
    traditionalName: "拉里奧哈",
    airports: [
      {
        code: "IRJ",
        name: "Captain v.a. almonacid",
        chineseName: "拉里奥哈机场",
        traditionalName: "拉里奧哈機場",
      },
    ],
  },
  IRK: {
    code: "IRK",
    name: "KIRKSVILLE",
    chineseName: "柯克斯维尔",
    traditionalName: "柯克斯維爾",
    airports: [
      {
        code: "IRK",
        name: "Kirksville reg. airport",
        chineseName: "柯克斯维尔地方机场",
        traditionalName: "柯克斯維爾地方機場",
      },
    ],
  },
  IRM: {
    code: "IRM",
    name: "IGRIM",
    chineseName: "伊格里姆",
    traditionalName: "伊格裡姆",
    airports: [
      {
        code: "IRM",
        name: "Igrim airport",
        chineseName: "伊格里姆机场",
        traditionalName: "伊格裡姆機場",
      },
    ],
  },
  IRP: {
    code: "IRP",
    name: "ISIRO",
    chineseName: "伊西罗",
    traditionalName: "伊西羅",
    airports: [
      {
        code: "IRP",
        name: "Matari",
        chineseName: "马塔利机场",
        traditionalName: "馬塔利機場",
      },
    ],
  },
  IRZ: {
    code: "IRZ",
    name: "SANTA ISABEL RIO NEGRO",
    chineseName: "内格罗河畔圣伊沙贝尔",
    traditionalName: "內格羅河畔聖伊沙貝爾",
    airports: [
      {
        code: "IRZ",
        name: "Tapuruquara",
        chineseName: "内格罗河畔圣伊沙贝尔机场",
        traditionalName: "內格羅河畔聖伊沙貝爾機場",
      },
    ],
  },
  ISA: {
    code: "ISA",
    name: "MOUNT ISA",
    chineseName: "芒特艾达",
    traditionalName: "芒特艾達",
    airports: [
      {
        code: "ISA",
        name: "Mount isa airport",
        chineseName: "芒特艾达机场",
        traditionalName: "芒特艾達機場",
      },
    ],
  },
  ISB: {
    code: "ISB",
    name: "ISLAMABAD",
    chineseName: "伊斯兰堡",
    traditionalName: "伊斯蘭馬巴德",
    airports: [
      {
        code: "ISB",
        name: "Islamabad intl.",
        chineseName: "伊斯兰堡奎德·E·阿扎姆国际机场",
        traditionalName: "伊斯蘭馬巴德奎德·E·阿紮姆國際機場",
      },
    ],
  },
  ISC: {
    code: "ISC",
    name: "ISLES OF SCILLY",
    chineseName: "锡利群岛",
    traditionalName: "錫利群島",
    airports: [
      {
        code: "ISC",
        name: "St mary's",
        chineseName: "圣马里机场",
        traditionalName: "聖馬裏機場",
      },
    ],
  },
  ISE: {
    code: "ISE",
    name: "ISPARTA",
    chineseName: "伊斯帕尔塔",
    traditionalName: "伊斯帕爾塔",
    airports: [
      {
        code: "ISE",
        name: "Suleyman demirel",
        chineseName: "伊斯帕尔塔机场",
        traditionalName: "伊斯帕爾塔機場",
      },
    ],
  },
  ISG: {
    code: "ISG",
    name: "ISHIGAKI",
    chineseName: "冲绳",
    traditionalName: "沖繩",
    airports: [
      {
        code: "ISG",
        name: "New ishigaki",
        chineseName: "石垣机场",
        traditionalName: "石垣機場",
      },
    ],
  },
  ISK: {
    code: "ISK",
    name: "NASIK",
    chineseName: "纳西克",
    traditionalName: "納西克",
    airports: [
      {
        code: "ISK",
        name: "Ozar",
        chineseName: "甘地讷格尔机场",
        traditionalName: "甘地訥格爾機場",
      },
    ],
  },
  ISN: {
    code: "ISN",
    name: "WILLISTON",
    chineseName: "威利斯顿",
    traditionalName: "威利斯頓",
    airports: [
      {
        code: "XWA",
        name: "Basin international",
        chineseName: "威利斯顿盆地国际机场",
        traditionalName: "威利斯頓盆地國際機場",
      },
    ],
  },
  ISP: {
    code: "ISP",
    name: "ISLIP",
    chineseName: "隆康科马",
    traditionalName: "隆康科馬",
    airports: [
      {
        code: "ISP",
        name: "Long island macarthur",
        chineseName: "长岛麦克阿瑟机场",
        traditionalName: "長島麥克亞瑟機場",
      },
    ],
  },
  IST: {
    code: "IST",
    name: "ISTANBUL",
    chineseName: "伊斯坦布尔",
    traditionalName: "伊斯坦布爾",
    airports: [
      {
        code: "ISL",
        name: "Ataturk",
        chineseName: "伊莎贝尔帕斯机场",
        traditionalName: "伊莎貝爾帕斯機場",
      },
      {
        code: "IST",
        name: "Istanbul airport",
        chineseName: "伊斯坦布尔新国际机场",
        traditionalName: "伊斯坦布爾新國際機場",
      },
      {
        code: "SAW",
        name: "Sabiha gokcen",
        chineseName: "萨比哈哥克赛恩机场",
        traditionalName: "薩比哈哥克賽恩機場",
      },
    ],
  },
  ISU: {
    code: "ISU",
    name: "SULAYMANIYAH",
    chineseName: "苏莱曼尼亚",
    traditionalName: "蘇萊曼尼亞",
    airports: [
      {
        code: "ISU",
        name: "Sulaymaniyah intl.",
        chineseName: "苏莱曼尼亚国际机场",
        traditionalName: "蘇萊曼尼亞國際機場",
      },
    ],
  },
  ITB: {
    code: "ITB",
    name: "ITAITUBA",
    chineseName: "伊泰图巴",
    traditionalName: "伊泰圖巴",
    airports: [
      {
        code: "ITB",
        name: "Itaituba airport",
        chineseName: "伊泰图巴机场",
        traditionalName: "伊泰圖巴機場",
      },
    ],
  },
  ITH: {
    code: "ITH",
    name: "ITHACA",
    chineseName: "伊萨卡",
    traditionalName: "伊薩卡",
    airports: [
      {
        code: "ITH",
        name: "Tompkins regional",
        chineseName: "汤普金斯机场",
        traditionalName: "湯普金斯機場",
      },
    ],
  },
  ITO: {
    code: "ITO",
    name: "HILO",
    chineseName: "希洛",
    traditionalName: "希洛",
    airports: [
      {
        code: "ITO",
        name: "Hilo intl.",
        chineseName: "希洛国际机场",
        traditionalName: "希洛國際機場",
      },
    ],
  },
  ITU: {
    code: "ITU",
    name: "ITURUP ISLAND",
    chineseName: "伊土鲁朴岛",
    traditionalName: "伊土魯樸島",
    airports: [
      {
        code: "ITU",
        name: "Iturup",
        chineseName: "择捉岛机场",
        traditionalName: "擇捉島機場",
      },
    ],
  },
  IUE: {
    code: "IUE",
    name: "NIUE ISLAND",
    chineseName: "纽埃岛",
    traditionalName: "紐埃島",
    airports: [
      {
        code: "IUE",
        name: "Niue island intl.",
        chineseName: "哈南机场",
        traditionalName: "哈南機場",
      },
    ],
  },
  IVC: {
    code: "IVC",
    name: "INVERCARGILL",
    chineseName: "因弗卡吉尔",
    traditionalName: "因弗卡吉耳",
    airports: [
      {
        code: "IVC",
        name: "Invercargill airport",
        chineseName: "因弗卡吉尔机场",
        traditionalName: "因弗卡吉耳機場",
      },
    ],
  },
  IVL: {
    code: "IVL",
    name: "IVALO",
    chineseName: "伊瓦洛",
    traditionalName: "伊瓦洛",
    airports: [
      {
        code: "IVL",
        name: "Ivalo airport",
        chineseName: "伊伐洛机场",
        traditionalName: "伊伐洛機場",
      },
    ],
  },
  IVR: {
    code: "IVR",
    name: "INVERELL",
    chineseName: "因弗雷尔",
    traditionalName: "因弗雷爾",
    airports: [
      {
        code: "IVR",
        name: "Inverell airport",
        chineseName: "因弗雷尔机场",
        traditionalName: "因弗雷爾機場",
      },
    ],
  },
  IWA: {
    code: "IWA",
    name: "IVANOVO",
    chineseName: "伊万诺沃",
    traditionalName: "伊萬諾沃",
    airports: [
      {
        code: "IWA",
        name: "Yuzhny",
        chineseName: "伊万诺沃机场",
        traditionalName: "伊萬諾沃機場",
      },
    ],
  },
  IWD: {
    code: "IWD",
    name: "IRONWOOD",
    chineseName: "艾恩伍德",
    traditionalName: "艾恩伍德",
    airports: [
      {
        code: "IWD",
        name: "Gogebic-iron county",
        chineseName: "戈格比克郡机场",
        traditionalName: "戈格比克郡機場",
      },
    ],
  },
  IWJ: {
    code: "IWJ",
    name: "MASUDA",
    chineseName: "益田市",
    traditionalName: "益田市",
    airports: [
      {
        code: "IWJ",
        name: "Iwami",
        chineseName: "岩见机场",
        traditionalName: "岩見機場",
      },
    ],
  },
  IWK: {
    code: "IWK",
    name: "IWAKUNI",
    chineseName: "岩国",
    traditionalName: "岩國",
    airports: [
      {
        code: "IWK",
        name: "Iwakuni airport",
        chineseName: "岩国机场",
        traditionalName: "岩國機場",
      },
    ],
  },
  IXA: {
    code: "IXA",
    name: "AGARTALA",
    chineseName: "阿加尔塔拉",
    traditionalName: "阿加爾塔拉",
    airports: [
      {
        code: "IXA",
        name: "Agartala airport",
        chineseName: "阿加尔塔拉机场",
        traditionalName: "阿加爾塔拉機場",
      },
    ],
  },
  IXB: {
    code: "IXB",
    name: "BAGDOGRA",
    chineseName: "巴格多格拉",
    traditionalName: "巴格多格拉",
    airports: [
      {
        code: "IXB",
        name: "Bagdogra airport",
        chineseName: "巴格多格拉机场",
        traditionalName: "巴格多格拉機場",
      },
    ],
  },
  IXC: {
    code: "IXC",
    name: "CHANDIGARH",
    chineseName: "昌迪加尔",
    traditionalName: "昌迪加爾",
    airports: [
      {
        code: "IXC",
        name: "Chandigarh airport",
        chineseName: "钱迪加机场",
        traditionalName: "錢迪加機場",
      },
    ],
  },
  IXD: {
    code: "IXD",
    name: "ALLAHABAD",
    chineseName: "安拉阿巴德",
    traditionalName: "安拉阿巴德",
    airports: [
      {
        code: "IXD",
        name: "Allahabad airport",
        chineseName: "阿拉哈巴德机场",
        traditionalName: "阿拉哈巴德機場",
      },
    ],
  },
  IXE: {
    code: "IXE",
    name: "MANGALORE",
    chineseName: "芒格洛尔",
    traditionalName: "芒格洛爾",
    airports: [
      {
        code: "IXE",
        name: "Mangalore airport",
        chineseName: "芒伽罗机场",
        traditionalName: "芒伽羅機場",
      },
    ],
  },
  IXG: {
    code: "IXG",
    name: "BELGAUM",
    chineseName: "贝尔高姆",
    traditionalName: "貝爾高姆",
    airports: [
      {
        code: "IXG",
        name: "Sambre",
        chineseName: "萨姆布勒机场",
        traditionalName: "薩姆布勒機場",
      },
    ],
  },
  IXI: {
    code: "IXI",
    name: "LILABARI",
    chineseName: "利拉巴里",
    traditionalName: "利拉巴里",
    airports: [
      {
        code: "IXI",
        name: "Lilabari airport",
        chineseName: "利拉巴里机场",
        traditionalName: "利拉巴里機場",
      },
    ],
  },
  IXJ: {
    code: "IXJ",
    name: "JAMMU",
    chineseName: "查谟",
    traditionalName: "查謨",
    airports: [
      {
        code: "IXJ",
        name: "Satwari",
        chineseName: "萨特瓦利机场",
        traditionalName: "薩特瓦利機場",
      },
    ],
  },
  IXK: {
    code: "IXK",
    name: "KESHOD",
    chineseName: "盖绍德",
    traditionalName: "蓋紹德",
    airports: [
      {
        code: "IXK",
        name: "Keshod airport",
        chineseName: "克肖德机场",
        traditionalName: "克肖德機場",
      },
    ],
  },
  IXL: {
    code: "IXL",
    name: "LEH",
    chineseName: "列城",
    traditionalName: "列城",
    airports: [
      {
        code: "IXL",
        name: "Kushok bakula rimpoche",
        chineseName: "巴库拉仁波切机场",
        traditionalName: "巴庫拉仁波切機場",
      },
    ],
  },
  IXM: {
    code: "IXM",
    name: "MADURAI",
    chineseName: "马杜赖",
    traditionalName: "馬杜賴",
    airports: [
      {
        code: "IXM",
        name: "Madurai airport",
        chineseName: "马杜赖机场",
        traditionalName: "馬杜賴機場",
      },
    ],
  },
  IXR: {
    code: "IXR",
    name: "RANCHI",
    chineseName: "兰契",
    traditionalName: "蘭契",
    airports: [
      {
        code: "IXR",
        name: "Birsa munda",
        chineseName: "伯萨蒙达机场",
        traditionalName: "伯薩蒙達機場",
      },
    ],
  },
  IXS: {
    code: "IXS",
    name: "SILCHAR",
    chineseName: "锡尔杰尔",
    traditionalName: "錫爾傑爾",
    airports: [
      {
        code: "IXS",
        name: "Kumbhirgram",
        chineseName: "库姆希尔格拉姆机场",
        traditionalName: "庫姆希爾格拉姆機場",
      },
    ],
  },
  IXT: {
    code: "IXT",
    name: "PASIGHAT",
    chineseName: "帕西加特",
    traditionalName: "帕西加特",
    airports: [
      {
        code: "IXT",
        name: "Pasighat airport",
        chineseName: "帕西加特机场",
        traditionalName: "帕西加特機場",
      },
    ],
  },
  IXU: {
    code: "IXU",
    name: "AURANGABAD",
    chineseName: "奥兰加巴德",
    traditionalName: "奧蘭加巴德",
    airports: [
      {
        code: "IXU",
        name: "Aurangabad airport",
        chineseName: "奥兰加巴德机场",
        traditionalName: "奧蘭加巴德機場",
      },
    ],
  },
  IXW: {
    code: "IXW",
    name: "JAMSHEDPUR",
    chineseName: "詹谢普尔",
    traditionalName: "詹謝普爾",
    airports: [
      {
        code: "IXW",
        name: "Sonari",
        chineseName: "贾姆谢德布尔机场",
        traditionalName: "賈姆謝德布林機場",
      },
    ],
  },
  IXY: {
    code: "IXY",
    name: "KANDLA",
    chineseName: "坎德拉",
    traditionalName: "坎德拉",
    airports: [
      {
        code: "IXY",
        name: "Kandla airport",
        chineseName: "坎德拉机场",
        traditionalName: "坎德拉機場",
      },
    ],
  },
  IXZ: {
    code: "IXZ",
    name: "PORT BLAIR",
    chineseName: "布莱尔港",
    traditionalName: "布萊爾港",
    airports: [
      {
        code: "IXZ",
        name: "Veer savarkar intl",
        chineseName: "布莱尔港机场",
        traditionalName: "布萊爾港機場",
      },
    ],
  },
  IZM: {
    code: "IZM",
    name: "IZMIR",
    chineseName: "伊兹密尔",
    traditionalName: "伊茲密爾",
    airports: [
      {
        code: "ADB",
        name: "Adnan menderes",
        chineseName: "阿德楠曼德列斯机场",
        traditionalName: "阿德楠曼德列斯機場",
      },
    ],
  },
  IZO: {
    code: "IZO",
    name: "IZUMO",
    chineseName: "出云",
    traditionalName: "出雲",
    airports: [
      {
        code: "IZO",
        name: "Izumo airport",
        chineseName: "出云机场",
        traditionalName: "出雲機場",
      },
    ],
  },
  JAC: {
    code: "JAC",
    name: "JACKSON",
    chineseName: "杰克逊",
    traditionalName: "傑克遜",
    airports: [
      {
        code: "JAC",
        name: "Jackson hole",
        chineseName: "杰克逊霍勒机场",
        traditionalName: "傑克遜霍勒機場",
      },
    ],
  },
  JAE: {
    code: "JAE",
    name: "JAEN",
    chineseName: "佐治亚州亚特兰大",
    traditionalName: "佐治亞州亞特蘭大",
    airports: [
      {
        code: "JAE",
        name: "Shumba",
        chineseName: "顺巴机场",
        traditionalName: "順巴機場",
      },
    ],
  },
  JAF: {
    code: "JAF",
    name: "JAFFNA",
    chineseName: "贾夫纳",
    traditionalName: "賈夫納",
    airports: [
      {
        code: "JAF",
        name: "Kankesanturai",
        chineseName: "贾夫纳机场",
        traditionalName: "賈夫納機場",
      },
    ],
  },
  JAI: {
    code: "JAI",
    name: "JAIPUR",
    chineseName: "斋浦尔",
    traditionalName: "齋浦爾",
    airports: [
      {
        code: "JAI",
        name: "Jaipur intl.",
        chineseName: "桑加尼亚机场",
        traditionalName: "桑加尼亞機場",
      },
    ],
  },
  JAN: {
    code: "JAN",
    name: "JACKSON",
    chineseName: "杰克逊",
    traditionalName: "傑克遜",
    airports: [
      {
        code: "HKS",
        name: "Hawkins field",
        chineseName: "杰克逊机场",
        traditionalName: "傑克遜機場",
      },
      {
        code: "JAN",
        name: "Medgar w. evers intl",
        chineseName: "杰克逊国际机场",
        traditionalName: "傑克遜國際機場",
      },
    ],
  },
  JAU: {
    code: "JAU",
    name: "JAUJA",
    chineseName: "豪哈",
    traditionalName: "豪哈",
    airports: [
      {
        code: "JAU",
        name: "Francisco carle",
        chineseName: "弗朗西斯科卡尔机场",
        traditionalName: "弗朗西斯科卡爾機場",
      },
    ],
  },
  JAV: {
    code: "JAV",
    name: "ILULISSAT",
    chineseName: "伊卢利萨特",
    traditionalName: "伊盧利薩特",
    airports: [
      {
        code: "JAV",
        name: "Ilulissat airport",
        chineseName: "伊卢利萨特机场",
        traditionalName: "伊盧利薩特機場",
      },
    ],
  },
  JAW: {
    code: "JAW",
    name: "ARARIPINA",
    chineseName: "阿拉里皮纳",
    traditionalName: "阿拉裏皮納",
    airports: [
      {
        code: "JAW",
        name: "Araripina airport",
        chineseName: "阿拉里皮纳机场",
        traditionalName: "阿拉裏皮納機場",
      },
    ],
  },
  JAX: {
    code: "JAX",
    name: "JACKSONVILLE",
    chineseName: "杰克逊维尔",
    traditionalName: "傑克遜維爾",
    airports: [
      {
        code: "JAX",
        name: "Jacksonville intl.",
        chineseName: "杰克逊维尔国际机场",
        traditionalName: "傑克遜維爾國際機場",
      },
      {
        code: "NIP",
        name: "Nas (towers field)",
        chineseName: "杰克逊维尔机场",
        traditionalName: "傑克遜維爾機場",
      },
      {
        code: "VQQ",
        name: "Cecil",
        chineseName: "塞西尔机场",
        traditionalName: "塞西爾機場",
      },
    ],
  },
  JBB: {
    code: "JBB",
    name: "JEMBER",
    chineseName: "任抹",
    traditionalName: "任抹",
    airports: [
      {
        code: "JBB",
        name: "Noto hadinegoro",
        chineseName: "任抹机场",
        traditionalName: "任抹機場",
      },
    ],
  },
  JBK: {
    code: "JBK",
    name: "QITAI",
    chineseName: "加利福尼亚州伯克利",
    traditionalName: "加利福尼亞州伯克利",
    airports: [
      {
        code: "JBK",
        name: "Jiangbulake",
        chineseName: "江布拉克机场",
        traditionalName: "江布拉克機場",
      },
    ],
  },
  JBR: {
    code: "JBR",
    name: "JONESBORO",
    chineseName: "琼斯伯勒",
    traditionalName: "瓊斯伯勒",
    airports: [
      {
        code: "JBR",
        name: "Jonesboro municipal",
        chineseName: "琼斯伯勒机场",
        traditionalName: "瓊斯伯勒機場",
      },
    ],
  },
  JCK: {
    code: "JCK",
    name: "JULIA CREEK",
    chineseName: "朱利亚河",
    traditionalName: "朱利亞河",
    airports: [
      {
        code: "JCK",
        name: "Julia creek airport",
        chineseName: "胡利亚克里克机场",
        traditionalName: "胡利亞克裡克機場",
      },
    ],
  },
  JCL: {
    code: "JCL",
    name: "CESKE BUDEJOVICE",
    chineseName: "捷克布杰约维采",
    traditionalName: "捷克布傑約維采",
    airports: [
      {
        code: "JCL",
        name: "Jihoceske letiste ceske budejo",
        chineseName: "JIHOCESKE LETISTE CESKE BUDEJO机场",
        traditionalName: "JIHOCESKE LETISTE CESKE BUDEJO機場",
      },
    ],
  },
  JCS: {
    code: "JCS",
    name: "CRATEUS",
    chineseName: "克拉特斯",
    traditionalName: "克拉特斯",
    airports: [
      {
        code: "JCS",
        name: "Aeroporto de crateus",
        chineseName: "克拉特乌斯机场",
        traditionalName: "克拉特烏斯機場",
      },
    ],
  },
  JDF: {
    code: "JDF",
    name: "JUIZ DE FORA",
    chineseName: "茹伊斯迪福拉",
    traditionalName: "茹伊斯迪福拉",
    airports: [
      {
        code: "IZA",
        name: "Presidente i. franco",
        chineseName: "Presidente I. Franco机场",
        traditionalName: "Presidente I. Franco機場",
      },
    ],
  },
  JDH: {
    code: "JDH",
    name: "JODHPUR",
    chineseName: "焦特布尔",
    traditionalName: "焦特布爾",
    airports: [
      {
        code: "JDH",
        name: "Jodhpur airport",
        chineseName: "焦特布尔机场",
        traditionalName: "焦特布爾機場",
      },
    ],
  },
  JDO: {
    code: "JDO",
    name: "JUAZEIRO DO NORTE",
    chineseName: "北茹阿泽鲁",
    traditionalName: "北茹阿澤魯",
    airports: [
      {
        code: "JDO",
        name: "O. bezerra de menezes",
        chineseName: "北茹阿泽鲁机场",
        traditionalName: "北茹阿澤魯機場",
      },
    ],
  },
  JDZ: {
    code: "JDZ",
    name: "JINGDEZHEN",
    chineseName: "景德镇",
    traditionalName: "景德鎮",
    airports: [
      {
        code: "JDZ",
        name: "Luojia",
        chineseName: "景德镇机场",
        traditionalName: "景德鎮機場",
      },
    ],
  },
  JED: {
    code: "JED",
    name: "JEDDAH",
    chineseName: "吉达",
    traditionalName: "吉達",
    airports: [
      {
        code: "JED",
        name: "King abdulaziz intl",
        chineseName: "阿卜杜勒阿齐兹国王国际机场",
        traditionalName: "阿蔔杜勒阿齊茲國王國際機場",
      },
    ],
  },
  JEG: {
    code: "JEG",
    name: "AASIAAT",
    chineseName: "亚西亚特",
    traditionalName: "亞西亞特",
    airports: [
      {
        code: "JEG",
        name: "Aasiaat airport",
        chineseName: "阿西亚特机场",
        traditionalName: "阿西亞特機場",
      },
    ],
  },
  JER: {
    code: "JER",
    name: "JERSEY",
    chineseName: "泽西",
    traditionalName: "澤西",
    airports: [
      {
        code: "JER",
        name: "Jersey airport",
        chineseName: "泽西机场",
        traditionalName: "澤西機場",
      },
    ],
  },
  JFR: {
    code: "JFR",
    name: "PAAMIUT",
    chineseName: "帕米尤特",
    traditionalName: "帕米尤特",
    airports: [
      {
        code: "JFR",
        name: "Paamiut airport",
        chineseName: "帕米尤特机场",
        traditionalName: "帕米尤特機場",
      },
    ],
  },
  JGA: {
    code: "JGA",
    name: "JAMNAGAR",
    chineseName: "贾姆讷格尔",
    traditionalName: "賈姆訥格爾",
    airports: [
      {
        code: "JGA",
        name: "Govardhanpur",
        chineseName: "格瓦德汉珀尔机场",
        traditionalName: "格瓦德漢珀爾機場",
      },
    ],
  },
  JGB: {
    code: "JGB",
    name: "JAGDALPUR",
    chineseName: "杰格德尔布尔",
    traditionalName: "傑格德爾布爾",
    airports: [
      {
        code: "JGB",
        name: "Jagdalpur airport",
        chineseName: "杰格德尔布尔机场",
        traditionalName: "傑格德爾布林機場",
      },
    ],
  },
  JGD: {
    code: "JGD",
    name: "JIAGEDAQI",
    chineseName: "加格达奇",
    traditionalName: "加格達奇",
    airports: [
      {
        code: "JGD",
        name: "Jiagedaqi airport",
        chineseName: "加格达奇机场",
        traditionalName: "加格達奇機場",
      },
    ],
  },
  JGN: {
    code: "JGN",
    name: "JIAYUGUAN",
    chineseName: "嘉峪关",
    traditionalName: "嘉峪關",
    airports: [
      {
        code: "JGN",
        name: "Jiayuguan airport",
        chineseName: "嘉峪关酒泉机场",
        traditionalName: "嘉峪關酒泉機場",
      },
    ],
  },
  JGS: {
    code: "JGS",
    name: "JI'AN",
    chineseName: "吉安",
    traditionalName: "吉安",
    airports: [
      {
        code: "JGS",
        name: "Jinggangshan",
        chineseName: "吉安井冈山机场",
        traditionalName: "吉安井岡山機場",
      },
    ],
  },
  JHB: {
    code: "JHB",
    name: "JOHOR BAHRU",
    chineseName: "新山",
    traditionalName: "柔佛巴魯",
    airports: [
      {
        code: "JHB",
        name: "Senai intl",
        chineseName: "新山机场",
        traditionalName: "柔佛巴魯機場",
      },
    ],
  },
  JHG: {
    code: "JHG",
    name: "XISHUANGBANNA",
    chineseName: "西双版纳",
    traditionalName: "西雙版納",
    airports: [
      {
        code: "JHG",
        name: "Xishuangbanna gasa int",
        chineseName: "嘎洒国际机场",
        traditionalName: "嘎灑國際機場",
      },
    ],
  },
  JHM: {
    code: "JHM",
    name: "KAPALUA",
    chineseName: "卡帕鲁阿",
    traditionalName: "卡帕魯阿",
    airports: [
      {
        code: "JHM",
        name: "Kapalua airport",
        chineseName: "卡帕鲁阿机场",
        traditionalName: "卡帕魯阿機場",
      },
    ],
  },
  JHS: {
    code: "JHS",
    name: "SISIMIUT",
    chineseName: "锡西米尤特",
    traditionalName: "錫西米尤特",
    airports: [
      {
        code: "JHS",
        name: "Sisimiut airport",
        chineseName: "锡西米尤特机场",
        traditionalName: "錫西米尤特機場",
      },
    ],
  },
  JIB: {
    code: "JIB",
    name: "DJIBOUTI",
    chineseName: "吉布提",
    traditionalName: "吉佈提",
    airports: [
      {
        code: "JIB",
        name: "Ambouli intl",
        chineseName: "安伯里机场",
        traditionalName: "安伯裏機場",
      },
    ],
  },
  JIC: {
    code: "JIC",
    name: "JINCHANG",
    chineseName: "金昌",
    traditionalName: "金昌",
    airports: [
      {
        code: "JIC",
        name: "Jinchuan",
        chineseName: "金川机场",
        traditionalName: "金川機場",
      },
    ],
  },
  JIJ: {
    code: "JIJ",
    name: "JIJIGA",
    chineseName: "吉吉加",
    traditionalName: "吉吉加",
    airports: [
      {
        code: "JIJ",
        name: "Jijiga airport",
        chineseName: "吉吉加机场",
        traditionalName: "吉吉加機場",
      },
    ],
  },
  JIK: {
    code: "JIK",
    name: "IKARIA ISLAND",
    chineseName: "伊卡里亚岛",
    traditionalName: "伊卡裡亞島",
    airports: [
      {
        code: "JIK",
        name: "Ikaria island airport",
        chineseName: "伊戈里亚机场",
        traditionalName: "伊戈裏亞機場",
      },
    ],
  },
  JIM: {
    code: "JIM",
    name: "JIMMA",
    chineseName: "季马",
    traditionalName: "季馬",
    airports: [
      {
        code: "JIM",
        name: "Aba segud",
        chineseName: "季马机场",
        traditionalName: "季馬機場",
      },
    ],
  },
  JIN: {
    code: "JIN",
    name: "JINJA",
    chineseName: "金贾",
    traditionalName: "金賈",
    airports: [
      {
        code: "JIN",
        name: "Jinja airport",
        chineseName: "津加机场",
        traditionalName: "津加機場",
      },
    ],
  },
  JIO: {
    code: "JIO",
    name: "TIAKUR",
    chineseName: "提库尔",
    traditionalName: "提庫爾",
    airports: [
      {
        code: "JIO",
        name: "Jos orno imsula",
        chineseName: "乔斯·奥诺·因苏拉机场",
        traditionalName: "喬斯·奧諾·因蘇拉機場",
      },
    ],
  },
  JIQ: {
    code: "JIQ",
    name: "QIANJIANG",
    chineseName: "黔江",
    traditionalName: "黔江",
    airports: [
      {
        code: "JIQ",
        name: "Qianjiang wulingshan",
        chineseName: "武陵山机场",
        traditionalName: "武陵山機場",
      },
    ],
  },
  JIU: {
    code: "JIU",
    name: "JIUJIANG",
    chineseName: "九江",
    traditionalName: "九江",
    airports: [
      {
        code: "JIU",
        name: "Lushan",
        chineseName: "庐山机场",
        traditionalName: "廬山機場",
      },
    ],
  },
  JJD: {
    code: "JJD",
    name: "CRUZ",
    chineseName: "克鲁兹",
    traditionalName: "克魯茲",
    airports: [
      {
        code: "JJD",
        name: "Jericoacoara",
        chineseName: "日若卡迪热里科阿科阿拉机场",
        traditionalName: "日若卡迪熱裏科阿科阿拉機場",
      },
    ],
  },
  JJG: {
    code: "JJG",
    name: "JAGUARUNA",
    chineseName: "雅瓜鲁纳",
    traditionalName: "雅瓜魯納",
    airports: [
      {
        code: "JJG",
        name: "Humberto bortoluzzi",
        chineseName: "雅瓜鲁纳机场",
        traditionalName: "雅瓜魯納機場",
      },
    ],
  },
  JJM: {
    code: "JJM",
    name: "MERU-KINNA",
    chineseName: "梅鲁",
    traditionalName: "梅魯",
    airports: [
      {
        code: "JJM",
        name: "Mulika lodge",
        chineseName: "Mulika Lodge机场",
        traditionalName: "MULIKA LODGE機場",
      },
    ],
  },
  JJN: {
    code: "JJN",
    name: "QUANZHOU",
    chineseName: "泉州",
    traditionalName: "泉州",
    airports: [
      {
        code: "JJN",
        name: "Jinjiang",
        chineseName: "晋江机场",
        traditionalName: "晉江機場",
      },
    ],
  },
  JKH: {
    code: "JKH",
    name: "CHIOS",
    chineseName: "希俄斯",
    traditionalName: "希俄斯",
    airports: [
      {
        code: "JKH",
        name: "Omiros",
        chineseName: "希俄斯机场",
        traditionalName: "希俄斯機場",
      },
    ],
  },
  JKL: {
    code: "JKL",
    name: "KALYMNOS ISLAND",
    chineseName: "卡利姆诺斯",
    traditionalName: "卡利姆諾斯",
    airports: [
      {
        code: "JKL",
        name: "Kalymnos island airport",
        chineseName: "卡利姆诺斯机场",
        traditionalName: "卡利姆諾斯機場",
      },
    ],
  },
  JKR: {
    code: "JKR",
    name: "JANAKPUR",
    chineseName: "贾纳克布尔",
    traditionalName: "賈納克布林",
    airports: [
      {
        code: "JKR",
        name: "Janakpur airport",
        chineseName: "贾纳克布尔机场",
        traditionalName: "賈納克布林機場",
      },
    ],
  },
  JKT: {
    code: "JKT",
    name: "JAKARTA",
    chineseName: "雅加达",
    traditionalName: "雅加達",
    airports: [
      {
        code: "CGK",
        name: "Soekarno-hatta intl",
        chineseName: "苏加诺-哈达国际机场",
        traditionalName: "蘇加諾－絲巾國際機場",
      },
      {
        code: "HLP",
        name: "Halim perdanakusuma",
        chineseName: "哈里姆－佩尔达纳－库苏马机场",
        traditionalName: "哈裏姆－佩爾達納－庫蘇馬機場",
      },
    ],
  },
  JLG: {
    code: "JLG",
    name: "JALGAON",
    chineseName: "日航",
    traditionalName: "日航",
    airports: [
      {
        code: "JLG",
        name: "Jalgaon",
        chineseName: "日航机场",
        traditionalName: "日航機場",
      },
    ],
  },
  JLN: {
    code: "JLN",
    name: "JOPLIN",
    chineseName: "乔普林",
    traditionalName: "喬普林",
    airports: [
      {
        code: "JLN",
        name: "Joplin reg. airport",
        chineseName: "乔普林机场",
        traditionalName: "喬普林機場",
      },
    ],
  },
  JLR: {
    code: "JLR",
    name: "JABALPUR",
    chineseName: "贾巴尔普尔",
    traditionalName: "賈巴爾普爾",
    airports: [
      {
        code: "JLR",
        name: "Jabalpur airport",
        chineseName: "贾巴尔普尔机场",
        traditionalName: "賈巴爾普爾機場",
      },
    ],
  },
  JMA: {
    code: "JMA",
    name: "MANHUACU",
    chineseName: "满花库",
    traditionalName: "滿花庫",
    airports: [
      {
        code: "JMA",
        name: "Manhuacu elias breder",
        chineseName: "休斯敦机场",
        traditionalName: "休士頓機場",
      },
    ],
  },
  JMJ: {
    code: "JMJ",
    name: "LANCANG",
    chineseName: "澜沧",
    traditionalName: "瀾滄",
    airports: [
      {
        code: "JMJ",
        name: "Jingmai",
        chineseName: "景迈机场",
        traditionalName: "景邁機場",
      },
    ],
  },
  JMK: {
    code: "JMK",
    name: "MYKONOS",
    chineseName: "米克诺斯岛",
    traditionalName: "米克諾斯島",
    airports: [
      {
        code: "JMK",
        name: "Mykonos airport",
        chineseName: "米克诺斯机场",
        traditionalName: "米克諾斯機場",
      },
    ],
  },
  JMS: {
    code: "JMS",
    name: "JAMESTOWN",
    chineseName: "詹姆斯敦",
    traditionalName: "詹姆士城",
    airports: [
      {
        code: "JMS",
        name: "Jamestown reg. airport",
        chineseName: "詹姆斯敦机场",
        traditionalName: "詹姆士城機場",
      },
    ],
  },
  JMU: {
    code: "JMU",
    name: "JIAMUSI",
    chineseName: "佳木斯",
    traditionalName: "佳木斯",
    airports: [
      {
        code: "JMU",
        name: "Dongjiao",
        chineseName: "佳木斯东郊机场",
        traditionalName: "佳木斯東郊機場",
      },
    ],
  },
  JNB: {
    code: "JNB",
    name: "JOHANNESBURG",
    chineseName: "约翰内斯堡",
    traditionalName: "約翰尼斯堡",
    airports: [
      {
        code: "HLA",
        name: "Lanseria international",
        chineseName: "兰塞里亚机场",
        traditionalName: "蘭塞裏亞機場",
      },
      {
        code: "JNB",
        name: "O.r. tambo int'l",
        chineseName: "奥利弗·雷金纳德·坦博国际机场",
        traditionalName: "奧利弗·雷金納德·坦博國際機場",
      },
    ],
  },
  JNG: {
    code: "JNG",
    name: "JINING",
    chineseName: "济宁",
    traditionalName: "濟寧",
    airports: [
      {
        code: "JNG",
        name: "Da'an",
        chineseName: "大安机场",
        traditionalName: "大安機場",
      },
    ],
  },
  JNU: {
    code: "JNU",
    name: "JUNEAU",
    chineseName: "朱诺",
    traditionalName: "朱諾",
    airports: [
      {
        code: "JNU",
        name: "Juneau intl.",
        chineseName: "朱诺国际机场",
        traditionalName: "朱諾國際機場",
      },
    ],
  },
  JNX: {
    code: "JNX",
    name: "NAXOS",
    chineseName: "纳克索斯岛",
    traditionalName: "納克索斯島",
    airports: [
      {
        code: "JNX",
        name: "Naxos airport",
        chineseName: "纳克索斯机场",
        traditionalName: "納克索斯機場",
      },
    ],
  },
  JNZ: {
    code: "JNZ",
    name: "JINZHOU",
    chineseName: "锦州",
    traditionalName: "錦州",
    airports: [
      {
        code: "JNZ",
        name: "Jinzhouwan",
        chineseName: "锦州湾机场",
        traditionalName: "錦州灣機場",
      },
    ],
  },
  JOE: {
    code: "JOE",
    name: "JOENSUU",
    chineseName: "约恩苏",
    traditionalName: "約恩蘇",
    airports: [
      {
        code: "JOE",
        name: "Joensuu airport",
        chineseName: "约恩苏机场",
        traditionalName: "約恩蘇機場",
      },
    ],
  },
  JOG: {
    code: "JOG",
    name: "YOGYAKARTA",
    chineseName: "日惹",
    traditionalName: "日惹",
    airports: [
      {
        code: "JOG",
        name: "Adisutjipto",
        chineseName: "日惹机场",
        traditionalName: "日惹機場",
      },
      {
        code: "YIA",
        name: "New yogyakarta int.",
        chineseName: "日惹国际机场",
        traditionalName: "日惹國際機場",
      },
    ],
  },
  JOI: {
    code: "JOI",
    name: "JOINVILLE",
    chineseName: "若因维利",
    traditionalName: "約恩維利",
    airports: [
      {
        code: "JOI",
        name: "Lauro carneiro loyola",
        chineseName: "劳罗卡内罗德洛约拉机场",
        traditionalName: "勞羅卡內羅德洛約拉機場",
      },
    ],
  },
  JOS: {
    code: "JOS",
    name: "JOS",
    chineseName: "乔斯",
    traditionalName: "喬斯",
    airports: [
      {
        code: "JOS",
        name: "Yakubu gowon",
        chineseName: "乔斯机场",
        traditionalName: "喬斯機場",
      },
    ],
  },
  JPA: {
    code: "JPA",
    name: "JOAO PESSOA",
    chineseName: "若昂佩索阿",
    traditionalName: "茹旺翁佩索阿",
    airports: [
      {
        code: "JPA",
        name: "Castro pinto intl",
        chineseName: "卡斯特罗平托国际机场",
        traditionalName: "卡斯楚平托國際機場",
      },
    ],
  },
  JPE: {
    code: "JPE",
    name: "PARAGOMINAS",
    chineseName: "巴拉圭城",
    traditionalName: "巴拉圭城",
    airports: [
      {
        code: "JPE",
        name: "Paragominas airport",
        chineseName: "帕拉戈米纳斯机场",
        traditionalName: "帕拉戈米納斯機場",
      },
    ],
  },
  JPO: {
    code: "JPO",
    name: "PATOS DE PARAIBA",
    chineseName: "帕托斯·德·帕里巴",
    traditionalName: "帕托斯·德·帕裏巴",
    airports: [
      {
        code: "JPO",
        name: "Brigadeiro firmino ayres",
        chineseName: "菲尔米诺艾尔斯准将机场",
        traditionalName: "菲爾米諾艾爾斯準將機場",
      },
    ],
  },
  JPR: {
    code: "JPR",
    name: "JI-PARANA",
    chineseName: "吉帕拉纳",
    traditionalName: "吉帕拉納",
    airports: [
      {
        code: "JPR",
        name: "Jose coleto",
        chineseName: "吉帕拉纳机场",
        traditionalName: "吉帕拉納機場",
      },
    ],
  },
  JQA: {
    code: "JQA",
    name: "QAARSUT",
    chineseName: "恰尔苏特",
    traditionalName: "恰爾蘇特",
    airports: [
      {
        code: "JQA",
        name: "Qaarsut airport",
        chineseName: "恰尔苏特机场",
        traditionalName: "恰爾蘇特機場",
      },
    ],
  },
  JRG: {
    code: "JRG",
    name: "JHARSUGUDA",
    chineseName: "贾苏古达",
    traditionalName: "賈蘇古達",
    airports: [
      {
        code: "JRG",
        name: "Veer surendra sai",
        chineseName: "恰尔苏古达机场",
        traditionalName: "恰爾蘇古達機場",
      },
    ],
  },
  JRH: {
    code: "JRH",
    name: "JORHAT",
    chineseName: "焦尔哈德",
    traditionalName: "焦爾哈德",
    airports: [
      {
        code: "JRH",
        name: "Rowriah",
        chineseName: "罗里阿机场",
        traditionalName: "羅裡阿機場",
      },
    ],
  },
  JRO: {
    code: "JRO",
    name: "KILIMANJARO",
    chineseName: "乞力马扎罗",
    traditionalName: "乞力馬扎羅",
    airports: [
      {
        code: "JRO",
        name: "Kilimanjaro intl.",
        chineseName: "乞力马扎罗国际机场",
        traditionalName: "乞力馬扎羅國際機場",
      },
    ],
  },
  JSA: {
    code: "JSA",
    name: "JAISALMER",
    chineseName: "贾沙梅尔",
    traditionalName: "賈沙梅爾",
    airports: [
      {
        code: "JSA",
        name: "Jaisalmer airport",
        chineseName: "杰伊瑟尔梅尔机场",
        traditionalName: "傑伊瑟爾梅爾機場",
      },
    ],
  },
  JSB: {
    code: "JSB",
    name: "SAO BENEDITO",
    chineseName: "圣贝内迪托",
    traditionalName: "聖貝內迪托",
    airports: [
      {
        code: "JSB",
        name: "Walfrido salmito de almeida",
        chineseName: "沃尔弗里多·萨尔米托·德·阿尔梅达机场",
        traditionalName: "沃爾弗裏多·薩爾米托·德·阿爾梅達機場",
      },
    ],
  },
  JSH: {
    code: "JSH",
    name: "SITEIA",
    chineseName: "锡蒂亚",
    traditionalName: "錫蒂亞",
    airports: [
      {
        code: "JSH",
        name: "Siteia airport",
        chineseName: "锡蒂亚机场",
        traditionalName: "錫蒂亞機場",
      },
    ],
  },
  JSI: {
    code: "JSI",
    name: "SKIATHOS",
    chineseName: "斯基亚索斯岛",
    traditionalName: "斯基亞索斯島",
    airports: [
      {
        code: "JSI",
        name: "Alex. papadiamantis",
        chineseName: "斯基亚索斯机场",
        traditionalName: "斯基亞索斯機場",
      },
    ],
  },
  JSJ: {
    code: "JSJ",
    name: "JIANSANJIANG",
    chineseName: "建三江",
    traditionalName: "建三江",
    airports: [
      {
        code: "JSJ",
        name: "Jiansanjiang airport",
        chineseName: "建三江机场",
        traditionalName: "建三江機場",
      },
    ],
  },
  JSK: {
    code: "JSK",
    name: "JASK",
    chineseName: "圣克劳德",
    traditionalName: "聖克勞德",
    airports: [
      {
        code: "JSK",
        name: "Jask airport",
        chineseName: "圣克劳德机场",
        traditionalName: "聖克勞德機場",
      },
    ],
  },
  JSO: {
    code: "JSO",
    name: "SOBRAL",
    chineseName: "南泰利耶",
    traditionalName: "南泰利耶",
    airports: [
      {
        code: "JSO",
        name: "Aerodromo publico",
        chineseName: "南泰利耶机场",
        traditionalName: "南泰利耶機場",
      },
    ],
  },
  JSR: {
    code: "JSR",
    name: "JESSORE",
    chineseName: "杰索尔",
    traditionalName: "傑索爾",
    airports: [
      {
        code: "JSR",
        name: "Jessore airport",
        chineseName: "杰索尔机场",
        traditionalName: "傑索爾機場",
      },
    ],
  },
  JST: {
    code: "JST",
    name: "JOHNSTOWN",
    chineseName: "宾夕法尼亚州约翰斯敦",
    traditionalName: "賓夕法尼亞州約翰斯敦",
    airports: [
      {
        code: "JST",
        name: "John murtha-cambria co",
        chineseName: "坎布里亚郡机场",
        traditionalName: "坎布里亞郡機場",
      },
    ],
  },
  JSU: {
    code: "JSU",
    name: "MANIITSOQ",
    chineseName: "马尼伊特索科",
    traditionalName: "馬尼伊特索科",
    airports: [
      {
        code: "JSU",
        name: "Maniitsoq airport",
        chineseName: "马尼伊特索科直升机机场",
        traditionalName: "馬尼伊特索科直升機機場",
      },
    ],
  },
  JSY: {
    code: "JSY",
    name: "SYROS ISLAND",
    chineseName: "锡罗斯岛",
    traditionalName: "錫羅斯島",
    airports: [
      {
        code: "JSY",
        name: "Dimitrios vikelas",
        chineseName: "希罗斯岛机场",
        traditionalName: "希羅斯島機場",
      },
    ],
  },
  JTC: {
    code: "JTC",
    name: "BAURU",
    chineseName: "包鲁",
    traditionalName: "包魯",
    airports: [
      {
        code: "JTC",
        name: "Moussa nakhl tobias",
        chineseName: "阿雷阿尔瓦机场",
        traditionalName: "阿雷阿爾瓦機場",
      },
    ],
  },
  JTR: {
    code: "JTR",
    name: "THIRA",
    chineseName: "圣托里尼岛",
    traditionalName: "聖托裡尼島",
    airports: [
      {
        code: "JTR",
        name: "Santorini",
        chineseName: "圣托里尼机场",
        traditionalName: "聖托裡尼機場",
      },
    ],
  },
  JTY: {
    code: "JTY",
    name: "ASTYPALAIA ISLAND",
    chineseName: "阿斯蒂帕莱亚岛",
    traditionalName: "阿斯蒂帕萊亞島",
    airports: [
      {
        code: "JTY",
        name: "Astypalaia island airport",
        chineseName: "阿斯提帕拉亚机场",
        traditionalName: "阿斯提帕拉亞機場",
      },
    ],
  },
  JUB: {
    code: "JUB",
    name: "JUBA",
    chineseName: "朱巴",
    traditionalName: "朱巴",
    airports: [
      {
        code: "JUB",
        name: "Juba airport",
        chineseName: "朱巴机场",
        traditionalName: "朱巴機場",
      },
    ],
  },
  JUH: {
    code: "JUH",
    name: "CHIZHOU",
    chineseName: "池州",
    traditionalName: "池州",
    airports: [
      {
        code: "JUH",
        name: "Jiuhuashan",
        chineseName: "九华山机场",
        traditionalName: "九華山機場",
      },
    ],
  },
  JUI: {
    code: "JUI",
    name: "JUIST",
    chineseName: "儒伊斯特",
    traditionalName: "儒伊斯特",
    airports: [
      {
        code: "JUI",
        name: "Juist airport",
        chineseName: "于斯特机场",
        traditionalName: "於斯特機場",
      },
    ],
  },
  JUJ: {
    code: "JUJ",
    name: "JUJUY",
    chineseName: "胡胡伊",
    traditionalName: "胡胡伊",
    airports: [
      {
        code: "JUJ",
        name: "Gobernador h. guzman",
        chineseName: "胡胡伊机场",
        traditionalName: "胡胡伊機場",
      },
    ],
  },
  JUL: {
    code: "JUL",
    name: "JULIACA",
    chineseName: "胡利亚卡",
    traditionalName: "胡利亞卡",
    airports: [
      {
        code: "JUL",
        name: "Inco mnco capac intl",
        chineseName: "胡利亚卡机场",
        traditionalName: "胡利亞卡機場",
      },
    ],
  },
  JUM: {
    code: "JUM",
    name: "JUMLA",
    chineseName: "久姆拉",
    traditionalName: "久姆拉",
    airports: [
      {
        code: "JUM",
        name: "Jumla airport",
        chineseName: "久姆拉机场",
        traditionalName: "久姆拉機場",
      },
    ],
  },
  JUV: {
    code: "JUV",
    name: "UPERNAVIK",
    chineseName: "乌佩纳维克",
    traditionalName: "烏佩納維克",
    airports: [
      {
        code: "JUV",
        name: "Upernavik airport",
        chineseName: "乌佩纳维克机场",
        traditionalName: "烏佩納維克機場",
      },
    ],
  },
  JUZ: {
    code: "JUZ",
    name: "QUZHOU",
    chineseName: "衢州",
    traditionalName: "衢州",
    airports: [
      {
        code: "JUZ",
        name: "Quzhou airport",
        chineseName: "衢州机场",
        traditionalName: "衢州機場",
      },
    ],
  },
  JWN: {
    code: "JWN",
    name: "ZANJAN",
    chineseName: "赞詹",
    traditionalName: "贊詹",
    airports: [
      {
        code: "JWN",
        name: "Zanjan airport",
        chineseName: "赞詹机场",
        traditionalName: "贊詹機場",
      },
    ],
  },
  JXA: {
    code: "JXA",
    name: "JIXI",
    chineseName: "鸡西",
    traditionalName: "雞西",
    airports: [
      {
        code: "JXA",
        name: "Xingkaihu",
        chineseName: "兴凯湖机场",
        traditionalName: "興凱湖機場",
      },
    ],
  },
  JYR: {
    code: "JYR",
    name: "JIROFT",
    chineseName: "吉罗夫特",
    traditionalName: "吉羅夫特",
    airports: [
      {
        code: "JYR",
        name: "Jiroft airport",
        chineseName: "吉罗夫特机场",
        traditionalName: "吉羅夫特機場",
      },
    ],
  },
  JYV: {
    code: "JYV",
    name: "JYVASKYLA",
    chineseName: "于韦斯屈莱",
    traditionalName: "于韋斯屈萊",
    airports: [
      {
        code: "JYV",
        name: "Jyvaskyla airport",
        chineseName: "于伐斯居拉机场",
        traditionalName: "於伐斯居拉機場",
      },
    ],
  },
  JZH: {
    code: "JZH",
    name: "JIUZHAIGOU",
    chineseName: "九寨沟",
    traditionalName: "九寨溝",
    airports: [
      {
        code: "JZH",
        name: "Jiuzhai huanglong",
        chineseName: "黄龙机场",
        traditionalName: "黃龍機場",
      },
    ],
  },
  KAA: {
    code: "KAA",
    name: "KASAMA",
    chineseName: "卡萨马",
    traditionalName: "卡薩馬",
    airports: [
      {
        code: "KAA",
        name: "Kasama airport",
        chineseName: "卡萨马机场",
        traditionalName: "卡薩馬機場",
      },
    ],
  },
  KAB: {
    code: "KAB",
    name: "KARIBA",
    chineseName: "卡里巴",
    traditionalName: "加里巴",
    airports: [
      {
        code: "KAB",
        name: "Kariba airport",
        chineseName: "卡里巴机场",
        traditionalName: "加里巴機場",
      },
    ],
  },
  KAD: {
    code: "KAD",
    name: "KADUNA",
    chineseName: "卡杜纳",
    traditionalName: "卡杜納",
    airports: [
      {
        code: "KAD",
        name: "Kaduna airport",
        chineseName: "卡杜纳机场",
        traditionalName: "卡杜納機場",
      },
    ],
  },
  KAE: {
    code: "KAE",
    name: "KAKE",
    chineseName: "凯克",
    traditionalName: "凱克",
    airports: [
      {
        code: "KAE",
        name: "Sea plane base",
        chineseName: "凯克水上飞机基地",
        traditionalName: "凱克水上飛機基地",
      },
    ],
  },
  KAJ: {
    code: "KAJ",
    name: "KAJAANI",
    chineseName: "卡亚尼",
    traditionalName: "卡亞尼",
    airports: [
      {
        code: "KAJ",
        name: "Kajaani airport",
        chineseName: "卡亚尼机场",
        traditionalName: "卡亞尼機場",
      },
    ],
  },
  KAL: {
    code: "KAL",
    name: "KALTAG",
    chineseName: "阿拉斯加城市卡尔塔",
    traditionalName: "阿拉斯加都市卡爾塔",
    airports: [
      {
        code: "KAL",
        name: "Kaltag airport",
        chineseName: "卡尔塔格机场",
        traditionalName: "卡爾塔格機場",
      },
    ],
  },
  KAN: {
    code: "KAN",
    name: "KANO",
    chineseName: "卡诺",
    traditionalName: "卡諾",
    airports: [
      {
        code: "KAN",
        name: "Mallam aminu kano intl",
        chineseName: "马拉姆阿米努卡诺国际机场",
        traditionalName: "馬拉姆阿米努卡諾國際機場",
      },
    ],
  },
  KAO: {
    code: "KAO",
    name: "KUUSAMO",
    chineseName: "库萨莫",
    traditionalName: "庫薩莫",
    airports: [
      {
        code: "KAO",
        name: "Kuusamo airport",
        chineseName: "库萨莫机场",
        traditionalName: "庫薩莫機場",
      },
    ],
  },
  KAT: {
    code: "KAT",
    name: "KAITAIA",
    chineseName: "凯塔亚",
    traditionalName: "凱塔亞",
    airports: [
      {
        code: "KAT",
        name: "Kaitaia airport",
        chineseName: "凯塔亚机场",
        traditionalName: "凱塔亞機場",
      },
    ],
  },
  KAW: {
    code: "KAW",
    name: "KAWTHAUNG",
    chineseName: "高当",
    traditionalName: "高當",
    airports: [
      {
        code: "KAW",
        name: "Kawthaung airport",
        chineseName: "高当机场",
        traditionalName: "高當機場",
      },
    ],
  },
  KAZ: {
    code: "KAZ",
    name: "KAU",
    chineseName: "卡乌",
    traditionalName: "卡烏",
    airports: [
      {
        code: "KAZ",
        name: "Kaubang",
        chineseName: "卡乌机场",
        traditionalName: "卡烏機場",
      },
    ],
  },
  KBC: {
    code: "KBC",
    name: "BIRCH CREEK",
    chineseName: "伯奇克里克",
    traditionalName: "伯奇克裏克",
    airports: [
      {
        code: "KBC",
        name: "Birch creek airport",
        chineseName: "伯奇克里克机场",
        traditionalName: "伯奇克裏克機場",
      },
    ],
  },
  KBH: {
    code: "KBH",
    name: "KAHAMA",
    chineseName: "格拉德",
    traditionalName: "格拉德",
    airports: [
      {
        code: "KBH",
        name: "Buzwagi",
        chineseName: "布兹瓦吉机场",
        traditionalName: "布茲瓦吉機場",
      },
    ],
  },
  KBL: {
    code: "KBL",
    name: "KABUL",
    chineseName: "喀布尔",
    traditionalName: "喀布爾",
    airports: [
      {
        code: "KBL",
        name: "Kabul intl.",
        chineseName: "喀布尔国际机场",
        traditionalName: "喀布爾國際機場",
      },
    ],
  },
  KBR: {
    code: "KBR",
    name: "KOTA BHARU",
    chineseName: "哥打巴鲁",
    traditionalName: "哥打巴魯",
    airports: [
      {
        code: "KBR",
        name: "Sultan ismail petra",
        chineseName: "苏丹伊斯梅尔佩特拉机场",
        traditionalName: "蘇丹伊斯梅爾佩特拉機場",
      },
    ],
  },
  KBT: {
    code: "KBT",
    name: "KABEN ISLAND",
    chineseName: "卡本",
    traditionalName: "卡本",
    airports: [
      {
        code: "KBT",
        name: "Kaben island airport",
        chineseName: "卡本机场",
        traditionalName: "卡本機場",
      },
    ],
  },
  KBU: {
    code: "KBU",
    name: "KOTABARU",
    chineseName: "哥打巴鲁",
    traditionalName: "哥打巴魯",
    airports: [
      {
        code: "KBU",
        name: "Gusti sjamsir alam",
        chineseName: "哥打巴卢机场",
        traditionalName: "哥打巴盧機場",
      },
    ],
  },
  KBV: {
    code: "KBV",
    name: "KRABI",
    chineseName: "甲米",
    traditionalName: "甲米",
    airports: [
      {
        code: "KBV",
        name: "Krabi airport",
        chineseName: "甲米机场",
        traditionalName: "甲米機場",
      },
    ],
  },
  KCA: {
    code: "KCA",
    name: "KUQA",
    chineseName: "库车",
    traditionalName: "庫車",
    airports: [
      {
        code: "KCA",
        name: "Quici",
        chineseName: "龟兹机场",
        traditionalName: "龜茲機場",
      },
    ],
  },
  KCC: {
    code: "KCC",
    name: "COFFMAN COVE",
    chineseName: "科夫曼湾",
    traditionalName: "科夫曼灣",
    airports: [
      {
        code: "KCC",
        name: "Sea plane base",
        chineseName: "考夫曼考弗水上飞机基地",
        traditionalName: "考夫曼考弗水上飛機基地",
      },
    ],
  },
  KCH: {
    code: "KCH",
    name: "KUCHING",
    chineseName: "古晋",
    traditionalName: "古晋",
    airports: [
      {
        code: "KCH",
        name: "Kuching intl.",
        chineseName: "古晋国际机场",
        traditionalName: "古晋國際機場",
      },
    ],
  },
  KCK: {
    code: "KCK",
    name: "KIRENSK",
    chineseName: "基廉斯克",
    traditionalName: "基廉斯克",
    airports: [
      {
        code: "KCK",
        name: "Kirensk airport",
        chineseName: "基廉斯克",
        traditionalName: "基廉斯克",
      },
    ],
  },
  KCL: {
    code: "KCL",
    name: "CHIGNIK",
    chineseName: "奇格尼克",
    traditionalName: "奇格尼克",
    airports: [
      {
        code: "KCG",
        name: "Chignik airport",
        chineseName: "奇格尼克机场",
        traditionalName: "奇格尼克機場",
      },
      {
        code: "KCL",
        name: "Chignik lagoon",
        chineseName: "奇格尼克机场",
        traditionalName: "奇格尼克機場",
      },
      {
        code: "KCQ",
        name: "Chignik lake",
        chineseName: "奇格尼克莱克机场",
        traditionalName: "奇格尼克萊克機場",
      },
    ],
  },
  KCM: {
    code: "KCM",
    name: "KAHRAMANMARAS",
    chineseName: "卡赫拉曼马拉什",
    traditionalName: "卡赫拉曼馬拉什",
    airports: [
      {
        code: "KCM",
        name: "Kahramanmaras airport",
        chineseName: "卡拉曼马拉斯机场",
        traditionalName: "卡拉曼馬拉斯機場",
      },
    ],
  },
  KCT: {
    code: "KCT",
    name: "KOGGALA",
    chineseName: "科加拉",
    traditionalName: "科加拉",
    airports: [
      {
        code: "KCT",
        name: "Koggala airport",
        chineseName: "克加拉机场",
        traditionalName: "克加拉機場",
      },
    ],
  },
  KCZ: {
    code: "KCZ",
    name: "KOCHI",
    chineseName: "高知",
    traditionalName: "高知",
    airports: [
      {
        code: "KCZ",
        name: "Kochi airport",
        chineseName: "高知机场",
        traditionalName: "高知機場",
      },
    ],
  },
  KDH: {
    code: "KDH",
    name: "KANDAHAR",
    chineseName: "坎大哈",
    traditionalName: "坎大哈",
    airports: [
      {
        code: "KDH",
        name: "Kandahar intl.",
        chineseName: "坎大哈国际机场",
        traditionalName: "坎大哈國際機場",
      },
    ],
  },
  KDI: {
    code: "KDI",
    name: "KENDARI",
    chineseName: "肯达里",
    traditionalName: "肯達裡",
    airports: [
      {
        code: "KDI",
        name: "Halu oleo",
        chineseName: "沃尔特蒙金西迪机场",
        traditionalName: "沃爾特蒙金西迪機場",
      },
    ],
  },
  KDL: {
    code: "KDL",
    name: "KARDLA",
    chineseName: "凯尔德拉",
    traditionalName: "凱爾德拉",
    airports: [
      {
        code: "KDL",
        name: "Kardla airport",
        chineseName: "凯尔德拉机场",
        traditionalName: "凱爾德拉機場",
      },
    ],
  },
  KDM: {
    code: "KDM",
    name: "KAADEDHDHOO ISLAND",
    chineseName: "佳特土",
    traditionalName: "佳特土",
    airports: [
      {
        code: "KDM",
        name: "Kaadedhdhoo island airport",
        chineseName: "加特土机场",
        traditionalName: "加特土機場",
      },
    ],
  },
  KDN: {
    code: "KDN",
    name: "NDENDE",
    chineseName: "恩代恩代",
    traditionalName: "恩代恩代",
    airports: [
      {
        code: "KDN",
        name: "Ndende airport",
        chineseName: "恩代恩代机场",
        traditionalName: "恩代恩代機場",
      },
    ],
  },
  KDO: {
    code: "KDO",
    name: "KADHDHOO ISLAND",
    chineseName: "加途",
    traditionalName: "加途",
    airports: [
      {
        code: "KDO",
        name: "Kadhdhoo island airport",
        chineseName: "加途机场",
        traditionalName: "加途機場",
      },
    ],
  },
  KDU: {
    code: "KDU",
    name: "SKARDU",
    chineseName: "斯卡都",
    traditionalName: "斯卡都",
    airports: [
      {
        code: "KDU",
        name: "Skardu airport",
        chineseName: "锡卡都机场",
        traditionalName: "錫卡都機場",
      },
    ],
  },
  KDV: {
    code: "KDV",
    name: "KADAVU ISLAND",
    chineseName: "坎达武",
    traditionalName: "坎達武",
    airports: [
      {
        code: "KDV",
        name: "Vunisea",
        chineseName: "坎达武岛机场",
        traditionalName: "坎達武島機場",
      },
    ],
  },
  KDW: {
    code: "KDW",
    name: "KANDY",
    chineseName: "康提",
    traditionalName: "康提",
    airports: [
      {
        code: "KDW",
        name: "Victoria reservoir spb",
        chineseName: "康提机场",
        traditionalName: "康提機場",
      },
    ],
  },
  KEA: {
    code: "KEA",
    name: "KERKI",
    chineseName: "凯撒",
    traditionalName: "凱撒",
    airports: [
      {
        code: "KEA",
        name: "Kerki intl.",
        chineseName: "凯撒机场",
        traditionalName: "凱撒機場",
      },
    ],
  },
  KEI: {
    code: "KEI",
    name: "KEPI",
    chineseName: "克皮",
    traditionalName: "克皮",
    airports: [
      {
        code: "KEI",
        name: "Kepi airport",
        chineseName: "克皮机场",
        traditionalName: "克皮機場",
      },
    ],
  },
  KEJ: {
    code: "KEJ",
    name: "KEMEROVO",
    chineseName: "克麦罗沃",
    traditionalName: "克麥羅沃",
    airports: [
      {
        code: "KEJ",
        name: "Kemerovo airport",
        chineseName: "克麦罗沃机场",
        traditionalName: "克麥羅沃機場",
      },
    ],
  },
  KEK: {
    code: "KEK",
    name: "EKWOK",
    chineseName: "阿拉斯加州埃克沃克",
    traditionalName: "阿拉斯加州埃克沃克",
    airports: [
      {
        code: "KEK",
        name: "Ekwok airport",
        chineseName: "埃阔克机场",
        traditionalName: "埃闊克機場",
      },
    ],
  },
  KEM: {
    code: "KEM",
    name: "KEMI/TORNIO",
    chineseName: "凯米/托尔尼奥",
    traditionalName: "凱米/托爾尼奧",
    airports: [
      {
        code: "KEM",
        name: "Kemi/tornio airport",
        chineseName: "凯米-托尔尼奥机场",
        traditionalName: "凱米-托爾尼奧機場",
      },
    ],
  },
  KEO: {
    code: "KEO",
    name: "ODIENNE",
    chineseName: "奥迭内",
    traditionalName: "奧迭內",
    airports: [
      {
        code: "KEO",
        name: "Odienne airport",
        chineseName: "奥迪内机场",
        traditionalName: "奧迪內機場",
      },
    ],
  },
  KEP: {
    code: "KEP",
    name: "NEPALGANJ",
    chineseName: "尼泊尔根杰",
    traditionalName: "尼泊爾根傑",
    airports: [
      {
        code: "KEP",
        name: "Nepalganj airport",
        chineseName: "尼泊尔根杰机场",
        traditionalName: "尼泊爾根傑機場",
      },
    ],
  },
  KER: {
    code: "KER",
    name: "KERMAN",
    chineseName: "克尔曼",
    traditionalName: "克爾曼",
    airports: [
      {
        code: "KER",
        name: "Kerman airport",
        chineseName: "克尔曼机场",
        traditionalName: "克爾曼機場",
      },
    ],
  },
  KET: {
    code: "KET",
    name: "KENGTUNG",
    chineseName: "景栋",
    traditionalName: "景棟",
    airports: [
      {
        code: "KET",
        name: "Kengtung airport",
        chineseName: "景栋机场",
        traditionalName: "景棟機場",
      },
    ],
  },
  KEW: {
    code: "KEW",
    name: "KEEWAYWIN",
    chineseName: "基瓦伊温",
    traditionalName: "基瓦伊溫",
    airports: [
      {
        code: "KEW",
        name: "Keewaywin airport",
        chineseName: "基瓦伊温机场",
        traditionalName: "基瓦伊溫機場",
      },
    ],
  },
  KFA: {
    code: "KFA",
    name: "KIFFA",
    chineseName: "基法",
    traditionalName: "基法",
    airports: [
      {
        code: "KFA",
        name: "Kiffa airport",
        chineseName: "基法机场",
        traditionalName: "基法機場",
      },
    ],
  },
  KFP: {
    code: "KFP",
    name: "FALSE PASS",
    chineseName: "阿拉斯加城市假山",
    traditionalName: "阿拉斯加都市假山",
    airports: [
      {
        code: "KFP",
        name: "False pass airport",
        chineseName: "福尔斯帕斯机场",
        traditionalName: "福爾斯帕斯機場",
      },
    ],
  },
  KFS: {
    code: "KFS",
    name: "KASTAMONU",
    chineseName: "卡斯塔莫努",
    traditionalName: "卡斯塔莫努",
    airports: [
      {
        code: "KFS",
        name: "Kastamonu airport",
        chineseName: "卡斯塔莫努机场",
        traditionalName: "卡斯塔莫努機場",
      },
    ],
  },
  KGA: {
    code: "KGA",
    name: "KANANGA",
    chineseName: "卡南加",
    traditionalName: "卡南加",
    airports: [
      {
        code: "KGA",
        name: "Kananga airport",
        chineseName: "卡南加机场",
        traditionalName: "卡南加機場",
      },
    ],
  },
  KGC: {
    code: "KGC",
    name: "KINGSCOTE",
    chineseName: "金斯科特",
    traditionalName: "金斯科特",
    airports: [
      {
        code: "KGC",
        name: "Kingscote airport",
        chineseName: "金斯科特机场",
        traditionalName: "金斯科特機場",
      },
    ],
  },
  KGD: {
    code: "KGD",
    name: "KALININGRAD",
    chineseName: "加里宁格勒",
    traditionalName: "加里寧格勒",
    airports: [
      {
        code: "KGD",
        name: "Khrabrovo",
        chineseName: "哈拉波罗夫机场",
        traditionalName: "哈拉波羅夫機場",
      },
    ],
  },
  KGE: {
    code: "KGE",
    name: "KAGHAU ISLAND",
    chineseName: "卡古",
    traditionalName: "卡古",
    airports: [
      {
        code: "KGE",
        name: "Kaghau island airport",
        chineseName: "卡加姆机场",
        traditionalName: "卡加姆機場",
      },
    ],
  },
  KGF: {
    code: "KGF",
    name: "KARAGANDA",
    chineseName: "卡拉干达",
    traditionalName: "卡拉幹達",
    airports: [
      {
        code: "KGF",
        name: "Sary-arka",
        chineseName: "萨雷阿卡机场",
        traditionalName: "薩雷阿卡機場",
      },
    ],
  },
  KGI: {
    code: "KGI",
    name: "KALGOORLIE-BOULDER",
    chineseName: "卡尔古利",
    traditionalName: "卡爾古利",
    airports: [
      {
        code: "KGI",
        name: "Kalgoorlie-boulder airport",
        chineseName: "卡尔古利博尔德机场",
        traditionalName: "卡爾古利博爾德機場",
      },
    ],
  },
  KGK: {
    code: "KGK",
    name: "KOLIGANEK",
    chineseName: "阿拉斯加州新科利盖内克",
    traditionalName: "阿拉斯加州新科利蓋內克",
    airports: [
      {
        code: "KGK",
        name: "Koliganek airport",
        chineseName: "科里加内克机场",
        traditionalName: "科裏加內克機場",
      },
    ],
  },
  KGL: {
    code: "KGL",
    name: "KIGALI",
    chineseName: "基加利",
    traditionalName: "吉佳利",
    airports: [
      {
        code: "KGL",
        name: "Kigali intl.",
        chineseName: "基加利国际机场",
        traditionalName: "吉佳利國際機場",
      },
    ],
  },
  KGP: {
    code: "KGP",
    name: "KOGALYM",
    chineseName: "科加雷姆",
    traditionalName: "科加雷姆",
    airports: [
      {
        code: "KGP",
        name: "Kogalym airport",
        chineseName: "克加利姆国际机场",
        traditionalName: "克加利姆國際機場",
      },
    ],
  },
  KGS: {
    code: "KGS",
    name: "KOS",
    chineseName: "科斯",
    traditionalName: "科斯",
    airports: [
      {
        code: "KGS",
        name: "Ippokratis",
        chineseName: "科斯机场",
        traditionalName: "科斯機場",
      },
    ],
  },
  KGT: {
    code: "KGT",
    name: "KANGDING",
    chineseName: "康定",
    traditionalName: "康定",
    airports: [
      {
        code: "KGT",
        name: "Kangding airport",
        chineseName: "康定机场",
        traditionalName: "康定機場",
      },
    ],
  },
  KGX: {
    code: "KGX",
    name: "GRAYLING",
    chineseName: "格雷灵",
    traditionalName: "格雷靈",
    airports: [
      {
        code: "KGX",
        name: "Grayling airport",
        chineseName: "格雷灵机场",
        traditionalName: "格雷靈機場",
      },
    ],
  },
  KHD: {
    code: "KHD",
    name: "KHORRAMABAD",
    chineseName: "霍拉巴马德",
    traditionalName: "霍拉巴馬德",
    airports: [
      {
        code: "KHD",
        name: "Khorramabad airport",
        chineseName: "霍拉巴马德机场",
        traditionalName: "霍拉巴馬德機場",
      },
    ],
  },
  KHG: {
    code: "KHG",
    name: "KASHI",
    chineseName: "喀什",
    traditionalName: "喀什",
    airports: [
      {
        code: "KHG",
        name: "Kashi airport",
        chineseName: "喀什徕宁国际机场",
        traditionalName: "喀什徠寧國際機場",
      },
    ],
  },
  KHH: {
    code: "KHH",
    name: "KAOHSIUNG",
    chineseName: "高雄",
    traditionalName: "高雄",
    airports: [
      {
        code: "KHH",
        name: "Kaohsiung intl.",
        chineseName: "高雄国际机场",
        traditionalName: "高雄國際機場",
      },
    ],
  },
  KHI: {
    code: "KHI",
    name: "KARACHI",
    chineseName: "卡拉奇",
    traditionalName: "卡拉奇",
    airports: [
      {
        code: "KHI",
        name: "Jinnah intl",
        chineseName: "真纳国际机场",
        traditionalName: "真納國際機場",
      },
    ],
  },
  KHM: {
    code: "KHM",
    name: "KHAMTI",
    chineseName: "坎底",
    traditionalName: "坎底",
    airports: [
      {
        code: "KHM",
        name: "Khamti airport",
        chineseName: "海姆提斯机场",
        traditionalName: "海姆提斯機場",
      },
    ],
  },
  KHN: {
    code: "KHN",
    name: "NANCHANG",
    chineseName: "南昌",
    traditionalName: "南昌",
    airports: [
      {
        code: "KHN",
        name: "Changbei intl",
        chineseName: "昌北国际机场",
        traditionalName: "昌北國際機場",
      },
    ],
  },
  KHS: {
    code: "KHS",
    name: "KHASAB",
    chineseName: "海塞卜",
    traditionalName: "海塞蔔",
    airports: [
      {
        code: "KHS",
        name: "Khasab airport",
        chineseName: "海塞卜机场",
        traditionalName: "海塞蔔機場",
      },
    ],
  },
  KHT: {
    code: "KHT",
    name: "KHOST",
    chineseName: "霍斯特",
    traditionalName: "霍斯特",
    airports: [
      {
        code: "KHT",
        name: "Chapman",
        chineseName: "霍斯特机场",
        traditionalName: "霍斯特機場",
      },
    ],
  },
  KHV: {
    code: "KHV",
    name: "KHABAROVSK",
    chineseName: "哈巴罗夫斯克",
    traditionalName: "哈巴羅夫斯克",
    airports: [
      {
        code: "KHV",
        name: "Novy",
        chineseName: "诺维机场",
        traditionalName: "諾維機場",
      },
    ],
  },
  KHX: {
    code: "KHX",
    name: "KIHIHI",
    chineseName: "Kihihi",
    traditionalName: "Kihihi",
    airports: [
      {
        code: "KHX",
        name: "Kihihi airport",
        chineseName: "奇黑黑机场",
        traditionalName: "奇黑黑機場",
      },
    ],
  },
  KHY: {
    code: "KHY",
    name: "KHOY",
    chineseName: "基希岛",
    traditionalName: "基希島",
    airports: [
      {
        code: "KHY",
        name: "Khoy airport",
        chineseName: "基希岛机场",
        traditionalName: "基希島機場",
      },
    ],
  },
  KHZ: {
    code: "KHZ",
    name: "KAUEHI",
    chineseName: "卡韦希环礁",
    traditionalName: "卡韋希環礁",
    airports: [
      {
        code: "KHZ",
        name: "Kauehi airport",
        chineseName: "卡耶西机场",
        traditionalName: "卡耶西機場",
      },
    ],
  },
  KID: {
    code: "KID",
    name: "KRISTIANSTAD",
    chineseName: "克里斯蒂娜城",
    traditionalName: "克莉絲蒂娜城",
    airports: [
      {
        code: "KID",
        name: "Kristianstad airport",
        chineseName: "克里斯蒂娜城机场",
        traditionalName: "克莉絲蒂娜城機場",
      },
    ],
  },
  KIE: {
    code: "KIE",
    name: "KIETA",
    chineseName: "基埃塔",
    traditionalName: "基埃塔",
    airports: [
      {
        code: "KIE",
        name: "Aropa",
        chineseName: "阿罗帕机场",
        traditionalName: "阿羅帕機場",
      },
    ],
  },
  KIF: {
    code: "KIF",
    name: "KINGFISHER LAKE",
    chineseName: "金菲舍湖",
    traditionalName: "金菲舍湖",
    airports: [
      {
        code: "KIF",
        name: "Kingfisher lake airport",
        chineseName: "金菲舍湖机场",
        traditionalName: "金菲舍湖機場",
      },
    ],
  },
  KIH: {
    code: "KIH",
    name: "KISH ISLAND",
    chineseName: "基什岛",
    traditionalName: "基什島",
    airports: [
      {
        code: "KIH",
        name: "Kish island airport",
        chineseName: "启什岛机场",
        traditionalName: "啟什島機場",
      },
    ],
  },
  KIJ: {
    code: "KIJ",
    name: "NIIGATA",
    chineseName: "新泻",
    traditionalName: "新瀉",
    airports: [
      {
        code: "KIJ",
        name: "Niigata airport",
        chineseName: "新潟机场",
        traditionalName: "新潟機場",
      },
    ],
  },
  KIK: {
    code: "KIK",
    name: "KIRKUK",
    chineseName: "基尔库克",
    traditionalName: "基爾庫克",
    airports: [
      {
        code: "KIK",
        name: "Kirkuk intl.",
        chineseName: "基尔库克机场",
        traditionalName: "基爾庫克機場",
      },
    ],
  },
  KIM: {
    code: "KIM",
    name: "KIMBERLEY",
    chineseName: "金伯利",
    traditionalName: "金伯利",
    airports: [
      {
        code: "KIM",
        name: "Kimberley airport",
        chineseName: "金伯利机场",
        traditionalName: "金伯利機場",
      },
    ],
  },
  KIN: {
    code: "KIN",
    name: "KINGSTON",
    chineseName: "金斯敦",
    traditionalName: "京斯頓",
    airports: [
      {
        code: "KIN",
        name: "Norman manley intl",
        chineseName: "诺曼曼雷国际机场",
        traditionalName: "諾曼曼雷國際機場",
      },
    ],
  },
  KIO: {
    code: "KIO",
    name: "KILI ISLAND",
    chineseName: "基利岛",
    traditionalName: "基利島",
    airports: [
      {
        code: "KIO",
        name: "Kili island airport",
        chineseName: "基利岛机场",
        traditionalName: "基利島機場",
      },
    ],
  },
  KIR: {
    code: "KIR",
    name: "KERRY",
    chineseName: "凯里郡",
    traditionalName: "凱裡郡",
    airports: [
      {
        code: "KIR",
        name: "Kerry airport",
        chineseName: "凯里郡机场",
        traditionalName: "凱裡郡機場",
      },
    ],
  },
  KIS: {
    code: "KIS",
    name: "KISUMU",
    chineseName: "基苏木",
    traditionalName: "基蘇木",
    airports: [
      {
        code: "KIS",
        name: "Kisumu airport",
        chineseName: "基苏木机场",
        traditionalName: "基蘇木機場",
      },
    ],
  },
  KIT: {
    code: "KIT",
    name: "KYTHIRA",
    chineseName: "基西拉岛",
    traditionalName: "基西拉島",
    airports: [
      {
        code: "KIT",
        name: "Alexandros a. onassis",
        chineseName: "基西拉机场",
        traditionalName: "基西拉機場",
      },
    ],
  },
  KIV: {
    code: "KIV",
    name: "CHISINAU",
    chineseName: "基希讷乌",
    traditionalName: "基希訥烏",
    airports: [
      {
        code: "RMO",
        name: "Chisinau intl.",
        chineseName: "基希讷乌国际机场",
        traditionalName: "基希訥烏國際機場",
      },
    ],
  },
  KJA: {
    code: "KJA",
    name: "KRASNOYARSK",
    chineseName: "克拉斯诺亚尔斯克",
    traditionalName: "克拉斯諾亞爾斯克",
    airports: [
      {
        code: "KCY",
        name: "Cheremshanka",
        chineseName: "Cheremshanka机场",
        traditionalName: "Cheremshanka機場",
      },
      {
        code: "KJA",
        name: "Krasnoyarsk airport",
        chineseName: "叶米里亚诺瓦机场",
        traditionalName: "葉米裏亞諾瓦機場",
      },
    ],
  },
  KJB: {
    code: "KJB",
    name: "KURNOOL",
    chineseName: "库尔诺尔",
    traditionalName: "庫爾諾爾",
    airports: [
      {
        code: "KJB",
        name: "Kurnool airport",
        chineseName: "Kurnool机场",
        traditionalName: "Kurnool機場",
      },
    ],
  },
  KJH: {
    code: "KJH",
    name: "HUANG PING",
    chineseName: "凯里",
    traditionalName: "凱裡",
    airports: [
      {
        code: "KJH",
        name: "Kai li",
        chineseName: "黄平机场",
        traditionalName: "黃平機場",
      },
    ],
  },
  KJI: {
    code: "KJI",
    name: "BURQIN",
    chineseName: "布尔津",
    traditionalName: "布林津",
    airports: [
      {
        code: "KJI",
        name: "Kanas",
        chineseName: "喀纳斯机场",
        traditionalName: "喀納斯機場",
      },
    ],
  },
  KJT: {
    code: "KJT",
    name: "MAJALENGKA",
    chineseName: "Majalenka",
    traditionalName: "Majalenka",
    airports: [
      {
        code: "KJT",
        name: "Kertajati intl",
        chineseName: "克尔塔查蒂机场",
        traditionalName: "克爾塔查蒂機場",
      },
    ],
  },
  KKA: {
    code: "KKA",
    name: "KOYUK",
    chineseName: "阿拉斯加州Koyuk",
    traditionalName: "阿拉斯加州Koyuk",
    airports: [
      {
        code: "KKA",
        name: "Alfred adams",
        chineseName: "阿尔弗雷德亚当斯机场",
        traditionalName: "阿爾弗雷德亞當斯機場",
      },
    ],
  },
  KKB: {
    code: "KKB",
    name: "KITOI BAY",
    chineseName: "基图伊贝",
    traditionalName: "基圖伊貝",
    airports: [
      {
        code: "KKB",
        name: "Sea plane base",
        chineseName: "基图伊贝机场",
        traditionalName: "基圖伊貝機場",
      },
    ],
  },
  KKC: {
    code: "KKC",
    name: "KHON KAEN",
    chineseName: "孔敬",
    traditionalName: "孔敬",
    airports: [
      {
        code: "KKC",
        name: "Khon kaen airport",
        chineseName: "孔敬机场",
        traditionalName: "孔敬機場",
      },
    ],
  },
  KKE: {
    code: "KKE",
    name: "KERIKERI",
    chineseName: "凯利凯利",
    traditionalName: "凱利凱利",
    airports: [
      {
        code: "KKE",
        name: "Bay of islands",
        chineseName: "克里克里机场",
        traditionalName: "克裡克裏機場",
      },
    ],
  },
  KKH: {
    code: "KKH",
    name: "KONGIGANAK",
    chineseName: "孔基加纳克",
    traditionalName: "孔基加納克",
    airports: [
      {
        code: "KKH",
        name: "Kongiganak airport",
        chineseName: "孔基加纳克机场",
        traditionalName: "孔基加納克機場",
      },
    ],
  },
  KKI: {
    code: "KKI",
    name: "AKIACHAK",
    chineseName: "阿拉斯加州阿基恰克",
    traditionalName: "阿拉斯加州阿基恰克",
    airports: [
      {
        code: "KKI",
        name: "Akiachak airport",
        chineseName: "阿基亚查克机场",
        traditionalName: "阿基亞查克機場",
      },
    ],
  },
  KKJ: {
    code: "KKJ",
    name: "KITAKYUSHU",
    chineseName: "福冈",
    traditionalName: "福岡",
    airports: [
      {
        code: "KKJ",
        name: "Kitakyushu airport",
        chineseName: "北九州岛机场",
        traditionalName: "北九州機場",
      },
    ],
  },
  KKN: {
    code: "KKN",
    name: "KIRKENES",
    chineseName: "希尔科内斯",
    traditionalName: "希爾科內斯",
    airports: [
      {
        code: "KKN",
        name: "Hoybuktmoen",
        chineseName: "霍布克特莫恩机场",
        traditionalName: "霍布克特莫恩機場",
      },
    ],
  },
  KKQ: {
    code: "KKQ",
    name: "KRASNOSELKUP",
    chineseName: "克拉斯诺塞尔库普",
    traditionalName: "克拉斯諾塞爾庫普",
    airports: [
      {
        code: "KKQ",
        name: "Krasnoselkup airport",
        chineseName: "克拉斯诺谢利库普机场",
        traditionalName: "克拉斯諾謝利庫普機場",
      },
    ],
  },
  KKR: {
    code: "KKR",
    name: "KAUKURA",
    chineseName: "考库拉环礁",
    traditionalName: "考庫拉環礁",
    airports: [
      {
        code: "KKR",
        name: "Kaukura airport",
        chineseName: "考库拉环礁机场",
        traditionalName: "考庫拉環礁機場",
      },
    ],
  },
  KKS: {
    code: "KKS",
    name: "KASHAN",
    chineseName: "卡尚",
    traditionalName: "卡尚",
    airports: [
      {
        code: "KKS",
        name: "Kashan airport",
        chineseName: "卡尚机场",
        traditionalName: "卡尚機場",
      },
    ],
  },
  KKX: {
    code: "KKX",
    name: "KIKAI",
    chineseName: "喜界岛",
    traditionalName: "喜界島",
    airports: [
      {
        code: "KKX",
        name: "Kikai airport",
        chineseName: "喜界机场",
        traditionalName: "喜界機場",
      },
    ],
  },
  KLF: {
    code: "KLF",
    name: "KALUGA",
    chineseName: "卡卢加",
    traditionalName: "卡盧加",
    airports: [
      {
        code: "KLF",
        name: "Grabtsevo",
        chineseName: "格拉比斯沃机场",
        traditionalName: "格拉比斯沃機場",
      },
    ],
  },
  KLG: {
    code: "KLG",
    name: "KALSKAG",
    chineseName: "阿拉斯加州城市Kalska",
    traditionalName: "阿拉斯加州都市Kalska",
    airports: [
      {
        code: "KLG",
        name: "Kalskag airport",
        chineseName: "卡尔斯卡格机场",
        traditionalName: "卡爾斯卡格機場",
      },
    ],
  },
  KLH: {
    code: "KLH",
    name: "KOLHAPUR",
    chineseName: "戈尔哈布尔",
    traditionalName: "戈爾哈布林",
    airports: [
      {
        code: "KLH",
        name: "Kolhapur airport",
        chineseName: "戈尔哈布尔机场",
        traditionalName: "戈爾哈布林機場",
      },
    ],
  },
  KLL: {
    code: "KLL",
    name: "LEVELOCK",
    chineseName: "莱弗洛克",
    traditionalName: "萊弗洛克",
    airports: [
      {
        code: "KLL",
        name: "Levelock airport",
        chineseName: "莱瓦洛克机场",
        traditionalName: "萊瓦洛克機場",
      },
    ],
  },
  KLN: {
    code: "KLN",
    name: "LARSEN BAY",
    chineseName: "阿拉斯加州拉森湾",
    traditionalName: "阿拉斯加州拉森灣",
    airports: [
      {
        code: "KLN",
        name: "Larsen bay airport",
        chineseName: "拉森贝机场",
        traditionalName: "拉森貝機場",
      },
    ],
  },
  KLO: {
    code: "KLO",
    name: "KALIBO",
    chineseName: "卡利波",
    traditionalName: "卡利波",
    airports: [
      {
        code: "KLO",
        name: "Kalibo intl.",
        chineseName: "卡利博机场",
        traditionalName: "卡里博機場",
      },
    ],
  },
  KLR: {
    code: "KLR",
    name: "KALMAR",
    chineseName: "卡尔马",
    traditionalName: "卡爾馬",
    airports: [
      {
        code: "KLR",
        name: "Kalmar airport",
        chineseName: "卡尔马机场",
        traditionalName: "卡爾馬機場",
      },
    ],
  },
  KLU: {
    code: "KLU",
    name: "KLAGENFURT",
    chineseName: "克拉根福",
    traditionalName: "克拉根福",
    airports: [
      {
        code: "KLU",
        name: "Klagenfurt airport",
        chineseName: "克拉根福机场",
        traditionalName: "克拉根福機場",
      },
    ],
  },
  KLW: {
    code: "KLW",
    name: "KLAWOCK",
    chineseName: "克拉沃克",
    traditionalName: "克拉沃克",
    airports: [
      {
        code: "KLW",
        name: "Klawock airport",
        chineseName: "克拉沃克机场",
        traditionalName: "克拉沃克機場",
      },
    ],
  },
  KLX: {
    code: "KLX",
    name: "KALAMATA",
    chineseName: "卡拉马塔",
    traditionalName: "卡拉馬塔",
    airports: [
      {
        code: "KLX",
        name: "Kalamata airport",
        chineseName: "卡拉马塔机场",
        traditionalName: "卡拉馬塔機場",
      },
    ],
  },
  KME: {
    code: "KME",
    name: "CYANGUGU",
    chineseName: "卡门贝",
    traditionalName: "卡門貝",
    airports: [
      {
        code: "KME",
        name: "Kamembe",
        chineseName: "卡门贝机场",
        traditionalName: "卡門貝機場",
      },
    ],
  },
  KMG: {
    code: "KMG",
    name: "KUNMING",
    chineseName: "昆明",
    traditionalName: "昆明",
    airports: [
      {
        code: "KMG",
        name: "Changshui intl",
        chineseName: "长水国际机场",
        traditionalName: "長水國際機場",
      },
    ],
  },
  KMI: {
    code: "KMI",
    name: "MIYAZAKI",
    chineseName: "宫崎",
    traditionalName: "宮崎",
    airports: [
      {
        code: "KMI",
        name: "Miyazaki airport",
        chineseName: "宫崎机场",
        traditionalName: "宮崎機場",
      },
    ],
  },
  KMJ: {
    code: "KMJ",
    name: "KUMAMOTO",
    chineseName: "熊本",
    traditionalName: "熊本",
    airports: [
      {
        code: "KMJ",
        name: "Kumamoto airport",
        chineseName: "熊本机场",
        traditionalName: "熊本機場",
      },
    ],
  },
  KMK: {
    code: "KMK",
    name: "MAKABANA",
    chineseName: "马卡巴纳",
    traditionalName: "馬卡巴納",
    airports: [
      {
        code: "KMK",
        name: "Makabana airport",
        chineseName: "马卡巴纳机场",
        traditionalName: "馬卡巴納機場",
      },
    ],
  },
  KMN: {
    code: "KMN",
    name: "KAMINA",
    chineseName: "卡米那",
    traditionalName: "卡米那",
    airports: [
      {
        code: "KMN",
        name: "Kamina-ville",
        chineseName: "卡米那机场",
        traditionalName: "卡米那機場",
      },
    ],
  },
  KMO: {
    code: "KMO",
    name: "MANOKOTAK",
    chineseName: "阿拉斯加州马诺科塔克",
    traditionalName: "阿拉斯加州馬諾科塔克",
    airports: [
      {
        code: "KMO",
        name: "Manokotak airport",
        chineseName: "马诺科塔克机场",
        traditionalName: "馬諾科塔克機場",
      },
    ],
  },
  KMQ: {
    code: "KMQ",
    name: "KOMATSU",
    chineseName: "小松",
    traditionalName: "小松",
    airports: [
      {
        code: "KMQ",
        name: "Komatsu airport",
        chineseName: "小松机场",
        traditionalName: "小松機場",
      },
    ],
  },
  KMS: {
    code: "KMS",
    name: "KUMASI",
    chineseName: "库马西",
    traditionalName: "庫馬西",
    airports: [
      {
        code: "KMS",
        name: "Kumasi airport",
        chineseName: "库马西机场",
        traditionalName: "庫馬西機場",
      },
    ],
  },
  KMU: {
    code: "KMU",
    name: "KISIMAYU",
    chineseName: "基斯马尤",
    traditionalName: "基斯馬尤",
    airports: [
      {
        code: "KMU",
        name: "Kisimayu airport",
        chineseName: "基斯马尤机场",
        traditionalName: "基斯馬尤機場",
      },
    ],
  },
  KMV: {
    code: "KMV",
    name: "KALEMYO",
    chineseName: "吉灵庙",
    traditionalName: "吉靈廟",
    airports: [
      {
        code: "KMV",
        name: "Kalemyo airport",
        chineseName: "吉灵庙机场",
        traditionalName: "吉靈廟機場",
      },
    ],
  },
  KMW: {
    code: "KMW",
    name: "KOSTROMA",
    chineseName: "科斯特罗马",
    traditionalName: "科斯特羅馬",
    airports: [
      {
        code: "KMW",
        name: "Kostroma airport",
        chineseName: "科斯特罗马机场",
        traditionalName: "科斯特羅馬機場",
      },
    ],
  },
  KMY: {
    code: "KMY",
    name: "MOSER BAY",
    chineseName: "莫塞尔湾",
    traditionalName: "莫塞爾灣",
    airports: [
      {
        code: "KMY",
        name: "Sea plane base",
        chineseName: "莫塞尔湾机场",
        traditionalName: "莫塞爾灣機場",
      },
    ],
  },
  KND: {
    code: "KND",
    name: "KINDU",
    chineseName: "金杜",
    traditionalName: "金杜",
    airports: [
      {
        code: "KND",
        name: "Kindu airport",
        chineseName: "金杜机场",
        traditionalName: "金杜機場",
      },
    ],
  },
  KNG: {
    code: "KNG",
    name: "UTAROM",
    chineseName: "凯马纳",
    traditionalName: "凱馬納",
    airports: [
      {
        code: "KNG",
        name: "Kaimana",
        chineseName: "凯马纳机场",
        traditionalName: "凱馬納機場",
      },
    ],
  },
  KNH: {
    code: "KNH",
    name: "KINMEN",
    chineseName: "金门",
    traditionalName: "金門",
    airports: [
      {
        code: "KNH",
        name: "Shangyi",
        chineseName: "尚义机场",
        traditionalName: "尚義機場",
      },
    ],
  },
  KNK: {
    code: "KNK",
    name: "KOKHANOK",
    chineseName: "阿拉斯加城市卡霍纳",
    traditionalName: "阿拉斯加都市卡霍納",
    airports: [
      {
        code: "KNK",
        name: "Kokhanok airport",
        chineseName: "卡克霍纳克机场",
        traditionalName: "卡克霍納克機場",
      },
    ],
  },
  KNQ: {
    code: "KNQ",
    name: "KONE",
    chineseName: "科内",
    traditionalName: "科內",
    airports: [
      {
        code: "KNQ",
        name: "Kone airport",
        chineseName: "科内机场",
        traditionalName: "科內機場",
      },
    ],
  },
  KNS: {
    code: "KNS",
    name: "KING ISLAND",
    chineseName: "金岛",
    traditionalName: "金島",
    airports: [
      {
        code: "KNS",
        name: "King island airport",
        chineseName: "金岛机场",
        traditionalName: "金島機場",
      },
    ],
  },
  KNU: {
    code: "KNU",
    name: "KANPUR",
    chineseName: "坎普尔",
    traditionalName: "坎普爾",
    airports: [
      {
        code: "KNU",
        name: "Kanpur airport",
        chineseName: "坎普尔机场",
        traditionalName: "坎普爾機場",
      },
    ],
  },
  KNW: {
    code: "KNW",
    name: "NEW STUYAHOK",
    chineseName: "阿拉斯加州新斯图亚霍克",
    traditionalName: "阿拉斯加州新斯圖亞霍克",
    airports: [
      {
        code: "KNW",
        name: "New stuyahok airport",
        chineseName: "新斯图亚豪克机场",
        traditionalName: "新斯圖亞豪克機場",
      },
    ],
  },
  KNX: {
    code: "KNX",
    name: "KUNUNURRA",
    chineseName: "库努纳拉",
    traditionalName: "庫努納拉",
    airports: [
      {
        code: "KNX",
        name: "Kununurra airport",
        chineseName: "库奴纳拉机场",
        traditionalName: "庫奴納拉機場",
      },
    ],
  },
  KNY: {
    code: "KNY",
    name: "KODINSK",
    chineseName: "基努绍",
    traditionalName: "基努紹",
    airports: [
      {
        code: "KNY",
        name: "Kodinsk airport",
        chineseName: "基努绍机场",
        traditionalName: "基努紹機場",
      },
    ],
  },
  KOA: {
    code: "KOA",
    name: "KONA",
    chineseName: "科纳",
    traditionalName: "科納",
    airports: [
      {
        code: "KOA",
        name: "Keahole",
        chineseName: "科纳机场",
        traditionalName: "科納機場",
      },
    ],
  },
  KOE: {
    code: "KOE",
    name: "KUPANG",
    chineseName: "古邦",
    traditionalName: "古邦",
    airports: [
      {
        code: "KOE",
        name: "El tari",
        chineseName: "埃尔塔里机场",
        traditionalName: "埃爾塔裏機場",
      },
    ],
  },
  KOI: {
    code: "KOI",
    name: "KIRKWALL",
    chineseName: "柯克沃尔",
    traditionalName: "柯克沃爾",
    airports: [
      {
        code: "KOI",
        name: "Kirkwall airport",
        chineseName: "柯克沃尔机场",
        traditionalName: "柯克沃爾機場",
      },
    ],
  },
  KOJ: {
    code: "KOJ",
    name: "KAGOSHIMA",
    chineseName: "鹿儿岛",
    traditionalName: "鹿兒島",
    airports: [
      {
        code: "KOJ",
        name: "Kagoshima airport",
        chineseName: "鹿儿岛机场",
        traditionalName: "鹿兒島機場",
      },
    ],
  },
  KOK: {
    code: "KOK",
    name: "KOKKOLA/PIETARSAARI",
    chineseName: "科科拉",
    traditionalName: "科科拉",
    airports: [
      {
        code: "KOK",
        name: "Kruunupyy",
        chineseName: "科科拉机场",
        traditionalName: "科科拉機場",
      },
    ],
  },
  KOM: {
    code: "KOM",
    name: "KOMO",
    chineseName: "克莫",
    traditionalName: "克莫",
    airports: [
      {
        code: "KOM",
        name: "Komo airport",
        chineseName: "克莫机场",
        traditionalName: "克莫機場",
      },
    ],
  },
  KOP: {
    code: "KOP",
    name: "NAKHON PHANOM",
    chineseName: "那空拍依",
    traditionalName: "那空拍依",
    airports: [
      {
        code: "KOP",
        name: "Nakhon phanom airport",
        chineseName: "那空拍侬机场",
        traditionalName: "那空拍儂機場",
      },
    ],
  },
  KOS: {
    code: "KOS",
    name: "SIHANOUKVILLE",
    chineseName: "西哈努克",
    traditionalName: "施漢諾",
    airports: [
      {
        code: "KOS",
        name: "Sihanoukville intl.",
        chineseName: "西哈努克国际机场",
        traditionalName: "施漢諾國際機場",
      },
    ],
  },
  KOT: {
    code: "KOT",
    name: "KOTLIK",
    chineseName: "阿拉斯加城市科特利",
    traditionalName: "阿拉斯加都市科特利",
    airports: [
      {
        code: "KOT",
        name: "Kotlik airport",
        chineseName: "科特里克机场",
        traditionalName: "科特裏克機場",
      },
    ],
  },
  KOV: {
    code: "KOV",
    name: "KOKSHETAU",
    chineseName: "科克舍套",
    traditionalName: "科克舍套",
    airports: [
      {
        code: "KOV",
        name: "Kokshetau airport",
        chineseName: "科科舍塔机场",
        traditionalName: "科科舍塔機場",
      },
    ],
  },
  KOW: {
    code: "KOW",
    name: "GANZHOU",
    chineseName: "赣州",
    traditionalName: "贛州",
    airports: [
      {
        code: "KOW",
        name: "Huangjin",
        chineseName: "黄金机场",
        traditionalName: "黃金機場",
      },
    ],
  },
  KOY: {
    code: "KOY",
    name: "OLGA BAY",
    chineseName: "奥尔加湾",
    traditionalName: "奧爾加灣",
    airports: [
      {
        code: "KOY",
        name: "Sea plane base",
        chineseName: "奥尔加湾机场",
        traditionalName: "奧爾加灣機場",
      },
    ],
  },
  KOZ: {
    code: "KOZ",
    name: "OUZINKIE",
    chineseName: "阿拉斯加城市乌津",
    traditionalName: "阿拉斯加都市烏津",
    airports: [
      {
        code: "KOZ",
        name: "Ouzinkie airport",
        chineseName: "奥兹恩基机场",
        traditionalName: "奧茲恩基機場",
      },
    ],
  },
  KPB: {
    code: "KPB",
    name: "POINT BAKER",
    chineseName: "波因特贝克",
    traditionalName: "波因特貝克",
    airports: [
      {
        code: "KPB",
        name: "Sea plane base",
        chineseName: "波因特贝克水上飞机机场",
        traditionalName: "波因特貝克水上飛機機場",
      },
    ],
  },
  KPN: {
    code: "KPN",
    name: "KIPNUK",
    chineseName: "基普努克，阿拉斯加",
    traditionalName: "基普努克，阿拉斯加",
    airports: [
      {
        code: "KPN",
        name: "Kipnuk airport",
        chineseName: "基普努克机场",
        traditionalName: "基普努克機場",
      },
    ],
  },
  KPO: {
    code: "KPO",
    name: "POHANG",
    chineseName: "浦项",
    traditionalName: "浦項",
    airports: [
      {
        code: "KPO",
        name: "Pohang airport",
        chineseName: "浦项机场",
        traditionalName: "浦項機場",
      },
    ],
  },
  KPR: {
    code: "KPR",
    name: "PORT WILLIAMS",
    chineseName: "威廉姆斯港",
    traditionalName: "威廉姆斯港",
    airports: [
      {
        code: "KPR",
        name: "Sea plane base",
        chineseName: "威廉姆斯港机场",
        traditionalName: "威廉姆斯港機場",
      },
    ],
  },
  KPV: {
    code: "KPV",
    name: "PERRYVILLE",
    chineseName: "佩里维尔，阿拉斯加",
    traditionalName: "佩裏維爾，阿拉斯加",
    airports: [
      {
        code: "KPV",
        name: "Perryville airport",
        chineseName: "佩里维尔机场",
        traditionalName: "佩里維爾機場",
      },
    ],
  },
  KPW: {
    code: "KPW",
    name: "KEPERVEYEM",
    chineseName: "克佩尔韦耶姆",
    traditionalName: "克佩爾韋耶姆",
    airports: [
      {
        code: "KPW",
        name: "Keperveyem airport",
        chineseName: "凯佩尔韦耶姆机场",
        traditionalName: "凱佩爾韋耶姆機場",
      },
    ],
  },
  KPY: {
    code: "KPY",
    name: "PORT BAILEY",
    chineseName: "拜雷港",
    traditionalName: "拜雷港",
    airports: [
      {
        code: "KPY",
        name: "Sea plane base",
        chineseName: "拜雷港水上飞机基地机场",
        traditionalName: "拜雷港水上飛機基地機場",
      },
    ],
  },
  KQA: {
    code: "KQA",
    name: "AKUTAN",
    chineseName: "阿库坦",
    traditionalName: "阿庫坦",
    airports: [
      {
        code: "KQA",
        name: "Akutan airport",
        chineseName: "阿库坦机场",
        traditionalName: "阿庫坦機場",
      },
    ],
  },
  KQH: {
    code: "KQH",
    name: "KISHANGARH",
    chineseName: "基尚格尔",
    traditionalName: "基尚格爾",
    airports: [
      {
        code: "KQH",
        name: "Ajmer",
        chineseName: "阿杰梅尔机场",
        traditionalName: "阿傑梅爾機場",
      },
    ],
  },
  KQT: {
    code: "KQT",
    name: "QURGHONTEPPA",
    chineseName: "库尔干秋别",
    traditionalName: "庫爾幹秋別",
    airports: [
      {
        code: "KQT",
        name: "Qurghonteppa intl.",
        chineseName: "库尔干秋别国际机场",
        traditionalName: "庫爾幹秋別國際機場",
      },
    ],
  },
  KRF: {
    code: "KRF",
    name: "KRAMFORS/SOLLEFTEA",
    chineseName: "克拉姆福什",
    traditionalName: "克拉姆福什",
    airports: [
      {
        code: "KRF",
        name: "Kramfors/solleftea airport",
        chineseName: "克拉姆福什机场",
        traditionalName: "克拉姆福什機場",
      },
    ],
  },
  KRK: {
    code: "KRK",
    name: "KRAKOW",
    chineseName: "克拉科夫",
    traditionalName: "克拉科夫",
    airports: [
      {
        code: "KRK",
        name: "John paul ii - balice",
        chineseName: "克拉科夫机场",
        traditionalName: "克拉科夫機場",
      },
    ],
  },
  KRL: {
    code: "KRL",
    name: "KORLA",
    chineseName: "库尔勒",
    traditionalName: "庫爾勒",
    airports: [
      {
        code: "KRL",
        name: "Korla airport",
        chineseName: "梨城机场",
        traditionalName: "梨城機場",
      },
    ],
  },
  KRN: {
    code: "KRN",
    name: "KIRUNA",
    chineseName: "基律纳",
    traditionalName: "基律納",
    airports: [
      {
        code: "KRN",
        name: "Kiruna airport",
        chineseName: "基律纳机场",
        traditionalName: "基律納機場",
      },
    ],
  },
  KRO: {
    code: "KRO",
    name: "KURGAN",
    chineseName: "库尔干",
    traditionalName: "庫爾幹",
    airports: [
      {
        code: "KRO",
        name: "Kurgan airport",
        chineseName: "库尔干机场",
        traditionalName: "庫爾幹機場",
      },
    ],
  },
  KRP: {
    code: "KRP",
    name: "KARUP",
    chineseName: "卡鲁普",
    traditionalName: "卡魯普",
    airports: [
      {
        code: "KRP",
        name: "Midtjyllands",
        chineseName: "卡鲁普机场",
        traditionalName: "卡魯普機場",
      },
    ],
  },
  KRS: {
    code: "KRS",
    name: "KRISTIANSAND",
    chineseName: "克里斯蒂安桑",
    traditionalName: "克里斯蒂安桑",
    airports: [
      {
        code: "KRS",
        name: "Kjevik",
        chineseName: "凯捷维克机场",
        traditionalName: "凱捷維克機場",
      },
    ],
  },
  KRT: {
    code: "KRT",
    name: "KHARTOUM",
    chineseName: "喀土穆",
    traditionalName: "喀土穆",
    airports: [
      {
        code: "KRT",
        name: "Khartoum intl.",
        chineseName: "喀土穆国际机场",
        traditionalName: "喀土穆國際機場",
      },
    ],
  },
  KRW: {
    code: "KRW",
    name: "TURKMENBASHI",
    chineseName: "土库曼巴什",
    traditionalName: "土庫曼巴什",
    airports: [
      {
        code: "KRW",
        name: "Turkmenbashi airport",
        chineseName: "土库曼巴希机场",
        traditionalName: "土庫曼巴希機場",
      },
    ],
  },
  KRY: {
    code: "KRY",
    name: "KARAMAY",
    chineseName: "克拉玛依",
    traditionalName: "克拉瑪依",
    airports: [
      {
        code: "KRY",
        name: "Karamay airport",
        chineseName: "克拉玛依机场",
        traditionalName: "克拉瑪依機場",
      },
    ],
  },
  KSA: {
    code: "KSA",
    name: "KOSRAE",
    chineseName: "科斯拉耶",
    traditionalName: "科斯拉耶",
    airports: [
      {
        code: "KSA",
        name: "Kosrae intl.",
        chineseName: "科斯雷机场",
        traditionalName: "科斯雷機場",
      },
    ],
  },
  KSC: {
    code: "KSC",
    name: "KOSICE",
    chineseName: "科希策",
    traditionalName: "科希策",
    airports: [
      {
        code: "KSC",
        name: "Kosice airport",
        chineseName: "科希策机场",
        traditionalName: "科希策機場",
      },
    ],
  },
  KSE: {
    code: "KSE",
    name: "KASESE",
    chineseName: "卡塞塞",
    traditionalName: "卡塞塞",
    airports: [
      {
        code: "KSE",
        name: "Kasese airport",
        chineseName: "卡塞塞机场",
        traditionalName: "卡塞塞機場",
      },
    ],
  },
  KSF: {
    code: "KSF",
    name: "KASSEL",
    chineseName: "卡塞尔",
    traditionalName: "卡塞爾",
    airports: [
      {
        code: "KSF",
        name: "Calden",
        chineseName: "卡塞尔－卡尔登机场",
        traditionalName: "卡塞爾－卡爾登機場",
      },
    ],
  },
  KSH: {
    code: "KSH",
    name: "KERMANSHAH",
    chineseName: "克尔曼沙阿",
    traditionalName: "克爾曼沙阿",
    airports: [
      {
        code: "KSH",
        name: "Shahid ashrafiesfahani",
        chineseName: "克尔曼沙阿机场",
        traditionalName: "克爾曼沙阿機場",
      },
    ],
  },
  KSJ: {
    code: "KSJ",
    name: "KASOS ISLAND",
    chineseName: "卡索斯岛",
    traditionalName: "卡索斯島",
    airports: [
      {
        code: "KSJ",
        name: "Kasos island airport",
        chineseName: "卡索斯岛机场",
        traditionalName: "卡索斯島機場",
      },
    ],
  },
  KSM: {
    code: "KSM",
    name: "ST MARY'S",
    chineseName: "圣玛丽斯",
    traditionalName: "聖瑪麗斯",
    airports: [
      {
        code: "KSM",
        name: "St mary's airport",
        chineseName: "圣玛丽斯机场",
        traditionalName: "聖瑪麗斯機場",
      },
    ],
  },
  KSN: {
    code: "KSN",
    name: "KOSTANAY",
    chineseName: "科斯塔内",
    traditionalName: "科斯塔內",
    airports: [
      {
        code: "KSN",
        name: "Kostanay airport",
        chineseName: "科斯塔内机场",
        traditionalName: "科斯塔內機場",
      },
    ],
  },
  KSO: {
    code: "KSO",
    name: "KASTORIA",
    chineseName: "卡斯托里亚",
    traditionalName: "卡斯托裏亞",
    airports: [
      {
        code: "KSO",
        name: "Aristotelis",
        chineseName: "亚里斯多德机场",
        traditionalName: "亞裡斯多德機場",
      },
    ],
  },
  KSQ: {
    code: "KSQ",
    name: "KARSHI",
    chineseName: "卡尔希",
    traditionalName: "卡爾希",
    airports: [
      {
        code: "KSQ",
        name: "Karshi intl.",
        chineseName: "卡尔希机场",
        traditionalName: "卡爾希機場",
      },
    ],
  },
  KSU: {
    code: "KSU",
    name: "KRISTIANSUND",
    chineseName: "科维恩伯格特",
    traditionalName: "科維恩伯格特",
    airports: [
      {
        code: "KSU",
        name: "Kvernberget",
        chineseName: "科维恩伯格特机场",
        traditionalName: "科維恩伯格特機場",
      },
    ],
  },
  KSY: {
    code: "KSY",
    name: "KARS",
    chineseName: "卡尔斯",
    traditionalName: "卡爾斯",
    airports: [
      {
        code: "KSY",
        name: "Kars airport",
        chineseName: "卡尔斯机场",
        traditionalName: "卡爾斯機場",
      },
    ],
  },
  KTA: {
    code: "KTA",
    name: "KARRATHA",
    chineseName: "卡拉萨",
    traditionalName: "卡拉薩",
    airports: [
      {
        code: "KTA",
        name: "Karratha airport",
        chineseName: "卡拉萨机场",
        traditionalName: "卡拉薩機場",
      },
    ],
  },
  KTB: {
    code: "KTB",
    name: "THORNE BAY",
    chineseName: "索恩贝",
    traditionalName: "索恩貝",
    airports: [
      {
        code: "KTB",
        name: "Sea plane base",
        chineseName: "索恩湾水上飞机基地",
        traditionalName: "索恩灣水上飛機基地",
      },
    ],
  },
  KTD: {
    code: "KTD",
    name: "KITADAITO",
    chineseName: "北大东",
    traditionalName: "北大東",
    airports: [
      {
        code: "KTD",
        name: "Kitadaito airport",
        chineseName: "北大东机场",
        traditionalName: "北大東機場",
      },
    ],
  },
  KTE: {
    code: "KTE",
    name: "KERTEH",
    chineseName: "居茶",
    traditionalName: "居茶",
    airports: [
      {
        code: "KTE",
        name: "Kerteh airport",
        chineseName: "居茶机场",
        traditionalName: "居茶機場",
      },
    ],
  },
  KTF: {
    code: "KTF",
    name: "TAKAKA",
    chineseName: "塔卡卡",
    traditionalName: "塔卡卡",
    airports: [
      {
        code: "KTF",
        name: "Takaka airport",
        chineseName: "塔卡卡机场",
        traditionalName: "塔卡卡機場",
      },
    ],
  },
  KTG: {
    code: "KTG",
    name: "KETAPANG",
    chineseName: "吉打邦",
    traditionalName: "吉打邦",
    airports: [
      {
        code: "KTG",
        name: "Rahadi osman",
        chineseName: "吉打邦机场",
        traditionalName: "吉打邦機場",
      },
    ],
  },
  KTL: {
    code: "KTL",
    name: "KITALE",
    chineseName: "基塔莱",
    traditionalName: "基塔萊",
    airports: [
      {
        code: "KTL",
        name: "Kitale airport",
        chineseName: "基塔莱机场",
        traditionalName: "基塔萊機場",
      },
    ],
  },
  KTM: {
    code: "KTM",
    name: "KATHMANDU",
    chineseName: "加德满都",
    traditionalName: "加德滿都",
    airports: [
      {
        code: "KTM",
        name: "Tribhuvan intl",
        chineseName: "特里布胡凡国际机场",
        traditionalName: "特裏布胡凡國際機場",
      },
    ],
  },
  KTN: {
    code: "KTN",
    name: "KETCHIKAN",
    chineseName: "凯奇坎",
    traditionalName: "凱奇坎",
    airports: [
      {
        code: "KTN",
        name: "Ketchikan intl.",
        chineseName: "凯奇坎国际机场",
        traditionalName: "凱奇坎國際機場",
      },
    ],
  },
  KTR: {
    code: "KTR",
    name: "KATHERINE",
    chineseName: "凯瑟琳",
    traditionalName: "凱薩琳",
    airports: [
      {
        code: "KTR",
        name: "Raaf tindal",
        chineseName: "廷达尔机场",
        traditionalName: "廷達爾機場",
      },
    ],
  },
  KTS: {
    code: "KTS",
    name: "BREVIG MISSION",
    chineseName: "Teller Mission，阿拉斯加",
    traditionalName: "Teller Mission， 阿拉斯加",
    airports: [
      {
        code: "KTS",
        name: "Brevig mission airport",
        chineseName: "布瑞维格米申机场",
        traditionalName: "布瑞維格米申機場",
      },
    ],
  },
  KTT: {
    code: "KTT",
    name: "KITTILA",
    chineseName: "基蒂拉",
    traditionalName: "基蒂拉",
    airports: [
      {
        code: "KTT",
        name: "Kittila airport",
        chineseName: "基蒂莱机场",
        traditionalName: "基蒂萊機場",
      },
    ],
  },
  KTW: {
    code: "KTW",
    name: "KATOWICE",
    chineseName: "卡托维兹",
    traditionalName: "卡托維茲",
    airports: [
      {
        code: "KTW",
        name: "Pyrzowice",
        chineseName: "皮尔佐维斯机场",
        traditionalName: "皮爾佐維斯機場",
      },
    ],
  },
  KUA: {
    code: "KUA",
    name: "KUANTAN",
    chineseName: "关丹",
    traditionalName: "關丹",
    airports: [
      {
        code: "KUA",
        name: "Sultan haji ahmad shah",
        chineseName: "苏尔坦哈吉艾哈迈德沙阿机场",
        traditionalName: "蘇爾坦哈吉艾哈邁德沙阿機場",
      },
    ],
  },
  KUC: {
    code: "KUC",
    name: "KURIA",
    chineseName: "库里亚",
    traditionalName: "庫裡亞",
    airports: [
      {
        code: "KUC",
        name: "Kuria airport",
        chineseName: "库里亚机场",
        traditionalName: "庫裡亞機場",
      },
    ],
  },
  KUF: {
    code: "KUF",
    name: "SAMARA",
    chineseName: "萨马拉",
    traditionalName: "薩馬拉",
    airports: [
      {
        code: "KUF",
        name: "Kurumoch int'l",
        chineseName: "库鲁莫奇机场",
        traditionalName: "庫魯莫奇機場",
      },
    ],
  },
  KUG: {
    code: "KUG",
    name: "KUBIN",
    chineseName: "库宾岛",
    traditionalName: "庫賓島",
    airports: [
      {
        code: "KUG",
        name: "Kubin airport",
        chineseName: "库滨岛机场",
        traditionalName: "庫濱島機場",
      },
    ],
  },
  KUH: {
    code: "KUH",
    name: "KUSHIRO",
    chineseName: "钏路",
    traditionalName: "釧路",
    airports: [
      {
        code: "KUH",
        name: "Kushiro airport",
        chineseName: "钏路机场",
        traditionalName: "釧路機場",
      },
    ],
  },
  KUK: {
    code: "KUK",
    name: "KASIGLUK",
    chineseName: "阿拉斯加城市卡西卢",
    traditionalName: "阿拉斯加都市卡西盧",
    airports: [
      {
        code: "KUK",
        name: "Kasigluk airport",
        chineseName: "阿尔缪特机场",
        traditionalName: "阿爾繆特機場",
      },
    ],
  },
  KUL: {
    code: "KUL",
    name: "KUALA LUMPUR",
    chineseName: "吉隆坡",
    traditionalName: "吉隆玻",
    airports: [
      {
        code: "KUL",
        name: "Kuala lumpur intl.",
        chineseName: "吉隆坡国际机场",
        traditionalName: "吉隆玻國際機場",
      },
      {
        code: "SZB",
        name: "Sultan abdul aziz shah",
        chineseName: "梳邦机场",
        traditionalName: "梳邦機場",
      },
    ],
  },
  KUM: {
    code: "KUM",
    name: "YAKUSHIMA",
    chineseName: "屋久岛",
    traditionalName: "屋久島",
    airports: [
      {
        code: "KUM",
        name: "Yakushima airport",
        chineseName: "屋久岛机场",
        traditionalName: "屋久島機場",
      },
    ],
  },
  KUN: {
    code: "KUN",
    name: "KAUNAS",
    chineseName: "考纳斯",
    traditionalName: "考納斯",
    airports: [
      {
        code: "KUN",
        name: "Kaunas intl.",
        chineseName: "考纳斯国际机场",
        traditionalName: "考納斯國際機場",
      },
    ],
  },
  KUO: {
    code: "KUO",
    name: "KUOPIO",
    chineseName: "库奥皮奥",
    traditionalName: "庫奧皮奧",
    airports: [
      {
        code: "KUO",
        name: "Kuopio airport",
        chineseName: "库奥皮奥机场",
        traditionalName: "庫奧皮奧機場",
      },
    ],
  },
  KUS: {
    code: "KUS",
    name: "KULUSUK",
    chineseName: "库鲁苏克",
    traditionalName: "庫魯蘇克",
    airports: [
      {
        code: "KUS",
        name: "Kulusuk airport",
        chineseName: "库伦贾克机场",
        traditionalName: "庫倫賈克機場",
      },
    ],
  },
  KUT: {
    code: "KUT",
    name: "KUTAISI",
    chineseName: "库塔伊西",
    traditionalName: "庫塔伊西",
    airports: [
      {
        code: "KUT",
        name: "Kutaisi intl.",
        chineseName: "库塔伊西机场",
        traditionalName: "庫塔伊西機場",
      },
    ],
  },
  KUU: {
    code: "KUU",
    name: "KULLU",
    chineseName: "库尔卢",
    traditionalName: "庫爾盧",
    airports: [
      {
        code: "KUU",
        name: "Bhuntar",
        chineseName: "布恩塔尔机场",
        traditionalName: "布恩塔爾機場",
      },
    ],
  },
  KUV: {
    code: "KUV",
    name: "GUNSAN",
    chineseName: "群山",
    traditionalName: "群山",
    airports: [
      {
        code: "KUV",
        name: "Gunsan airport",
        chineseName: "群山机场",
        traditionalName: "群山機場",
      },
    ],
  },
  KVA: {
    code: "KVA",
    name: "KAVALA",
    chineseName: "卡瓦拉",
    traditionalName: "卡瓦拉",
    airports: [
      {
        code: "KVA",
        name: "Megas alexandros",
        chineseName: "梅加斯亚历山德洛斯机场",
        traditionalName: "梅加斯亞曆山德洛斯機場",
      },
    ],
  },
  KVC: {
    code: "KVC",
    name: "KING COVE",
    chineseName: "阿拉斯加市国王",
    traditionalName: "阿拉斯加市國王",
    airports: [
      {
        code: "KVC",
        name: "King cove airport",
        chineseName: "金科夫机场",
        traditionalName: "金科夫機場",
      },
    ],
  },
  KVD: {
    code: "KVD",
    name: "GANJA",
    chineseName: "甘贾",
    traditionalName: "甘賈",
    airports: [
      {
        code: "GNJ",
        name: "Ganja airport",
        chineseName: "占贾机场",
        traditionalName: "占賈機場",
      },
    ],
  },
  KVG: {
    code: "KVG",
    name: "KAVIENG",
    chineseName: "卡维恩",
    traditionalName: "卡威恩",
    airports: [
      {
        code: "KVG",
        name: "Kavieng airport",
        chineseName: "卡维恩机场",
        traditionalName: "卡威恩機場",
      },
    ],
  },
  KVK: {
    code: "KVK",
    name: "KIROVSK/APATITY",
    chineseName: "基洛夫斯克",
    traditionalName: "基洛夫斯克",
    airports: [
      {
        code: "KVK",
        name: "Khibiny",
        chineseName: "基洛夫斯克机场",
        traditionalName: "基洛夫斯克機場",
      },
    ],
  },
  KVL: {
    code: "KVL",
    name: "KIVALINA",
    chineseName: "阿拉斯加州基瓦利纳",
    traditionalName: "阿拉斯加州基瓦利納",
    airports: [
      {
        code: "KVL",
        name: "Kivalina airport",
        chineseName: "基瓦利纳机场",
        traditionalName: "基瓦利納機場",
      },
    ],
  },
  KVM: {
    code: "KVM",
    name: "MARKOVO",
    chineseName: "马尔科沃",
    traditionalName: "馬爾科沃",
    airports: [
      {
        code: "KVM",
        name: "Markovo airport",
        chineseName: "马科伏机场",
        traditionalName: "馬科伏機場",
      },
    ],
  },
  KVO: {
    code: "KVO",
    name: "KRALJEVO",
    chineseName: "克拉列沃",
    traditionalName: "克拉列沃",
    airports: [
      {
        code: "KVO",
        name: "Morava",
        chineseName: "莫拉瓦机场",
        traditionalName: "莫拉瓦機場",
      },
    ],
  },
  KVR: {
    code: "KVR",
    name: "KAVALEROVO",
    chineseName: "卡瓦列罗沃",
    traditionalName: "卡瓦列羅沃",
    airports: [
      {
        code: "KVR",
        name: "Kavalerovo airport",
        chineseName: "卡瓦列罗沃",
        traditionalName: "卡瓦列羅沃",
      },
    ],
  },
  KVX: {
    code: "KVX",
    name: "KIROV",
    chineseName: "基洛夫",
    traditionalName: "基洛夫",
    airports: [
      {
        code: "KVX",
        name: "Pobedilovo",
        chineseName: "基洛夫机场",
        traditionalName: "基洛夫機場",
      },
    ],
  },
  KWA: {
    code: "KWA",
    name: "KWAJALEIN ISLAND",
    chineseName: "夸贾林",
    traditionalName: "誇賈林",
    airports: [
      {
        code: "KWA",
        name: "Bucholz aaf",
        chineseName: "夸贾林机场",
        traditionalName: "誇賈林機場",
      },
    ],
  },
  KWE: {
    code: "KWE",
    name: "GUIYANG",
    chineseName: "贵阳",
    traditionalName: "貴陽",
    airports: [
      {
        code: "KWE",
        name: "Longdongbao intl",
        chineseName: "龙洞堡国际机场",
        traditionalName: "龍洞堡國際機場",
      },
    ],
  },
  KWI: {
    code: "KWI",
    name: "KUWAIT",
    chineseName: "科威特",
    traditionalName: "科威特",
    airports: [
      {
        code: "KWI",
        name: "Kuwait intl.",
        chineseName: "科威特国际机场",
        traditionalName: "科威特國際機場",
      },
    ],
  },
  KWJ: {
    code: "KWJ",
    name: "GWANGJU",
    chineseName: "光州",
    traditionalName: "光州",
    airports: [
      {
        code: "KWJ",
        name: "Gwangju airport",
        chineseName: "光州机场",
        traditionalName: "光州機場",
      },
    ],
  },
  KWK: {
    code: "KWK",
    name: "KWIGILLINGOK",
    chineseName: "阿拉斯加州Kwigillingkok",
    traditionalName: "阿拉斯加州Kwigillingkok",
    airports: [
      {
        code: "KWK",
        name: "Kwigillingok airport",
        chineseName: "奎吉林戈克机场",
        traditionalName: "奎吉林戈克機場",
      },
    ],
  },
  KWL: {
    code: "KWL",
    name: "GUILIN",
    chineseName: "桂林",
    traditionalName: "桂林",
    airports: [
      {
        code: "KWL",
        name: "Liangjiang intl",
        chineseName: "两江国际机场",
        traditionalName: "兩江國際機場",
      },
    ],
  },
  KWM: {
    code: "KWM",
    name: "KOWANYAMA",
    chineseName: "科瓦尼阿马",
    traditionalName: "科瓦尼阿馬",
    airports: [
      {
        code: "KWM",
        name: "Kowanyama airport",
        chineseName: "科瓦尼阿马机场",
        traditionalName: "科瓦尼阿馬機場",
      },
    ],
  },
  KWN: {
    code: "KWN",
    name: "QUINHAGAK",
    chineseName: "昆哈加克",
    traditionalName: "昆哈加克",
    airports: [
      {
        code: "KWN",
        name: "Quinhagak airport",
        chineseName: "奎因哈加克机场",
        traditionalName: "奎因哈加克機場",
      },
    ],
  },
  KWP: {
    code: "KWP",
    name: "WEST POINT",
    chineseName: "阿拉斯加州西",
    traditionalName: "阿拉斯加州西",
    airports: [
      {
        code: "KWP",
        name: "West point village spb",
        chineseName: "西点机场",
        traditionalName: "西點機場",
      },
    ],
  },
  KWT: {
    code: "KWT",
    name: "KWETHLUK",
    chineseName: "阿拉斯加州Kwethluk",
    traditionalName: "阿拉斯加州Kwethluk",
    airports: [
      {
        code: "KWT",
        name: "Kwethluk airport",
        chineseName: "奎斯卢克机场",
        traditionalName: "奎斯盧克機場",
      },
    ],
  },
  KWZ: {
    code: "KWZ",
    name: "KOLWEZI",
    chineseName: "科卢韦齐",
    traditionalName: "科盧韋齊",
    airports: [
      {
        code: "KWZ",
        name: "Kolwezi airport",
        chineseName: "科尔韦齐机场",
        traditionalName: "科爾韋齊機場",
      },
    ],
  },
  KXA: {
    code: "KXA",
    name: "KASAAN",
    chineseName: "卡萨",
    traditionalName: "卡薩",
    airports: [
      {
        code: "KXA",
        name: "Sea plane base",
        chineseName: "卡萨水上飞机机场",
        traditionalName: "卡薩水上飛機機場",
      },
    ],
  },
  KXB: {
    code: "KXB",
    name: "KOLAKA",
    chineseName: "科拉卡",
    traditionalName: "柯拉卡",
    airports: [
      {
        code: "KXB",
        name: "Sangia nibandera",
        chineseName: "Sangia Nibandera机场",
        traditionalName: "Sangia Nibandera機場",
      },
    ],
  },
  KXF: {
    code: "KXF",
    name: "KORO ISLAND",
    chineseName: "科罗岛",
    traditionalName: "柯洛島",
    airports: [
      {
        code: "KXF",
        name: "Koro island airport",
        chineseName: "科罗机场",
        traditionalName: "柯洛機場",
      },
    ],
  },
  KXO: {
    code: "KXO",
    name: "KISORO",
    chineseName: "Kisoro",
    traditionalName: "Kisoro",
    airports: [
      {
        code: "KXO",
        name: "Kisoro airport",
        chineseName: "基索罗机场",
        traditionalName: "基索羅機場",
      },
    ],
  },
  KXU: {
    code: "KXU",
    name: "KATIU",
    chineseName: "卡蒂乌",
    traditionalName: "卡蒂烏",
    airports: [
      {
        code: "KXU",
        name: "Katiu airport",
        chineseName: "卡提雷机场",
        traditionalName: "卡提雷機場",
      },
    ],
  },
  KYA: {
    code: "KYA",
    name: "KONYA",
    chineseName: "科尼亚",
    traditionalName: "科尼亞",
    airports: [
      {
        code: "KYA",
        name: "Konya airport",
        chineseName: "科尼亚机场",
        traditionalName: "科尼亞機場",
      },
    ],
  },
  KYD: {
    code: "KYD",
    name: "LANYU (ORCHID ISLAND)",
    chineseName: "兰屿",
    traditionalName: "蘭嶼",
    airports: [
      {
        code: "KYD",
        name: "Lanyu (orchid island) airport",
        chineseName: "奥奇德岛机场",
        traditionalName: "奧奇德島機場",
      },
    ],
  },
  KYK: {
    code: "KYK",
    name: "KARLUK",
    chineseName: "卡勒克",
    traditionalName: "卡勒克",
    airports: [
      {
        code: "KYK",
        name: "Karluk airport",
        chineseName: "卡勒克机场",
        traditionalName: "卡勒克機場",
      },
    ],
  },
  KYP: {
    code: "KYP",
    name: "KYAUKPYU",
    chineseName: "皎漂",
    traditionalName: "皎漂",
    airports: [
      {
        code: "KYP",
        name: "Kyaukpyu airport",
        chineseName: "皎漂机场",
        traditionalName: "皎漂機場",
      },
    ],
  },
  KYS: {
    code: "KYS",
    name: "KAYES",
    chineseName: "卡伊",
    traditionalName: "卡伊",
    airports: [
      {
        code: "KYS",
        name: "Dag-dag",
        chineseName: "凯斯机场",
        traditionalName: "凱斯機場",
      },
    ],
  },
  KYU: {
    code: "KYU",
    name: "KOYUKUK",
    chineseName: "阿拉斯加州Koyukuk",
    traditionalName: "阿拉斯加州Koyukuk",
    airports: [
      {
        code: "KYU",
        name: "Koyukuk airport",
        chineseName: "科尤库克机场",
        traditionalName: "科尤庫克機場",
      },
    ],
  },
  KYZ: {
    code: "KYZ",
    name: "KYZYL",
    chineseName: "克孜勒",
    traditionalName: "克孜勒",
    airports: [
      {
        code: "KYZ",
        name: "Kyzyl airport",
        chineseName: "克孜勒机场",
        traditionalName: "克孜勒機場",
      },
    ],
  },
  KZB: {
    code: "KZB",
    name: "ZACHAR BAY",
    chineseName: "扎切尔",
    traditionalName: "紮切爾",
    airports: [
      {
        code: "KZB",
        name: "Sea plane base",
        chineseName: "水上飞机场",
        traditionalName: "水上飛機場",
      },
    ],
  },
  KZI: {
    code: "KZI",
    name: "KOZANI",
    chineseName: "科扎尼",
    traditionalName: "科紮尼",
    airports: [
      {
        code: "KZI",
        name: "Filippos",
        chineseName: "菲利波斯机场",
        traditionalName: "菲利波斯機場",
      },
    ],
  },
  KZN: {
    code: "KZN",
    name: "KAZAN",
    chineseName: "喀山",
    traditionalName: "喀山",
    airports: [
      {
        code: "KZN",
        name: "Kazan intl.",
        chineseName: "喀山国际机场",
        traditionalName: "喀山國際機場",
      },
    ],
  },
  KZO: {
    code: "KZO",
    name: "KYZYLORDA",
    chineseName: "克孜勒奥尔达",
    traditionalName: "克孜勒奧爾達",
    airports: [
      {
        code: "KZO",
        name: "Kyzylorda airport",
        chineseName: "克孜勒奥尔达机场",
        traditionalName: "克孜勒奧爾達機場",
      },
    ],
  },
  KZR: {
    code: "KZR",
    name: "KUTAHYA",
    chineseName: "屈塔希亚",
    traditionalName: "屈塔希亞",
    airports: [
      {
        code: "KZR",
        name: "Zafer",
        chineseName: "屈塔希亚机场",
        traditionalName: "屈塔希亞機場",
      },
    ],
  },
  KZS: {
    code: "KZS",
    name: "MEGISTI",
    chineseName: "卡斯特洛里佐",
    traditionalName: "卡斯特洛裏佐",
    airports: [
      {
        code: "KZS",
        name: "Megisti airport",
        chineseName: "卡斯特洛里佐机场",
        traditionalName: "卡斯特洛裏佐機場",
      },
    ],
  },
  LAD: {
    code: "LAD",
    name: "LUANDA",
    chineseName: "罗安达",
    traditionalName: "魯安達",
    airports: [
      {
        code: "LAD",
        name: "4 de fevereiro",
        chineseName: "夸德罗安达国际机场",
        traditionalName: "誇德羅安達國際機場",
      },
      {
        code: "NBJ",
        name: "Dr antonio agostinho neto",
        chineseName: "安东尼奥·阿戈斯蒂尼奥·内托博士国际机场",
        traditionalName: "安東尼奧·阿戈斯蒂尼奧·內托博士國際機場",
      },
    ],
  },
  LAE: {
    code: "LAE",
    name: "LAE",
    chineseName: "莱城",
    traditionalName: "萊城",
    airports: [
      {
        code: "LAE",
        name: "Nadzab",
        chineseName: "纳德扎博机场",
        traditionalName: "納德紮博機場",
      },
    ],
  },
  LAF: {
    code: "LAF",
    name: "LAFAYETTE",
    chineseName: "拉法耶特",
    traditionalName: "拉法耶特",
    airports: [
      {
        code: "LAF",
        name: "Purdue university",
        chineseName: "普尔杜埃大学机场",
        traditionalName: "普爾杜埃大學機場",
      },
    ],
  },
  LAH: {
    code: "LAH",
    name: "LABUHA",
    chineseName: "拉布哈",
    traditionalName: "拉布哈",
    airports: [
      {
        code: "LAH",
        name: "Oesman sadik",
        chineseName: "拉布哈机场",
        traditionalName: "拉布哈機場",
      },
    ],
  },
  LAK: {
    code: "LAK",
    name: "AKLAVIK",
    chineseName: "阿克拉维克",
    traditionalName: "阿克拉維克",
    airports: [
      {
        code: "LAK",
        name: "Freddie carmichael",
        chineseName: "阿克拉维克机场",
        traditionalName: "阿克拉維克機場",
      },
    ],
  },
  LAL: {
    code: "LAL",
    name: "LAKELAND",
    chineseName: "莱克兰",
    traditionalName: "萊克蘭",
    airports: [
      {
        code: "LAL",
        name: "Linder regional",
        chineseName: "莱克兰林德国际机场",
        traditionalName: "萊克蘭林德國際機場",
      },
    ],
  },
  LAN: {
    code: "LAN",
    name: "LANSING",
    chineseName: "兰辛",
    traditionalName: "蘭辛",
    airports: [
      {
        code: "LAN",
        name: "Capital region intl",
        chineseName: "首都地区国际机场",
        traditionalName: "首都地區國際機場",
      },
    ],
  },
  LAO: {
    code: "LAO",
    name: "LAOAG",
    chineseName: "拉瓦格",
    traditionalName: "拉瓦格",
    airports: [
      {
        code: "LAO",
        name: "Laoag intl.",
        chineseName: "拉瓦格机场",
        traditionalName: "拉瓦格機場",
      },
    ],
  },
  LAP: {
    code: "LAP",
    name: "LA PAZ",
    chineseName: "拉巴斯",
    traditionalName: "拉巴斯",
    airports: [
      {
        code: "LAP",
        name: "Manuel marquez de leon",
        chineseName: "莱昂机场",
        traditionalName: "萊昂機場",
      },
    ],
  },
  LAQ: {
    code: "LAQ",
    name: "BEIDA",
    chineseName: "拜达",
    traditionalName: "拜達",
    airports: [
      {
        code: "LAQ",
        name: "Labraq",
        chineseName: "拉布拉克机场",
        traditionalName: "拉布拉克機場",
      },
    ],
  },
  LAR: {
    code: "LAR",
    name: "LARAMIE",
    chineseName: "拉勒米",
    traditionalName: "拉勒米",
    airports: [
      {
        code: "LAR",
        name: "Laramie reg. airport",
        chineseName: "拉勒米地区机场",
        traditionalName: "拉勒米地區機場",
      },
    ],
  },
  LAS: {
    code: "LAS",
    name: "LAS VEGAS",
    chineseName: "拉斯维加斯",
    traditionalName: "拉斯維加斯",
    airports: [
      {
        code: "BLD",
        name: "Boulder city municipal",
        chineseName: "博尔德城机场",
        traditionalName: "博爾德城機場",
      },
      {
        code: "HSH",
        name: "Henderson executive",
        chineseName: "拉斯韦加斯机场",
        traditionalName: "拉斯韋加斯機場",
      },
      {
        code: "LAS",
        name: "Harry reid intl",
        chineseName: "哈里瑞德机场",
        traditionalName: "哈裏瑞德機場",
      },
    ],
  },
  LAU: {
    code: "LAU",
    name: "LAMU",
    chineseName: "拉穆",
    traditionalName: "拉穆",
    airports: [
      {
        code: "LAU",
        name: "Manda",
        chineseName: "拉穆机场",
        traditionalName: "拉穆機場",
      },
    ],
  },
  LAW: {
    code: "LAW",
    name: "LAWTON/FORT SILL",
    chineseName: "劳顿",
    traditionalName: "勞頓",
    airports: [
      {
        code: "LAW",
        name: "Lawton/fort sill reg. airport",
        chineseName: "劳顿地方机场",
        traditionalName: "勞頓地方機場",
      },
    ],
  },
  LAX: {
    code: "LAX",
    name: "LOS ANGELES",
    chineseName: "洛杉矶",
    traditionalName: "洛杉磯",
    airports: [
      {
        code: "LAX",
        name: "Los angeles intl.",
        chineseName: "洛杉矶国际机场",
        traditionalName: "洛杉磯國際機場",
      },
      {
        code: "ONT",
        name: "Ontario international",
        chineseName: "安大略国际机场",
        traditionalName: "安大略國際機場",
      },
      {
        code: "VNY",
        name: "Van nuys",
        chineseName: "凡努伊斯机场",
        traditionalName: "凡努伊斯機場",
      },
    ],
  },
  LBA: {
    code: "LBA",
    name: "LEEDS/BRADFORD",
    chineseName: "利兹",
    traditionalName: "里茲",
    airports: [
      {
        code: "LBA",
        name: "Leeds/bradford airport",
        chineseName: "利兹机场",
        traditionalName: "里茲機場",
      },
    ],
  },
  LBB: {
    code: "LBB",
    name: "LUBBOCK",
    chineseName: "拉伯克",
    traditionalName: "拉伯克",
    airports: [
      {
        code: "LBB",
        name: "Preston smith intl",
        chineseName: "普雷斯顿史密斯国际机场",
        traditionalName: "普雷斯顿史密斯國際機場",
      },
    ],
  },
  LBC: {
    code: "LBC",
    name: "LUEBECK",
    chineseName: "吕贝克",
    traditionalName: "盧貝克",
    airports: [
      {
        code: "LBC",
        name: "Luebeck airport",
        chineseName: "布兰肯塞机场",
        traditionalName: "布蘭肯塞機場",
      },
    ],
  },
  LBD: {
    code: "LBD",
    name: "KHUJAND",
    chineseName: "胡占德",
    traditionalName: "胡占德",
    airports: [
      {
        code: "LBD",
        name: "Khujand intl.",
        chineseName: "苦盏机场",
        traditionalName: "苦盞機場",
      },
    ],
  },
  LBE: {
    code: "LBE",
    name: "LATROBE",
    chineseName: "拉特罗布",
    traditionalName: "拉特羅布",
    airports: [
      {
        code: "LBE",
        name: "Arnold palmer regional",
        chineseName: "阿诺德帕尔默区域机场",
        traditionalName: "阿諾德帕爾默區域機場",
      },
    ],
  },
  LBF: {
    code: "LBF",
    name: "NORTH PLATTE",
    chineseName: "北普拉特",
    traditionalName: "北普拉特",
    airports: [
      {
        code: "LBF",
        name: "Regional(lee bird fld)",
        chineseName: "里伯德机场",
        traditionalName: "裏伯德機場",
      },
    ],
  },
  LBJ: {
    code: "LBJ",
    name: "LABUAN BAJO",
    chineseName: "拉布汉巴焦",
    traditionalName: "拉布漢巴焦",
    airports: [
      {
        code: "LBJ",
        name: "Komodo",
        chineseName: "科莫多机场",
        traditionalName: "科莫多機場",
      },
    ],
  },
  LBL: {
    code: "LBL",
    name: "LIBERAL",
    chineseName: "利伯勒尔",
    traditionalName: "利伯勒爾",
    airports: [
      {
        code: "LBL",
        name: "Mid-america regional",
        chineseName: "利伯勒尔地方机场",
        traditionalName: "利伯勒爾地方機場",
      },
    ],
  },
  LBP: {
    code: "LBP",
    name: "LONG BANGA",
    chineseName: "隆邦加",
    traditionalName: "隆邦加",
    airports: [
      {
        code: "LBP",
        name: "Long banga airport",
        chineseName: "隆邦加机场",
        traditionalName: "隆邦加機場",
      },
    ],
  },
  LBR: {
    code: "LBR",
    name: "LABREA",
    chineseName: "拉布里亚",
    traditionalName: "拉布裡亞",
    airports: [
      {
        code: "LBR",
        name: "Labrea airport",
        chineseName: "拉布里亚机场",
        traditionalName: "拉布裡亞機場",
      },
    ],
  },
  LBS: {
    code: "LBS",
    name: "LABASA",
    chineseName: "兰巴萨",
    traditionalName: "蘭巴薩",
    airports: [
      {
        code: "LBS",
        name: "Labasa airport",
        chineseName: "兰巴萨机场",
        traditionalName: "蘭巴薩機場",
      },
    ],
  },
  LBU: {
    code: "LBU",
    name: "LABUAN",
    chineseName: "拉布安",
    traditionalName: "拉布安",
    airports: [
      {
        code: "LBU",
        name: "Labuan airport",
        chineseName: "拉布安岛机场",
        traditionalName: "拉布安島機場",
      },
    ],
  },
  LBV: {
    code: "LBV",
    name: "LIBREVILLE",
    chineseName: "利伯维尔",
    traditionalName: "自由市",
    airports: [
      {
        code: "LBV",
        name: "Leon m'ba intl",
        chineseName: "利伯维尔机场",
        traditionalName: "自由市機場",
      },
    ],
  },
  LCA: {
    code: "LCA",
    name: "LARNACA",
    chineseName: "拉纳卡",
    traditionalName: "拉納卡",
    airports: [
      {
        code: "LCA",
        name: "Larnaca airport",
        chineseName: "拉纳卡机场",
        traditionalName: "拉納卡機場",
      },
    ],
  },
  LCE: {
    code: "LCE",
    name: "LA CEIBA",
    chineseName: "拉塞瓦",
    traditionalName: "拉塞瓦",
    airports: [
      {
        code: "LCE",
        name: "Goloson international",
        chineseName: "格罗森国际机场",
        traditionalName: "格羅森國際機場",
      },
    ],
  },
  LCG: {
    code: "LCG",
    name: "A CORUNA",
    chineseName: "拉科鲁尼亚",
    traditionalName: "拉科魯尼亞",
    airports: [
      {
        code: "LCG",
        name: "A coruna airport",
        chineseName: "拉科鲁利亚机场",
        traditionalName: "拉科魯利亞機場",
      },
    ],
  },
  LCH: {
    code: "LCH",
    name: "LAKE CHARLES",
    chineseName: "莱克查尔斯",
    traditionalName: "萊克查爾斯",
    airports: [
      {
        code: "LCH",
        name: "Lake charles reg. airport",
        chineseName: "莱克查尔斯地方机场",
        traditionalName: "萊克查理斯地方機場",
      },
    ],
  },
  LCJ: {
    code: "LCJ",
    name: "LODZ",
    chineseName: "罗兹",
    traditionalName: "羅茲",
    airports: [
      {
        code: "LCJ",
        name: "Wladyslaw reymont",
        chineseName: "弗拉迪斯拉夫莱蒙特机场",
        traditionalName: "弗拉迪斯拉夫萊蒙特機場",
      },
    ],
  },
  LCR: {
    code: "LCR",
    name: "LA CHORRERA",
    chineseName: "拉乔雷拉",
    traditionalName: "拉喬雷拉",
    airports: [
      {
        code: "LCR",
        name: "La chorrera airport",
        chineseName: "拉乔雷拉机场",
        traditionalName: "拉喬雷拉機場",
      },
    ],
  },
  LCX: {
    code: "LCX",
    name: "LONGYAN",
    chineseName: "龙岩",
    traditionalName: "龍岩",
    airports: [
      {
        code: "LCX",
        name: "Guanzhishan",
        chineseName: "冠豸山机场",
        traditionalName: "冠豸山機場",
      },
    ],
  },
  LDB: {
    code: "LDB",
    name: "LONDRINA",
    chineseName: "隆德里纳",
    traditionalName: "隆德里納",
    airports: [
      {
        code: "LDB",
        name: "Jose richa",
        chineseName: "隆德里纳机场",
        traditionalName: "隆德里納機場",
      },
    ],
  },
  LDE: {
    code: "LDE",
    name: "LOURDES/TARBES",
    chineseName: "洛尔德斯",
    traditionalName: "洛爾德斯",
    airports: [
      {
        code: "LDE",
        name: "Pyrenees",
        chineseName: "塔尔贝斯奥松-卢尔德机场",
        traditionalName: "塔爾貝斯奧松-盧爾德機場",
      },
    ],
  },
  LDH: {
    code: "LDH",
    name: "LORD HOWE ISLAND",
    chineseName: "豪勋爵岛",
    traditionalName: "豪勳爵島",
    airports: [
      {
        code: "LDH",
        name: "Lord howe island airport",
        chineseName: "豪勋爵岛机场",
        traditionalName: "豪勳爵島機場",
      },
    ],
  },
  LDS: {
    code: "LDS",
    name: "YICHUN (HEILONGJIANG)",
    chineseName: "伊春",
    traditionalName: "伊春",
    airports: [
      {
        code: "LDS",
        name: "Lindu",
        chineseName: "林都机场",
        traditionalName: "林都機場",
      },
    ],
  },
  LDU: {
    code: "LDU",
    name: "LAHAD DATU",
    chineseName: "拿笃",
    traditionalName: "拿篤",
    airports: [
      {
        code: "LDU",
        name: "Lahad datu airport",
        chineseName: "拉哈达图机场",
        traditionalName: "拉哈達圖機場",
      },
    ],
  },
  LDY: {
    code: "LDY",
    name: "DERRY",
    chineseName: "德里",
    traditionalName: "德里",
    airports: [
      {
        code: "LDY",
        name: "Eglinton",
        chineseName: "埃格林登机场",
        traditionalName: "埃格林登機場",
      },
    ],
  },
  LDZ: {
    code: "LDZ",
    name: "LONDOLOZI",
    chineseName: "伦德尔洛兹",
    traditionalName: "倫德爾洛茲",
    airports: [
      {
        code: "LDZ",
        name: "Londolozi airport",
        chineseName: "伦德尔洛兹机场",
        traditionalName: "倫德爾洛茲機場",
      },
    ],
  },
  LEA: {
    code: "LEA",
    name: "LEARMONTH",
    chineseName: "里尔芒斯",
    traditionalName: "裏爾芒斯",
    airports: [
      {
        code: "LEA",
        name: "Learmonth airport",
        chineseName: "里尔芒斯机场",
        traditionalName: "里爾芒斯機場",
      },
    ],
  },
  LEB: {
    code: "LEB",
    name: "LEBANON",
    chineseName: "黎巴嫩",
    traditionalName: "黎巴嫩",
    airports: [
      {
        code: "LEB",
        name: "Lebanon municipal",
        chineseName: "黎巴嫩地区机场",
        traditionalName: "黎巴嫩地區機場",
      },
    ],
  },
  LEC: {
    code: "LEC",
    name: "LENCOIS",
    chineseName: "伦索伊斯",
    traditionalName: "倫索伊斯",
    airports: [
      {
        code: "LEC",
        name: "Horacio de mattos",
        chineseName: "科罗内尔奥拉西奥马托斯机场",
        traditionalName: "科羅內爾奧拉西奧馬托斯機場",
      },
    ],
  },
  LED: {
    code: "LED",
    name: "ST PETERSBURG",
    chineseName: "圣彼得堡",
    traditionalName: "聖彼德堡",
    airports: [
      {
        code: "LED",
        name: "Pulkovo",
        chineseName: "普尔科夫机场",
        traditionalName: "普爾科夫機場",
      },
    ],
  },
  LEI: {
    code: "LEI",
    name: "ALMERIA",
    chineseName: "阿尔梅里亚",
    traditionalName: "阿爾梅裡亞",
    airports: [
      {
        code: "LEI",
        name: "Almeria airport",
        chineseName: "阿尔梅里亚机场",
        traditionalName: "阿爾梅裡亞機場",
      },
    ],
  },
  LEL: {
    code: "LEL",
    name: "GAPUWIYAK",
    chineseName: "莱克埃委拉",
    traditionalName: "萊克埃委拉",
    airports: [
      {
        code: "LEL",
        name: "Lake evella",
        chineseName: "莱克埃委拉机场",
        traditionalName: "萊克埃委拉機場",
      },
    ],
  },
  LEN: {
    code: "LEN",
    name: "LEON",
    chineseName: "莱昂",
    traditionalName: "萊昂",
    airports: [
      {
        code: "LEN",
        name: "Leon airport",
        chineseName: "莱昂机场",
        traditionalName: "萊昂機場",
      },
    ],
  },
  LEQ: {
    code: "LEQ",
    name: "LAND'S END",
    chineseName: "Lands End城",
    traditionalName: "Lands End城",
    airports: [
      {
        code: "LEQ",
        name: "St just",
        chineseName: "莱比锡/哈雷机场",
        traditionalName: "萊比錫/哈雷機場",
      },
    ],
  },
  LER: {
    code: "LER",
    name: "LEINSTER",
    chineseName: "伦斯特",
    traditionalName: "倫斯特",
    airports: [
      {
        code: "LER",
        name: "Leinster airport",
        chineseName: "伦斯特机场",
        traditionalName: "倫斯特機場",
      },
    ],
  },
  LET: {
    code: "LET",
    name: "LETICIA",
    chineseName: "莱蒂西亚",
    traditionalName: "萊蒂西亞",
    airports: [
      {
        code: "LET",
        name: "Alfredo v. cobb intl",
        chineseName: "莱蒂西亚机场",
        traditionalName: "萊蒂西亞機場",
      },
    ],
  },
  LEU: {
    code: "LEU",
    name: "SEO DE URGEL",
    chineseName: "塞奥德乌赫尔",
    traditionalName: "塞奧德烏赫爾",
    airports: [
      {
        code: "LEU",
        name: "Seo de urgel airport",
        chineseName: "安道尔–拉苏德格机场",
        traditionalName: "安道爾–拉蘇德格機場",
      },
    ],
  },
  LEV: {
    code: "LEV",
    name: "LEVUKA",
    chineseName: "莱武卡",
    traditionalName: "萊武卡",
    airports: [
      {
        code: "LEV",
        name: "Bureta",
        chineseName: "莱武卡机场",
        traditionalName: "萊武卡機場",
      },
    ],
  },
  LEX: {
    code: "LEX",
    name: "LEXINGTON",
    chineseName: "列克星敦",
    traditionalName: "列剋星敦",
    airports: [
      {
        code: "LEX",
        name: "Blue grass",
        chineseName: "莱克星顿机场",
        traditionalName: "萊剋星頓機場",
      },
    ],
  },
  LFQ: {
    code: "LFQ",
    name: "LINFEN",
    chineseName: "临汾",
    traditionalName: "臨汾",
    airports: [
      {
        code: "LFQ",
        name: "Qiaoli",
        chineseName: "尧都机场",
        traditionalName: "堯都機場",
      },
    ],
  },
  LFR: {
    code: "LFR",
    name: "LA FRIA",
    chineseName: "拉弗里亚",
    traditionalName: "拉弗裏亞",
    airports: [
      {
        code: "LFR",
        name: "La fria airport",
        chineseName: "拉弗里亚机场",
        traditionalName: "拉弗裡亞機場",
      },
    ],
  },
  LFT: {
    code: "LFT",
    name: "LAFAYETTE",
    chineseName: "拉法耶特",
    traditionalName: "拉法耶特",
    airports: [
      {
        code: "LFT",
        name: "Lafayette reg. airport",
        chineseName: "拉菲特地区机场",
        traditionalName: "拉菲特地區機場",
      },
    ],
  },
  LFW: {
    code: "LFW",
    name: "LOME",
    chineseName: "洛美",
    traditionalName: "洛美",
    airports: [
      {
        code: "LFW",
        name: "G. eyadema intl",
        chineseName: "洛美机场",
        traditionalName: "洛美機場",
      },
    ],
  },
  LGB: {
    code: "LGB",
    name: "LONG BEACH",
    chineseName: "长滩",
    traditionalName: "長灘",
    airports: [
      {
        code: "LGB",
        name: "Daugherty field",
        chineseName: "长滩地方机场",
        traditionalName: "長灘地方機場",
      },
    ],
  },
  LGG: {
    code: "LGG",
    name: "LIEGE",
    chineseName: "列日",
    traditionalName: "列日",
    airports: [
      {
        code: "LGG",
        name: "Liege airport",
        chineseName: "列日机场",
        traditionalName: "列日機場",
      },
    ],
  },
  LGI: {
    code: "LGI",
    name: "DEADMANS CAY",
    chineseName: "戴得曼斯凯",
    traditionalName: "戴得曼斯凱",
    airports: [
      {
        code: "LGI",
        name: "Deadmans cay airport",
        chineseName: "戴德曼斯凯机场",
        traditionalName: "戴德曼斯凱機場",
      },
    ],
  },
  LGK: {
    code: "LGK",
    name: "LANGKAWI",
    chineseName: "兰卡威",
    traditionalName: "浮羅交怡",
    airports: [
      {
        code: "LGK",
        name: "Langkawi intl.",
        chineseName: "兰卡威国际机场",
        traditionalName: "浮羅交怡國際機場",
      },
    ],
  },
  LGL: {
    code: "LGL",
    name: "LONG LELLANG",
    chineseName: "隆勒朗",
    traditionalName: "隆勒朗",
    airports: [
      {
        code: "LGL",
        name: "Long lellang airport",
        chineseName: "隆勒朗机场",
        traditionalName: "隆勒朗機場",
      },
    ],
  },
  LGP: {
    code: "LGP",
    name: "LEGAZPI",
    chineseName: "黎牙实比",
    traditionalName: "黎牙實比",
    airports: [
      {
        code: "LGP",
        name: "Legazpi airport",
        chineseName: "黎牙实比机场",
        traditionalName: "黎牙實比機場",
      },
    ],
  },
  LGZ: {
    code: "LGZ",
    name: "SHANNAN",
    chineseName: "山南",
    traditionalName: "山南",
    airports: [
      {
        code: "LGZ",
        name: "Shannan longzi",
        chineseName: "隆子机场",
        traditionalName: "隆子機場",
      },
    ],
  },
  LHE: {
    code: "LHE",
    name: "LAHORE",
    chineseName: "拉合尔",
    traditionalName: "拉合爾",
    airports: [
      {
        code: "LHE",
        name: "Allama iqbal intl",
        chineseName: "阿拉马伊克巴勒国际机场",
        traditionalName: "阿拉馬伊克巴勒國際機場",
      },
    ],
  },
  LHG: {
    code: "LHG",
    name: "LIGHTNING RIDGE",
    chineseName: "闪电岭",
    traditionalName: "閃電嶺",
    airports: [
      {
        code: "LHG",
        name: "Lightning ridge airport",
        chineseName: "莱特宁岭机场",
        traditionalName: "萊特寧嶺機場",
      },
    ],
  },
  LHN: {
    code: "LHN",
    name: "LINHARES",
    chineseName: "骊山",
    traditionalName: "驪山",
    airports: [
      {
        code: "LHN",
        name: "Linhares municipal airport",
        chineseName: "立山机场",
        traditionalName: "立山機場",
      },
    ],
  },
  LHW: {
    code: "LHW",
    name: "LANZHOU",
    chineseName: "兰州",
    traditionalName: "蘭州",
    airports: [
      {
        code: "LHW",
        name: "Zhongchuan",
        chineseName: "中川机场",
        traditionalName: "中川機場",
      },
    ],
  },
  LIF: {
    code: "LIF",
    name: "LIFOU",
    chineseName: "利富",
    traditionalName: "利富",
    airports: [
      {
        code: "LIF",
        name: "Ouanaham",
        chineseName: "利富机场",
        traditionalName: "利富機場",
      },
    ],
  },
  LIG: {
    code: "LIG",
    name: "LIMOGES",
    chineseName: "利摩日",
    traditionalName: "利摩日",
    airports: [
      {
        code: "LIG",
        name: "Bellegarde",
        chineseName: "贝勒加德机场",
        traditionalName: "貝勒加德機場",
      },
    ],
  },
  LIH: {
    code: "LIH",
    name: "LIHUE",
    chineseName: "考爱岛",
    traditionalName: "考愛島",
    airports: [
      {
        code: "LIH",
        name: "Lihue airport",
        chineseName: "利胡埃机场",
        traditionalName: "利胡埃機場",
      },
    ],
  },
  LIK: {
    code: "LIK",
    name: "LIKIEP ISLAND",
    chineseName: "利吉耶普",
    traditionalName: "利吉耶普",
    airports: [
      {
        code: "LIK",
        name: "Likiep island airport",
        chineseName: "利吉耶普机场",
        traditionalName: "利吉耶普機場",
      },
    ],
  },
  LIL: {
    code: "LIL",
    name: "LILLE",
    chineseName: "里尔",
    traditionalName: "里爾",
    airports: [
      {
        code: "LIL",
        name: "Lesquin",
        chineseName: "莱斯奎恩机场",
        traditionalName: "萊斯奎恩機場",
      },
    ],
  },
  LIM: {
    code: "LIM",
    name: "LIMA",
    chineseName: "利马",
    traditionalName: "利馬",
    airports: [
      {
        code: "LIM",
        name: "Jorge chavez intl",
        chineseName: "豪尔赫查韦斯国际机场",
        traditionalName: "豪爾赫查韋斯國際機場",
      },
    ],
  },
  LIO: {
    code: "LIO",
    name: "LIMON",
    chineseName: "利蒙",
    traditionalName: "利蒙",
    airports: [
      {
        code: "LIO",
        name: "Limon intl.",
        chineseName: "利蒙国际机场",
        traditionalName: "利蒙國際機場",
      },
    ],
  },
  LIQ: {
    code: "LIQ",
    name: "LISALA",
    chineseName: "利萨拉",
    traditionalName: "利薩拉",
    airports: [
      {
        code: "LIQ",
        name: "Lisala airport",
        chineseName: "利萨拉机场",
        traditionalName: "利薩拉機場",
      },
    ],
  },
  LIR: {
    code: "LIR",
    name: "GUANACASTE",
    chineseName: "利比里亚",
    traditionalName: "賴比瑞亞",
    airports: [
      {
        code: "LIR",
        name: "Guanacaste airport",
        chineseName: "利比里亚机场",
        traditionalName: "賴比瑞亞機場",
      },
    ],
  },
  LIS: {
    code: "LIS",
    name: "LISBON",
    chineseName: "里斯本",
    traditionalName: "里斯本",
    airports: [
      {
        code: "LIS",
        name: "Lisbon airport",
        chineseName: "里斯本机场",
        traditionalName: "里斯本機場",
      },
    ],
  },
  LIT: {
    code: "LIT",
    name: "LITTLE ROCK",
    chineseName: "小石城",
    traditionalName: "小石城",
    airports: [
      {
        code: "LIT",
        name: "B. \u0026 h. clinton natl",
        chineseName: "克林顿国家机场",
        traditionalName: "柯林頓國家機場",
      },
    ],
  },
  LJA: {
    code: "LJA",
    name: "LODJA",
    chineseName: "洛贾",
    traditionalName: "洛賈",
    airports: [
      {
        code: "LJA",
        name: "Lodja airport",
        chineseName: "洛贾机场",
        traditionalName: "洛賈機場",
      },
    ],
  },
  LJG: {
    code: "LJG",
    name: "LIJIANG",
    chineseName: "丽江",
    traditionalName: "麗江",
    airports: [
      {
        code: "LJG",
        name: "Sanyi",
        chineseName: "三义机场",
        traditionalName: "三義機場",
      },
    ],
  },
  LJU: {
    code: "LJU",
    name: "LJUBLJANA",
    chineseName: "卢布尔雅那",
    traditionalName: "盧布亞納",
    airports: [
      {
        code: "LJU",
        name: "Joze pucnik",
        chineseName: "卢布尔雅那机场",
        traditionalName: "盧布亞納機場",
      },
    ],
  },
  LKA: {
    code: "LKA",
    name: "LARANTUKA",
    chineseName: "拉兰图卡",
    traditionalName: "拉蘭圖卡",
    airports: [
      {
        code: "LKA",
        name: "Gewayantana",
        chineseName: "拉兰图卡机场",
        traditionalName: "拉蘭圖卡機場",
      },
    ],
  },
  LKB: {
    code: "LKB",
    name: "LAKEBA ISLAND",
    chineseName: "拉肯巴",
    traditionalName: "拉肯巴",
    airports: [
      {
        code: "LKB",
        name: "Lakeba island airport",
        chineseName: "拉巴肯机场",
        traditionalName: "拉巴肯機場",
      },
    ],
  },
  LKH: {
    code: "LKH",
    name: "LONG AKAH",
    chineseName: "隆亚甲",
    traditionalName: "隆亞甲",
    airports: [
      {
        code: "LKH",
        name: "Long akah airport",
        chineseName: "隆亚甲机场",
        traditionalName: "隆亞甲機場",
      },
    ],
  },
  LKI: {
    code: "LKI",
    name: "SINABANG",
    chineseName: "明尼苏达州德卢斯",
    traditionalName: "明尼蘇達州德盧斯",
    airports: [
      {
        code: "LKI",
        name: "Lasikin",
        chineseName: "拉西金机场",
        traditionalName: "拉西金機場",
      },
    ],
  },
  LKL: {
    code: "LKL",
    name: "LAKSELV",
    chineseName: "拉克塞尔夫",
    traditionalName: "拉克塞爾夫",
    airports: [
      {
        code: "LKL",
        name: "Banak",
        chineseName: "巴纳克机场",
        traditionalName: "巴納克機場",
      },
    ],
  },
  LKN: {
    code: "LKN",
    name: "LEKNES",
    chineseName: "莱克讷斯",
    traditionalName: "萊克訥斯",
    airports: [
      {
        code: "LKN",
        name: "Leknes airport",
        chineseName: "莱克讷斯机场",
        traditionalName: "萊克訥斯機場",
      },
    ],
  },
  LKO: {
    code: "LKO",
    name: "LUCKNOW",
    chineseName: "勒克瑙",
    traditionalName: "勒克瑙",
    airports: [
      {
        code: "LKO",
        name: "Chaudhary charan singh",
        chineseName: "乔杜里查兰辛格国际机场",
        traditionalName: "喬杜裏查蘭辛格國際機場",
      },
    ],
  },
  LKY: {
    code: "LKY",
    name: "LAKE MANYARA",
    chineseName: "马尼亚拉湖",
    traditionalName: "馬尼亞拉湖",
    airports: [
      {
        code: "LKY",
        name: "Lake manyara airport",
        chineseName: "莱克曼亚拉机场",
        traditionalName: "萊克曼亞拉機場",
      },
    ],
  },
  LLA: {
    code: "LLA",
    name: "LULEA",
    chineseName: "吕勒奥",
    traditionalName: "呂勒奧",
    airports: [
      {
        code: "LLA",
        name: "Kallax",
        chineseName: "卡拉克斯机场",
        traditionalName: "卡拉克斯機場",
      },
    ],
  },
  LLB: {
    code: "LLB",
    name: "LIBO",
    chineseName: "荔波",
    traditionalName: "荔波",
    airports: [
      {
        code: "LLB",
        name: "Libo airport",
        chineseName: "荔波机场",
        traditionalName: "荔波機場",
      },
    ],
  },
  LLF: {
    code: "LLF",
    name: "YONGZHOU",
    chineseName: "永州",
    traditionalName: "永州",
    airports: [
      {
        code: "LLF",
        name: "Lingling",
        chineseName: "零陵机场",
        traditionalName: "零陵機場",
      },
    ],
  },
  LLI: {
    code: "LLI",
    name: "LALIBELA",
    chineseName: "拉里贝拉",
    traditionalName: "拉裡貝拉",
    airports: [
      {
        code: "LLI",
        name: "Lalibela airport",
        chineseName: "拉利贝拉机场",
        traditionalName: "拉利貝拉機場",
      },
    ],
  },
  LLJ: {
    code: "LLJ",
    name: "LUBUK LINGGAU",
    chineseName: "卢布克灵高",
    traditionalName: "盧布克靈高",
    airports: [
      {
        code: "LLJ",
        name: "Silampari",
        chineseName: "希兰帕里机场",
        traditionalName: "希蘭帕裡機場",
      },
    ],
  },
  LLK: {
    code: "LLK",
    name: "LANKARAN",
    chineseName: "连科兰",
    traditionalName: "連科蘭",
    airports: [
      {
        code: "LLK",
        name: "Lankaran airport",
        chineseName: "连科兰国际机场",
        traditionalName: "連科蘭國際機場",
      },
    ],
  },
  LLM: {
    code: "LLM",
    name: "LOMLOM",
    chineseName: "隆拉马",
    traditionalName: "隆拉馬",
    airports: [
      {
        code: "LLM",
        name: "Lomlom airport",
        chineseName: "隆拉马机场",
        traditionalName: "隆拉馬機場",
      },
    ],
  },
  LLO: {
    code: "LLO",
    name: "PALOPO",
    chineseName: "帕洛波",
    traditionalName: "帕洛波",
    airports: [
      {
        code: "LLO",
        name: "Lagaligo",
        chineseName: "帕洛波机场",
        traditionalName: "帕洛波機場",
      },
    ],
  },
  LLV: {
    code: "LLV",
    name: "LULIANG",
    chineseName: "吕梁",
    traditionalName: "呂梁",
    airports: [
      {
        code: "LLV",
        name: "Luliang airport",
        chineseName: "吕梁机场",
        traditionalName: "呂梁機場",
      },
    ],
  },
  LLW: {
    code: "LLW",
    name: "LILONGWE",
    chineseName: "利隆圭",
    traditionalName: "里郎威",
    airports: [
      {
        code: "LLW",
        name: "Kamuzu intl",
        chineseName: "利隆圭国际机场",
        traditionalName: "里郎威國際機場",
      },
    ],
  },
  LMA: {
    code: "LMA",
    name: "LAKE MINCHUMINA",
    chineseName: "阿拉斯加州城市明楚米纳",
    traditionalName: "阿拉斯加州都市明楚米納",
    airports: [
      {
        code: "LMA",
        name: "Lake minchumina airport",
        chineseName: "莱克明丘米纳机场",
        traditionalName: "萊克明丘米納機場",
      },
    ],
  },
  LMC: {
    code: "LMC",
    name: "LA MACARENA",
    chineseName: "拉马卡雷纳",
    traditionalName: "拉馬卡雷納",
    airports: [
      {
        code: "LMC",
        name: "La macarena airport",
        chineseName: "拉马卡雷纳机场",
        traditionalName: "拉馬卡雷納機場",
      },
    ],
  },
  LMM: {
    code: "LMM",
    name: "LOS MOCHIS",
    chineseName: "洛斯莫奇斯",
    traditionalName: "洛斯莫奇斯",
    airports: [
      {
        code: "LMM",
        name: "Fed. valle del fuerte",
        chineseName: "费德拉尔机场",
        traditionalName: "費德拉爾機場",
      },
    ],
  },
  LMN: {
    code: "LMN",
    name: "LIMBANG",
    chineseName: "林梦",
    traditionalName: "林夢",
    airports: [
      {
        code: "LMN",
        name: "Limbang airport",
        chineseName: "林梦机场",
        traditionalName: "林夢機場",
      },
    ],
  },
  LMP: {
    code: "LMP",
    name: "LAMPEDUSA",
    chineseName: "兰佩杜萨",
    traditionalName: "蘭佩杜薩",
    airports: [
      {
        code: "LMP",
        name: "Lampedusa airport",
        chineseName: "兰佩杜萨机场",
        traditionalName: "蘭佩杜薩機場",
      },
    ],
  },
  LMU: {
    code: "LMU",
    name: "JEMAJA ISLAND",
    chineseName: "杰马贾岛",
    traditionalName: "傑馬賈島",
    airports: [
      {
        code: "LMU",
        name: "Letung",
        chineseName: "乐通机场",
        traditionalName: "樂通機場",
      },
    ],
  },
  LMV: {
    code: "LMV",
    name: "MADIVARU",
    chineseName: "马迪瓦鲁",
    traditionalName: "馬迪瓦魯",
    airports: [
      {
        code: "LMV",
        name: "Madivaru airport",
        chineseName: "MADIVARU机场",
        traditionalName: "Madivaru機場",
      },
    ],
  },
  LNB: {
    code: "LNB",
    name: "LAMEN BAY",
    chineseName: "拉门贝",
    traditionalName: "拉門貝",
    airports: [
      {
        code: "LNB",
        name: "Lamen bay airport",
        chineseName: "拉门贝机场",
        traditionalName: "拉門貝機場",
      },
    ],
  },
  LNE: {
    code: "LNE",
    name: "LONORORE",
    chineseName: "朗挪罗依",
    traditionalName: "朗挪羅依",
    airports: [
      {
        code: "LNE",
        name: "Lonorore airport",
        chineseName: "朗挪罗依机场",
        traditionalName: "朗挪羅依機場",
      },
    ],
  },
  LNJ: {
    code: "LNJ",
    name: "LINCANG",
    chineseName: "临沧",
    traditionalName: "臨滄",
    airports: [
      {
        code: "LNJ",
        name: "Lincang airport",
        chineseName: "临沧机场",
        traditionalName: "臨滄機場",
      },
    ],
  },
  LNK: {
    code: "LNK",
    name: "LINCOLN",
    chineseName: "林肯",
    traditionalName: "林肯",
    airports: [
      {
        code: "LNK",
        name: "Lincoln airport",
        chineseName: "林肯机场",
        traditionalName: "林肯機場",
      },
    ],
  },
  LNL: {
    code: "LNL",
    name: "LONGNAN",
    chineseName: "陇南",
    traditionalName: "隴南",
    airports: [
      {
        code: "LNL",
        name: "Cheng xian",
        chineseName: "成县机场",
        traditionalName: "成縣機場",
      },
    ],
  },
  LNO: {
    code: "LNO",
    name: "LEONORA",
    chineseName: "利奥诺拉",
    traditionalName: "利奧諾拉",
    airports: [
      {
        code: "LNO",
        name: "Leonora airport",
        chineseName: "利奥诺拉机场",
        traditionalName: "利奧諾拉機場",
      },
    ],
  },
  LNS: {
    code: "LNS",
    name: "LANCASTER",
    chineseName: "兰开斯特",
    traditionalName: "蘭開斯特",
    airports: [
      {
        code: "LNS",
        name: "Lancaster airport",
        chineseName: "兰开斯特机场",
        traditionalName: "蘭開斯特機場",
      },
    ],
  },
  LNU: {
    code: "LNU",
    name: "MALINAU",
    chineseName: "马利瑙",
    traditionalName: "馬利瑙",
    airports: [
      {
        code: "LNU",
        name: "Kolonel ra bessing",
        chineseName: "沃尔纳特里奇机场",
        traditionalName: "沃爾納特裏奇機場",
      },
    ],
  },
  LNV: {
    code: "LNV",
    name: "LIHIR ISLAND",
    chineseName: "利希尔岛",
    traditionalName: "利希爾島",
    airports: [
      {
        code: "LNV",
        name: "Kunaye",
        chineseName: "利希尔岛机场",
        traditionalName: "利希爾島機場",
      },
    ],
  },
  LNY: {
    code: "LNY",
    name: "LANAI CITY",
    chineseName: "拉奈",
    traditionalName: "拉奈",
    airports: [
      {
        code: "LNY",
        name: "Lanai city airport",
        chineseName: "拉奈机场",
        traditionalName: "拉奈機場",
      },
    ],
  },
  LNZ: {
    code: "LNZ",
    name: "LINZ",
    chineseName: "林茨",
    traditionalName: "林茨",
    airports: [
      {
        code: "LNZ",
        name: "Blue danube",
        chineseName: "林茨机场",
        traditionalName: "林茨機場",
      },
    ],
  },
  LOD: {
    code: "LOD",
    name: "LONGANA",
    chineseName: "隆阿纳",
    traditionalName: "隆阿納",
    airports: [
      {
        code: "LOD",
        name: "Longana airport",
        chineseName: "隆阿纳机场",
        traditionalName: "隆阿納機場",
      },
    ],
  },
  LOE: {
    code: "LOE",
    name: "LOEI",
    chineseName: "洛伊",
    traditionalName: "洛伊",
    airports: [
      {
        code: "LOE",
        name: "Loei airport",
        chineseName: "黎机场",
        traditionalName: "黎機場",
      },
    ],
  },
  LOH: {
    code: "LOH",
    name: "LOJA",
    chineseName: "洛哈",
    traditionalName: "洛哈",
    airports: [
      {
        code: "LOH",
        name: "Catamayo",
        chineseName: "洛哈机场",
        traditionalName: "洛哈機場",
      },
    ],
  },
  LOK: {
    code: "LOK",
    name: "LODWAR",
    chineseName: "洛德瓦尔",
    traditionalName: "洛德瓦爾",
    airports: [
      {
        code: "LOK",
        name: "Lodwar airport",
        chineseName: "洛德瓦尔机场",
        traditionalName: "洛德瓦爾機場",
      },
    ],
  },
  LON: {
    code: "LON",
    name: "LONDON",
    chineseName: "伦敦",
    traditionalName: "倫敦",
    airports: [
      {
        code: "LCY",
        name: "City airport",
        chineseName: "伦敦城机场",
        traditionalName: "倫敦城機場",
      },
      {
        code: "LGW",
        name: "Gatwick",
        chineseName: "盖特维克机场",
        traditionalName: "蓋特維克機場",
      },
      {
        code: "LHR",
        name: "Heathrow",
        chineseName: "希思罗机场",
        traditionalName: "希思羅機場",
      },
      {
        code: "LTN",
        name: "Luton",
        chineseName: "卢登机场",
        traditionalName: "盧登機場",
      },
      {
        code: "SEN",
        name: "Southend",
        chineseName: "绍森德机场",
        traditionalName: "紹森德機場",
      },
      {
        code: "STN",
        name: "Stansted",
        chineseName: "斯坦德机场",
        traditionalName: "斯坦德機場",
      },
    ],
  },
  LOO: {
    code: "LOO",
    name: "LAGHOUAT",
    chineseName: "艾格瓦特",
    traditionalName: "艾格瓦特",
    airports: [
      {
        code: "LOO",
        name: "L'mekrareg",
        chineseName: "梅克拉雷格机场",
        traditionalName: "梅克拉雷格機場",
      },
    ],
  },
  LOP: {
    code: "LOP",
    name: "PRAYA",
    chineseName: "龙目岛",
    traditionalName: "龍目島",
    airports: [
      {
        code: "LOP",
        name: "Lombok international",
        chineseName: "龙目岛国际机场",
        traditionalName: "龍目島國際機場",
      },
    ],
  },
  LOS: {
    code: "LOS",
    name: "LAGOS",
    chineseName: "拉各斯",
    traditionalName: "拉各斯",
    airports: [
      {
        code: "LOS",
        name: "Murtala muhammed intl",
        chineseName: "莫尔塔拉穆哈迈德国际机场",
        traditionalName: "莫爾塔拉穆哈邁德國際機場",
      },
    ],
  },
  LOY: {
    code: "LOY",
    name: "LOYENGALANI",
    chineseName: "罗扬加拉尼",
    traditionalName: "羅揚加拉尼",
    airports: [
      {
        code: "LOY",
        name: "Loyengalani airport",
        chineseName: "卢延加拉尼机场",
        traditionalName: "盧延加拉尼機場",
      },
    ],
  },
  LPA: {
    code: "LPA",
    name: "GRAN CANARIA",
    chineseName: "加那利群岛",
    traditionalName: "加那利群島",
    airports: [
      {
        code: "LPA",
        name: "Gran canaria airport",
        chineseName: "大加那利机场",
        traditionalName: "大加那利機場",
      },
    ],
  },
  LPB: {
    code: "LPB",
    name: "LA PAZ",
    chineseName: "拉巴斯",
    traditionalName: "拉巴斯",
    airports: [
      {
        code: "LPB",
        name: "El alto intl",
        chineseName: "阿尔托国际机场",
        traditionalName: "阿爾托國際機場",
      },
    ],
  },
  LPD: {
    code: "LPD",
    name: "LA PEDRERA",
    chineseName: "拉佩德雷拉",
    traditionalName: "拉佩德雷拉",
    airports: [
      {
        code: "LPD",
        name: "La pedrera airport",
        chineseName: "拉佩德雷拉机场",
        traditionalName: "拉佩德雷拉機場",
      },
    ],
  },
  LPF: {
    code: "LPF",
    name: "LIUPANSHUI",
    chineseName: "六盘水",
    traditionalName: "六盤水",
    airports: [
      {
        code: "LPF",
        name: "Yue zhao",
        chineseName: "月照机场",
        traditionalName: "月照機場",
      },
    ],
  },
  LPI: {
    code: "LPI",
    name: "LINKOPING",
    chineseName: "林雪平",
    traditionalName: "林雪平",
    airports: [
      {
        code: "LPI",
        name: "City airport",
        chineseName: "林雪平城市机场",
        traditionalName: "林雪平都市機場",
      },
    ],
  },
  LPL: {
    code: "LPL",
    name: "LIVERPOOL",
    chineseName: "利物浦",
    traditionalName: "利物浦",
    airports: [
      {
        code: "LPL",
        name: "John lennon",
        chineseName: "约翰列农机场",
        traditionalName: "約翰列農機場",
      },
    ],
  },
  LPM: {
    code: "LPM",
    name: "LAMAP",
    chineseName: "拉马普",
    traditionalName: "拉馬普",
    airports: [
      {
        code: "LPM",
        name: "Malekoula",
        chineseName: "拉马普机场",
        traditionalName: "拉馬普機場",
      },
    ],
  },
  LPP: {
    code: "LPP",
    name: "LAPPEENRANTA",
    chineseName: "拉彭兰塔",
    traditionalName: "拉彭蘭塔",
    airports: [
      {
        code: "LPP",
        name: "Lappeenranta airport",
        chineseName: "拉彭兰塔机场",
        traditionalName: "拉彭蘭塔機場",
      },
    ],
  },
  LPQ: {
    code: "LPQ",
    name: "LUANG PRABANG",
    chineseName: "琅勃拉邦",
    traditionalName: "瑯勃拉邦",
    airports: [
      {
        code: "LPQ",
        name: "Luang prabang intl.",
        chineseName: "朗勃拉邦国际机场",
        traditionalName: "朗勃拉邦國際機場",
      },
    ],
  },
  LPS: {
    code: "LPS",
    name: "LOPEZ ISLAND",
    chineseName: "洛佩兹岛",
    traditionalName: "洛佩茲島",
    airports: [
      {
        code: "LPS",
        name: "Lopez island airport",
        chineseName: "洛佩兹岛机场",
        traditionalName: "洛佩茲島機場",
      },
    ],
  },
  LPT: {
    code: "LPT",
    name: "LAMPANG",
    chineseName: "南邦",
    traditionalName: "南邦",
    airports: [
      {
        code: "LPT",
        name: "Lampang airport",
        chineseName: "南邦机场",
        traditionalName: "南邦機場",
      },
    ],
  },
  LPY: {
    code: "LPY",
    name: "LE PUY",
    chineseName: "勒皮",
    traditionalName: "勒皮",
    airports: [
      {
        code: "LPY",
        name: "Loudes",
        chineseName: "罗德斯机场",
        traditionalName: "羅德斯機場",
      },
    ],
  },
  LQM: {
    code: "LQM",
    name: "PUERTO LEGUIZAMO",
    chineseName: "莱吉萨莫港",
    traditionalName: "萊吉薩莫港",
    airports: [
      {
        code: "LQM",
        name: "Caucaya",
        chineseName: "莱吉萨莫港机场",
        traditionalName: "萊吉薩莫港機場",
      },
    ],
  },
  LQP: {
    code: "LQP",
    name: "CHENZHOU",
    chineseName: "郴州",
    traditionalName: "郴州",
    airports: [
      {
        code: "HCZ",
        name: "Beihu",
        chineseName: "郴州北湖机场",
        traditionalName: "郴州北湖機場",
      },
    ],
  },
  LRD: {
    code: "LRD",
    name: "LAREDO",
    chineseName: "拉雷多",
    traditionalName: "拉雷多",
    airports: [
      {
        code: "LRD",
        name: "Laredo intl.",
        chineseName: "拉雷多国际机场",
        traditionalName: "拉雷多國際機場",
      },
    ],
  },
  LRE: {
    code: "LRE",
    name: "LONGREACH",
    chineseName: "朗里奇",
    traditionalName: "朗裏奇",
    airports: [
      {
        code: "LRE",
        name: "Longreach airport",
        chineseName: "朗里奇机场",
        traditionalName: "朗裏奇機場",
      },
    ],
  },
  LRH: {
    code: "LRH",
    name: "LA ROCHELLE",
    chineseName: "拉罗谢尔",
    traditionalName: "拉羅謝爾",
    airports: [
      {
        code: "LRH",
        name: "Ile de re",
        chineseName: "拉罗切利机场",
        traditionalName: "拉羅切利機場",
      },
    ],
  },
  LRM: {
    code: "LRM",
    name: "LA ROMANA",
    chineseName: "拉罗马纳",
    traditionalName: "拉羅馬納",
    airports: [
      {
        code: "LRM",
        name: "Casa de campo intl",
        chineseName: "拉罗马纳机场",
        traditionalName: "拉羅馬納機場",
      },
    ],
  },
  LRR: {
    code: "LRR",
    name: "LAR",
    chineseName: "拉尔",
    traditionalName: "拉爾",
    airports: [
      {
        code: "LRR",
        name: "Lar airport",
        chineseName: "拉尔机场",
        traditionalName: "拉爾機場",
      },
    ],
  },
  LRS: {
    code: "LRS",
    name: "LEROS",
    chineseName: "勒罗斯市",
    traditionalName: "勒羅斯市",
    airports: [
      {
        code: "LRS",
        name: "Leros airport",
        chineseName: "莱罗斯岛机场",
        traditionalName: "萊羅斯島機場",
      },
    ],
  },
  LRT: {
    code: "LRT",
    name: "LORIENT",
    chineseName: "洛里昂",
    traditionalName: "洛里昂",
    airports: [
      {
        code: "LRT",
        name: "Lann bihoue",
        chineseName: "拉恩比霍埃机场",
        traditionalName: "拉恩比霍埃機場",
      },
    ],
  },
  LRU: {
    code: "LRU",
    name: "LAS CRUCES",
    chineseName: "拉斯克鲁塞斯",
    traditionalName: "拉斯克魯塞斯",
    airports: [
      {
        code: "LRU",
        name: "Las cruces intl.",
        chineseName: "拉斯克鲁塞斯机场",
        traditionalName: "拉斯克魯塞斯機場",
      },
    ],
  },
  LRV: {
    code: "LRV",
    name: "LOS ROQUES",
    chineseName: "洛斯罗克斯",
    traditionalName: "洛斯羅克斯",
    airports: [
      {
        code: "LRV",
        name: "Los roques airport",
        chineseName: "洛斯罗克斯机场",
        traditionalName: "洛斯羅克斯機場",
      },
    ],
  },
  LSC: {
    code: "LSC",
    name: "LA SERENA",
    chineseName: "拉塞雷纳",
    traditionalName: "拉塞雷納",
    airports: [
      {
        code: "LSC",
        name: "La florida",
        chineseName: "拉佛罗里达机场",
        traditionalName: "拉佛羅里達機場",
      },
    ],
  },
  LSE: {
    code: "LSE",
    name: "LA CROSSE",
    chineseName: "拉克鲁斯",
    traditionalName: "拉克魯斯",
    airports: [
      {
        code: "LSE",
        name: "La crosse reg. airport",
        chineseName: "拉克鲁斯地方机场",
        traditionalName: "拉克魯斯地方機場",
      },
    ],
  },
  LSH: {
    code: "LSH",
    name: "LASHIO",
    chineseName: "腊戍",
    traditionalName: "臘戍",
    airports: [
      {
        code: "LSH",
        name: "Lashio airport",
        chineseName: "腊戍机场",
        traditionalName: "臘戍機場",
      },
    ],
  },
  LSP: {
    code: "LSP",
    name: "LAS PIEDRAS",
    chineseName: "拉斯彼德拉斯",
    traditionalName: "拉斯彼德拉斯",
    airports: [
      {
        code: "LSP",
        name: "Josefa camejo intl",
        chineseName: "约瑟法－卡梅约机场",
        traditionalName: "約瑟法－卡梅約機場",
      },
    ],
  },
  LSQ: {
    code: "LSQ",
    name: "LOS ANGELES",
    chineseName: "洛桑赫莱斯",
    traditionalName: "洛桑赫萊斯",
    airports: [
      {
        code: "LSQ",
        name: "Maria dolores",
        chineseName: "多罗蕾斯机场",
        traditionalName: "多羅蕾斯機場",
      },
    ],
  },
  LSS: {
    code: "LSS",
    name: "TERRE-DE-HAUT",
    chineseName: "上岛",
    traditionalName: "上島",
    airports: [
      {
        code: "LSS",
        name: "Les saintes",
        chineseName: "上岛机场",
        traditionalName: "上島機場",
      },
    ],
  },
  LST: {
    code: "LST",
    name: "LAUNCESTON",
    chineseName: "朗塞斯顿",
    traditionalName: "朗塞斯頓",
    airports: [
      {
        code: "LST",
        name: "Launceston airport",
        chineseName: "朗塞斯顿机场",
        traditionalName: "朗塞斯頓機場",
      },
    ],
  },
  LSW: {
    code: "LSW",
    name: "LHOK SEUMAWE",
    chineseName: "司马威",
    traditionalName: "司馬威",
    airports: [
      {
        code: "LSW",
        name: "Malikussaleh",
        chineseName: "司马威机场",
        traditionalName: "司馬威機場",
      },
    ],
  },
  LTI: {
    code: "LTI",
    name: "ALTAI",
    chineseName: "阿尔泰",
    traditionalName: "阿勒泰",
    airports: [
      {
        code: "LTI",
        name: "Altai airport",
        chineseName: "阿尔泰机场",
        traditionalName: "阿勒泰機場",
      },
    ],
  },
  LTK: {
    code: "LTK",
    name: "LATAKIA",
    chineseName: "拉塔基亚",
    traditionalName: "拉塔基亞",
    airports: [
      {
        code: "LTK",
        name: "Bassel al assad intl",
        chineseName: "巴塞勒阿萨德国际机场",
        traditionalName: "巴塞勒阿塞德國際機場",
      },
    ],
  },
  LTM: {
    code: "LTM",
    name: "LETHEM",
    chineseName: "莱瑟姆",
    traditionalName: "萊瑟姆",
    airports: [
      {
        code: "LTM",
        name: "Lethem airport",
        chineseName: "莱瑟姆机场",
        traditionalName: "萊瑟姆機場",
      },
    ],
  },
  LTO: {
    code: "LTO",
    name: "LORETO",
    chineseName: "洛雷托",
    traditionalName: "洛雷托",
    airports: [
      {
        code: "LTO",
        name: "Loreto intl.",
        chineseName: "洛雷托机场",
        traditionalName: "洛雷托機場",
      },
    ],
  },
  LTR: {
    code: "LTR",
    name: "LETTERKENNY",
    chineseName: "莱特肯尼",
    traditionalName: "萊特肯尼",
    airports: [
      {
        code: "LTR",
        name: "Letterkenny airport",
        chineseName: "莱特肯尼机场",
        traditionalName: "萊特肯尼機場",
      },
    ],
  },
  LTX: {
    code: "LTX",
    name: "LATACUNGA",
    chineseName: "拉塔昆加",
    traditionalName: "拉塔昆加",
    airports: [
      {
        code: "LTX",
        name: "Cotapaxi international",
        chineseName: "拉塔昆加机场",
        traditionalName: "拉塔昆加機場",
      },
    ],
  },
  LUA: {
    code: "LUA",
    name: "LUKLA",
    chineseName: "鲁卡拉",
    traditionalName: "魯卡拉",
    airports: [
      {
        code: "LUA",
        name: "Tenzing-hillary",
        chineseName: "卢克拉机场",
        traditionalName: "盧克拉機場",
      },
    ],
  },
  LUD: {
    code: "LUD",
    name: "LUDERITZ",
    chineseName: "吕德里茨",
    traditionalName: "呂德裏茨",
    airports: [
      {
        code: "LUD",
        name: "Luderitz airport",
        chineseName: "吕德里茨机场",
        traditionalName: "呂德里茨機場",
      },
    ],
  },
  LUH: {
    code: "LUH",
    name: "LUDHIANA",
    chineseName: "卢迪亚纳",
    traditionalName: "盧迪亞納",
    airports: [
      {
        code: "LUH",
        name: "Ludhiana airport",
        chineseName: "卢迪亚纳机场",
        traditionalName: "盧迪亞納機場",
      },
    ],
  },
  LUL: {
    code: "LUL",
    name: "HATTIESBURG/LAUREL",
    chineseName: "哈蒂斯堡/劳雷尔",
    traditionalName: "哈蒂斯堡/勞雷爾",
    airports: [
      {
        code: "PIB",
        name: "Hattiesburg/laurel reg. airpor",
        chineseName: "哈蒂斯堡－劳雷尔地区机场",
        traditionalName: "哈蒂斯堡－勞雷爾地區機場",
      },
    ],
  },
  LUM: {
    code: "LUM",
    name: "MANGSHI",
    chineseName: "芒",
    traditionalName: "芒",
    airports: [
      {
        code: "LUM",
        name: "Dehong mangshi",
        chineseName: "德宏芒市机场",
        traditionalName: "德宏芒市機場",
      },
    ],
  },
  LUN: {
    code: "LUN",
    name: "LUSAKA",
    chineseName: "卢萨卡",
    traditionalName: "路沙卡",
    airports: [
      {
        code: "LUN",
        name: "Lusaka intl.",
        chineseName: "卢萨卡国际机场",
        traditionalName: "路沙卡國際機場",
      },
    ],
  },
  LUO: {
    code: "LUO",
    name: "LUENA",
    chineseName: "卢恩阿",
    traditionalName: "盧恩阿",
    airports: [
      {
        code: "LUO",
        name: "Luena airport",
        chineseName: "卢埃纳机场",
        traditionalName: "盧埃納機場",
      },
    ],
  },
  LUP: {
    code: "LUP",
    name: "KALAUPAPA",
    chineseName: "卡劳帕帕",
    traditionalName: "卡勞帕帕",
    airports: [
      {
        code: "LUP",
        name: "Kalaupapa airport",
        chineseName: "卡劳帕帕机场",
        traditionalName: "卡勞帕帕機場",
      },
    ],
  },
  LUQ: {
    code: "LUQ",
    name: "SAN LUIS",
    chineseName: "圣路易斯",
    traditionalName: "聖路易斯",
    airports: [
      {
        code: "LUQ",
        name: "D. cesar raul ojeda",
        chineseName: "圣路易斯机场",
        traditionalName: "聖路易斯機場",
      },
    ],
  },
  LUR: {
    code: "LUR",
    name: "CAPE LISBURNE",
    chineseName: "开普利斯本",
    traditionalName: "開普利斯本",
    airports: [
      {
        code: "LUR",
        name: "Cape lisburne airport",
        chineseName: "开普利斯本机场",
        traditionalName: "開普利斯本機場",
      },
    ],
  },
  LUV: {
    code: "LUV",
    name: "LANGGUR",
    chineseName: "兰格尔",
    traditionalName: "蘭格爾",
    airports: [
      {
        code: "LUV",
        name: "Dumatubun",
        chineseName: "兰格尔机场",
        traditionalName: "蘭格爾機場",
      },
    ],
  },
  LUW: {
    code: "LUW",
    name: "LUWUK",
    chineseName: "卢武克",
    traditionalName: "盧武克",
    airports: [
      {
        code: "LUW",
        name: "S.aminuddin amir",
        chineseName: "卢武克机场",
        traditionalName: "盧武克機場",
      },
    ],
  },
  LUX: {
    code: "LUX",
    name: "LUXEMBOURG",
    chineseName: "卢森堡",
    traditionalName: "盧森堡",
    airports: [
      {
        code: "LUX",
        name: "Luxembourg airport",
        chineseName: "卢森堡机场",
        traditionalName: "盧森堡機場",
      },
    ],
  },
  LUZ: {
    code: "LUZ",
    name: "LUBLIN",
    chineseName: "希维德尼克",
    traditionalName: "希維德尼克",
    airports: [
      {
        code: "LUZ",
        name: "Lublin airport",
        chineseName: "卢布林机场",
        traditionalName: "盧布林機場",
      },
    ],
  },
  LVI: {
    code: "LVI",
    name: "LIVINGSTONE",
    chineseName: "利文斯敦",
    traditionalName: "利文斯敦",
    airports: [
      {
        code: "LVI",
        name: "Livingstone airport",
        chineseName: "利文斯敦机场",
        traditionalName: "利文斯敦機場",
      },
    ],
  },
  LVK: {
    code: "LVK",
    name: "LIVERMORE",
    chineseName: "利弗莫尔",
    traditionalName: "利弗莫爾",
    airports: [
      {
        code: "LVK",
        name: "Livermore municipal",
        chineseName: "利弗莫尔机场",
        traditionalName: "利弗莫爾機場",
      },
    ],
  },
  LVO: {
    code: "LVO",
    name: "LAVERTON",
    chineseName: "拉弗顿",
    traditionalName: "拉弗頓",
    airports: [
      {
        code: "LVO",
        name: "Laverton airport",
        chineseName: "拉弗顿机场",
        traditionalName: "拉弗頓機場",
      },
    ],
  },
  LWB: {
    code: "LWB",
    name: "LEWISBURG",
    chineseName: "刘易斯堡",
    traditionalName: "路易斯堡",
    airports: [
      {
        code: "LWB",
        name: "Greenbrier valley",
        chineseName: "格林布里尔瓦雷机场",
        traditionalName: "格林布裏爾瓦雷機場",
      },
    ],
  },
  LWE: {
    code: "LWE",
    name: "LEWOLEBA",
    chineseName: "勒沃莱巴",
    traditionalName: "勒沃萊巴",
    airports: [
      {
        code: "LWE",
        name: "Wunopito",
        chineseName: "刘沃莱巴机场",
        traditionalName: "劉沃萊巴機場",
      },
    ],
  },
  LWS: {
    code: "LWS",
    name: "LEWISTON",
    chineseName: "刘易斯顿",
    traditionalName: "劉易斯頓",
    airports: [
      {
        code: "LWS",
        name: "Nez perce county",
        chineseName: "内兹帕斯郡地区机场",
        traditionalName: "內茲帕斯郡地區機場",
      },
    ],
  },
  LWY: {
    code: "LWY",
    name: "LAWAS",
    chineseName: "拉瓦斯",
    traditionalName: "拉瓦斯",
    airports: [
      {
        code: "LWY",
        name: "Lawas airport",
        chineseName: "拉瓦斯机场",
        traditionalName: "拉瓦斯機場",
      },
    ],
  },
  LXA: {
    code: "LXA",
    name: "LHASA/LASA",
    chineseName: "拉萨",
    traditionalName: "拉薩",
    airports: [
      {
        code: "LXA",
        name: "Gonggar",
        chineseName: "贡嘎国际机场",
        traditionalName: "貢嘎國際機場",
      },
    ],
  },
  LXG: {
    code: "LXG",
    name: "LUANG NAMTHA",
    chineseName: "琅南塔",
    traditionalName: "琅南塔",
    airports: [
      {
        code: "LXG",
        name: "Luang namtha airport",
        chineseName: "琅南塔机场",
        traditionalName: "琅南塔機場",
      },
    ],
  },
  LXR: {
    code: "LXR",
    name: "LUXOR",
    chineseName: "卢克索",
    traditionalName: "盧克索",
    airports: [
      {
        code: "LXR",
        name: "Luxor intl.",
        chineseName: "卢克索国际机场",
        traditionalName: "盧克索國際機場",
      },
    ],
  },
  LXS: {
    code: "LXS",
    name: "LIMNOS",
    chineseName: "利姆诺斯岛",
    traditionalName: "利姆諾斯島",
    airports: [
      {
        code: "LXS",
        name: "Limnos airport",
        chineseName: "利姆诺斯机场",
        traditionalName: "利姆諾斯機場",
      },
    ],
  },
  LYA: {
    code: "LYA",
    name: "LUOYANG",
    chineseName: "洛阳",
    traditionalName: "洛陽",
    airports: [
      {
        code: "LYA",
        name: "Beijiao",
        chineseName: "北郊机场",
        traditionalName: "北郊機場",
      },
    ],
  },
  LYB: {
    code: "LYB",
    name: "LITTLE CAYMAN",
    chineseName: "小开曼",
    traditionalName: "小開曼",
    airports: [
      {
        code: "LYB",
        name: "Edward bodden",
        chineseName: "爱德华博登机场",
        traditionalName: "愛德華博登機場",
      },
    ],
  },
  LYC: {
    code: "LYC",
    name: "LYCKSELE",
    chineseName: "吕克瑟勒",
    traditionalName: "呂克瑟勒",
    airports: [
      {
        code: "LYC",
        name: "Lycksele airport",
        chineseName: "吕克瑟勒机场",
        traditionalName: "呂克瑟勒機場",
      },
    ],
  },
  LYG: {
    code: "LYG",
    name: "LIANYUNGANG",
    chineseName: "连云港",
    traditionalName: "連雲港",
    airports: [
      {
        code: "LYG",
        name: "Huaguoshan",
        chineseName: "花果山机场",
        traditionalName: "花果山機場",
      },
    ],
  },
  LYH: {
    code: "LYH",
    name: "LYNCHBURG",
    chineseName: "林奇堡",
    traditionalName: "林奇堡",
    airports: [
      {
        code: "LYH",
        name: "Regional-p. glenn fld",
        chineseName: "普雷斯顿格伦机场",
        traditionalName: "普雷斯顿葛籣機場",
      },
    ],
  },
  LYI: {
    code: "LYI",
    name: "LINYI",
    chineseName: "临沂",
    traditionalName: "臨沂",
    airports: [
      {
        code: "LYI",
        name: "Shubuling",
        chineseName: "临沂启阳机场",
        traditionalName: "臨沂啟陽機場",
      },
    ],
  },
  LYP: {
    code: "LYP",
    name: "FAISALABAD",
    chineseName: "费萨拉巴德",
    traditionalName: "費薩拉巴特",
    airports: [
      {
        code: "LYP",
        name: "Faisalabad intl.",
        chineseName: "费萨拉巴德国际机场",
        traditionalName: "費薩拉巴特國際機場",
      },
    ],
  },
  LYR: {
    code: "LYR",
    name: "LONGYEARBYEN",
    chineseName: "斯瓦尔巴群岛",
    traditionalName: "斯瓦爾巴群島",
    airports: [
      {
        code: "LYR",
        name: "Svalbard",
        chineseName: "斯瓦尔巴德机场",
        traditionalName: "斯瓦爾巴德機場",
      },
    ],
  },
  LYS: {
    code: "LYS",
    name: "LYON",
    chineseName: "里昂",
    traditionalName: "里昂",
    airports: [
      {
        code: "GNB",
        name: "Grenoble-isere",
        chineseName: "格勒诺布尔机场",
        traditionalName: "格勒諾布爾機場",
      },
      {
        code: "LYS",
        name: "St-exupery",
        chineseName: "里昂圣埃克絮佩里机场",
        traditionalName: "里昂聖埃克絮佩里機場",
      },
    ],
  },
  LZG: {
    code: "LZG",
    name: "LANGZHONG",
    chineseName: "阆中",
    traditionalName: "閬中",
    airports: [
      {
        code: "LZG",
        name: "Langzhong gucheng",
        chineseName: "阆中古城机场",
        traditionalName: "閬中古城機場",
      },
    ],
  },
  LZH: {
    code: "LZH",
    name: "LIUZHOU",
    chineseName: "柳州",
    traditionalName: "柳州",
    airports: [
      {
        code: "LZH",
        name: "Bailian",
        chineseName: "白莲机场",
        traditionalName: "白蓮機場",
      },
    ],
  },
  LZN: {
    code: "LZN",
    name: "MATSU (NANGAN)",
    chineseName: "连江",
    traditionalName: "連江",
    airports: [
      {
        code: "LZN",
        name: "Matsu (nangan) airport",
        chineseName: "马祖南竿机场",
        traditionalName: "馬祖南竿機場",
      },
    ],
  },
  LZO: {
    code: "LZO",
    name: "LUZHOU",
    chineseName: "泸州",
    traditionalName: "瀘州",
    airports: [
      {
        code: "LZO",
        name: "Yunlong",
        chineseName: "云龙机场",
        traditionalName: "雲龍機場",
      },
    ],
  },
  LZU: {
    code: "LZU",
    name: "LAWRENCEVILLE",
    chineseName: "劳伦斯维尔",
    traditionalName: "勞倫斯維爾",
    airports: [
      {
        code: "LZU",
        name: "Gwinnett county",
        chineseName: "格威纳特县机场",
        traditionalName: "格威納特縣機場",
      },
    ],
  },
  LZY: {
    code: "LZY",
    name: "NYINGCHI/LINZHI",
    chineseName: "林芝",
    traditionalName: "林芝",
    airports: [
      {
        code: "LZY",
        name: "Mainling/milin",
        chineseName: "米林机场",
        traditionalName: "米林機場",
      },
    ],
  },
  MAA: {
    code: "MAA",
    name: "CHENNAI",
    chineseName: "金奈",
    traditionalName: "金奈",
    airports: [
      {
        code: "MAA",
        name: "International",
        chineseName: "晨奈国际机场",
        traditionalName: "晨奈國際機場",
      },
    ],
  },
  MAB: {
    code: "MAB",
    name: "MARABA",
    chineseName: "马拉巴",
    traditionalName: "馬拉巴",
    airports: [
      {
        code: "MAB",
        name: "Joao correa da rocha",
        chineseName: "马拉巴机场",
        traditionalName: "馬拉巴機場",
      },
    ],
  },
  MAD: {
    code: "MAD",
    name: "MADRID",
    chineseName: "马德里",
    traditionalName: "馬德里",
    airports: [
      {
        code: "MAD",
        name: "Adolfo suarez-barajas",
        chineseName: "巴拉哈斯机场",
        traditionalName: "巴拉哈斯機場",
      },
    ],
  },
  MAF: {
    code: "MAF",
    name: "MIDLAND",
    chineseName: "米德兰",
    traditionalName: "米德蘭",
    airports: [
      {
        code: "MAF",
        name: "Midland intl.",
        chineseName: "米德兰国际机场",
        traditionalName: "米德蘭國際機場",
      },
    ],
  },
  MAG: {
    code: "MAG",
    name: "MADANG",
    chineseName: "马当",
    traditionalName: "馬當",
    airports: [
      {
        code: "MAG",
        name: "Madang airport",
        chineseName: "马当机场",
        traditionalName: "馬當機場",
      },
    ],
  },
  MAH: {
    code: "MAH",
    name: "MENORCA",
    chineseName: "梅诺卡岛",
    traditionalName: "梅諾卡島",
    airports: [
      {
        code: "MAH",
        name: "Menorca airport",
        chineseName: "梅诺卡机场",
        traditionalName: "梅諾卡機場",
      },
    ],
  },
  MAJ: {
    code: "MAJ",
    name: "MAJURO",
    chineseName: "马朱罗",
    traditionalName: "麥哲魯",
    airports: [
      {
        code: "MAJ",
        name: "Amata kabua intl",
        chineseName: "阿马塔卡布阿国际机场",
        traditionalName: "阿馬塔卡布阿國際機場",
      },
    ],
  },
  MAM: {
    code: "MAM",
    name: "MATAMOROS",
    chineseName: "马塔莫罗斯",
    traditionalName: "馬塔莫羅斯",
    airports: [
      {
        code: "MAM",
        name: "Servando canales intl",
        chineseName: "塞尔瓦多卡纳莱斯将军国际机场",
        traditionalName: "塞爾瓦多卡納萊斯將軍國際機場",
      },
    ],
  },
  MAN: {
    code: "MAN",
    name: "MANCHESTER",
    chineseName: "曼彻斯特",
    traditionalName: "曼徹斯特",
    airports: [
      {
        code: "MAN",
        name: "Manchester airport",
        chineseName: "曼彻斯特机场",
        traditionalName: "曼徹斯特機場",
      },
    ],
  },
  MAO: {
    code: "MAO",
    name: "MANAUS",
    chineseName: "马瑙斯",
    traditionalName: "馬瑙斯",
    airports: [
      {
        code: "MAO",
        name: "Eduardo gomes intl",
        chineseName: "埃杜阿多戈梅斯国际机场",
        traditionalName: "埃杜阿多戈梅斯國際機場",
      },
    ],
  },
  MAQ: {
    code: "MAQ",
    name: "MAE SOT",
    chineseName: "湄索",
    traditionalName: "湄索",
    airports: [
      {
        code: "MAQ",
        name: "Mae sot airport",
        chineseName: "湄索机场",
        traditionalName: "湄索機場",
      },
    ],
  },
  MAR: {
    code: "MAR",
    name: "MARACAIBO",
    chineseName: "马拉开波",
    traditionalName: "馬拉凱博",
    airports: [
      {
        code: "MAR",
        name: "La chinita intl",
        chineseName: "拉奇尼塔机场",
        traditionalName: "拉奇尼塔機場",
      },
    ],
  },
  MAS: {
    code: "MAS",
    name: "MANUS ISLAND",
    chineseName: "马努斯岛",
    traditionalName: "馬努斯島",
    airports: [
      {
        code: "MAS",
        name: "Momote",
        chineseName: "莫莫特机场",
        traditionalName: "莫莫特機場",
      },
    ],
  },
  MAU: {
    code: "MAU",
    name: "MAUPITI",
    chineseName: "莫皮蒂",
    traditionalName: "莫皮蒂",
    airports: [
      {
        code: "MAU",
        name: "Maupiti airport",
        chineseName: "莫皮蒂机场",
        traditionalName: "莫皮蒂機場",
      },
    ],
  },
  MAV: {
    code: "MAV",
    name: "MALOELAP ATOLL",
    chineseName: "马洛埃拉普",
    traditionalName: "馬婁艾拉普",
    airports: [
      {
        code: "MAV",
        name: "Taroa island",
        chineseName: "马洛埃拉普机场",
        traditionalName: "馬婁艾拉普機場",
      },
    ],
  },
  MAZ: {
    code: "MAZ",
    name: "MAYAGUEZ",
    chineseName: "马亚圭斯",
    traditionalName: "馬亞圭斯",
    airports: [
      {
        code: "MAZ",
        name: "Eugenio m. de hostos",
        chineseName: "尤格尼奥德霍斯托斯机场",
        traditionalName: "尤格尼奧德霍斯托斯機場",
      },
    ],
  },
  MBA: {
    code: "MBA",
    name: "MOMBASA",
    chineseName: "蒙巴萨",
    traditionalName: "蒙巴薩",
    airports: [
      {
        code: "MBA",
        name: "Moi international",
        chineseName: "莫伊国际机场",
        traditionalName: "莫伊國際機場",
      },
    ],
  },
  MBB: {
    code: "MBB",
    name: "MARBLE BAR",
    chineseName: "马布尔巴",
    traditionalName: "馬布爾巴",
    airports: [
      {
        code: "MBB",
        name: "Marble bar airport",
        chineseName: "马布尔巴机场",
        traditionalName: "馬布林巴機場",
      },
    ],
  },
  MBE: {
    code: "MBE",
    name: "MONBETSU",
    chineseName: "鄂霍次克",
    traditionalName: "鄂霍次克",
    airports: [
      {
        code: "MBE",
        name: "Monbetsu airport",
        chineseName: "鄂霍次克机场",
        traditionalName: "鄂霍次克機場",
      },
    ],
  },
  MBI: {
    code: "MBI",
    name: "MBEYA",
    chineseName: "姆贝亚",
    traditionalName: "姆貝亞",
    airports: [
      {
        code: "MBI",
        name: "Mbeya airport",
        chineseName: "姆贝亚机场",
        traditionalName: "姆貝亞機場",
      },
    ],
  },
  MBJ: {
    code: "MBJ",
    name: "MONTEGO BAY",
    chineseName: "蒙坦戈贝",
    traditionalName: "蒙坦戈貝",
    airports: [
      {
        code: "MBJ",
        name: "Sangster intl",
        chineseName: "桑斯特国际机场",
        traditionalName: "桑斯特國際機場",
      },
    ],
  },
  MBL: {
    code: "MBL",
    name: "MANISTEE",
    chineseName: "马尼斯蒂",
    traditionalName: "馬尼斯蒂",
    airports: [
      {
        code: "MBL",
        name: "Manistee co. blacker",
        chineseName: "布莱科尔机场",
        traditionalName: "布萊科爾機場",
      },
    ],
  },
  MBQ: {
    code: "MBQ",
    name: "MBARARA",
    chineseName: "姆巴拉拉",
    traditionalName: "姆巴拉拉",
    airports: [
      {
        code: "MBQ",
        name: "Mbarara airport",
        chineseName: "姆巴拉拉机场",
        traditionalName: "姆巴拉拉機場",
      },
    ],
  },
  MBS: {
    code: "MBS",
    name: "SAGINAW/MIDLAND/BAY C.",
    chineseName: "萨吉诺",
    traditionalName: "薩吉諾",
    airports: [
      {
        code: "MBS",
        name: "Mbs intl",
        chineseName: "MBS国际机场",
        traditionalName: "MBS國際機場",
      },
    ],
  },
  MBT: {
    code: "MBT",
    name: "MASBATE",
    chineseName: "马斯巴特",
    traditionalName: "馬斯巴特",
    airports: [
      {
        code: "MBT",
        name: "Moises r. espinosa",
        chineseName: "马斯巴特机场",
        traditionalName: "馬斯巴特機場",
      },
    ],
  },
  MBZ: {
    code: "MBZ",
    name: "MAUES",
    chineseName: "毛埃斯",
    traditionalName: "毛埃斯",
    airports: [
      {
        code: "MBZ",
        name: "Maues airport",
        chineseName: "毛埃斯机场",
        traditionalName: "毛埃斯機場",
      },
    ],
  },
  MCE: {
    code: "MCE",
    name: "MERCED",
    chineseName: "默塞德",
    traditionalName: "默塞德",
    airports: [
      {
        code: "MCE",
        name: "Merced reg. airport",
        chineseName: "默塞德地方机场",
        traditionalName: "默塞德地方機場",
      },
    ],
  },
  MCG: {
    code: "MCG",
    name: "MCGRATH",
    chineseName: "麦格拉斯",
    traditionalName: "麥格拉斯",
    airports: [
      {
        code: "MCG",
        name: "Mcgrath airport",
        chineseName: "麦克格雷斯机场",
        traditionalName: "麥克格雷斯機場",
      },
    ],
  },
  MCK: {
    code: "MCK",
    name: "MCCOOK",
    chineseName: "麦库克",
    traditionalName: "麥庫克",
    airports: [
      {
        code: "MCK",
        name: "Ben nelson regional",
        chineseName: "麦库克机场",
        traditionalName: "麥庫克機場",
      },
    ],
  },
  MCN: {
    code: "MCN",
    name: "MACON",
    chineseName: "梅肯",
    traditionalName: "梅肯",
    airports: [
      {
        code: "MCN",
        name: "Middle georgia rgnl",
        chineseName: "乔治亚中部地区机场",
        traditionalName: "喬治亞中部地區機場",
      },
    ],
  },
  MCP: {
    code: "MCP",
    name: "MACAPA",
    chineseName: "马卡帕",
    traditionalName: "馬卡帕",
    airports: [
      {
        code: "MCP",
        name: "Alberto alcolumbre int",
        chineseName: "马卡帕国际机场",
        traditionalName: "馬卡帕國際機場",
      },
    ],
  },
  MCT: {
    code: "MCT",
    name: "MUSCAT",
    chineseName: "马斯喀特",
    traditionalName: "馬斯喀特",
    airports: [
      {
        code: "MCT",
        name: "Muscat intl.",
        chineseName: "马斯喀特国际机场",
        traditionalName: "馬斯喀特國際機場",
      },
    ],
  },
  MCV: {
    code: "MCV",
    name: "MCARTHUR RIVER MINE",
    chineseName: "麦克阿瑟河",
    traditionalName: "麥克亞瑟河",
    airports: [
      {
        code: "MCV",
        name: "Mcarthur river mine airport",
        chineseName: "麦克阿瑟河机场",
        traditionalName: "麥克亞瑟河機場",
      },
    ],
  },
  MCW: {
    code: "MCW",
    name: "MASON CITY",
    chineseName: "梅森城",
    traditionalName: "梅森城",
    airports: [
      {
        code: "MCW",
        name: "Mason city municipal",
        chineseName: "梅森城地区机场",
        traditionalName: "梅森城地區機場",
      },
    ],
  },
  MCX: {
    code: "MCX",
    name: "MAKHACHKALA",
    chineseName: "马哈奇卡拉",
    traditionalName: "馬哈奇卡拉",
    airports: [
      {
        code: "MCX",
        name: "Uytash",
        chineseName: "马哈奇卡拉机场",
        traditionalName: "馬哈奇卡拉機場",
      },
    ],
  },
  MCY: {
    code: "MCY",
    name: "SUNSHINE COAST",
    chineseName: "桑夏恩海岸",
    traditionalName: "桑夏恩海岸",
    airports: [
      {
        code: "MCY",
        name: "Maroochydore",
        chineseName: "马鲁奇多雷机场",
        traditionalName: "馬魯奇多雷機場",
      },
    ],
  },
  MCZ: {
    code: "MCZ",
    name: "MACEIO",
    chineseName: "马塞约",
    traditionalName: "馬賽約",
    airports: [
      {
        code: "MCZ",
        name: "Zumbi dos palmares int",
        chineseName: "帕尔马雷斯机场",
        traditionalName: "帕爾馬雷斯機場",
      },
    ],
  },
  MDC: {
    code: "MDC",
    name: "MANADO",
    chineseName: "万鸦老",
    traditionalName: "萬鴉老",
    airports: [
      {
        code: "MDC",
        name: "Sam ratulangi",
        chineseName: "萨姆拉图兰吉机场",
        traditionalName: "薩姆拉圖蘭吉機場",
      },
    ],
  },
  MDE: {
    code: "MDE",
    name: "MEDELLIN",
    chineseName: "麦德林",
    traditionalName: "麥德林",
    airports: [
      {
        code: "EOH",
        name: "Enrique olaya herrera",
        chineseName: "恩里克奥拉亚埃雷拉机场",
        traditionalName: "恩裡克奧拉亞埃雷拉機場",
      },
      {
        code: "MDE",
        name: "Jose maria cordova int",
        chineseName: "麦德林何塞·玛丽亚·科尔多瓦国际机场",
        traditionalName: "麥德林何塞·瑪麗亞·科爾多瓦國際機場",
      },
    ],
  },
  MDG: {
    code: "MDG",
    name: "MUDANJIANG",
    chineseName: "牡丹江",
    traditionalName: "牡丹江",
    airports: [
      {
        code: "MDG",
        name: "Hailang",
        chineseName: "海浪机场",
        traditionalName: "海浪機場",
      },
    ],
  },
  MDK: {
    code: "MDK",
    name: "MBANDAKA",
    chineseName: "姆班达克",
    traditionalName: "姆班達克",
    airports: [
      {
        code: "MDK",
        name: "Mbandaka airport",
        chineseName: "姆班达克机场",
        traditionalName: "姆班達克機場",
      },
    ],
  },
  MDL: {
    code: "MDL",
    name: "MANDALAY",
    chineseName: "曼德勒",
    traditionalName: "曼德勒",
    airports: [
      {
        code: "MDL",
        name: "Mandalay intl.",
        chineseName: "曼德勒国际机场",
        traditionalName: "曼德勒國際機場",
      },
    ],
  },
  MDQ: {
    code: "MDQ",
    name: "MAR DEL PLATA",
    chineseName: "马德普拉塔",
    traditionalName: "馬德普拉塔",
    airports: [
      {
        code: "MDQ",
        name: "Astor piazzola",
        chineseName: "马德普拉塔机场",
        traditionalName: "馬德普拉塔機場",
      },
    ],
  },
  MDU: {
    code: "MDU",
    name: "MENDI",
    chineseName: "门迪",
    traditionalName: "門迪",
    airports: [
      {
        code: "MDU",
        name: "Mendi airport",
        chineseName: "门迪机场",
        traditionalName: "門迪機場",
      },
    ],
  },
  MDZ: {
    code: "MDZ",
    name: "MENDOZA",
    chineseName: "门多萨",
    traditionalName: "門多薩",
    airports: [
      {
        code: "MDZ",
        name: "El plumerillo",
        chineseName: "埃尔普鲁梅里罗机场",
        traditionalName: "埃爾普魯梅裏羅機場",
      },
    ],
  },
  MEC: {
    code: "MEC",
    name: "MANTA",
    chineseName: "曼塔",
    traditionalName: "曼塔",
    airports: [
      {
        code: "MEC",
        name: "Eloy alfaro intl",
        chineseName: "埃洛伊阿尔法罗国际机场",
        traditionalName: "埃洛伊阿爾法羅國際機場",
      },
    ],
  },
  MED: {
    code: "MED",
    name: "MADINAH",
    chineseName: "麦地那",
    traditionalName: "麥地那",
    airports: [
      {
        code: "MED",
        name: "Mohammad bin abdulaziz",
        chineseName: "穆罕默德本阿布杜拉齐兹机场",
        traditionalName: "穆罕默德本阿布杜拉齊茲機場",
      },
    ],
  },
  MEE: {
    code: "MEE",
    name: "MARE",
    chineseName: "马雷岛",
    traditionalName: "馬雷島",
    airports: [
      {
        code: "MEE",
        name: "La roche",
        chineseName: "马雷岛机场",
        traditionalName: "馬雷島機場",
      },
    ],
  },
  MEH: {
    code: "MEH",
    name: "MEHAMN",
    chineseName: "默哈姆",
    traditionalName: "默哈姆",
    airports: [
      {
        code: "MEH",
        name: "Mehamn airport",
        chineseName: "梅哈姆机场",
        traditionalName: "梅哈姆機場",
      },
    ],
  },
  MEI: {
    code: "MEI",
    name: "MERIDIAN",
    chineseName: "默里迪恩",
    traditionalName: "默裏迪恩",
    airports: [
      {
        code: "MEI",
        name: "Regional (key field)",
        chineseName: "凯机场",
        traditionalName: "凱機場",
      },
    ],
  },
  MEL: {
    code: "MEL",
    name: "MELBOURNE",
    chineseName: "墨尔本",
    traditionalName: "墨爾本",
    airports: [
      {
        code: "AVV",
        name: "Avalon",
        chineseName: "阿瓦隆机场",
        traditionalName: "阿瓦隆機場",
      },
      {
        code: "MBW",
        name: "Moorabbin",
        chineseName: "穆拉宾机场",
        traditionalName: "穆拉賓機場",
      },
      {
        code: "MEB",
        name: "Essendon",
        chineseName: "墨尔本机场",
        traditionalName: "墨爾本機場",
      },
      {
        code: "MEL",
        name: "Melbourne airport",
        chineseName: "墨尔本机场",
        traditionalName: "墨爾本機場",
      },
    ],
  },
  MEM: {
    code: "MEM",
    name: "MEMPHIS",
    chineseName: "孟菲斯",
    traditionalName: "孟菲斯",
    airports: [
      {
        code: "MEM",
        name: "Memphis intl.",
        chineseName: "孟菲斯国际机场",
        traditionalName: "孟菲斯國際機場",
      },
    ],
  },
  MEN: {
    code: "MEN",
    name: "MENDE",
    chineseName: "芒德",
    traditionalName: "芒德",
    airports: [
      {
        code: "MEN",
        name: "Brenoux",
        chineseName: "芒德机场",
        traditionalName: "芒德機場",
      },
    ],
  },
  MEQ: {
    code: "MEQ",
    name: "CUT NYAK DIEN",
    chineseName: "米拉务",
    traditionalName: "米拉務",
    airports: [
      {
        code: "MEQ",
        name: "Nagan raya",
        chineseName: "苏纳甘机场",
        traditionalName: "蘇納甘機場",
      },
    ],
  },
  MES: {
    code: "MES",
    name: "MEDAN",
    chineseName: "梅丹",
    traditionalName: "梅丹",
    airports: [
      {
        code: "KNO",
        name: "Kuala namu",
        chineseName: "瓜拉娜姆国际机场",
        traditionalName: "瓜拉娜姆國際機場",
      },
      {
        code: "MES",
        name: "Polonia",
        chineseName: "棉兰国际机场",
        traditionalName: "棉蘭國際機場",
      },
    ],
  },
  MEU: {
    code: "MEU",
    name: "MONTE DOURADO",
    chineseName: "蒙特多拉多",
    traditionalName: "蒙特多拉多",
    airports: [
      {
        code: "MEU",
        name: "Serra do areao",
        chineseName: "蒙特多拉多机场",
        traditionalName: "蒙特多拉多機場",
      },
    ],
  },
  MEX: {
    code: "MEX",
    name: "MEXICO CITY",
    chineseName: "墨西哥城",
    traditionalName: "墨西哥城",
    airports: [
      {
        code: "MEX",
        name: "Benito juarez intl",
        chineseName: "贝尼托·胡亚雷斯国际机场",
        traditionalName: "貝尼托·胡亞雷斯國際機場",
      },
      {
        code: "NLU",
        name: "Felipe angeles intl.",
        chineseName: "菲利普·安吉利斯国际机场",
        traditionalName: "菲利普·安吉利斯國際機場",
      },
      {
        code: "TLC",
        name: "Toluca-a.lopez mateos",
        chineseName: "托卢卡机场",
        traditionalName: "托盧卡機場",
      },
    ],
  },
  MFA: {
    code: "MFA",
    name: "MAFIA ISLAND",
    chineseName: "马菲亚",
    traditionalName: "馬菲亞",
    airports: [
      {
        code: "MFA",
        name: "Mafia island airport",
        chineseName: "马菲亚机场",
        traditionalName: "馬菲亞機場",
      },
    ],
  },
  MFE: {
    code: "MFE",
    name: "MCALLEN/MISSION",
    chineseName: "麦卡伦",
    traditionalName: "麥卡倫",
    airports: [
      {
        code: "MFE",
        name: "Miller international",
        chineseName: "米勒国际机场",
        traditionalName: "米勒國際機場",
      },
    ],
  },
  MFJ: {
    code: "MFJ",
    name: "MOALA ISLAND",
    chineseName: "莫阿拉",
    traditionalName: "莫阿拉",
    airports: [
      {
        code: "MFJ",
        name: "Moala island airport",
        chineseName: "莫阿拉机场",
        traditionalName: "莫阿拉機場",
      },
    ],
  },
  MFK: {
    code: "MFK",
    name: "MATSU (BEIGAN)",
    chineseName: "北竿",
    traditionalName: "北竿",
    airports: [
      {
        code: "MFK",
        name: "Matsu (beigan) airport",
        chineseName: "马祖北竿机场",
        traditionalName: "馬祖北竿機場",
      },
    ],
  },
  MFM: {
    code: "MFM",
    name: "MACAU",
    chineseName: "澳门",
    traditionalName: "澳門",
    airports: [
      {
        code: "MFM",
        name: "Macau intl.",
        chineseName: "澳门国际机场",
        traditionalName: "澳門國際機場",
      },
    ],
  },
  MFR: {
    code: "MFR",
    name: "MEDFORD",
    chineseName: "梅德福",
    traditionalName: "梅德福",
    airports: [
      {
        code: "MFR",
        name: "Rogue valley intl",
        chineseName: "罗格谷国际机场",
        traditionalName: "羅格穀國際機場",
      },
    ],
  },
  MFU: {
    code: "MFU",
    name: "MFUWE",
    chineseName: "姆富韦",
    traditionalName: "姆富韋",
    airports: [
      {
        code: "MFU",
        name: "Mfuwe airport",
        chineseName: "姆富韦机场",
        traditionalName: "姆富韋機場",
      },
    ],
  },
  MGA: {
    code: "MGA",
    name: "MANAGUA",
    chineseName: "马纳瓜",
    traditionalName: "馬納瓜",
    airports: [
      {
        code: "MGA",
        name: "Augusto c. sandino int",
        chineseName: "奥古斯托桑迪诺机场",
        traditionalName: "奧古斯托桑迪諾機場",
      },
    ],
  },
  MGB: {
    code: "MGB",
    name: "MOUNT GAMBIER",
    chineseName: "芒特甘比尔",
    traditionalName: "芒特甘比爾",
    airports: [
      {
        code: "MGB",
        name: "Mount gambier airport",
        chineseName: "甘比尔山机场",
        traditionalName: "甘比爾山機場",
      },
    ],
  },
  MGF: {
    code: "MGF",
    name: "MARINGA",
    chineseName: "马林加",
    traditionalName: "馬林加",
    airports: [
      {
        code: "MGF",
        name: "Silvio name jr.",
        chineseName: "马林加地区机场",
        traditionalName: "馬林加地區機場",
      },
    ],
  },
  MGH: {
    code: "MGH",
    name: "MARGATE",
    chineseName: "马盖特",
    traditionalName: "馬蓋特",
    airports: [
      {
        code: "MGH",
        name: "Margate airport",
        chineseName: "马盖特机场",
        traditionalName: "馬蓋特機場",
      },
    ],
  },
  MGM: {
    code: "MGM",
    name: "MONTGOMERY",
    chineseName: "蒙哥马利",
    traditionalName: "蒙哥馬利",
    airports: [
      {
        code: "MGM",
        name: "Regional-dannelly fld",
        chineseName: "达内里机场",
        traditionalName: "達內裏機場",
      },
    ],
  },
  MGQ: {
    code: "MGQ",
    name: "MOGADISHU",
    chineseName: "摩加迪沙",
    traditionalName: "摩加迪休",
    airports: [
      {
        code: "MGQ",
        name: "Aden adde intl",
        chineseName: "亚丁阿德国际机场",
        traditionalName: "亞丁阿德國際機場",
      },
    ],
  },
  MGT: {
    code: "MGT",
    name: "MILINGIMBI ISLAND",
    chineseName: "米灵吉姆彼",
    traditionalName: "米靈吉姆彼",
    airports: [
      {
        code: "MGT",
        name: "Milingimbi island airport",
        chineseName: "米灵吉姆彼机场",
        traditionalName: "米靈吉姆彼機場",
      },
    ],
  },
  MGW: {
    code: "MGW",
    name: "MORGANTOWN",
    chineseName: "摩根敦",
    traditionalName: "摩根敦",
    airports: [
      {
        code: "MGW",
        name: "Morgantown municipal",
        chineseName: "摩根敦机场",
        traditionalName: "摩根敦機場",
      },
    ],
  },
  MGZ: {
    code: "MGZ",
    name: "MYEIK",
    chineseName: "丹老",
    traditionalName: "丹老",
    airports: [
      {
        code: "MGZ",
        name: "Myeik airport",
        chineseName: "美克机场",
        traditionalName: "美克機場",
      },
    ],
  },
  MHD: {
    code: "MHD",
    name: "MASHHAD",
    chineseName: "马什哈德",
    traditionalName: "馬什哈德",
    airports: [
      {
        code: "MHD",
        name: "Shahid hashemi nejad",
        chineseName: "马什哈德机场",
        traditionalName: "馬什哈德機場",
      },
    ],
  },
  MHH: {
    code: "MHH",
    name: "MARSH HARBOUR",
    chineseName: "马什港",
    traditionalName: "馬什港",
    airports: [
      {
        code: "MHH",
        name: "Marsh harbour airport",
        chineseName: "马什港国际机场",
        traditionalName: "馬什港國際機場",
      },
    ],
  },
  MHK: {
    code: "MHK",
    name: "MANHATTAN",
    chineseName: "曼哈顿",
    traditionalName: "曼哈頓",
    airports: [
      {
        code: "MHK",
        name: "Manhattan reg. airport",
        chineseName: "曼格顿地方机场",
        traditionalName: "曼格頓地方機場",
      },
    ],
  },
  MHM: {
    code: "MHM",
    name: "MALAITA",
    chineseName: "明丘米纳",
    traditionalName: "明丘米納",
    airports: [
      {
        code: "MHM",
        name: "Manaoba",
        chineseName: "明丘米纳机场",
        traditionalName: "明丘米納機場",
      },
    ],
  },
  MHQ: {
    code: "MHQ",
    name: "MARIEHAMN",
    chineseName: "玛丽港",
    traditionalName: "瑪麗港",
    airports: [
      {
        code: "MHQ",
        name: "Mariehamn airport",
        chineseName: "玛丽港机场",
        traditionalName: "瑪麗港機場",
      },
    ],
  },
  MHT: {
    code: "MHT",
    name: "MANCHESTER",
    chineseName: "曼彻斯特",
    traditionalName: "曼徹斯特",
    airports: [
      {
        code: "MHT",
        name: "Manchester-boston rgnl",
        chineseName: "波士顿地区机场",
        traditionalName: "波士頓地區機場",
      },
    ],
  },
  MIA: {
    code: "MIA",
    name: "MIAMI",
    chineseName: "迈阿密",
    traditionalName: "邁阿密",
    airports: [
      {
        code: "MIA",
        name: "Miami intl.",
        chineseName: "迈阿密国际机场",
        traditionalName: "邁阿密國際機場",
      },
      {
        code: "OPF",
        name: "Opa-locka executive",
        chineseName: "迈阿密机场",
        traditionalName: "邁阿密機場",
      },
    ],
  },
  MID: {
    code: "MID",
    name: "MERIDA",
    chineseName: "梅里达",
    traditionalName: "梅里達",
    airports: [
      {
        code: "MID",
        name: "M. crescencio rejon",
        chineseName: "曼努埃尔克雷森西奥雷洪国际机场",
        traditionalName: "曼努埃爾克雷森西奧雷洪國際機場",
      },
    ],
  },
  MIG: {
    code: "MIG",
    name: "MIANYANG",
    chineseName: "绵阳",
    traditionalName: "綿陽",
    airports: [
      {
        code: "MIG",
        name: "Nanjiao",
        chineseName: "南郊机场",
        traditionalName: "南郊機場",
      },
    ],
  },
  MII: {
    code: "MII",
    name: "MARILIA",
    chineseName: "马里利亚",
    traditionalName: "馬裏利亞",
    airports: [
      {
        code: "MII",
        name: "Frank m. milenkowichi",
        chineseName: "马里利亚机场",
        traditionalName: "馬裏利亞機場",
      },
    ],
  },
  MIJ: {
    code: "MIJ",
    name: "MILI ISLAND",
    chineseName: "米利岛",
    traditionalName: "米利島",
    airports: [
      {
        code: "MIJ",
        name: "Mili island airport",
        chineseName: "宫崎机场",
        traditionalName: "宮崎機場",
      },
    ],
  },
  MIL: {
    code: "MIL",
    name: "MILAN",
    chineseName: "米兰",
    traditionalName: "米蘭",
    airports: [
      {
        code: "BGY",
        name: "Bergamo/orio al serio",
        chineseName: "贝加莫机场",
        traditionalName: "貝加莫機場",
      },
      {
        code: "LIN",
        name: "Linate",
        chineseName: "利纳特机场",
        traditionalName: "利納特機場",
      },
      {
        code: "MXP",
        name: "Malpensa",
        chineseName: "马尔彭萨机场",
        traditionalName: "瑪律彭薩機場",
      },
      {
        code: "PMF",
        name: "Parma",
        chineseName: "帕尔马机场",
        traditionalName: "帕爾馬機場",
      },
    ],
  },
  MIM: {
    code: "MIM",
    name: "MERIMBULA",
    chineseName: "梅里姆布拉",
    traditionalName: "梅裏姆布拉",
    airports: [
      {
        code: "MIM",
        name: "Merimbula airport",
        chineseName: "默林布拉机场",
        traditionalName: "梅林布拉機場",
      },
    ],
  },
  MIR: {
    code: "MIR",
    name: "MONASTIR",
    chineseName: "莫纳斯提尔",
    traditionalName: "莫納斯提爾",
    airports: [
      {
        code: "MIR",
        name: "Habib bourguiba intl",
        chineseName: "哈比布布尔圭巴国际机场",
        traditionalName: "哈比布布林圭巴國際機場",
      },
    ],
  },
  MIS: {
    code: "MIS",
    name: "MISIMA ISLAND",
    chineseName: "米西马岛",
    traditionalName: "米西馬島",
    airports: [
      {
        code: "MIS",
        name: "Misima island airport",
        chineseName: "米西马岛机场",
        traditionalName: "米西馬島機場",
      },
    ],
  },
  MIU: {
    code: "MIU",
    name: "MAIDUGURI",
    chineseName: "迈杜古里",
    traditionalName: "邁杜古里",
    airports: [
      {
        code: "MIU",
        name: "Maiduguri intl.",
        chineseName: "迈杜古里国际机场",
        traditionalName: "邁杜古里國際機場",
      },
    ],
  },
  MJB: {
    code: "MJB",
    name: "MEJIT ISLAND",
    chineseName: "梅吉特岛",
    traditionalName: "梅吉特島",
    airports: [
      {
        code: "MJB",
        name: "Mejit island airport",
        chineseName: "梅吉特岛机场",
        traditionalName: "梅吉特島機場",
      },
    ],
  },
  MJC: {
    code: "MJC",
    name: "MAN",
    chineseName: "马恩",
    traditionalName: "馬恩",
    airports: [
      {
        code: "MJC",
        name: "Man airport",
        chineseName: "马恩机场",
        traditionalName: "馬恩機場",
      },
    ],
  },
  MJE: {
    code: "MJE",
    name: "MAJKIN",
    chineseName: "迈基金",
    traditionalName: "邁基金",
    airports: [
      {
        code: "MJE",
        name: "Majkin airport",
        chineseName: "迈基金机场",
        traditionalName: "邁基金機場",
      },
    ],
  },
  MJF: {
    code: "MJF",
    name: "MOSJOEN",
    chineseName: "莫舍恩",
    traditionalName: "莫舍恩",
    airports: [
      {
        code: "MJF",
        name: "Kjaerstad",
        chineseName: "喀加尔斯塔德机场",
        traditionalName: "喀加爾斯塔德機場",
      },
    ],
  },
  MJK: {
    code: "MJK",
    name: "MONKEY MIA",
    chineseName: "芒基米亚",
    traditionalName: "芒基米亞",
    airports: [
      {
        code: "MJK",
        name: "Shark bay",
        chineseName: "沙克贝机场",
        traditionalName: "沙克貝機場",
      },
    ],
  },
  MJM: {
    code: "MJM",
    name: "MBUJI-MAYI",
    chineseName: "姆布吉马伊",
    traditionalName: "姆布吉馬伊",
    airports: [
      {
        code: "MJM",
        name: "Mbuji-mayi airport",
        chineseName: "姆布吉马伊机场",
        traditionalName: "姆布吉馬伊機場",
      },
    ],
  },
  MJN: {
    code: "MJN",
    name: "MAHAJANGA",
    chineseName: "马贡加",
    traditionalName: "馬貢加",
    airports: [
      {
        code: "MJN",
        name: "Philibert tsiranana",
        chineseName: "阿姆博洛维机场",
        traditionalName: "阿姆博洛維機場",
      },
    ],
  },
  MJT: {
    code: "MJT",
    name: "MYTILINI",
    chineseName: "米蒂利尼",
    traditionalName: "米蒂利尼",
    airports: [
      {
        code: "MJT",
        name: "Odysseas elytis",
        chineseName: "米蒂利尼机场",
        traditionalName: "米蒂利尼機場",
      },
    ],
  },
  MJU: {
    code: "MJU",
    name: "MAMUJU",
    chineseName: "马穆朱",
    traditionalName: "馬穆朱",
    airports: [
      {
        code: "MJU",
        name: "Tampa padang",
        chineseName: "坦帕巴东机场",
        traditionalName: "坦帕巴東機場",
      },
    ],
  },
  MJV: {
    code: "MJV",
    name: "MURCIA",
    chineseName: "穆尔西亚",
    traditionalName: "穆爾西亞",
    airports: [
      {
        code: "RMU",
        name: "Intl region de murcia",
        chineseName: "穆尔西亚地区国际机场",
        traditionalName: "穆爾西亞地區國際機場",
      },
    ],
  },
  MJZ: {
    code: "MJZ",
    name: "MIRNY",
    chineseName: "米尔内",
    traditionalName: "米爾內",
    airports: [
      {
        code: "MJZ",
        name: "Mirny airport",
        chineseName: "米尔内机场",
        traditionalName: "米爾內機場",
      },
    ],
  },
  MKC: {
    code: "MKC",
    name: "KANSAS CITY",
    chineseName: "密苏里州堪萨斯",
    traditionalName: "密蘇里州堪薩斯",
    airports: [
      {
        code: "JCI",
        name: "New century aircenter",
        chineseName: "奥拉西机场",
        traditionalName: "奧拉西機場",
      },
      {
        code: "MCI",
        name: "Kansas city intl.",
        chineseName: "堪萨斯城国际机场",
        traditionalName: "坎薩斯城國際機場",
      },
      {
        code: "MKC",
        name: "C.b. wheeler downtown",
        chineseName: "堪萨斯城机场",
        traditionalName: "坎薩斯城機場",
      },
    ],
  },
  MKE: {
    code: "MKE",
    name: "MILWAUKEE",
    chineseName: "密尔沃基",
    traditionalName: "密爾沃基",
    airports: [
      {
        code: "MKE",
        name: "General mitchell intl",
        chineseName: "米歇尔将军国际机场",
        traditionalName: "蜜雪兒將軍國際機場",
      },
    ],
  },
  MKG: {
    code: "MKG",
    name: "MUSKEGON",
    chineseName: "马斯基根",
    traditionalName: "馬斯基根",
    airports: [
      {
        code: "MKG",
        name: "Muskegon county",
        chineseName: "马斯基根机场",
        traditionalName: "馬斯基根機場",
      },
    ],
  },
  MKK: {
    code: "MKK",
    name: "HOOLEHUA",
    chineseName: "霍奥莱胡阿",
    traditionalName: "霍奧萊胡阿",
    airports: [
      {
        code: "MKK",
        name: "Molokai",
        chineseName: "莫洛凯机场",
        traditionalName: "莫洛凱機場",
      },
    ],
  },
  MKL: {
    code: "MKL",
    name: "JACKSON",
    chineseName: "杰克逊市",
    traditionalName: "傑克遜市",
    airports: [
      {
        code: "MKL",
        name: "Mckellar-sipes rgnl",
        chineseName: "麦克拉尔机场",
        traditionalName: "麥克拉爾機場",
      },
    ],
  },
  MKM: {
    code: "MKM",
    name: "MUKAH",
    chineseName: "穆卡",
    traditionalName: "穆卡",
    airports: [
      {
        code: "MKM",
        name: "Mukah airport",
        chineseName: "穆卡机场",
        traditionalName: "穆卡機場",
      },
    ],
  },
  MKP: {
    code: "MKP",
    name: "MAKEMO",
    chineseName: "马凯莫",
    traditionalName: "馬凱莫",
    airports: [
      {
        code: "MKP",
        name: "Makemo airport",
        chineseName: "马凯莫机场",
        traditionalName: "馬凱莫機場",
      },
    ],
  },
  MKQ: {
    code: "MKQ",
    name: "MERAUKE",
    chineseName: "马老奇 ",
    traditionalName: "馬老奇",
    airports: [
      {
        code: "MKQ",
        name: "Mopah",
        chineseName: "莫帕赫机场",
        traditionalName: "莫帕赫機場",
      },
    ],
  },
  MKR: {
    code: "MKR",
    name: "MEEKATHARRA",
    chineseName: "米卡萨拉",
    traditionalName: "米卡薩拉",
    airports: [
      {
        code: "MKR",
        name: "Meekatharra airport",
        chineseName: "米卡萨拉机场",
        traditionalName: "米卡薩拉機場",
      },
    ],
  },
  MKW: {
    code: "MKW",
    name: "MANOKWARI",
    chineseName: "马诺夸里",
    traditionalName: "馬諾誇裡",
    airports: [
      {
        code: "MKW",
        name: "Rendani",
        chineseName: "雷恩达尼机场",
        traditionalName: "雷恩達尼機場",
      },
    ],
  },
  MKY: {
    code: "MKY",
    name: "MACKAY",
    chineseName: "麦凯",
    traditionalName: "麥凱",
    airports: [
      {
        code: "MKY",
        name: "Mackay airport",
        chineseName: "麦凯机场",
        traditionalName: "麥凱機場",
      },
    ],
  },
  MKZ: {
    code: "MKZ",
    name: "MALACCA",
    chineseName: "马六甲",
    traditionalName: "麻六甲",
    airports: [
      {
        code: "MKZ",
        name: "Malacca airport",
        chineseName: "马六甲机场",
        traditionalName: "麻六甲機場",
      },
    ],
  },
  MLA: {
    code: "MLA",
    name: "MALTA",
    chineseName: "马耳他",
    traditionalName: "馬爾他",
    airports: [
      {
        code: "MLA",
        name: "Luqa international",
        chineseName: "卢卡国际机场",
        traditionalName: "盧卡國際機場",
      },
    ],
  },
  MLB: {
    code: "MLB",
    name: "MELBOURNE",
    chineseName: "墨尔本",
    traditionalName: "墨爾本",
    airports: [
      {
        code: "MLB",
        name: "Melbourne orlando intl",
        chineseName: "墨尔本国际机场",
        traditionalName: "墨爾本國際機場",
      },
    ],
  },
  MLE: {
    code: "MLE",
    name: "MALE",
    chineseName: "马累",
    traditionalName: "馬累",
    airports: [
      {
        code: "MLE",
        name: "Velana international",
        chineseName: "马累国际机场",
        traditionalName: "馬累國際機場",
      },
    ],
  },
  MLG: {
    code: "MLG",
    name: "MALANG",
    chineseName: "玛琅",
    traditionalName: "瑪琅",
    airports: [
      {
        code: "MLG",
        name: "Abdul rachman saleh",
        chineseName: "阿卜杜勒拉赫曼萨利赫机场",
        traditionalName: "阿蔔杜勒拉赫曼薩利赫機場",
      },
    ],
  },
  MLI: {
    code: "MLI",
    name: "MOLINE",
    chineseName: "莫林",
    traditionalName: "莫林",
    airports: [
      {
        code: "MLI",
        name: "Quad city intl",
        chineseName: "库阿德城国际机场",
        traditionalName: "庫阿德城國際機場",
      },
    ],
  },
  MLL: {
    code: "MLL",
    name: "MARSHALL",
    chineseName: "阿拉斯加州马歇尔",
    traditionalName: "阿拉斯加州馬歇爾",
    airports: [
      {
        code: "MLL",
        name: "Don hunter sr.",
        chineseName: "唐猎高级机场",
        traditionalName: "唐獵高級機場",
      },
    ],
  },
  MLM: {
    code: "MLM",
    name: "MORELIA",
    chineseName: "莫雷利亚",
    traditionalName: "莫雷里亞",
    airports: [
      {
        code: "MLM",
        name: "F.j. mujica intl",
        chineseName: "弗朗西斯科穆希卡将军国际机场",
        traditionalName: "弗朗西斯科穆希卡將軍國際機場",
      },
    ],
  },
  MLN: {
    code: "MLN",
    name: "MELILLA",
    chineseName: "梅利利拉",
    traditionalName: "梅利利拉",
    airports: [
      {
        code: "MLN",
        name: "Melilla airport",
        chineseName: "梅利利拉机场",
        traditionalName: "梅利利拉機場",
      },
    ],
  },
  MLO: {
    code: "MLO",
    name: "MILOS",
    chineseName: "米洛斯",
    traditionalName: "米洛斯",
    airports: [
      {
        code: "MLO",
        name: "Milos airport",
        chineseName: "米洛斯岛机场",
        traditionalName: "米洛斯島機場",
      },
    ],
  },
  MLU: {
    code: "MLU",
    name: "MONROE",
    chineseName: "门罗",
    traditionalName: "門羅",
    airports: [
      {
        code: "MLU",
        name: "Monroe reg. airport",
        chineseName: "门罗地方机场",
        traditionalName: "門羅地方機場",
      },
    ],
  },
  MLW: {
    code: "MLW",
    name: "MONROVIA",
    chineseName: "蒙罗维亚",
    traditionalName: "蒙羅維亞",
    airports: [
      {
        code: "ROB",
        name: "Roberts intl",
        chineseName: "罗伯茨国际机场",
        traditionalName: "羅伯茨國際機場",
      },
    ],
  },
  MLX: {
    code: "MLX",
    name: "MALATYA",
    chineseName: "马拉蒂亚",
    traditionalName: "馬拉蒂亞",
    airports: [
      {
        code: "MLX",
        name: "Erhac",
        chineseName: "马拉提亚机场",
        traditionalName: "馬拉提亞機場",
      },
    ],
  },
  MLY: {
    code: "MLY",
    name: "MANLEY HOT SPRINGS",
    chineseName: "曼利赫特斯普林",
    traditionalName: "曼利赫特斯普林",
    airports: [
      {
        code: "MLY",
        name: "Manley hot springs airport",
        chineseName: "曼利温泉城机场",
        traditionalName: "曼利溫泉城機場",
      },
    ],
  },
  MMA: {
    code: "MMA",
    name: "MALMO",
    chineseName: "马尔默",
    traditionalName: "瑪律默",
    airports: [
      {
        code: "MMX",
        name: "Malmo intl.",
        chineseName: "马尔默机场",
        traditionalName: "瑪律默機場",
      },
    ],
  },
  MMB: {
    code: "MMB",
    name: "MEMANBETSU",
    chineseName: "女满别",
    traditionalName: "女滿別",
    airports: [
      {
        code: "MMB",
        name: "Memanbetsu airport",
        chineseName: "女满别机场",
        traditionalName: "女滿別機場",
      },
    ],
  },
  MMD: {
    code: "MMD",
    name: "MINAMIDAITO",
    chineseName: "南大东岛",
    traditionalName: "南大東島",
    airports: [
      {
        code: "MMD",
        name: "Minamidaito airport",
        chineseName: "南大东机场",
        traditionalName: "南大東機場",
      },
    ],
  },
  MME: {
    code: "MME",
    name: "TEESSIDE",
    chineseName: "达勒姆提斯瓦雷",
    traditionalName: "達勒姆提斯瓦雷",
    airports: [
      {
        code: "MME",
        name: "Teesside international",
        chineseName: "提斯瓦雷机场",
        traditionalName: "提斯瓦雷機場",
      },
    ],
  },
  MMG: {
    code: "MMG",
    name: "MOUNT MAGNET",
    chineseName: "芒特马格尼特",
    traditionalName: "芒特馬格尼特",
    airports: [
      {
        code: "MMG",
        name: "Mount magnet airport",
        chineseName: "芒特马格尼特机场",
        traditionalName: "芒特馬格尼特機場",
      },
    ],
  },
  MMH: {
    code: "MMH",
    name: "MAMMOTH LAKES",
    chineseName: "马姆莫斯湖",
    traditionalName: "馬姆莫斯湖",
    airports: [
      {
        code: "MMH",
        name: "Mammoth yosemite",
        chineseName: "马默斯约塞米蒂机场",
        traditionalName: "馬默斯約塞米蒂機場",
      },
    ],
  },
  MMJ: {
    code: "MMJ",
    name: "MATSUMOTO",
    chineseName: "松本",
    traditionalName: "松本",
    airports: [
      {
        code: "MMJ",
        name: "Matsumoto airport",
        chineseName: "松本机场",
        traditionalName: "松本機場",
      },
    ],
  },
  MMK: {
    code: "MMK",
    name: "MURMANSK",
    chineseName: "摩尔曼斯科",
    traditionalName: "摩爾曼斯科",
    airports: [
      {
        code: "MMK",
        name: "Murmansk airport",
        chineseName: "摩尔曼斯克机场",
        traditionalName: "摩爾曼斯克機場",
      },
    ],
  },
  MMO: {
    code: "MMO",
    name: "MAIO ISLAND",
    chineseName: "迈奥",
    traditionalName: "邁奧",
    airports: [
      {
        code: "MMO",
        name: "Maio island airport",
        chineseName: "马尤岛机场",
        traditionalName: "馬尤島機場",
      },
    ],
  },
  MMP: {
    code: "MMP",
    name: "MOMPOS",
    chineseName: "蒙波斯",
    traditionalName: "蒙波斯",
    airports: [
      {
        code: "MMP",
        name: "San bernardo",
        chineseName: "蒙波斯机场",
        traditionalName: "蒙波斯機場",
      },
    ],
  },
  MMU: {
    code: "MMU",
    name: "MORRISTOWN",
    chineseName: "莫里斯敦",
    traditionalName: "莫里斯敦",
    airports: [
      {
        code: "MMU",
        name: "Morristown municipal",
        chineseName: "莫里斯敦地方机场",
        traditionalName: "莫里斯敦地方機場",
      },
    ],
  },
  MMY: {
    code: "MMY",
    name: "MIYAKOJIMA",
    chineseName: "宫古",
    traditionalName: "宮古",
    airports: [
      {
        code: "MMY",
        name: "Miyako",
        chineseName: "宫古机场",
        traditionalName: "宮古機場",
      },
      {
        code: "SHI",
        name: "Shimojishima",
        chineseName: "下地岛机场",
        traditionalName: "下地島機場",
      },
    ],
  },
  MNA: {
    code: "MNA",
    name: "MELANGGUANE",
    chineseName: "梅兰瓜内",
    traditionalName: "梅蘭瓜內",
    airports: [
      {
        code: "MNA",
        name: "Melangguane airport",
        chineseName: "梅兰瓜内机场",
        traditionalName: "梅蘭瓜內機場",
      },
    ],
  },
  MNB: {
    code: "MNB",
    name: "MUANDA",
    chineseName: "莫安达",
    traditionalName: "莫安達",
    airports: [
      {
        code: "MNB",
        name: "Muanda airport",
        chineseName: "莫安达机场",
        traditionalName: "莫安達機場",
      },
    ],
  },
  MNC: {
    code: "MNC",
    name: "NACALA",
    chineseName: "纳卡拉",
    traditionalName: "納卡拉",
    airports: [
      {
        code: "MNC",
        name: "Nacala airport",
        chineseName: "纳卡拉机场",
        traditionalName: "納卡拉機場",
      },
    ],
  },
  MNG: {
    code: "MNG",
    name: "MANINGRIDA",
    chineseName: "马宁里达",
    traditionalName: "馬寧裏達",
    airports: [
      {
        code: "MNG",
        name: "Maningrida airport",
        chineseName: "马宁格里达机场",
        traditionalName: "馬寧格裏達機場",
      },
    ],
  },
  MNI: {
    code: "MNI",
    name: "MONTSERRAT",
    chineseName: "蒙特塞拉特",
    traditionalName: "蒙特塞拉特",
    airports: [
      {
        code: "MNI",
        name: "John a. osborne",
        chineseName: "约翰奥斯本机场",
        traditionalName: "約翰奧斯本機場",
      },
    ],
  },
  MNK: {
    code: "MNK",
    name: "MAIANA",
    chineseName: "迈亚纳环礁",
    traditionalName: "邁亞納環礁",
    airports: [
      {
        code: "MNK",
        name: "Maiana airport",
        chineseName: "马亚纳环礁机场",
        traditionalName: "馬亞納環礁機場",
      },
    ],
  },
  MNL: {
    code: "MNL",
    name: "MANILA",
    chineseName: "马尼拉",
    traditionalName: "馬尼拉",
    airports: [
      {
        code: "MNL",
        name: "Ninoy aquino intl",
        chineseName: "尼诺伊阿基诺国际机场",
        traditionalName: "尼諾伊阿基諾國際機場",
      },
    ],
  },
  MNO: {
    code: "MNO",
    name: "MANONO",
    chineseName: "马诺诺",
    traditionalName: "馬諾諾",
    airports: [
      {
        code: "MNO",
        name: "Manono airport",
        chineseName: "马诺诺机场",
        traditionalName: "馬諾諾機場",
      },
    ],
  },
  MNS: {
    code: "MNS",
    name: "MANSA",
    chineseName: "曼萨",
    traditionalName: "曼薩",
    airports: [
      {
        code: "MNS",
        name: "Mansa airport",
        chineseName: "曼萨机场",
        traditionalName: "曼薩機場",
      },
    ],
  },
  MNT: {
    code: "MNT",
    name: "MINTO",
    chineseName: "阿拉斯加州明托",
    traditionalName: "阿拉斯加州明托",
    airports: [
      {
        code: "MNT",
        name: "Al wright",
        chineseName: "阿尔莱特机场",
        traditionalName: "阿爾萊特機場",
      },
    ],
  },
  MNU: {
    code: "MNU",
    name: "MAWLAMYINE",
    chineseName: "毛淡棉",
    traditionalName: "毛淡棉",
    airports: [
      {
        code: "MNU",
        name: "Mawlamyine airport",
        chineseName: "毛淡棉机场",
        traditionalName: "毛淡棉機場",
      },
    ],
  },
  MNX: {
    code: "MNX",
    name: "MANICORE",
    chineseName: "马尼科雷",
    traditionalName: "馬尼科雷",
    airports: [
      {
        code: "MNX",
        name: "Manicore airport",
        chineseName: "马尼科雷机场",
        traditionalName: "馬尼科雷機場",
      },
    ],
  },
  MNY: {
    code: "MNY",
    name: "MONO ISLAND",
    chineseName: "莫诺",
    traditionalName: "莫諾",
    airports: [
      {
        code: "MNY",
        name: "Mono island airport",
        chineseName: "莫诺机场",
        traditionalName: "莫諾機場",
      },
    ],
  },
  MNZ: {
    code: "MNZ",
    name: "MANASSAS",
    chineseName: "马纳萨斯",
    traditionalName: "馬納薩斯",
    airports: [
      {
        code: "MNZ",
        name: "Manassas reg. airport",
        chineseName: "马纳萨斯机场",
        traditionalName: "馬納薩斯機場",
      },
    ],
  },
  MOA: {
    code: "MOA",
    name: "MOA",
    chineseName: "莫阿",
    traditionalName: "莫阿",
    airports: [
      {
        code: "MOA",
        name: "Orestes acosta",
        chineseName: "奥雷斯特斯－阿科斯塔机场",
        traditionalName: "奧雷斯特斯－阿科斯塔機場",
      },
    ],
  },
  MOB: {
    code: "MOB",
    name: "MOBILE",
    chineseName: "莫比尔",
    traditionalName: "莫比爾",
    airports: [
      {
        code: "BFM",
        name: "Downtown arpt",
        chineseName: "莫比尔机场",
        traditionalName: "莫比爾機場",
      },
      {
        code: "MOB",
        name: "Mobile reg. airport",
        chineseName: "莫比尔地方机场",
        traditionalName: "莫比爾地方機場",
      },
    ],
  },
  MOC: {
    code: "MOC",
    name: "MONTES CLAROS",
    chineseName: "蒙蒂斯克拉鲁斯",
    traditionalName: "蒙蒂斯克拉魯斯",
    airports: [
      {
        code: "MOC",
        name: "Mario ribeiro",
        chineseName: "蒙蒂斯克拉鲁斯机场",
        traditionalName: "蒙蒂斯克拉魯斯機場",
      },
    ],
  },
  MOF: {
    code: "MOF",
    name: "MAUMERE",
    chineseName: "毛梅雷",
    traditionalName: "毛梅雷",
    airports: [
      {
        code: "MOF",
        name: "Fransiskus x. seda",
        chineseName: "弗兰斯塞达机场",
        traditionalName: "弗蘭斯塞達機場",
      },
    ],
  },
  MOG: {
    code: "MOG",
    name: "MONG HSAT",
    chineseName: "孟萨",
    traditionalName: "孟薩",
    airports: [
      {
        code: "MOG",
        name: "Mong hsat airport",
        chineseName: "孟萨机场",
        traditionalName: "孟薩機場",
      },
    ],
  },
  MOH: {
    code: "MOH",
    name: "MOROWALI",
    chineseName: "莫罕巴里",
    traditionalName: "莫罕巴裏",
    airports: [
      {
        code: "MOH",
        name: "Morowali airport",
        chineseName: "莫罗瓦利机场",
        traditionalName: "莫羅瓦利機場",
      },
      {
        code: "MWS",
        name: "Bandara khusus imip",
        chineseName: "威尔逊山机场",
        traditionalName: "威爾遜山機場",
      },
    ],
  },
  MOL: {
    code: "MOL",
    name: "MOLDE",
    chineseName: "莫尔德",
    traditionalName: "莫爾德",
    airports: [
      {
        code: "MOL",
        name: "Aro",
        chineseName: "阿洛机场",
        traditionalName: "阿洛機場",
      },
    ],
  },
  MOO: {
    code: "MOO",
    name: "MOOMBA",
    chineseName: "穆巴",
    traditionalName: "穆巴",
    airports: [
      {
        code: "MOO",
        name: "Moomba airport",
        chineseName: "穆巴机场",
        traditionalName: "穆巴機場",
      },
    ],
  },
  MOQ: {
    code: "MOQ",
    name: "MORONDAVA",
    chineseName: "穆龙达瓦",
    traditionalName: "穆龍達瓦",
    airports: [
      {
        code: "MOQ",
        name: "Morondava airport",
        chineseName: "穆龙达瓦机场",
        traditionalName: "穆龍達瓦機場",
      },
    ],
  },
  MOT: {
    code: "MOT",
    name: "MINOT",
    chineseName: "米诺",
    traditionalName: "米諾",
    airports: [
      {
        code: "MOT",
        name: "Minot intl.",
        chineseName: "米诺国际机场",
        traditionalName: "米諾國際機場",
      },
    ],
  },
  MOU: {
    code: "MOU",
    name: "MOUNTAIN VILLAGE",
    chineseName: "阿拉斯加市山",
    traditionalName: "阿拉斯加市山",
    airports: [
      {
        code: "MOU",
        name: "Mountain village airport",
        chineseName: "芒廷瓦利基机场",
        traditionalName: "芒廷瓦利基機場",
      },
    ],
  },
  MOV: {
    code: "MOV",
    name: "MORANBAH",
    chineseName: "穆兰巴赫",
    traditionalName: "穆蘭巴赫",
    airports: [
      {
        code: "MOV",
        name: "Moranbah airport",
        chineseName: "穆兰巴赫机场",
        traditionalName: "穆蘭巴赫機場",
      },
    ],
  },
  MOW: {
    code: "MOW",
    name: "MOSCOW",
    chineseName: "莫斯科",
    traditionalName: "莫斯科",
    airports: [
      {
        code: "DME",
        name: "Domodedovo",
        chineseName: "德莫杰多沃国际机场",
        traditionalName: "德莫傑多沃國際機場",
      },
      {
        code: "SVO",
        name: "Sheremetyevo",
        chineseName: "谢列蔑契娃机场",
        traditionalName: "謝列蔑契娃機場",
      },
      {
        code: "VKO",
        name: "Vnukovo",
        chineseName: "伏努科沃机场",
        traditionalName: "伏努科沃機場",
      },
    ],
  },
  MOZ: {
    code: "MOZ",
    name: "MOOREA",
    chineseName: "莫雷阿",
    traditionalName: "莫雷阿",
    airports: [
      {
        code: "MOZ",
        name: "Temae",
        chineseName: "塔马埃机场",
        traditionalName: "塔馬埃機場",
      },
    ],
  },
  MPA: {
    code: "MPA",
    name: "KATIMA MULILO",
    chineseName: "姆巴查",
    traditionalName: "姆巴查",
    airports: [
      {
        code: "MPA",
        name: "Mpacha",
        chineseName: "姆巴查机场",
        traditionalName: "姆巴查機場",
      },
    ],
  },
  MPH: {
    code: "MPH",
    name: "CATICLAN",
    chineseName: "卡地克兰",
    traditionalName: "卡地克蘭",
    airports: [
      {
        code: "MPH",
        name: "Godofredo p. ramos",
        chineseName: "戈多弗雷多拉莫斯机场",
        traditionalName: "戈多弗雷多拉莫斯機場",
      },
    ],
  },
  MPL: {
    code: "MPL",
    name: "MONTPELLIER",
    chineseName: "蒙彼利埃",
    traditionalName: "蒙彼利埃",
    airports: [
      {
        code: "MPL",
        name: "Mediterranee",
        chineseName: "迈迪特雷尼机场",
        traditionalName: "邁迪特雷尼機場",
      },
    ],
  },
  MPM: {
    code: "MPM",
    name: "MAPUTO",
    chineseName: "马普托",
    traditionalName: "馬布多",
    airports: [
      {
        code: "MPM",
        name: "Maputo intl.",
        chineseName: "马普托国际机场",
        traditionalName: "馬布多國際機場",
      },
    ],
  },
  MPN: {
    code: "MPN",
    name: "MOUNT PLEASANT",
    chineseName: "芒特普莱森特",
    traditionalName: "芒特普萊森特",
    airports: [
      {
        code: "MPN",
        name: "Raf station",
        chineseName: "芒特普莱森特机场",
        traditionalName: "芒特普萊森特機場",
      },
    ],
  },
  MQF: {
    code: "MQF",
    name: "MAGNITOGORSK",
    chineseName: "马格尼托哥尔斯克",
    traditionalName: "馬格尼托哥爾斯克",
    airports: [
      {
        code: "MQF",
        name: "Magnitogorsk airport",
        chineseName: "马格尼托哥尔斯克机场",
        traditionalName: "馬格尼托哥爾斯克機場",
      },
    ],
  },
  MQJ: {
    code: "MQJ",
    name: "KHONU",
    chineseName: "克洪努",
    traditionalName: "克洪努",
    airports: [
      {
        code: "MQJ",
        name: "Moma",
        chineseName: "霍努机场",
        traditionalName: "霍努機場",
      },
    ],
  },
  MQL: {
    code: "MQL",
    name: "MILDURA",
    chineseName: "米尔杜拉",
    traditionalName: "米爾杜拉",
    airports: [
      {
        code: "MQL",
        name: "Mildura airport",
        chineseName: "米尔迪拉机场",
        traditionalName: "米爾迪拉機場",
      },
    ],
  },
  MQM: {
    code: "MQM",
    name: "MARDIN",
    chineseName: "马尔丁",
    traditionalName: "瑪律丁",
    airports: [
      {
        code: "MQM",
        name: "Mardin airport",
        chineseName: "马尔丁机场",
        traditionalName: "瑪律丁機場",
      },
    ],
  },
  MQN: {
    code: "MQN",
    name: "MO I RANA",
    chineseName: "摩城",
    traditionalName: "摩城",
    airports: [
      {
        code: "MQN",
        name: "Rossvoll",
        chineseName: "莫尔德机场",
        traditionalName: "莫爾德機場",
      },
    ],
  },
  MQS: {
    code: "MQS",
    name: "MUSTIQUE",
    chineseName: "马斯蒂克岛",
    traditionalName: "馬斯蒂克島",
    airports: [
      {
        code: "MQS",
        name: "Mustique airport",
        chineseName: "马斯蒂克岛机场",
        traditionalName: "馬斯蒂克島機場",
      },
    ],
  },
  MQT: {
    code: "MQT",
    name: "MARQUETTE",
    chineseName: "马凯特",
    traditionalName: "馬凱特",
    airports: [
      {
        code: "MQT",
        name: "Sawyer international",
        chineseName: "绍亚尔国际机场",
        traditionalName: "紹亞爾國際機場",
      },
    ],
  },
  MQX: {
    code: "MQX",
    name: "MEKELE",
    chineseName: "默克莱",
    traditionalName: "默克萊",
    airports: [
      {
        code: "MQX",
        name: "Alula aba nega",
        chineseName: "默克莱机场",
        traditionalName: "默克萊機場",
      },
    ],
  },
  MQY: {
    code: "MQY",
    name: "SMYRNA",
    chineseName: "士麦那",
    traditionalName: "士麥那",
    airports: [
      {
        code: "MQY",
        name: "Smyrna airport",
        chineseName: "土麦那机场",
        traditionalName: "土麥那機場",
      },
    ],
  },
  MRA: {
    code: "MRA",
    name: "MISURATA",
    chineseName: "米苏拉塔",
    traditionalName: "米蘇拉塔",
    airports: [
      {
        code: "MRA",
        name: "Misurata airport",
        chineseName: "米苏拉塔机场",
        traditionalName: "米蘇拉塔機場",
      },
    ],
  },
  MRE: {
    code: "MRE",
    name: "MAASAI MARA",
    chineseName: "马拉洛奇斯",
    traditionalName: "馬拉洛奇斯",
    airports: [
      {
        code: "ANA",
        name: "Angama",
        chineseName: "阿纳希姆机场",
        traditionalName: "阿納希姆機場",
      },
      {
        code: "HKR",
        name: "Mara north",
        chineseName: "马塞马拉机场",
        traditionalName: "馬塞馬拉機場",
      },
      {
        code: "KEU",
        name: "Keekorok",
        chineseName: "Keekorok机场",
        traditionalName: "KEEKOROK機場",
      },
      {
        code: "KTJ",
        name: "Kichwa tembo",
        chineseName: "科契瓦坦伯机场",
        traditionalName: "科契瓦坦伯機場",
      },
      {
        code: "MDR",
        name: "Musiara",
        chineseName: "梅德弗拉机场",
        traditionalName: "梅德弗拉機場",
      },
      {
        code: "MRE",
        name: "Mara serena",
        chineseName: "马拉洛奇机场",
        traditionalName: "馬拉洛奇機場",
      },
      {
        code: "OLG",
        name: "Olare",
        chineseName: "奥莱尔机场",
        traditionalName: "奧萊爾機場",
      },
      {
        code: "OLX",
        name: "Olkiombo",
        chineseName: "奥吉姆伯机场",
        traditionalName: "奧吉姆伯機場",
      },
      {
        code: "OSJ",
        name: "Ol seki",
        chineseName: "奥塞基机场",
        traditionalName: "奧塞基機場",
      },
    ],
  },
  MRG: {
    code: "MRG",
    name: "MAREEBA",
    chineseName: "马里巴",
    traditionalName: "馬裏巴",
    airports: [
      {
        code: "MRG",
        name: "Mareeba airport",
        chineseName: "马里巴机场",
        traditionalName: "馬裏巴機場",
      },
    ],
  },
  MRS: {
    code: "MRS",
    name: "MARSEILLE",
    chineseName: "马赛",
    traditionalName: "馬賽",
    airports: [
      {
        code: "MRS",
        name: "Provence",
        chineseName: "普罗旺斯机场",
        traditionalName: "普羅旺斯機場",
      },
    ],
  },
  MRU: {
    code: "MRU",
    name: "MAURITIUS",
    chineseName: "毛里求斯",
    traditionalName: "模裡西斯",
    airports: [
      {
        code: "MRU",
        name: "Sir s. ramgoolam intl",
        chineseName: "西沃萨古尔拉姆古兰爵士国际机场",
        traditionalName: "西沃薩古爾拉姆古蘭爵士國際機場",
      },
    ],
  },
  MRV: {
    code: "MRV",
    name: "MINERALNYE VODY",
    chineseName: "矿水城",
    traditionalName: "礦水城",
    airports: [
      {
        code: "MRV",
        name: "Mineralnye vody airport",
        chineseName: "米拉尔耶沃德机场",
        traditionalName: "米拉爾耶沃德機場",
      },
    ],
  },
  MRX: {
    code: "MRX",
    name: "BANDAR MAHSHAHR",
    chineseName: "马沙尔",
    traditionalName: "馬沙爾",
    airports: [
      {
        code: "MRX",
        name: "Mahshahr",
        chineseName: "马沙尔机场",
        traditionalName: "馬沙爾機場",
      },
    ],
  },
  MRY: {
    code: "MRY",
    name: "MONTEREY/CARMEL",
    chineseName: "蒙特雷",
    traditionalName: "蒙特雷",
    airports: [
      {
        code: "MRY",
        name: "Monterey regional",
        chineseName: "蒙特雷地区机场",
        traditionalName: "蒙特雷地區機場",
      },
    ],
  },
  MRZ: {
    code: "MRZ",
    name: "MOREE",
    chineseName: "莫里",
    traditionalName: "莫里",
    airports: [
      {
        code: "MRZ",
        name: "Moree airport",
        chineseName: "莫里机场",
        traditionalName: "莫里機場",
      },
    ],
  },
  MSA: {
    code: "MSA",
    name: "MUSKRAT DAM",
    chineseName: "马斯克拉特坝",
    traditionalName: "馬斯克拉特壩",
    airports: [
      {
        code: "MSA",
        name: "Muskrat dam airport",
        chineseName: "马斯克拉特坝机场",
        traditionalName: "馬斯克拉特壩機場",
      },
    ],
  },
  MSH: {
    code: "MSH",
    name: "MASIRAH",
    chineseName: "马西拉",
    traditionalName: "馬西拉",
    airports: [
      {
        code: "MSH",
        name: "Air base",
        chineseName: "马西拉岛机场",
        traditionalName: "馬西拉島機場",
      },
    ],
  },
  MSJ: {
    code: "MSJ",
    name: "MISAWA",
    chineseName: "三泽",
    traditionalName: "三澤",
    airports: [
      {
        code: "MSJ",
        name: "Misawa airport",
        chineseName: "三泽机场",
        traditionalName: "三澤機場",
      },
    ],
  },
  MSK: {
    code: "MSK",
    name: "PUERTO GAITAN",
    chineseName: "马什蒂斯珀特",
    traditionalName: "馬什蒂斯珀特",
    airports: [
      {
        code: "MSK",
        name: "Morelia",
        chineseName: "马什蒂斯珀特机场",
        traditionalName: "馬什蒂斯珀特機場",
      },
    ],
  },
  MSL: {
    code: "MSL",
    name: "MUSCLE SHOALS/FLORENCE",
    chineseName: "阿拉巴马",
    traditionalName: "阿拉巴馬",
    airports: [
      {
        code: "MSL",
        name: "Northwest alabama rgnl",
        chineseName: "西北阿拉巴马地区机场",
        traditionalName: "西北阿拉巴馬地區機場",
      },
    ],
  },
  MSN: {
    code: "MSN",
    name: "MADISON",
    chineseName: "麦迪逊",
    traditionalName: "麥迪遜",
    airports: [
      {
        code: "MSN",
        name: "Dane county regional",
        chineseName: "麦迪逊机场",
        traditionalName: "麥迪遜機場",
      },
    ],
  },
  MSO: {
    code: "MSO",
    name: "MISSOULA",
    chineseName: "米苏拉",
    traditionalName: "米蘇拉",
    airports: [
      {
        code: "MSO",
        name: "Missoula intl.",
        chineseName: "米苏拉国际机场",
        traditionalName: "米蘇拉國際機場",
      },
    ],
  },
  MSP: {
    code: "MSP",
    name: "MINNEAPOLIS/ST PAUL",
    chineseName: "明尼阿波利斯",
    traditionalName: "明尼阿波利斯",
    airports: [
      {
        code: "MSP",
        name: "Minneapolis/st paul intl.",
        chineseName: "圣保罗国际机场",
        traditionalName: "聖保羅國際機場",
      },
    ],
  },
  MSQ: {
    code: "MSQ",
    name: "MINSK",
    chineseName: "明斯克",
    traditionalName: "明斯克",
    airports: [
      {
        code: "MSQ",
        name: "Minsk intl.",
        chineseName: "明斯克国际机场",
        traditionalName: "明斯克國際機場",
      },
    ],
  },
  MSR: {
    code: "MSR",
    name: "MUS",
    chineseName: "穆什",
    traditionalName: "穆什",
    airports: [
      {
        code: "MSR",
        name: "Mus airport",
        chineseName: "穆什机场",
        traditionalName: "穆什機場",
      },
    ],
  },
  MSS: {
    code: "MSS",
    name: "MASSENA",
    chineseName: "马塞纳",
    traditionalName: "馬塞納",
    airports: [
      {
        code: "MSS",
        name: "Massena intl.",
        chineseName: "马塞纳国际机场",
        traditionalName: "馬塞納國際機場",
      },
    ],
  },
  MST: {
    code: "MST",
    name: "MAASTRICHT",
    chineseName: "马斯特里赫特",
    traditionalName: "馬斯垂克",
    airports: [
      {
        code: "MST",
        name: "Maastricht/aachen",
        chineseName: "马斯特里赫特亚琛机场",
        traditionalName: "馬斯垂克阿亨機場",
      },
    ],
  },
  MSU: {
    code: "MSU",
    name: "MASERU",
    chineseName: "马塞卢",
    traditionalName: "馬塞魯",
    airports: [
      {
        code: "MSU",
        name: "Moshoeshoe i intl",
        chineseName: "莫舒舒一世国际机场",
        traditionalName: "莫舒舒一世國際機場",
      },
    ],
  },
  MSY: {
    code: "MSY",
    name: "NEW ORLEANS",
    chineseName: "新奥尔良",
    traditionalName: "新奧爾良",
    airports: [
      {
        code: "MSY",
        name: "Louis armstrong intl",
        chineseName: "路易斯阿姆斯特朗国际机场",
        traditionalName: "路易斯阿姆斯特朗國際機場",
      },
    ],
  },
  MSZ: {
    code: "MSZ",
    name: "NAMIBE",
    chineseName: "纳米贝",
    traditionalName: "納米貝",
    airports: [
      {
        code: "MSZ",
        name: "Yuri gagarin",
        chineseName: "纳米布机场",
        traditionalName: "納米布機場",
      },
    ],
  },
  MTB: {
    code: "MTB",
    name: "MONTELIBANO",
    chineseName: "蒙特利瓦诺",
    traditionalName: "蒙特利瓦諾",
    airports: [
      {
        code: "MTB",
        name: "Montelibano airport",
        chineseName: "蒙特利巴诺机场",
        traditionalName: "蒙特利巴諾機場",
      },
    ],
  },
  MTJ: {
    code: "MTJ",
    name: "MONTROSE",
    chineseName: "蒙特罗斯",
    traditionalName: "蒙特羅斯",
    airports: [
      {
        code: "MTJ",
        name: "Montrose reg. airport",
        chineseName: "蒙特罗斯地区机场",
        traditionalName: "蒙特羅斯地區機場",
      },
    ],
  },
  MTK: {
    code: "MTK",
    name: "MAKIN",
    chineseName: "马金岛",
    traditionalName: "馬金島",
    airports: [
      {
        code: "MTK",
        name: "Makin airport",
        chineseName: "马金岛机场",
        traditionalName: "馬金島機場",
      },
    ],
  },
  MTM: {
    code: "MTM",
    name: "METLAKATLA",
    chineseName: "梅特拉卡特拉",
    traditionalName: "梅特拉卡特拉",
    airports: [
      {
        code: "MTM",
        name: "Sea plane base",
        chineseName: "梅特拉卡特拉水上飞机基地",
        traditionalName: "梅特拉卡特拉水上飛機基地",
      },
    ],
  },
  MTR: {
    code: "MTR",
    name: "MONTERIA",
    chineseName: "蒙特里亚",
    traditionalName: "蒙特裏亞",
    airports: [
      {
        code: "MTR",
        name: "Los garzones",
        chineseName: "蒙特里亚机场",
        traditionalName: "蒙特裏亞機場",
      },
    ],
  },
  MTS: {
    code: "MTS",
    name: "MANZINI",
    chineseName: " 曼齐尼",
    traditionalName: "曼齊尼",
    airports: [
      {
        code: "MTS",
        name: "Matsapha international",
        chineseName: "曼齐尼国际机场",
        traditionalName: "曼齊尼國際機場",
      },
      {
        code: "SHO",
        name: "King mswati iii intl",
        chineseName: "姆斯瓦蒂三世国际机场",
        traditionalName: "姆斯瓦蒂三世國際機場",
      },
    ],
  },
  MTT: {
    code: "MTT",
    name: "MINATITLAN",
    chineseName: "米纳蒂特兰",
    traditionalName: "米納蒂特蘭",
    airports: [
      {
        code: "MTT",
        name: "Coatzacoalcos",
        chineseName: "夸察夸尔科斯机场",
        traditionalName: "誇察誇爾科斯機場",
      },
    ],
  },
  MTV: {
    code: "MTV",
    name: "MOTA LAVA ISLAND",
    chineseName: "莫塔拉瓦",
    traditionalName: "莫塔拉瓦",
    airports: [
      {
        code: "MTV",
        name: "Mota lava island airport",
        chineseName: "莫塔拉瓦机场",
        traditionalName: "莫塔拉瓦機場",
      },
    ],
  },
  MTY: {
    code: "MTY",
    name: "MONTERREY",
    chineseName: "蒙特雷",
    traditionalName: "蒙特雷",
    airports: [
      {
        code: "MTY",
        name: "Mariano escobedo intl",
        chineseName: "马里阿诺埃斯科贝多将军机场",
        traditionalName: "馬利阿諾埃斯科貝多將軍機場",
      },
    ],
  },
  MUA: {
    code: "MUA",
    name: "MUNDA",
    chineseName: "蒙达",
    traditionalName: "蒙達",
    airports: [
      {
        code: "MUA",
        name: "Munda airport",
        chineseName: "蒙达机场",
        traditionalName: "蒙達機場",
      },
    ],
  },
  MUB: {
    code: "MUB",
    name: "MAUN",
    chineseName: "马翁",
    traditionalName: "馬翁",
    airports: [
      {
        code: "MUB",
        name: "Maun airport",
        chineseName: "马翁机场",
        traditionalName: "馬翁機場",
      },
    ],
  },
  MUC: {
    code: "MUC",
    name: "MUNICH",
    chineseName: "慕尼黑",
    traditionalName: "慕尼克",
    airports: [
      {
        code: "MUC",
        name: "Munich intl.",
        chineseName: "慕尼黑机场",
        traditionalName: "慕尼克機場",
      },
    ],
  },
  MUD: {
    code: "MUD",
    name: "MUEDA",
    chineseName: "穆埃达",
    traditionalName: "穆艾達",
    airports: [
      {
        code: "MUD",
        name: "Mueda airport",
        chineseName: "穆埃达机场",
        traditionalName: "穆艾達機場",
      },
    ],
  },
  MUE: {
    code: "MUE",
    name: "KAMUELA",
    chineseName: "卡姆艾拉",
    traditionalName: "卡姆艾拉",
    airports: [
      {
        code: "MUE",
        name: "Waimea-kohala",
        chineseName: "怀梅阿机场",
        traditionalName: "懷梅阿機場",
      },
    ],
  },
  MUN: {
    code: "MUN",
    name: "MATURIN",
    chineseName: "马图林",
    traditionalName: "馬圖林",
    airports: [
      {
        code: "MUN",
        name: "Jose t. monagas intl",
        chineseName: "何塞塔德奥莫纳加斯国际机场",
        traditionalName: "何塞塔德奧莫納加斯國際機場",
      },
    ],
  },
  MUR: {
    code: "MUR",
    name: "MARUDI",
    chineseName: "马鲁迪",
    traditionalName: "馬魯迪",
    airports: [
      {
        code: "MUR",
        name: "Marudi airport",
        chineseName: "马鲁迪机场",
        traditionalName: "馬魯迪機場",
      },
    ],
  },
  MUU: {
    code: "MUU",
    name: "MARAU",
    chineseName: "宾夕法尼亚州联合山",
    traditionalName: "賓夕法尼亞州聯合山",
    airports: [
      {
        code: "MUU",
        name: "Marau barra grande",
        chineseName: "芒特尤宁机场",
        traditionalName: "芒特尤寧機場",
      },
    ],
  },
  MUX: {
    code: "MUX",
    name: "MULTAN",
    chineseName: "木尔坦",
    traditionalName: "木爾坦",
    airports: [
      {
        code: "MUX",
        name: "Multan intl.",
        chineseName: "木尔坦机场",
        traditionalName: "木爾坦機場",
      },
    ],
  },
  MUZ: {
    code: "MUZ",
    name: "MUSOMA",
    chineseName: "穆索马",
    traditionalName: "穆索馬",
    airports: [
      {
        code: "MUZ",
        name: "Musoma airport",
        chineseName: "穆索马机场",
        traditionalName: "穆索馬機場",
      },
    ],
  },
  MVB: {
    code: "MVB",
    name: "FRANCEVILLE",
    chineseName: "弗朗斯维尔",
    traditionalName: "弗朗斯維爾",
    airports: [
      {
        code: "MVB",
        name: "Mvengue",
        chineseName: "蒙格机场",
        traditionalName: "蒙格機場",
      },
    ],
  },
  MVD: {
    code: "MVD",
    name: "MONTEVIDEO",
    chineseName: "蒙得维的亚",
    traditionalName: "蒙特維多",
    airports: [
      {
        code: "MVD",
        name: "Carrasco",
        chineseName: "卡拉斯科国际机场",
        traditionalName: "卡拉斯科國際機場",
      },
    ],
  },
  MVF: {
    code: "MVF",
    name: "MOSSORO",
    chineseName: "莫索罗",
    traditionalName: "莫索羅",
    airports: [
      {
        code: "MVF",
        name: "Dix-sept rosado",
        chineseName: "莫索罗机场",
        traditionalName: "莫索羅機場",
      },
    ],
  },
  MVP: {
    code: "MVP",
    name: "MITU",
    chineseName: "米图",
    traditionalName: "米圖",
    airports: [
      {
        code: "MVP",
        name: "Fabio a. leon bentley",
        chineseName: "米图机场",
        traditionalName: "米圖機場",
      },
    ],
  },
  MVR: {
    code: "MVR",
    name: "MAROUA",
    chineseName: "马鲁阿",
    traditionalName: "馬魯阿",
    airports: [
      {
        code: "MVR",
        name: "Salak",
        chineseName: "萨拉姆机场",
        traditionalName: "薩拉姆機場",
      },
    ],
  },
  MVT: {
    code: "MVT",
    name: "MATAIVA",
    chineseName: "马塔伊瓦",
    traditionalName: "馬塔伊瓦",
    airports: [
      {
        code: "MVT",
        name: "Mataiva airport",
        chineseName: "马塔伊瓦机场",
        traditionalName: "馬塔伊瓦機場",
      },
    ],
  },
  MVY: {
    code: "MVY",
    name: "MARTHA'S VINEYARD",
    chineseName: "马撒葡萄园岛",
    traditionalName: "馬撒葡萄園島",
    airports: [
      {
        code: "MVY",
        name: "Martha's vineyard airport",
        chineseName: "马萨葡萄园机场",
        traditionalName: "馬薩葡萄園機場",
      },
    ],
  },
  MWA: {
    code: "MWA",
    name: "MARION",
    chineseName: "马里恩",
    traditionalName: "馬里恩",
    airports: [
      {
        code: "MWA",
        name: "Veterans southern il.",
        chineseName: "威廉姆森郡机场",
        traditionalName: "威廉姆森郡機場",
      },
    ],
  },
  MWF: {
    code: "MWF",
    name: "MAEWO ISLAND",
    chineseName: "梅窝",
    traditionalName: "梅窩",
    airports: [
      {
        code: "MWF",
        name: "Naone",
        chineseName: "迈沃岛机场",
        traditionalName: "邁沃島機場",
      },
    ],
  },
  MWK: {
    code: "MWK",
    name: "MATAK",
    chineseName: "马塔克",
    traditionalName: "馬塔克",
    airports: [
      {
        code: "MWK",
        name: "Tarempa",
        chineseName: "马塔克机场",
        traditionalName: "馬塔克機場",
      },
    ],
  },
  MWX: {
    code: "MWX",
    name: "MUAN",
    chineseName: "光州",
    traditionalName: "光州",
    airports: [
      {
        code: "MWX",
        name: "Muan intl.",
        chineseName: "务安国际机场",
        traditionalName: "務安國際機場",
      },
    ],
  },
  MWZ: {
    code: "MWZ",
    name: "MWANZA",
    chineseName: "姆万扎",
    traditionalName: "姆萬扎",
    airports: [
      {
        code: "MWZ",
        name: "Mwanza airport",
        chineseName: "姆万扎机场",
        traditionalName: "姆萬扎機場",
      },
    ],
  },
  MXH: {
    code: "MXH",
    name: "MORO",
    chineseName: "莫罗",
    traditionalName: "莫洛",
    airports: [
      {
        code: "MXH",
        name: "Moro airport",
        chineseName: "莫罗机场",
        traditionalName: "莫洛機場",
      },
    ],
  },
  MXL: {
    code: "MXL",
    name: "MEXICALI",
    chineseName: "墨西卡利",
    traditionalName: "墨西卡里",
    airports: [
      {
        code: "MXL",
        name: "R.sanchez taboada int",
        chineseName: "鲁道夫桑切斯将军国际机场",
        traditionalName: "魯道夫桑切斯將軍國際機場",
      },
    ],
  },
  MXQ: {
    code: "MXQ",
    name: "CAIRU",
    chineseName: "米切尔里弗",
    traditionalName: "米切爾裏弗",
    airports: [
      {
        code: "MXQ",
        name: "Lorenzo",
        chineseName: "米切尔里弗机场",
        traditionalName: "米切爾裏弗機場",
      },
      {
        code: "PBA",
        name: "Cav. lav. fabio perini",
        chineseName: "巴罗角机场",
        traditionalName: "巴羅角機場",
      },
    ],
  },
  MXV: {
    code: "MXV",
    name: "MORON",
    chineseName: "莫龙",
    traditionalName: "莫龍",
    airports: [
      {
        code: "MXV",
        name: "Moron airport",
        chineseName: "木伦机场",
        traditionalName: "木倫機場",
      },
    ],
  },
  MXX: {
    code: "MXX",
    name: "MORA",
    chineseName: "穆拉",
    traditionalName: "穆拉",
    airports: [
      {
        code: "MXX",
        name: "Siljan",
        chineseName: "锡利扬机场",
        traditionalName: "錫利揚機場",
      },
    ],
  },
  MXY: {
    code: "MXY",
    name: "MCCARTHY",
    chineseName: "阿拉斯加州麦卡锡",
    traditionalName: "阿拉斯加州麥卡錫",
    airports: [
      {
        code: "MXY",
        name: "Mccarthy airport",
        chineseName: "麦卡锡机场",
        traditionalName: "麥卡錫機場",
      },
    ],
  },
  MXZ: {
    code: "MXZ",
    name: "MEIXIAN",
    chineseName: "梅县",
    traditionalName: "梅縣",
    airports: [
      {
        code: "MXZ",
        name: "Meixian airport",
        chineseName: "梅县机场",
        traditionalName: "梅縣機場",
      },
    ],
  },
  MYA: {
    code: "MYA",
    name: "MORUYA",
    chineseName: "莫鲁亚",
    traditionalName: "莫魯亞",
    airports: [
      {
        code: "MYA",
        name: "Moruya airport",
        chineseName: "莫鲁亚机场",
        traditionalName: "莫魯亞機場",
      },
    ],
  },
  MYD: {
    code: "MYD",
    name: "MALINDI",
    chineseName: "马林迪",
    traditionalName: "馬林迪",
    airports: [
      {
        code: "MYD",
        name: "Malindi airport",
        chineseName: "马林迪机场",
        traditionalName: "馬林迪機場",
      },
    ],
  },
  MYE: {
    code: "MYE",
    name: "MIYAKEJIMA",
    chineseName: "三宅岛",
    traditionalName: "三宅島",
    airports: [
      {
        code: "MYE",
        name: "Miyakejima airport",
        chineseName: "三宅岛机场",
        traditionalName: "三宅島機場",
      },
    ],
  },
  MYG: {
    code: "MYG",
    name: "MAYAGUANA",
    chineseName: "马亚瓜纳",
    traditionalName: "馬亞瓜納",
    airports: [
      {
        code: "MYG",
        name: "Mayaguana airport",
        chineseName: "马亚瓜纳机场",
        traditionalName: "馬亞瓜納機場",
      },
    ],
  },
  MYI: {
    code: "MYI",
    name: "MURRAY ISLAND",
    chineseName: "默里岛",
    traditionalName: "默里島",
    airports: [
      {
        code: "MYI",
        name: "Murray island airport",
        chineseName: "默里岛机场",
        traditionalName: "默里島機場",
      },
    ],
  },
  MYJ: {
    code: "MYJ",
    name: "MATSUYAMA",
    chineseName: "松山",
    traditionalName: "松山",
    airports: [
      {
        code: "MYJ",
        name: "Matsuyama airport",
        chineseName: "松山机场",
        traditionalName: "松山機場",
      },
    ],
  },
  MYK: {
    code: "MYK",
    name: "MAY CREEK",
    chineseName: "梅克里克",
    traditionalName: "梅克裏克",
    airports: [
      {
        code: "MYK",
        name: "May creek airport",
        chineseName: "梅克里克机场",
        traditionalName: "梅克裏克機場",
      },
    ],
  },
  MYP: {
    code: "MYP",
    name: "MARY",
    chineseName: "马雷",
    traditionalName: "馬雷",
    airports: [
      {
        code: "MYP",
        name: "Mary airport",
        chineseName: "马雷机场",
        traditionalName: "馬雷機場",
      },
    ],
  },
  MYQ: {
    code: "MYQ",
    name: "MYSORE",
    chineseName: "迈索尔",
    traditionalName: "邁索爾",
    airports: [
      {
        code: "MYQ",
        name: "Mandakalli",
        chineseName: "迈索尔机场",
        traditionalName: "邁索爾機場",
      },
    ],
  },
  MYR: {
    code: "MYR",
    name: "MYRTLE BEACH",
    chineseName: "默特尔比奇",
    traditionalName: "默特爾比奇",
    airports: [
      {
        code: "MYR",
        name: "Myrtle beach intl.",
        chineseName: "默特尔比奇国际机场",
        traditionalName: "默特爾比奇國際機場",
      },
    ],
  },
  MYT: {
    code: "MYT",
    name: "MYITKYINA",
    chineseName: "密支那",
    traditionalName: "密支那",
    airports: [
      {
        code: "MYT",
        name: "Myitkyina airport",
        chineseName: "密支那机场",
        traditionalName: "密支那機場",
      },
    ],
  },
  MYU: {
    code: "MYU",
    name: "MEKORYUK",
    chineseName: "Mekoryuk，阿拉斯加",
    traditionalName: "Mekoryuk， 阿拉斯加",
    airports: [
      {
        code: "MYU",
        name: "Mekoryuk airport",
        chineseName: "梅科尤克机场",
        traditionalName: "梅科尤克機場",
      },
    ],
  },
  MYW: {
    code: "MYW",
    name: "MTWARA",
    chineseName: "姆特瓦拉",
    traditionalName: "姆特瓦拉",
    airports: [
      {
        code: "MYW",
        name: "Mtwara airport",
        chineseName: "姆特瓦拉机场",
        traditionalName: "姆特瓦拉機場",
      },
    ],
  },
  MYY: {
    code: "MYY",
    name: "MIRI",
    chineseName: "美里",
    traditionalName: "美裡",
    airports: [
      {
        code: "MYY",
        name: "Miri airport",
        chineseName: "米里机场",
        traditionalName: "米裏機場",
      },
    ],
  },
  MZA: {
    code: "MZA",
    name: "MAZAMARI",
    chineseName: "穆扎法尔讷格尔",
    traditionalName: "穆紮法爾訥格爾",
    airports: [
      {
        code: "MZA",
        name: "Manuel prado",
        chineseName: "穆扎法尔讷格尔机场",
        traditionalName: "穆紮法爾訥格爾機場",
      },
    ],
  },
  MZG: {
    code: "MZG",
    name: "PENGHU",
    chineseName: "马公",
    traditionalName: "馬公",
    airports: [
      {
        code: "MZG",
        name: "Penghu airport",
        chineseName: "马公机场",
        traditionalName: "馬公機場",
      },
    ],
  },
  MZH: {
    code: "MZH",
    name: "AMASYA",
    chineseName: "梅尔济丰",
    traditionalName: "梅爾濟豐",
    airports: [
      {
        code: "MZH",
        name: "Merzifon",
        chineseName: "梅尔济丰机场",
        traditionalName: "梅爾濟豐機場",
      },
    ],
  },
  MZK: {
    code: "MZK",
    name: "MARAKEI",
    chineseName: "马拉凯环礁",
    traditionalName: "馬拉凱環礁",
    airports: [
      {
        code: "MZK",
        name: "Marakei airport",
        chineseName: "马拉凯伊机场",
        traditionalName: "馬拉凱伊機場",
      },
    ],
  },
  MZL: {
    code: "MZL",
    name: "MANIZALES",
    chineseName: "马尼萨莱斯",
    traditionalName: "馬尼薩萊斯",
    airports: [
      {
        code: "MZL",
        name: "La nubia",
        chineseName: "努比亚机场",
        traditionalName: "努比亞機場",
      },
    ],
  },
  MZO: {
    code: "MZO",
    name: "MANZANILLO",
    chineseName: "曼萨尼约",
    traditionalName: "曼薩尼尤",
    airports: [
      {
        code: "MZO",
        name: "Sierra maestra",
        chineseName: "希拉马埃斯特拉机场",
        traditionalName: "希拉馬埃斯特拉機場",
      },
    ],
  },
  MZR: {
    code: "MZR",
    name: "MAZAR-E SHARIF",
    chineseName: "马扎里沙里夫",
    traditionalName: "馬紮裡沙裡夫",
    airports: [
      {
        code: "MZR",
        name: "Mazar-e sharif airport",
        chineseName: "马扎里沙里夫机场",
        traditionalName: "馬紮裡沙裡夫機場",
      },
    ],
  },
  MZS: {
    code: "MZS",
    name: "MORADABAD",
    chineseName: "莫斯廷",
    traditionalName: "莫斯廷",
    airports: [
      {
        code: "MZS",
        name: "Moradabad airport",
        chineseName: "莫斯廷机场",
        traditionalName: "莫斯廷機場",
      },
    ],
  },
  MZT: {
    code: "MZT",
    name: "MAZATLAN",
    chineseName: "马萨特兰",
    traditionalName: "馬薩特蘭",
    airports: [
      {
        code: "MZT",
        name: "Rafael buelna intl",
        chineseName: "拉法尔布埃尔纳将军国际机场",
        traditionalName: "拉法爾布埃爾納將軍國際機場",
      },
    ],
  },
  MZV: {
    code: "MZV",
    name: "MULU",
    chineseName: "姆鲁",
    traditionalName: "姆魯",
    airports: [
      {
        code: "MZV",
        name: "Mulu airport",
        chineseName: "姆鲁机场",
        traditionalName: "姆魯機場",
      },
    ],
  },
  MZW: {
    code: "MZW",
    name: "MECHERIA",
    chineseName: "迈舍里耶",
    traditionalName: "邁舍裏耶",
    airports: [
      {
        code: "MZW",
        name: "Mecheria airport",
        chineseName: "迈舍里耶机场",
        traditionalName: "邁舍裏耶機場",
      },
    ],
  },
  NAA: {
    code: "NAA",
    name: "NARRABRI",
    chineseName: "纳拉布莱",
    traditionalName: "納拉布萊",
    airports: [
      {
        code: "NAA",
        name: "Narrabri airport",
        chineseName: "纳拉布莱机场",
        traditionalName: "納拉布萊機場",
      },
    ],
  },
  NAG: {
    code: "NAG",
    name: "NAGPUR",
    chineseName: "那格浦尔",
    traditionalName: "那格浦爾",
    airports: [
      {
        code: "NAG",
        name: "Dr.ambedkar intl",
        chineseName: "索内加昂国际机场",
        traditionalName: "索內加昂國際機場",
      },
    ],
  },
  NAH: {
    code: "NAH",
    name: "TAHUNA",
    chineseName: "塔胡纳",
    traditionalName: "塔胡納",
    airports: [
      {
        code: "NAH",
        name: "Naha",
        chineseName: "那霸机场",
        traditionalName: "那霸機場",
      },
    ],
  },
  NAJ: {
    code: "NAJ",
    name: "NAKCHIVAN",
    chineseName: "纳希切万",
    traditionalName: "納希切萬",
    airports: [
      {
        code: "NAJ",
        name: "Nakchivan airport",
        chineseName: "纳西切万机场",
        traditionalName: "納西切萬機場",
      },
    ],
  },
  NAL: {
    code: "NAL",
    name: "NALCHIK",
    chineseName: "纳尔奇克",
    traditionalName: "納爾奇克",
    airports: [
      {
        code: "NAL",
        name: "Nalchik airport",
        chineseName: "纳尔奇克机场",
        traditionalName: "納爾奇克機場",
      },
    ],
  },
  NAM: {
    code: "NAM",
    name: "NAMLEA",
    chineseName: "楠勒阿",
    traditionalName: "楠勒阿",
    airports: [
      {
        code: "NAM",
        name: "Namlea airport",
        chineseName: "楠勒阿机场",
        traditionalName: "楠勒阿機場",
      },
    ],
  },
  NAN: {
    code: "NAN",
    name: "NADI",
    chineseName: "楠迪",
    traditionalName: "楠迪",
    airports: [
      {
        code: "NAN",
        name: "Nadi intl.",
        chineseName: "楠迪国际机场",
        traditionalName: "楠迪國際機場",
      },
    ],
  },
  NAO: {
    code: "NAO",
    name: "NANCHONG",
    chineseName: "南充",
    traditionalName: "南充",
    airports: [
      {
        code: "NAO",
        name: "Gaoping",
        chineseName: "高坪机场",
        traditionalName: "高坪機場",
      },
    ],
  },
  NAP: {
    code: "NAP",
    name: "NAPLES",
    chineseName: "那不勒斯",
    traditionalName: "那不勒斯",
    airports: [
      {
        code: "NAP",
        name: "Capodichino",
        chineseName: "那不勒斯机场",
        traditionalName: "那不勒斯機場",
      },
    ],
  },
  NAQ: {
    code: "NAQ",
    name: "QAANAAQ",
    chineseName: "恰纳克",
    traditionalName: "恰納克",
    airports: [
      {
        code: "NAQ",
        name: "Qaanaaq airport",
        chineseName: "恰纳克机场",
        traditionalName: "恰納克機場",
      },
    ],
  },
  NAS: {
    code: "NAS",
    name: "NASSAU",
    chineseName: "拿骚",
    traditionalName: "拿索",
    airports: [
      {
        code: "NAS",
        name: "Lynden pindling intl",
        chineseName: "林丁平德林国际机场",
        traditionalName: "林丁平德林國際機場",
      },
    ],
  },
  NAT: {
    code: "NAT",
    name: "NATAL",
    chineseName: "纳塔尔",
    traditionalName: "納塔爾",
    airports: [
      {
        code: "NAT",
        name: "Natal intl.",
        chineseName: "奥古斯托塞佛洛机场",
        traditionalName: "奧古斯托塞佛洛機場",
      },
    ],
  },
  NAU: {
    code: "NAU",
    name: "NAPUKA",
    chineseName: "纳普卡岛",
    traditionalName: "納普卡島",
    airports: [
      {
        code: "NAU",
        name: "Napuka airport",
        chineseName: "纳普卡岛机场",
        traditionalName: "納普卡島機場",
      },
    ],
  },
  NAV: {
    code: "NAV",
    name: "NEVSEHIR",
    chineseName: "内夫谢希尔",
    traditionalName: "內夫謝希爾",
    airports: [
      {
        code: "NAV",
        name: "Kapadokya",
        chineseName: "卡帕多奇亚机场",
        traditionalName: "卡帕多奇亞機場",
      },
    ],
  },
  NAW: {
    code: "NAW",
    name: "NARATHIWAT",
    chineseName: "那拉提瓦",
    traditionalName: "那拉提瓦",
    airports: [
      {
        code: "NAW",
        name: "Narathiwat airport",
        chineseName: "奈良机场",
        traditionalName: "奈良機場",
      },
    ],
  },
  NBC: {
    code: "NBC",
    name: "NIZHNEKAMSK",
    chineseName: "卡马河畔切尔尼",
    traditionalName: "卡馬河畔切爾尼",
    airports: [
      {
        code: "NBC",
        name: "Begishevo",
        chineseName: "别吉舍沃机场",
        traditionalName: "別吉舍沃機場",
      },
    ],
  },
  NBE: {
    code: "NBE",
    name: "ENFIDHA",
    chineseName: "安菲达",
    traditionalName: "安菲達",
    airports: [
      {
        code: "NBE",
        name: "Hammamet",
        chineseName: "哈马马特机场",
        traditionalName: "哈馬馬特機場",
      },
    ],
  },
  NBO: {
    code: "NBO",
    name: "NAIROBI",
    chineseName: "内罗毕",
    traditionalName: "奈洛比",
    airports: [
      {
        code: "NBO",
        name: "Jomo kenyatta intl",
        chineseName: "内罗毕机场",
        traditionalName: "奈洛比機場",
      },
      {
        code: "WIL",
        name: "Wilson",
        chineseName: "维尔森机场",
        traditionalName: "維爾森機場",
      },
    ],
  },
  NBS: {
    code: "NBS",
    name: "BAISHAN",
    chineseName: "白山",
    traditionalName: "白山",
    airports: [
      {
        code: "NBS",
        name: "Changbaishan",
        chineseName: "长白山机场",
        traditionalName: "長白山機場",
      },
    ],
  },
  NBX: {
    code: "NBX",
    name: "NABIRE",
    chineseName: "纳比雷",
    traditionalName: "納比雷",
    airports: [
      {
        code: "NBX",
        name: "Nabire airport",
        chineseName: "纳比雷机场",
        traditionalName: "納比雷機場",
      },
    ],
  },
  NCE: {
    code: "NCE",
    name: "NICE",
    chineseName: "尼斯",
    traditionalName: "尼斯",
    airports: [
      {
        code: "NCE",
        name: "Cote d'azur",
        chineseName: "克特阿祖尔机场",
        traditionalName: "克特阿祖爾機場",
      },
    ],
  },
  NCL: {
    code: "NCL",
    name: "NEWCASTLE",
    chineseName: "纽卡斯尔",
    traditionalName: "紐卡斯爾",
    airports: [
      {
        code: "NCL",
        name: "Newcastle intl.",
        chineseName: "纽卡斯尔国际机场",
        traditionalName: "紐卡斯爾國際機場",
      },
    ],
  },
  NCN: {
    code: "NCN",
    name: "CHENEGA",
    chineseName: "阿拉斯加州新切内加",
    traditionalName: "阿拉斯加州新切內加",
    airports: [
      {
        code: "NCN",
        name: "Chenega bay",
        chineseName: "新彻讷加机场",
        traditionalName: "新徹訥加機場",
      },
    ],
  },
  NCU: {
    code: "NCU",
    name: "NUKUS",
    chineseName: "努库斯",
    traditionalName: "努庫斯",
    airports: [
      {
        code: "NCU",
        name: "Nukus airport",
        chineseName: "努库斯机场",
        traditionalName: "努庫斯機場",
      },
    ],
  },
  NCY: {
    code: "NCY",
    name: "ANNECY",
    chineseName: "阿讷西",
    traditionalName: "阿納西",
    airports: [
      {
        code: "NCY",
        name: "Meythet",
        chineseName: "阿内西机场",
        traditionalName: "阿內西機場",
      },
    ],
  },
  NDB: {
    code: "NDB",
    name: "NOUADHIBOU",
    chineseName: "努瓦迪布",
    traditionalName: "努瓦迪布",
    airports: [
      {
        code: "NDB",
        name: "Nouadhibou airport",
        chineseName: "努瓦迪布机场",
        traditionalName: "努瓦迪布機場",
      },
    ],
  },
  NDC: {
    code: "NDC",
    name: "NANDED",
    chineseName: "楠代德",
    traditionalName: "楠代德",
    airports: [
      {
        code: "NDC",
        name: "Nanded airport",
        chineseName: "楠德德机场",
        traditionalName: "楠德德機場",
      },
    ],
  },
  NDE: {
    code: "NDE",
    name: "MANDERA",
    chineseName: "曼德拉",
    traditionalName: "曼德拉",
    airports: [
      {
        code: "NDE",
        name: "Mandera airport",
        chineseName: "曼德拉机场",
        traditionalName: "曼德拉機場",
      },
    ],
  },
  NDG: {
    code: "NDG",
    name: "QIQIHAR",
    chineseName: "齐齐哈尔",
    traditionalName: "齊齊哈爾",
    airports: [
      {
        code: "NDG",
        name: "Sanjiazi",
        chineseName: "三家子机场",
        traditionalName: "三家子機場",
      },
    ],
  },
  NDJ: {
    code: "NDJ",
    name: "N'DJAMENA",
    chineseName: "恩贾梅纳",
    traditionalName: "恩賈梅納",
    airports: [
      {
        code: "NDJ",
        name: "Hassan djamous intl",
        chineseName: "恩贾梅纳国际机场",
        traditionalName: "恩賈梅納國際機場",
      },
    ],
  },
  NDK: {
    code: "NDK",
    name: "NAMDRIK ISLAND",
    chineseName: "楠德里克岛",
    traditionalName: "楠德里克島",
    airports: [
      {
        code: "NDK",
        name: "Namdrik island airport",
        chineseName: "楠德里克岛机场",
        traditionalName: "楠德里克島機場",
      },
    ],
  },
  NDR: {
    code: "NDR",
    name: "NADOR",
    chineseName: "纳祖尔",
    traditionalName: "納祖爾",
    airports: [
      {
        code: "NDR",
        name: "El aroui",
        chineseName: "纳祖尔机场",
        traditionalName: "納祖爾機場",
      },
    ],
  },
  NDU: {
    code: "NDU",
    name: "RUNDU",
    chineseName: "伦杜",
    traditionalName: "倫杜",
    airports: [
      {
        code: "NDU",
        name: "Rundu airport",
        chineseName: "伦杜机场",
        traditionalName: "倫杜機場",
      },
    ],
  },
  NEI: {
    code: "NEI",
    name: "TERNEY",
    chineseName: "特尼",
    traditionalName: "特尼",
    airports: [
      {
        code: "NEI",
        name: "Terney airport",
        chineseName: "捷尔涅伊机场",
        traditionalName: "捷爾涅伊機場",
      },
    ],
  },
  NEK: {
    code: "NEK",
    name: "NEKEMTE",
    chineseName: "内凯姆特",
    traditionalName: "內凱姆特",
    airports: [
      {
        code: "NEK",
        name: "Nekemte airport",
        chineseName: "内凯姆特机场",
        traditionalName: "內凱姆特機場",
      },
    ],
  },
  NER: {
    code: "NER",
    name: "NERYUNGRI",
    chineseName: "尼永日",
    traditionalName: "尼永日",
    airports: [
      {
        code: "NER",
        name: "Chulman",
        chineseName: "内尤格里机场",
        traditionalName: "內尤格裏機場",
      },
    ],
  },
  NEU: {
    code: "NEU",
    name: "SAM NEUA",
    chineseName: "萨姆诺阿",
    traditionalName: "薩姆諾阿",
    airports: [
      {
        code: "NEU",
        name: "Sam neua airport",
        chineseName: "萨姆诺阿机场",
        traditionalName: "薩姆諾阿機場",
      },
    ],
  },
  NEV: {
    code: "NEV",
    name: "NEVIS",
    chineseName: "尼维斯岛",
    traditionalName: "尼維斯島",
    airports: [
      {
        code: "NEV",
        name: "Vance w. amory intl",
        chineseName: "万斯艾默里国际机场",
        traditionalName: "范錫艾默裏國際機場",
      },
    ],
  },
  NGB: {
    code: "NGB",
    name: "NINGBO",
    chineseName: "宁波",
    traditionalName: "寧波",
    airports: [
      {
        code: "NGB",
        name: "Lishe intl",
        chineseName: "栎社国际机场",
        traditionalName: "櫟社國際機場",
      },
    ],
  },
  NGE: {
    code: "NGE",
    name: "NGAOUNDERE",
    chineseName: "恩冈代雷",
    traditionalName: "恩岡代雷",
    airports: [
      {
        code: "NGE",
        name: "Ngaoundere airport",
        chineseName: "恩冈代雷机场",
        traditionalName: "恩岡代雷機場",
      },
    ],
  },
  NGI: {
    code: "NGI",
    name: "GAU ISLAND",
    chineseName: "恩高岛",
    traditionalName: "恩高島",
    airports: [
      {
        code: "NGI",
        name: "Gau island airport",
        chineseName: "恩加机场",
        traditionalName: "恩加機場",
      },
    ],
  },
  NGK: {
    code: "NGK",
    name: "NOGLIKI",
    chineseName: "诺格利基",
    traditionalName: "諾格利基",
    airports: [
      {
        code: "NGK",
        name: "Nogliki airport",
        chineseName: "诺格利基机场",
        traditionalName: "諾格利基機場",
      },
    ],
  },
  NGO: {
    code: "NGO",
    name: "NAGOYA",
    chineseName: "名古屋",
    traditionalName: "名古屋",
    airports: [
      {
        code: "NGO",
        name: "Chubu centrair intl",
        chineseName: "名古屋中部国际机场",
        traditionalName: "名古屋中部國際機場",
      },
      {
        code: "NKM",
        name: "Nagoya (komaki)",
        chineseName: "小牧机场",
        traditionalName: "小牧機場",
      },
    ],
  },
  NGQ: {
    code: "NGQ",
    name: "SHIQUANHE",
    chineseName: "阿里",
    traditionalName: "阿裡",
    airports: [
      {
        code: "NGQ",
        name: "Ngari gunsa/ali kunsha",
        chineseName: "昆莎机场",
        traditionalName: "昆莎機場",
      },
    ],
  },
  NGS: {
    code: "NGS",
    name: "NAGASAKI",
    chineseName: "长崎",
    traditionalName: "長崎",
    airports: [
      {
        code: "NGS",
        name: "Nagasaki airport",
        chineseName: "长崎机场",
        traditionalName: "長崎機場",
      },
    ],
  },
  NHA: {
    code: "NHA",
    name: "NHA TRANG",
    chineseName: "NHA TRANG",
    traditionalName: "NHA TRANG",
    airports: [
      {
        code: "CXR",
        name: "Cam ranh intl",
        chineseName: "金兰国际机场",
        traditionalName: "金蘭國際機場",
      },
    ],
  },
  NHV: {
    code: "NHV",
    name: "NUKU HIVA",
    chineseName: "努库希瓦",
    traditionalName: "努庫希瓦",
    airports: [
      {
        code: "NHV",
        name: "Nuku hiva airport",
        chineseName: "努库希瓦机场",
        traditionalName: "努庫希瓦機場",
      },
    ],
  },
  NIB: {
    code: "NIB",
    name: "NIKOLAI",
    chineseName: "阿拉斯加城市尼古",
    traditionalName: "阿拉斯加都市尼古",
    airports: [
      {
        code: "NIB",
        name: "Nikolai airport",
        chineseName: "尼古拉机场",
        traditionalName: "尼古拉機場",
      },
    ],
  },
  NIG: {
    code: "NIG",
    name: "NIKUNAU",
    chineseName: "尼库瑙",
    traditionalName: "尼庫瑙",
    airports: [
      {
        code: "NIG",
        name: "Nikunau airport",
        chineseName: "尼古纳机场",
        traditionalName: "尼古納機場",
      },
    ],
  },
  NIM: {
    code: "NIM",
    name: "NIAMEY",
    chineseName: "尼亚美",
    traditionalName: "尼阿美",
    airports: [
      {
        code: "NIM",
        name: "Diori hamani intl",
        chineseName: "哈马尼迪奥里国际机场",
        traditionalName: "哈馬尼迪奧裏國際機場",
      },
    ],
  },
  NIO: {
    code: "NIO",
    name: "NIOKI",
    chineseName: "尼奥基",
    traditionalName: "尼奧基",
    airports: [
      {
        code: "NIO",
        name: "Nioki airport",
        chineseName: "尼奥基机场",
        traditionalName: "尼奧基機場",
      },
    ],
  },
  NIU: {
    code: "NIU",
    name: "NIAU",
    chineseName: "法卡拉瓦尼奥",
    traditionalName: "法卡拉瓦尼奧",
    airports: [
      {
        code: "NIU",
        name: "Niau airport",
        chineseName: "纽阿机场",
        traditionalName: "紐阿機場",
      },
    ],
  },
  NJC: {
    code: "NJC",
    name: "NIZHNEVARTOVSK",
    chineseName: "下瓦尔托夫斯克",
    traditionalName: "下瓦爾托夫斯克",
    airports: [
      {
        code: "NJC",
        name: "Nizhnevartovsk airport",
        chineseName: "下瓦尔托夫斯克机场",
        traditionalName: "下瓦爾托夫斯克機場",
      },
    ],
  },
  NJF: {
    code: "NJF",
    name: "AL NAJAF",
    chineseName: "纳杰夫",
    traditionalName: "納傑夫",
    airports: [
      {
        code: "NJF",
        name: "Al-ashraf intl",
        chineseName: "纳杰夫国际机场",
        traditionalName: "納傑夫國際機場",
      },
    ],
  },
  NKC: {
    code: "NKC",
    name: "NOUAKCHOTT",
    chineseName: "努瓦克肖特",
    traditionalName: "諾克少",
    airports: [
      {
        code: "NKC",
        name: "Nouakchott airport",
        chineseName: "努瓦克肖特机场",
        traditionalName: "諾克少機場",
      },
    ],
  },
  NKG: {
    code: "NKG",
    name: "NANJING",
    chineseName: "南京",
    traditionalName: "南京",
    airports: [
      {
        code: "NKG",
        name: "Lukou intl",
        chineseName: "禄口国际机场",
        traditionalName: "祿口國際機場",
      },
    ],
  },
  NKI: {
    code: "NKI",
    name: "NAUKITI BAY",
    chineseName: "Naukiti，阿拉斯加",
    traditionalName: "Naukiti， 阿拉斯加",
    airports: [
      {
        code: "NKI",
        name: "Sea plane base",
        chineseName: "纳乌基蒂水上飞机基地",
        traditionalName: "納烏基蒂水上飛機基地",
      },
    ],
  },
  NKT: {
    code: "NKT",
    name: "SIRNAK",
    chineseName: "Cizre",
    traditionalName: "Cizre",
    airports: [
      {
        code: "NKT",
        name: "Sirnak airport",
        chineseName: "舍尔纳克机场",
        traditionalName: "舍爾納克機場",
      },
    ],
  },
  NLA: {
    code: "NLA",
    name: "NDOLA",
    chineseName: "恩多拉",
    traditionalName: "恩多拉",
    airports: [
      {
        code: "NLA",
        name: "Simon m. kapwepwe intl",
        chineseName: "恩多拉机场",
        traditionalName: "恩多拉機場",
      },
    ],
  },
  NLD: {
    code: "NLD",
    name: "NUEVO LAREDO",
    chineseName: "新拉雷多",
    traditionalName: "新拉雷多",
    airports: [
      {
        code: "NLD",
        name: "Quetzalcoatl intl",
        chineseName: "奎特扎尔克特尔国际机场",
        traditionalName: "奎特紮爾克特爾國際機場",
      },
    ],
  },
  NLF: {
    code: "NLF",
    name: "DARNLEY ISLAND",
    chineseName: "达恩利岛",
    traditionalName: "達恩利島",
    airports: [
      {
        code: "NLF",
        name: "Darnley island airport",
        chineseName: "达恩利岛机场",
        traditionalName: "達恩利島機場",
      },
    ],
  },
  NLG: {
    code: "NLG",
    name: "NELSON LAGOON",
    chineseName: "阿拉斯加州纳尔逊泻",
    traditionalName: "阿拉斯加州納爾遜瀉",
    airports: [
      {
        code: "NLG",
        name: "Nelson lagoon airport",
        chineseName: "纳尔逊拉贡机场",
        traditionalName: "納爾遜拉貢機場",
      },
    ],
  },
  NLH: {
    code: "NLH",
    name: "NINGLANG",
    chineseName: "宁蒗",
    traditionalName: "寧蒗",
    airports: [
      {
        code: "NLH",
        name: "Luguhu",
        chineseName: "泸沽湖机场",
        traditionalName: "瀘沽湖機場",
      },
    ],
  },
  NLI: {
    code: "NLI",
    name: "NIKOLAYEVSK-NA-AMURE",
    chineseName: "尼古拉耶夫斯克-纳穆尔",
    traditionalName: "尼古拉耶夫斯克-納穆爾",
    airports: [
      {
        code: "NLI",
        name: "Nikolayevsk-na-amure airport",
        chineseName: "阿穆尔河畔尼古拉耶夫斯克机场",
        traditionalName: "阿莫爾河畔尼古拉耶夫斯克機場",
      },
    ],
  },
  NLK: {
    code: "NLK",
    name: "NORFOLK ISLAND",
    chineseName: "诺福克岛",
    traditionalName: "諾福克島",
    airports: [
      {
        code: "NLK",
        name: "Norfolk island airport",
        chineseName: "诺福克岛机场",
        traditionalName: "諾福克島機場",
      },
    ],
  },
  NLP: {
    code: "NLP",
    name: "NELSPRUIT",
    chineseName: "内尔斯普雷特",
    traditionalName: "內爾斯普雷特",
    airports: [
      {
        code: "MQP",
        name: "Kruger mpumalanga intl",
        chineseName: "克鲁格尔普马兰加国际机场",
        traditionalName: "克魯格爾普馬蘭加國際機場",
      },
    ],
  },
  NLT: {
    code: "NLT",
    name: "XINYUAN",
    chineseName: "新源",
    traditionalName: "新源",
    airports: [
      {
        code: "NLT",
        name: "Nalati",
        chineseName: "那拉提机场",
        traditionalName: "那拉提機場",
      },
    ],
  },
  NMA: {
    code: "NMA",
    name: "NAMANGAN",
    chineseName: "纳曼干",
    traditionalName: "納曼幹",
    airports: [
      {
        code: "NMA",
        name: "Namangan airport",
        chineseName: "纳曼干机场",
        traditionalName: "納曼幹機場",
      },
    ],
  },
  NME: {
    code: "NME",
    name: "NIGHTMUTE",
    chineseName: "奈特缪特",
    traditionalName: "奈特繆特",
    airports: [
      {
        code: "NME",
        name: "Nightmute airport",
        chineseName: "奈特缪特机场",
        traditionalName: "奈特繆特機場",
      },
    ],
  },
  NMF: {
    code: "NMF",
    name: "MAAFARU",
    chineseName: "马法鲁",
    traditionalName: "馬法魯",
    airports: [
      {
        code: "NMF",
        name: "Maafaru intl.",
        chineseName: "马法卢国际机场",
        traditionalName: "馬法盧國際機場",
      },
    ],
  },
  NNB: {
    code: "NNB",
    name: "SANTA ANA ISLAND",
    chineseName: "圣安娜",
    traditionalName: "聖安娜",
    airports: [
      {
        code: "NNB",
        name: "Santa ana island airport",
        chineseName: "圣安娜机场",
        traditionalName: "聖安娜機場",
      },
    ],
  },
  NNG: {
    code: "NNG",
    name: "NANNING",
    chineseName: "南宁",
    traditionalName: "南寧",
    airports: [
      {
        code: "NNG",
        name: "Wuxu intl",
        chineseName: "吴圩国际机场",
        traditionalName: "吳圩國際機場",
      },
    ],
  },
  NNL: {
    code: "NNL",
    name: "NONDALTON",
    chineseName: "阿拉斯加州农多尔顿",
    traditionalName: "阿拉斯加州農多爾頓",
    airports: [
      {
        code: "NNL",
        name: "Nondalton airport",
        chineseName: "廊达尔顿机场",
        traditionalName: "廊達爾頓機場",
      },
    ],
  },
  NNM: {
    code: "NNM",
    name: "NARYAN-MAR",
    chineseName: "纳扬马尔",
    traditionalName: "納揚瑪律",
    airports: [
      {
        code: "NNM",
        name: "Naryan-mar airport",
        chineseName: "纳里扬马尔机场",
        traditionalName: "納裡揚瑪律機場",
      },
    ],
  },
  NNR: {
    code: "NNR",
    name: "SPIDDAL",
    chineseName: "斯皮达尔",
    traditionalName: "斯皮達爾",
    airports: [
      {
        code: "NNR",
        name: "Connemara",
        chineseName: "斯皮达尔机场",
        traditionalName: "斯皮達爾機場",
      },
    ],
  },
  NNT: {
    code: "NNT",
    name: "NAN",
    chineseName: "南府",
    traditionalName: "南府",
    airports: [
      {
        code: "NNT",
        name: "Nan airport",
        chineseName: "楠府机场",
        traditionalName: "楠府機場",
      },
    ],
  },
  NNY: {
    code: "NNY",
    name: "NANYANG",
    chineseName: "南阳",
    traditionalName: "南陽",
    airports: [
      {
        code: "NNY",
        name: "Jiangying",
        chineseName: "姜营机场",
        traditionalName: "薑營機場",
      },
    ],
  },
  NOB: {
    code: "NOB",
    name: "NOSARA",
    chineseName: "诺萨拉比奇",
    traditionalName: "諾薩拉比奇",
    airports: [
      {
        code: "NOB",
        name: "Nosara airport",
        chineseName: "诺萨拉比奇机场",
        traditionalName: "諾薩拉比奇機場",
      },
    ],
  },
  NOC: {
    code: "NOC",
    name: "KNOCK",
    chineseName: "诺克",
    traditionalName: "諾克",
    airports: [
      {
        code: "NOC",
        name: "Ireland west",
        chineseName: "爱尔兰西部诺克机场",
        traditionalName: "愛爾蘭西部諾克機場",
      },
    ],
  },
  NOD: {
    code: "NOD",
    name: "NORDEN",
    chineseName: "诺登",
    traditionalName: "諾登",
    airports: [
      {
        code: "NOD",
        name: "Norddeich",
        chineseName: "诺登机场",
        traditionalName: "諾登機場",
      },
    ],
  },
  NOJ: {
    code: "NOJ",
    name: "NOYABRSK",
    chineseName: "诺贾布尔斯克",
    traditionalName: "諾賈布爾斯克",
    airports: [
      {
        code: "NOJ",
        name: "Noyabrsk airport",
        chineseName: "诺加布克斯克机场",
        traditionalName: "諾加布克斯克機場",
      },
    ],
  },
  NON: {
    code: "NON",
    name: "NONOUTI",
    chineseName: "诺诺乌蒂",
    traditionalName: "諾諾烏蒂",
    airports: [
      {
        code: "NON",
        name: "Nonouti airport",
        chineseName: "诺诺乌蒂机场",
        traditionalName: "諾諾烏蒂機場",
      },
    ],
  },
  NOP: {
    code: "NOP",
    name: "SINOP",
    chineseName: "锡诺普",
    traditionalName: "錫諾普",
    airports: [
      {
        code: "NOP",
        name: "Sinop airport",
        chineseName: "锡诺普机场",
        traditionalName: "錫諾普機場",
      },
    ],
  },
  NOS: {
    code: "NOS",
    name: "NOSY-BE",
    chineseName: "努西贝",
    traditionalName: "努西貝",
    airports: [
      {
        code: "NOS",
        name: "Fascene",
        chineseName: "法西内机场",
        traditionalName: "法西內機場",
      },
    ],
  },
  NOU: {
    code: "NOU",
    name: "NOUMEA",
    chineseName: "努美阿",
    traditionalName: "諾美亞",
    airports: [
      {
        code: "GEA",
        name: "Magenta",
        chineseName: "马根塔机场",
        traditionalName: "馬根塔機場",
      },
      {
        code: "NOU",
        name: "La tontouta",
        chineseName: "努美阿机场",
        traditionalName: "諾美亞機場",
      },
    ],
  },
  NOV: {
    code: "NOV",
    name: "HUAMBO",
    chineseName: "万博",
    traditionalName: "萬博",
    airports: [
      {
        code: "NOV",
        name: "Albano machado",
        chineseName: "阿尔巴诺马查多机场",
        traditionalName: "阿爾巴諾馬查多機場",
      },
    ],
  },
  NOZ: {
    code: "NOZ",
    name: "NOVOKUZNETSK",
    chineseName: "新库兹涅茨克",
    traditionalName: "新庫茲涅茨克",
    airports: [
      {
        code: "NOZ",
        name: "Novokuznetsk airport",
        chineseName: "新库兹涅茨克机场",
        traditionalName: "新庫茲涅茨克機場",
      },
    ],
  },
  NPE: {
    code: "NPE",
    name: "NAPIER/HASTINGS",
    chineseName: "纳皮尔",
    traditionalName: "納皮爾",
    airports: [
      {
        code: "NPE",
        name: "Hawke's bay",
        chineseName: "豪客斯贝机场",
        traditionalName: "豪客斯貝機場",
      },
    ],
  },
  NPL: {
    code: "NPL",
    name: "NEW PLYMOUTH",
    chineseName: "新普利茅斯",
    traditionalName: "新普利茅斯",
    airports: [
      {
        code: "NPL",
        name: "New plymouth airport",
        chineseName: "新普利茅茨机场",
        traditionalName: "新普利茅茨機場",
      },
    ],
  },
  NPY: {
    code: "NPY",
    name: "MPANDA",
    chineseName: "姆班达",
    traditionalName: "姆班達",
    airports: [
      {
        code: "NPY",
        name: "Mpanda airport",
        chineseName: "Mpanda机场",
        traditionalName: "Mpanda機場",
      },
    ],
  },
  NQN: {
    code: "NQN",
    name: "NEUQUEN",
    chineseName: "内乌肯",
    traditionalName: "內烏肯",
    airports: [
      {
        code: "NQN",
        name: "Presidente peron",
        chineseName: "庇隆总统国际机场",
        traditionalName: "庇隆總統國際機場",
      },
    ],
  },
  NQT: {
    code: "NQT",
    name: "NOTTINGHAM",
    chineseName: "诺丁汉",
    traditionalName: "諾丁漢",
    airports: [
      {
        code: "EMA",
        name: "East midlands",
        chineseName: "东米德兰机场",
        traditionalName: "東米德蘭機場",
      },
    ],
  },
  NQU: {
    code: "NQU",
    name: "NUQUI",
    chineseName: "努基",
    traditionalName: "努基",
    airports: [
      {
        code: "NQU",
        name: "Reyes murillo",
        chineseName: "雷耶斯穆里略机场",
        traditionalName: "雷耶斯穆裏略機場",
      },
    ],
  },
  NQY: {
    code: "NQY",
    name: "NEWQUAY",
    chineseName: "康沃尔",
    traditionalName: "康沃爾",
    airports: [
      {
        code: "NQY",
        name: "Cornwall",
        chineseName: "康沃尔机场",
        traditionalName: "康沃爾機場",
      },
    ],
  },
  NQZ: {
    code: "NQZ",
    name: "ASTANA",
    chineseName: "阿斯塔纳",
    traditionalName: "阿斯坦納",
    airports: [
      {
        code: "NQZ",
        name: "Nursultan nazarbayev",
        chineseName: "努尔苏丹-纳扎尔巴耶夫国际机场",
        traditionalName: "努爾蘇丹-納紮爾巴耶夫國際機場",
      },
    ],
  },
  NRA: {
    code: "NRA",
    name: "NARRANDERA",
    chineseName: "纳兰德拉",
    traditionalName: "納蘭德拉",
    airports: [
      {
        code: "NRA",
        name: "Narrandera airport",
        chineseName: "纳兰德拉机场",
        traditionalName: "納蘭德拉機場",
      },
    ],
  },
  NRE: {
    code: "NRE",
    name: "NAMROLE",
    chineseName: "楠罗勒",
    traditionalName: "楠羅勒",
    airports: [
      {
        code: "NRE",
        name: "Namrole airport",
        chineseName: "楠罗勒机场",
        traditionalName: "楠羅勒機場",
      },
    ],
  },
  NRK: {
    code: "NRK",
    name: "NORRKOPING",
    chineseName: "诺尔雪平",
    traditionalName: "諾爾雪平",
    airports: [
      {
        code: "NRK",
        name: "Kungsangen",
        chineseName: "库恩桑根机场",
        traditionalName: "庫恩桑根機場",
      },
    ],
  },
  NRR: {
    code: "NRR",
    name: "CEIBA",
    chineseName: "罗斯福路",
    traditionalName: "羅斯福路",
    airports: [
      {
        code: "NRR",
        name: "J. aponte de la torre",
        chineseName: "何塞阿庞特德拉托雷机场",
        traditionalName: "何塞阿龐特德拉托雷機場",
      },
    ],
  },
  NSH: {
    code: "NSH",
    name: "NOW SHAHR",
    chineseName: "瑙沙赫尔",
    traditionalName: "瑙沙赫爾",
    airports: [
      {
        code: "NSH",
        name: "Now shahr airport",
        chineseName: "瑙沙赫尔机场",
        traditionalName: "瑙沙赫爾機場",
      },
    ],
  },
  NSK: {
    code: "NSK",
    name: "NORILSK",
    chineseName: "诺里尔斯克",
    traditionalName: "諾里爾斯克",
    airports: [
      {
        code: "NSK",
        name: "Alykel",
        chineseName: "阿雷克里机场",
        traditionalName: "阿雷克裏機場",
      },
    ],
  },
  NSN: {
    code: "NSN",
    name: "NELSON",
    chineseName: "纳尔逊",
    traditionalName: "納爾遜",
    airports: [
      {
        code: "NSN",
        name: "Nelson airport",
        chineseName: "尼尔森机场",
        traditionalName: "尼爾森機場",
      },
    ],
  },
  NSR: {
    code: "NSR",
    name: "SAO RAIMUNDO NONATO",
    chineseName: "圣雷蒙多·诺纳托",
    traditionalName: "聖雷蒙多·諾納托",
    airports: [
      {
        code: "NSR",
        name: "Serra da capivara",
        chineseName: "塞拉达卡皮瓦拉机场",
        traditionalName: "塞拉達卡皮瓦拉機場",
      },
    ],
  },
  NST: {
    code: "NST",
    name: "NAKHON SI THAMMARAT",
    chineseName: "洛坤府",
    traditionalName: "洛坤府",
    airports: [
      {
        code: "NST",
        name: "Nakhon si thammarat airport",
        chineseName: "那空是贪玛叻机场",
        traditionalName: "那空是貪瑪叻機場",
      },
    ],
  },
  NTE: {
    code: "NTE",
    name: "NANTES",
    chineseName: "南特",
    traditionalName: "南特",
    airports: [
      {
        code: "NTE",
        name: "Atlantique",
        chineseName: "大西洋机场",
        traditionalName: "大西洋機場",
      },
    ],
  },
  NTG: {
    code: "NTG",
    name: "NANTONG",
    chineseName: "南通",
    traditionalName: "南通",
    airports: [
      {
        code: "NTG",
        name: "Xingdong",
        chineseName: "兴东国际机场",
        traditionalName: "興東國際機場",
      },
    ],
  },
  NTL: {
    code: "NTL",
    name: "NEWCASTLE",
    chineseName: "纽卡斯尔",
    traditionalName: "紐卡斯爾",
    airports: [
      {
        code: "NTL",
        name: "Williamtown",
        chineseName: "威廉姆敦机场",
        traditionalName: "威廉姆敦機場",
      },
    ],
  },
  NTN: {
    code: "NTN",
    name: "NORMANTON",
    chineseName: "诺曼顿",
    traditionalName: "諾曼頓",
    airports: [
      {
        code: "NTN",
        name: "Normanton airport",
        chineseName: "诺曼顿机场",
        traditionalName: "諾曼頓機場",
      },
    ],
  },
  NTQ: {
    code: "NTQ",
    name: "WAJIMA",
    chineseName: "轮岛",
    traditionalName: "輪島",
    airports: [
      {
        code: "NTQ",
        name: "Noto",
        chineseName: "诺特机场",
        traditionalName: "諾特機場",
      },
    ],
  },
  NTX: {
    code: "NTX",
    name: "NATUNA",
    chineseName: "纳图纳拉奈",
    traditionalName: "納圖納拉奈",
    airports: [
      {
        code: "NTX",
        name: "Ranai",
        chineseName: "拉奈机场",
        traditionalName: "拉奈機場",
      },
    ],
  },
  NUE: {
    code: "NUE",
    name: "NUREMBERG",
    chineseName: "纽伦堡",
    traditionalName: "紐倫堡",
    airports: [
      {
        code: "NUE",
        name: "Nuremberg airport",
        chineseName: "纽伦堡机场",
        traditionalName: "紐倫堡機場",
      },
    ],
  },
  NUF: {
    code: "NUF",
    name: "HATTON",
    chineseName: "哈顿",
    traditionalName: "哈頓",
    airports: [
      {
        code: "NUF",
        name: "Castlereigh resrvr spb",
        chineseName: "哈顿基地机场",
        traditionalName: "哈頓基地機場",
      },
    ],
  },
  NUI: {
    code: "NUI",
    name: "NUIQSUT",
    chineseName: "阿拉斯加州Nuiqsut",
    traditionalName: "阿拉斯加州Nuiqsut",
    airports: [
      {
        code: "NUI",
        name: "Nuiqsut airport",
        chineseName: "努伊克苏特机场",
        traditionalName: "努伊克蘇特機場",
      },
    ],
  },
  NUK: {
    code: "NUK",
    name: "NUKUTAVAKE",
    chineseName: "努库塔维克岛",
    traditionalName: "努庫塔維克島",
    airports: [
      {
        code: "NUK",
        name: "Nukutavake airport",
        chineseName: "努库塔维克岛机场",
        traditionalName: "努庫塔維克島機場",
      },
    ],
  },
  NUL: {
    code: "NUL",
    name: "NULATO",
    chineseName: "阿拉斯加州努拉托",
    traditionalName: "阿拉斯加州努拉托",
    airports: [
      {
        code: "NUL",
        name: "Nulato airport",
        chineseName: "努拉图机场",
        traditionalName: "努拉圖機場",
      },
    ],
  },
  NUM: {
    code: "NUM",
    name: "NEOM BAY",
    chineseName: "新海湾城",
    traditionalName: "新海灣城",
    airports: [
      {
        code: "NUM",
        name: "Neom bay airport",
        chineseName: "新未来城机场",
        traditionalName: "新未來城機場",
      },
    ],
  },
  NUP: {
    code: "NUP",
    name: "NUNAPITCHUK",
    chineseName: "努纳皮丘克",
    traditionalName: "努納皮丘克",
    airports: [
      {
        code: "NUP",
        name: "Nunapitchuk airport",
        chineseName: "努纳皮丘克机场",
        traditionalName: "努納皮丘克機場",
      },
    ],
  },
  NUS: {
    code: "NUS",
    name: "NORSUP",
    chineseName: "诺索普",
    traditionalName: "諾索普",
    airports: [
      {
        code: "NUS",
        name: "Norsup airport",
        chineseName: "诺萨普机场",
        traditionalName: "諾薩普機場",
      },
    ],
  },
  NUX: {
    code: "NUX",
    name: "NOVY URENGOY",
    chineseName: "诺维恩伦格",
    traditionalName: "諾維恩倫格",
    airports: [
      {
        code: "NUX",
        name: "Novy urengoy airport",
        chineseName: "诺维恩伦格机场",
        traditionalName: "諾維恩倫格機場",
      },
    ],
  },
  NVA: {
    code: "NVA",
    name: "NEIVA",
    chineseName: "内瓦",
    traditionalName: "內瓦",
    airports: [
      {
        code: "NVA",
        name: "Benito salas",
        chineseName: "贝尼托萨拉斯机场",
        traditionalName: "貝尼托薩拉斯機場",
      },
    ],
  },
  NVI: {
    code: "NVI",
    name: "NAVOI",
    chineseName: "纳沃伊",
    traditionalName: "納沃伊",
    airports: [
      {
        code: "NVI",
        name: "Navoi intl.",
        chineseName: "纳沃伊国际机场",
        traditionalName: "納沃伊國際機場",
      },
    ],
  },
  NVT: {
    code: "NVT",
    name: "NAVEGANTES",
    chineseName: "伊塔雅伊",
    traditionalName: "伊塔雅伊",
    airports: [
      {
        code: "NVT",
        name: "Victor konder intl",
        chineseName: "纳韦甘蒂斯机场",
        traditionalName: "納韋甘蒂斯機場",
      },
    ],
  },
  NWA: {
    code: "NWA",
    name: "MOHELI",
    chineseName: "莫埃利岛",
    traditionalName: "莫埃利島",
    airports: [
      {
        code: "NWA",
        name: "Bandar es salam",
        chineseName: "莫埃利岛机场",
        traditionalName: "莫埃利島機場",
      },
    ],
  },
  NWI: {
    code: "NWI",
    name: "NORWICH",
    chineseName: "诺里奇",
    traditionalName: "諾里奇",
    airports: [
      {
        code: "NWI",
        name: "Norwich intl.",
        chineseName: "诺维奇国际机场",
        traditionalName: "諾維奇國際機場",
      },
    ],
  },
  NYA: {
    code: "NYA",
    name: "NYAGAN",
    chineseName: "尼亚干",
    traditionalName: "尼亞幹",
    airports: [
      {
        code: "NYA",
        name: "Nyagan airport",
        chineseName: "尼亚干机场",
        traditionalName: "尼亞幹機場",
      },
    ],
  },
  NYC: {
    code: "NYC",
    name: "NEW YORK",
    chineseName: "纽约",
    traditionalName: "紐約",
    airports: [
      {
        code: "EWR",
        name: "Newark liberty intl",
        chineseName: "纽瓦克国际机场",
        traditionalName: "紐瓦克國際機場",
      },
      {
        code: "JFK",
        name: "John f kennedy intl",
        chineseName: "肯尼迪国际机场",
        traditionalName: "肎尼迪國際機場",
      },
      {
        code: "LGA",
        name: "Laguardia",
        chineseName: "拉瓜迪亚机场",
        traditionalName: "拉瓜迪亞機場",
      },
      {
        code: "SWF",
        name: "Stewart international",
        chineseName: "斯提尤瓦特机场",
        traditionalName: "斯提尤瓦特機場",
      },
    ],
  },
  NYI: {
    code: "NYI",
    name: "SUNYANI",
    chineseName: "苏尼亚尼",
    traditionalName: "蘇尼亞尼",
    airports: [
      {
        code: "NYI",
        name: "Sunyani airport",
        chineseName: "苏尼亚尼机场",
        traditionalName: "蘇尼亞尼機場",
      },
    ],
  },
  NYK: {
    code: "NYK",
    name: "NANYUKI",
    chineseName: "纳纽基",
    traditionalName: "納紐基",
    airports: [
      {
        code: "NYK",
        name: "Nanyuki airport",
        chineseName: "纳纽基机场",
        traditionalName: "納紐基機場",
      },
    ],
  },
  NYM: {
    code: "NYM",
    name: "NADYM",
    chineseName: "纳德姆",
    traditionalName: "納德姆",
    airports: [
      {
        code: "NYM",
        name: "Nadym airport",
        chineseName: "纳德姆机场",
        traditionalName: "納德姆機場",
      },
    ],
  },
  NYR: {
    code: "NYR",
    name: "NYURBA",
    chineseName: "纽尔巴",
    traditionalName: "紐爾巴",
    airports: [
      {
        code: "NYR",
        name: "Nyurba airport",
        chineseName: "纽尔巴机场",
        traditionalName: "紐爾巴機場",
      },
    ],
  },
  NYT: {
    code: "NYT",
    name: "NAY PYI TAW",
    chineseName: "内比都",
    traditionalName: "內比都",
    airports: [
      {
        code: "NYT",
        name: "Nay pyi taw intl.",
        chineseName: "内比都机场",
        traditionalName: "內比都機場",
      },
    ],
  },
  NYU: {
    code: "NYU",
    name: "BAGAN/NYAUNG-U",
    chineseName: "良乌",
    traditionalName: "良烏",
    airports: [
      {
        code: "NYU",
        name: "Bagan/nyaung-u airport",
        chineseName: "良乌机场",
        traditionalName: "良烏機場",
      },
    ],
  },
  NYW: {
    code: "NYW",
    name: "MONYWA",
    chineseName: "蒙育瓦",
    traditionalName: "蒙育瓦",
    airports: [
      {
        code: "NYW",
        name: "Monywa airport",
        chineseName: "蒙育瓦机场",
        traditionalName: "蒙育瓦機場",
      },
    ],
  },
  NZE: {
    code: "NZE",
    name: "NZEREKORE",
    chineseName: "恩泽雷科雷",
    traditionalName: "恩澤雷科雷",
    airports: [
      {
        code: "NZE",
        name: "Nzerekore airport",
        chineseName: "恩泽雷科雷机场",
        traditionalName: "恩澤雷科雷機場",
      },
    ],
  },
  NZG: {
    code: "NZG",
    name: "NIZHNEANGARSK",
    chineseName: "下诺夫哥罗斯克",
    traditionalName: "下諾夫哥羅斯克",
    airports: [
      {
        code: "NZG",
        name: "Nizhneangarsk intl.",
        chineseName: "下诺夫哥罗斯克国际机场",
        traditionalName: "下諾夫哥羅斯克國際機場",
      },
    ],
  },
  NZH: {
    code: "NZH",
    name: "MANZHOULI",
    chineseName: "满洲里",
    traditionalName: "滿洲里",
    airports: [
      {
        code: "NZH",
        name: "Xijiao",
        chineseName: "满洲里西郊国际机场",
        traditionalName: "滿洲里西郊國際機場",
      },
    ],
  },
  NZL: {
    code: "NZL",
    name: "ZHALANTUN",
    chineseName: "扎兰屯",
    traditionalName: "紮蘭屯",
    airports: [
      {
        code: "NZL",
        name: "Chengjisihan",
        chineseName: "成吉思汗机场",
        traditionalName: "成吉思汗機場",
      },
    ],
  },
  OAG: {
    code: "OAG",
    name: "ORANGE",
    chineseName: "奥兰芝",
    traditionalName: "奧蘭芝",
    airports: [
      {
        code: "OAG",
        name: "Orange airport",
        chineseName: "奥兰治机场",
        traditionalName: "奧蘭治機場",
      },
    ],
  },
  OAJ: {
    code: "OAJ",
    name: "JACKSONVILLE",
    chineseName: "杰克逊维尔",
    traditionalName: "傑克遜維爾",
    airports: [
      {
        code: "OAJ",
        name: "Albert j ellis",
        chineseName: "阿尔伯特埃利斯机场",
        traditionalName: "阿爾伯特艾理斯機場",
      },
    ],
  },
  OAK: {
    code: "OAK",
    name: "OAKLAND",
    chineseName: "奥克兰",
    traditionalName: "奧克蘭",
    airports: [
      {
        code: "OAK",
        name: "Oakland intl.",
        chineseName: "奥克兰国际机场",
        traditionalName: "奧克蘭國際機場",
      },
    ],
  },
  OAL: {
    code: "OAL",
    name: "CACOAL",
    chineseName: "卡瓜欧",
    traditionalName: "卡瓜歐",
    airports: [
      {
        code: "OAL",
        name: "Capital do cafe",
        chineseName: "卡夸尔机场",
        traditionalName: "卡誇爾機場",
      },
    ],
  },
  OAX: {
    code: "OAX",
    name: "OAXACA",
    chineseName: "瓦哈卡",
    traditionalName: "瓦哈卡",
    airports: [
      {
        code: "OAX",
        name: "Xoxocotlan intl",
        chineseName: "肖肖克特兰国际机场",
        traditionalName: "肖肖克特蘭國際機場",
      },
    ],
  },
  OBN: {
    code: "OBN",
    name: "OBAN",
    chineseName: "奥本",
    traditionalName: "奧本",
    airports: [
      {
        code: "OBN",
        name: "North connel",
        chineseName: "奥本机场",
        traditionalName: "奧本機場",
      },
    ],
  },
  OBO: {
    code: "OBO",
    name: "OBIHIRO",
    chineseName: "带广",
    traditionalName: "帶廣",
    airports: [
      {
        code: "OBO",
        name: "Obihiro airport",
        chineseName: "带广机场",
        traditionalName: "帶廣機場",
      },
    ],
  },
  OBU: {
    code: "OBU",
    name: "KOBUK",
    chineseName: "阿拉斯加州科布克",
    traditionalName: "阿拉斯加州科布克",
    airports: [
      {
        code: "OBU",
        name: "Kobuk airport",
        chineseName: "科伯克机场",
        traditionalName: "科伯克機場",
      },
    ],
  },
  OCC: {
    code: "OCC",
    name: "COCA",
    chineseName: "科卡",
    traditionalName: "科卡",
    airports: [
      {
        code: "OCC",
        name: "Francisco de orellana",
        chineseName: "科卡机场",
        traditionalName: "科卡機場",
      },
    ],
  },
  OCJ: {
    code: "OCJ",
    name: "OCHO RIOS",
    chineseName: "奥乔里奥斯",
    traditionalName: "奧喬裏奧斯",
    airports: [
      {
        code: "OCJ",
        name: "Ian fleming intl",
        chineseName: "奥乔里奥斯机场",
        traditionalName: "奧喬裏奧斯機場",
      },
    ],
  },
  OCM: {
    code: "OCM",
    name: "BOOLGEEDA",
    chineseName: "博格达",
    traditionalName: "柏格達",
    airports: [
      {
        code: "OCM",
        name: "Boolgeeda airport",
        chineseName: "布尔格达机场",
        traditionalName: "布林格達機場",
      },
    ],
  },
  ODN: {
    code: "ODN",
    name: "LONG SERIDAN",
    chineseName: "伦塞里旦",
    traditionalName: "倫塞裏旦",
    airports: [
      {
        code: "ODN",
        name: "Long seridan airport",
        chineseName: "伦塞里旦机场",
        traditionalName: "倫塞裏旦機場",
      },
    ],
  },
  ODO: {
    code: "ODO",
    name: "BODAYBO",
    chineseName: "博达博",
    traditionalName: "博達博",
    airports: [
      {
        code: "ODO",
        name: "Bodaybo airport",
        chineseName: "博代博机场",
        traditionalName: "博代博機場",
      },
    ],
  },
  ODY: {
    code: "ODY",
    name: "MUANG XAY",
    chineseName: "奥多姆克塞",
    traditionalName: "奧多姆克塞",
    airports: [
      {
        code: "ODY",
        name: "Oudomxai",
        chineseName: "奥多姆克塞机场",
        traditionalName: "奧多姆克塞機場",
      },
    ],
  },
  OEC: {
    code: "OEC",
    name: "OECUSSI",
    chineseName: "欧库西",
    traditionalName: "歐庫西",
    airports: [
      {
        code: "OEC",
        name: "Oecussi airport",
        chineseName: "欧库西机场",
        traditionalName: "歐庫西機場",
      },
    ],
  },
  OER: {
    code: "OER",
    name: "ORNSKOLDSVIK",
    chineseName: "恩舍尔兹维克",
    traditionalName: "恩舍爾茲維克",
    airports: [
      {
        code: "OER",
        name: "Ornskoldsvik airport",
        chineseName: "恩舍尔兹维克机场",
        traditionalName: "恩舍爾茲維克機場",
      },
    ],
  },
  OFU: {
    code: "OFU",
    name: "OFU ISLAND",
    chineseName: "奥弗",
    traditionalName: "奧弗",
    airports: [
      {
        code: "OFU",
        name: "Ofu island airport",
        chineseName: "奥弗机场",
        traditionalName: "奧弗機場",
      },
    ],
  },
  OGD: {
    code: "OGD",
    name: "OGDEN",
    chineseName: "犹他州奥格登",
    traditionalName: "猶他州奧格登",
    airports: [
      {
        code: "OGD",
        name: "Hinckley",
        chineseName: "欣克利机场",
        traditionalName: "欣克利機場",
      },
    ],
  },
  OGG: {
    code: "OGG",
    name: "KAHULUI",
    chineseName: "卡胡卢伊",
    traditionalName: "卡胡盧伊",
    airports: [
      {
        code: "OGG",
        name: "Kahului airport",
        chineseName: "卡胡卢伊机场",
        traditionalName: "卡胡盧伊機場",
      },
    ],
  },
  OGN: {
    code: "OGN",
    name: "YONAGUNI",
    chineseName: "与那国",
    traditionalName: "與那國",
    airports: [
      {
        code: "OGN",
        name: "Yonaguni airport",
        chineseName: "与那国岛机场",
        traditionalName: "與那國島機場",
      },
    ],
  },
  OGS: {
    code: "OGS",
    name: "OGDENSBURG",
    chineseName: "奥格登斯堡",
    traditionalName: "奧格登斯堡",
    airports: [
      {
        code: "OGS",
        name: "Ogdensburg intl.",
        chineseName: "奥格登斯堡国际机场",
        traditionalName: "奧格登斯堡國際機場",
      },
    ],
  },
  OGU: {
    code: "OGU",
    name: "ORDU/GIRESUN",
    chineseName: "奥尔杜吉雷松",
    traditionalName: "奧爾杜吉雷松",
    airports: [
      {
        code: "OGU",
        name: "Ordu/giresun airport",
        chineseName: "奥尔杜吉雷松机场",
        traditionalName: "奧爾杜吉雷松機場",
      },
    ],
  },
  OGX: {
    code: "OGX",
    name: "OUARGLA",
    chineseName: "瓦尔格拉",
    traditionalName: "瓦爾格拉",
    airports: [
      {
        code: "OGX",
        name: "Ain el beida",
        chineseName: "埃恩贝达机场",
        traditionalName: "埃恩貝達機場",
      },
    ],
  },
  OGZ: {
    code: "OGZ",
    name: "VLADIKAVKAZ",
    chineseName: "弗拉季高加索",
    traditionalName: "弗拉季高加索",
    airports: [
      {
        code: "OGZ",
        name: "Beslan",
        chineseName: "别斯兰机场",
        traditionalName: "別斯蘭機場",
      },
    ],
  },
  OHD: {
    code: "OHD",
    name: "OHRID",
    chineseName: "奥赫里德",
    traditionalName: "奧赫裏德",
    airports: [
      {
        code: "OHD",
        name: "St.paul the apostle",
        chineseName: "奥赫里德机场",
        traditionalName: "奧赫裏德機場",
      },
    ],
  },
  OHE: {
    code: "OHE",
    name: "MOHE",
    chineseName: "漠河",
    traditionalName: "漠河",
    airports: [
      {
        code: "OHE",
        name: "Gulian",
        chineseName: "漠河机场",
        traditionalName: "漠河機場",
      },
    ],
  },
  OHH: {
    code: "OHH",
    name: "OKHA",
    chineseName: "奥卡",
    traditionalName: "奧卡",
    airports: [
      {
        code: "OHH",
        name: "Novostroyka",
        chineseName: "奥哈机场",
        traditionalName: "奧哈機場",
      },
    ],
  },
  OHO: {
    code: "OHO",
    name: "OKHOTSK",
    chineseName: "鄂霍次克",
    traditionalName: "鄂霍次克",
    airports: [
      {
        code: "OHO",
        name: "Okhotsk airport",
        chineseName: "鄂霍次克机场",
        traditionalName: "鄂霍次克機場",
      },
    ],
  },
  OHS: {
    code: "OHS",
    name: "SOHAR",
    chineseName: "苏哈尔",
    traditionalName: "蘇哈爾",
    airports: [
      {
        code: "OHS",
        name: "Sohar airport",
        chineseName: "苏哈尔机场",
        traditionalName: "蘇哈爾機場",
      },
    ],
  },
  OIA: {
    code: "OIA",
    name: "OURILANDIA DO NORTE",
    chineseName: "奥里兰蒂亚",
    traditionalName: "奧裏蘭蒂亞",
    airports: [
      {
        code: "OIA",
        name: "Ourilandia do norte airport",
        chineseName: "奥里兰蒂亚机场",
        traditionalName: "奧裏蘭蒂亞機場",
      },
    ],
  },
  OIM: {
    code: "OIM",
    name: "OSHIMA",
    chineseName: "大岛",
    traditionalName: "大島",
    airports: [
      {
        code: "OIM",
        name: "Oshima airport",
        chineseName: "大岛机场",
        traditionalName: "大島機場",
      },
    ],
  },
  OIR: {
    code: "OIR",
    name: "OKUSHIRI",
    chineseName: "奥尻",
    traditionalName: "奧尻",
    airports: [
      {
        code: "OIR",
        name: "Okushiri airport",
        chineseName: "奥尻机场",
        traditionalName: "奧尻機場",
      },
    ],
  },
  OIT: {
    code: "OIT",
    name: "OITA",
    chineseName: "大分",
    traditionalName: "大分",
    airports: [
      {
        code: "OIT",
        name: "Oita airport",
        chineseName: "大分机场",
        traditionalName: "大分機場",
      },
    ],
  },
  OKA: {
    code: "OKA",
    name: "OKINAWA",
    chineseName: "冲绳",
    traditionalName: "沖繩",
    airports: [
      {
        code: "OKA",
        name: "Naha",
        chineseName: "那霸机场",
        traditionalName: "那霸機場",
      },
    ],
  },
  OKC: {
    code: "OKC",
    name: "OKLAHOMA CITY",
    chineseName: "俄克拉荷马城",
    traditionalName: "奧克拉荷馬城",
    airports: [
      {
        code: "OKC",
        name: "Will rogers world",
        chineseName: "维尔罗杰斯机场",
        traditionalName: "維爾羅傑斯機場",
      },
    ],
  },
  OKE: {
    code: "OKE",
    name: "OKIERABU",
    chineseName: "和泊",
    traditionalName: "和泊",
    airports: [
      {
        code: "OKE",
        name: "Okierabu airport",
        chineseName: "冲九良部机场",
        traditionalName: "沖九良部機場",
      },
    ],
  },
  OKI: {
    code: "OKI",
    name: "OKI",
    chineseName: "隐岐诸岛",
    traditionalName: "隱岐諸島",
    airports: [
      {
        code: "OKI",
        name: "Oki airport",
        chineseName: "奥基岛机场",
        traditionalName: "奧基島機場",
      },
    ],
  },
  OKJ: {
    code: "OKJ",
    name: "OKAYAMA",
    chineseName: "冈山",
    traditionalName: "岡山",
    airports: [
      {
        code: "OKJ",
        name: "Okayama airport",
        chineseName: "冈山机场",
        traditionalName: "岡山機場",
      },
    ],
  },
  OKL: {
    code: "OKL",
    name: "OKSIBIL",
    chineseName: "奥克西比尔",
    traditionalName: "奧克西比爾",
    airports: [
      {
        code: "OKL",
        name: "Gunung bintang",
        chineseName: "奥克西比尔机场",
        traditionalName: "奧克西比爾機場",
      },
    ],
  },
  OKR: {
    code: "OKR",
    name: "YORKE ISLAND",
    chineseName: "约克岛",
    traditionalName: "約克島",
    airports: [
      {
        code: "OKR",
        name: "Yorke island airport",
        chineseName: "约克岛机场",
        traditionalName: "約克島機場",
      },
    ],
  },
  OLA: {
    code: "OLA",
    name: "ORLAND",
    chineseName: "奥兰",
    traditionalName: "奧蘭",
    airports: [
      {
        code: "OLA",
        name: "Orland airport",
        chineseName: "奥兰机场",
        traditionalName: "奧蘭機場",
      },
    ],
  },
  OLB: {
    code: "OLB",
    name: "OLBIA",
    chineseName: "奥尔比亚",
    traditionalName: "奧爾比亞",
    airports: [
      {
        code: "OLB",
        name: "Costa smeralda",
        chineseName: "科斯塔斯梅拉尔达机场",
        traditionalName: "科斯塔斯梅拉爾達機場",
      },
    ],
  },
  OLF: {
    code: "OLF",
    name: "WOLF POINT",
    chineseName: "蒙大拿州沃尔夫",
    traditionalName: "蒙大拿州沃爾夫",
    airports: [
      {
        code: "OLF",
        name: "L.m. clayton",
        chineseName: "克雷顿机场",
        traditionalName: "克雷頓機場",
      },
    ],
  },
  OLH: {
    code: "OLH",
    name: "OLD HARBOR",
    chineseName: "奥尔德港",
    traditionalName: "奧爾德港",
    airports: [
      {
        code: "OLH",
        name: "Old harbor airport",
        chineseName: "奥尔德港机场",
        traditionalName: "奧爾德港機場",
      },
    ],
  },
  OLP: {
    code: "OLP",
    name: "OLYMPIC DAM",
    chineseName: "奥林匹克坝",
    traditionalName: "奧林匹克壩",
    airports: [
      {
        code: "OLP",
        name: "Olympic dam airport",
        chineseName: "奥林匹亚坝机场",
        traditionalName: "奧林匹亞壩機場",
      },
    ],
  },
  OLZ: {
    code: "OLZ",
    name: "OLEKMINSK",
    chineseName: "Olokminsk",
    traditionalName: "Olokminsk",
    airports: [
      {
        code: "OLZ",
        name: "Olekminsk airport",
        chineseName: "奥尔约克明斯克机场",
        traditionalName: "奧爾約克明斯克機場",
      },
    ],
  },
  OMA: {
    code: "OMA",
    name: "OMAHA",
    chineseName: "奥马哈",
    traditionalName: "奧馬哈",
    airports: [
      {
        code: "OMA",
        name: "Eppley airfield",
        chineseName: "埃普雷机场",
        traditionalName: "埃普雷機場",
      },
    ],
  },
  OME: {
    code: "OME",
    name: "NOME",
    chineseName: "诺姆",
    traditionalName: "諾姆",
    airports: [
      {
        code: "OME",
        name: "Nome airport",
        chineseName: "诺姆机场",
        traditionalName: "諾姆機場",
      },
    ],
  },
  OMH: {
    code: "OMH",
    name: "URUMIYEH",
    chineseName: "乌尔米耶",
    traditionalName: "烏爾米耶",
    airports: [
      {
        code: "OMH",
        name: "Urumiyeh airport",
        chineseName: "乌尔米耶机场",
        traditionalName: "烏爾米耶機場",
      },
    ],
  },
  OMM: {
    code: "OMM",
    name: "MARMUL",
    chineseName: "迈尔穆勒",
    traditionalName: "邁爾穆勒",
    airports: [
      {
        code: "OMM",
        name: "Marmul airport",
        chineseName: "迈尔穆勒机场",
        traditionalName: "邁爾穆勒機場",
      },
    ],
  },
  OMN: {
    code: "OMN",
    name: "ZOMIN",
    chineseName: "奥斯马纳巴德",
    traditionalName: "奧斯馬納巴德",
    airports: [
      {
        code: "OMN",
        name: "Zomin airport",
        chineseName: "奥斯曼阿巴德机场",
        traditionalName: "奧斯曼阿巴德機場",
      },
    ],
  },
  OMO: {
    code: "OMO",
    name: "MOSTAR",
    chineseName: "莫斯塔尔",
    traditionalName: "莫斯塔爾",
    airports: [
      {
        code: "OMO",
        name: "Mostar intl.",
        chineseName: "莫斯塔尔机场",
        traditionalName: "莫斯塔爾機場",
      },
    ],
  },
  OMR: {
    code: "OMR",
    name: "ORADEA",
    chineseName: "奥拉迪亚",
    traditionalName: "奧拉迪亞",
    airports: [
      {
        code: "OMR",
        name: "Oradea airport",
        chineseName: "拉迪亚机场",
        traditionalName: "拉迪亞機場",
      },
    ],
  },
  OMS: {
    code: "OMS",
    name: "OMSK",
    chineseName: "鄂木斯克",
    traditionalName: "鄂木斯克",
    airports: [
      {
        code: "OMS",
        name: "Tsentralny",
        chineseName: "鄂姆斯克机场",
        traditionalName: "鄂姆斯克機場",
      },
    ],
  },
  OND: {
    code: "OND",
    name: "ONDANGWA",
    chineseName: "翁丹瓜",
    traditionalName: "翁丹瓜",
    airports: [
      {
        code: "OND",
        name: "Ondangwa airport",
        chineseName: "翁丹瓜机场",
        traditionalName: "翁丹瓜機場",
      },
    ],
  },
  ONG: {
    code: "ONG",
    name: "MORNINGTON ISLAND",
    chineseName: "莫宁顿",
    traditionalName: "莫寧頓",
    airports: [
      {
        code: "ONG",
        name: "Mornington island airport",
        chineseName: "莫宁顿机场",
        traditionalName: "莫寧頓機場",
      },
    ],
  },
  ONJ: {
    code: "ONJ",
    name: "ODATE/NOSHIRO",
    chineseName: "大馆能代",
    traditionalName: "大館能代",
    airports: [
      {
        code: "ONJ",
        name: "Odate/noshiro airport",
        chineseName: "大馆能代机场",
        traditionalName: "大館能代機場",
      },
    ],
  },
  ONK: {
    code: "ONK",
    name: "OLENEK",
    chineseName: "奥莱尼约克",
    traditionalName: "奧萊尼約克",
    airports: [
      {
        code: "ONK",
        name: "Olenek airport",
        chineseName: "奥列尼奥克机场",
        traditionalName: "奧列尼奧克機場",
      },
    ],
  },
  ONQ: {
    code: "ONQ",
    name: "ZONGULDAK",
    chineseName: "宗古尔达克",
    traditionalName: "宗古爾達克",
    airports: [
      {
        code: "ONQ",
        name: "Caycuma",
        chineseName: "宗古尔达克机场",
        traditionalName: "宗古爾達克機場",
      },
    ],
  },
  ONS: {
    code: "ONS",
    name: "ONSLOW",
    chineseName: "昂斯洛",
    traditionalName: "昂斯洛",
    airports: [
      {
        code: "ONS",
        name: "Onslow airport",
        chineseName: "昂斯洛机场",
        traditionalName: "昂斯洛機場",
      },
    ],
  },
  OOD: {
    code: "OOD",
    name: "KOODAIDERI MINE",
    chineseName: "Koodaideri矿山城",
    traditionalName: "Koodaideri礦山城",
    airports: [
      {
        code: "OOD",
        name: "Gudai-darri mine",
        chineseName: "古代·达里矿场机场",
        traditionalName: "古代·達裏礦場機場",
      },
    ],
  },
  OOK: {
    code: "OOK",
    name: "TOKSOOK BAY",
    chineseName: "阿拉斯加市东须",
    traditionalName: "阿拉斯加市東須",
    airports: [
      {
        code: "OOK",
        name: "Toksook bay airport",
        chineseName: "托克苏克贝机场",
        traditionalName: "托克蘇克貝機場",
      },
    ],
  },
  OOL: {
    code: "OOL",
    name: "GOLD COAST",
    chineseName: "黄金海岸",
    traditionalName: "黃金海岸",
    airports: [
      {
        code: "OOL",
        name: "Coolangatta",
        chineseName: "库兰加塔机场",
        traditionalName: "庫蘭加塔機場",
      },
    ],
  },
  OOT: {
    code: "OOT",
    name: "ONOTOA",
    chineseName: "奥诺托阿",
    traditionalName: "奧諾托阿",
    airports: [
      {
        code: "OOT",
        name: "Onotoa airport",
        chineseName: "奥诺托机场",
        traditionalName: "奧諾托機場",
      },
    ],
  },
  OPO: {
    code: "OPO",
    name: "PORTO",
    chineseName: "波尔图",
    traditionalName: "波爾圖",
    airports: [
      {
        code: "OPO",
        name: "Francisco sa carneiro",
        chineseName: "弗朗西斯科卡内罗机场",
        traditionalName: "弗朗西斯科卡內羅機場",
      },
    ],
  },
  OPP: {
    code: "OPP",
    name: "SALINOPOLIS",
    chineseName: "Salinopolis",
    traditionalName: "Salinopolis",
    airports: [
      {
        code: "OPP",
        name: "Salinopolis airport",
        chineseName: "萨利诺波利斯机场",
        traditionalName: "薩利諾波利斯機場",
      },
    ],
  },
  OPS: {
    code: "OPS",
    name: "SINOP",
    chineseName: "希诺普",
    traditionalName: "希諾普",
    airports: [
      {
        code: "OPS",
        name: "Jao b. figueiredo",
        chineseName: "锡诺普机场",
        traditionalName: "錫諾普機場",
      },
    ],
  },
  ORB: {
    code: "ORB",
    name: "OREBRO",
    chineseName: "厄勒布鲁",
    traditionalName: "厄勒布魯",
    airports: [
      {
        code: "ORB",
        name: "Orebro airport",
        chineseName: "厄勒布鲁机场",
        traditionalName: "厄勒布魯機場",
      },
    ],
  },
  ORF: {
    code: "ORF",
    name: "NORFOLK",
    chineseName: "诺福克",
    traditionalName: "諾福克",
    airports: [
      {
        code: "ORF",
        name: "Norfolk intl.",
        chineseName: "诺福克国际机场",
        traditionalName: "諾福克國際機場",
      },
    ],
  },
  ORH: {
    code: "ORH",
    name: "WORCESTER",
    chineseName: "伍斯特",
    traditionalName: "伍斯特",
    airports: [
      {
        code: "ORH",
        name: "Worcester reg. airport",
        chineseName: "伍斯特机场",
        traditionalName: "伍斯特機場",
      },
    ],
  },
  ORI: {
    code: "ORI",
    name: "PORT LIONS",
    chineseName: "阿拉斯加州狮",
    traditionalName: "阿拉斯加州獅",
    airports: [
      {
        code: "ORI",
        name: "Port lions airport",
        chineseName: "莱昂斯港机场",
        traditionalName: "萊昂斯港機場",
      },
    ],
  },
  ORK: {
    code: "ORK",
    name: "CORK",
    chineseName: "科克",
    traditionalName: "科克",
    airports: [
      {
        code: "ORK",
        name: "Cork intl.",
        chineseName: "科克机场",
        traditionalName: "科克機場",
      },
    ],
  },
  ORL: {
    code: "ORL",
    name: "ORLANDO",
    chineseName: "奥兰多",
    traditionalName: "奧蘭多",
    airports: [
      {
        code: "MCO",
        name: "Orlando intl.",
        chineseName: "奥兰多国际机场",
        traditionalName: "奧蘭多國際機場",
      },
      {
        code: "SFB",
        name: "Sanford intl",
        chineseName: "桑福德国际机场",
        traditionalName: "桑福德國際機場",
      },
    ],
  },
  ORN: {
    code: "ORN",
    name: "ORAN",
    chineseName: "奥兰",
    traditionalName: "奧蘭",
    airports: [
      {
        code: "ORN",
        name: "Ahmed ben bella",
        chineseName: "埃斯塞尼阿机场",
        traditionalName: "埃斯塞尼阿機場",
      },
    ],
  },
  ORU: {
    code: "ORU",
    name: "ORURO",
    chineseName: "奥鲁罗",
    traditionalName: "奧魯羅",
    airports: [
      {
        code: "ORU",
        name: "Juan mendoza",
        chineseName: "胡安门多萨机场",
        traditionalName: "胡安門多薩機場",
      },
    ],
  },
  ORV: {
    code: "ORV",
    name: "NOORVIK",
    chineseName: "诺尔维克",
    traditionalName: "諾爾維克",
    airports: [
      {
        code: "ORV",
        name: "R. (bob) curtis mem.",
        chineseName: "科提斯－梅莫里阿尔机场",
        traditionalName: "科提斯－梅莫裏阿爾機場",
      },
    ],
  },
  OSA: {
    code: "OSA",
    name: "OSAKA",
    chineseName: "大阪",
    traditionalName: "大阪",
    airports: [
      {
        code: "ITM",
        name: "Osaka intl (itami)",
        chineseName: "伊丹机场",
        traditionalName: "伊丹機場",
      },
      {
        code: "KIX",
        name: "Kansai international",
        chineseName: "关西国际机场",
        traditionalName: "關西國際機場",
      },
      {
        code: "UKB",
        name: "Kobe",
        chineseName: "神户机场",
        traditionalName: "神戶機場",
      },
    ],
  },
  OSD: {
    code: "OSD",
    name: "ARE/OSTERSUND",
    chineseName: "奥斯特松",
    traditionalName: "奧斯特松",
    airports: [
      {
        code: "OSD",
        name: "Are/ostersund airport",
        chineseName: "厄斯特松德机场",
        traditionalName: "厄斯特松德機場",
      },
    ],
  },
  OSI: {
    code: "OSI",
    name: "OSIJEK",
    chineseName: "奥西耶克",
    traditionalName: "奧西耶克",
    airports: [
      {
        code: "OSI",
        name: "Osijek airport",
        chineseName: "奥西耶克机场",
        traditionalName: "奧西耶克機場",
      },
    ],
  },
  OSL: {
    code: "OSL",
    name: "OSLO",
    chineseName: "奥斯陆",
    traditionalName: "奧斯陸",
    airports: [
      {
        code: "OSL",
        name: "Gardermoen",
        chineseName: "奥斯陆机场",
        traditionalName: "奧斯陸機場",
      },
      {
        code: "TRF",
        name: "Sandefjord-torp",
        chineseName: "桑德尔福德机场",
        traditionalName: "桑德爾福德機場",
      },
    ],
  },
  OSR: {
    code: "OSR",
    name: "OSTRAVA",
    chineseName: "俄斯特拉发",
    traditionalName: "俄斯特拉發",
    airports: [
      {
        code: "OSR",
        name: "Leos janacek",
        chineseName: "莱奥什亚纳切克机场",
        traditionalName: "萊奧什亞納切克機場",
      },
    ],
  },
  OSS: {
    code: "OSS",
    name: "OSH",
    chineseName: "奥什",
    traditionalName: "奧什",
    airports: [
      {
        code: "OSS",
        name: "Osh airport",
        chineseName: "奥什机场",
        traditionalName: "奧什機場",
      },
    ],
  },
  OST: {
    code: "OST",
    name: "OOSTENDE/BRUGGE",
    chineseName: "奥斯坦德",
    traditionalName: "奧斯坦德",
    airports: [
      {
        code: "OST",
        name: "Oostende/brugge airport",
        chineseName: "奥斯坦德布鲁日国际机场",
        traditionalName: "奧斯坦德布魯日國際機場",
      },
    ],
  },
  OSW: {
    code: "OSW",
    name: "ORSK",
    chineseName: "奥尔斯克",
    traditionalName: "奧爾斯克",
    airports: [
      {
        code: "OSW",
        name: "Orsk airport",
        chineseName: "奥尔斯克机场",
        traditionalName: "奧爾斯克機場",
      },
    ],
  },
  OSY: {
    code: "OSY",
    name: "NAMSOS",
    chineseName: "纳姆索斯",
    traditionalName: "納姆索斯",
    airports: [
      {
        code: "OSY",
        name: "Namsos airport",
        chineseName: "纳姆索斯机场",
        traditionalName: "納姆索斯機場",
      },
    ],
  },
  OTH: {
    code: "OTH",
    name: "NORTH BEND",
    chineseName: "北本德",
    traditionalName: "北本德",
    airports: [
      {
        code: "OTH",
        name: "Southwest oregon rgnl",
        chineseName: "西南俄勒冈地区机场",
        traditionalName: "西南俄勒岡地區機場",
      },
    ],
  },
  OTI: {
    code: "OTI",
    name: "MOROTAI ISLAND",
    chineseName: "莫罗泰岛",
    traditionalName: "莫洛泰島",
    airports: [
      {
        code: "OTI",
        name: "Pitu",
        chineseName: "比都机场",
        traditionalName: "比都機場",
      },
    ],
  },
  OTS: {
    code: "OTS",
    name: "ANACORTES",
    chineseName: "阿纳科特斯",
    traditionalName: "阿納科特斯",
    airports: [
      {
        code: "OTS",
        name: "Anacortes airport",
        chineseName: "阿纳科特斯机场",
        traditionalName: "阿納科特斯機場",
      },
    ],
  },
  OTZ: {
    code: "OTZ",
    name: "KOTZEBUE",
    chineseName: "科策布",
    traditionalName: "科策布",
    airports: [
      {
        code: "OTZ",
        name: "Ralph wien memorial",
        chineseName: "拉尔夫维恩纪念机场",
        traditionalName: "拉爾夫維恩紀念機場",
      },
    ],
  },
  OUA: {
    code: "OUA",
    name: "OUAGADOUGOU",
    chineseName: "瓦加杜古",
    traditionalName: "瓦加杜古",
    airports: [
      {
        code: "OUA",
        name: "Ouagadougou airport",
        chineseName: "瓦加杜古机场",
        traditionalName: "瓦加杜古機場",
      },
    ],
  },
  OUD: {
    code: "OUD",
    name: "OUJDA",
    chineseName: "乌季达",
    traditionalName: "烏季達",
    airports: [
      {
        code: "OUD",
        name: "Angads",
        chineseName: "安加德斯机场",
        traditionalName: "安加德斯機場",
      },
    ],
  },
  OUE: {
    code: "OUE",
    name: "OUESSO",
    chineseName: "韦索",
    traditionalName: "韋索",
    airports: [
      {
        code: "OUE",
        name: "Ouesso airport",
        chineseName: "韦索机场",
        traditionalName: "韋索機場",
      },
    ],
  },
  OUI: {
    code: "OUI",
    name: "OUESSANT",
    chineseName: "会晒",
    traditionalName: "會曬",
    airports: [
      {
        code: "OUI",
        name: "Ouessant airport",
        chineseName: "会晒机场",
        traditionalName: "會曬機場",
      },
    ],
  },
  OUL: {
    code: "OUL",
    name: "OULU",
    chineseName: "奥卢",
    traditionalName: "奧盧",
    airports: [
      {
        code: "OUL",
        name: "Oulu airport",
        chineseName: "奥卢机场",
        traditionalName: "奧盧機場",
      },
    ],
  },
  OUZ: {
    code: "OUZ",
    name: "ZOUERATE",
    chineseName: "祖埃拉特",
    traditionalName: "祖埃拉特",
    airports: [
      {
        code: "OUZ",
        name: "Tazadit",
        chineseName: "塔扎迪特机场",
        traditionalName: "塔紮迪特機場",
      },
    ],
  },
  OVB: {
    code: "OVB",
    name: "NOVOSIBIRSK",
    chineseName: "新西伯利亚",
    traditionalName: "新西伯利亞",
    airports: [
      {
        code: "OVB",
        name: "Tolmachevo",
        chineseName: "托尔马切夫机场",
        traditionalName: "托爾馬切夫機場",
      },
    ],
  },
  OVD: {
    code: "OVD",
    name: "ASTURIAS",
    chineseName: "阿斯图里亚斯",
    traditionalName: "阿斯圖裡亞斯",
    airports: [
      {
        code: "OVD",
        name: "Asturias airport",
        chineseName: "阿斯图里亚斯机场",
        traditionalName: "阿斯圖裡亞斯機場",
      },
    ],
  },
  OVS: {
    code: "OVS",
    name: "SOVETSKY",
    chineseName: "苏维埃斯基",
    traditionalName: "蘇維埃斯基",
    airports: [
      {
        code: "OVS",
        name: "Sovetsky airport",
        chineseName: "苏维埃斯基机场",
        traditionalName: "蘇維埃斯基機場",
      },
    ],
  },
  OWB: {
    code: "OWB",
    name: "OWENSBORO",
    chineseName: "肯塔基州欧文斯伯勒",
    traditionalName: "肯塔基州歐文斯伯勒",
    airports: [
      {
        code: "OWB",
        name: "Daviess county",
        chineseName: "达维斯郡机场",
        traditionalName: "達維斯郡機場",
      },
    ],
  },
  OWD: {
    code: "OWD",
    name: "NORWOOD",
    chineseName: "诺伍德",
    traditionalName: "諾伍德",
    airports: [
      {
        code: "OWD",
        name: "Memorial",
        chineseName: "诺伍德机场",
        traditionalName: "諾伍德機場",
      },
    ],
  },
  OXB: {
    code: "OXB",
    name: "BISSAU",
    chineseName: "比绍",
    traditionalName: "比索",
    airports: [
      {
        code: "OXB",
        name: "Osvaldo vieira intl",
        chineseName: "奥斯瓦尔多－维埃拉机场",
        traditionalName: "奧斯瓦爾多－維艾拉機場",
      },
    ],
  },
  OXF: {
    code: "OXF",
    name: "OXFORD",
    chineseName: "牛津",
    traditionalName: "牛津",
    airports: [
      {
        code: "OXF",
        name: "London oxford",
        chineseName: "牛津机场",
        traditionalName: "牛津機場",
      },
    ],
  },
  OYE: {
    code: "OYE",
    name: "OYEM",
    chineseName: "奥耶姆",
    traditionalName: "奧耶姆",
    airports: [
      {
        code: "OYE",
        name: "Oyem airport",
        chineseName: "奥耶姆机场",
        traditionalName: "奧耶姆機場",
      },
    ],
  },
  OZC: {
    code: "OZC",
    name: "OZAMIZ",
    chineseName: "奥萨米斯",
    traditionalName: "奧薩米斯",
    airports: [
      {
        code: "OZC",
        name: "Labo",
        chineseName: "拉波机场",
        traditionalName: "拉波機場",
      },
    ],
  },
  OZG: {
    code: "OZG",
    name: "ZAGORA",
    chineseName: "扎古拉",
    traditionalName: "紮古拉",
    airports: [
      {
        code: "OZG",
        name: "Zagora airport",
        chineseName: "扎古拉机场",
        traditionalName: "紮古拉機場",
      },
    ],
  },
  OZZ: {
    code: "OZZ",
    name: "OUARZAZATE",
    chineseName: "瓦尔扎扎特",
    traditionalName: "瓦爾扎扎特",
    airports: [
      {
        code: "OZZ",
        name: "Ouarzazate airport",
        chineseName: "瓦尔扎扎特机场",
        traditionalName: "瓦爾扎扎特機場",
      },
    ],
  },
  PAB: {
    code: "PAB",
    name: "BILASPUR",
    chineseName: "比拉斯普尔",
    traditionalName: "比拉斯普爾",
    airports: [
      {
        code: "PAB",
        name: "Bilaspur airport",
        chineseName: "比拉斯布尔机场",
        traditionalName: "比拉斯布林機場",
      },
    ],
  },
  PAD: {
    code: "PAD",
    name: "PADERBORN/LIPPSTADT",
    chineseName: "帕德博恩",
    traditionalName: "帕德博恩",
    airports: [
      {
        code: "PAD",
        name: "Paderborn/lippstadt airport",
        chineseName: "帕德博恩机场",
        traditionalName: "帕德博恩機場",
      },
    ],
  },
  PAF: {
    code: "PAF",
    name: "PAKUBA",
    chineseName: "帕库巴",
    traditionalName: "帕庫巴",
    airports: [
      {
        code: "PAF",
        name: "Pakuba",
        chineseName: "帕库巴机场",
        traditionalName: "帕庫巴機場",
      },
    ],
  },
  PAG: {
    code: "PAG",
    name: "PAGADIAN",
    chineseName: "帕加迪安",
    traditionalName: "帕加迪安",
    airports: [
      {
        code: "PAG",
        name: "Pagadian airport",
        chineseName: "帕加迪安机场",
        traditionalName: "帕加迪安機場",
      },
    ],
  },
  PAH: {
    code: "PAH",
    name: "PADUCAH",
    chineseName: "帕迪尤卡",
    traditionalName: "帕迪尤卡",
    airports: [
      {
        code: "PAH",
        name: "Barkley regional",
        chineseName: "巴克雷地区机场",
        traditionalName: "巴克雷地區機場",
      },
    ],
  },
  PAP: {
    code: "PAP",
    name: "PORT-AU-PRINCE",
    chineseName: "海地太子港",
    traditionalName: "海地太子港",
    airports: [
      {
        code: "PAP",
        name: "Toussaint louverture",
        chineseName: "太子港机场",
        traditionalName: "太子港機場",
      },
    ],
  },
  PAR: {
    code: "PAR",
    name: "PARIS",
    chineseName: "巴黎",
    traditionalName: "巴黎",
    airports: [
      {
        code: "BVA",
        name: "Beauvais-tille",
        chineseName: "博瓦伊提勒机场",
        traditionalName: "博瓦伊提勒機場",
      },
      {
        code: "CDG",
        name: "Charles de gaulle",
        chineseName: "戴高乐机场",
        traditionalName: "戴高樂機場",
      },
      {
        code: "LBG",
        name: "Le bourget",
        chineseName: "勒布尔热机场",
        traditionalName: "勒布林熱機場",
      },
      {
        code: "ORY",
        name: "Orly",
        chineseName: "奥利机场",
        traditionalName: "奧利機場",
      },
      {
        code: "XCR",
        name: "Chalons-vatry",
        chineseName: "沙隆瓦特里机场",
        traditionalName: "沙隆瓦特裏機場",
      },
    ],
  },
  PAS: {
    code: "PAS",
    name: "PAROS",
    chineseName: "帕罗斯",
    traditionalName: "帕羅斯",
    airports: [
      {
        code: "PAS",
        name: "Paros airport",
        chineseName: "帕罗斯机场",
        traditionalName: "帕羅斯機場",
      },
    ],
  },
  PAT: {
    code: "PAT",
    name: "PATNA",
    chineseName: "巴特纳",
    traditionalName: "巴特納",
    airports: [
      {
        code: "PAT",
        name: "Jayaprakash narayan",
        chineseName: "巴特纳机场",
        traditionalName: "巴特納機場",
      },
    ],
  },
  PBC: {
    code: "PBC",
    name: "PUEBLA",
    chineseName: "普埃布拉",
    traditionalName: "布埃布拉",
    airports: [
      {
        code: "PBC",
        name: "Hermanos serdan intl",
        chineseName: "普埃布拉机场",
        traditionalName: "布埃布拉機場",
      },
    ],
  },
  PBG: {
    code: "PBG",
    name: "PLATTSBURGH",
    chineseName: "普拉茨堡",
    traditionalName: "普拉茨堡",
    airports: [
      {
        code: "PBG",
        name: "Plattsburgh intl.",
        chineseName: "普拉茨堡国际机场",
        traditionalName: "普拉茨堡國際機場",
      },
    ],
  },
  PBH: {
    code: "PBH",
    name: "PARO",
    chineseName: "帕罗",
    traditionalName: "帕羅",
    airports: [
      {
        code: "PBH",
        name: "Paro intl.",
        chineseName: "帕罗机场",
        traditionalName: "帕羅機場",
      },
    ],
  },
  PBI: {
    code: "PBI",
    name: "WEST PALM BEACH",
    chineseName: "西棕榈滩",
    traditionalName: "西棕櫚灘",
    airports: [
      {
        code: "PBI",
        name: "Palm beach intl",
        chineseName: "西棕榈滩国际机场",
        traditionalName: "西棕櫚灘國際機場",
      },
    ],
  },
  PBJ: {
    code: "PBJ",
    name: "PAAMA ISLAND",
    chineseName: "帕马",
    traditionalName: "帕馬",
    airports: [
      {
        code: "PBJ",
        name: "Paama island airport",
        chineseName: "帕马机场",
        traditionalName: "帕馬機場",
      },
    ],
  },
  PBM: {
    code: "PBM",
    name: "PARAMARIBO",
    chineseName: "帕拉马里博",
    traditionalName: "巴拉馬利波",
    airports: [
      {
        code: "ORG",
        name: "Zorg en hoop",
        chineseName: "ZORG EN HOOP机场",
        traditionalName: "ZORG EN HOOP機場",
      },
      {
        code: "PBM",
        name: "Johan a. pengel intl",
        chineseName: "约翰阿道夫彭赫尔国际机场",
        traditionalName: "約翰阿道夫彭赫爾國際機場",
      },
    ],
  },
  PBO: {
    code: "PBO",
    name: "PARABURDOO",
    chineseName: "帕拉布尔多",
    traditionalName: "帕拉布林多",
    airports: [
      {
        code: "PBO",
        name: "Paraburdoo airport",
        chineseName: "帕拉布尔多机场",
        traditionalName: "帕拉布林多機場",
      },
    ],
  },
  PBR: {
    code: "PBR",
    name: "PUERTO BARRIOS",
    chineseName: "巴里奥斯港",
    traditionalName: "巴里奧斯港",
    airports: [
      {
        code: "PBR",
        name: "Puerto barrios airport",
        chineseName: "巴里奥斯港机场",
        traditionalName: "巴里奧斯港機場",
      },
    ],
  },
  PBU: {
    code: "PBU",
    name: "PUTAO",
    chineseName: "葡萄县",
    traditionalName: "葡萄縣",
    airports: [
      {
        code: "PBU",
        name: "Putao airport",
        chineseName: "葡萄机场",
        traditionalName: "葡萄機場",
      },
    ],
  },
  PBZ: {
    code: "PBZ",
    name: "PLETTENBERG BAY",
    chineseName: "普莱滕贝格湾",
    traditionalName: "普萊滕貝格灣",
    airports: [
      {
        code: "PBZ",
        name: "Plettenberg bay airport",
        chineseName: "普莱滕贝格机场",
        traditionalName: "普萊滕貝格機場",
      },
    ],
  },
  PCL: {
    code: "PCL",
    name: "PUCALLPA",
    chineseName: "普卡尔帕",
    traditionalName: "普卡爾帕",
    airports: [
      {
        code: "PCL",
        name: "D.abenzur rengifo intl",
        chineseName: "卡皮坦罗尔登机场",
        traditionalName: "卡皮坦羅爾登機場",
      },
    ],
  },
  PCN: {
    code: "PCN",
    name: "PICTON",
    chineseName: "皮克顿",
    traditionalName: "皮克頓",
    airports: [
      {
        code: "PCN",
        name: "Picton airport",
        chineseName: "皮克顿机场",
        traditionalName: "皮克頓機場",
      },
    ],
  },
  PCP: {
    code: "PCP",
    name: "PRINCIPE ISLAND",
    chineseName: "普林西比岛",
    traditionalName: "普林西比島",
    airports: [
      {
        code: "PCP",
        name: "Principe island airport",
        chineseName: "普林西比机场",
        traditionalName: "普林西比機場",
      },
    ],
  },
  PCR: {
    code: "PCR",
    name: "PUERTO CARRENO",
    chineseName: "卡雷尼奥港",
    traditionalName: "卡雷尼奧港",
    airports: [
      {
        code: "PCR",
        name: "German olano",
        chineseName: "卡雷尼奥港机场",
        traditionalName: "卡雷尼奧港機場",
      },
    ],
  },
  PDA: {
    code: "PDA",
    name: "PUERTO INIRIDA",
    chineseName: "伊尼里达港",
    traditionalName: "伊尼裏達港",
    airports: [
      {
        code: "PDA",
        name: "Obando",
        chineseName: "伊尼里达港机场",
        traditionalName: "伊尼裏達港機場",
      },
    ],
  },
  PDB: {
    code: "PDB",
    name: "PEDRO BAY",
    chineseName: "佩德罗贝",
    traditionalName: "佩德羅貝",
    airports: [
      {
        code: "PDB",
        name: "Pedro bay airport",
        chineseName: "佩德罗贝机场",
        traditionalName: "佩德羅貝機場",
      },
    ],
  },
  PDG: {
    code: "PDG",
    name: "PADANG",
    chineseName: "巴东",
    traditionalName: "巴東",
    airports: [
      {
        code: "PDG",
        name: "Minangkabau",
        chineseName: "米南佳保机场",
        traditionalName: "米南佳保機場",
      },
    ],
  },
  PDL: {
    code: "PDL",
    name: "PONTA DELGADA",
    chineseName: "蓬塔德尔加达",
    traditionalName: "蓬塔德爾加達",
    airports: [
      {
        code: "PDL",
        name: "Joao paulo ii",
        chineseName: "若昂保罗二世机场",
        traditionalName: "若昂保羅二世機場",
      },
    ],
  },
  PDM: {
    code: "PDM",
    name: "PEDASI",
    chineseName: "佩达西",
    traditionalName: "佩達西",
    airports: [
      {
        code: "PDM",
        name: "Capt. j. montenegro",
        chineseName: "佩达西机场",
        traditionalName: "佩達西機場",
      },
    ],
  },
  PDP: {
    code: "PDP",
    name: "PUNTA DEL ESTE",
    chineseName: "埃斯特角",
    traditionalName: "埃斯特角",
    airports: [
      {
        code: "PDP",
        name: "Carlos a. curbelo intl",
        chineseName: "埃斯特角城机场",
        traditionalName: "埃斯特角城機場",
      },
    ],
  },
  PDS: {
    code: "PDS",
    name: "PIEDRAS NEGRAS",
    chineseName: "彼德拉斯内格拉斯",
    traditionalName: "彼德拉斯內格拉斯",
    airports: [
      {
        code: "PDS",
        name: "Piedras negras intl.",
        chineseName: "彼德拉斯内格拉斯国际机场",
        traditionalName: "彼德拉斯內格拉斯國際機場",
      },
    ],
  },
  PDT: {
    code: "PDT",
    name: "PENDLETON",
    chineseName: "彭德尔顿",
    traditionalName: "彭德爾頓",
    airports: [
      {
        code: "PDT",
        name: "Eastern oregon rgnl",
        chineseName: "东部俄勒冈地区机场",
        traditionalName: "東部俄勒岡地區機場",
      },
    ],
  },
  PDV: {
    code: "PDV",
    name: "PLOVDIV",
    chineseName: "普罗夫迪夫",
    traditionalName: "普羅夫迪夫",
    airports: [
      {
        code: "PDV",
        name: "Krumovo",
        chineseName: "普罗夫蒂夫机场",
        traditionalName: "普羅夫蒂夫機場",
      },
    ],
  },
  PDX: {
    code: "PDX",
    name: "PORTLAND",
    chineseName: "波特兰",
    traditionalName: "波特蘭",
    airports: [
      {
        code: "PDX",
        name: "Portland intl.",
        chineseName: "波特兰国际机场",
        traditionalName: "波特蘭國際機場",
      },
    ],
  },
  PEC: {
    code: "PEC",
    name: "PELICAN",
    chineseName: "阿拉斯加鹈鹕",
    traditionalName: "阿拉斯加鵜鶘",
    airports: [
      {
        code: "PEC",
        name: "Sea plane base",
        chineseName: "派力肯机场",
        traditionalName: "派力肯機場",
      },
    ],
  },
  PED: {
    code: "PED",
    name: "PARDUBICE",
    chineseName: "帕尔杜比采",
    traditionalName: "帕爾杜比采",
    airports: [
      {
        code: "PED",
        name: "Pardubice airport",
        chineseName: "帕尔杜比采机场",
        traditionalName: "帕爾杜比采機場",
      },
    ],
  },
  PEE: {
    code: "PEE",
    name: "PERM",
    chineseName: "彼尔姆",
    traditionalName: "彼爾姆",
    airports: [
      {
        code: "PEE",
        name: "Bolshoye savino",
        chineseName: "彼尔姆机场",
        traditionalName: "彼爾姆機場",
      },
    ],
  },
  PEG: {
    code: "PEG",
    name: "PERUGIA",
    chineseName: "佩鲁贾",
    traditionalName: "佩魯賈",
    airports: [
      {
        code: "PEG",
        name: "St. francis of assisi",
        chineseName: "佩鲁贾机场",
        traditionalName: "佩魯賈機場",
      },
    ],
  },
  PEI: {
    code: "PEI",
    name: "PEREIRA",
    chineseName: "佩雷拉",
    traditionalName: "佩雷拉",
    airports: [
      {
        code: "PEI",
        name: "Matecana intl",
        chineseName: "马特卡纳机场",
        traditionalName: "馬特卡納機場",
      },
    ],
  },
  PEM: {
    code: "PEM",
    name: "PUERTO MALDONADO",
    chineseName: "马尔多纳多港",
    traditionalName: "瑪律多納多港",
    airports: [
      {
        code: "PEM",
        name: "Padre aldamiz intl",
        chineseName: "马尔多纳多港机场",
        traditionalName: "瑪律多納多港機場",
      },
    ],
  },
  PEN: {
    code: "PEN",
    name: "PENANG",
    chineseName: "槟城",
    traditionalName: "檳城",
    airports: [
      {
        code: "PEN",
        name: "Penang intl.",
        chineseName: "槟城国际机场",
        traditionalName: "檳城國際機場",
      },
    ],
  },
  PER: {
    code: "PER",
    name: "PERTH",
    chineseName: "珀斯",
    traditionalName: "珀斯",
    airports: [
      {
        code: "PER",
        name: "Perth intl.",
        chineseName: "珀斯机场",
        traditionalName: "珀斯機場",
      },
    ],
  },
  PES: {
    code: "PES",
    name: "PETROZAVODSK",
    chineseName: "彼得罗扎沃茨克",
    traditionalName: "彼得羅紮沃茨克",
    airports: [
      {
        code: "PES",
        name: "Besovets",
        chineseName: "彼得罗扎沃茨克机场",
        traditionalName: "彼得羅紮沃茨克機場",
      },
    ],
  },
  PET: {
    code: "PET",
    name: "PELOTAS",
    chineseName: "佩洛塔斯",
    traditionalName: "佩洛塔斯",
    airports: [
      {
        code: "PET",
        name: "Pelotas intl.",
        chineseName: "佩洛塔斯国际机场",
        traditionalName: "佩洛塔斯國際機場",
      },
    ],
  },
  PEU: {
    code: "PEU",
    name: "PUERTO LEMPIRA",
    chineseName: "伦皮拉港",
    traditionalName: "倫皮拉港",
    airports: [
      {
        code: "PEU",
        name: "Puerto lempira airport",
        chineseName: "雷姆皮拉港机场",
        traditionalName: "雷姆皮拉港機場",
      },
    ],
  },
  PEV: {
    code: "PEV",
    name: "PECS",
    chineseName: "佩奇",
    traditionalName: "佩奇",
    airports: [
      {
        code: "PEV",
        name: "Pogany",
        chineseName: "波加尼机场",
        traditionalName: "波加尼機場",
      },
    ],
  },
  PEW: {
    code: "PEW",
    name: "PESHAWAR",
    chineseName: "白沙瓦",
    traditionalName: "白沙瓦",
    airports: [
      {
        code: "PEW",
        name: "Bacha khan intl",
        chineseName: "白沙瓦机场",
        traditionalName: "白沙瓦機場",
      },
    ],
  },
  PEZ: {
    code: "PEZ",
    name: "PENZA",
    chineseName: "奔萨",
    traditionalName: "奔薩",
    airports: [
      {
        code: "PEZ",
        name: "Ternovka",
        chineseName: "奔萨机场",
        traditionalName: "奔薩機場",
      },
    ],
  },
  PFB: {
    code: "PFB",
    name: "PASSO FUNDO",
    chineseName: "帕苏丰杜",
    traditionalName: "帕蘇豐杜",
    airports: [
      {
        code: "PFB",
        name: "Lauro kurtz",
        chineseName: "劳罗库尔茨机场",
        traditionalName: "勞羅庫爾茨機場",
      },
    ],
  },
  PFO: {
    code: "PFO",
    name: "PAPHOS",
    chineseName: "帕福斯",
    traditionalName: "帕福斯",
    airports: [
      {
        code: "PFO",
        name: "Paphos intl.",
        chineseName: "帕福斯国际机场",
        traditionalName: "帕福斯國際機場",
      },
    ],
  },
  PFQ: {
    code: "PFQ",
    name: "PARSABAD",
    chineseName: "帕尔萨巴德",
    traditionalName: "帕爾薩巴德",
    airports: [
      {
        code: "PFQ",
        name: "Moghan",
        chineseName: "帕尔萨巴德机场",
        traditionalName: "帕爾薩巴德機場",
      },
    ],
  },
  PGA: {
    code: "PGA",
    name: "PAGE",
    chineseName: "佩奇",
    traditionalName: "佩奇",
    airports: [
      {
        code: "PGA",
        name: "Page municipal",
        chineseName: "佩吉机场",
        traditionalName: "佩吉機場",
      },
    ],
  },
  PGD: {
    code: "PGD",
    name: "PUNTA GORDA",
    chineseName: "佛罗里达州蓬塔戈尔达",
    traditionalName: "佛羅里達州蓬塔戈爾達",
    airports: [
      {
        code: "PGD",
        name: "Punta gorda airport",
        chineseName: "蓬塔戈尔达机场",
        traditionalName: "蓬塔戈爾達機場",
      },
    ],
  },
  PGF: {
    code: "PGF",
    name: "PERPIGNAN",
    chineseName: "佩皮尼昂",
    traditionalName: "佩皮尼昂",
    airports: [
      {
        code: "PGF",
        name: "Rivesaltes",
        chineseName: "里沃萨尔特机场",
        traditionalName: "裏沃薩爾特機場",
      },
    ],
  },
  PGH: {
    code: "PGH",
    name: "PANTNAGAR",
    chineseName: "潘特纳加尔",
    traditionalName: "潘特納加爾",
    airports: [
      {
        code: "PGH",
        name: "Pantnagar airport",
        chineseName: "潘特纳加尔机场",
        traditionalName: "潘特納加爾機場",
      },
    ],
  },
  PGK: {
    code: "PGK",
    name: "PANGKALPINANG",
    chineseName: "邦加槟港",
    traditionalName: "邦加檳港",
    airports: [
      {
        code: "PGK",
        name: "Depati amir",
        chineseName: "槟港机场",
        traditionalName: "檳港機場",
      },
    ],
  },
  PGM: {
    code: "PGM",
    name: "PORT GRAHAM",
    chineseName: "格雷厄姆港",
    traditionalName: "格雷厄姆港",
    airports: [
      {
        code: "PGM",
        name: "Port graham airport",
        chineseName: "格雷厄姆港机场",
        traditionalName: "格雷厄姆港機場",
      },
    ],
  },
  PGQ: {
    code: "PGQ",
    name: "PEKAULANG",
    chineseName: "Pekaulang",
    traditionalName: "Pekaulang",
    airports: [
      {
        code: "PGQ",
        name: "Buli",
        chineseName: "布里机场",
        traditionalName: "布裡機場",
      },
    ],
  },
  PGU: {
    code: "PGU",
    name: "ASALOYEH",
    chineseName: "阿萨鲁耶",
    traditionalName: "阿薩魯耶",
    airports: [
      {
        code: "PGU",
        name: "Persian gulf intl",
        chineseName: "波斯湾国际机场",
        traditionalName: "波斯灣國際機場",
      },
    ],
  },
  PGV: {
    code: "PGV",
    name: "GREENVILLE",
    chineseName: "格林维尔",
    traditionalName: "格林維爾",
    airports: [
      {
        code: "PGV",
        name: "Pitt-greenville",
        chineseName: "皮特格林维尔机场",
        traditionalName: "皮特格林維爾機場",
      },
    ],
  },
  PGZ: {
    code: "PGZ",
    name: "PONTA GROSSA",
    chineseName: "逢塔格罗萨",
    traditionalName: "逢塔格羅薩",
    airports: [
      {
        code: "PGZ",
        name: "A.amilton beraldo",
        chineseName: "圣安娜机场",
        traditionalName: "聖安娜機場",
      },
    ],
  },
  PHB: {
    code: "PHB",
    name: "PARNAIBA",
    chineseName: "巴纳伊巴",
    traditionalName: "巴納伊巴",
    airports: [
      {
        code: "PHB",
        name: "Joao silva filho intl",
        chineseName: "若昂席尔瓦菲略国际机场",
        traditionalName: "若昂席爾瓦菲略國際機場",
      },
    ],
  },
  PHC: {
    code: "PHC",
    name: "PORT HARCOURT",
    chineseName: "哈科特港",
    traditionalName: "哈科特港",
    airports: [
      {
        code: "PHC",
        name: "Port harcourt intl.",
        chineseName: "哈科特港国际机场",
        traditionalName: "哈科特港國際機場",
      },
    ],
  },
  PHE: {
    code: "PHE",
    name: "PORT HEDLAND",
    chineseName: "黑德兰港",
    traditionalName: "黑德蘭港",
    airports: [
      {
        code: "PHE",
        name: "Port hedland intl.",
        chineseName: "黑德兰港机场",
        traditionalName: "黑德蘭港機場",
      },
    ],
  },
  PHF: {
    code: "PHF",
    name: "NEWPORT NEWS/WILLIAMSB",
    chineseName: "纽波特纽斯",
    traditionalName: "紐波特紐斯",
    airports: [
      {
        code: "PHF",
        name: "Newport news/williamsb intl.",
        chineseName: "纽波特纽斯国际机场",
        traditionalName: "紐波特紐斯國際機場",
      },
    ],
  },
  PHL: {
    code: "PHL",
    name: "PHILADELPHIA",
    chineseName: "费城",
    traditionalName: "費城",
    airports: [
      {
        code: "PHL",
        name: "Philadelphia intl.",
        chineseName: "费城国际机场",
        traditionalName: "費城國際機場",
      },
      {
        code: "TTN",
        name: "Trenton-mercer",
        chineseName: "特伦顿梅塞尔机场",
        traditionalName: "特倫頓梅塞爾機場",
      },
    ],
  },
  PHO: {
    code: "PHO",
    name: "POINT HOPE",
    chineseName: "波因特霍普",
    traditionalName: "波因特霍普",
    airports: [
      {
        code: "PHO",
        name: "Point hope airport",
        chineseName: "波因特霍普机场",
        traditionalName: "波因特霍普機場",
      },
    ],
  },
  PHQ: {
    code: "PHQ",
    name: "PHOSPHATE HILL",
    chineseName: "磷山",
    traditionalName: "磷山",
    airports: [
      {
        code: "PHQ",
        name: "The monument",
        chineseName: "磷山机场",
        traditionalName: "磷山機場",
      },
    ],
  },
  PHS: {
    code: "PHS",
    name: "PHITSANULOK",
    chineseName: "彭世洛",
    traditionalName: "彭世洛",
    airports: [
      {
        code: "PHS",
        name: "Phitsanulok airport",
        chineseName: "彭世洛机场",
        traditionalName: "彭世洛機場",
      },
    ],
  },
  PHX: {
    code: "PHX",
    name: "PHOENIX",
    chineseName: "凤凰城",
    traditionalName: "鳳凰城",
    airports: [
      {
        code: "AZA",
        name: "Mesa gateway",
        chineseName: "梅萨盖特威机场",
        traditionalName: "梅薩山蓋特威機場",
      },
      {
        code: "PHX",
        name: "Sky harbor intl",
        chineseName: "凤凰城天港国际机场",
        traditionalName: "鳳凰城天港國際機場",
      },
      {
        code: "SCF",
        name: "Scottsdale apt",
        chineseName: "斯科茨代尔地方机场",
        traditionalName: "斯科茨代爾地方機場",
      },
    ],
  },
  PIA: {
    code: "PIA",
    name: "PEORIA",
    chineseName: "皮奥里亚",
    traditionalName: "皮奧里亞",
    airports: [
      {
        code: "PIA",
        name: "General downing intl",
        chineseName: "韦恩唐宁将军国际机场",
        traditionalName: "韋恩唐寧將軍國際機場",
      },
    ],
  },
  PIH: {
    code: "PIH",
    name: "POCATELLO",
    chineseName: "波卡特洛",
    traditionalName: "波卡特洛",
    airports: [
      {
        code: "PIH",
        name: "Pocatello reg. airport",
        chineseName: "波卡特洛机场",
        traditionalName: "波卡特洛機場",
      },
    ],
  },
  PIN: {
    code: "PIN",
    name: "PARINTINS",
    chineseName: "帕林廷斯",
    traditionalName: "帕林廷斯",
    airports: [
      {
        code: "PIN",
        name: "Julio belem",
        chineseName: "胡里奥贝伦机场",
        traditionalName: "胡裏奧貝倫機場",
      },
    ],
  },
  PIO: {
    code: "PIO",
    name: "PISCO",
    chineseName: "皮斯科",
    traditionalName: "皮斯科",
    airports: [
      {
        code: "PIO",
        name: "Renan elias olivera",
        chineseName: "皮斯科机场",
        traditionalName: "皮斯科機場",
      },
    ],
  },
  PIP: {
    code: "PIP",
    name: "PILOT POINT",
    chineseName: "阿拉斯加州市飞行员",
    traditionalName: "阿拉斯加州市飛行員",
    airports: [
      {
        code: "PIP",
        name: "Pilot point airport",
        chineseName: "派勒特波因特机场",
        traditionalName: "派勒特波因特機場",
      },
    ],
  },
  PIR: {
    code: "PIR",
    name: "PIERRE",
    chineseName: "皮尔",
    traditionalName: "皮爾",
    airports: [
      {
        code: "PIR",
        name: "Pierre reg. airport",
        chineseName: "皮埃尔机场",
        traditionalName: "皮埃爾機場",
      },
    ],
  },
  PIS: {
    code: "PIS",
    name: "POITIERS",
    chineseName: "普瓦捷",
    traditionalName: "普瓦捷",
    airports: [
      {
        code: "PIS",
        name: "Biard",
        chineseName: "比亚德机场",
        traditionalName: "比亞德機場",
      },
    ],
  },
  PIT: {
    code: "PIT",
    name: "PITTSBURGH",
    chineseName: "匹兹堡",
    traditionalName: "匹茲堡",
    airports: [
      {
        code: "AGC",
        name: "Allegheny county",
        chineseName: "匹兹堡机场",
        traditionalName: "匹茲堡機場",
      },
      {
        code: "PIT",
        name: "Pittsburgh intl.",
        chineseName: "匹兹堡国际机场",
        traditionalName: "匹茲堡國際機場",
      },
    ],
  },
  PIU: {
    code: "PIU",
    name: "PIURA",
    chineseName: "皮乌拉",
    traditionalName: "皮烏拉",
    airports: [
      {
        code: "PIU",
        name: "G.concha iberico intl",
        chineseName: "皮乌拉机场",
        traditionalName: "皮烏拉機場",
      },
    ],
  },
  PIX: {
    code: "PIX",
    name: "PICO ISLAND",
    chineseName: "皮科岛",
    traditionalName: "皮科島",
    airports: [
      {
        code: "PIX",
        name: "Pico island airport",
        chineseName: "皮克岛机场",
        traditionalName: "皮克島機場",
      },
    ],
  },
  PIZ: {
    code: "PIZ",
    name: "POINT LAY",
    chineseName: "Point Lay，阿拉斯加",
    traditionalName: "Point Lay， 阿拉斯加",
    airports: [
      {
        code: "PIZ",
        name: "Point lay airport",
        chineseName: "波因特莱机场",
        traditionalName: "波因特萊機場",
      },
    ],
  },
  PJA: {
    code: "PJA",
    name: "PAJALA",
    chineseName: "帕亚拉",
    traditionalName: "帕亞拉",
    airports: [
      {
        code: "PJA",
        name: "Pajala-yllas",
        chineseName: "帕亚拉机场",
        traditionalName: "帕亞拉機場",
      },
    ],
  },
  PJM: {
    code: "PJM",
    name: "PUERTO JIMENEZ",
    chineseName: "希门尼斯港",
    traditionalName: "希門尼斯港",
    airports: [
      {
        code: "PJM",
        name: "Puerto jimenez airport",
        chineseName: "希门尼斯港机场",
        traditionalName: "希門尼斯港機場",
      },
    ],
  },
  PKA: {
    code: "PKA",
    name: "NAPASKIAK",
    chineseName: "阿拉斯加州城市纳帕斯基亚",
    traditionalName: "阿拉斯加州都市納帕斯基亞",
    airports: [
      {
        code: "PKA",
        name: "Napaskiak airport",
        chineseName: "纳帕斯基亚克机场",
        traditionalName: "納帕斯基亞克機場",
      },
    ],
  },
  PKB: {
    code: "PKB",
    name: "PARKERSBURG",
    chineseName: "帕克斯堡",
    traditionalName: "帕克斯堡",
    airports: [
      {
        code: "PKB",
        name: "Mid-ohio valley rgnl",
        chineseName: "帕克斯堡机场",
        traditionalName: "帕克斯堡機場",
      },
    ],
  },
  PKC: {
    code: "PKC",
    name: "PETROPAVLOVSK",
    chineseName: "彼得罗巴甫洛夫斯克",
    traditionalName: "彼得羅巴甫洛夫斯克",
    airports: [
      {
        code: "PKC",
        name: "Yelizovo",
        chineseName: "埃利佐沃机场",
        traditionalName: "埃利佐沃機場",
      },
    ],
  },
  PKE: {
    code: "PKE",
    name: "PARKES",
    chineseName: "帕克斯",
    traditionalName: "帕克斯",
    airports: [
      {
        code: "PKE",
        name: "Parkes airport",
        chineseName: "帕克斯机场",
        traditionalName: "帕克斯機場",
      },
    ],
  },
  PKN: {
    code: "PKN",
    name: "PANGKALANBUUN",
    chineseName: "旁卡兰布翁",
    traditionalName: "旁卡蘭布翁",
    airports: [
      {
        code: "PKN",
        name: "Iskandar",
        chineseName: "依斯干达机场",
        traditionalName: "依斯幹達機場",
      },
    ],
  },
  PKP: {
    code: "PKP",
    name: "PUKA PUKA",
    chineseName: "普卡普卡",
    traditionalName: "普卡普卡",
    airports: [
      {
        code: "PKP",
        name: "Puka puka airport",
        chineseName: "普卡普卡机场",
        traditionalName: "普卡普卡機場",
      },
    ],
  },
  PKR: {
    code: "PKR",
    name: "POKHARA",
    chineseName: "博克拉",
    traditionalName: "博克拉",
    airports: [
      {
        code: "PKR",
        name: "Pokhara airport",
        chineseName: "博卡拉国际机场",
        traditionalName: "博卡拉國際機場",
      },
    ],
  },
  PKU: {
    code: "PKU",
    name: "PEKANBARU",
    chineseName: "北干巴鲁",
    traditionalName: "北乾巴魯",
    airports: [
      {
        code: "PKU",
        name: "Sultan syarif kasim ii",
        chineseName: "苏丹沙里夫卡西姆二世机场",
        traditionalName: "蘇丹沙裏夫卡西姆二世機場",
      },
    ],
  },
  PKV: {
    code: "PKV",
    name: "PSKOV",
    chineseName: "普斯科夫",
    traditionalName: "普斯科夫",
    airports: [
      {
        code: "PKV",
        name: "Pskov airport",
        chineseName: "普斯科夫机场",
        traditionalName: "普斯科夫機場",
      },
    ],
  },
  PKY: {
    code: "PKY",
    name: "PALANGKARAYA",
    chineseName: "帕朗卡拉亚",
    traditionalName: "帕朗卡拉亞",
    airports: [
      {
        code: "PKY",
        name: "Tjilik riwut",
        chineseName: "基里克利乌特机场",
        traditionalName: "基裡克利烏特機場",
      },
    ],
  },
  PKZ: {
    code: "PKZ",
    name: "PAKSE",
    chineseName: "巴色",
    traditionalName: "巴色",
    airports: [
      {
        code: "PKZ",
        name: "Pakse intl.",
        chineseName: "巴色国际机场",
        traditionalName: "巴色國際機場",
      },
    ],
  },
  PLH: {
    code: "PLH",
    name: "PLYMOUTH",
    chineseName: "普利茅斯",
    traditionalName: "普利茅斯",
    airports: [
      {
        code: "PLH",
        name: "City airport",
        chineseName: "普利茅斯机场",
        traditionalName: "普利茅斯機場",
      },
    ],
  },
  PLJ: {
    code: "PLJ",
    name: "PLACENCIA",
    chineseName: "珀拉什奇亚",
    traditionalName: "珀拉什奇亞",
    airports: [
      {
        code: "PLJ",
        name: "Placencia airport",
        chineseName: "普拉森舍机场",
        traditionalName: "普拉森舍機場",
      },
    ],
  },
  PLM: {
    code: "PLM",
    name: "PALEMBANG",
    chineseName: "巨港",
    traditionalName: "巨港",
    airports: [
      {
        code: "PLM",
        name: "S m badaruddin ii",
        chineseName: "苏丹马赫穆德巴达鲁丁二世机场",
        traditionalName: "蘇丹馬赫穆德巴達魯丁二世機場",
      },
    ],
  },
  PLN: {
    code: "PLN",
    name: "PELLSTON",
    chineseName: "皮尔斯顿",
    traditionalName: "皮爾斯頓",
    airports: [
      {
        code: "PLN",
        name: "Regional (emmet co.)",
        chineseName: "佩尔斯顿地区机场",
        traditionalName: "佩爾斯頓地區機場",
      },
    ],
  },
  PLO: {
    code: "PLO",
    name: "PORT LINCOLN",
    chineseName: "林肯港",
    traditionalName: "林肯港",
    airports: [
      {
        code: "PLO",
        name: "Port lincoln airport",
        chineseName: "林肯港机场",
        traditionalName: "林肯港機場",
      },
    ],
  },
  PLQ: {
    code: "PLQ",
    name: "KLAIPEDA/PALANGA",
    chineseName: "帕兰加",
    traditionalName: "帕蘭加",
    airports: [
      {
        code: "PLQ",
        name: "Palanga international",
        chineseName: "帕兰加国际机场",
        traditionalName: "帕蘭加國際機場",
      },
    ],
  },
  PLS: {
    code: "PLS",
    name: "PROVIDENCIALES",
    chineseName: "普罗维登西亚莱斯",
    traditionalName: "普羅維登西亞萊斯",
    airports: [
      {
        code: "PLS",
        name: "Providenciales intl.",
        chineseName: "普罗维登西亚莱斯岛国际机场",
        traditionalName: "普羅維登西亞萊斯島國際機場",
      },
    ],
  },
  PLW: {
    code: "PLW",
    name: "PALU",
    chineseName: "帕卢",
    traditionalName: "帕盧",
    airports: [
      {
        code: "PLW",
        name: "Mutiara",
        chineseName: "穆提阿拉机场",
        traditionalName: "穆提阿拉機場",
      },
    ],
  },
  PLX: {
    code: "PLX",
    name: "SEMEY",
    chineseName: "塞米巴拉金斯克",
    traditionalName: "塞米巴拉金斯克",
    airports: [
      {
        code: "PLX",
        name: "Semey airport",
        chineseName: "塞米伊机场",
        traditionalName: "塞米伊機場",
      },
    ],
  },
  PLZ: {
    code: "PLZ",
    name: "PORT ELIZABETH",
    chineseName: "伊丽莎白港",
    traditionalName: "伊麗沙伯港",
    airports: [
      {
        code: "PLZ",
        name: "Port elizabeth airport",
        chineseName: "伊丽莎白港机场",
        traditionalName: "伊麗沙伯港機場",
      },
    ],
  },
  PMA: {
    code: "PMA",
    name: "PEMBA",
    chineseName: "彭巴",
    traditionalName: "彭巴",
    airports: [
      {
        code: "PMA",
        name: "Pemba airport",
        chineseName: "奔巴机场",
        traditionalName: "奔巴機場",
      },
    ],
  },
  PMC: {
    code: "PMC",
    name: "PUERTO MONTT",
    chineseName: "蒙特港",
    traditionalName: "蒙特港",
    airports: [
      {
        code: "PMC",
        name: "El tepual",
        chineseName: "特普阿尔机场",
        traditionalName: "特普阿爾機場",
      },
    ],
  },
  PMG: {
    code: "PMG",
    name: "PONTA PORA",
    chineseName: "蓬塔波朗",
    traditionalName: "蓬塔波朗",
    airports: [
      {
        code: "PMG",
        name: "Ponta pora intl.",
        chineseName: "蓬塔波朗国际机场",
        traditionalName: "蓬塔波朗國際機場",
      },
    ],
  },
  PMI: {
    code: "PMI",
    name: "PALMA DE MALLORCA",
    chineseName: "马洛卡岛帕尔马",
    traditionalName: "馬婁卡島帕爾馬",
    airports: [
      {
        code: "PMI",
        name: "Palma de mallorca airport",
        chineseName: "帕尔马马拉尔克机场",
        traditionalName: "帕爾馬馬拉爾克機場",
      },
    ],
  },
  PMK: {
    code: "PMK",
    name: "PALM ISLAND",
    chineseName: "棕榈岛",
    traditionalName: "棕櫚島",
    airports: [
      {
        code: "PMK",
        name: "Palm island airport",
        chineseName: "帕姆群岛机场",
        traditionalName: "帕姆群島機場",
      },
    ],
  },
  PML: {
    code: "PML",
    name: "PORT MOLLER",
    chineseName: "阿拉斯加市莫勒",
    traditionalName: "阿拉斯加市莫勒",
    airports: [
      {
        code: "PML",
        name: "Port moller airport",
        chineseName: "莫勒港机场",
        traditionalName: "莫勒港機場",
      },
    ],
  },
  PMO: {
    code: "PMO",
    name: "PALERMO",
    chineseName: "巴勒莫",
    traditionalName: "巴勒莫",
    airports: [
      {
        code: "PMO",
        name: "Punta raisi",
        chineseName: "蓬塔莱希机场",
        traditionalName: "蓬塔萊希機場",
      },
    ],
  },
  PMR: {
    code: "PMR",
    name: "PALMERSTON NORTH",
    chineseName: "北帕默斯顿",
    traditionalName: "北帕默斯頓",
    airports: [
      {
        code: "PMR",
        name: "Palmerston north airport",
        chineseName: "帕默斯顿北机场",
        traditionalName: "帕默斯頓北機場",
      },
    ],
  },
  PMV: {
    code: "PMV",
    name: "PORLAMAR",
    chineseName: "波拉马尔",
    traditionalName: "波拉瑪律",
    airports: [
      {
        code: "PMV",
        name: "Del caribe intl",
        chineseName: "德尔卡里博－根马里诺机场",
        traditionalName: "德爾卡裏博－根馬裏諾機場",
      },
    ],
  },
  PMW: {
    code: "PMW",
    name: "PALMAS",
    chineseName: "帕尔马斯",
    traditionalName: "帕爾馬斯",
    airports: [
      {
        code: "PMW",
        name: "Lysias rodrigues",
        chineseName: "帕尔马斯机场",
        traditionalName: "帕爾馬斯機場",
      },
    ],
  },
  PMY: {
    code: "PMY",
    name: "PUERTO MADRYN",
    chineseName: "马德林",
    traditionalName: "馬德林",
    airports: [
      {
        code: "PMY",
        name: "El tehuelche",
        chineseName: "特胡埃尔切机场",
        traditionalName: "特胡埃爾切機場",
      },
    ],
  },
  PNA: {
    code: "PNA",
    name: "PAMPLONA",
    chineseName: "潘普洛纳",
    traditionalName: "潘普洛納",
    airports: [
      {
        code: "PNA",
        name: "Pamplona airport",
        chineseName: "潘普洛拉机场",
        traditionalName: "潘普洛拉機場",
      },
    ],
  },
  PND: {
    code: "PND",
    name: "PUNTA GORDA",
    chineseName: "蓬塔戈尔达",
    traditionalName: "蓬塔戈爾達",
    airports: [
      {
        code: "PND",
        name: "Punta gorda airport",
        chineseName: "蓬塔戈尔达机场",
        traditionalName: "蓬塔戈爾達機場",
      },
    ],
  },
  PNH: {
    code: "PNH",
    name: "PHNOM PENH",
    chineseName: "金边",
    traditionalName: "金邊",
    airports: [
      {
        code: "PNH",
        name: "Phnom penh intl.",
        chineseName: "金边国际机场",
        traditionalName: "金邊國際機場",
      },
    ],
  },
  PNI: {
    code: "PNI",
    name: "POHNPEI",
    chineseName: "波纳佩",
    traditionalName: "波納佩",
    airports: [
      {
        code: "PNI",
        name: "Pohnpei intl.",
        chineseName: "波恩佩国际机场",
        traditionalName: "波恩佩國際機場",
      },
    ],
  },
  PNK: {
    code: "PNK",
    name: "PONTIANAK",
    chineseName: "坤甸(庞提纳克)",
    traditionalName: "坤甸（龐提納克）",
    airports: [
      {
        code: "PNK",
        name: "Supadio",
        chineseName: "苏帕迪奥机场",
        traditionalName: "蘇帕迪奧機場",
      },
    ],
  },
  PNL: {
    code: "PNL",
    name: "PANTELLERIA",
    chineseName: "潘泰莱里亚",
    traditionalName: "潘泰萊裏亞",
    airports: [
      {
        code: "PNL",
        name: "Pantelleria airport",
        chineseName: "潘泰莱里亚机场",
        traditionalName: "潘泰萊裡亞機場",
      },
    ],
  },
  PNP: {
    code: "PNP",
    name: "POPONDETTA",
    chineseName: "波蓬德塔",
    traditionalName: "波蓬德塔",
    airports: [
      {
        code: "PNP",
        name: "Girua",
        chineseName: "吉鲁阿机场",
        traditionalName: "吉魯阿機場",
      },
    ],
  },
  PNQ: {
    code: "PNQ",
    name: "PUNE",
    chineseName: "浦那",
    traditionalName: "浦那",
    airports: [
      {
        code: "PNQ",
        name: "Lohegaon",
        chineseName: "洛赫加昂机场",
        traditionalName: "洛赫加昂機場",
      },
    ],
  },
  PNR: {
    code: "PNR",
    name: "POINTE-NOIRE",
    chineseName: "黑角",
    traditionalName: "黑角",
    airports: [
      {
        code: "PNR",
        name: "Pointe-noire airport",
        chineseName: "黑角机场",
        traditionalName: "黑角機場",
      },
    ],
  },
  PNS: {
    code: "PNS",
    name: "PENSACOLA",
    chineseName: "彭萨科拉",
    traditionalName: "彭薩科拉",
    airports: [
      {
        code: "PNS",
        name: "Pensacola intl.",
        chineseName: "彭萨科拉国际机场",
        traditionalName: "彭薩科拉國際機場",
      },
    ],
  },
  PNT: {
    code: "PNT",
    name: "PUERTO NATALES",
    chineseName: "纳塔莱斯港",
    traditionalName: "納塔萊斯港",
    airports: [
      {
        code: "PNT",
        name: "Teniente j. gallardo",
        chineseName: "特尼恩特－加拉尔多机场",
        traditionalName: "特尼恩特－加拉爾多機場",
      },
    ],
  },
  PNY: {
    code: "PNY",
    name: "PONDICHERRY",
    chineseName: "本地治里",
    traditionalName: "本地治裡",
    airports: [
      {
        code: "PNY",
        name: "Pondicherry airport",
        chineseName: "本地治里机场",
        traditionalName: "本地治裡機場",
      },
    ],
  },
  PNZ: {
    code: "PNZ",
    name: "PETROLINA",
    chineseName: "彼得罗利纳",
    traditionalName: "彼得羅利納",
    airports: [
      {
        code: "PNZ",
        name: "Senador nilo coelho",
        chineseName: "彼得罗利纳国际机场",
        traditionalName: "彼得羅利納國際機場",
      },
    ],
  },
  POA: {
    code: "POA",
    name: "PORTO ALEGRE",
    chineseName: "阿雷格里港",
    traditionalName: "阿雷格里港",
    airports: [
      {
        code: "POA",
        name: "Salgado filho intl",
        chineseName: "萨尔加多费尔霍国际机场",
        traditionalName: "薩爾加多費爾霍國際機場",
      },
    ],
  },
  POG: {
    code: "POG",
    name: "PORT-GENTIL",
    chineseName: "让蒂尔港",
    traditionalName: "讓蒂爾港",
    airports: [
      {
        code: "POG",
        name: "Port-gentil intl.",
        chineseName: "让蒂尔港机场",
        traditionalName: "讓蒂爾港機場",
      },
    ],
  },
  POJ: {
    code: "POJ",
    name: "PATOS DE MINAS",
    chineseName: "帕图斯迪米纳斯",
    traditionalName: "帕圖斯迪米納斯",
    airports: [
      {
        code: "POJ",
        name: "P.pereira dos santos",
        chineseName: "帕托•德•米纳斯机场",
        traditionalName: "帕托•德•米納斯機場",
      },
    ],
  },
  POL: {
    code: "POL",
    name: "PEMBA",
    chineseName: "彭巴",
    traditionalName: "彭巴",
    airports: [
      {
        code: "POL",
        name: "Pemba airport",
        chineseName: "彭巴机场",
        traditionalName: "彭巴機場",
      },
    ],
  },
  POM: {
    code: "POM",
    name: "PORT MORESBY",
    chineseName: "莫尔兹比港",
    traditionalName: "莫爾斯貝港",
    airports: [
      {
        code: "POM",
        name: "Jacksons international",
        chineseName: "杰克逊国际机场",
        traditionalName: "傑克遜國際機場",
      },
    ],
  },
  POP: {
    code: "POP",
    name: "PUERTO PLATA",
    chineseName: "普拉塔港",
    traditionalName: "普拉塔港",
    airports: [
      {
        code: "POP",
        name: "Gregorio luperon intl",
        chineseName: "格雷戈里奥卢佩龙国际机场",
        traditionalName: "葛列格里奧盧佩龍國際機場",
      },
    ],
  },
  POR: {
    code: "POR",
    name: "PORI",
    chineseName: "波里",
    traditionalName: "波里",
    airports: [
      {
        code: "POR",
        name: "Pori airport",
        chineseName: "波里机场",
        traditionalName: "波里機場",
      },
    ],
  },
  POS: {
    code: "POS",
    name: "PORT OF SPAIN",
    chineseName: "西班牙港",
    traditionalName: "西班牙港",
    airports: [
      {
        code: "POS",
        name: "Piarco intl",
        chineseName: "皮阿尔科国际机场",
        traditionalName: "皮阿爾科國際機場",
      },
    ],
  },
  POZ: {
    code: "POZ",
    name: "POZNAN",
    chineseName: "波兹南",
    traditionalName: "波茲南",
    airports: [
      {
        code: "POZ",
        name: "Lawica",
        chineseName: "拉维卡机场",
        traditionalName: "拉維卡機場",
      },
    ],
  },
  PPB: {
    code: "PPB",
    name: "PRESIDENTE PRUDENTE",
    chineseName: "普鲁登特总统城",
    traditionalName: "普魯登特總統城",
    airports: [
      {
        code: "PPB",
        name: "Presidente prudente airport",
        chineseName: "普鲁登特总统机场",
        traditionalName: "普魯登特總統機場",
      },
    ],
  },
  PPG: {
    code: "PPG",
    name: "PAGO PAGO",
    chineseName: "帕果帕果",
    traditionalName: "帕果帕果",
    airports: [
      {
        code: "PPG",
        name: "Pago pago intl.",
        chineseName: "帕果帕果国际机场",
        traditionalName: "帕果帕果國際機場",
      },
    ],
  },
  PPK: {
    code: "PPK",
    name: "PETROPAVLOVSK",
    chineseName: "彼得罗巴普洛夫斯克",
    traditionalName: "彼得羅巴普洛夫斯克",
    airports: [
      {
        code: "PPK",
        name: "Petropavlovsk airport",
        chineseName: "彼得罗巴甫洛夫斯克机场",
        traditionalName: "彼得羅巴甫洛夫斯克機場",
      },
    ],
  },
  PPL: {
    code: "PPL",
    name: "PHAPLU",
    chineseName: "法普鲁",
    traditionalName: "法普魯",
    airports: [
      {
        code: "PPL",
        name: "Phaplu airport",
        chineseName: "法普鲁机场",
        traditionalName: "法普魯機場",
      },
    ],
  },
  PPN: {
    code: "PPN",
    name: "POPAYAN",
    chineseName: "波帕扬",
    traditionalName: "波帕揚",
    airports: [
      {
        code: "PPN",
        name: "Guillermo l. valencia",
        chineseName: "波帕扬机场",
        traditionalName: "波帕揚機場",
      },
    ],
  },
  PPP: {
    code: "PPP",
    name: "PROSERPINE",
    chineseName: "普罗瑟派恩",
    traditionalName: "普羅瑟派恩",
    airports: [
      {
        code: "PPP",
        name: "Whitsunday coast",
        chineseName: "维特桑迪考斯特机场",
        traditionalName: "維特桑迪考斯特機場",
      },
    ],
  },
  PPQ: {
    code: "PPQ",
    name: "PARAPARAUMU",
    chineseName: "帕拉帕拉乌穆",
    traditionalName: "帕拉帕拉烏穆",
    airports: [
      {
        code: "PPQ",
        name: "Kapiti coast",
        chineseName: "帕拉帕拉乌穆机场",
        traditionalName: "帕拉帕拉烏穆機場",
      },
    ],
  },
  PPS: {
    code: "PPS",
    name: "PUERTO PRINCESA",
    chineseName: "普林塞萨港",
    traditionalName: "普林塞薩港",
    airports: [
      {
        code: "PPS",
        name: "Puerto princesa intl.",
        chineseName: "普林塞萨港机场",
        traditionalName: "普林塞薩港機場",
      },
    ],
  },
  PPT: {
    code: "PPT",
    name: "TAHITI",
    chineseName: "帕皮提",
    traditionalName: "帕比提",
    airports: [
      {
        code: "PPT",
        name: "Faaa",
        chineseName: "法阿机场",
        traditionalName: "法阿機場",
      },
    ],
  },
  PPV: {
    code: "PPV",
    name: "PORT PROTECTION",
    chineseName: "阿拉斯加市港口保护",
    traditionalName: "阿拉斯加市港口保護",
    airports: [
      {
        code: "PPV",
        name: "Sea plane base",
        chineseName: "保护港水上飞机基地",
        traditionalName: "保護港水上飛機基地",
      },
    ],
  },
  PQC: {
    code: "PQC",
    name: "PHU QUOC ISLAND",
    chineseName: "富国岛",
    traditionalName: "富國島",
    airports: [
      {
        code: "PQC",
        name: "Phu quoc island intl.",
        chineseName: "富国岛国际机场",
        traditionalName: "富國島國際機場",
      },
    ],
  },
  PQI: {
    code: "PQI",
    name: "PRESQUE ISLE",
    chineseName: "普雷斯克岛",
    traditionalName: "普雷斯克島",
    airports: [
      {
        code: "PQI",
        name: "Northern maine rgnl",
        chineseName: "普雷斯克岛地方机场",
        traditionalName: "普雷斯克島地方機場",
      },
    ],
  },
  PQQ: {
    code: "PQQ",
    name: "PORT MACQUARIE",
    chineseName: "麦觉理港",
    traditionalName: "麥覺理港",
    airports: [
      {
        code: "PQQ",
        name: "Port macquarie airport",
        chineseName: "麦夸里港机场",
        traditionalName: "麥誇裏港機場",
      },
    ],
  },
  PQS: {
    code: "PQS",
    name: "PILOT STATION",
    chineseName: "阿拉斯加市飞行员",
    traditionalName: "阿拉斯加市飛行員",
    airports: [
      {
        code: "PQS",
        name: "Pilot station airport",
        chineseName: "派勒特站机场",
        traditionalName: "派勒特站機場",
      },
    ],
  },
  PRA: {
    code: "PRA",
    name: "PARANA",
    chineseName: "柏拉拿",
    traditionalName: "柏拉拿",
    airports: [
      {
        code: "PRA",
        name: "General urquiza",
        chineseName: "巴拉那机场",
        traditionalName: "巴拉那機場",
      },
    ],
  },
  PRC: {
    code: "PRC",
    name: "PRESCOTT",
    chineseName: "普雷斯科特",
    traditionalName: "普萊斯考特",
    airports: [
      {
        code: "PRC",
        name: "Ernest a. love field",
        chineseName: "普雷斯科特机场",
        traditionalName: "普萊斯考特機場",
      },
    ],
  },
  PRG: {
    code: "PRG",
    name: "PRAGUE",
    chineseName: "布拉格",
    traditionalName: "布拉格",
    airports: [
      {
        code: "PRG",
        name: "Vaclav havel",
        chineseName: "瓦茨拉夫哈维尔国际机场",
        traditionalName: "瓦茨拉夫哈維爾國際機場",
      },
    ],
  },
  PRI: {
    code: "PRI",
    name: "PRASLIN ISLAND",
    chineseName: "普拉兰岛",
    traditionalName: "普拉蘭島",
    airports: [
      {
        code: "PRI",
        name: "Praslin island airport",
        chineseName: "普拉兰岛机场",
        traditionalName: "普拉蘭島機場",
      },
    ],
  },
  PRM: {
    code: "PRM",
    name: "PORTIMAO",
    chineseName: "波尔蒂芒",
    traditionalName: "波爾蒂芒",
    airports: [
      {
        code: "PRM",
        name: "Portimao airport",
        chineseName: "波尔蒂芒机场",
        traditionalName: "波爾蒂芒機場",
      },
    ],
  },
  PRN: {
    code: "PRN",
    name: "PRISTINA",
    chineseName: "普里什蒂纳",
    traditionalName: "普裡什蒂納",
    airports: [
      {
        code: "PRN",
        name: "Pristina intl.",
        chineseName: "普里什蒂纳国际机场",
        traditionalName: "普裡什蒂納國際機場",
      },
    ],
  },
  PRS: {
    code: "PRS",
    name: "PARASI",
    chineseName: "帕拉西",
    traditionalName: "帕拉西",
    airports: [
      {
        code: "PRS",
        name: "Parasi airport",
        chineseName: "帕拉西机场",
        traditionalName: "帕拉西機場",
      },
    ],
  },
  PSA: {
    code: "PSA",
    name: "PISA",
    chineseName: "比萨",
    traditionalName: "比薩",
    airports: [
      {
        code: "PSA",
        name: "Galileo galilei",
        chineseName: "伽利略伽利莱机场",
        traditionalName: "伽利略伽利萊機場",
      },
    ],
  },
  PSC: {
    code: "PSC",
    name: "PASCO",
    chineseName: "帕斯科",
    traditionalName: "帕斯科",
    airports: [
      {
        code: "PSC",
        name: "Tri-cities",
        chineseName: "特里希提斯机场",
        traditionalName: "特裏希提斯機場",
      },
    ],
  },
  PSE: {
    code: "PSE",
    name: "PONCE",
    chineseName: "庞塞",
    traditionalName: "龐塞",
    airports: [
      {
        code: "PSE",
        name: "Mercedita",
        chineseName: "梅塞迪塔机场",
        traditionalName: "梅塞迪塔機場",
      },
    ],
  },
  PSG: {
    code: "PSG",
    name: "PETERSBURG",
    chineseName: "阿拉斯加城市彼得",
    traditionalName: "阿拉斯加都市彼得",
    airports: [
      {
        code: "PSG",
        name: "James a. johnson",
        chineseName: "詹姆斯约翰逊机场",
        traditionalName: "詹姆斯約翰遜機場",
      },
    ],
  },
  PSO: {
    code: "PSO",
    name: "PASTO",
    chineseName: "帕斯托",
    traditionalName: "帕斯托",
    airports: [
      {
        code: "PSO",
        name: "Antonio narino",
        chineseName: "帕斯托机场",
        traditionalName: "帕斯托機場",
      },
    ],
  },
  PSP: {
    code: "PSP",
    name: "PALM SPRINGS",
    chineseName: "棕榈泉",
    traditionalName: "棕櫚泉",
    airports: [
      {
        code: "PSP",
        name: "Palm springs intl.",
        chineseName: "帕姆斯普林斯国际机场",
        traditionalName: "帕姆斯普林斯國際機場",
      },
    ],
  },
  PSR: {
    code: "PSR",
    name: "PESCARA",
    chineseName: "佩斯卡拉",
    traditionalName: "佩斯卡拉",
    airports: [
      {
        code: "PSR",
        name: "Abruzzo",
        chineseName: "阿布鲁佐机场",
        traditionalName: "阿布魯佐機場",
      },
    ],
  },
  PSS: {
    code: "PSS",
    name: "POSADAS",
    chineseName: "波萨达斯",
    traditionalName: "波薩達斯",
    airports: [
      {
        code: "PSS",
        name: "Jose de san martin",
        chineseName: "何塞圣马丁机场",
        traditionalName: "何塞聖馬丁機場",
      },
    ],
  },
  PSU: {
    code: "PSU",
    name: "PUTUSSIBAU",
    chineseName: "普图西包",
    traditionalName: "普圖西包",
    airports: [
      {
        code: "PSU",
        name: "Pangsuma",
        chineseName: "普图西包机场",
        traditionalName: "普圖西包機場",
      },
    ],
  },
  PTA: {
    code: "PTA",
    name: "PORT ALSWORTH",
    chineseName: "阿拉斯加州阿尔斯沃斯",
    traditionalName: "阿拉斯加州阿爾斯沃斯",
    airports: [
      {
        code: "PTA",
        name: "Port alsworth airport",
        chineseName: "阿尔斯渥斯港机场",
        traditionalName: "阿爾斯渥斯港機場",
      },
    ],
  },
  PTG: {
    code: "PTG",
    name: "POLOKWANE",
    chineseName: "波罗瓜尼",
    traditionalName: "波羅瓜尼",
    airports: [
      {
        code: "PTG",
        name: "Polokwane intl.",
        chineseName: "波罗克瓦内机场",
        traditionalName: "波羅克瓦內機場",
      },
    ],
  },
  PTH: {
    code: "PTH",
    name: "PORT HEIDEN",
    chineseName: "海登港",
    traditionalName: "海頓港",
    airports: [
      {
        code: "PTH",
        name: "Port heiden airport",
        chineseName: "黑登港机场",
        traditionalName: "黑登港機場",
      },
    ],
  },
  PTK: {
    code: "PTK",
    name: "PONTIAC",
    chineseName: "庞蒂亚克",
    traditionalName: "皮蒂亞克",
    airports: [
      {
        code: "PTK",
        name: "Oakland county intl",
        chineseName: "奥克兰县机场",
        traditionalName: "奧克蘭縣機場",
      },
    ],
  },
  PTO: {
    code: "PTO",
    name: "PATO BRANCO",
    chineseName: "帕托布兰科",
    traditionalName: "帕托布蘭科",
    airports: [
      {
        code: "PTO",
        name: "J.loureiro cardoso",
        chineseName: "帕图布兰库机场",
        traditionalName: "帕圖布蘭庫機場",
      },
    ],
  },
  PTP: {
    code: "PTP",
    name: "POINTE-A-PITRE",
    chineseName: "阿比姆",
    traditionalName: "阿比姆",
    airports: [
      {
        code: "PTP",
        name: "Le raizet",
        chineseName: "勒莱泽特机场",
        traditionalName: "勒萊澤特機場",
      },
    ],
  },
  PTQ: {
    code: "PTQ",
    name: "PORTO DE MOZ",
    chineseName: "莫斯港",
    traditionalName: "莫斯港",
    airports: [
      {
        code: "PTQ",
        name: "Porto de moz airport",
        chineseName: "莫斯港机场",
        traditionalName: "莫斯港機場",
      },
    ],
  },
  PTU: {
    code: "PTU",
    name: "PLATINUM",
    chineseName: "普拉蒂纳姆",
    traditionalName: "普拉蒂納姆",
    airports: [
      {
        code: "PTU",
        name: "Platinum airport",
        chineseName: "普拉蒂纳姆机场",
        traditionalName: "普拉蒂納姆機場",
      },
    ],
  },
  PTW: {
    code: "PTW",
    name: "POTTSTOWN",
    chineseName: "宾夕法尼亚州波茨敦",
    traditionalName: "賓夕法尼亞州波茨敦",
    airports: [
      {
        code: "PTW",
        name: "Heritage field",
        chineseName: "Pottstown机场",
        traditionalName: "Pottstown機場",
      },
    ],
  },
  PTX: {
    code: "PTX",
    name: "PITALITO",
    chineseName: "皮塔利托",
    traditionalName: "皮塔利托",
    airports: [
      {
        code: "PTX",
        name: "Pitalito airport",
        chineseName: "皮塔利托机场",
        traditionalName: "皮塔利托機場",
      },
    ],
  },
  PTY: {
    code: "PTY",
    name: "PANAMA CITY",
    chineseName: "巴拿马城",
    traditionalName: "巴拿馬城",
    airports: [
      {
        code: "PAC",
        name: "Marcos a. gelabert int",
        chineseName: "马科斯格拉伯特奥尔布鲁克国际机场",
        traditionalName: "馬可仕格拉伯特奧爾布魯克國際機場",
      },
      {
        code: "PTY",
        name: "Tocumen international",
        chineseName: "托库门国际机场",
        traditionalName: "托庫門國際機場",
      },
    ],
  },
  PUB: {
    code: "PUB",
    name: "PUEBLO",
    chineseName: "普韦布洛",
    traditionalName: "普韋布洛",
    airports: [
      {
        code: "PUB",
        name: "Memorial",
        chineseName: "普埃布罗梅莫里阿尔机场",
        traditionalName: "普埃布羅梅莫裏阿爾機場",
      },
    ],
  },
  PUF: {
    code: "PUF",
    name: "PAU",
    chineseName: "波城",
    traditionalName: "波城",
    airports: [
      {
        code: "PUF",
        name: "Pyrenees",
        chineseName: "乌兹恩机场",
        traditionalName: "烏茲恩機場",
      },
    ],
  },
  PUJ: {
    code: "PUJ",
    name: "PUNTA CANA",
    chineseName: "蓬塔卡纳",
    traditionalName: "蓬塔卡納",
    airports: [
      {
        code: "PUJ",
        name: "Punta cana intl.",
        chineseName: "蓬塔卡纳国际机场",
        traditionalName: "蓬塔卡納國際機場",
      },
    ],
  },
  PUK: {
    code: "PUK",
    name: "PUKARUA",
    chineseName: "普卡鲁阿岛",
    traditionalName: "普卡魯阿島",
    airports: [
      {
        code: "PUK",
        name: "Pukarua airport",
        chineseName: "普卡鲁阿机场",
        traditionalName: "普卡魯阿機場",
      },
    ],
  },
  PUQ: {
    code: "PUQ",
    name: "PUNTA ARENAS",
    chineseName: "蓬塔阿雷纳斯",
    traditionalName: "蓬塔阿雷納斯",
    airports: [
      {
        code: "PUQ",
        name: "C.ibanez del campo",
        chineseName: "普雷斯伊巴内兹机场",
        traditionalName: "普雷斯伊巴內茲機場",
      },
    ],
  },
  PUS: {
    code: "PUS",
    name: "BUSAN",
    chineseName: "釜山",
    traditionalName: "釜山",
    airports: [
      {
        code: "PUS",
        name: "Gimhae intl",
        chineseName: "金海国际机场",
        traditionalName: "金海國際機場",
      },
    ],
  },
  PUU: {
    code: "PUU",
    name: "PUERTO ASIS",
    chineseName: "阿西斯港",
    traditionalName: "阿西斯港",
    airports: [
      {
        code: "PUU",
        name: "Tres de mayo",
        chineseName: "阿西斯港机场",
        traditionalName: "阿西斯港機場",
      },
    ],
  },
  PUW: {
    code: "PUW",
    name: "PULLMAN WA/MOSCOW ID",
    chineseName: "普尔曼",
    traditionalName: "普爾曼",
    airports: [
      {
        code: "PUW",
        name: "Pullman wa/moscow id reg. airp",
        chineseName: "莫斯科地区机场",
        traditionalName: "莫斯科地區機場",
      },
    ],
  },
  PUY: {
    code: "PUY",
    name: "PULA",
    chineseName: "普拉",
    traditionalName: "普拉",
    airports: [
      {
        code: "PUY",
        name: "Pula airport",
        chineseName: "普拉机场",
        traditionalName: "普拉機場",
      },
    ],
  },
  PUZ: {
    code: "PUZ",
    name: "PUERTO CABEZAS",
    chineseName: "卡贝萨斯港",
    traditionalName: "卡貝薩斯港",
    airports: [
      {
        code: "PUZ",
        name: "Puerto cabezas airport",
        chineseName: "卡贝萨斯港机场",
        traditionalName: "卡貝薩斯港機場",
      },
    ],
  },
  PVA: {
    code: "PVA",
    name: "PROVIDENCIA ISLAND",
    chineseName: "普罗维登西亚",
    traditionalName: "普羅維登西亞",
    airports: [
      {
        code: "PVA",
        name: "El embrujo",
        chineseName: "Providencia机场",
        traditionalName: "Providencia機場",
      },
    ],
  },
  PVC: {
    code: "PVC",
    name: "PROVINCETOWN",
    chineseName: "普罗文斯敦",
    traditionalName: "普羅文斯敦",
    airports: [
      {
        code: "PVC",
        name: "Provincetown municipal",
        chineseName: "普罗温斯敦机场",
        traditionalName: "普羅溫斯敦機場",
      },
    ],
  },
  PVD: {
    code: "PVD",
    name: "PROVIDENCE",
    chineseName: "普罗维登斯",
    traditionalName: "普羅維登斯",
    airports: [
      {
        code: "PVD",
        name: "T.f. green state apt",
        chineseName: "西奥多弗朗西斯格林州立机场",
        traditionalName: "西奧多弗朗西斯格林州立機場",
      },
    ],
  },
  PVH: {
    code: "PVH",
    name: "PORTO VELHO",
    chineseName: "波多韦柳",
    traditionalName: "波多韋柳",
    airports: [
      {
        code: "PVH",
        name: "J.t. de oliveira intl",
        chineseName: "德奥利韦拉国际机场",
        traditionalName: "德奧利韋拉國際機場",
      },
    ],
  },
  PVK: {
    code: "PVK",
    name: "PREVEZA/LEFKADA",
    chineseName: "普雷韦扎",
    traditionalName: "普雷韋紮",
    airports: [
      {
        code: "PVK",
        name: "Aktion",
        chineseName: "阿克西翁机场",
        traditionalName: "阿克西翁機場",
      },
    ],
  },
  PVR: {
    code: "PVR",
    name: "PUERTO VALLARTA",
    chineseName: "巴亚尔塔港",
    traditionalName: "巴亞爾塔港",
    airports: [
      {
        code: "PVR",
        name: "G.diaz ordaz intl",
        chineseName: "奥达兹国际机场",
        traditionalName: "奧達茲國際機場",
      },
    ],
  },
  PVU: {
    code: "PVU",
    name: "PROVO",
    chineseName: "普罗沃",
    traditionalName: "普羅沃",
    airports: [
      {
        code: "PVU",
        name: "Provo municipal",
        chineseName: "普若佛机场",
        traditionalName: "普若佛機場",
      },
    ],
  },
  PWE: {
    code: "PWE",
    name: "PEVEK",
    chineseName: "佩韦克",
    traditionalName: "佩韋克",
    airports: [
      {
        code: "PWE",
        name: "Pevek airport",
        chineseName: "佩韦克机场",
        traditionalName: "佩韋克機場",
      },
    ],
  },
  PWM: {
    code: "PWM",
    name: "PORTLAND",
    chineseName: "缅因波特兰",
    traditionalName: "緬因波特蘭",
    airports: [
      {
        code: "PWM",
        name: "Intl jetport",
        chineseName: "波特兰国际喷气机机场",
        traditionalName: "波特蘭國際噴氣機機場",
      },
    ],
  },
  PWQ: {
    code: "PWQ",
    name: "PAVLODAR",
    chineseName: "巴甫洛达尔",
    traditionalName: "巴甫洛達爾",
    airports: [
      {
        code: "PWQ",
        name: "Pavlodar airport",
        chineseName: "巴甫洛达尔机场",
        traditionalName: "巴甫洛達爾機場",
      },
    ],
  },
  PXM: {
    code: "PXM",
    name: "PUERTO ESCONDIDO",
    chineseName: "埃斯孔迪多港",
    traditionalName: "埃斯孔迪多港",
    airports: [
      {
        code: "PXM",
        name: "Puerto escondido intl.",
        chineseName: "埃斯孔迪多港机场",
        traditionalName: "埃斯孔迪多港機場",
      },
    ],
  },
  PXO: {
    code: "PXO",
    name: "PORTO SANTO",
    chineseName: "圣港",
    traditionalName: "聖港",
    airports: [
      {
        code: "PXO",
        name: "Porto santo airport",
        chineseName: "圣港机场",
        traditionalName: "聖港機場",
      },
    ],
  },
  PXU: {
    code: "PXU",
    name: "PLEIKU",
    chineseName: "波来古",
    traditionalName: "波來古",
    airports: [
      {
        code: "PXU",
        name: "Pleiku airport",
        chineseName: "波来古机场",
        traditionalName: "波來古機場",
      },
    ],
  },
  PYB: {
    code: "PYB",
    name: "JEYPORE",
    chineseName: "杰伊布尔",
    traditionalName: "傑伊布爾",
    airports: [
      {
        code: "PYB",
        name: "Jeypore airport",
        chineseName: "Jeypore机场",
        traditionalName: "Jeypore機場",
      },
    ],
  },
  PYG: {
    code: "PYG",
    name: "GANGTOK",
    chineseName: "甘托克",
    traditionalName: "甘托克",
    airports: [
      {
        code: "PYG",
        name: "Pakyong",
        chineseName: "伯蓉机场",
        traditionalName: "伯蓉機場",
      },
    ],
  },
  PYH: {
    code: "PYH",
    name: "PUERTO AYACUCHO",
    chineseName: "阿亚库乔港",
    traditionalName: "阿亞庫喬港",
    airports: [
      {
        code: "PYH",
        name: "Cacique aramare",
        chineseName: "阿亚库乔港机场",
        traditionalName: "阿亞庫喬港機場",
      },
    ],
  },
  PYJ: {
    code: "PYJ",
    name: "POLYARNY",
    chineseName: "波利安伊",
    traditionalName: "波利安伊",
    airports: [
      {
        code: "PYJ",
        name: "Polyarny airport",
        chineseName: "波利安伊机场",
        traditionalName: "波利安伊機場",
      },
    ],
  },
  PYT: {
    code: "PYT",
    name: "PARACATU",
    chineseName: "帕拉卡图",
    traditionalName: "帕拉卡圖",
    airports: [
      {
        code: "PYT",
        name: "Paracatu airport",
        chineseName: "帕拉卡图机场",
        traditionalName: "帕拉卡圖機場",
      },
    ],
  },
  PZB: {
    code: "PZB",
    name: "PIETERMARITZBURG",
    chineseName: "彼得马里茨堡",
    traditionalName: "彼得馬裏茨堡",
    airports: [
      {
        code: "PZB",
        name: "Pietermaritzburg airport",
        chineseName: "彼得马里茨堡机场",
        traditionalName: "彼得馬裏茨堡機場",
      },
    ],
  },
  PZI: {
    code: "PZI",
    name: "PANZHIHUA",
    chineseName: "攀枝花",
    traditionalName: "攀枝花",
    airports: [
      {
        code: "PZI",
        name: "Bao'angong",
        chineseName: "保安营机场",
        traditionalName: "警衛營機場",
      },
    ],
  },
  PZO: {
    code: "PZO",
    name: "PUERTO ORDAZ",
    chineseName: "奥尔达斯港",
    traditionalName: "奧爾達斯港",
    airports: [
      {
        code: "PZO",
        name: "Manuel carlos piar",
        chineseName: "奥尔达斯港机场",
        traditionalName: "奧爾達斯港機場",
      },
    ],
  },
  PZU: {
    code: "PZU",
    name: "PORT SUDAN",
    chineseName: "苏丹港",
    traditionalName: "蘇丹港",
    airports: [
      {
        code: "PZU",
        name: "New international",
        chineseName: "苏丹港新国际机场",
        traditionalName: "蘇丹港新國際機場",
      },
    ],
  },
  PZY: {
    code: "PZY",
    name: "PIESTANY",
    chineseName: "皮耶什佳尼",
    traditionalName: "皮耶什佳尼",
    airports: [
      {
        code: "PZY",
        name: "Piestany airport",
        chineseName: "皮耶什佳尼机场",
        traditionalName: "皮耶什佳尼機場",
      },
    ],
  },
  QBC: {
    code: "QBC",
    name: "BELLA COOLA",
    chineseName: "贝拉库拉",
    traditionalName: "貝拉庫拉",
    airports: [
      {
        code: "QBC",
        name: "Bella coola airport",
        chineseName: "贝拉库拉机场",
        traditionalName: "貝拉庫拉機場",
      },
    ],
  },
  QGP: {
    code: "QGP",
    name: "GARANHUNS",
    chineseName: "加拉尼温斯",
    traditionalName: "加拉尼溫斯",
    airports: [
      {
        code: "QGP",
        name: "Garanhuns airport",
        chineseName: "加拉尼温斯机场",
        traditionalName: "加拉尼溫斯機場",
      },
    ],
  },
  QIG: {
    code: "QIG",
    name: "IGUATU",
    chineseName: "伊瓜图",
    traditionalName: "伊瓜圖",
    airports: [
      {
        code: "QIG",
        name: "Iguatu airport",
        chineseName: "伊瓜图机场",
        traditionalName: "伊瓜圖機場",
      },
    ],
  },
  QIN: {
    code: "QIN",
    name: "MERSIN",
    chineseName: "梅尔辛",
    traditionalName: "梅爾辛",
    airports: [
      {
        code: "COV",
        name: "Cukurova",
        chineseName: "库库罗瓦机场",
        traditionalName: "庫庫羅瓦機場",
      },
    ],
  },
  QOW: {
    code: "QOW",
    name: "OWERRI",
    chineseName: "伊莫",
    traditionalName: "伊莫",
    airports: [
      {
        code: "QOW",
        name: "Sam mbakwe intl",
        chineseName: "奥韦里机场",
        traditionalName: "奧韋裡機場",
      },
    ],
  },
  QRO: {
    code: "QRO",
    name: "QUERETARO",
    chineseName: "克雷塔罗",
    traditionalName: "克雷塔羅",
    airports: [
      {
        code: "QRO",
        name: "Intercontinental",
        chineseName: "克雷塔罗国际机场",
        traditionalName: "克雷塔羅國際機場",
      },
    ],
  },
  QRW: {
    code: "QRW",
    name: "WARRI",
    chineseName: "瓦里",
    traditionalName: "瓦裡",
    airports: [
      {
        code: "QRW",
        name: "Osubi",
        chineseName: "瓦利机场",
        traditionalName: "瓦利機場",
      },
    ],
  },
  QSF: {
    code: "QSF",
    name: "SETIF",
    chineseName: "塞蒂夫",
    traditionalName: "塞蒂夫",
    airports: [
      {
        code: "QSF",
        name: "8 mai 45",
        chineseName: "塞蒂夫机场",
        traditionalName: "塞蒂夫機場",
      },
    ],
  },
  QSR: {
    code: "QSR",
    name: "SALERNO",
    chineseName: "萨勒诺",
    traditionalName: "薩勒諾",
    airports: [
      {
        code: "QSR",
        name: "Pontecagnano",
        chineseName: "蓬泰卡尼亚诺机场",
        traditionalName: "蓬泰卡尼亞諾機場",
      },
    ],
  },
  QSZ: {
    code: "QSZ",
    name: "SHACHE",
    chineseName: "莎车",
    traditionalName: "莎車",
    airports: [
      {
        code: "QSZ",
        name: "Yeerqiang",
        chineseName: "叶尔羌机场",
        traditionalName: "葉爾羌機場",
      },
    ],
  },
  QUO: {
    code: "QUO",
    name: "UYO",
    chineseName: "乌约",
    traditionalName: "烏約",
    airports: [
      {
        code: "QUO",
        name: "Akwa ibom intl",
        chineseName: "阿克瓦伊博姆机场",
        traditionalName: "阿克瓦伊博姆機場",
      },
    ],
  },
  RAB: {
    code: "RAB",
    name: "RABAUL",
    chineseName: "拉包尔",
    traditionalName: "拉包爾",
    airports: [
      {
        code: "RAB",
        name: "Tokua",
        chineseName: "托库阿机场",
        traditionalName: "托庫阿機場",
      },
    ],
  },
  RAE: {
    code: "RAE",
    name: "ARAR",
    chineseName: "阿拉",
    traditionalName: "阿拉",
    airports: [
      {
        code: "RAE",
        name: "Arar airport",
        chineseName: "阿拉机场",
        traditionalName: "阿拉機場",
      },
    ],
  },
  RAH: {
    code: "RAH",
    name: "RAFHA",
    chineseName: "拉夫哈",
    traditionalName: "拉夫哈",
    airports: [
      {
        code: "RAH",
        name: "Rafha airport",
        chineseName: "拉夫哈机场",
        traditionalName: "拉夫哈機場",
      },
    ],
  },
  RAI: {
    code: "RAI",
    name: "PRAIA",
    chineseName: "普拉亚",
    traditionalName: "培亞",
    airports: [
      {
        code: "RAI",
        name: "Praia intl.",
        chineseName: "普拉亚国际机场",
        traditionalName: "培亞國際機場",
      },
    ],
  },
  RAK: {
    code: "RAK",
    name: "MARRAKECH",
    chineseName: "马拉喀什",
    traditionalName: "馬拉喀什",
    airports: [
      {
        code: "RAK",
        name: "Menara",
        chineseName: "梅纳拉机场",
        traditionalName: "梅納拉機場",
      },
    ],
  },
  RAL: {
    code: "RAL",
    name: "RIVERSIDE",
    chineseName: "河滨城",
    traditionalName: "河濱城",
    airports: [
      {
        code: "RIV",
        name: "March jarb",
        chineseName: "马奇空军预备役基地",
        traditionalName: "馬奇空軍預備役基地",
      },
    ],
  },
  RAM: {
    code: "RAM",
    name: "RAMINGINING",
    chineseName: "瑞明吉宁",
    traditionalName: "瑞明吉寧",
    airports: [
      {
        code: "RAM",
        name: "Ramingining airport",
        chineseName: "拉明集宁机场",
        traditionalName: "拉明集寧機場",
      },
    ],
  },
  RAO: {
    code: "RAO",
    name: "RIBEIRAO PRETO",
    chineseName: "里贝朗普雷图",
    traditionalName: "里貝朗普雷圖",
    airports: [
      {
        code: "RAO",
        name: "Leite lopes",
        chineseName: "莱特洛佩斯机场",
        traditionalName: "萊特洛佩斯機場",
      },
    ],
  },
  RAP: {
    code: "RAP",
    name: "RAPID CITY",
    chineseName: "拉皮德城",
    traditionalName: "拉皮德城",
    airports: [
      {
        code: "RAP",
        name: "Rapid city reg. airport",
        chineseName: "拉皮德城地区机场",
        traditionalName: "拉皮德城地區機場",
      },
    ],
  },
  RAQ: {
    code: "RAQ",
    name: "MUNA",
    chineseName: "穆纳岛",
    traditionalName: "穆納島",
    airports: [
      {
        code: "RAQ",
        name: "Sugimanuru",
        chineseName: "苏基马努鲁机场",
        traditionalName: "蘇基馬努魯機場",
      },
    ],
  },
  RAR: {
    code: "RAR",
    name: "RAROTONGA ISLAND",
    chineseName: "拉罗汤加",
    traditionalName: "拉羅湯加",
    airports: [
      {
        code: "RAR",
        name: "Rarotonga island airport",
        chineseName: "拉罗汤加岛机场",
        traditionalName: "拉羅東加島機場",
      },
    ],
  },
  RAS: {
    code: "RAS",
    name: "RASHT",
    chineseName: "拉什特",
    traditionalName: "拉什特",
    airports: [
      {
        code: "RAS",
        name: "Sandra-e-jangal",
        chineseName: "拉什特机场",
        traditionalName: "拉什特機場",
      },
    ],
  },
  RBA: {
    code: "RBA",
    name: "RABAT",
    chineseName: "拉巴特",
    traditionalName: "拉巴特",
    airports: [
      {
        code: "RBA",
        name: "Sale",
        chineseName: "塞尔机场",
        traditionalName: "塞爾機場",
      },
    ],
  },
  RBB: {
    code: "RBB",
    name: "BORBA",
    chineseName: "博尔巴",
    traditionalName: "博爾巴",
    airports: [
      {
        code: "RBB",
        name: "Borba airport",
        chineseName: "博尔巴机场",
        traditionalName: "博爾巴機場",
      },
    ],
  },
  RBQ: {
    code: "RBQ",
    name: "RURRENABAQUE",
    chineseName: "鲁雷纳瓦克",
    traditionalName: "魯雷納瓦克",
    airports: [
      {
        code: "RBQ",
        name: "Rurrenabaque airport",
        chineseName: "鲁雷纳瓦克机场",
        traditionalName: "魯雷納瓦克機場",
      },
    ],
  },
  RBR: {
    code: "RBR",
    name: "RIO BRANCO",
    chineseName: "里奥布朗库",
    traditionalName: "里奧布朗庫",
    airports: [
      {
        code: "RBR",
        name: "Placido de castro intl",
        chineseName: "里奥布朗库机场",
        traditionalName: "里奧布朗庫機場",
      },
    ],
  },
  RBV: {
    code: "RBV",
    name: "RAMATA ISLAND",
    chineseName: "拉玛塔",
    traditionalName: "拉瑪塔",
    airports: [
      {
        code: "RBV",
        name: "Ramata island airport",
        chineseName: "拉马塔机场",
        traditionalName: "拉馬塔機場",
      },
    ],
  },
  RBY: {
    code: "RBY",
    name: "RUBY",
    chineseName: "鲁比",
    traditionalName: "魯比",
    airports: [
      {
        code: "RBY",
        name: "Ruby airport",
        chineseName: "鲁比机场",
        traditionalName: "魯比機場",
      },
    ],
  },
  RCB: {
    code: "RCB",
    name: "RICHARDS BAY",
    chineseName: "里查兹贝",
    traditionalName: "裏查茲貝",
    airports: [
      {
        code: "RCB",
        name: "Richards bay airport",
        chineseName: "理查德湾机场",
        traditionalName: "理查灣機場",
      },
    ],
  },
  RCE: {
    code: "RCE",
    name: "ROCHE HARBOR",
    chineseName: "罗氏港",
    traditionalName: "羅氏港",
    airports: [
      {
        code: "RCE",
        name: "Sea plane base",
        chineseName: "罗奇湾机场",
        traditionalName: "羅奇灣機場",
      },
    ],
  },
  RCH: {
    code: "RCH",
    name: "RIOHACHA",
    chineseName: "里奥阿查",
    traditionalName: "里奧阿查",
    airports: [
      {
        code: "RCH",
        name: "Almirante padilla",
        chineseName: "里奥阿查机场",
        traditionalName: "里奧阿查機場",
      },
    ],
  },
  RCM: {
    code: "RCM",
    name: "RICHMOND",
    chineseName: "里士满",
    traditionalName: "里士滿",
    airports: [
      {
        code: "RCM",
        name: "Richmond airport",
        chineseName: "里士满机场",
        traditionalName: "里士滿機場",
      },
    ],
  },
  RCU: {
    code: "RCU",
    name: "RIO CUARTO",
    chineseName: "里奥夸尔托",
    traditionalName: "裡奧誇爾托",
    airports: [
      {
        code: "RCU",
        name: "Las higueras",
        chineseName: "里奥夸尔多机场",
        traditionalName: "裏奧誇爾多機場",
      },
    ],
  },
  RDB: {
    code: "RDB",
    name: "RED DOG",
    chineseName: "红狗，阿拉斯加",
    traditionalName: "紅狗，阿拉斯加",
    airports: [
      {
        code: "RDB",
        name: "Red dog airport",
        chineseName: "雷德道格机场",
        traditionalName: "雷德道格機場",
      },
    ],
  },
  RDD: {
    code: "RDD",
    name: "REDDING",
    chineseName: "雷丁",
    traditionalName: "雷丁",
    airports: [
      {
        code: "RDD",
        name: "Redding municipal",
        chineseName: "雷丁机场",
        traditionalName: "雷丁機場",
      },
    ],
  },
  RDG: {
    code: "RDG",
    name: "READING",
    chineseName: "雷丁",
    traditionalName: "雷丁",
    airports: [
      {
        code: "RDG",
        name: "Reading reg. airport",
        chineseName: "雷丁机场",
        traditionalName: "雷丁機場",
      },
    ],
  },
  RDM: {
    code: "RDM",
    name: "REDMOND/BEND",
    chineseName: "雷德蒙德",
    traditionalName: "雷德蒙德",
    airports: [
      {
        code: "RDM",
        name: "Roberts field",
        chineseName: "罗伯茨机场",
        traditionalName: "羅伯茨機場",
      },
    ],
  },
  RDN: {
    code: "RDN",
    name: "REDANG ISLAND",
    chineseName: "热浪岛",
    traditionalName: "熱浪島",
    airports: [
      {
        code: "RDN",
        name: "Redang island airport",
        chineseName: "热浪岛机场",
        traditionalName: "熱浪島機場",
      },
    ],
  },
  RDP: {
    code: "RDP",
    name: "DURGAPUR",
    chineseName: "杜尔加布尔",
    traditionalName: "杜爾加布林",
    airports: [
      {
        code: "RDP",
        name: "Kazi nazrul islam",
        chineseName: "纳兹鲁尔机场",
        traditionalName: "納茲魯爾機場",
      },
    ],
  },
  RDU: {
    code: "RDU",
    name: "RALEIGH/DURHAM",
    chineseName: "罗利",
    traditionalName: "羅利",
    airports: [
      {
        code: "RDU",
        name: "Raleigh/durham intl.",
        chineseName: "罗利国际机场",
        traditionalName: "羅利國際機場",
      },
    ],
  },
  RDV: {
    code: "RDV",
    name: "RED DEVIL",
    chineseName: "雷德德维尔",
    traditionalName: "雷德德維爾",
    airports: [
      {
        code: "RDV",
        name: "Red devil airport",
        chineseName: "雷德德维尔机场",
        traditionalName: "雷德德維爾機場",
      },
    ],
  },
  RDZ: {
    code: "RDZ",
    name: "RODEZ",
    chineseName: "罗德兹",
    traditionalName: "羅德茲",
    airports: [
      {
        code: "RDZ",
        name: "Marcillac",
        chineseName: "马希拉克机场",
        traditionalName: "馬希拉克機場",
      },
    ],
  },
  REA: {
    code: "REA",
    name: "REAO",
    chineseName: "雷奥环礁",
    traditionalName: "雷奧環礁",
    airports: [
      {
        code: "REA",
        name: "Reao airport",
        chineseName: "雷奥机场",
        traditionalName: "雷奧機場",
      },
    ],
  },
  REC: {
    code: "REC",
    name: "RECIFE",
    chineseName: "累西腓",
    traditionalName: "累西腓",
    airports: [
      {
        code: "REC",
        name: "Guararapes intl",
        chineseName: "瓜拉拉佩斯国际机场",
        traditionalName: "瓜拉拉佩斯國際機場",
      },
    ],
  },
  REG: {
    code: "REG",
    name: "REGGIO DI CALABRIA",
    chineseName: "雷焦卡拉布里亚",
    traditionalName: "雷焦卡拉布裡亞",
    airports: [
      {
        code: "REG",
        name: "Reggio di calabria airport",
        chineseName: "雷焦卡拉布里亚机场",
        traditionalName: "雷焦卡拉布裡亞機場",
      },
    ],
  },
  REK: {
    code: "REK",
    name: "REYKJAVIK",
    chineseName: "雷克雅未克",
    traditionalName: "雷克雅維克",
    airports: [
      {
        code: "KEF",
        name: "Keflavik international",
        chineseName: "凯夫拉维克国际机场",
        traditionalName: "凱夫拉維克國際機場",
      },
      {
        code: "RKV",
        name: "Reykjavik domestic",
        chineseName: "雷克雅未克国内机场",
        traditionalName: "雷克雅維克國內機場",
      },
    ],
  },
  REL: {
    code: "REL",
    name: "TRELEW",
    chineseName: "特雷利乌",
    traditionalName: "特雷利烏",
    airports: [
      {
        code: "REL",
        name: "Almirante m.a. zar",
        chineseName: "特雷利乌机场",
        traditionalName: "特雷利烏機場",
      },
    ],
  },
  REN: {
    code: "REN",
    name: "ORENBURG",
    chineseName: "奥伦堡",
    traditionalName: "奧倫堡",
    airports: [
      {
        code: "REN",
        name: "Tsentralny",
        chineseName: "特森特拉尼机场",
        traditionalName: "特森特拉尼機場",
      },
    ],
  },
  RER: {
    code: "RER",
    name: "RETALHULEU",
    chineseName: "雷塔卢莱乌",
    traditionalName: "雷塔盧萊烏",
    airports: [
      {
        code: "RER",
        name: "Retalhuleu airport",
        chineseName: "雷塔卢莱乌机场",
        traditionalName: "雷塔盧萊烏機場",
      },
    ],
  },
  RES: {
    code: "RES",
    name: "RESISTENCIA",
    chineseName: "雷西斯滕西亚",
    traditionalName: "雷西斯滕西亞",
    airports: [
      {
        code: "RES",
        name: "Resistencia airport",
        chineseName: "雷西斯滕西亚机场",
        traditionalName: "雷西斯滕西亞機場",
      },
    ],
  },
  RET: {
    code: "RET",
    name: "ROST",
    chineseName: "罗斯特",
    traditionalName: "羅斯特",
    airports: [
      {
        code: "RET",
        name: "Rost airport",
        chineseName: "斯托尔波特机场",
        traditionalName: "斯托爾波特機場",
      },
    ],
  },
  REU: {
    code: "REU",
    name: "REUS",
    chineseName: "雷乌斯",
    traditionalName: "雷烏斯",
    airports: [
      {
        code: "REU",
        name: "Reus airport",
        chineseName: "雷乌斯机场",
        traditionalName: "雷烏斯機場",
      },
    ],
  },
  REX: {
    code: "REX",
    name: "REYNOSA",
    chineseName: "雷诺萨",
    traditionalName: "雷諾薩",
    airports: [
      {
        code: "REX",
        name: "Lucio blanco intl",
        chineseName: "卢西奥布兰科将军国际机场",
        traditionalName: "盧西奧布蘭科將軍國際機場",
      },
    ],
  },
  REZ: {
    code: "REZ",
    name: "RESENDE",
    chineseName: "雷森德",
    traditionalName: "雷森德",
    airports: [
      {
        code: "REZ",
        name: "Resende airport",
        chineseName: "雷森德机场",
        traditionalName: "雷森德機場",
      },
    ],
  },
  RFP: {
    code: "RFP",
    name: "RAIATEA",
    chineseName: "赖阿特阿岛",
    traditionalName: "賴阿特阿島",
    airports: [
      {
        code: "RFP",
        name: "Uturoa",
        chineseName: "莱阿提阿机场",
        traditionalName: "萊阿提阿機場",
      },
    ],
  },
  RGA: {
    code: "RGA",
    name: "RIO GRANDE",
    chineseName: "里奥格兰德",
    traditionalName: "裏奧格蘭德",
    airports: [
      {
        code: "RGA",
        name: "Hermes quijada",
        chineseName: "里奥格兰德机场",
        traditionalName: "裏奧格蘭德機場",
      },
    ],
  },
  RGI: {
    code: "RGI",
    name: "RANGIROA",
    chineseName: "伦吉拉环礁",
    traditionalName: "倫吉拉環礁",
    airports: [
      {
        code: "RGI",
        name: "Rangiroa airport",
        chineseName: "朗伊罗阿机场",
        traditionalName: "朗伊羅阿機場",
      },
    ],
  },
  RGK: {
    code: "RGK",
    name: "GORNO-ALTAYSK",
    chineseName: "戈尔诺-阿尔泰斯克",
    traditionalName: "戈爾諾-阿爾泰斯克",
    airports: [
      {
        code: "RGK",
        name: "Gorno-altaysk airport",
        chineseName: "戈尔诺·阿尔泰斯克机场",
        traditionalName: "戈爾諾·阿爾泰斯克機場",
      },
    ],
  },
  RGL: {
    code: "RGL",
    name: "RIO GALLEGOS",
    chineseName: "里奥加耶戈斯",
    traditionalName: "里奧戈耶斯省",
    airports: [
      {
        code: "RGL",
        name: "Piloto n. fernandez",
        chineseName: "里奥加耶戈斯国际机场",
        traditionalName: "里奧戈耶斯省國際機場",
      },
    ],
  },
  RGN: {
    code: "RGN",
    name: "YANGON",
    chineseName: "仰光",
    traditionalName: "仰光",
    airports: [
      {
        code: "RGN",
        name: "Yangon intl.",
        chineseName: "仰光国际机场",
        traditionalName: "仰光國際機場",
      },
    ],
  },
  RGS: {
    code: "RGS",
    name: "BURGOS",
    chineseName: "布尔戈斯",
    traditionalName: "布林戈斯",
    airports: [
      {
        code: "RGS",
        name: "Burgos airport",
        chineseName: "布尔戈斯机场",
        traditionalName: "布林戈斯機場",
      },
    ],
  },
  RHD: {
    code: "RHD",
    name: "TERMAS DE RIO HONDO",
    chineseName: "瑞航德",
    traditionalName: "瑞航德",
    airports: [
      {
        code: "RHD",
        name: "Termas de rio hondo airport",
        chineseName: "里奥翁多机场",
        traditionalName: "裏奧翁多機場",
      },
    ],
  },
  RHI: {
    code: "RHI",
    name: "RHINELANDER",
    chineseName: "莱茵兰德",
    traditionalName: "萊茵蘭德",
    airports: [
      {
        code: "RHI",
        name: "Oneida county",
        chineseName: "奥涅达郡机场",
        traditionalName: "奧涅達郡機場",
      },
    ],
  },
  RHO: {
    code: "RHO",
    name: "RHODES",
    chineseName: "罗得岛",
    traditionalName: "羅德島",
    airports: [
      {
        code: "RHO",
        name: "Diagoras",
        chineseName: "迪阿格拉斯机场",
        traditionalName: "迪阿格拉斯機場",
      },
    ],
  },
  RHP: {
    code: "RHP",
    name: "RAMECHHAP",
    chineseName: "拉梅奇哈普",
    traditionalName: "拉梅奇哈普",
    airports: [
      {
        code: "RHP",
        name: "Ramechhap airport",
        chineseName: "拉梅奇哈普机场",
        traditionalName: "拉梅奇哈普機場",
      },
    ],
  },
  RIA: {
    code: "RIA",
    name: "SANTA MARIA",
    chineseName: "圣玛丽亚",
    traditionalName: "聖瑪麗亞",
    airports: [
      {
        code: "RIA",
        name: "Santa maria airport",
        chineseName: "圣马丽亚机场",
        traditionalName: "聖馬麗亞機場",
      },
    ],
  },
  RIB: {
    code: "RIB",
    name: "RIBERALTA",
    chineseName: "里韦拉尔塔",
    traditionalName: "裏韋拉爾塔",
    airports: [
      {
        code: "RIB",
        name: "Riberalta airport",
        chineseName: "里韦拉尔塔机场",
        traditionalName: "裏韋拉爾塔機場",
      },
    ],
  },
  RIC: {
    code: "RIC",
    name: "RICHMOND",
    chineseName: "里士满",
    traditionalName: "里士滿",
    airports: [
      {
        code: "RIC",
        name: "Richmond intl.",
        chineseName: "里士满国际机场",
        traditionalName: "里士滿國際機場",
      },
    ],
  },
  RIH: {
    code: "RIH",
    name: "RIO HATO",
    chineseName: "里约哈托",
    traditionalName: "裡約哈托",
    airports: [
      {
        code: "RIH",
        name: "Scarlett martinez intl",
        chineseName: "斯佳丽马丁内斯国际机场",
        traditionalName: "斯佳麗馬丁內斯國際機場",
      },
    ],
  },
  RIL: {
    code: "RIL",
    name: "RIFLE",
    chineseName: "来福",
    traditionalName: "來福",
    airports: [
      {
        code: "RIL",
        name: "Garfield county rgnl",
        chineseName: "赖夫尔机场",
        traditionalName: "賴夫爾機場",
      },
    ],
  },
  RIO: {
    code: "RIO",
    name: "RIO DE JANEIRO",
    chineseName: "里约热内卢",
    traditionalName: "里約熱內盧",
    airports: [
      {
        code: "GIG",
        name: "Galeao-a.c.jobim intl",
        chineseName: "里约热内卢国际机场",
        traditionalName: "里約熱內盧國際機場",
      },
      {
        code: "RRJ",
        name: "Jacarepagua",
        chineseName: "雅卡雷帕瓜机场",
        traditionalName: "雅卡雷帕瓜機場",
      },
      {
        code: "SDU",
        name: "Santos dumont",
        chineseName: "桑托斯杜蒙特机场",
        traditionalName: "桑托斯杜蒙特機場",
      },
    ],
  },
  RIS: {
    code: "RIS",
    name: "RISHIRI",
    chineseName: "里希里",
    traditionalName: "裏希裏",
    airports: [
      {
        code: "RIS",
        name: "Rishiri airport",
        chineseName: "利尻机场",
        traditionalName: "利尻機場",
      },
    ],
  },
  RIW: {
    code: "RIW",
    name: "RIVERTON",
    chineseName: "怀俄明州里弗顿",
    traditionalName: "懷俄明州裏弗頓",
    airports: [
      {
        code: "RIW",
        name: "Riverton reg. airport",
        chineseName: "里弗顿机场",
        traditionalName: "裏弗頓機場",
      },
    ],
  },
  RIX: {
    code: "RIX",
    name: "RIGA",
    chineseName: "里加",
    traditionalName: "裏加",
    airports: [
      {
        code: "RIX",
        name: "Riga intl.",
        chineseName: "里加国际机场",
        traditionalName: "裏加國際機場",
      },
    ],
  },
  RIY: {
    code: "RIY",
    name: "MUKALLA",
    chineseName: "里雅恩",
    traditionalName: "裏雅恩",
    airports: [
      {
        code: "RIY",
        name: "Riyan",
        chineseName: "里扬机场",
        traditionalName: "裏揚機場",
      },
    ],
  },
  RIZ: {
    code: "RIZ",
    name: "RIZHAO",
    chineseName: "日照",
    traditionalName: "日照",
    airports: [
      {
        code: "RIZ",
        name: "Shanzihe",
        chineseName: "山字河机场",
        traditionalName: "山字河機場",
      },
    ],
  },
  RJA: {
    code: "RJA",
    name: "RAJAHMUNDRY",
    chineseName: "拉贾蒙德里",
    traditionalName: "拉賈蒙德里",
    airports: [
      {
        code: "RJA",
        name: "Rajahmundry airport",
        chineseName: "拉贾蒙德里机场",
        traditionalName: "拉賈蒙德里機場",
      },
    ],
  },
  RJB: {
    code: "RJB",
    name: "RAJBIRAJ",
    chineseName: "Rajbiraj",
    traditionalName: "Rajbiraj",
    airports: [
      {
        code: "RJB",
        name: "Rajbiraj airport",
        chineseName: "拉吉比拉吉机场",
        traditionalName: "拉吉比拉吉機場",
      },
    ],
  },
  RJH: {
    code: "RJH",
    name: "RAJSHAHI",
    chineseName: "拉杰沙希",
    traditionalName: "拉傑沙希",
    airports: [
      {
        code: "RJH",
        name: "Shah makhdum",
        chineseName: "拉杰沙希机场",
        traditionalName: "拉傑沙希機場",
      },
    ],
  },
  RJK: {
    code: "RJK",
    name: "RIJEKA",
    chineseName: "里耶卡",
    traditionalName: "里耶卡",
    airports: [
      {
        code: "RJK",
        name: "Rijeka airport",
        chineseName: "里耶卡机场",
        traditionalName: "里耶卡機場",
      },
    ],
  },
  RJL: {
    code: "RJL",
    name: "LOGRONO",
    chineseName: "洛格罗尼奥",
    traditionalName: "洛格羅尼奧",
    airports: [
      {
        code: "RJL",
        name: "Agoncillo",
        chineseName: "阿格恩希洛机场",
        traditionalName: "阿格恩希洛機場",
      },
    ],
  },
  RKA: {
    code: "RKA",
    name: "ARATIKA",
    chineseName: "阿拉蒂卡环礁",
    traditionalName: "阿拉蒂卡環礁",
    airports: [
      {
        code: "RKA",
        name: "Aratika-nord",
        chineseName: "阿拉蒂卡机场",
        traditionalName: "阿拉蒂卡機場",
      },
    ],
  },
  RKD: {
    code: "RKD",
    name: "ROCKLAND",
    chineseName: "缅因州罗克兰",
    traditionalName: "緬因州羅克蘭",
    airports: [
      {
        code: "RKD",
        name: "Knox county regional",
        chineseName: "诺克斯郡地区机场",
        traditionalName: "諾克斯郡地區機場",
      },
    ],
  },
  RKS: {
    code: "RKS",
    name: "ROCK SPRINGS",
    chineseName: "怀俄明州岩石泉",
    traditionalName: "懷俄明州岩石泉",
    airports: [
      {
        code: "RKS",
        name: "Sweetwater county",
        chineseName: "斯威特沃特郡机场",
        traditionalName: "斯威特沃特郡機場",
      },
    ],
  },
  RKT: {
    code: "RKT",
    name: "RAS AL KHAIMAH",
    chineseName: "哈伊马角",
    traditionalName: "哈伊馬角",
    airports: [
      {
        code: "RKT",
        name: "Ras al khaimah intl.",
        chineseName: "哈伊马角国际机场",
        traditionalName: "哈伊馬角國際機場",
      },
    ],
  },
  RKZ: {
    code: "RKZ",
    name: "XIGAZE/RIKAZE",
    chineseName: "日喀则",
    traditionalName: "日喀則",
    airports: [
      {
        code: "RKZ",
        name: "Peace",
        chineseName: "日喀则和平机场",
        traditionalName: "日喀則和平機場",
      },
    ],
  },
  RLG: {
    code: "RLG",
    name: "ROSTOCK",
    chineseName: "罗斯托克-拉格",
    traditionalName: "羅斯托克-拉格",
    airports: [
      {
        code: "RLG",
        name: "Laage",
        chineseName: "拉阿格机场",
        traditionalName: "拉阿格機場",
      },
    ],
  },
  RLK: {
    code: "RLK",
    name: "BAYANNUR",
    chineseName: "巴彦淖尔",
    traditionalName: "巴彥淖爾",
    airports: [
      {
        code: "RLK",
        name: "Tianjitai",
        chineseName: "天吉泰机场",
        traditionalName: "天吉泰機場",
      },
    ],
  },
  RLO: {
    code: "RLO",
    name: "MERLO",
    chineseName: "梅洛",
    traditionalName: "梅洛",
    airports: [
      {
        code: "RLO",
        name: "Valle del conlara",
        chineseName: "瓦莱德尔康拉拉国际机场",
        traditionalName: "瓦萊德爾康拉拉國際機場",
      },
    ],
  },
  RMA: {
    code: "RMA",
    name: "ROMA",
    chineseName: "罗马",
    traditionalName: "羅馬",
    airports: [
      {
        code: "RMA",
        name: "Roma airport",
        chineseName: "罗马机场",
        traditionalName: "羅馬機場",
      },
    ],
  },
  RMF: {
    code: "RMF",
    name: "MARSA ALAM",
    chineseName: "马萨阿拉姆",
    traditionalName: "馬薩阿拉姆",
    airports: [
      {
        code: "RMF",
        name: "Marsa alam intl.",
        chineseName: "阿莱姆港机场",
        traditionalName: "阿萊姆港機場",
      },
    ],
  },
  RMI: {
    code: "RMI",
    name: "RIMINI",
    chineseName: "里米尼",
    traditionalName: "裡米尼",
    airports: [
      {
        code: "RMI",
        name: "Miramare",
        chineseName: "米拉马雷机场",
        traditionalName: "米拉馬雷機場",
      },
    ],
  },
  RMP: {
    code: "RMP",
    name: "RAMPART",
    chineseName: "兰帕特",
    traditionalName: "蘭帕特",
    airports: [
      {
        code: "RMP",
        name: "Rampart airport",
        chineseName: "兰帕特机场",
        traditionalName: "蘭帕特機場",
      },
    ],
  },
  RMQ: {
    code: "RMQ",
    name: "TAICHUNG",
    chineseName: "台中",
    traditionalName: "台中",
    airports: [
      {
        code: "RMQ",
        name: "Cingcyuangang",
        chineseName: "清泉岗机场",
        traditionalName: "清泉崗機場",
      },
    ],
  },
  RMT: {
    code: "RMT",
    name: "RIMATARA",
    chineseName: "里马塔拉岛",
    traditionalName: "裏馬塔拉島",
    airports: [
      {
        code: "RMT",
        name: "Rimatara airport",
        chineseName: "里马塔拉机场",
        traditionalName: "裏馬塔拉機場",
      },
    ],
  },
  RNA: {
    code: "RNA",
    name: "ARONA",
    chineseName: "阿罗纳",
    traditionalName: "阿羅納",
    airports: [
      {
        code: "RNA",
        name: "Ulawa",
        chineseName: "乌拉瓦机场",
        traditionalName: "烏拉瓦機場",
      },
    ],
  },
  RNB: {
    code: "RNB",
    name: "RONNEBY/KARLSKRONA",
    chineseName: "龙讷比",
    traditionalName: "龍訥比",
    airports: [
      {
        code: "RNB",
        name: "Kallinge",
        chineseName: "卡林格机场",
        traditionalName: "卡林格機場",
      },
    ],
  },
  RNI: {
    code: "RNI",
    name: "CORN ISLAND",
    chineseName: "科恩岛",
    traditionalName: "科恩島",
    airports: [
      {
        code: "RNI",
        name: "Corn island airport",
        chineseName: "科恩岛机场",
        traditionalName: "科恩島機場",
      },
    ],
  },
  RNJ: {
    code: "RNJ",
    name: "YORON",
    chineseName: "与论岛",
    traditionalName: "與論島",
    airports: [
      {
        code: "RNJ",
        name: "Yoron airport",
        chineseName: "舆论岛机场",
        traditionalName: "輿論島機場",
      },
    ],
  },
  RNL: {
    code: "RNL",
    name: "RENNELL ISLAND",
    chineseName: "伦内尔",
    traditionalName: "倫內爾",
    airports: [
      {
        code: "RNL",
        name: "Tigoa",
        chineseName: "伦内尔岛机场",
        traditionalName: "倫內爾島機場",
      },
    ],
  },
  RNM: {
    code: "RNM",
    name: "QARN ALAM",
    chineseName: "Qarn Alam",
    traditionalName: "Qarn Alam",
    airports: [
      {
        code: "RNM",
        name: "Qarn alam airport",
        chineseName: "克恩阿拉姆机场",
        traditionalName: "克恩阿拉姆機場",
      },
    ],
  },
  RNN: {
    code: "RNN",
    name: "BORNHOLM",
    chineseName: "伯恩霍尔姆",
    traditionalName: "伯恩霍爾姆",
    airports: [
      {
        code: "RNN",
        name: "Ronne",
        chineseName: "伯恩霍尔姆机场",
        traditionalName: "伯恩霍爾姆機場",
      },
    ],
  },
  RNO: {
    code: "RNO",
    name: "RENO",
    chineseName: "雷诺",
    traditionalName: "雷諾",
    airports: [
      {
        code: "RNO",
        name: "Reno/tahoe intl",
        chineseName: "里诺坎农国际机场",
        traditionalName: "裏諾坎農國際機場",
      },
    ],
  },
  RNS: {
    code: "RNS",
    name: "RENNES",
    chineseName: "雷恩",
    traditionalName: "雷恩",
    airports: [
      {
        code: "RNS",
        name: "St jacques",
        chineseName: "圣雅各机场",
        traditionalName: "聖雅各機場",
      },
    ],
  },
  ROA: {
    code: "ROA",
    name: "ROANOKE",
    chineseName: "罗阿诺克",
    traditionalName: "羅阿諾克",
    airports: [
      {
        code: "ROA",
        name: "Regional (woodrum fld)",
        chineseName: "罗阿诺克地方机场",
        traditionalName: "羅阿諾克地方機場",
      },
    ],
  },
  ROC: {
    code: "ROC",
    name: "ROCHESTER",
    chineseName: "罗切斯特",
    traditionalName: "羅切斯特",
    airports: [
      {
        code: "ROC",
        name: "Greater rochester intl",
        chineseName: "大罗切斯特国际机场",
        traditionalName: "大羅賈斯特國際機場",
      },
    ],
  },
  ROI: {
    code: "ROI",
    name: "ROI ET",
    chineseName: "黎逸",
    traditionalName: "黎逸",
    airports: [
      {
        code: "ROI",
        name: "Roi et airport",
        chineseName: "黎逸机场",
        traditionalName: "黎逸機場",
      },
    ],
  },
  ROK: {
    code: "ROK",
    name: "ROCKHAMPTON",
    chineseName: "罗克汉普顿",
    traditionalName: "羅克漢普頓",
    airports: [
      {
        code: "ROK",
        name: "Rockhampton airport",
        chineseName: "罗克汉普顿机场",
        traditionalName: "羅克漢普頓機場",
      },
    ],
  },
  ROM: {
    code: "ROM",
    name: "ROME",
    chineseName: "罗马",
    traditionalName: "羅馬",
    airports: [
      {
        code: "CIA",
        name: "Ciampino",
        chineseName: "洽米皮诺机场",
        traditionalName: "洽米皮諾機場",
      },
      {
        code: "FCO",
        name: "Fiumicino",
        chineseName: "菲乌米奇诺机场",
        traditionalName: "菲烏米奇諾機場",
      },
    ],
  },
  RON: {
    code: "RON",
    name: "PAIPA",
    chineseName: "派帕",
    traditionalName: "派帕",
    airports: [
      {
        code: "RON",
        name: "Juan jose rondon",
        chineseName: "胡安-若泽机场",
        traditionalName: "胡安-若澤機場",
      },
    ],
  },
  ROO: {
    code: "ROO",
    name: "RONDONOPOLIS",
    chineseName: "龙多诺波利斯",
    traditionalName: "龍多諾波利斯",
    airports: [
      {
        code: "ROO",
        name: "Maestro marinho franco",
        chineseName: "大师佛朗哥马里尼奥机场",
        traditionalName: "大師佛朗哥馬裏尼奧機場",
      },
    ],
  },
  ROP: {
    code: "ROP",
    name: "ROTA",
    chineseName: "罗塔",
    traditionalName: "羅塔",
    airports: [
      {
        code: "ROP",
        name: "Rota intl.",
        chineseName: "罗塔国际机场",
        traditionalName: "羅塔國際機場",
      },
    ],
  },
  ROR: {
    code: "ROR",
    name: "KOROR",
    chineseName: "科罗尔",
    traditionalName: "科羅爾",
    airports: [
      {
        code: "ROR",
        name: "Palau international",
        chineseName: "罗曼莫图国际机场",
        traditionalName: "羅曼莫圖國際機場",
      },
    ],
  },
  ROS: {
    code: "ROS",
    name: "ROSARIO",
    chineseName: "罗萨里奥",
    traditionalName: "羅薩里奧",
    airports: [
      {
        code: "ROS",
        name: "Islas malvinas",
        chineseName: "马尔维纳斯群岛机场",
        traditionalName: "馬爾維納斯群島機場",
      },
    ],
  },
  ROT: {
    code: "ROT",
    name: "ROTORUA",
    chineseName: "罗托鲁阿",
    traditionalName: "羅托魯阿",
    airports: [
      {
        code: "ROT",
        name: "Rotorua intl.",
        chineseName: "罗托鲁阿机场",
        traditionalName: "羅托魯阿機場",
      },
    ],
  },
  ROW: {
    code: "ROW",
    name: "ROSWELL",
    chineseName: "罗斯韦尔",
    traditionalName: "羅茲韋爾",
    airports: [
      {
        code: "ROW",
        name: "Intl air center",
        chineseName: "罗斯韦尔国际机场",
        traditionalName: "羅茲韋爾國際機場",
      },
    ],
  },
  RPR: {
    code: "RPR",
    name: "RAIPUR",
    chineseName: "赖布尔",
    traditionalName: "賴布爾",
    airports: [
      {
        code: "RPR",
        name: "Swami vivekananda",
        chineseName: "斯瓦米维威卡南达机场",
        traditionalName: "斯瓦米維威卡南達機場",
      },
    ],
  },
  RQA: {
    code: "RQA",
    name: "RUOQIANG",
    chineseName: "若羌",
    traditionalName: "若羌",
    airports: [
      {
        code: "RQA",
        name: "Loulan",
        chineseName: "楼兰机场",
        traditionalName: "樓蘭機場",
      },
    ],
  },
  RQY: {
    code: "RQY",
    name: "SHIVAMOGGA",
    chineseName: "希瓦莫加",
    traditionalName: "希瓦莫加",
    airports: [
      {
        code: "RQY",
        name: "Shivamogga airport",
        chineseName: "库文普机场",
        traditionalName: "庫文普機場",
      },
    ],
  },
  RRG: {
    code: "RRG",
    name: "RODRIGUES ISLAND",
    chineseName: "罗德里格斯岛",
    traditionalName: "羅德里格斯島",
    airports: [
      {
        code: "RRG",
        name: "Plaine corail",
        chineseName: "罗德里格斯岛机场",
        traditionalName: "羅德里格斯島機場",
      },
    ],
  },
  RRK: {
    code: "RRK",
    name: "ROURKELA",
    chineseName: "鲁尔克拉",
    traditionalName: "魯爾克拉",
    airports: [
      {
        code: "RRK",
        name: "Rourkela airport",
        chineseName: "罗尔克拉机场",
        traditionalName: "羅爾克拉機場",
      },
    ],
  },
  RRR: {
    code: "RRR",
    name: "RAROIA",
    chineseName: "拉罗亚环礁",
    traditionalName: "拉羅亞環礁",
    airports: [
      {
        code: "RRR",
        name: "Raroia airport",
        chineseName: "拉洛阿机场",
        traditionalName: "拉洛阿機場",
      },
    ],
  },
  RRS: {
    code: "RRS",
    name: "ROROS",
    chineseName: "勒罗斯",
    traditionalName: "勒羅斯",
    airports: [
      {
        code: "RRS",
        name: "Roros airport",
        chineseName: "勒罗斯机场",
        traditionalName: "勒羅斯機場",
      },
    ],
  },
  RSA: {
    code: "RSA",
    name: "SANTA ROSA",
    chineseName: "圣罗莎",
    traditionalName: "聖羅莎",
    airports: [
      {
        code: "RSA",
        name: "Santa rosa airport",
        chineseName: "圣罗莎机场",
        traditionalName: "聖羅莎機場",
      },
    ],
  },
  RSD: {
    code: "RSD",
    name: "ROCK SOUND",
    chineseName: "罗克桑德",
    traditionalName: "羅克桑德",
    airports: [
      {
        code: "RSD",
        name: "Rock sound intl.",
        chineseName: "罗克桑德机场",
        traditionalName: "羅克桑德機場",
      },
    ],
  },
  RSH: {
    code: "RSH",
    name: "RUSSIAN MISSION",
    chineseName: "阿拉斯加市俄罗斯使",
    traditionalName: "阿拉斯加市俄羅斯使",
    airports: [
      {
        code: "RSH",
        name: "Russian mission airport",
        chineseName: "俄罗斯米申机场",
        traditionalName: "俄羅斯米申機場",
      },
    ],
  },
  RSI: {
    code: "RSI",
    name: "RED SEA INTERNATIONAL",
    chineseName: "Rio Sidra",
    traditionalName: "Rio Sidra",
    airports: [
      {
        code: "RSI",
        name: "Red sea international airport",
        chineseName: "红海国际机场",
        traditionalName: "紅海國際機場",
      },
    ],
  },
  RST: {
    code: "RST",
    name: "ROCHESTER",
    chineseName: "罗切斯特",
    traditionalName: "羅切斯特",
    airports: [
      {
        code: "RST",
        name: "Rochester intl.",
        chineseName: "罗切斯特国际机场",
        traditionalName: "羅切斯特國際機場",
      },
    ],
  },
  RSU: {
    code: "RSU",
    name: "YEOSU/SUNCHEON",
    chineseName: "丽水",
    traditionalName: "麗水",
    airports: [
      {
        code: "RSU",
        name: "Yeosu/suncheon airport",
        chineseName: "丽水机场",
        traditionalName: "麗水機場",
      },
    ],
  },
  RTA: {
    code: "RTA",
    name: "ROTUMA ISLAND",
    chineseName: "罗图马岛",
    traditionalName: "羅圖馬島",
    airports: [
      {
        code: "RTA",
        name: "Rotuma island airport",
        chineseName: "罗图马岛机场",
        traditionalName: "羅圖馬島機場",
      },
    ],
  },
  RTB: {
    code: "RTB",
    name: "ROATAN",
    chineseName: "罗阿坦",
    traditionalName: "羅阿坦",
    airports: [
      {
        code: "RTB",
        name: "Juan manuel galvez",
        chineseName: "罗阿坦机场",
        traditionalName: "羅阿坦機場",
      },
    ],
  },
  RTG: {
    code: "RTG",
    name: "RUTENG",
    chineseName: "鲁滕机场",
    traditionalName: "魯滕機場",
    airports: [
      {
        code: "RTG",
        name: "Frans sales lega",
        chineseName: "鲁滕机场",
        traditionalName: "魯滕機場",
      },
    ],
  },
  RTI: {
    code: "RTI",
    name: "ROTI",
    chineseName: "罗蒂",
    traditionalName: "羅蒂",
    airports: [
      {
        code: "RTI",
        name: "David c. saudale",
        chineseName: "罗地机场",
        traditionalName: "羅地機場",
      },
    ],
  },
  RTM: {
    code: "RTM",
    name: "ROTTERDAM",
    chineseName: "鹿特丹",
    traditionalName: "鹿特丹",
    airports: [
      {
        code: "RTM",
        name: "Rotterdam airport",
        chineseName: "鹿特丹机场",
        traditionalName: "鹿特丹機場",
      },
    ],
  },
  RTW: {
    code: "RTW",
    name: "SARATOV",
    chineseName: "萨拉托夫",
    traditionalName: "薩拉托夫",
    airports: [
      {
        code: "GSV",
        name: "Gagarin",
        chineseName: "加加林国际机场",
        traditionalName: "加加林國際機場",
      },
      {
        code: "RTW",
        name: "Tsentralny",
        chineseName: "萨拉托夫机场",
        traditionalName: "薩拉托夫機場",
      },
    ],
  },
  RUA: {
    code: "RUA",
    name: "ARUA",
    chineseName: "阿鲁阿",
    traditionalName: "阿魯阿",
    airports: [
      {
        code: "RUA",
        name: "Arua airport",
        chineseName: "阿鲁阿机场",
        traditionalName: "阿魯阿機場",
      },
    ],
  },
  RUE: {
    code: "RUE",
    name: "BUTEMBO",
    chineseName: "阿肯色州拉塞尔维尔",
    traditionalName: "阿肯色州拉塞爾維爾",
    airports: [
      {
        code: "RUE",
        name: "Butembo airport",
        chineseName: "布滕博机场",
        traditionalName: "布滕博機場",
      },
    ],
  },
  RUH: {
    code: "RUH",
    name: "RIYADH",
    chineseName: "利雅得",
    traditionalName: "利雅德",
    airports: [
      {
        code: "RUH",
        name: "King khalid intl",
        chineseName: "哈立德国王国际机场",
        traditionalName: "哈立德國王國際機場",
      },
    ],
  },
  RUL: {
    code: "RUL",
    name: "MAAVARULU",
    chineseName: "马瓦鲁鲁",
    traditionalName: "馬瓦魯魯",
    airports: [
      {
        code: "RUL",
        name: "Maavarulu airport",
        chineseName: "MAAVARULU机场",
        traditionalName: "MAAVARULU機場",
      },
    ],
  },
  RUN: {
    code: "RUN",
    name: "ST-DENIS",
    chineseName: "圣丹尼斯",
    traditionalName: "聖鄧尼斯",
    airports: [
      {
        code: "RUN",
        name: "Roland garros",
        chineseName: "罗兰加洛斯机场",
        traditionalName: "羅蘭加洛斯機場",
      },
    ],
  },
  RUP: {
    code: "RUP",
    name: "RUPSI",
    chineseName: "鲁布西",
    traditionalName: "魯布西",
    airports: [
      {
        code: "RUP",
        name: "Rupsi airport",
        chineseName: "鲁布西机场",
        traditionalName: "魯布西機場",
      },
    ],
  },
  RUR: {
    code: "RUR",
    name: "RURUTU",
    chineseName: "鲁鲁土岛",
    traditionalName: "魯魯土島",
    airports: [
      {
        code: "RUR",
        name: "Rurutu airport",
        chineseName: "鲁鲁土岛机场",
        traditionalName: "魯魯土島機場",
      },
    ],
  },
  RUT: {
    code: "RUT",
    name: "RUTLAND",
    chineseName: "拉特兰",
    traditionalName: "拉特蘭",
    airports: [
      {
        code: "RUT",
        name: "Southern vermont rgnl",
        chineseName: "拉特兰机场",
        traditionalName: "拉特蘭機場",
      },
    ],
  },
  RVD: {
    code: "RVD",
    name: "RIO VERDE",
    chineseName: "里奥韦尔迪",
    traditionalName: "裏奧韋爾迪",
    airports: [
      {
        code: "RVD",
        name: "Leite de castro",
        chineseName: "里奥贝尔德机场",
        traditionalName: "裏奧貝爾德機場",
      },
    ],
  },
  RVE: {
    code: "RVE",
    name: "SARAVENA",
    chineseName: "萨拉瓦内",
    traditionalName: "薩拉瓦內",
    airports: [
      {
        code: "RVE",
        name: "Los colonizadores",
        chineseName: "萨拉瓦内机场",
        traditionalName: "薩拉瓦內機場",
      },
    ],
  },
  RVK: {
    code: "RVK",
    name: "RORVIK",
    chineseName: "罗尔维克",
    traditionalName: "羅爾維克",
    airports: [
      {
        code: "RVK",
        name: "Ryum",
        chineseName: "罗尔维克机场",
        traditionalName: "羅爾維克機場",
      },
    ],
  },
  RVN: {
    code: "RVN",
    name: "ROVANIEMI",
    chineseName: "罗瓦涅米",
    traditionalName: "羅瓦涅米",
    airports: [
      {
        code: "RVN",
        name: "Rovaniemi airport",
        chineseName: "罗瓦涅米机场",
        traditionalName: "羅瓦涅米機場",
      },
    ],
  },
  RVV: {
    code: "RVV",
    name: "RAIVAVAE",
    chineseName: "拉伊鲁阿",
    traditionalName: "拉伊魯阿",
    airports: [
      {
        code: "RVV",
        name: "Raivavae airport",
        chineseName: "赖瓦瓦埃岛机场",
        traditionalName: "賴瓦瓦埃島機場",
      },
    ],
  },
  RXS: {
    code: "RXS",
    name: "ROXAS",
    chineseName: "罗哈斯城",
    traditionalName: "羅哈斯城",
    airports: [
      {
        code: "RXS",
        name: "Roxas airport",
        chineseName: "罗哈斯机场",
        traditionalName: "羅哈斯機場",
      },
    ],
  },
  RYL: {
    code: "RYL",
    name: "LOWER ZAMBEZI NAT.PARK",
    chineseName: "赞比西河下游国家公园城",
    traditionalName: "贊比西河下游國家公園城",
    airports: [
      {
        code: "JEK",
        name: "Jeki",
        chineseName: "杰基机场",
        traditionalName: "傑基機場",
      },
      {
        code: "RYL",
        name: "Royal",
        chineseName: "赞比西河下游国家公园机场",
        traditionalName: "贊比西河下游國家公園機場",
      },
    ],
  },
  RZE: {
    code: "RZE",
    name: "RZESZOW",
    chineseName: "热舒夫",
    traditionalName: "熱舒夫",
    airports: [
      {
        code: "RZE",
        name: "Jasionka",
        chineseName: "加西翁卡机场",
        traditionalName: "加西翁卡機場",
      },
    ],
  },
  RZH: {
    code: "RZH",
    name: "PREOBRAZHENIYE",
    chineseName: "加利福尼亚州兰开斯特",
    traditionalName: "加利福尼亞州蘭開斯特",
    airports: [
      {
        code: "RZH",
        name: "Preobrazheniye airport",
        chineseName: "普里奥布拉哲尼机场",
        traditionalName: "普裏奧布拉哲尼機場",
      },
    ],
  },
  RZR: {
    code: "RZR",
    name: "RAMSAR",
    chineseName: "拉姆萨尔",
    traditionalName: "拉姆薩爾",
    airports: [
      {
        code: "RZR",
        name: "Ramsar airport",
        chineseName: "拉姆萨尔机场",
        traditionalName: "拉姆薩爾機場",
      },
    ],
  },
  RZV: {
    code: "RZV",
    name: "RIZE",
    chineseName: "里泽",
    traditionalName: "裏澤",
    airports: [
      {
        code: "RZV",
        name: "Rize artvin",
        chineseName: "里泽阿尔特温机场",
        traditionalName: "裏澤阿爾特溫機場",
      },
    ],
  },
  SAB: {
    code: "SAB",
    name: "SABA",
    chineseName: "塞巴",
    traditionalName: "塞巴",
    airports: [
      {
        code: "SAB",
        name: "Juancho e. yrausquin",
        chineseName: "伊劳斯奎恩机场",
        traditionalName: "伊勞斯奎恩機場",
      },
    ],
  },
  SAC: {
    code: "SAC",
    name: "SACRAMENTO",
    chineseName: "萨克拉门托",
    traditionalName: "薩克拉門托",
    airports: [
      {
        code: "MHR",
        name: "Mather",
        chineseName: "萨克拉门托机场",
        traditionalName: "薩克拉門托機場",
      },
      {
        code: "SCK",
        name: "Stockton metropolitan",
        chineseName: "斯托克顿市机场",
        traditionalName: "斯托克頓市機場",
      },
      {
        code: "SMF",
        name: "Sacramento intl.",
        chineseName: "萨克拉门托国际机场",
        traditionalName: "薩克拉門托國際機場",
      },
    ],
  },
  SAF: {
    code: "SAF",
    name: "SANTA FE",
    chineseName: "圣菲",
    traditionalName: "聖菲",
    airports: [
      {
        code: "SAF",
        name: "Santa fe municipal airport",
        chineseName: "圣菲机场",
        traditionalName: "聖菲機場",
      },
    ],
  },
  SAG: {
    code: "SAG",
    name: "SHIRDI",
    chineseName: "舍尔第",
    traditionalName: "舍爾第",
    airports: [
      {
        code: "SAG",
        name: "Shirdi airport",
        chineseName: "舍地机场",
        traditionalName: "舍地機場",
      },
    ],
  },
  SAH: {
    code: "SAH",
    name: "SANA'A",
    chineseName: "萨那",
    traditionalName: "沙那",
    airports: [
      {
        code: "SAH",
        name: "Sana'a intl.",
        chineseName: "萨那国际机场",
        traditionalName: "沙那國際機場",
      },
    ],
  },
  SAI: {
    code: "SAI",
    name: "SIEM REAP",
    chineseName: "圣马力诺",
    traditionalName: "聖馬利諾",
    airports: [
      {
        code: "SAI",
        name: "Siem reap angkor",
        chineseName: "吴哥暹粒国际机场",
        traditionalName: "吳哥暹粒國際機場",
      },
    ],
  },
  SAL: {
    code: "SAL",
    name: "SAN SALVADOR",
    chineseName: "圣萨尔瓦多",
    traditionalName: "聖薩爾瓦多",
    airports: [
      {
        code: "SAL",
        name: "El salvador intl",
        chineseName: "萨尔瓦多国际机场",
        traditionalName: "薩爾瓦多國際機場",
      },
    ],
  },
  SAN: {
    code: "SAN",
    name: "SAN DIEGO",
    chineseName: "圣地亚哥",
    traditionalName: "聖地牙哥",
    airports: [
      {
        code: "CLD",
        name: "Mcclellan-palomar",
        chineseName: "卡尔斯巴德机场",
        traditionalName: "卡爾斯巴德機場",
      },
      {
        code: "SAN",
        name: "San diego intl.",
        chineseName: "圣地亚哥国际机场",
        traditionalName: "聖地牙哥國際機場",
      },
    ],
  },
  SAO: {
    code: "SAO",
    name: "SAO PAULO",
    chineseName: "圣保罗",
    traditionalName: "聖保羅",
    airports: [
      {
        code: "CGH",
        name: "Congonhas",
        chineseName: "康根哈斯机场",
        traditionalName: "康根哈斯機場",
      },
      {
        code: "GRU",
        name: "Guarulhos intl",
        chineseName: "瓜鲁尔霍斯国际机场",
        traditionalName: "瓜魯爾霍斯國際機場",
      },
      {
        code: "VCP",
        name: "Viracopos-campinas int",
        chineseName: "维拉科波斯机场",
        traditionalName: "維拉科波斯機場",
      },
    ],
  },
  SAP: {
    code: "SAP",
    name: "SAN PEDRO SULA",
    chineseName: "圣佩德罗苏拉",
    traditionalName: "聖佩德羅蘇拉",
    airports: [
      {
        code: "SAP",
        name: "Ramon v. morales intl",
        chineseName: "拉蒙维勒达莫拉尔斯机场",
        traditionalName: "拉蒙維勒達莫拉爾斯機場",
      },
    ],
  },
  SAQ: {
    code: "SAQ",
    name: "SAN ANDROS",
    chineseName: "圣安德拉斯",
    traditionalName: "聖安德拉斯",
    airports: [
      {
        code: "SAQ",
        name: "San andros airport",
        chineseName: "圣安德拉斯机场",
        traditionalName: "聖安德拉斯機場",
      },
    ],
  },
  SAR: {
    code: "SAR",
    name: "SPARTA",
    chineseName: "斯巴达",
    traditionalName: "斯巴達",
    airports: [
      {
        code: "SAR",
        name: "Sparta community",
        chineseName: "斯巴达社区机场",
        traditionalName: "斯巴達社區機場",
      },
    ],
  },
  SAT: {
    code: "SAT",
    name: "SAN ANTONIO",
    chineseName: "圣安东尼奥",
    traditionalName: "聖安東尼奧",
    airports: [
      {
        code: "SAT",
        name: "San antonio intl.",
        chineseName: "圣安东尼奥国际机场",
        traditionalName: "聖安東尼奧國際機場",
      },
      {
        code: "SKF",
        name: "Lackland afb-kelly fld",
        chineseName: "圣安东尼奥机场",
        traditionalName: "聖安東尼奧機場",
      },
    ],
  },
  SAU: {
    code: "SAU",
    name: "SAWU",
    chineseName: "萨武",
    traditionalName: "薩武",
    airports: [
      {
        code: "SAU",
        name: "Tardamu",
        chineseName: "萨武机场",
        traditionalName: "薩武機場",
      },
    ],
  },
  SAV: {
    code: "SAV",
    name: "SAVANNAH",
    chineseName: "萨凡纳",
    traditionalName: "薩凡納",
    airports: [
      {
        code: "SAV",
        name: "Hilton head intl",
        chineseName: "萨凡纳/希尔顿黑德国际机场",
        traditionalName: "薩凡納/希爾頓黑德國際機場",
      },
    ],
  },
  SBA: {
    code: "SBA",
    name: "SANTA BARBARA",
    chineseName: "圣巴巴拉",
    traditionalName: "聖巴巴拉",
    airports: [
      {
        code: "SBA",
        name: "Santa barbara municipal",
        chineseName: "圣巴巴拉机场",
        traditionalName: "聖巴巴拉機場",
      },
    ],
  },
  SBD: {
    code: "SBD",
    name: "SAN BERNARDINO",
    chineseName: "圣贝纳迪诺",
    traditionalName: "聖貝納迪諾",
    airports: [
      {
        code: "SBD",
        name: "San bernardino intl.",
        chineseName: "圣贝纳迪诺机场",
        traditionalName: "聖貝納迪諾機場",
      },
    ],
  },
  SBH: {
    code: "SBH",
    name: "ST BARTHELEMY",
    chineseName: "圣巴泰勒米岛",
    traditionalName: "聖巴泰勒米島",
    airports: [
      {
        code: "SBH",
        name: "Gustaf iii",
        chineseName: "圣巴泰勒米岛机场",
        traditionalName: "聖巴泰勒米島機場",
      },
    ],
  },
  SBN: {
    code: "SBN",
    name: "SOUTH BEND",
    chineseName: "南本德",
    traditionalName: "南本德",
    airports: [
      {
        code: "SBN",
        name: "South bend intl.",
        chineseName: "南本德国际机场",
        traditionalName: "南本德國際機場",
      },
    ],
  },
  SBP: {
    code: "SBP",
    name: "SAN LUIS OBISPO",
    chineseName: "加利福尼亚州圣路易斯奥比斯波",
    traditionalName: "加利福尼亞州聖路易斯奧比斯波",
    airports: [
      {
        code: "SBP",
        name: "San luis county rgnl",
        chineseName: "圣刘易斯乡村地区机场",
        traditionalName: "聖劉易斯鄉村地區機場",
      },
    ],
  },
  SBR: {
    code: "SBR",
    name: "SAIBAI ISLAND",
    chineseName: "赛巴伊岛",
    traditionalName: "賽巴伊島",
    airports: [
      {
        code: "SBR",
        name: "Saibai island airport",
        chineseName: "赛巴伊岛机场",
        traditionalName: "賽巴伊島機場",
      },
    ],
  },
  SBT: {
    code: "SBT",
    name: "SABETTA",
    chineseName: "加利福尼亚州圣贝纳迪诺",
    traditionalName: "加利福尼亞州聖貝納迪諾",
    airports: [
      {
        code: "SBT",
        name: "Sabetta intl.",
        chineseName: "特里城机场",
        traditionalName: "特裡城機場",
      },
    ],
  },
  SBW: {
    code: "SBW",
    name: "SIBU",
    chineseName: "诗巫",
    traditionalName: "詩巫",
    airports: [
      {
        code: "SBW",
        name: "Sibu airport",
        chineseName: "泗务机场",
        traditionalName: "泗務機場",
      },
    ],
  },
  SBY: {
    code: "SBY",
    name: "SALISBURY/OCEAN CITY",
    chineseName: "索尔兹伯里",
    traditionalName: "索爾茲伯里",
    airports: [
      {
        code: "SBY",
        name: "Wicomico regional",
        chineseName: "维科米科地区机场",
        traditionalName: "維科米科地區機場",
      },
    ],
  },
  SBZ: {
    code: "SBZ",
    name: "SIBIU",
    chineseName: "锡比乌",
    traditionalName: "錫比烏",
    airports: [
      {
        code: "SBZ",
        name: "Sibiu airport",
        chineseName: "锡比乌机场",
        traditionalName: "錫比烏機場",
      },
    ],
  },
  SCC: {
    code: "SCC",
    name: "PRUDHOE BAY/DEADHORSE",
    chineseName: "普拉德霍湾/代德豪斯",
    traditionalName: "普拉德霍灣/代德豪斯",
    airports: [
      {
        code: "SCC",
        name: "Deadhorse",
        chineseName: "代德豪斯机场",
        traditionalName: "代德豪斯機場",
      },
    ],
  },
  SCE: {
    code: "SCE",
    name: "STATE COLLEGE",
    chineseName: "斯泰特科利奇",
    traditionalName: "斯泰特科利奇",
    airports: [
      {
        code: "SCE",
        name: "University park",
        chineseName: "大学公园机场",
        traditionalName: "大學公園機場",
      },
    ],
  },
  SCL: {
    code: "SCL",
    name: "SANTIAGO",
    chineseName: "圣地亚哥",
    traditionalName: "聖地牙哥",
    airports: [
      {
        code: "SCL",
        name: "Arturo merino benitez",
        chineseName: "阿图罗梅里诺博尼特兹机场",
        traditionalName: "阿圖羅梅裏諾博尼特茲機場",
      },
    ],
  },
  SCM: {
    code: "SCM",
    name: "SCAMMON BAY",
    chineseName: "阿拉斯加市斯卡蒙",
    traditionalName: "阿拉斯加市斯卡蒙",
    airports: [
      {
        code: "SCM",
        name: "Scammon bay airport",
        chineseName: "斯卡蒙贝机场",
        traditionalName: "斯卡蒙貝機場",
      },
    ],
  },
  SCN: {
    code: "SCN",
    name: "SAARBRUECKEN",
    chineseName: "萨尔布吕肯",
    traditionalName: "索爾布呂肯",
    airports: [
      {
        code: "SCN",
        name: "Saarbruecken airport",
        chineseName: "萨尔布吕肯机场",
        traditionalName: "索爾布呂肯機場",
      },
      {
        code: "ZQW",
        name: "Zweibruecken",
        chineseName: "茨魏布吕肯机场",
        traditionalName: "茨魏布呂肯機場",
      },
    ],
  },
  SCO: {
    code: "SCO",
    name: "AKTAU",
    chineseName: "阿克套",
    traditionalName: "阿克套",
    airports: [
      {
        code: "SCO",
        name: "Aktau airport",
        chineseName: "阿克套机场",
        traditionalName: "阿克套機場",
      },
    ],
  },
  SCQ: {
    code: "SCQ",
    name: "SANTIAGO DE COMPOSTELA",
    chineseName: "圣地亚哥",
    traditionalName: "聖地牙哥",
    airports: [
      {
        code: "SCQ",
        name: "Santiago de compostela airport",
        chineseName: "圣地亚哥德孔波斯特拉机场",
        traditionalName: "聖地牙哥德孔波斯特拉機場",
      },
    ],
  },
  SCR: {
    code: "SCR",
    name: "SALEN",
    chineseName: "宾夕法尼亚州斯克兰顿",
    traditionalName: "賓夕法尼亞州斯克蘭頓",
    airports: [
      {
        code: "SCR",
        name: "Scandinavian mountains",
        chineseName: "威尔克斯-巴雷-斯克兰顿市政公寓机场",
        traditionalName: "威爾克斯-巴雷-斯克蘭頓市政公寓機場",
      },
    ],
  },
  SCT: {
    code: "SCT",
    name: "SOCOTRA",
    chineseName: "索科特拉岛",
    traditionalName: "索科特拉島",
    airports: [
      {
        code: "SCT",
        name: "Socotra airport",
        chineseName: "索科特拉岛机场",
        traditionalName: "索科特拉島機場",
      },
    ],
  },
  SCU: {
    code: "SCU",
    name: "SANTIAGO DE CUBA",
    chineseName: "圣地亚哥",
    traditionalName: "聖地牙哥",
    airports: [
      {
        code: "SCU",
        name: "Antonio maceo intl",
        chineseName: "安东尼奥－马赛奥机场",
        traditionalName: "安東尼奧－馬賽奧機場",
      },
    ],
  },
  SCV: {
    code: "SCV",
    name: "SUCEAVA",
    chineseName: "苏恰瓦",
    traditionalName: "蘇恰瓦",
    airports: [
      {
        code: "SCV",
        name: "Stefan cel mare",
        chineseName: "苏恰瓦机场",
        traditionalName: "蘇恰瓦機場",
      },
    ],
  },
  SCW: {
    code: "SCW",
    name: "SYKTYVKAR",
    chineseName: "瑟克特夫卡尔",
    traditionalName: "瑟克特夫卡爾",
    airports: [
      {
        code: "SCW",
        name: "Syktyvkar airport",
        chineseName: "瑟克特夫卡尔机场",
        traditionalName: "瑟克特夫卡爾機場",
      },
    ],
  },
  SCY: {
    code: "SCY",
    name: "SAN CRISTOBAL ISLAND",
    chineseName: "圣克里斯托瓦尔",
    traditionalName: "聖克裡斯托瓦爾",
    airports: [
      {
        code: "SCY",
        name: "San cristobal",
        chineseName: "圣克里斯托巴尔机场",
        traditionalName: "聖克裡斯托巴爾機場",
      },
    ],
  },
  SCZ: {
    code: "SCZ",
    name: "SANTA CRUZ ISLAND",
    chineseName: "圣克鲁斯岛",
    traditionalName: "聖克魯斯島",
    airports: [
      {
        code: "SCZ",
        name: "Santa cruz island  airport",
        chineseName: "圣克鲁斯岛机场",
        traditionalName: "聖克魯斯島機場",
      },
    ],
  },
  SDD: {
    code: "SDD",
    name: "LUBANGO",
    chineseName: "卢班戈",
    traditionalName: "盧班戈",
    airports: [
      {
        code: "SDD",
        name: "Mukanka",
        chineseName: "卢班戈机场",
        traditionalName: "盧班戈機場",
      },
    ],
  },
  SDE: {
    code: "SDE",
    name: "SANTIAGO DEL ESTERO",
    chineseName: "圣地亚哥-德尔埃斯特罗",
    traditionalName: "聖地牙哥-德爾埃斯特羅",
    airports: [
      {
        code: "SDE",
        name: "A. de la paz aragonez",
        chineseName: "圣地亚哥－德尔埃斯特罗机场",
        traditionalName: "聖地牙哥－德爾埃斯特羅機場",
      },
    ],
  },
  SDF: {
    code: "SDF",
    name: "LOUISVILLE",
    chineseName: "路易斯维尔",
    traditionalName: "路易斯維爾",
    airports: [
      {
        code: "SDF",
        name: "Intl-standiford fld",
        chineseName: "斯坦迪福德机场",
        traditionalName: "斯坦迪福德機場",
      },
    ],
  },
  SDJ: {
    code: "SDJ",
    name: "SENDAI",
    chineseName: "仙台",
    traditionalName: "仙台",
    airports: [
      {
        code: "SDJ",
        name: "Sendai airport",
        chineseName: "仙台机场",
        traditionalName: "仙台機場",
      },
    ],
  },
  SDK: {
    code: "SDK",
    name: "SANDAKAN",
    chineseName: "山打根",
    traditionalName: "山打根",
    airports: [
      {
        code: "SDK",
        name: "Sandakan airport",
        chineseName: "山打根机场",
        traditionalName: "山打根機場",
      },
    ],
  },
  SDL: {
    code: "SDL",
    name: "SUNDSVALL/HARNOSAND",
    chineseName: "松兹瓦尔",
    traditionalName: "松茲瓦爾",
    airports: [
      {
        code: "SDL",
        name: "Sundsvall-timra",
        chineseName: "泰米拉机场",
        traditionalName: "泰米拉機場",
      },
    ],
  },
  SDN: {
    code: "SDN",
    name: "SANDANE",
    chineseName: "桑纳讷",
    traditionalName: "桑納訥",
    airports: [
      {
        code: "SDN",
        name: "Anda",
        chineseName: "桑纳讷机场",
        traditionalName: "桑納訥機場",
      },
    ],
  },
  SDP: {
    code: "SDP",
    name: "SAND POINT",
    chineseName: "桑德波因特",
    traditionalName: "桑德波因特",
    airports: [
      {
        code: "SDP",
        name: "Sand point airport",
        chineseName: "桑德波因特机场",
        traditionalName: "桑德波因特機場",
      },
    ],
  },
  SDQ: {
    code: "SDQ",
    name: "SANTO DOMINGO",
    chineseName: "圣多明各",
    traditionalName: "聖多明哥",
    airports: [
      {
        code: "JBQ",
        name: "Dr.joaquin balaguer",
        chineseName: "拉尔伊莎贝拉国际机场",
        traditionalName: "拉爾伊莎貝拉國際機場",
      },
      {
        code: "SDQ",
        name: "Las americas intl",
        chineseName: "亚美利加国际机场",
        traditionalName: "亞美利加國際機場",
      },
    ],
  },
  SDR: {
    code: "SDR",
    name: "SANTANDER",
    chineseName: "桑坦德",
    traditionalName: "桑坦德",
    airports: [
      {
        code: "SDR",
        name: "Santander airport",
        chineseName: "桑坦德机场",
        traditionalName: "桑坦德機場",
      },
    ],
  },
  SDW: {
    code: "SDW",
    name: "MALVAN",
    chineseName: "松迪布",
    traditionalName: "松迪布",
    airports: [
      {
        code: "SDW",
        name: "Sindhudurg",
        chineseName: "松迪布机场",
        traditionalName: "松迪布機場",
      },
    ],
  },
  SDY: {
    code: "SDY",
    name: "SIDNEY",
    chineseName: "西德尼",
    traditionalName: "西德尼",
    airports: [
      {
        code: "SDY",
        name: "Richland municipal",
        chineseName: "里奇兰地方机场",
        traditionalName: "裏奇蘭地方機場",
      },
    ],
  },
  SDZ: {
    code: "SDZ",
    name: "SHETLAND ISLANDS",
    chineseName: "SHETLAND岛城",
    traditionalName: "SHETLAND島城",
    airports: [
      {
        code: "LSI",
        name: "Sumburgh",
        chineseName: "苏姆博机场",
        traditionalName: "蘇姆博機場",
      },
      {
        code: "LWK",
        name: "Lerwick/tingwall",
        chineseName: "勒威克机场",
        traditionalName: "勒威克機場",
      },
    ],
  },
  SEA: {
    code: "SEA",
    name: "SEATTLE",
    chineseName: "西雅图",
    traditionalName: "西雅圖",
    airports: [
      {
        code: "BFI",
        name: "Boeing fld-king co int",
        chineseName: "波音菲尔德国际机场",
        traditionalName: "波音菲爾德國際機場",
      },
      {
        code: "LKE",
        name: "Lake union spb",
        chineseName: "莱克乌尼翁水上飞机机场",
        traditionalName: "萊克烏尼翁水上飛機機場",
      },
      {
        code: "PAE",
        name: "Snohomish county",
        chineseName: "斯诺霍米圣郡机场",
        traditionalName: "斯諾霍米聖郡機場",
      },
      {
        code: "SEA",
        name: "Seattle-tacoma intl",
        chineseName: "西雅图国际机场",
        traditionalName: "西雅圖國際機場",
      },
    ],
  },
  SEB: {
    code: "SEB",
    name: "SEBHA",
    chineseName: "塞卜哈",
    traditionalName: "塞卜哈",
    airports: [
      {
        code: "SEB",
        name: "Sebha airport",
        chineseName: "瑟哈机场",
        traditionalName: "瑟哈機場",
      },
    ],
  },
  SEK: {
    code: "SEK",
    name: "SREDNEKOLYMSK",
    chineseName: "Srednekolymsk",
    traditionalName: "Srednekolymsk",
    airports: [
      {
        code: "SEK",
        name: "Srednekolymsk airport",
        chineseName: "中科雷姆斯克机场",
        traditionalName: "中科雷姆斯克機場",
      },
    ],
  },
  SEL: {
    code: "SEL",
    name: "SEOUL",
    chineseName: "首尔",
    traditionalName: "首爾",
    airports: [
      {
        code: "GMP",
        name: "Gimpo international",
        chineseName: "金浦国际机场",
        traditionalName: "金浦國際機場",
      },
      {
        code: "ICN",
        name: "Incheon international",
        chineseName: "仁川国际机场",
        traditionalName: "仁川國際機場",
      },
    ],
  },
  SES: {
    code: "SES",
    name: "SVETLOGORSK",
    chineseName: "塞尔马",
    traditionalName: "塞爾馬",
    airports: [
      {
        code: "SES",
        name: "Svetlogorsk airport",
        chineseName: "塞尔马市立机场",
        traditionalName: "塞爾馬市立機場",
      },
    ],
  },
  SET: {
    code: "SET",
    name: "SERRA TALHADA",
    chineseName: "圣埃斯特万",
    traditionalName: "聖埃斯特萬",
    airports: [
      {
        code: "SET",
        name: "Santa magalhaes",
        chineseName: "圣埃斯特万机场",
        traditionalName: "聖埃斯特萬機場",
      },
    ],
  },
  SEU: {
    code: "SEU",
    name: "SERONERA",
    chineseName: "塞罗内拉",
    traditionalName: "塞羅內拉",
    airports: [
      {
        code: "SEU",
        name: "Seronera airport",
        chineseName: "瑟罗内拉机场",
        traditionalName: "瑟羅內拉機場",
      },
    ],
  },
  SEZ: {
    code: "SEZ",
    name: "MAHE ISLAND",
    chineseName: "维多利亚",
    traditionalName: "維多利亞",
    airports: [
      {
        code: "SEZ",
        name: "Seychelles intl",
        chineseName: "塞舌尔国际机场",
        traditionalName: "塞舌耳國際機場",
      },
    ],
  },
  SFA: {
    code: "SFA",
    name: "SFAX",
    chineseName: "斯法克斯",
    traditionalName: "斯法克斯",
    airports: [
      {
        code: "SFA",
        name: "Thyna",
        chineseName: "斯法克斯－埃尔马欧机场",
        traditionalName: "斯法克斯－埃爾馬歐機場",
      },
    ],
  },
  SFD: {
    code: "SFD",
    name: "SAN FERNANDO APURE",
    chineseName: "阿普雷河畔圣费尔南多",
    traditionalName: "阿普雷河畔聖費爾南多",
    airports: [
      {
        code: "SFD",
        name: "Las flecheras",
        chineseName: "圣费尔南多机场",
        traditionalName: "聖費爾南多機場",
      },
    ],
  },
  SFG: {
    code: "SFG",
    name: "ST MARTIN",
    chineseName: "圣马丁",
    traditionalName: "聖馬丁",
    airports: [
      {
        code: "SFG",
        name: "Grand-case l'esperance",
        chineseName: "埃斯珀伦斯机场",
        traditionalName: "埃斯珀倫斯機場",
      },
    ],
  },
  SFJ: {
    code: "SFJ",
    name: "KANGERLUSSUAQ",
    chineseName: "康克鲁斯瓦格",
    traditionalName: "康克魯斯瓦格",
    airports: [
      {
        code: "SFJ",
        name: "Kangerlussuaq airport",
        chineseName: "康克鲁斯瓦格机场",
        traditionalName: "康克魯斯瓦格機場",
      },
    ],
  },
  SFL: {
    code: "SFL",
    name: "SAO FILIPE",
    chineseName: "圣菲利普",
    traditionalName: "聖菲力浦",
    airports: [
      {
        code: "SFL",
        name: "Sao filipe airport",
        chineseName: "圣菲利普机场",
        traditionalName: "聖菲力浦機場",
      },
    ],
  },
  SFN: {
    code: "SFN",
    name: "SANTA FE",
    chineseName: "圣菲",
    traditionalName: "聖菲",
    airports: [
      {
        code: "SFN",
        name: "Sauce viejo",
        chineseName: "圣菲机场",
        traditionalName: "聖菲機場",
      },
    ],
  },
  SFO: {
    code: "SFO",
    name: "SAN FRANCISCO",
    chineseName: "旧金山",
    traditionalName: "舊金山",
    airports: [
      {
        code: "SFO",
        name: "San francisco intl.",
        chineseName: "旧金山国际机场",
        traditionalName: "舊金山國際機場",
      },
    ],
  },
  SFQ: {
    code: "SFQ",
    name: "SANLIURFA",
    chineseName: "尚利乌尔法",
    traditionalName: "尚利烏爾法",
    airports: [
      {
        code: "GNY",
        name: "Guney anadolu projesi",
        chineseName: "桑利乌法机场",
        traditionalName: "桑利烏法機場",
      },
    ],
  },
  SFS: {
    code: "SFS",
    name: "SUBIC BAY",
    chineseName: "苏比克湾",
    traditionalName: "蘇比克灣",
    airports: [
      {
        code: "SFS",
        name: "Subic bay intl.",
        chineseName: "苏比克贝国际机场",
        traditionalName: "蘇比克貝國際機場",
      },
    ],
  },
  SFT: {
    code: "SFT",
    name: "SKELLEFTEA",
    chineseName: "谢莱夫特奥",
    traditionalName: "謝萊夫特奧",
    airports: [
      {
        code: "SFT",
        name: "Skelleftea airport",
        chineseName: "谢莱夫特奥机场",
        traditionalName: "謝萊夫特奧機場",
      },
    ],
  },
  SGC: {
    code: "SGC",
    name: "SURGUT",
    chineseName: "苏古特",
    traditionalName: "蘇古特",
    airports: [
      {
        code: "SGC",
        name: "Surgut airport",
        chineseName: "苏尔古特机场",
        traditionalName: "蘇爾古特機場",
      },
    ],
  },
  SGD: {
    code: "SGD",
    name: "SONDERBORG",
    chineseName: "松德堡",
    traditionalName: "松德堡",
    airports: [
      {
        code: "SGD",
        name: "Sonderborg airport",
        chineseName: "森讷堡机场",
        traditionalName: "森訥堡機場",
      },
    ],
  },
  SGF: {
    code: "SGF",
    name: "SPRINGFIELD",
    chineseName: "斯普林菲尔德",
    traditionalName: "斯普林菲爾德",
    airports: [
      {
        code: "SGF",
        name: "Springfld-branson natl",
        chineseName: "布兰森国家机场",
        traditionalName: "布蘭森國家機場",
      },
    ],
  },
  SGN: {
    code: "SGN",
    name: "HO CHI MINH CITY",
    chineseName: "胡志明市",
    traditionalName: "胡志明市",
    airports: [
      {
        code: "SGN",
        name: "Tan son nhat intl",
        chineseName: "新山一国际机场",
        traditionalName: "柔佛巴魯一國際機場",
      },
    ],
  },
  SGO: {
    code: "SGO",
    name: "ST GEORGE",
    chineseName: "圣乔治",
    traditionalName: "聖喬治",
    airports: [
      {
        code: "SGO",
        name: "St george airport",
        chineseName: "圣乔治机场",
        traditionalName: "聖喬治機場",
      },
    ],
  },
  SGU: {
    code: "SGU",
    name: "ST GEORGE",
    chineseName: "犹他州圣乔治",
    traditionalName: "猶他州聖喬治",
    airports: [
      {
        code: "SGU",
        name: "St george municipal",
        chineseName: "圣乔治地方机场",
        traditionalName: "聖喬治地方機場",
      },
    ],
  },
  SGX: {
    code: "SGX",
    name: "SONGEA",
    chineseName: "松盖阿",
    traditionalName: "松蓋阿",
    airports: [
      {
        code: "SGX",
        name: "Songea airport",
        chineseName: "松盖阿",
        traditionalName: "松蓋阿",
      },
    ],
  },
  SGY: {
    code: "SGY",
    name: "SKAGWAY",
    chineseName: "斯卡圭",
    traditionalName: "斯卡圭",
    airports: [
      {
        code: "SGY",
        name: "Skagway airport",
        chineseName: "史凯威机场",
        traditionalName: "史凱威機場",
      },
    ],
  },
  SGZ: {
    code: "SGZ",
    name: "SONGKHLA",
    chineseName: "宋卡",
    traditionalName: "宋卡",
    airports: [
      {
        code: "SGZ",
        name: "Songkhla airport",
        chineseName: "宋卡机场",
        traditionalName: "宋卡機場",
      },
    ],
  },
  SHA: {
    code: "SHA",
    name: "SHANGHAI",
    chineseName: "上海",
    traditionalName: "上海",
    airports: [
      {
        code: "PVG",
        name: "Pudong intl",
        chineseName: "浦东国际机场",
        traditionalName: "浦東國際機場",
      },
      {
        code: "SHA",
        name: "Hongqiao intl",
        chineseName: "上海虹桥国际机场",
        traditionalName: "上海虹橋國際機場",
      },
    ],
  },
  SHB: {
    code: "SHB",
    name: "NAKASHIBETSU",
    chineseName: "中标津",
    traditionalName: "得標津",
    airports: [
      {
        code: "SHB",
        name: "Nakashibetsu airport",
        chineseName: "根室中标津机场",
        traditionalName: "根室得標津機場",
      },
    ],
  },
  SHC: {
    code: "SHC",
    name: "INDA SELASSIE",
    chineseName: "因达塞拉西耶",
    traditionalName: "因達塞拉西耶",
    airports: [
      {
        code: "SHC",
        name: "Shire",
        chineseName: "因达塞拉西耶机场",
        traditionalName: "因達塞拉西耶機場",
      },
    ],
  },
  SHD: {
    code: "SHD",
    name: "STAUNTON/WAYNESBORO",
    chineseName: "斯汤顿",
    traditionalName: "斯湯頓",
    airports: [
      {
        code: "SHD",
        name: "Shenandoah valley rgnl",
        chineseName: "谢南多阿瓦雷机场",
        traditionalName: "謝南多阿瓦雷機場",
      },
    ],
  },
  SHE: {
    code: "SHE",
    name: "SHENYANG",
    chineseName: "沈阳",
    traditionalName: "瀋陽",
    airports: [
      {
        code: "SHE",
        name: "Taoxian intl",
        chineseName: "桃仙国际机场",
        traditionalName: "桃仙國際機場",
      },
    ],
  },
  SHF: {
    code: "SHF",
    name: "SHIHEZI",
    chineseName: "石河子",
    traditionalName: "石河子",
    airports: [
      {
        code: "SHF",
        name: "Huayuan",
        chineseName: "花园机场",
        traditionalName: "花園機場",
      },
    ],
  },
  SHG: {
    code: "SHG",
    name: "SHUNGNAK",
    chineseName: "申纳克",
    traditionalName: "申納克",
    airports: [
      {
        code: "SHG",
        name: "Shungnak airport",
        chineseName: "舒恩纳克机场",
        traditionalName: "舒恩納克機場",
      },
    ],
  },
  SHH: {
    code: "SHH",
    name: "SHISHMAREF",
    chineseName: "希什马廖夫",
    traditionalName: "希什馬廖夫",
    airports: [
      {
        code: "SHH",
        name: "Shishmaref airport",
        chineseName: "希什马廖夫机场",
        traditionalName: "希什馬廖夫機場",
      },
    ],
  },
  SHJ: {
    code: "SHJ",
    name: "SHARJAH",
    chineseName: "沙迦",
    traditionalName: "沙迦",
    airports: [
      {
        code: "SHJ",
        name: "Sharjah airport",
        chineseName: "沙迦机场",
        traditionalName: "沙迦機場",
      },
    ],
  },
  SHL: {
    code: "SHL",
    name: "SHILLONG",
    chineseName: "西隆",
    traditionalName: "西隆",
    airports: [
      {
        code: "SHL",
        name: "Barapani",
        chineseName: "西隆机场",
        traditionalName: "西隆機場",
      },
    ],
  },
  SHM: {
    code: "SHM",
    name: "SHIRAHAMA",
    chineseName: "白滨",
    traditionalName: "白濱",
    airports: [
      {
        code: "SHM",
        name: "Nanki-shirahama",
        chineseName: "白滨机场",
        traditionalName: "白濱機場",
      },
    ],
  },
  SHR: {
    code: "SHR",
    name: "SHERIDAN",
    chineseName: "谢里登",
    traditionalName: "謝里登",
    airports: [
      {
        code: "SHR",
        name: "Sheridan county",
        chineseName: "谢里登机场",
        traditionalName: "謝里登機場",
      },
    ],
  },
  SHS: {
    code: "SHS",
    name: "JINGZHOU",
    chineseName: "荆州",
    traditionalName: "荊州",
    airports: [
      {
        code: "SHS",
        name: "Shashi",
        chineseName: "沙市机场",
        traditionalName: "沙市機場",
      },
    ],
  },
  SHV: {
    code: "SHV",
    name: "SHREVEPORT",
    chineseName: "什里夫波特",
    traditionalName: "什裡夫波特",
    airports: [
      {
        code: "SHV",
        name: "Shreveport reg. airport",
        chineseName: "什里夫波特地区机场",
        traditionalName: "什裡夫波特地區機場",
      },
    ],
  },
  SHW: {
    code: "SHW",
    name: "SHARURAH",
    chineseName: "沙鲁拉",
    traditionalName: "沙魯拉",
    airports: [
      {
        code: "SHW",
        name: "Sharurah airport",
        chineseName: "沙鲁拉机场",
        traditionalName: "沙魯拉機場",
      },
    ],
  },
  SHX: {
    code: "SHX",
    name: "SHAGELUK",
    chineseName: "阿拉斯加州沙格鲁克",
    traditionalName: "阿拉斯加州沙格魯克",
    airports: [
      {
        code: "SHX",
        name: "Shageluk airport",
        chineseName: "夏格鲁克机场",
        traditionalName: "夏格魯克機場",
      },
    ],
  },
  SIA: {
    code: "SIA",
    name: "XI'AN",
    chineseName: "西安",
    traditionalName: "西安",
    airports: [
      {
        code: "SIA",
        name: "Xiguan",
        chineseName: "西关机场",
        traditionalName: "西關機場",
      },
      {
        code: "XIY",
        name: "Xianyang intl",
        chineseName: "咸阳国际机场",
        traditionalName: "咸陽國際機場",
      },
    ],
  },
  SID: {
    code: "SID",
    name: "SAL ISLAND",
    chineseName: "撒尔",
    traditionalName: "撒爾",
    airports: [
      {
        code: "SID",
        name: "Amilcar cabral intl",
        chineseName: "阿米尔卡卡布拉尔国际机场",
        traditionalName: "阿米爾卡卡布拉爾國際機場",
      },
    ],
  },
  SIF: {
    code: "SIF",
    name: "SIMARA",
    chineseName: "锡马拉",
    traditionalName: "錫馬拉",
    airports: [
      {
        code: "SIF",
        name: "Simara airport",
        chineseName: "锡马拉机场",
        traditionalName: "錫馬拉機場",
      },
    ],
  },
  SIN: {
    code: "SIN",
    name: "SINGAPORE",
    chineseName: "新加坡",
    traditionalName: "新加坡",
    airports: [
      {
        code: "SIN",
        name: "Changi",
        chineseName: "樟宜国际机场",
        traditionalName: "樟宜國際機場",
      },
      {
        code: "XSP",
        name: "Seletar",
        chineseName: "实里达机场",
        traditionalName: "實裏達機場",
      },
    ],
  },
  SIQ: {
    code: "SIQ",
    name: "SINGKEP",
    chineseName: "新开",
    traditionalName: "新開",
    airports: [
      {
        code: "SIQ",
        name: "Dabo",
        chineseName: "新及岛机场",
        traditionalName: "新及島機場",
      },
    ],
  },
  SIR: {
    code: "SIR",
    name: "SION",
    chineseName: "锡安",
    traditionalName: "錫安",
    airports: [
      {
        code: "SIR",
        name: "Sion airport",
        chineseName: "锡永机场",
        traditionalName: "錫永機場",
      },
    ],
  },
  SIS: {
    code: "SIS",
    name: "SISHEN",
    chineseName: "赛申",
    traditionalName: "賽申",
    airports: [
      {
        code: "SIS",
        name: "Sishen airport",
        chineseName: "赛申机场",
        traditionalName: "賽申機場",
      },
    ],
  },
  SIT: {
    code: "SIT",
    name: "SITKA",
    chineseName: "锡特卡",
    traditionalName: "錫特卡",
    airports: [
      {
        code: "SIT",
        name: "Rocky gutierrez",
        chineseName: "洛基古铁雷斯机场",
        traditionalName: "洛基古鐵雷斯機場",
      },
    ],
  },
  SJC: {
    code: "SJC",
    name: "SAN JOSE",
    chineseName: "圣何塞",
    traditionalName: "聖約瑟",
    airports: [
      {
        code: "SJC",
        name: "Norman y. mineta intl",
        chineseName: "圣何塞国际机场",
        traditionalName: "聖約瑟國際機場",
      },
    ],
  },
  SJD: {
    code: "SJD",
    name: "SAN JOSE DEL CABO",
    chineseName: "圣约瑟卡博",
    traditionalName: "聖約瑟卡博",
    airports: [
      {
        code: "SJD",
        name: "Los cabos intl",
        chineseName: "洛斯卡波国际机场",
        traditionalName: "洛斯卡波國際機場",
      },
    ],
  },
  SJE: {
    code: "SJE",
    name: "SAN JOSE DEL GUAVIARE",
    chineseName: "圣约瑟德尔瓜",
    traditionalName: "聖約瑟德爾瓜",
    airports: [
      {
        code: "SJE",
        name: "Jorge e. gonzalez t.",
        chineseName: "圣约瑟德尔瓜机场",
        traditionalName: "聖約瑟德爾瓜機場",
      },
    ],
  },
  SJI: {
    code: "SJI",
    name: "SAN JOSE",
    chineseName: "圣何塞",
    traditionalName: "聖約瑟",
    airports: [
      {
        code: "SJI",
        name: "San jose airport",
        chineseName: "圣琼斯机场",
        traditionalName: "聖鐘斯機場",
      },
    ],
  },
  SJJ: {
    code: "SJJ",
    name: "SARAJEVO",
    chineseName: "萨拉热窝",
    traditionalName: "塞拉耶佛",
    airports: [
      {
        code: "SJJ",
        name: "Sarajevo intl.",
        chineseName: "萨拉热窝国际机场",
        traditionalName: "塞拉耶佛國際機場",
      },
    ],
  },
  SJK: {
    code: "SJK",
    name: "SAO JOSE DOS CAMPOS",
    chineseName: "圣若泽杜斯坎普斯",
    traditionalName: "聖若澤杜斯坎普斯",
    airports: [
      {
        code: "SJK",
        name: "U.e. stumpf intl",
        chineseName: "圣若泽杜斯坎普斯机场",
        traditionalName: "聖若澤杜斯坎普斯機場",
      },
    ],
  },
  SJL: {
    code: "SJL",
    name: "SAO GABRIEL CACHOEIRA",
    chineseName: "圣加布里埃尔",
    traditionalName: "聖加布裏埃爾",
    airports: [
      {
        code: "SJL",
        name: "Sao gabriel cachoeira airport",
        chineseName: "圣加布里埃尔机场",
        traditionalName: "聖加布裡埃爾機場",
      },
    ],
  },
  SJO: {
    code: "SJO",
    name: "SAN JOSE",
    chineseName: "圣何塞",
    traditionalName: "聖約瑟",
    airports: [
      {
        code: "SJO",
        name: "Juan santamaria intl",
        chineseName: "胡安.圣玛丽亚国际机场",
        traditionalName: "胡安. 聖瑪麗亞國際機場",
      },
    ],
  },
  SJP: {
    code: "SJP",
    name: "SAO JOSE DO RIO PRETO",
    chineseName: "普雷图河畔圣若泽",
    traditionalName: "普雷圖河畔聖若澤",
    airports: [
      {
        code: "SJP",
        name: "Eribelto manoel reino",
        chineseName: "普雷图河畔圣若泽机场",
        traditionalName: "普雷圖河畔聖若澤機場",
      },
    ],
  },
  SJT: {
    code: "SJT",
    name: "SAN ANGELO",
    chineseName: "圣安吉洛",
    traditionalName: "聖安吉洛",
    airports: [
      {
        code: "SJT",
        name: "Regional (mathis fld)",
        chineseName: "马希斯机场",
        traditionalName: "馬希斯機場",
      },
    ],
  },
  SJU: {
    code: "SJU",
    name: "SAN JUAN",
    chineseName: "圣胡安",
    traditionalName: "聖胡安",
    airports: [
      {
        code: "SIG",
        name: "F.l. ribas dominicci",
        chineseName: "费尔南多路易斯里巴斯多米尼奇机场",
        traditionalName: "費爾南多路易斯裏巴斯多米尼奇機場",
      },
      {
        code: "SJU",
        name: "Luis munoz marin intl",
        chineseName: "路易斯·穆尼奥斯·马林国际机场",
        traditionalName: "路易斯·穆尼奧斯·馬林國際機場",
      },
    ],
  },
  SJW: {
    code: "SJW",
    name: "SHIJIAZHUANG",
    chineseName: "石家庄",
    traditionalName: "石家莊",
    airports: [
      {
        code: "SJW",
        name: "Zhengding intl",
        chineseName: "正定国际机场",
        traditionalName: "正定國際機場",
      },
    ],
  },
  SJZ: {
    code: "SJZ",
    name: "SAO JORGE ISLAND",
    chineseName: "圣约格岛",
    traditionalName: "聖約格島",
    airports: [
      {
        code: "SJZ",
        name: "Sao jorge island airport",
        chineseName: "圣约格岛机场",
        traditionalName: "聖約格島機場",
      },
    ],
  },
  SKB: {
    code: "SKB",
    name: "ST KITTS",
    chineseName: "巴斯特尔",
    traditionalName: "巴士地",
    airports: [
      {
        code: "SKB",
        name: "Robert l. bradshaw int",
        chineseName: "罗伯特布拉德肖国际机场",
        traditionalName: "羅伯特布拉德肖國際機場",
      },
    ],
  },
  SKD: {
    code: "SKD",
    name: "SAMARKAND",
    chineseName: "撒马尔罕",
    traditionalName: "撒馬爾罕",
    airports: [
      {
        code: "SKD",
        name: "Samarkand intl.",
        chineseName: "撒马尔罕国际机场",
        traditionalName: "撒馬爾罕國際機場",
      },
    ],
  },
  SKG: {
    code: "SKG",
    name: "THESSALONIKI",
    chineseName: "塞萨洛尼基",
    traditionalName: "塞薩洛尼基",
    airports: [
      {
        code: "SKG",
        name: "Makedonia",
        chineseName: "马克东尼亚机场",
        traditionalName: "馬克東尼亞機場",
      },
    ],
  },
  SKH: {
    code: "SKH",
    name: "SURKHET",
    chineseName: "苏尔凯德",
    traditionalName: "蘇爾凱德",
    airports: [
      {
        code: "SKH",
        name: "Surkhet airport",
        chineseName: "瑟克黑特机场",
        traditionalName: "瑟克黑特機場",
      },
    ],
  },
  SKK: {
    code: "SKK",
    name: "SHAKTOOLIK",
    chineseName: "阿拉斯加城市沙克托利",
    traditionalName: "阿拉斯加都市沙克托利",
    airports: [
      {
        code: "SKK",
        name: "Shaktoolik airport",
        chineseName: "沙克图利克机场",
        traditionalName: "沙克圖利克機場",
      },
    ],
  },
  SKN: {
    code: "SKN",
    name: "STOKMARKNES",
    chineseName: "斯卡恩",
    traditionalName: "斯卡恩",
    airports: [
      {
        code: "SKN",
        name: "Skagen",
        chineseName: "斯卡恩机场",
        traditionalName: "斯卡恩機場",
      },
    ],
  },
  SKO: {
    code: "SKO",
    name: "SOKOTO",
    chineseName: "索科托",
    traditionalName: "索科托",
    airports: [
      {
        code: "SKO",
        name: "Sadiq abubakar iii int",
        chineseName: "萨迪克布巴卡尔三世国际机场",
        traditionalName: "薩迪克布巴卡爾三世國際機場",
      },
    ],
  },
  SKP: {
    code: "SKP",
    name: "SKOPJE",
    chineseName: "斯科普里",
    traditionalName: "斯高彼亞",
    airports: [
      {
        code: "SKP",
        name: "Skopje intl.",
        chineseName: "斯科普里机场",
        traditionalName: "斯高彼亞機場",
      },
    ],
  },
  SKT: {
    code: "SKT",
    name: "SIALKOT",
    chineseName: "锡亚尔科特",
    traditionalName: "錫亞爾科特",
    airports: [
      {
        code: "SKT",
        name: "Sialkot intl.",
        chineseName: "锡亚尔科特机场",
        traditionalName: "錫亞爾科特機場",
      },
    ],
  },
  SKU: {
    code: "SKU",
    name: "SKYROS",
    chineseName: "斯基罗斯",
    traditionalName: "斯基羅斯",
    airports: [
      {
        code: "SKU",
        name: "Skyros airport",
        chineseName: "斯基罗斯机场",
        traditionalName: "斯基羅斯機場",
      },
    ],
  },
  SKW: {
    code: "SKW",
    name: "SKWENTNA",
    chineseName: "阿拉斯加Skwentna",
    traditionalName: "阿拉斯加Skwentna",
    airports: [
      {
        code: "SKW",
        name: "Skwentna airport",
        chineseName: "斯昂特纳机场",
        traditionalName: "斯昂特納機場",
      },
    ],
  },
  SKX: {
    code: "SKX",
    name: "SARANSK",
    chineseName: "萨兰斯克",
    traditionalName: "薩蘭斯克",
    airports: [
      {
        code: "SKX",
        name: "Saransk airport",
        chineseName: "萨兰斯克机场",
        traditionalName: "薩蘭斯克機場",
      },
    ],
  },
  SKZ: {
    code: "SKZ",
    name: "SUKKUR",
    chineseName: "苏库尔",
    traditionalName: "蘇庫爾",
    airports: [
      {
        code: "SKZ",
        name: "Sukkur airport",
        chineseName: "苏库尔机场",
        traditionalName: "蘇庫爾機場",
      },
    ],
  },
  SLA: {
    code: "SLA",
    name: "SALTA",
    chineseName: "萨尔塔",
    traditionalName: "薩爾塔",
    airports: [
      {
        code: "SLA",
        name: "Martin m. de guemes",
        chineseName: "马丁米盖尔机场",
        traditionalName: "馬丁米蓋爾機場",
      },
    ],
  },
  SLC: {
    code: "SLC",
    name: "SALT LAKE CITY",
    chineseName: "盐湖城",
    traditionalName: "鹽湖城",
    airports: [
      {
        code: "SLC",
        name: "Salt lake city intl.",
        chineseName: "盐湖城国际机场",
        traditionalName: "鹽湖城國際機場",
      },
    ],
  },
  SLE: {
    code: "SLE",
    name: "SALEM",
    chineseName: "萨勒姆",
    traditionalName: "薩勒姆",
    airports: [
      {
        code: "SLE",
        name: "Mcnary field",
        chineseName: "塞勒姆机场",
        traditionalName: "賽勒姆機場",
      },
    ],
  },
  SLH: {
    code: "SLH",
    name: "SOLA",
    chineseName: "索拉",
    traditionalName: "索拉",
    airports: [
      {
        code: "SLH",
        name: "Vanua lava",
        chineseName: "瓦努阿拉瓦机场",
        traditionalName: "瓦努阿拉瓦機場",
      },
    ],
  },
  SLI: {
    code: "SLI",
    name: "SOLWEZI",
    chineseName: "索卢韦齐",
    traditionalName: "索盧韋齊",
    airports: [
      {
        code: "SLI",
        name: "Solwezi airport",
        chineseName: "索户韦齐",
        traditionalName: "索戶韋齊",
      },
    ],
  },
  SLK: {
    code: "SLK",
    name: "SARANAC LAKE",
    chineseName: "萨拉纳克湖",
    traditionalName: "薩拉納克湖",
    airports: [
      {
        code: "SLK",
        name: "Adirondack regional",
        chineseName: "阿迪隆达克机场",
        traditionalName: "阿迪隆達克機場",
      },
    ],
  },
  SLL: {
    code: "SLL",
    name: "SALALAH",
    chineseName: "塞拉莱",
    traditionalName: "塞拉萊",
    airports: [
      {
        code: "SLL",
        name: "Salalah airport",
        chineseName: "塞拉莱机场",
        traditionalName: "塞拉萊機場",
      },
    ],
  },
  SLM: {
    code: "SLM",
    name: "SALAMANCA",
    chineseName: "萨拉曼卡",
    traditionalName: "薩拉曼卡",
    airports: [
      {
        code: "SLM",
        name: "Salamanca airport",
        chineseName: "萨拉曼卡机场",
        traditionalName: "薩拉曼卡機場",
      },
    ],
  },
  SLN: {
    code: "SLN",
    name: "SALINA",
    chineseName: "萨利纳",
    traditionalName: "薩利納",
    airports: [
      {
        code: "SLN",
        name: "Salina reg. airport",
        chineseName: "萨利纳机场",
        traditionalName: "薩利納機場",
      },
    ],
  },
  SLP: {
    code: "SLP",
    name: "SAN LUIS POTOSI",
    chineseName: "圣路易斯波托西",
    traditionalName: "聖路易斯波托西",
    airports: [
      {
        code: "SLP",
        name: "Ponciano arriaga intl",
        chineseName: "庞西亚诺阿里亚加国际机场",
        traditionalName: "龐西亞諾阿裏亞加國際機場",
      },
    ],
  },
  SLQ: {
    code: "SLQ",
    name: "SLEETMUTE",
    chineseName: "斯利特缪特",
    traditionalName: "斯利特繆特",
    airports: [
      {
        code: "SLQ",
        name: "Sleetmute airport",
        chineseName: "斯利特缪特机场",
        traditionalName: "斯利特繆特機場",
      },
    ],
  },
  SLU: {
    code: "SLU",
    name: "ST LUCIA",
    chineseName: "圣卢西亚岛",
    traditionalName: "聖盧西亞島",
    airports: [
      {
        code: "SLU",
        name: "George f.l. charles",
        chineseName: "卡斯特里机场",
        traditionalName: "卡斯翠機場",
      },
      {
        code: "UVF",
        name: "Hewanorra intl",
        chineseName: "赫瓦诺拉国际机场",
        traditionalName: "赫瓦諾拉國際機場",
      },
    ],
  },
  SLV: {
    code: "SLV",
    name: "SHIMLA",
    chineseName: "西姆拉",
    traditionalName: "西姆拉",
    airports: [
      {
        code: "SLV",
        name: "Shimla airport",
        chineseName: "西姆拉机场",
        traditionalName: "西姆拉機場",
      },
    ],
  },
  SLX: {
    code: "SLX",
    name: "SALT CAY",
    chineseName: "索尔特岛",
    traditionalName: "索爾特島",
    airports: [
      {
        code: "SLX",
        name: "Salt cay airport",
        chineseName: "索尔特岛机场",
        traditionalName: "索爾特島機場",
      },
    ],
  },
  SLY: {
    code: "SLY",
    name: "SALEKHARD",
    chineseName: "萨勒克哈德",
    traditionalName: "薩勒克哈德",
    airports: [
      {
        code: "SLY",
        name: "Salekhard airport",
        chineseName: "萨勒克哈德机场",
        traditionalName: "薩勒克哈德機場",
      },
    ],
  },
  SLZ: {
    code: "SLZ",
    name: "SAO LUIS",
    chineseName: "圣路易斯",
    traditionalName: "聖路易斯",
    airports: [
      {
        code: "SLZ",
        name: "Cunha machado intl",
        chineseName: "马尔松哈马卡多机场",
        traditionalName: "馬爾松哈馬卡多機場",
      },
    ],
  },
  SMA: {
    code: "SMA",
    name: "SANTA MARIA ISLAND",
    chineseName: "圣玛丽亚",
    traditionalName: "聖瑪麗亞",
    airports: [
      {
        code: "SMA",
        name: "Santa maria island airport",
        chineseName: "圣玛丽亚机场",
        traditionalName: "聖瑪麗亞機場",
      },
    ],
  },
  SMI: {
    code: "SMI",
    name: "SAMOS",
    chineseName: "萨摩斯",
    traditionalName: "薩摩斯",
    airports: [
      {
        code: "SMI",
        name: "Aristarchos of samos",
        chineseName: "萨摩斯机场",
        traditionalName: "薩摩斯機場",
      },
    ],
  },
  SMK: {
    code: "SMK",
    name: "ST MICHAEL",
    chineseName: " 圣米歇尔",
    traditionalName: "聖蜜雪兒",
    airports: [
      {
        code: "SMK",
        name: "St michael airport",
        chineseName: "圣米歇尔机场",
        traditionalName: "聖蜜雪兒機場",
      },
    ],
  },
  SML: {
    code: "SML",
    name: "STELLA MARIS",
    chineseName: "斯泰拉马利斯",
    traditionalName: "斯泰拉馬利斯",
    airports: [
      {
        code: "SML",
        name: "Stella maris airport",
        chineseName: "海星圣母机场",
        traditionalName: "海星聖母機場",
      },
    ],
  },
  SMQ: {
    code: "SMQ",
    name: "SAMPIT",
    chineseName: "桑皮特",
    traditionalName: "桑皮特",
    airports: [
      {
        code: "SMQ",
        name: "H.asan",
        chineseName: "桑皮特机场",
        traditionalName: "桑皮特機場",
      },
    ],
  },
  SMR: {
    code: "SMR",
    name: "SANTA MARTA",
    chineseName: "圣玛尔塔",
    traditionalName: "聖馬爾塔",
    airports: [
      {
        code: "SMR",
        name: "Simon bolivar intl",
        chineseName: "西蒙－玻利维亚机场",
        traditionalName: "西蒙－玻利維亞機場",
      },
    ],
  },
  SMS: {
    code: "SMS",
    name: "SAINTE-MARIE",
    chineseName: "圣玛丽",
    traditionalName: "聖瑪麗",
    airports: [
      {
        code: "SMS",
        name: "Sainte-marie airport",
        chineseName: "圣玛丽机场",
        traditionalName: "聖瑪麗機場",
      },
    ],
  },
  SMT: {
    code: "SMT",
    name: "SORRISO",
    chineseName: "日月潭",
    traditionalName: "日月潭",
    airports: [
      {
        code: "SMT",
        name: "Sorriso airport",
        chineseName: "索尔斯欧机场",
        traditionalName: "索爾斯歐機場",
      },
    ],
  },
  SMV: {
    code: "SMV",
    name: "ST MORITZ",
    chineseName: "圣莫里茨",
    traditionalName: "聖莫里茨",
    airports: [
      {
        code: "SMV",
        name: "Engadin",
        chineseName: "萨梅丹机场",
        traditionalName: "薩梅丹機場",
      },
    ],
  },
  SMX: {
    code: "SMX",
    name: "SANTA MARIA",
    chineseName: "圣玛丽亚",
    traditionalName: "聖瑪麗亞",
    airports: [
      {
        code: "SMX",
        name: "Public apt",
        chineseName: "圣玛丽亚公共机场",
        traditionalName: "聖瑪麗亞公共機場",
      },
    ],
  },
  SMZ: {
    code: "SMZ",
    name: "STOELMANSEILAND",
    chineseName: "斯托尔曼塞兰",
    traditionalName: "斯托爾曼塞蘭",
    airports: [
      {
        code: "SMZ",
        name: "Stoelmanseiland airport",
        chineseName: "斯托尔曼塞兰德机场",
        traditionalName: "斯托爾曼塞蘭德機場",
      },
    ],
  },
  SNA: {
    code: "SNA",
    name: "SANTA ANA",
    chineseName: "圣塔安那",
    traditionalName: "聖塔安那",
    airports: [
      {
        code: "SNA",
        name: "John wayne",
        chineseName: "约翰韦恩机场",
        traditionalName: "約翰韋恩機場",
      },
    ],
  },
  SNB: {
    code: "SNB",
    name: "MILIKAPITI",
    chineseName: "米丽卡皮提",
    traditionalName: "米麗卡皮提",
    airports: [
      {
        code: "SNB",
        name: "Snake bay",
        chineseName: "米丽卡皮提机场",
        traditionalName: "米麗卡皮提機場",
      },
    ],
  },
  SNE: {
    code: "SNE",
    name: "SAO NICOLAU ISLAND",
    chineseName: "圣尼古拉岛",
    traditionalName: "聖尼古拉島",
    airports: [
      {
        code: "SNE",
        name: "Preguica",
        chineseName: "普雷圭卡机场",
        traditionalName: "普雷圭卡機場",
      },
    ],
  },
  SNN: {
    code: "SNN",
    name: "SHANNON",
    chineseName: "香农",
    traditionalName: "香農",
    airports: [
      {
        code: "SNN",
        name: "Shannon intl.",
        chineseName: "香农国际机场",
        traditionalName: "香農國際機場",
      },
    ],
  },
  SNO: {
    code: "SNO",
    name: "SAKON NAKHON",
    chineseName: "沙功那空府",
    traditionalName: "沙功那空府",
    airports: [
      {
        code: "SNO",
        name: "Sakon nakhon airport",
        chineseName: "沙功那空机场",
        traditionalName: "沙功那空機場",
      },
    ],
  },
  SNP: {
    code: "SNP",
    name: "ST PAUL ISLAND",
    chineseName: "圣保罗岛",
    traditionalName: "聖保羅島",
    airports: [
      {
        code: "SNP",
        name: "St paul island airport",
        chineseName: "圣保罗岛机场",
        traditionalName: "聖保羅島機場",
      },
    ],
  },
  SNR: {
    code: "SNR",
    name: "ST-NAZAIRE",
    chineseName: "圣纳泽尔",
    traditionalName: "聖納澤爾",
    airports: [
      {
        code: "SNR",
        name: "Montoir",
        chineseName: "蒙特瓦机场",
        traditionalName: "蒙特瓦機場",
      },
    ],
  },
  SNU: {
    code: "SNU",
    name: "SANTA CLARA",
    chineseName: "圣克拉拉",
    traditionalName: "聖克拉拉",
    airports: [
      {
        code: "SNU",
        name: "Abel santamaria",
        chineseName: "阿贝尔桑塔马里亚机场",
        traditionalName: "阿貝爾桑塔馬里亞機場",
      },
    ],
  },
  SNW: {
    code: "SNW",
    name: "THANDWE",
    chineseName: "丹兑",
    traditionalName: "丹兌",
    airports: [
      {
        code: "SNW",
        name: "Thandwe airport",
        chineseName: "丹兑机场",
        traditionalName: "丹兌機場",
      },
    ],
  },
  SOC: {
    code: "SOC",
    name: "SURAKARTA (SOLO)",
    chineseName: "梭罗",
    traditionalName: "梭羅",
    airports: [
      {
        code: "SOC",
        name: "Adi sumarmo",
        chineseName: "阿迪苏马尔默机场",
        traditionalName: "阿迪蘇瑪律默機場",
      },
    ],
  },
  SOF: {
    code: "SOF",
    name: "SOFIA",
    chineseName: "索非亚",
    traditionalName: "索菲亞",
    airports: [
      {
        code: "SOF",
        name: "Sofia airport",
        chineseName: "索非亚机场",
        traditionalName: "索菲亞機場",
      },
    ],
  },
  SOG: {
    code: "SOG",
    name: "SOGNDAL",
    chineseName: "松达尔",
    traditionalName: "松達爾",
    airports: [
      {
        code: "SOG",
        name: "Haukasen",
        chineseName: "豪卡森机场",
        traditionalName: "豪卡森機場",
      },
    ],
  },
  SOJ: {
    code: "SOJ",
    name: "SORKJOSEN",
    chineseName: "索克约森",
    traditionalName: "索克約森",
    airports: [
      {
        code: "SOJ",
        name: "Sorkjosen airport",
        chineseName: "索克约森机场",
        traditionalName: "索克約森機場",
      },
    ],
  },
  SON: {
    code: "SON",
    name: "LUGANVILLE",
    chineseName: "圣埃斯皮里图岛",
    traditionalName: "聖埃斯皮裡圖島",
    airports: [
      {
        code: "SON",
        name: "Santo",
        chineseName: "佩克阿机场",
        traditionalName: "佩克阿機場",
      },
    ],
  },
  SOO: {
    code: "SOO",
    name: "SODERHAMN",
    chineseName: "瑟德港",
    traditionalName: "瑟德港",
    airports: [
      {
        code: "SOO",
        name: "Soderhamn airport",
        chineseName: "瑟德港机场",
        traditionalName: "瑟德港機場",
      },
    ],
  },
  SOQ: {
    code: "SOQ",
    name: "SORONG",
    chineseName: "索龙",
    traditionalName: "索龍",
    airports: [
      {
        code: "SOQ",
        name: "Domine eduard osok",
        chineseName: "多米尼克爱德华奥索机场",
        traditionalName: "多明尼克愛德華奧索機場",
      },
    ],
  },
  SOU: {
    code: "SOU",
    name: "SOUTHAMPTON",
    chineseName: "南安普敦",
    traditionalName: "南安普敦",
    airports: [
      {
        code: "SOU",
        name: "Southampton airport",
        chineseName: "南安普顿机场",
        traditionalName: "南安普頓機場",
      },
    ],
  },
  SOV: {
    code: "SOV",
    name: "SELDOVIA",
    chineseName: "塞尔多维亚",
    traditionalName: "塞爾多元亞",
    airports: [
      {
        code: "SOV",
        name: "Seldovia airport",
        chineseName: "塞尔多维亚机场",
        traditionalName: "塞爾多元亞機場",
      },
    ],
  },
  SOW: {
    code: "SOW",
    name: "SHOW LOW",
    chineseName: "Show Low，亚利桑那",
    traditionalName: "Show Low， 亞利桑那",
    airports: [
      {
        code: "SOW",
        name: "Show low reg. airport",
        chineseName: "肖罗机场",
        traditionalName: "肖羅機場",
      },
    ],
  },
  SPC: {
    code: "SPC",
    name: "SANTA CRUZ DE LA PALMA",
    chineseName: "圣克鲁斯德拉帕尔马",
    traditionalName: "聖克魯斯德拉帕爾馬",
    airports: [
      {
        code: "SPC",
        name: "La palma",
        chineseName: "拉帕尔马机场",
        traditionalName: "拉帕爾馬機場",
      },
    ],
  },
  SPD: {
    code: "SPD",
    name: "SAIDPUR",
    chineseName: "赛义德布尔",
    traditionalName: "賽義德布爾",
    airports: [
      {
        code: "SPD",
        name: "Saidpur airport",
        chineseName: "赛伊德布尔机场",
        traditionalName: "賽伊德布林機場",
      },
    ],
  },
  SPI: {
    code: "SPI",
    name: "SPRINGFIELD",
    chineseName: "斯普林菲尔德",
    traditionalName: "斯普林菲爾德",
    airports: [
      {
        code: "SPI",
        name: "A.lincoln capital",
        chineseName: "亚布拉罕林肯首都机场",
        traditionalName: "亞布拉罕林肯首都機場",
      },
    ],
  },
  SPK: {
    code: "SPK",
    name: "SAPPORO",
    chineseName: "札幌 (北海道)",
    traditionalName: "札幌 (北海道)",
    airports: [
      {
        code: "CTS",
        name: "New chitose",
        chineseName: "新千岁机场",
        traditionalName: "新千歲機場",
      },
      {
        code: "OKD",
        name: "Okadama",
        chineseName: "札幌丘珠空港",
        traditionalName: "札幌丘珠空港",
      },
    ],
  },
  SPN: {
    code: "SPN",
    name: "SAIPAN",
    chineseName: "塞班",
    traditionalName: "塞班",
    airports: [
      {
        code: "SPN",
        name: "Francisco c. ada intl",
        chineseName: "塞班国际机场",
        traditionalName: "塞班國際機場",
      },
    ],
  },
  SPP: {
    code: "SPP",
    name: "MENONGUE",
    chineseName: "梅农盖",
    traditionalName: "梅農蓋",
    airports: [
      {
        code: "SPP",
        name: "Menongue airport",
        chineseName: "北宽扎机场",
        traditionalName: "北寬紮機場",
      },
    ],
  },
  SPR: {
    code: "SPR",
    name: "SAN PEDRO",
    chineseName: "圣佩德罗",
    traditionalName: "聖佩德羅",
    airports: [
      {
        code: "SPR",
        name: "San pedro airport",
        chineseName: "圣佩德罗机场",
        traditionalName: "聖佩德羅機場",
      },
    ],
  },
  SPS: {
    code: "SPS",
    name: "WICHITA FALLS",
    chineseName: "威奇塔瀑布",
    traditionalName: "威奇塔瀑布",
    airports: [
      {
        code: "SPS",
        name: "Municipal/sheppard afb",
        chineseName: "谢帕德空军基地",
        traditionalName: "謝帕德空軍基地",
      },
    ],
  },
  SPU: {
    code: "SPU",
    name: "SPLIT",
    chineseName: "斯普利特",
    traditionalName: "斯普利特",
    airports: [
      {
        code: "SPU",
        name: "Split airport",
        chineseName: "斯普利特机场",
        traditionalName: "斯普利特機場",
      },
    ],
  },
  SPX: {
    code: "SPX",
    name: "GIZA",
    chineseName: "吉萨",
    traditionalName: "吉薩",
    airports: [
      {
        code: "SPX",
        name: "Sphinx international",
        chineseName: "斯菲克斯国际机场",
        traditionalName: "斯菲克斯國際機場",
      },
    ],
  },
  SPY: {
    code: "SPY",
    name: "SAN-PEDRO",
    chineseName: "圣佩德罗",
    traditionalName: "聖佩德羅",
    airports: [
      {
        code: "SPY",
        name: "San-pedro airport",
        chineseName: "圣佩德罗机场",
        traditionalName: "聖佩德羅機場",
      },
    ],
  },
  SQD: {
    code: "SQD",
    name: "SHANGRAO",
    chineseName: "上饶",
    traditionalName: "上饒",
    airports: [
      {
        code: "SQD",
        name: "Sanqingshan",
        chineseName: "三清山机场",
        traditionalName: "三清山機場",
      },
    ],
  },
  SQG: {
    code: "SQG",
    name: "SINTANG",
    chineseName: "新当",
    traditionalName: "新當",
    airports: [
      {
        code: "SQG",
        name: "Susilo",
        chineseName: "新当机场",
        traditionalName: "新當機場",
      },
    ],
  },
  SQI: {
    code: "SQI",
    name: "STERLING/ROCK FALLS",
    chineseName: "斯特灵",
    traditionalName: "斯特靈",
    airports: [
      {
        code: "SQI",
        name: "Whiteside county",
        chineseName: "斯特灵机场",
        traditionalName: "斯特靈機場",
      },
    ],
  },
  SQJ: {
    code: "SQJ",
    name: "SANMING",
    chineseName: "三明",
    traditionalName: "三明",
    airports: [
      {
        code: "SQJ",
        name: "Shaxian",
        chineseName: "沙县机场",
        traditionalName: "沙縣機場",
      },
    ],
  },
  SQL: {
    code: "SQL",
    name: "SAN CARLOS",
    chineseName: "圣卡洛斯",
    traditionalName: "聖卡洛斯",
    airports: [
      {
        code: "SQL",
        name: "San carlos airport",
        chineseName: "圣卡洛斯机场",
        traditionalName: "聖卡洛斯機場",
      },
    ],
  },
  SQN: {
    code: "SQN",
    name: "SANANA",
    chineseName: "萨纳纳岛",
    traditionalName: "薩納納島",
    airports: [
      {
        code: "SQN",
        name: "Emalamo",
        chineseName: "萨纳纳机场",
        traditionalName: "薩納納機場",
      },
    ],
  },
  SRE: {
    code: "SRE",
    name: "SUCRE",
    chineseName: "苏克雷",
    traditionalName: "蘇克瑞",
    airports: [
      {
        code: "SRE",
        name: "Alcantari",
        chineseName: "阿尔坎塔里国际机场",
        traditionalName: "阿爾坎塔裏國際機場",
      },
    ],
  },
  SRG: {
    code: "SRG",
    name: "SEMARANG",
    chineseName: "三宝垄",
    traditionalName: "三寶瓏",
    airports: [
      {
        code: "SRG",
        name: "Ahmad yani",
        chineseName: "艾哈迈德亚尼国际机场",
        traditionalName: "艾哈邁德亞尼國際機場",
      },
    ],
  },
  SRI: {
    code: "SRI",
    name: "SAMARINDA",
    chineseName: "三马林达",
    traditionalName: "三馬林達",
    airports: [
      {
        code: "AAP",
        name: "Ap tumenggung pranoto",
        chineseName: "APT普拉诺托国际机场",
        traditionalName: "APT普拉諾托國際機場",
      },
      {
        code: "SRI",
        name: "Temindung",
        chineseName: "三马林达机场",
        traditionalName: "三馬林達機場",
      },
    ],
  },
  SRP: {
    code: "SRP",
    name: "STORD",
    chineseName: "斯图尔",
    traditionalName: "斯圖爾",
    airports: [
      {
        code: "SRP",
        name: "Sorstokken",
        chineseName: "斯图尔机场",
        traditionalName: "斯圖爾機場",
      },
    ],
  },
  SRQ: {
    code: "SRQ",
    name: "SARASOTA/BRADENTON",
    chineseName: "萨拉索塔",
    traditionalName: "薩拉索塔",
    airports: [
      {
        code: "SRQ",
        name: "Sarasota/bradenton intl.",
        chineseName: "不拉登顿国际机场",
        traditionalName: "不拉登頓國際機場",
      },
    ],
  },
  SRV: {
    code: "SRV",
    name: "STONY RIVER",
    chineseName: "斯托尼里弗",
    traditionalName: "斯托尼裏弗",
    airports: [
      {
        code: "SRV",
        name: "Stony river airport",
        chineseName: "斯托尼里弗机场",
        traditionalName: "斯托尼裏弗機場",
      },
    ],
  },
  SRY: {
    code: "SRY",
    name: "SARI",
    chineseName: "萨里",
    traditionalName: "薩里",
    airports: [
      {
        code: "SRY",
        name: "Dasht-e-naz",
        chineseName: "达什特纳兹机场",
        traditionalName: "達什特納茲機場",
      },
    ],
  },
  SRZ: {
    code: "SRZ",
    name: "SANTA CRUZ",
    chineseName: "圣克鲁斯港",
    traditionalName: "聖克魯斯港",
    airports: [
      {
        code: "VVI",
        name: "Viru viru intl",
        chineseName: "比鲁比鲁国际机场",
        traditionalName: "比魯比魯國際機場",
      },
    ],
  },
  SSA: {
    code: "SSA",
    name: "SALVADOR",
    chineseName: "萨尔瓦多",
    traditionalName: "薩爾瓦多",
    airports: [
      {
        code: "SSA",
        name: "Luis e. magalhaes intl",
        chineseName: "路易斯马加尔哈斯机场",
        traditionalName: "路易士馬加爾哈斯機場",
      },
    ],
  },
  SSG: {
    code: "SSG",
    name: "MALABO",
    chineseName: "马拉博",
    traditionalName: "馬拉博",
    airports: [
      {
        code: "SSG",
        name: "Malabo intl.",
        chineseName: "马拉博国际机场",
        traditionalName: "馬拉博國際機場",
      },
    ],
  },
  SSH: {
    code: "SSH",
    name: "SHARM EL-SHEIKH",
    chineseName: "沙姆沙伊赫",
    traditionalName: "沙姆沙伊赫",
    airports: [
      {
        code: "SSH",
        name: "Sharm el-sheikh intl.",
        chineseName: "沙姆沙伊赫湾国际机场",
        traditionalName: "沙姆沙伊赫灣國際機場",
      },
    ],
  },
  SSI: {
    code: "SSI",
    name: "BRUNSWICK",
    chineseName: "不伦瑞克",
    traditionalName: "布勞恩斯魏克",
    airports: [
      {
        code: "BQK",
        name: "Golden isles",
        chineseName: "黄金岛机场",
        traditionalName: "黃金島機場",
      },
    ],
  },
  SSJ: {
    code: "SSJ",
    name: "SANDNESSJOEN",
    chineseName: "桑德斯瑙",
    traditionalName: "桑德斯瑙",
    airports: [
      {
        code: "SSJ",
        name: "Stokka",
        chineseName: "斯托卡机场",
        traditionalName: "斯托卡機場",
      },
    ],
  },
  SSM: {
    code: "SSM",
    name: "SAULT STE MARIE",
    chineseName: "圣玛丽",
    traditionalName: "聖瑪麗",
    airports: [
      {
        code: "CIU",
        name: "Chippewa county intl",
        chineseName: "奇波瓦郡机场",
        traditionalName: "奇波瓦郡機場",
      },
    ],
  },
  SSR: {
    code: "SSR",
    name: "SARA",
    chineseName: "萨拉",
    traditionalName: "薩拉",
    airports: [
      {
        code: "SSR",
        name: "Sara airport",
        chineseName: "萨拉机场",
        traditionalName: "薩拉機場",
      },
    ],
  },
  STB: {
    code: "STB",
    name: "SANTA BARBARA ZULIA",
    chineseName: "圣巴巴拉埃德",
    traditionalName: "聖巴巴拉埃德",
    airports: [
      {
        code: "STB",
        name: "Miguel u. fernandez",
        chineseName: "圣巴巴拉埃德机场",
        traditionalName: "聖巴巴拉埃德機場",
      },
    ],
  },
  STC: {
    code: "STC",
    name: "ST CLOUD",
    chineseName: "圣克劳德",
    traditionalName: "聖克勞德",
    airports: [
      {
        code: "STC",
        name: "St cloud reg. airport",
        chineseName: "圣克劳德地方机场",
        traditionalName: "聖克勞德地方機場",
      },
    ],
  },
  STD: {
    code: "STD",
    name: "SANTO DOMINGO",
    chineseName: "圣多明各",
    traditionalName: "聖多明哥",
    airports: [
      {
        code: "STD",
        name: "Buenaventura vivas",
        chineseName: "圣多明戈机场",
        traditionalName: "聖多明戈機場",
      },
    ],
  },
  STG: {
    code: "STG",
    name: "ST GEORGE ISLAND",
    chineseName: "阿拉斯加州圣乔治",
    traditionalName: "阿拉斯加州聖喬治",
    airports: [
      {
        code: "STG",
        name: "St george island airport",
        chineseName: "圣乔治岛机场",
        traditionalName: "聖喬治島機場",
      },
    ],
  },
  STI: {
    code: "STI",
    name: "SANTIAGO",
    chineseName: "圣地亚哥",
    traditionalName: "聖地牙哥",
    airports: [
      {
        code: "STI",
        name: "Cibao intl",
        chineseName: "圣地亚哥地方机场",
        traditionalName: "聖地牙哥地方機場",
      },
    ],
  },
  STL: {
    code: "STL",
    name: "ST LOUIS",
    chineseName: "圣路易斯",
    traditionalName: "聖路易斯",
    airports: [
      {
        code: "STL",
        name: "Lambert-st louis intl",
        chineseName: "兰伯特圣路易斯国际机场",
        traditionalName: "蘭伯特聖路易斯國際機場",
      },
      {
        code: "SUS",
        name: "Spirit of st louis",
        chineseName: "圣路易斯机场",
        traditionalName: "聖路易斯機場",
      },
    ],
  },
  STM: {
    code: "STM",
    name: "SANTAREM",
    chineseName: "圣塔伦",
    traditionalName: "聖塔倫",
    airports: [
      {
        code: "STM",
        name: "Maestro wilson fonseca",
        chineseName: "麦斯托威尔逊丰塞卡机场",
        traditionalName: "麥斯托威爾遜豐塞卡機場",
      },
    ],
  },
  STO: {
    code: "STO",
    name: "STOCKHOLM",
    chineseName: "斯德哥尔摩",
    traditionalName: "斯德哥爾摩",
    airports: [
      {
        code: "ARN",
        name: "Arlanda",
        chineseName: "阿兰达机场",
        traditionalName: "阿蘭達機場",
      },
      {
        code: "BMA",
        name: "Bromma",
        chineseName: "布罗马机场",
        traditionalName: "布羅馬機場",
      },
      {
        code: "NYO",
        name: "Skavsta",
        chineseName: "斯卡夫斯塔机场",
        traditionalName: "斯卡夫斯塔機場",
      },
      {
        code: "VST",
        name: "Vasteras",
        chineseName: "瓦斯特拉斯机场",
        traditionalName: "瓦斯特拉斯機場",
      },
    ],
  },
  STR: {
    code: "STR",
    name: "STUTTGART",
    chineseName: "斯图加特",
    traditionalName: "斯圖加特",
    airports: [
      {
        code: "STR",
        name: "Stuttgart airport",
        chineseName: "斯图加特机场",
        traditionalName: "斯圖加特機場",
      },
    ],
  },
  STS: {
    code: "STS",
    name: "SANTA ROSA",
    chineseName: "圣罗莎",
    traditionalName: "聖羅莎",
    airports: [
      {
        code: "STS",
        name: "Charles m. schulz",
        chineseName: "查尔斯舒尔茨机场",
        traditionalName: "查爾斯舒爾茨機場",
      },
    ],
  },
  STT: {
    code: "STT",
    name: "ST THOMAS ISLAND",
    chineseName: "圣托马斯",
    traditionalName: "聖托馬斯",
    airports: [
      {
        code: "SPB",
        name: "Charlotte amalie spb",
        chineseName: "夏洛特阿马利亚机场",
        traditionalName: "夏洛特阿馬利亞機場",
      },
      {
        code: "STT",
        name: "Cyril e. king",
        chineseName: "塞里尔金机场",
        traditionalName: "塞里爾金機場",
      },
    ],
  },
  STV: {
    code: "STV",
    name: "SURAT",
    chineseName: "苏拉特",
    traditionalName: "蘇拉特",
    airports: [
      {
        code: "STV",
        name: "Surat airport",
        chineseName: "苏拉特机场",
        traditionalName: "蘇拉特機場",
      },
    ],
  },
  STW: {
    code: "STW",
    name: "STAVROPOL",
    chineseName: "斯塔夫罗波尔",
    traditionalName: "斯塔夫羅波爾",
    airports: [
      {
        code: "STW",
        name: "Shpakovskoye",
        chineseName: "什帕科夫斯科耶机场",
        traditionalName: "什帕科夫斯科耶機場",
      },
    ],
  },
  STX: {
    code: "STX",
    name: "ST CROIX ISLAND",
    chineseName: "圣克罗伊岛",
    traditionalName: "聖克羅伊島",
    airports: [
      {
        code: "SSB",
        name: "Christiansted spb",
        chineseName: "圣克罗伊水上飞机基地",
        traditionalName: "聖克羅伊水上飛機基地",
      },
      {
        code: "STX",
        name: "Henry e. rohlsen",
        chineseName: "圣克罗伊岛机场",
        traditionalName: "聖克羅伊島機場",
      },
    ],
  },
  STY: {
    code: "STY",
    name: "SALTO",
    chineseName: "萨尔托",
    traditionalName: "薩爾托",
    airports: [
      {
        code: "STY",
        name: "Nueva hesperides",
        chineseName: "新赫斯帕里得斯国际机场",
        traditionalName: "新赫斯帕裏得斯國際機場",
      },
    ],
  },
  SUB: {
    code: "SUB",
    name: "SURABAYA",
    chineseName: "泗水",
    traditionalName: "泗水",
    airports: [
      {
        code: "SUB",
        name: "Juanda",
        chineseName: "朱安达机场",
        traditionalName: "朱安達機場",
      },
    ],
  },
  SUF: {
    code: "SUF",
    name: "LAMEZIA TERME",
    chineseName: "拉默齐亚",
    traditionalName: "拉默齊亞",
    airports: [
      {
        code: "SUF",
        name: "Lamezia terme airport",
        chineseName: "拉梅齐亚泰尔梅机场",
        traditionalName: "拉梅齊亞泰爾梅機場",
      },
    ],
  },
  SUG: {
    code: "SUG",
    name: "SURIGAO",
    chineseName: "苏里高",
    traditionalName: "蘇裏高",
    airports: [
      {
        code: "SUG",
        name: "Surigao airport",
        chineseName: "苏里高机场",
        traditionalName: "蘇裏高機場",
      },
    ],
  },
  SUJ: {
    code: "SUJ",
    name: "SATU MARE",
    chineseName: "萨图马雷",
    traditionalName: "薩圖馬雷",
    airports: [
      {
        code: "SUJ",
        name: "Satu mare airport",
        chineseName: "萨图马雷机场",
        traditionalName: "薩圖馬雷機場",
      },
    ],
  },
  SUK: {
    code: "SUK",
    name: "SAKKYRYR",
    chineseName: "巴塔盖阿利塔",
    traditionalName: "巴塔蓋阿利塔",
    airports: [
      {
        code: "SUK",
        name: "Sakkyryr airport",
        chineseName: "塞克雅尔机场",
        traditionalName: "塞克雅爾機場",
      },
    ],
  },
  SUN: {
    code: "SUN",
    name: "HAILEY/SUN VALLEY",
    chineseName: "森瓦利",
    traditionalName: "森瓦利",
    airports: [
      {
        code: "SUN",
        name: "Friedman memorial",
        chineseName: "弗里德曼纪念机场",
        traditionalName: "弗裡德曼紀念機場",
      },
    ],
  },
  SUR: {
    code: "SUR",
    name: "SUMMER BEAVER",
    chineseName: "萨莫比佛",
    traditionalName: "薩莫比佛",
    airports: [
      {
        code: "SUR",
        name: "Summer beaver airport",
        chineseName: "萨莫比佛机场",
        traditionalName: "薩莫比佛機場",
      },
    ],
  },
  SUV: {
    code: "SUV",
    name: "SUVA",
    chineseName: "苏瓦",
    traditionalName: "蘇瓦",
    airports: [
      {
        code: "SUV",
        name: "Nausori intl",
        chineseName: "纳乌索里机场",
        traditionalName: "納烏索裏機場",
      },
    ],
  },
  SUX: {
    code: "SUX",
    name: "SIOUX CITY",
    chineseName: "苏城",
    traditionalName: "蘇城",
    airports: [
      {
        code: "SUX",
        name: "Sioux gateway",
        chineseName: "苏城门户机场",
        traditionalName: "蘇城門戶機場",
      },
    ],
  },
  SUY: {
    code: "SUY",
    name: "SUNTAR",
    chineseName: "孙塔尔",
    traditionalName: "孫塔爾",
    airports: [
      {
        code: "SUY",
        name: "Suntar airport",
        chineseName: "苏杜雷里机场",
        traditionalName: "蘇杜雷裏機場",
      },
    ],
  },
  SVA: {
    code: "SVA",
    name: "SAVOONGA",
    chineseName: "萨文加",
    traditionalName: "薩文加",
    airports: [
      {
        code: "SVA",
        name: "Savoonga airport",
        chineseName: "萨文加机场",
        traditionalName: "薩文加機場",
      },
    ],
  },
  SVB: {
    code: "SVB",
    name: "SAMBAVA",
    chineseName: "桑巴瓦",
    traditionalName: "桑巴瓦",
    airports: [
      {
        code: "SVB",
        name: "Sambava airport",
        chineseName: "桑巴瓦机场",
        traditionalName: "桑巴瓦機場",
      },
    ],
  },
  SVC: {
    code: "SVC",
    name: "SILVER CITY",
    chineseName: "新墨西哥州银",
    traditionalName: "新墨西哥州銀",
    airports: [
      {
        code: "SVC",
        name: "Grant county",
        chineseName: "格兰特郡机场",
        traditionalName: "格蘭特郡機場",
      },
    ],
  },
  SVD: {
    code: "SVD",
    name: "ST VINCENT",
    chineseName: "圣文森特",
    traditionalName: "聖文森特",
    airports: [
      {
        code: "SVD",
        name: "Argyle international",
        chineseName: "雅盖国际机场",
        traditionalName: "雅蓋國際機場",
      },
    ],
  },
  SVG: {
    code: "SVG",
    name: "STAVANGER",
    chineseName: "斯塔万格",
    traditionalName: "斯塔萬格",
    airports: [
      {
        code: "SVG",
        name: "Sola",
        chineseName: "斯塔万格机场",
        traditionalName: "斯塔萬格機場",
      },
    ],
  },
  SVI: {
    code: "SVI",
    name: "SAN VICENTE DEL CAGUAN",
    chineseName: "圣维森特",
    traditionalName: "聖維森特",
    airports: [
      {
        code: "SVI",
        name: "Eduardo falla solano",
        chineseName: "爱德华多·法利亚·索拉诺机场",
        traditionalName: "愛德華多·法利亞·索拉諾機場",
      },
    ],
  },
  SVJ: {
    code: "SVJ",
    name: "SVOLVAER",
    chineseName: "斯沃尔韦尔",
    traditionalName: "斯沃爾韋爾",
    airports: [
      {
        code: "SVJ",
        name: "Helle",
        chineseName: "斯沃尔韦尔机场",
        traditionalName: "斯沃爾韋爾機場",
      },
    ],
  },
  SVL: {
    code: "SVL",
    name: "SAVONLINNA",
    chineseName: "萨翁林纳",
    traditionalName: "薩翁林納",
    airports: [
      {
        code: "SVL",
        name: "Savonlinna airport",
        chineseName: "萨翁林纳机场",
        traditionalName: "薩翁林納機場",
      },
    ],
  },
  SVP: {
    code: "SVP",
    name: "KUITO",
    chineseName: "奎托",
    traditionalName: "奎托",
    airports: [
      {
        code: "SVP",
        name: "Kuito airport",
        chineseName: "奎托机场",
        traditionalName: "奎托機場",
      },
    ],
  },
  SVQ: {
    code: "SVQ",
    name: "SEVILLA",
    chineseName: "塞维利亚",
    traditionalName: "西維爾",
    airports: [
      {
        code: "SVQ",
        name: "Sevilla airport",
        chineseName: "塞维利亚机场",
        traditionalName: "西維爾機場",
      },
    ],
  },
  SVS: {
    code: "SVS",
    name: "STEVENS VILLAGE",
    chineseName: "史蒂文斯",
    traditionalName: "史蒂文斯",
    airports: [
      {
        code: "SVS",
        name: "Stevens village airport",
        chineseName: "史蒂芬斯威里奇机场",
        traditionalName: "史蒂芬斯威裏奇機場",
      },
    ],
  },
  SVU: {
    code: "SVU",
    name: "SAVUSAVU",
    chineseName: "萨武萨武",
    traditionalName: "薩武薩武",
    airports: [
      {
        code: "SVU",
        name: "Savusavu airport",
        chineseName: "萨武萨武机场",
        traditionalName: "薩武薩武機場",
      },
    ],
  },
  SVX: {
    code: "SVX",
    name: "YEKATERINBURG",
    chineseName: "叶卡捷琳堡",
    traditionalName: "葉卡捷琳堡",
    airports: [
      {
        code: "SVX",
        name: "Koltsovo",
        chineseName: "科利佐沃机场",
        traditionalName: "科利佐沃機場",
      },
    ],
  },
  SVZ: {
    code: "SVZ",
    name: "SAN ANTONIO TACHIRA",
    chineseName: "圣安东尼奥",
    traditionalName: "聖安東尼奧",
    airports: [
      {
        code: "SVZ",
        name: "Juan v. gomez intl",
        chineseName: "圣安东尼奥机场",
        traditionalName: "聖安東尼奧機場",
      },
    ],
  },
  SWA: {
    code: "SWA",
    name: "SHANTOU",
    chineseName: "揭阳",
    traditionalName: "揭陽",
    airports: [
      {
        code: "SWA",
        name: "Jieyang chaoshan",
        chineseName: "揭阳潮汕机场",
        traditionalName: "揭陽潮汕機場",
      },
    ],
  },
  SWJ: {
    code: "SWJ",
    name: "SOUTH WEST BAY",
    chineseName: "西南湾",
    traditionalName: "西南灣",
    airports: [
      {
        code: "SWJ",
        name: "South west bay airport",
        chineseName: "西南湾机场",
        traditionalName: "西南灣機場",
      },
    ],
  },
  SWL: {
    code: "SWL",
    name: "SAN VICENTE",
    chineseName: "圣维森特",
    traditionalName: "聖維森特",
    airports: [
      {
        code: "SWL",
        name: "San vicente airport",
        chineseName: "圣维森特机场",
        traditionalName: "聖維森特機場",
      },
    ],
  },
  SWO: {
    code: "SWO",
    name: "STILLWATER",
    chineseName: "斯蒂尔沃特",
    traditionalName: "斯蒂爾沃特",
    airports: [
      {
        code: "SWO",
        name: "Stillwater reg. airport",
        chineseName: "斯蒂尔沃特地区机场",
        traditionalName: "斯蒂爾沃特地區機場",
      },
    ],
  },
  SWQ: {
    code: "SWQ",
    name: "SUMBAWA",
    chineseName: "大松巴哇",
    traditionalName: "大松巴哇",
    airports: [
      {
        code: "SWQ",
        name: "Brangbiji",
        chineseName: "苏丹穆罕默德卡哈卢丁三世机场",
        traditionalName: "蘇丹穆罕默德卡哈盧丁三世機場",
      },
    ],
  },
  SWS: {
    code: "SWS",
    name: "SWANSEA",
    chineseName: "斯旺西",
    traditionalName: "斯旺西",
    airports: [
      {
        code: "SWS",
        name: "Swansea airport",
        chineseName: "斯旺西机场",
        traditionalName: "斯旺西機場",
      },
    ],
  },
  SWT: {
    code: "SWT",
    name: "STREZHEVOY",
    chineseName: "Strzhewoi",
    traditionalName: "Strzhewoi",
    airports: [
      {
        code: "SWT",
        name: "Strezhevoy airport",
        chineseName: "斯特列热沃伊机场",
        traditionalName: "斯特列熱沃伊機場",
      },
    ],
  },
  SWV: {
    code: "SWV",
    name: "EVENSK",
    chineseName: "鄂温斯克",
    traditionalName: "鄂溫斯克",
    airports: [
      {
        code: "SWV",
        name: "Severo-evensk",
        chineseName: "希卡尔珀尔机场",
        traditionalName: "希卡爾珀爾機場",
      },
    ],
  },
  SXB: {
    code: "SXB",
    name: "STRASBOURG",
    chineseName: "斯特拉斯堡",
    traditionalName: "斯特拉斯堡",
    airports: [
      {
        code: "SXB",
        name: "Entzheim",
        chineseName: "恩特扎姆机场",
        traditionalName: "恩特紮姆機場",
      },
    ],
  },
  SXK: {
    code: "SXK",
    name: "SAUMLAKI",
    chineseName: "萨温拉基",
    traditionalName: "薩溫拉基",
    airports: [
      {
        code: "SXK",
        name: "Olilit",
        chineseName: "苏姆拉基机场",
        traditionalName: "蘇姆拉基機場",
      },
    ],
  },
  SXM: {
    code: "SXM",
    name: "ST MAARTEN",
    chineseName: "圣马丁",
    traditionalName: "聖馬丁",
    airports: [
      {
        code: "SXM",
        name: "Princess juliana intl",
        chineseName: "朱莉安娜公主国际机场",
        traditionalName: "朱莉安娜公主國際機場",
      },
    ],
  },
  SXP: {
    code: "SXP",
    name: "NUNAM IQUA",
    chineseName: "谢尔登波因特",
    traditionalName: "謝爾登波因特",
    airports: [
      {
        code: "SXP",
        name: "Sheldon point",
        chineseName: "谢尔登波因特机场",
        traditionalName: "謝爾登波因特機場",
      },
    ],
  },
  SXR: {
    code: "SXR",
    name: "SRINAGAR",
    chineseName: "斯利那加",
    traditionalName: "斯利那加",
    airports: [
      {
        code: "SXR",
        name: "Sheikh ul alam",
        chineseName: "斯利那加机场",
        traditionalName: "斯利那加機場",
      },
    ],
  },
  SXV: {
    code: "SXV",
    name: "SALEM",
    chineseName: "塞勒姆",
    traditionalName: "賽勒姆",
    airports: [
      {
        code: "SXV",
        name: "Salem airport",
        chineseName: "塞勒姆机场",
        traditionalName: "賽勒姆機場",
      },
    ],
  },
  SXZ: {
    code: "SXZ",
    name: "SIIRT",
    chineseName: "锡尔特",
    traditionalName: "錫爾特",
    airports: [
      {
        code: "SXZ",
        name: "Siirt airport",
        chineseName: "锡尔特机场",
        traditionalName: "錫爾特機場",
      },
    ],
  },
  SYB: {
    code: "SYB",
    name: "SEAL BAY",
    chineseName: "阿拉斯加市海豹",
    traditionalName: "阿拉斯加市海豹",
    airports: [
      {
        code: "SYB",
        name: "Sea plane base",
        chineseName: "水上飞机场",
        traditionalName: "水上飛機場",
      },
    ],
  },
  SYD: {
    code: "SYD",
    name: "SYDNEY",
    chineseName: "悉尼",
    traditionalName: "雪梨",
    airports: [
      {
        code: "SYD",
        name: "Kingsford smith",
        chineseName: "金斯福德史密斯机场",
        traditionalName: "金斯福德史密斯機場",
      },
    ],
  },
  SYF: {
    code: "SYF",
    name: "GABRIOLA ISLAND",
    chineseName: "希尔瓦贝",
    traditionalName: "希爾瓦貝",
    airports: [
      {
        code: "SYF",
        name: "Silva bay spb",
        chineseName: "希尔瓦贝机场",
        traditionalName: "希爾瓦貝機場",
      },
    ],
  },
  SYJ: {
    code: "SYJ",
    name: "SIRJAN",
    chineseName: "锡尔詹",
    traditionalName: "錫爾詹",
    airports: [
      {
        code: "SYJ",
        name: "Sirjan airport",
        chineseName: "希尔加恩机场",
        traditionalName: "希爾加恩機場",
      },
    ],
  },
  SYM: {
    code: "SYM",
    name: "SIMAO",
    chineseName: "普洱",
    traditionalName: "普洱",
    airports: [
      {
        code: "SYM",
        name: "Simao airport",
        chineseName: "思茅机场",
        traditionalName: "思茅機場",
      },
    ],
  },
  SYO: {
    code: "SYO",
    name: "SHONAI",
    chineseName: "庄内",
    traditionalName: "莊內",
    airports: [
      {
        code: "SYO",
        name: "Shonai airport",
        chineseName: "庄内机场",
        traditionalName: "莊內機場",
      },
    ],
  },
  SYR: {
    code: "SYR",
    name: "SYRACUSE",
    chineseName: "雪城",
    traditionalName: "雪城",
    airports: [
      {
        code: "SYR",
        name: "Hancock intl",
        chineseName: "汉考克国际机场",
        traditionalName: "漢考克國際機場",
      },
    ],
  },
  SYS: {
    code: "SYS",
    name: "SASKYLAKH",
    chineseName: "萨斯克拉赫",
    traditionalName: "薩斯克拉赫",
    airports: [
      {
        code: "SYS",
        name: "Saskylakh airport",
        chineseName: "萨斯克拉赫机场",
        traditionalName: "薩斯克拉赫機場",
      },
    ],
  },
  SYU: {
    code: "SYU",
    name: "WARRABER ISLAND",
    chineseName: "苏岛",
    traditionalName: "蘇島",
    airports: [
      {
        code: "SYU",
        name: "Warraber island airport",
        chineseName: "苏岛机场",
        traditionalName: "蘇島機場",
      },
    ],
  },
  SYX: {
    code: "SYX",
    name: "SANYA",
    chineseName: "三亚",
    traditionalName: "三亞",
    airports: [
      {
        code: "SYX",
        name: "Phoenix intl",
        chineseName: "凤凰国际机场",
        traditionalName: "鳳凰國際機場",
      },
    ],
  },
  SYY: {
    code: "SYY",
    name: "STORNOWAY",
    chineseName: "斯托诺威",
    traditionalName: "斯托諾威",
    airports: [
      {
        code: "SYY",
        name: "Stornoway airport",
        chineseName: "斯托诺威机场",
        traditionalName: "斯托諾威機場",
      },
    ],
  },
  SYZ: {
    code: "SYZ",
    name: "SHIRAZ",
    chineseName: "设拉子",
    traditionalName: "設拉子",
    airports: [
      {
        code: "SYZ",
        name: "Shahid dastghaib intl",
        chineseName: "设拉子国际机场",
        traditionalName: "設拉子國際機場",
      },
    ],
  },
  SZA: {
    code: "SZA",
    name: "SOYO",
    chineseName: "索约",
    traditionalName: "索約",
    airports: [
      {
        code: "SZA",
        name: "Soyo airport",
        chineseName: "索约机场",
        traditionalName: "索約機場",
      },
    ],
  },
  SZE: {
    code: "SZE",
    name: "SEMERA",
    chineseName: "瑟梅拉",
    traditionalName: "瑟梅拉",
    airports: [
      {
        code: "SZE",
        name: "Semera airport",
        chineseName: "瑟梅拉机场",
        traditionalName: "瑟梅拉機場",
      },
    ],
  },
  SZF: {
    code: "SZF",
    name: "SAMSUN",
    chineseName: "萨姆松",
    traditionalName: "薩姆松",
    airports: [
      {
        code: "SZF",
        name: "Carsamba",
        chineseName: "卡尔萨姆巴机场",
        traditionalName: "卡爾薩姆巴機場",
      },
    ],
  },
  SZG: {
    code: "SZG",
    name: "SALZBURG",
    chineseName: "萨尔茨堡",
    traditionalName: "薩爾茨堡",
    airports: [
      {
        code: "SZG",
        name: "W.a. mozart",
        chineseName: "莫扎特机场",
        traditionalName: "莫札特機場",
      },
    ],
  },
  SZH: {
    code: "SZH",
    name: "SHUOZHOU",
    chineseName: "塞尼帕",
    traditionalName: "塞尼帕",
    airports: [
      {
        code: "SZH",
        name: "Shuozhou zirun",
        chineseName: "滋润机场",
        traditionalName: "滋潤機場",
      },
    ],
  },
  SZK: {
    code: "SZK",
    name: "SKUKUZA",
    chineseName: "斯库库扎",
    traditionalName: "斯庫庫紮",
    airports: [
      {
        code: "SZK",
        name: "Skukuza airport",
        chineseName: "斯库库扎机场",
        traditionalName: "斯庫庫紮機場",
      },
    ],
  },
  SZS: {
    code: "SZS",
    name: "STEWART ISLAND",
    chineseName: "斯图尔特岛",
    traditionalName: "斯圖爾特島",
    airports: [
      {
        code: "SZS",
        name: "Ryan's creek",
        chineseName: "斯图尔特岛机场",
        traditionalName: "斯圖爾特島機場",
      },
    ],
  },
  SZV: {
    code: "SZV",
    name: "SUZHOU",
    chineseName: "苏州",
    traditionalName: "蘇州",
    airports: [
      {
        code: "SZV",
        name: "Guangfu",
        chineseName: "苏州光福机场",
        traditionalName: "蘇州光福機場",
      },
    ],
  },
  SZX: {
    code: "SZX",
    name: "SHENZHEN",
    chineseName: "深圳",
    traditionalName: "深圳",
    airports: [
      {
        code: "SZX",
        name: "Bao'an intl",
        chineseName: "宝安国际机场",
        traditionalName: "寶安國際機場",
      },
    ],
  },
  SZY: {
    code: "SZY",
    name: "SZCZYTNO",
    chineseName: "希曼尼",
    traditionalName: "希曼尼",
    airports: [
      {
        code: "SZY",
        name: "Olsztyn-mazury",
        chineseName: "马祖里机场",
        traditionalName: "馬祖裏機場",
      },
    ],
  },
  SZZ: {
    code: "SZZ",
    name: "SZCZECIN",
    chineseName: "什切青",
    traditionalName: "什切青",
    airports: [
      {
        code: "SZZ",
        name: "Goleniow",
        chineseName: "格勒尼欧机场",
        traditionalName: "格勒尼歐機場",
      },
    ],
  },
  TAB: {
    code: "TAB",
    name: "TOBAGO",
    chineseName: "多巴哥岛",
    traditionalName: "多巴哥島",
    airports: [
      {
        code: "TAB",
        name: "A.n.r. robinson intl",
        chineseName: "ANR罗宾逊国际机场",
        traditionalName: "ANR羅賓遜國際機場",
      },
    ],
  },
  TAC: {
    code: "TAC",
    name: "TACLOBAN",
    chineseName: "塔克洛班",
    traditionalName: "塔克洛班",
    airports: [
      {
        code: "TAC",
        name: "D.z. romualdez",
        chineseName: "罗姆阿尔德兹机场",
        traditionalName: "羅姆阿爾德茲機場",
      },
    ],
  },
  TAE: {
    code: "TAE",
    name: "DAEGU",
    chineseName: "大邱",
    traditionalName: "大邱",
    airports: [
      {
        code: "TAE",
        name: "Daegu intl.",
        chineseName: "大邱国际机场",
        traditionalName: "大邱國際機場",
      },
    ],
  },
  TAG: {
    code: "TAG",
    name: "PANGLAO",
    chineseName: "塔比拉兰",
    traditionalName: "塔比拉蘭",
    airports: [
      {
        code: "TAG",
        name: "Bohol international",
        chineseName: "邦劳岛国际机场",
        traditionalName: "邦勞島國際機場",
      },
    ],
  },
  TAH: {
    code: "TAH",
    name: "TANNA ISLAND",
    chineseName: "塔纳岛",
    traditionalName: "塔納島",
    airports: [
      {
        code: "TAH",
        name: "Tanna",
        chineseName: "白草机场",
        traditionalName: "白草機場",
      },
    ],
  },
  TAI: {
    code: "TAI",
    name: "TAIZZ",
    chineseName: "塔伊兹",
    traditionalName: "塔伊茲",
    airports: [
      {
        code: "TAI",
        name: "Taizz intl.",
        chineseName: "塔伊兹国际机场",
        traditionalName: "塔伊茲國際機場",
      },
    ],
  },
  TAK: {
    code: "TAK",
    name: "TAKAMATSU",
    chineseName: "高松",
    traditionalName: "高松",
    airports: [
      {
        code: "TAK",
        name: "Takamatsu airport",
        chineseName: "高松机场",
        traditionalName: "高松機場",
      },
    ],
  },
  TAL: {
    code: "TAL",
    name: "TANANA",
    chineseName: "塔纳诺",
    traditionalName: "塔納諾",
    airports: [
      {
        code: "TAL",
        name: "Ralph m. calhoun mem.",
        chineseName: "拉尔夫－卡尔洪机场",
        traditionalName: "拉爾夫－卡爾洪機場",
      },
    ],
  },
  TAM: {
    code: "TAM",
    name: "TAMPICO",
    chineseName: "坦皮科",
    traditionalName: "坦皮科",
    airports: [
      {
        code: "TAM",
        name: "F. javier mina intl",
        chineseName: "弗朗西斯科哈维尔米纳国际机场",
        traditionalName: "弗朗西斯科哈維爾米納國際機場",
      },
    ],
  },
  TAO: {
    code: "TAO",
    name: "QINGDAO",
    chineseName: "青岛",
    traditionalName: "青島",
    airports: [
      {
        code: "TAO",
        name: "Jiaodong international",
        chineseName: "青岛胶东国际机场",
        traditionalName: "青島膠東國際機場",
      },
    ],
  },
  TAP: {
    code: "TAP",
    name: "TAPACHULA",
    chineseName: "塔帕丘拉",
    traditionalName: "塔帕丘拉",
    airports: [
      {
        code: "TAP",
        name: "Tapachula intl.",
        chineseName: "塔帕丘拉国际机场",
        traditionalName: "塔帕丘拉國際機場",
      },
    ],
  },
  TAS: {
    code: "TAS",
    name: "TASHKENT",
    chineseName: "塔什干",
    traditionalName: "塔什干",
    airports: [
      {
        code: "TAS",
        name: "Tashkent intl.",
        chineseName: "塔什干国际机场",
        traditionalName: "塔什干國際機場",
      },
    ],
  },
  TAT: {
    code: "TAT",
    name: "POPRAD",
    chineseName: "波普拉德",
    traditionalName: "波普拉德",
    airports: [
      {
        code: "TAT",
        name: "Tatry",
        chineseName: "塔特里机场",
        traditionalName: "塔特裏機場",
      },
    ],
  },
  TAY: {
    code: "TAY",
    name: "TARTU",
    chineseName: "塔尔图",
    traditionalName: "塔爾圖",
    airports: [
      {
        code: "TAY",
        name: "Ulenurme",
        chineseName: "答尔丢夫机场",
        traditionalName: "答爾丟夫機場",
      },
    ],
  },
  TAZ: {
    code: "TAZ",
    name: "DASHOGUZ",
    chineseName: "达什奥古兹",
    traditionalName: "達什奧古茲",
    airports: [
      {
        code: "TAZ",
        name: "Dashoguz airport",
        chineseName: "达沙古兹机场",
        traditionalName: "達沙古茲機場",
      },
    ],
  },
  TBB: {
    code: "TBB",
    name: "TUY HOA",
    chineseName: "绥和",
    traditionalName: "綏和",
    airports: [
      {
        code: "TBB",
        name: "Dong tac",
        chineseName: "东索机场",
        traditionalName: "東索機場",
      },
    ],
  },
  TBF: {
    code: "TBF",
    name: "TABITEUEA NORTH",
    chineseName: "北塔比特韦亚",
    traditionalName: "北塔比特韋亞",
    airports: [
      {
        code: "TBF",
        name: "Tabiteuea north airport",
        chineseName: "塔比特阿机场",
        traditionalName: "塔比特阿機場",
      },
    ],
  },
  TBG: {
    code: "TBG",
    name: "TABUBIL",
    chineseName: "塔布比尔",
    traditionalName: "塔布比爾",
    airports: [
      {
        code: "TBG",
        name: "Tabubil airport",
        chineseName: "塔布比尔机场",
        traditionalName: "塔布比爾機場",
      },
    ],
  },
  TBH: {
    code: "TBH",
    name: "TABLAS ISLAND",
    chineseName: "塔布拉斯",
    traditionalName: "塔布拉斯",
    airports: [
      {
        code: "TBH",
        name: "Tugdan",
        chineseName: "塔布拉斯机场",
        traditionalName: "塔布拉斯機場",
      },
    ],
  },
  TBI: {
    code: "TBI",
    name: "THE BIGHT",
    chineseName: "海湾",
    traditionalName: "海灣",
    airports: [
      {
        code: "TBI",
        name: "New bight",
        chineseName: "纽拜特机场",
        traditionalName: "紐拜特機場",
      },
    ],
  },
  TBJ: {
    code: "TBJ",
    name: "TABARKA",
    chineseName: "塔巴卡",
    traditionalName: "塔巴卡",
    airports: [
      {
        code: "TBJ",
        name: "Ain draham",
        chineseName: "艾因带拉希姆机场",
        traditionalName: "艾因帶拉希姆機場",
      },
    ],
  },
  TBN: {
    code: "TBN",
    name: "FORT LEONARD WOOD",
    chineseName: "密苏里州伦纳德伍德",
    traditionalName: "密蘇里州倫納德伍德",
    airports: [
      {
        code: "TBN",
        name: "Waynesvl-st robert rgnl",
        chineseName: "伟恩斯维尔圣罗伯特地区机场",
        traditionalName: "偉恩斯維爾聖羅伯特地區機場",
      },
    ],
  },
  TBO: {
    code: "TBO",
    name: "TABORA",
    chineseName: "塔波拉",
    traditionalName: "塔波拉",
    airports: [
      {
        code: "TBO",
        name: "Tabora airport",
        chineseName: "塔波拉机场",
        traditionalName: "塔波拉機場",
      },
    ],
  },
  TBP: {
    code: "TBP",
    name: "TUMBES",
    chineseName: "通贝斯",
    traditionalName: "通貝斯",
    airports: [
      {
        code: "TBP",
        name: "Pedro canga rodriguez",
        chineseName: "通贝斯机场",
        traditionalName: "通貝斯機場",
      },
    ],
  },
  TBS: {
    code: "TBS",
    name: "TBILISI",
    chineseName: "第比利斯",
    traditionalName: "第比利斯",
    airports: [
      {
        code: "TBS",
        name: "Tbilisi intl.",
        chineseName: "第比利斯国际机场",
        traditionalName: "第比利斯國際機場",
      },
    ],
  },
  TBT: {
    code: "TBT",
    name: "TABATINGA",
    chineseName: "塔巴廷加",
    traditionalName: "塔巴廷加",
    airports: [
      {
        code: "TBT",
        name: "Tabatinga intl.",
        chineseName: "塔巴廷加国际机场",
        traditionalName: "塔巴廷加國際機場",
      },
    ],
  },
  TBU: {
    code: "TBU",
    name: "NUKU'ALOFA",
    chineseName: "努库阿洛法",
    traditionalName: "努瓜婁發",
    airports: [
      {
        code: "TBU",
        name: "Fua'amotu intl",
        chineseName: "弗阿阿莫图国际机场",
        traditionalName: "弗阿阿莫圖國際機場",
      },
    ],
  },
  TBW: {
    code: "TBW",
    name: "TAMBOV",
    chineseName: "坦波夫",
    traditionalName: "坦波夫",
    airports: [
      {
        code: "TBW",
        name: "Donskoye",
        chineseName: "顿斯科耶机场",
        traditionalName: "頓斯科耶機場",
      },
    ],
  },
  TBZ: {
    code: "TBZ",
    name: "TABRIZ",
    chineseName: "大不里士",
    traditionalName: "大不裡士",
    airports: [
      {
        code: "TBZ",
        name: "Tabriz intl.",
        chineseName: "大不里士国际机场",
        traditionalName: "大不裡士國際機場",
      },
    ],
  },
  TCA: {
    code: "TCA",
    name: "TENNANT CREEK",
    chineseName: "滕南特克里克",
    traditionalName: "滕南特克裏克",
    airports: [
      {
        code: "TCA",
        name: "Tennant creek airport",
        chineseName: "滕南特克里克机场",
        traditionalName: "滕南特克裡克機場",
      },
    ],
  },
  TCB: {
    code: "TCB",
    name: "TREASURE CAY",
    chineseName: "特利休阿岛",
    traditionalName: "特利休阿島",
    airports: [
      {
        code: "TCB",
        name: "Treasure cay airport",
        chineseName: "特雷苏尔凯机场",
        traditionalName: "特雷蘇爾凱機場",
      },
    ],
  },
  TCD: {
    code: "TCD",
    name: "TARAPACA",
    chineseName: "塔拉帕卡",
    traditionalName: "塔拉帕卡",
    airports: [
      {
        code: "TCD",
        name: "Tarapaca airport",
        chineseName: "塔拉帕卡机场",
        traditionalName: "塔拉帕卡機場",
      },
    ],
  },
  TCG: {
    code: "TCG",
    name: "TACHENG",
    chineseName: "塔城",
    traditionalName: "塔城",
    airports: [
      {
        code: "TCG",
        name: "Tacheng airport",
        chineseName: "塔城千泉机场",
        traditionalName: "塔城千泉機場",
      },
    ],
  },
  TCI: {
    code: "TCI",
    name: "TENERIFE",
    chineseName: "特内里费",
    traditionalName: "特內裡費",
    airports: [
      {
        code: "TFN",
        name: "Tenerife-norte",
        chineseName: "特内里费北部机场",
        traditionalName: "特內裏費北部機場",
      },
      {
        code: "TFS",
        name: "Tenerife-sur",
        chineseName: "特内里费南部机场",
        traditionalName: "特內裏費南部機場",
      },
    ],
  },
  TCO: {
    code: "TCO",
    name: "TUMACO",
    chineseName: "图马科",
    traditionalName: "圖馬科",
    airports: [
      {
        code: "TCO",
        name: "La florida",
        chineseName: "拉佛罗里达机场",
        traditionalName: "拉佛羅里達機場",
      },
    ],
  },
  TCQ: {
    code: "TCQ",
    name: "TACNA",
    chineseName: "塔克纳",
    traditionalName: "塔克納",
    airports: [
      {
        code: "TCQ",
        name: "C.ciriani santa rosa",
        chineseName: "塔克纳机场",
        traditionalName: "塔克納機場",
      },
    ],
  },
  TCR: {
    code: "TCR",
    name: "TUTICORIN",
    chineseName: "杜蒂戈林",
    traditionalName: "杜蒂戈林",
    airports: [
      {
        code: "TCR",
        name: "Tuticorin airport",
        chineseName: "杜蒂戈林机场",
        traditionalName: "杜蒂戈林機場",
      },
    ],
  },
  TCT: {
    code: "TCT",
    name: "TAKOTNA",
    chineseName: "塔克特纳",
    traditionalName: "塔克特納",
    airports: [
      {
        code: "TCT",
        name: "Takotna airport",
        chineseName: "塔克特纳机场",
        traditionalName: "塔克特納機場",
      },
    ],
  },
  TCX: {
    code: "TCX",
    name: "TABAS",
    chineseName: "塔巴斯",
    traditionalName: "塔巴斯",
    airports: [
      {
        code: "TCX",
        name: "Tabas airport",
        chineseName: "塔巴斯机场",
        traditionalName: "塔巴斯機場",
      },
    ],
  },
  TCZ: {
    code: "TCZ",
    name: "TENGCHONG",
    chineseName: "腾冲",
    traditionalName: "騰沖",
    airports: [
      {
        code: "TCZ",
        name: "Tuofeng",
        chineseName: "驼峰机场",
        traditionalName: "駝峰機場",
      },
    ],
  },
  TDD: {
    code: "TDD",
    name: "TRINIDAD",
    chineseName: "特立尼达",
    traditionalName: "特立尼達",
    airports: [
      {
        code: "TDD",
        name: "Jorge henrich arauz",
        chineseName: "特立尼达机场",
        traditionalName: "特立尼達機場",
      },
    ],
  },
  TDK: {
    code: "TDK",
    name: "TALDYKORGAN",
    chineseName: "塔迪库尔干",
    traditionalName: "塔迪庫爾幹",
    airports: [
      {
        code: "TDK",
        name: "Taldykorgan airport",
        chineseName: "塔尔迪库尔干机场",
        traditionalName: "塔爾迪庫爾幹機場",
      },
    ],
  },
  TDX: {
    code: "TDX",
    name: "TRAT",
    chineseName: "达叻",
    traditionalName: "達叻",
    airports: [
      {
        code: "TDX",
        name: "Trat airport",
        chineseName: "达叻机场",
        traditionalName: "達叻機場",
      },
    ],
  },
  TEB: {
    code: "TEB",
    name: "TETERBORO",
    chineseName: "泰特伯勒",
    traditionalName: "泰特伯勒",
    airports: [
      {
        code: "TEB",
        name: "Teterboro airport",
        chineseName: "泰特伯勒机场",
        traditionalName: "泰特伯勒機場",
      },
    ],
  },
  TEC: {
    code: "TEC",
    name: "TELEMACO BORBA",
    chineseName: "特雷马科博巴",
    traditionalName: "特雷馬科博巴",
    airports: [
      {
        code: "TEC",
        name: "Telemaco borba airport",
        chineseName: "特雷马科博巴机场",
        traditionalName: "特雷馬科博巴機場",
      },
    ],
  },
  TEE: {
    code: "TEE",
    name: "TEBESSA",
    chineseName: "泰贝萨",
    traditionalName: "泰貝薩",
    airports: [
      {
        code: "TEE",
        name: "Cheikh larbi tebessi",
        chineseName: "泰贝萨机场",
        traditionalName: "泰貝薩機場",
      },
    ],
  },
  TEF: {
    code: "TEF",
    name: "TELFER",
    chineseName: "特尔佛",
    traditionalName: "特爾佛",
    airports: [
      {
        code: "TEF",
        name: "Telfer airport",
        chineseName: "特尔佛机场",
        traditionalName: "特爾佛機場",
      },
    ],
  },
  TEI: {
    code: "TEI",
    name: "TEZU",
    chineseName: "德苏",
    traditionalName: "德蘇",
    airports: [
      {
        code: "TEI",
        name: "Tezu airport",
        chineseName: "德苏机场",
        traditionalName: "德蘇機場",
      },
    ],
  },
  TEK: {
    code: "TEK",
    name: "TATITLEK",
    chineseName: "塔蒂特利克",
    traditionalName: "塔蒂特利克",
    airports: [
      {
        code: "TEK",
        name: "Tatitlek airport",
        chineseName: "塔蒂特利克机场",
        traditionalName: "塔蒂特利克機場",
      },
    ],
  },
  TEN: {
    code: "TEN",
    name: "TONGREN",
    chineseName: "铜仁",
    traditionalName: "銅仁",
    airports: [
      {
        code: "TEN",
        name: "Fenhuang",
        chineseName: "凤凰机场",
        traditionalName: "鳳凰機場",
      },
    ],
  },
  TEQ: {
    code: "TEQ",
    name: "TEKIRDAG",
    chineseName: "泰基尔达",
    traditionalName: "泰基爾達",
    airports: [
      {
        code: "TEQ",
        name: "Corlu",
        chineseName: "考鲁机场",
        traditionalName: "考魯機場",
      },
    ],
  },
  TER: {
    code: "TER",
    name: "TERCEIRA ISLAND",
    chineseName: "特塞拉岛",
    traditionalName: "特塞拉島",
    airports: [
      {
        code: "TER",
        name: "Lajes",
        chineseName: "拉杰斯机场",
        traditionalName: "拉傑斯機場",
      },
    ],
  },
  TET: {
    code: "TET",
    name: "TETE",
    chineseName: "太特",
    traditionalName: "太特",
    airports: [
      {
        code: "TET",
        name: "Chingozi",
        chineseName: "马通多机场",
        traditionalName: "馬通多機場",
      },
    ],
  },
  TEX: {
    code: "TEX",
    name: "TELLURIDE",
    chineseName: "特柳赖德",
    traditionalName: "特柳賴德",
    airports: [
      {
        code: "TEX",
        name: "Telluride reg. airport",
        chineseName: "特柳赖德机场",
        traditionalName: "特柳賴德機場",
      },
    ],
  },
  TFF: {
    code: "TFF",
    name: "TEFE",
    chineseName: "蒂费",
    traditionalName: "蒂費",
    airports: [
      {
        code: "TFF",
        name: "Tefe airport",
        chineseName: "特费机场",
        traditionalName: "特費機場",
      },
    ],
  },
  TFL: {
    code: "TFL",
    name: "TEOFILO OTONI",
    chineseName: "特奥菲卢奥托尼",
    traditionalName: "特奧菲盧奧托尼",
    airports: [
      {
        code: "TFL",
        name: "Juscelino kubitscheck",
        chineseName: "特奥菲卢奥托尼机场",
        traditionalName: "特奧菲盧奧托尼機場",
      },
    ],
  },
  TGC: {
    code: "TGC",
    name: "TANJUNG MANIS",
    chineseName: "泗里奎",
    traditionalName: "泗裏奎",
    airports: [
      {
        code: "TGC",
        name: "Tanjung manis airport",
        chineseName: "丹戎马尼港",
        traditionalName: "丹戎馬尼港",
      },
    ],
  },
  TGD: {
    code: "TGD",
    name: "PODGORICA",
    chineseName: "波德戈里察",
    traditionalName: "波德戈裡察",
    airports: [
      {
        code: "TGD",
        name: "Podgorica airport",
        chineseName: "波德戈里察机场",
        traditionalName: "波德戈裡察機場",
      },
    ],
  },
  TGG: {
    code: "TGG",
    name: "KUALA TERENGGANU",
    chineseName: "瓜拉丁加奴",
    traditionalName: "瓜拉丁加奴",
    airports: [
      {
        code: "TGG",
        name: "Sultan mahmud",
        chineseName: "苏丹马赫穆德机场",
        traditionalName: "蘇丹馬赫穆德機場",
      },
    ],
  },
  TGI: {
    code: "TGI",
    name: "TINGO MARIA",
    chineseName: "廷戈玛丽亚",
    traditionalName: "廷戈瑪麗亞",
    airports: [
      {
        code: "TGI",
        name: "Tingo maria airport",
        chineseName: "廷戈玛丽亚机场",
        traditionalName: "廷戈瑪麗亞機場",
      },
    ],
  },
  TGM: {
    code: "TGM",
    name: "TARGU-MURES",
    chineseName: "Tirgu Mures",
    traditionalName: "Tirgu Mures",
    airports: [
      {
        code: "TGM",
        name: "Transilvania",
        chineseName: "特尔古穆列什机场",
        traditionalName: "特爾古穆列什機場",
      },
    ],
  },
  TGO: {
    code: "TGO",
    name: "TONGLIAO",
    chineseName: "通辽",
    traditionalName: "通遼",
    airports: [
      {
        code: "TGO",
        name: "Tongliao airport",
        chineseName: "通辽机场",
        traditionalName: "通遼機場",
      },
    ],
  },
  TGP: {
    code: "TGP",
    name: "BOR",
    chineseName: "博尔",
    traditionalName: "博爾",
    airports: [
      {
        code: "TGP",
        name: "Podkamennaya tunguska",
        chineseName: "石泉通古斯卡机场",
        traditionalName: "石泉通古斯卡機場",
      },
    ],
  },
  TGR: {
    code: "TGR",
    name: "TOUGGOURT",
    chineseName: "图古尔特",
    traditionalName: "圖古爾特",
    airports: [
      {
        code: "TGR",
        name: "Sidi mahdi",
        chineseName: "图古尔特机场",
        traditionalName: "圖古爾特機場",
      },
    ],
  },
  TGT: {
    code: "TGT",
    name: "TANGA",
    chineseName: "坦噶",
    traditionalName: "坦噶",
    airports: [
      {
        code: "TGT",
        name: "Tanga airport",
        chineseName: "坦噶机场",
        traditionalName: "坦噶機場",
      },
    ],
  },
  TGU: {
    code: "TGU",
    name: "TEGUCIGALPA",
    chineseName: "特古西加尔巴",
    traditionalName: "德古西加巴",
    airports: [
      {
        code: "TGU",
        name: "Toncontin intl",
        chineseName: "通孔廷国际机场",
        traditionalName: "通孔廷國際機場",
      },
      {
        code: "XPL",
        name: "Palmerola intl.",
        chineseName: "帕尔梅罗拉空军基地机场",
        traditionalName: "帕爾梅羅拉空軍基地機場",
      },
    ],
  },
  TGZ: {
    code: "TGZ",
    name: "TUXTLA GUTIERREZ",
    chineseName: "图斯特拉-古铁雷斯",
    traditionalName: "圖斯特拉-古鐵雷斯",
    airports: [
      {
        code: "TGZ",
        name: "Angel albino corzo int",
        chineseName: "安赫尔阿尔比诺科尔佐国际机场",
        traditionalName: "安赫爾阿爾比諾科爾佐國際機場",
      },
    ],
  },
  THD: {
    code: "THD",
    name: "THANH HOA",
    chineseName: "清化",
    traditionalName: "清化",
    airports: [
      {
        code: "THD",
        name: "Tho xuan",
        chineseName: "寿春机场",
        traditionalName: "壽春機場",
      },
    ],
  },
  THE: {
    code: "THE",
    name: "TERESINA",
    chineseName: "特雷西纳",
    traditionalName: "特雷西納",
    airports: [
      {
        code: "THE",
        name: "Petronio portella",
        chineseName: "塞纳多尔佩特罗尼奥波特拉机场",
        traditionalName: "塞納多爾佩特羅尼奧波特拉機場",
      },
    ],
  },
  THL: {
    code: "THL",
    name: "TACHILEK",
    chineseName: "大其力",
    traditionalName: "大其力",
    airports: [
      {
        code: "THL",
        name: "Tachilek airport",
        chineseName: "塔基雷克机场",
        traditionalName: "塔基雷克機場",
      },
    ],
  },
  THN: {
    code: "THN",
    name: "TROLLHATTAN/VANERSBORG",
    chineseName: "特罗尔海坦",
    traditionalName: "特羅爾海坦",
    airports: [
      {
        code: "THN",
        name: "Trollhattan/vanersborg airport",
        chineseName: "特罗尔海坦机场",
        traditionalName: "特羅爾海坦機場",
      },
    ],
  },
  THO: {
    code: "THO",
    name: "THORSHOFN",
    chineseName: "索尔斯港",
    traditionalName: "索爾斯港",
    airports: [
      {
        code: "THO",
        name: "Thorshofn airport",
        chineseName: "索尔斯港机场",
        traditionalName: "索爾斯港機場",
      },
    ],
  },
  THQ: {
    code: "THQ",
    name: "TIANSHUI",
    chineseName: "天水",
    traditionalName: "天水",
    airports: [
      {
        code: "THQ",
        name: "Maijishan",
        chineseName: "麦积山机场",
        traditionalName: "麥積山機場",
      },
    ],
  },
  THR: {
    code: "THR",
    name: "TEHRAN",
    chineseName: "德黑兰",
    traditionalName: "德黑蘭",
    airports: [
      {
        code: "IKA",
        name: "Imam khomeini intl",
        chineseName: "伊玛姆科梅尼国际机场",
        traditionalName: "伊瑪姆科梅尼國際機場",
      },
      {
        code: "THR",
        name: "Mehrabad intl",
        chineseName: "梅赫拉巴德机场",
        traditionalName: "梅赫拉巴德機場",
      },
    ],
  },
  THS: {
    code: "THS",
    name: "SUKHOTHAI",
    chineseName: "素可泰",
    traditionalName: "素可泰",
    airports: [
      {
        code: "THS",
        name: "Sukhothai airport",
        chineseName: "素可泰机场",
        traditionalName: "素可泰機場",
      },
    ],
  },
  THU: {
    code: "THU",
    name: "PITUFFIK",
    chineseName: "皮图菲克",
    traditionalName: "皮圖菲克",
    airports: [
      {
        code: "THU",
        name: "Thule air base",
        chineseName: "图勒空军基地",
        traditionalName: "圖勒空軍基地",
      },
    ],
  },
  THX: {
    code: "THX",
    name: "TURUKHANSK",
    chineseName: "图鲁汉斯克",
    traditionalName: "圖魯漢斯克",
    airports: [
      {
        code: "THX",
        name: "Turukhansk airport",
        chineseName: "土鲁罕斯克机场",
        traditionalName: "土魯罕斯克機場",
      },
    ],
  },
  TIA: {
    code: "TIA",
    name: "TIRANA",
    chineseName: "地拉那",
    traditionalName: "地拉那",
    airports: [
      {
        code: "TIA",
        name: "Nene tereza intl",
        chineseName: "地拉那机场",
        traditionalName: "地拉那機場",
      },
    ],
  },
  TID: {
    code: "TID",
    name: "TIARET",
    chineseName: "提亚雷特",
    traditionalName: "提亞雷特",
    airports: [
      {
        code: "TID",
        name: "Bou chekif",
        chineseName: "博切基夫机场",
        traditionalName: "博切基夫機場",
      },
    ],
  },
  TIF: {
    code: "TIF",
    name: "TAIF",
    chineseName: "塔伊夫",
    traditionalName: "塔伊夫",
    airports: [
      {
        code: "TIF",
        name: "Taif airport",
        chineseName: "塔伊夫机场",
        traditionalName: "塔伊夫機場",
      },
    ],
  },
  TIH: {
    code: "TIH",
    name: "TIKEHAU",
    chineseName: "提克豪环礁",
    traditionalName: "提克豪環礁",
    airports: [
      {
        code: "TIH",
        name: "Tikehau airport",
        chineseName: "提克豪环礁机场",
        traditionalName: "提克豪環礁機場",
      },
    ],
  },
  TIJ: {
    code: "TIJ",
    name: "TIJUANA",
    chineseName: "蒂华纳",
    traditionalName: "蒂華納",
    airports: [
      {
        code: "TIJ",
        name: "A.l. rodriguez intl",
        chineseName: "罗德里格兹将军国际机场",
        traditionalName: "羅德里格茲將軍國際機場",
      },
    ],
  },
  TIM: {
    code: "TIM",
    name: "TEMBAGAPURA/TIMIKA",
    chineseName: "特巴加普拉",
    traditionalName: "特巴加普拉",
    airports: [
      {
        code: "TIM",
        name: "Moses kilangin",
        chineseName: "提米卡机场",
        traditionalName: "提米卡機場",
      },
    ],
  },
  TIN: {
    code: "TIN",
    name: "TINDOUF",
    chineseName: "廷杜夫",
    traditionalName: "廷杜夫",
    airports: [
      {
        code: "TIN",
        name: "Tindouf airport",
        chineseName: "廷杜夫机场",
        traditionalName: "廷杜夫機場",
      },
    ],
  },
  TIP: {
    code: "TIP",
    name: "TRIPOLI",
    chineseName: "的黎波里",
    traditionalName: "的黎波里",
    airports: [
      {
        code: "MJI",
        name: "Mitiga",
        chineseName: "米提加机场",
        traditionalName: "米提加機場",
      },
    ],
  },
  TIQ: {
    code: "TIQ",
    name: "TINIAN",
    chineseName: "提尼安",
    traditionalName: "提尼安",
    airports: [
      {
        code: "TIQ",
        name: "Tinian intl.",
        chineseName: "天宁国际机场",
        traditionalName: "天寧國際機場",
      },
    ],
  },
  TIR: {
    code: "TIR",
    name: "TIRUPATI",
    chineseName: "蒂鲁伯蒂",
    traditionalName: "蒂魯伯蒂",
    airports: [
      {
        code: "TIR",
        name: "Tirupati airport",
        chineseName: "蒂鲁伯蒂机场",
        traditionalName: "蒂魯伯蒂機場",
      },
    ],
  },
  TIU: {
    code: "TIU",
    name: "TIMARU",
    chineseName: "蒂玛鲁",
    traditionalName: "蒂瑪魯",
    airports: [
      {
        code: "TIU",
        name: "Richard pearse",
        chineseName: "理查德皮尔斯机场",
        traditionalName: "理查德皮爾斯機場",
      },
    ],
  },
  TIV: {
    code: "TIV",
    name: "TIVAT",
    chineseName: "蒂瓦特",
    traditionalName: "蒂瓦特",
    airports: [
      {
        code: "TIV",
        name: "Tivat airport",
        chineseName: "提瓦特机场",
        traditionalName: "提瓦特機場",
      },
    ],
  },
  TIZ: {
    code: "TIZ",
    name: "TARI",
    chineseName: "塔利",
    traditionalName: "塔利",
    airports: [
      {
        code: "TIZ",
        name: "Tari airport",
        chineseName: "塔利机场",
        traditionalName: "塔利機場",
      },
    ],
  },
  TJA: {
    code: "TJA",
    name: "TARIJA",
    chineseName: "塔里哈",
    traditionalName: "塔里哈",
    airports: [
      {
        code: "TJA",
        name: "Cap. oriel lea plaza",
        chineseName: "塔里哈机场",
        traditionalName: "塔里哈機場",
      },
    ],
  },
  TJH: {
    code: "TJH",
    name: "TOYOOKA",
    chineseName: "丰冈",
    traditionalName: "豐岡",
    airports: [
      {
        code: "TJH",
        name: "Tajima",
        chineseName: "丰冈机场",
        traditionalName: "豐岡機場",
      },
    ],
  },
  TJK: {
    code: "TJK",
    name: "TOKAT",
    chineseName: "托卡特",
    traditionalName: "托卡特",
    airports: [
      {
        code: "TJK",
        name: "Tokat airport",
        chineseName: "托卡特机场",
        traditionalName: "托卡特機場",
      },
    ],
  },
  TJL: {
    code: "TJL",
    name: "TRES LAGOAS",
    chineseName: "特雷斯拉瓜斯",
    traditionalName: "特雷斯拉瓜斯",
    airports: [
      {
        code: "TJL",
        name: "Plinio alarcom",
        chineseName: "特雷斯拉瓜斯机场",
        traditionalName: "特雷斯拉瓜斯機場",
      },
    ],
  },
  TJM: {
    code: "TJM",
    name: "TYUMEN",
    chineseName: "秋明",
    traditionalName: "秋明",
    airports: [
      {
        code: "TJM",
        name: "Roshchino",
        chineseName: "罗希诺国际机场",
        traditionalName: "羅希諾國際機場",
      },
    ],
  },
  TJN: {
    code: "TJN",
    name: "TAKUME",
    chineseName: "塔库梅",
    traditionalName: "塔庫梅",
    airports: [
      {
        code: "TJN",
        name: "Takume airport",
        chineseName: "塔库梅机场",
        traditionalName: "塔庫梅機場",
      },
    ],
  },
  TJQ: {
    code: "TJQ",
    name: "TANJUNG PANDAN",
    chineseName: "丹戎潘丹",
    traditionalName: "丹戎潘丹",
    airports: [
      {
        code: "TJQ",
        name: "H.a.s. hanandjoeddin",
        chineseName: "H.A.S.汉纳德卓丁机场",
        traditionalName: "H.A.S.漢納德卓丁機場",
      },
    ],
  },
  TJS: {
    code: "TJS",
    name: "TANJUNG SELOR",
    chineseName: "丹戎瑟罗尔",
    traditionalName: "丹戎瑟羅爾",
    airports: [
      {
        code: "TJS",
        name: "Tanjung harapan",
        chineseName: "丹戎瑟罗尔机场",
        traditionalName: "丹戎瑟羅爾機場",
      },
    ],
  },
  TJU: {
    code: "TJU",
    name: "KULOB",
    chineseName: "库利亚布",
    traditionalName: "庫利亞布",
    airports: [
      {
        code: "TJU",
        name: "Kulob airport",
        chineseName: "库利亚布机场",
        traditionalName: "庫利亞布機場",
      },
    ],
  },
  TKD: {
    code: "TKD",
    name: "TAKORADI",
    chineseName: "塔科拉迪",
    traditionalName: "塔科拉迪",
    airports: [
      {
        code: "TKD",
        name: "Takoradi airport",
        chineseName: "塔科拉迪机场",
        traditionalName: "塔科拉迪機場",
      },
    ],
  },
  TKE: {
    code: "TKE",
    name: "TENAKEE SPRINGS",
    chineseName: "特纳基",
    traditionalName: "特納基",
    airports: [
      {
        code: "TKE",
        name: "Tenakee spb",
        chineseName: "特纳基水上飞机基地",
        traditionalName: "特納基水上飛機基地",
      },
    ],
  },
  TKF: {
    code: "TKF",
    name: "TRUCKEE",
    chineseName: "特拉基",
    traditionalName: "特拉基",
    airports: [
      {
        code: "TKF",
        name: "Truckee-tahoe",
        chineseName: "特拉基机场",
        traditionalName: "特拉基機場",
      },
    ],
  },
  TKG: {
    code: "TKG",
    name: "BANDAR LAMPUNG",
    chineseName: "楠榜港",
    traditionalName: "楠榜港",
    airports: [
      {
        code: "TKG",
        name: "Radin inten ii",
        chineseName: "雷丁印甸二世机场",
        traditionalName: "雷丁印甸二世機場",
      },
    ],
  },
  TKJ: {
    code: "TKJ",
    name: "TOK",
    chineseName: "阿拉斯加州托克",
    traditionalName: "阿拉斯加州托克",
    airports: [
      {
        code: "TKJ",
        name: "Tok junction",
        chineseName: "托克山机场",
        traditionalName: "托克山機場",
      },
    ],
  },
  TKK: {
    code: "TKK",
    name: "CHUUK",
    chineseName: "特鲁克",
    traditionalName: "特魯克",
    airports: [
      {
        code: "TKK",
        name: "Chuuk intl.",
        chineseName: "楚克国际机场",
        traditionalName: "楚克國際機場",
      },
    ],
  },
  TKM: {
    code: "TKM",
    name: "TAKSIMO",
    chineseName: "蒂卡尔",
    traditionalName: "蒂卡爾",
    airports: [
      {
        code: "TKM",
        name: "Taksimo intl.",
        chineseName: "蒂卡尔机场",
        traditionalName: "蒂卡爾機場",
      },
    ],
  },
  TKN: {
    code: "TKN",
    name: "TOKUNOSHIMA",
    chineseName: "德之岛",
    traditionalName: "德之島",
    airports: [
      {
        code: "TKN",
        name: "Tokunoshima airport",
        chineseName: "德之岛机场",
        traditionalName: "德之島機場",
      },
    ],
  },
  TKP: {
    code: "TKP",
    name: "TAKAPOTO",
    chineseName: "塔卡波托",
    traditionalName: "塔卡波托",
    airports: [
      {
        code: "TKP",
        name: "Takapoto airport",
        chineseName: "塔卡波托机场",
        traditionalName: "塔卡波托機場",
      },
    ],
  },
  TKQ: {
    code: "TKQ",
    name: "KIGOMA",
    chineseName: "基戈马",
    traditionalName: "基戈馬",
    airports: [
      {
        code: "TKQ",
        name: "Kigoma airport",
        chineseName: "基戈马机场",
        traditionalName: "基戈馬機場",
      },
    ],
  },
  TKS: {
    code: "TKS",
    name: "TOKUSHIMA",
    chineseName: "德岛",
    traditionalName: "德島",
    airports: [
      {
        code: "TKS",
        name: "Tokushima airport",
        chineseName: "德岛机场",
        traditionalName: "德島機場",
      },
    ],
  },
  TKU: {
    code: "TKU",
    name: "TURKU",
    chineseName: "图尔库",
    traditionalName: "圖爾庫",
    airports: [
      {
        code: "TKU",
        name: "Turku airport",
        chineseName: "图尔库机场",
        traditionalName: "圖爾庫機場",
      },
    ],
  },
  TKV: {
    code: "TKV",
    name: "TATAKOTO",
    chineseName: "图阿莫托",
    traditionalName: "圖阿莫托",
    airports: [
      {
        code: "TKV",
        name: "Tatakoto airport",
        chineseName: "塔塔科托机场",
        traditionalName: "塔塔科托機場",
      },
    ],
  },
  TKX: {
    code: "TKX",
    name: "TAKAROA",
    chineseName: "塔卡罗阿",
    traditionalName: "塔卡羅阿",
    airports: [
      {
        code: "TKX",
        name: "Takaroa airport",
        chineseName: "塔卡罗阿机场",
        traditionalName: "塔卡羅阿機場",
      },
    ],
  },
  TLA: {
    code: "TLA",
    name: "TELLER",
    chineseName: "阿拉斯加州泰勒",
    traditionalName: "阿拉斯加州泰勒",
    airports: [
      {
        code: "TLA",
        name: "Teller airport",
        chineseName: "特勒机场",
        traditionalName: "特勒機場",
      },
    ],
  },
  TLE: {
    code: "TLE",
    name: "TOLIARA",
    chineseName: "图利亚拉",
    traditionalName: "圖利亞拉",
    airports: [
      {
        code: "TLE",
        name: "Toliara airport",
        chineseName: "图莱亚尔机场",
        traditionalName: "圖萊亞爾機場",
      },
    ],
  },
  TLH: {
    code: "TLH",
    name: "TALLAHASSEE",
    chineseName: "塔拉哈西",
    traditionalName: "達拉哈西",
    airports: [
      {
        code: "TLH",
        name: "Tallahassee intl.",
        chineseName: "塔拉哈西国际机场",
        traditionalName: "達拉哈西國際機場",
      },
    ],
  },
  TLI: {
    code: "TLI",
    name: "TOLITOLI",
    chineseName: "托利托利",
    traditionalName: "托利托利",
    airports: [
      {
        code: "TLI",
        name: "Lalos",
        chineseName: "托利托利机场",
        traditionalName: "托利托利機場",
      },
    ],
  },
  TLJ: {
    code: "TLJ",
    name: "TATALINA",
    chineseName: "阿拉斯加州塔塔林纳",
    traditionalName: "阿拉斯加州塔塔林納",
    airports: [
      {
        code: "TLJ",
        name: "Tatalina airport",
        chineseName: "塔塔里纳机场",
        traditionalName: "塔塔裏納機場",
      },
    ],
  },
  TLK: {
    code: "TLK",
    name: "TALAKAN",
    chineseName: "塔拉坎",
    traditionalName: "塔拉坎",
    airports: [
      {
        code: "TLK",
        name: "Talakan airport",
        chineseName: "塔拉坎机场",
        traditionalName: "塔拉坎機場",
      },
    ],
  },
  TLL: {
    code: "TLL",
    name: "TALLINN",
    chineseName: "塔林",
    traditionalName: "塔林",
    airports: [
      {
        code: "TLL",
        name: "Lennart meri",
        chineseName: "伦纳特梅里机场",
        traditionalName: "倫納特梅裡機場",
      },
    ],
  },
  TLM: {
    code: "TLM",
    name: "TLEMCEN",
    chineseName: "特莱姆森",
    traditionalName: "特萊姆森",
    airports: [
      {
        code: "TLM",
        name: "Zenata-messali el hadj",
        chineseName: "泽纳塔机场",
        traditionalName: "澤納塔機場",
      },
    ],
  },
  TLN: {
    code: "TLN",
    name: "TOULON/HYERES",
    chineseName: "土伦",
    traditionalName: "土倫",
    airports: [
      {
        code: "TLN",
        name: "La palyvestre",
        chineseName: "海雷斯机场",
        traditionalName: "海雷斯機場",
      },
    ],
  },
  TLQ: {
    code: "TLQ",
    name: "TURPAN",
    chineseName: "吐鲁番",
    traditionalName: "吐魯番",
    airports: [
      {
        code: "TLQ",
        name: "Jiaohe",
        chineseName: "交河机场",
        traditionalName: "交河機場",
      },
    ],
  },
  TLS: {
    code: "TLS",
    name: "TOULOUSE",
    chineseName: "图卢兹市",
    traditionalName: "圖盧茲市",
    airports: [
      {
        code: "TLS",
        name: "Blagnac",
        chineseName: "布拉格纳克机场",
        traditionalName: "布拉格納克機場",
      },
    ],
  },
  TLT: {
    code: "TLT",
    name: "TULUKSAK",
    chineseName: "图卢克萨克",
    traditionalName: "圖盧克薩克",
    airports: [
      {
        code: "TLT",
        name: "Tuluksak airport",
        chineseName: "图鲁克萨克机场",
        traditionalName: "圖魯克薩克機場",
      },
    ],
  },
  TLU: {
    code: "TLU",
    name: "TOLU",
    chineseName: "托卢",
    traditionalName: "托盧",
    airports: [
      {
        code: "TLU",
        name: "Golfo de morrosquillo",
        chineseName: "托卢机场",
        traditionalName: "托盧機場",
      },
    ],
  },
  TLV: {
    code: "TLV",
    name: "TEL AVIV-YAFO",
    chineseName: "特拉维夫",
    traditionalName: "特拉維夫",
    airports: [
      {
        code: "TLV",
        name: "Ben gurion intl",
        chineseName: "本古里安国际机场",
        traditionalName: "本古裡安國際機場",
      },
    ],
  },
  TLY: {
    code: "TLY",
    name: "PLASTUN",
    chineseName: "普拉斯通",
    traditionalName: "普拉斯通",
    airports: [
      {
        code: "TLY",
        name: "Plastun airport",
        chineseName: "普拉斯通机场",
        traditionalName: "普拉斯通機場",
      },
    ],
  },
  TMC: {
    code: "TMC",
    name: "TAMBOLAKA",
    chineseName: "坦博拉卡",
    traditionalName: "坦博拉卡",
    airports: [
      {
        code: "TMC",
        name: "Waikabubak",
        chineseName: "坦博拉卡机场",
        traditionalName: "坦博拉卡機場",
      },
    ],
  },
  TME: {
    code: "TME",
    name: "TAME",
    chineseName: "塔梅",
    traditionalName: "塔梅",
    airports: [
      {
        code: "TME",
        name: "Gabriel vargas santos",
        chineseName: "加布里埃尔瓦尔加斯桑托斯机场",
        traditionalName: "加布裡埃爾瓦爾加斯桑托斯機場",
      },
    ],
  },
  TMF: {
    code: "TMF",
    name: "THIMARAFUSHI",
    chineseName: "提玛拉孚士",
    traditionalName: "提瑪拉孚士",
    airports: [
      {
        code: "TMF",
        name: "Thimarafushi airport",
        chineseName: "提玛拉孚士机场",
        traditionalName: "提瑪拉孚士機場",
      },
    ],
  },
  TMH: {
    code: "TMH",
    name: "TANAHMERAH",
    chineseName: "塔拉默拉",
    traditionalName: "塔拉默拉",
    airports: [
      {
        code: "TMH",
        name: "Tanahmerah airport",
        chineseName: "塔拉默拉机场",
        traditionalName: "塔拉默拉機場",
      },
    ],
  },
  TMI: {
    code: "TMI",
    name: "TUMLINGTAR",
    chineseName: "图姆灵塔尔",
    traditionalName: "圖姆靈塔爾",
    airports: [
      {
        code: "TMI",
        name: "Tumlingtar airport",
        chineseName: "图姆灵塔尔机场",
        traditionalName: "圖姆靈塔爾機場",
      },
    ],
  },
  TMJ: {
    code: "TMJ",
    name: "TERMEZ",
    chineseName: "铁尔米兹",
    traditionalName: "鐵爾米茲",
    airports: [
      {
        code: "TMJ",
        name: "Termez airport",
        chineseName: "泰尔梅兹机场",
        traditionalName: "泰爾梅茲機場",
      },
    ],
  },
  TML: {
    code: "TML",
    name: "TAMALE",
    chineseName: "塔马利",
    traditionalName: "塔馬利",
    airports: [
      {
        code: "TML",
        name: "Tamale airport",
        chineseName: "塔马拉机场",
        traditionalName: "塔馬拉機場",
      },
    ],
  },
  TMM: {
    code: "TMM",
    name: "TOAMASINA",
    chineseName: "塔马塔夫",
    traditionalName: "塔馬塔夫",
    airports: [
      {
        code: "TMM",
        name: "Toamasina airport",
        chineseName: "图阿马西纳机场",
        traditionalName: "圖阿馬西納機場",
      },
    ],
  },
  TMN: {
    code: "TMN",
    name: "TAMANA",
    chineseName: "塔马纳岛",
    traditionalName: "塔馬納島",
    airports: [
      {
        code: "TMN",
        name: "Tamana airport",
        chineseName: "塔马拉岛机场",
        traditionalName: "塔馬拉島機場",
      },
    ],
  },
  TMP: {
    code: "TMP",
    name: "TAMPERE",
    chineseName: "坦佩雷",
    traditionalName: "坦佩雷",
    airports: [
      {
        code: "TMP",
        name: "Tampere-pirkkala",
        chineseName: "皮尔卡拉机场",
        traditionalName: "皮爾卡拉機場",
      },
    ],
  },
  TMR: {
    code: "TMR",
    name: "TAMANRASSET",
    chineseName: "塔曼盖塞特",
    traditionalName: "塔曼蓋塞特",
    airports: [
      {
        code: "TMR",
        name: "Aguenar",
        chineseName: "阿格马尔机场",
        traditionalName: "阿格馬爾機場",
      },
    ],
  },
  TMS: {
    code: "TMS",
    name: "SAO TOME",
    chineseName: "圣多美岛",
    traditionalName: "聖多美島",
    airports: [
      {
        code: "TMS",
        name: "Sao tome intl.",
        chineseName: "圣多美国际机场",
        traditionalName: "聖多美國際機場",
      },
    ],
  },
  TMT: {
    code: "TMT",
    name: "TROMBETAS",
    chineseName: "特龙贝塔斯",
    traditionalName: "特龍貝塔斯",
    airports: [
      {
        code: "TMT",
        name: "Trombetas airport",
        chineseName: "特龙贝塔斯机场",
        traditionalName: "特龍貝塔斯機場",
      },
    ],
  },
  TMW: {
    code: "TMW",
    name: "TAMWORTH",
    chineseName: "塔姆沃思",
    traditionalName: "塔姆沃思",
    airports: [
      {
        code: "TMW",
        name: "Tamworth airport",
        chineseName: "塔姆沃思机场",
        traditionalName: "塔姆沃思機場",
      },
    ],
  },
  TMX: {
    code: "TMX",
    name: "TIMIMOUN",
    chineseName: "提米蒙",
    traditionalName: "提米蒙",
    airports: [
      {
        code: "TMX",
        name: "Timimoun airport",
        chineseName: "提米蒙机场",
        traditionalName: "提米蒙機場",
      },
    ],
  },
  TNA: {
    code: "TNA",
    name: "JINAN",
    chineseName: "济南",
    traditionalName: "濟南",
    airports: [
      {
        code: "TNA",
        name: "Yaoqiang intl",
        chineseName: "遥墙国际机场",
        traditionalName: "遙牆國際機場",
      },
    ],
  },
  TNC: {
    code: "TNC",
    name: "TIN CITY",
    chineseName: "丁城",
    traditionalName: "丁城",
    airports: [
      {
        code: "TNC",
        name: "Tin city airport",
        chineseName: "丁城机场",
        traditionalName: "丁城機場",
      },
    ],
  },
  TNE: {
    code: "TNE",
    name: "TANEGASHIMA",
    chineseName: "种子岛",
    traditionalName: "種子島",
    airports: [
      {
        code: "TNE",
        name: "Tanegashima airport",
        chineseName: "种子岛机场",
        traditionalName: "種子島機場",
      },
    ],
  },
  TNG: {
    code: "TNG",
    name: "TANGIER",
    chineseName: "丹吉尔",
    traditionalName: "坦吉爾",
    airports: [
      {
        code: "TNG",
        name: "Ibn batouta",
        chineseName: "伊本白图泰机场",
        traditionalName: "伊本白圖泰機場",
      },
    ],
  },
  TNH: {
    code: "TNH",
    name: "TONGHUA",
    chineseName: "通化",
    traditionalName: "通化",
    airports: [
      {
        code: "TNH",
        name: "Sanyuanpu",
        chineseName: "三源浦机场",
        traditionalName: "三源浦機場",
      },
    ],
  },
  TNJ: {
    code: "TNJ",
    name: "TANJUNG PINANG",
    chineseName: "丹戎槟榔",
    traditionalName: "丹戎檳榔",
    airports: [
      {
        code: "TNJ",
        name: "Raja haji fisabilillah",
        chineseName: "拉贾·哈吉·斐萨比里拉国际机场",
        traditionalName: "拉賈·哈吉·斐薩比裏拉國際機場",
      },
    ],
  },
  TNK: {
    code: "TNK",
    name: "TUNUNAK",
    chineseName: "阿拉斯加州图努纳克",
    traditionalName: "阿拉斯加州圖努納克",
    airports: [
      {
        code: "TNK",
        name: "Tununak airport",
        chineseName: "图努纳克机场",
        traditionalName: "圖努納克機場",
      },
    ],
  },
  TNN: {
    code: "TNN",
    name: "TAINAN",
    chineseName: "台南",
    traditionalName: "台南",
    airports: [
      {
        code: "TNN",
        name: "Tainan airport",
        chineseName: "台南机场",
        traditionalName: "台南機場",
      },
    ],
  },
  TNO: {
    code: "TNO",
    name: "TAMARINDO",
    chineseName: "塔马林多",
    traditionalName: "塔馬林多",
    airports: [
      {
        code: "TNO",
        name: "Tamarindo airport",
        chineseName: "塔马林多机场",
        traditionalName: "塔馬林多機場",
      },
    ],
  },
  TNR: {
    code: "TNR",
    name: "ANTANANARIVO",
    chineseName: "塔那那利佛",
    traditionalName: "安塔那那利佛",
    airports: [
      {
        code: "TNR",
        name: "Ivato intl",
        chineseName: "伊瓦图国际机场",
        traditionalName: "伊瓦圖國際機場",
      },
    ],
  },
  TOB: {
    code: "TOB",
    name: "TOBRUK",
    chineseName: "图卜鲁克",
    traditionalName: "圖蔔魯克",
    airports: [
      {
        code: "TOB",
        name: "Tobruk airport",
        chineseName: "图卜鲁格机场",
        traditionalName: "圖卜魯格機場",
      },
    ],
  },
  TOE: {
    code: "TOE",
    name: "TOZEUR",
    chineseName: "托泽尔",
    traditionalName: "托澤爾",
    airports: [
      {
        code: "TOE",
        name: "Nefta",
        chineseName: "内夫塔机场",
        traditionalName: "內夫塔機場",
      },
    ],
  },
  TOF: {
    code: "TOF",
    name: "TOMSK",
    chineseName: "托木斯克",
    traditionalName: "托木斯克",
    airports: [
      {
        code: "TOF",
        name: "Bogashevo",
        chineseName: "柏加谢沃机场",
        traditionalName: "柏加謝沃機場",
      },
    ],
  },
  TOG: {
    code: "TOG",
    name: "TOGIAK",
    chineseName: "托贾克",
    traditionalName: "托賈克",
    airports: [
      {
        code: "TOG",
        name: "Togiak airport",
        chineseName: "托贾克机场",
        traditionalName: "托賈克機場",
      },
    ],
  },
  TOH: {
    code: "TOH",
    name: "TORRES ISLANDS",
    chineseName: "托雷斯",
    traditionalName: "托雷斯",
    airports: [
      {
        code: "TOH",
        name: "Torres islands airport",
        chineseName: "托雷斯机场",
        traditionalName: "托雷斯機場",
      },
    ],
  },
  TOL: {
    code: "TOL",
    name: "TOLEDO",
    chineseName: "托莱多",
    traditionalName: "托萊多",
    airports: [
      {
        code: "TOL",
        name: "Express",
        chineseName: "伊克斯普雷斯机场",
        traditionalName: "伊克斯普雷斯機場",
      },
    ],
  },
  TOM: {
    code: "TOM",
    name: "TOMBOUCTOU",
    chineseName: "廷巴克图",
    traditionalName: "廷巴克圖",
    airports: [
      {
        code: "TOM",
        name: "Tombouctou airport",
        chineseName: "通布图机场",
        traditionalName: "通布圖機場",
      },
    ],
  },
  TOP: {
    code: "TOP",
    name: "TOPEKA",
    chineseName: "托皮卡",
    traditionalName: "托皮卡",
    airports: [
      {
        code: "FOE",
        name: "Forbes field",
        chineseName: "托皮卡机场",
        traditionalName: "托皮卡機場",
      },
    ],
  },
  TOS: {
    code: "TOS",
    name: "TROMSO",
    chineseName: "特罗姆瑟",
    traditionalName: "特羅姆瑟",
    airports: [
      {
        code: "TOS",
        name: "Langnes",
        chineseName: "朗内斯机场",
        traditionalName: "朗內斯機場",
      },
    ],
  },
  TOV: {
    code: "TOV",
    name: "TORTOLA",
    chineseName: "托尔托拉岛",
    traditionalName: "托爾托拉島",
    airports: [
      {
        code: "EIS",
        name: "Terrance b. lettsome",
        chineseName: "泰伦斯利尔森机场",
        traditionalName: "泰倫斯利爾森機場",
      },
    ],
  },
  TOX: {
    code: "TOX",
    name: "TOBOLSK",
    chineseName: "托博尔斯克",
    traditionalName: "托博爾斯克",
    airports: [
      {
        code: "RMZ",
        name: "Remezov",
        chineseName: "雷梅佐夫机场",
        traditionalName: "雷梅佐夫機場",
      },
    ],
  },
  TOY: {
    code: "TOY",
    name: "TOYAMA",
    chineseName: "富山",
    traditionalName: "富山",
    airports: [
      {
        code: "TOY",
        name: "Toyama airport",
        chineseName: "富山机场",
        traditionalName: "富山機場",
      },
    ],
  },
  TPA: {
    code: "TPA",
    name: "TAMPA",
    chineseName: "坦帕",
    traditionalName: "坦帕",
    airports: [
      {
        code: "PIE",
        name: "St.pete-clearwater int",
        chineseName: "圣彼得斯堡国际机场",
        traditionalName: "聖彼得斯堡國際機場",
      },
      {
        code: "TPA",
        name: "Tampa intl.",
        chineseName: "坦帕机场",
        traditionalName: "坦帕機場",
      },
    ],
  },
  TPE: {
    code: "TPE",
    name: "TAIPEI",
    chineseName: "台北",
    traditionalName: "臺北",
    airports: [
      {
        code: "TPE",
        name: "Taiwan taoyuan int'l",
        chineseName: "台湾桃园国际机场",
        traditionalName: "臺灣桃園國際機場",
      },
      {
        code: "TSA",
        name: "Songshan",
        chineseName: "松山机场",
        traditionalName: "松山機場",
      },
    ],
  },
  TPJ: {
    code: "TPJ",
    name: "TAPLEJUNG",
    chineseName: "达布莱宗",
    traditionalName: "達布萊宗",
    airports: [
      {
        code: "TPJ",
        name: "Taplejung airport",
        chineseName: "达布莱宗机场",
        traditionalName: "達布萊宗機場",
      },
    ],
  },
  TPP: {
    code: "TPP",
    name: "TARAPOTO",
    chineseName: "塔拉波托",
    traditionalName: "塔拉波托",
    airports: [
      {
        code: "TPP",
        name: "G.del castillo paredes",
        chineseName: "塔拉波托机场",
        traditionalName: "塔拉波托機場",
      },
    ],
  },
  TPQ: {
    code: "TPQ",
    name: "TEPIC",
    chineseName: "特皮克",
    traditionalName: "特皮克",
    airports: [
      {
        code: "TPQ",
        name: "Amado nervo",
        chineseName: "特皮克机场",
        traditionalName: "特皮克機場",
      },
    ],
  },
  TPS: {
    code: "TPS",
    name: "TRAPANI",
    chineseName: "特拉帕尼",
    traditionalName: "特拉帕尼",
    airports: [
      {
        code: "TPS",
        name: "Birgi",
        chineseName: "博吉机场",
        traditionalName: "博吉機場",
      },
    ],
  },
  TQP: {
    code: "TQP",
    name: "TREPELL",
    chineseName: "塔休沙克",
    traditionalName: "塔休沙克",
    airports: [
      {
        code: "TQP",
        name: "Trepell airport",
        chineseName: "塔休沙克(卡苏伊特苏普)机场",
        traditionalName: "塔休沙克（卡蘇伊特蘇普）機場",
      },
    ],
  },
  TQQ: {
    code: "TQQ",
    name: "TOMIA",
    chineseName: "Tomia",
    traditionalName: "Tomia",
    airports: [
      {
        code: "TQQ",
        name: "Maranggo",
        chineseName: "莫龙格机场",
        traditionalName: "莫龍格機場",
      },
    ],
  },
  TRA: {
    code: "TRA",
    name: "TARAMA",
    chineseName: "多良间",
    traditionalName: "多良間",
    airports: [
      {
        code: "TRA",
        name: "Tarama airport",
        chineseName: "多良间机场",
        traditionalName: "多良間機場",
      },
    ],
  },
  TRC: {
    code: "TRC",
    name: "TORREON",
    chineseName: "托雷翁",
    traditionalName: "托雷翁",
    airports: [
      {
        code: "TRC",
        name: "Francisco sarabia intl",
        chineseName: "弗朗西斯科萨拉比亚机场",
        traditionalName: "法蘭西斯科薩拉比亞機場",
      },
    ],
  },
  TRD: {
    code: "TRD",
    name: "TRONDHEIM",
    chineseName: "特隆赫姆",
    traditionalName: "特隆赫姆",
    airports: [
      {
        code: "TRD",
        name: "Vaernes",
        chineseName: "瓦尔内斯机场",
        traditionalName: "瓦爾內斯機場",
      },
    ],
  },
  TRE: {
    code: "TRE",
    name: "TIREE",
    chineseName: "泰里岛",
    traditionalName: "泰裡島",
    airports: [
      {
        code: "TRE",
        name: "Tiree airport",
        chineseName: "泰里岛机场",
        traditionalName: "泰裡島機場",
      },
    ],
  },
  TRG: {
    code: "TRG",
    name: "TAURANGA",
    chineseName: "陶朗加",
    traditionalName: "陶朗加",
    airports: [
      {
        code: "TRG",
        name: "Tauranga airport",
        chineseName: "陶朗加机场",
        traditionalName: "陶朗加機場",
      },
    ],
  },
  TRI: {
    code: "TRI",
    name: "BRISTOL/JOHNSON/KINGSP",
    chineseName: "布里斯托尔",
    traditionalName: "布裏斯托爾",
    airports: [
      {
        code: "TRI",
        name: "Tri-cities rgnl tn/va",
        chineseName: "三连市机场",
        traditionalName: "三連市機場",
      },
    ],
  },
  TRK: {
    code: "TRK",
    name: "TARAKAN",
    chineseName: "打拉根",
    traditionalName: "打拉根",
    airports: [
      {
        code: "TRK",
        name: "Juwata",
        chineseName: "打拉根国际机场",
        traditionalName: "打拉根國際機場",
      },
    ],
  },
  TRM: {
    code: "TRM",
    name: "THERMAL",
    chineseName: "加利福尼亚州Thermal",
    traditionalName: "加利福尼亞州Thermal",
    airports: [
      {
        code: "TRM",
        name: "J.cochran regional",
        chineseName: "特马尔机场",
        traditionalName: "特馬爾機場",
      },
    ],
  },
  TRN: {
    code: "TRN",
    name: "TURIN",
    chineseName: "都灵",
    traditionalName: "都靈",
    airports: [
      {
        code: "TRN",
        name: "Caselle",
        chineseName: "都灵机场",
        traditionalName: "都靈機場",
      },
    ],
  },
  TRR: {
    code: "TRR",
    name: "TRINCOMALEE",
    chineseName: "亭可马里",
    traditionalName: "特亭可馬利",
    airports: [
      {
        code: "TRR",
        name: "China bay",
        chineseName: "中国湾机场",
        traditionalName: "中國灣機場",
      },
    ],
  },
  TRS: {
    code: "TRS",
    name: "TRIESTE",
    chineseName: "的里雅斯特",
    traditionalName: "的里雅斯特",
    airports: [
      {
        code: "TRS",
        name: "Ronchi dei legionari",
        chineseName: "弗留利威尼斯朱利亚机场",
        traditionalName: "弗留利威尼斯朱利亞機場",
      },
    ],
  },
  TRT: {
    code: "TRT",
    name: "MENGKENDEK",
    chineseName: "特里蒙顿",
    traditionalName: "特裏蒙頓",
    airports: [
      {
        code: "TRT",
        name: "Toraja",
        chineseName: "特里蒙顿机场",
        traditionalName: "特裏蒙頓機場",
      },
    ],
  },
  TRU: {
    code: "TRU",
    name: "TRUJILLO",
    chineseName: "特鲁希略",
    traditionalName: "特魯希略",
    airports: [
      {
        code: "TRU",
        name: "C.martinez de pinillos",
        chineseName: "特鲁希略机场",
        traditionalName: "特魯希略機場",
      },
    ],
  },
  TRV: {
    code: "TRV",
    name: "THIRUVANANTHAPURAM",
    chineseName: "特里凡得琅",
    traditionalName: "特里凡德瑯",
    airports: [
      {
        code: "TRV",
        name: "Thiruvananthapuram intl.",
        chineseName: "提鲁瓦南萨普拉姆国际机场",
        traditionalName: "提魯瓦南薩普拉姆國際機場",
      },
    ],
  },
  TRW: {
    code: "TRW",
    name: "TARAWA",
    chineseName: "塔拉瓦",
    traditionalName: "塔拉瓦",
    airports: [
      {
        code: "TRW",
        name: "Bonriki intl",
        chineseName: "伯恩里基机场",
        traditionalName: "伯恩裏基機場",
      },
    ],
  },
  TRZ: {
    code: "TRZ",
    name: "TIRUCHCHIRAPPALLI",
    chineseName: "蒂鲁吉拉帕利",
    traditionalName: "蒂魯吉拉帕利",
    airports: [
      {
        code: "TRZ",
        name: "Tiruchirappalli",
        chineseName: "蒂鲁吉拉伯利机场",
        traditionalName: "蒂魯吉拉伯利機場",
      },
    ],
  },
  TSH: {
    code: "TSH",
    name: "TSHIKAPA",
    chineseName: "奇卡帕",
    traditionalName: "奇卡帕",
    airports: [
      {
        code: "TSH",
        name: "Tshikapa airport",
        chineseName: "奇卡帕机场",
        traditionalName: "奇卡帕機場",
      },
    ],
  },
  TSJ: {
    code: "TSJ",
    name: "TSUSHIMA",
    chineseName: "对马",
    traditionalName: "對馬",
    airports: [
      {
        code: "TSJ",
        name: "Tsushima airport",
        chineseName: "津岛机场",
        traditionalName: "津島機場",
      },
    ],
  },
  TSM: {
    code: "TSM",
    name: "TAOS",
    chineseName: "新墨西哥州陶斯",
    traditionalName: "新墨西哥州陶斯",
    airports: [
      {
        code: "TSM",
        name: "Taos reg. airport",
        chineseName: "塔奥斯机场",
        traditionalName: "塔奧斯機場",
      },
    ],
  },
  TSN: {
    code: "TSN",
    name: "TIANJIN",
    chineseName: "天津",
    traditionalName: "天津",
    airports: [
      {
        code: "TSN",
        name: "Binhai intl",
        chineseName: "滨海国际机场",
        traditionalName: "濱海國際機場",
      },
    ],
  },
  TSR: {
    code: "TSR",
    name: "TIMISOARA",
    chineseName: "蒂米什瓦拉",
    traditionalName: "蒂米什瓦拉",
    airports: [
      {
        code: "TSR",
        name: "Traian vuia",
        chineseName: "特拉伊安维亚国际机场",
        traditionalName: "特拉伊安維亞國際機場",
      },
    ],
  },
  TST: {
    code: "TST",
    name: "TRANG",
    chineseName: "董里",
    traditionalName: "董裏",
    airports: [
      {
        code: "TST",
        name: "Trang airport",
        chineseName: "董里河机场",
        traditionalName: "董裡河機場",
      },
    ],
  },
  TSU: {
    code: "TSU",
    name: "TABITEUEA SOUTH",
    chineseName: "南塔比特韦亚",
    traditionalName: "南塔比特韋亞",
    airports: [
      {
        code: "TSU",
        name: "Tabiteuea south airport",
        chineseName: "塔比特阿绍斯机场",
        traditionalName: "塔比特阿紹斯機場",
      },
    ],
  },
  TSV: {
    code: "TSV",
    name: "TOWNSVILLE",
    chineseName: "汤斯维尔",
    traditionalName: "湯斯維爾",
    airports: [
      {
        code: "TSV",
        name: "Townsville intl.",
        chineseName: "汤斯维尔机场",
        traditionalName: "湯斯維爾機場",
      },
    ],
  },
  TSY: {
    code: "TSY",
    name: "TASIKMALAYA",
    chineseName: "塔西马拉亚",
    traditionalName: "塔西馬拉亞",
    airports: [
      {
        code: "TSY",
        name: "Wiriadinata",
        chineseName: "塔西马拉亚机场",
        traditionalName: "塔西馬拉亞機場",
      },
    ],
  },
  TTA: {
    code: "TTA",
    name: "TAN-TAN",
    chineseName: "坦坦",
    traditionalName: "坦坦",
    airports: [
      {
        code: "TTA",
        name: "Plage blanche",
        chineseName: "坦坦机场",
        traditionalName: "坦坦機場",
      },
    ],
  },
  TTE: {
    code: "TTE",
    name: "TERNATE",
    chineseName: "特尔纳特",
    traditionalName: "特爾納特",
    airports: [
      {
        code: "TTE",
        name: "Sultan babullah",
        chineseName: "巴布拉机场",
        traditionalName: "巴布拉機場",
      },
    ],
  },
  TTJ: {
    code: "TTJ",
    name: "TOTTORI",
    chineseName: "鸟取",
    traditionalName: "鳥取",
    airports: [
      {
        code: "TTJ",
        name: "Tottori airport",
        chineseName: "鸟取机场",
        traditionalName: "鳥取機場",
      },
    ],
  },
  TTQ: {
    code: "TTQ",
    name: "TORTUGUERO",
    chineseName: "托图奎罗",
    traditionalName: "托圖奎羅",
    airports: [
      {
        code: "TTQ",
        name: "Tortuguero airport",
        chineseName: "托图奎罗机场",
        traditionalName: "托圖奎羅機場",
      },
    ],
  },
  TTT: {
    code: "TTT",
    name: "TAITUNG",
    chineseName: "台东",
    traditionalName: "台東",
    airports: [
      {
        code: "TTT",
        name: "Fongnian",
        chineseName: "台东机场",
        traditionalName: "台東機場",
      },
    ],
  },
  TTU: {
    code: "TTU",
    name: "TETOUAN",
    chineseName: "得土安",
    traditionalName: "得土安",
    airports: [
      {
        code: "TTU",
        name: "Saniat r'mel",
        chineseName: "萨尼阿拉梅尔机场",
        traditionalName: "薩尼阿拉梅爾機場",
      },
    ],
  },
  TUB: {
    code: "TUB",
    name: "TUBUAI",
    chineseName: "土布艾群岛",
    traditionalName: "土布艾群島",
    airports: [
      {
        code: "TUB",
        name: "Mataura",
        chineseName: "土布艾岛机场",
        traditionalName: "土布艾島機場",
      },
    ],
  },
  TUC: {
    code: "TUC",
    name: "TUCUMAN",
    chineseName: "图库曼",
    traditionalName: "圖庫曼",
    airports: [
      {
        code: "TUC",
        name: "Benjamin matienzo",
        chineseName: "本杰明马提恩佐机场",
        traditionalName: "本傑明馬提恩佐機場",
      },
    ],
  },
  TUF: {
    code: "TUF",
    name: "TOURS",
    chineseName: "图尔",
    traditionalName: "圖爾",
    airports: [
      {
        code: "TUF",
        name: "Val de loire",
        chineseName: "瓦尔河谷机场机场",
        traditionalName: "瓦爾河谷機場機場",
      },
    ],
  },
  TUG: {
    code: "TUG",
    name: "TUGUEGARAO",
    chineseName: "土格加劳",
    traditionalName: "土格加勞",
    airports: [
      {
        code: "TUG",
        name: "Tuguegarao airport",
        chineseName: "土格加劳机场",
        traditionalName: "土格加勞機場",
      },
    ],
  },
  TUI: {
    code: "TUI",
    name: "TURAIF",
    chineseName: "图莱夫",
    traditionalName: "圖萊夫",
    airports: [
      {
        code: "TUI",
        name: "Turaif airport",
        chineseName: "图莱夫机场",
        traditionalName: "圖萊夫機場",
      },
    ],
  },
  TUK: {
    code: "TUK",
    name: "TURBAT",
    chineseName: "图尔伯德",
    traditionalName: "圖爾伯德",
    airports: [
      {
        code: "TUK",
        name: "Turbat intl.",
        chineseName: "图尔伯德机场",
        traditionalName: "圖爾伯德機場",
      },
    ],
  },
  TUL: {
    code: "TUL",
    name: "TULSA",
    chineseName: "塔尔萨",
    traditionalName: "塔爾薩",
    airports: [
      {
        code: "TUL",
        name: "Tulsa intl.",
        chineseName: "塔尔萨国际机场",
        traditionalName: "塔爾薩國際機場",
      },
    ],
  },
  TUN: {
    code: "TUN",
    name: "TUNIS",
    chineseName: "突尼斯",
    traditionalName: "突尼斯",
    airports: [
      {
        code: "TUN",
        name: "Carthage",
        chineseName: "迦太基国际机场",
        traditionalName: "迦太基國際機場",
      },
    ],
  },
  TUO: {
    code: "TUO",
    name: "TAUPO",
    chineseName: "陶波",
    traditionalName: "陶波",
    airports: [
      {
        code: "TUO",
        name: "Taupo airport",
        chineseName: "陶波机场",
        traditionalName: "陶波機場",
      },
    ],
  },
  TUP: {
    code: "TUP",
    name: "TUPELO",
    chineseName: "密西西比州图珀洛",
    traditionalName: "密西西比州圖珀洛",
    airports: [
      {
        code: "TUP",
        name: "Tupelo reg. airport",
        chineseName: "图珀洛地方机场",
        traditionalName: "圖珀洛地方機場",
      },
    ],
  },
  TUR: {
    code: "TUR",
    name: "TUCURUI",
    chineseName: "图库鲁伊",
    traditionalName: "圖庫魯伊",
    airports: [
      {
        code: "TUR",
        name: "Tucurui airport",
        chineseName: "图库鲁伊机场",
        traditionalName: "圖庫魯伊機場",
      },
    ],
  },
  TUS: {
    code: "TUS",
    name: "TUCSON",
    chineseName: "图森",
    traditionalName: "圖森",
    airports: [
      {
        code: "TUS",
        name: "Tucson intl.",
        chineseName: "图森国际机场",
        traditionalName: "圖森國際機場",
      },
    ],
  },
  TUU: {
    code: "TUU",
    name: "TABUK",
    chineseName: "塔布克",
    traditionalName: "塔布克",
    airports: [
      {
        code: "TUU",
        name: "Tabuk airport",
        chineseName: "泰布克机场",
        traditionalName: "泰布克機場",
      },
    ],
  },
  TUY: {
    code: "TUY",
    name: "TULUM",
    chineseName: "图卢姆",
    traditionalName: "圖盧姆",
    airports: [
      {
        code: "TQO",
        name: "Felipe carrillo puerto",
        chineseName: "图卢姆费利佩卡里略波多机场",
        traditionalName: "圖盧姆費利佩卡裏略波多機場",
      },
    ],
  },
  TVC: {
    code: "TVC",
    name: "TRAVERSE CITY",
    chineseName: "特拉弗斯城",
    traditionalName: "特拉弗斯城",
    airports: [
      {
        code: "TVC",
        name: "Cherry capital",
        chineseName: "樱桃首都机场",
        traditionalName: "櫻桃首都機場",
      },
    ],
  },
  TVF: {
    code: "TVF",
    name: "THIEF RIVER FALLS",
    chineseName: "锡夫里弗福尔斯",
    traditionalName: "錫夫裏弗福爾斯",
    airports: [
      {
        code: "TVF",
        name: "Thief river falls reg. airport",
        chineseName: "锡夫里弗福尔斯地区机场",
        traditionalName: "錫夫裏弗福爾斯地區機場",
      },
    ],
  },
  TVS: {
    code: "TVS",
    name: "TANGSHAN",
    chineseName: "唐山",
    traditionalName: "唐山",
    airports: [
      {
        code: "TVS",
        name: "Sannuhe",
        chineseName: "三女河机场",
        traditionalName: "三女河機場",
      },
    ],
  },
  TVU: {
    code: "TVU",
    name: "TAVEUNI ISLAND",
    chineseName: "塔韦马尼岛",
    traditionalName: "塔韋馬尼島",
    airports: [
      {
        code: "TVU",
        name: "Matei",
        chineseName: "马特机场",
        traditionalName: "馬特機場",
      },
    ],
  },
  TVY: {
    code: "TVY",
    name: "DAWEI",
    chineseName: "土瓦",
    traditionalName: "土瓦",
    airports: [
      {
        code: "TVY",
        name: "Dawei airport",
        chineseName: "土瓦机场",
        traditionalName: "土瓦機場",
      },
    ],
  },
  TWA: {
    code: "TWA",
    name: "TWIN HILLS",
    chineseName: "阿拉斯加州双子山",
    traditionalName: "阿拉斯加州雙子山",
    airports: [
      {
        code: "TWA",
        name: "Twin hills airport",
        chineseName: "特温希尔斯机场",
        traditionalName: "特溫希爾斯機場",
      },
    ],
  },
  TWB: {
    code: "TWB",
    name: "TOOWOOMBA",
    chineseName: "图文巴",
    traditionalName: "圖文巴",
    airports: [
      {
        code: "WTB",
        name: "Brisbane west wellcamp",
        chineseName: "布里斯班西威尔坎普机场",
        traditionalName: "布裏斯班西威爾坎普機場",
      },
    ],
  },
  TWC: {
    code: "TWC",
    name: "TUMUSHUKE",
    chineseName: "图木舒克",
    traditionalName: "圖木舒克",
    airports: [
      {
        code: "TWC",
        name: "Tangwangcheng",
        chineseName: "唐王城机场",
        traditionalName: "唐王城機場",
      },
    ],
  },
  TWF: {
    code: "TWF",
    name: "TWIN FALLS",
    chineseName: "双子瀑布",
    traditionalName: "雙子瀑布",
    airports: [
      {
        code: "TWF",
        name: "Magic valley regional",
        chineseName: "魔谷地区机场",
        traditionalName: "魔穀地區機場",
      },
    ],
  },
  TWT: {
    code: "TWT",
    name: "TAWI TAWI ISLAND",
    chineseName: "邦奥",
    traditionalName: "邦奧",
    airports: [
      {
        code: "TWT",
        name: "Sanga-sanga",
        chineseName: "塔威塔威机场",
        traditionalName: "塔威塔威機場",
      },
    ],
  },
  TWU: {
    code: "TWU",
    name: "TAWAU",
    chineseName: "斗湖",
    traditionalName: "鬥湖",
    airports: [
      {
        code: "TWU",
        name: "Tawau airport",
        chineseName: "斗湖机场",
        traditionalName: "鬥湖機場",
      },
    ],
  },
  TXK: {
    code: "TXK",
    name: "TEXARKANA",
    chineseName: "特克萨卡纳",
    traditionalName: "特克薩卡納",
    airports: [
      {
        code: "TXK",
        name: "Regional - webb field",
        chineseName: "特克萨卡纳机场",
        traditionalName: "特克薩卡納機場",
      },
    ],
  },
  TXN: {
    code: "TXN",
    name: "HUANGSHAN",
    chineseName: "黄山",
    traditionalName: "黃山",
    airports: [
      {
        code: "TXN",
        name: "Tunxi intl",
        chineseName: "屯溪国际机场",
        traditionalName: "屯溪國際機場",
      },
    ],
  },
  TYD: {
    code: "TYD",
    name: "TYNDA",
    chineseName: "廷达",
    traditionalName: "廷達",
    airports: [
      {
        code: "TYD",
        name: "Tynda airport",
        chineseName: "滕达河机场",
        traditionalName: "滕達河機場",
      },
    ],
  },
  TYF: {
    code: "TYF",
    name: "TORSBY",
    chineseName: "图什比",
    traditionalName: "圖什比",
    airports: [
      {
        code: "TYF",
        name: "Torsby airport",
        chineseName: "图什比机场",
        traditionalName: "圖什比機場",
      },
    ],
  },
  TYL: {
    code: "TYL",
    name: "TALARA",
    chineseName: "塔拉拉",
    traditionalName: "塔拉拉",
    airports: [
      {
        code: "TYL",
        name: "Victor monteas arias",
        chineseName: "塔拉拉机场",
        traditionalName: "塔拉拉機場",
      },
    ],
  },
  TYM: {
    code: "TYM",
    name: "STANIEL CAY",
    chineseName: "斯坦尼尔凯",
    traditionalName: "斯坦尼爾凱",
    airports: [
      {
        code: "TYM",
        name: "Staniel cay airport",
        chineseName: "斯坦尼尔凯机场",
        traditionalName: "斯坦尼爾凱機場",
      },
    ],
  },
  TYN: {
    code: "TYN",
    name: "TAIYUAN",
    chineseName: "太原",
    traditionalName: "太原",
    airports: [
      {
        code: "TYN",
        name: "Wusu intl",
        chineseName: "武宿国际机场",
        traditionalName: "武宿國際機場",
      },
    ],
  },
  TYO: {
    code: "TYO",
    name: "TOKYO",
    chineseName: "东京",
    traditionalName: "東京",
    airports: [
      {
        code: "HND",
        name: "Tokyo intl (haneda)",
        chineseName: "羽田机场",
        traditionalName: "羽田機場",
      },
      {
        code: "NRT",
        name: "Narita intl",
        chineseName: "成田国际机场",
        traditionalName: "成田國際機場",
      },
    ],
  },
  TYR: {
    code: "TYR",
    name: "TYLER",
    chineseName: "泰勒",
    traditionalName: "泰勒",
    airports: [
      {
        code: "TYR",
        name: "Pounds regional",
        chineseName: "庞兹机场",
        traditionalName: "龐茲機場",
      },
    ],
  },
  TYS: {
    code: "TYS",
    name: "KNOXVILLE",
    chineseName: "诺克斯维尔",
    traditionalName: "諾克斯維爾",
    airports: [
      {
        code: "TYS",
        name: "Mcghee tyson",
        chineseName: "麦吉泰森机场",
        traditionalName: "麥吉泰森機場",
      },
    ],
  },
  TZL: {
    code: "TZL",
    name: "TUZLA",
    chineseName: "图兹拉",
    traditionalName: "圖茲拉",
    airports: [
      {
        code: "TZL",
        name: "Tuzla intl.",
        chineseName: "图兹拉国际机场",
        traditionalName: "圖茲拉國際機場",
      },
    ],
  },
  TZN: {
    code: "TZN",
    name: "SOUTH ANDROS",
    chineseName: "南安德罗斯",
    traditionalName: "南安德羅斯",
    airports: [
      {
        code: "TZN",
        name: "Congo town",
        chineseName: "南安德罗斯机场",
        traditionalName: "南安德羅斯機場",
      },
    ],
  },
  TZX: {
    code: "TZX",
    name: "TRABZON",
    chineseName: "特拉布宗",
    traditionalName: "特拉布宗",
    airports: [
      {
        code: "TZX",
        name: "Trabzon airport",
        chineseName: "特拉布宗机场",
        traditionalName: "特拉布宗機場",
      },
    ],
  },
  UAH: {
    code: "UAH",
    name: "UA HUKA",
    chineseName: "瓦胡卡岛",
    traditionalName: "瓦胡卡島",
    airports: [
      {
        code: "UAH",
        name: "Ua huka airport",
        chineseName: "乌阿胡卡机场",
        traditionalName: "烏阿胡卡機場",
      },
    ],
  },
  UAK: {
    code: "UAK",
    name: "NARSARSUAQ",
    chineseName: "纳沙斯雅克",
    traditionalName: "納沙斯雅克",
    airports: [
      {
        code: "UAK",
        name: "Narsarsuaq airport",
        chineseName: "纳萨尔苏瓦克机场",
        traditionalName: "納薩爾蘇瓦克機場",
      },
    ],
  },
  UAP: {
    code: "UAP",
    name: "UA POU",
    chineseName: "乌阿珀",
    traditionalName: "烏阿珀",
    airports: [
      {
        code: "UAP",
        name: "Ua pou airport",
        chineseName: "乌阿珀机场",
        traditionalName: "烏阿珀機場",
      },
    ],
  },
  UAQ: {
    code: "UAQ",
    name: "SAN JUAN",
    chineseName: "圣胡安",
    traditionalName: "聖胡安",
    airports: [
      {
        code: "UAQ",
        name: "Domingo f. sarmiento",
        chineseName: "圣胡安机场",
        traditionalName: "聖胡安機場",
      },
    ],
  },
  UAS: {
    code: "UAS",
    name: "SAMBURU",
    chineseName: "桑布鲁",
    traditionalName: "桑布魯",
    airports: [
      {
        code: "UAS",
        name: "Buffalo spring",
        chineseName: "桑布鲁机场",
        traditionalName: "桑布魯機場",
      },
    ],
  },
  UBA: {
    code: "UBA",
    name: "UBERABA",
    chineseName: "乌贝拉巴",
    traditionalName: "烏貝拉巴",
    airports: [
      {
        code: "UBA",
        name: "M. de almeida franco",
        chineseName: "乌贝拉巴机场",
        traditionalName: "烏貝拉巴機場",
      },
    ],
  },
  UBB: {
    code: "UBB",
    name: "MABUIAG ISLAND",
    chineseName: "马布亚克岛",
    traditionalName: "馬布亞克島",
    airports: [
      {
        code: "UBB",
        name: "Mabuiag island airport",
        chineseName: "马布亚格岛机场",
        traditionalName: "馬布亞格島機場",
      },
    ],
  },
  UBJ: {
    code: "UBJ",
    name: "UBE",
    chineseName: "山口",
    traditionalName: "山口",
    airports: [
      {
        code: "UBJ",
        name: "Yamaguchi-ube",
        chineseName: "山口宇部机场",
        traditionalName: "山口宇部機場",
      },
    ],
  },
  UBP: {
    code: "UBP",
    name: "UBON RATCHATHANI",
    chineseName: "乌汶",
    traditionalName: "烏汶",
    airports: [
      {
        code: "UBP",
        name: "Ubon ratchathani airport",
        chineseName: "乌汶叻差他尼机场",
        traditionalName: "烏汶叻差他尼機場",
      },
    ],
  },
  UBS: {
    code: "UBS",
    name: "COLUMBUS",
    chineseName: "哥伦布",
    traditionalName: "哥倫布",
    airports: [
      {
        code: "GTR",
        name: "Golden triangle rgnl",
        chineseName: "金三角地区机场",
        traditionalName: "金三角地區機場",
      },
    ],
  },
  UBU: {
    code: "UBU",
    name: "KALUMBURU",
    chineseName: "卡伦布鲁",
    traditionalName: "卡倫布魯",
    airports: [
      {
        code: "UBU",
        name: "Kalumburu airport",
        chineseName: "卡伦布鲁机场",
        traditionalName: "卡倫布魯機場",
      },
    ],
  },
  UCB: {
    code: "UCB",
    name: "ULANQAB",
    chineseName: "乌兰察布",
    traditionalName: "烏蘭察布",
    airports: [
      {
        code: "UCB",
        name: "Ulanqab airport",
        chineseName: "乌兰察布机场",
        traditionalName: "烏蘭察布機場",
      },
    ],
  },
  UCT: {
    code: "UCT",
    name: "UKHTA",
    chineseName: "乌赫塔",
    traditionalName: "烏赫塔",
    airports: [
      {
        code: "UCT",
        name: "Ukhta airport",
        chineseName: "阿塔机场",
        traditionalName: "阿塔機場",
      },
    ],
  },
  UDI: {
    code: "UDI",
    name: "UBERLANDIA",
    chineseName: "乌贝兰迪亚",
    traditionalName: "烏貝蘭迪亞",
    airports: [
      {
        code: "UDI",
        name: "Cesar bombonato",
        chineseName: "乌贝兰迪亚机场",
        traditionalName: "烏貝蘭迪亞機場",
      },
    ],
  },
  UDR: {
    code: "UDR",
    name: "UDAIPUR",
    chineseName: "乌代浦尔",
    traditionalName: "烏代浦爾",
    airports: [
      {
        code: "UDR",
        name: "Maharana pratap",
        chineseName: "达博克机场",
        traditionalName: "達博克機場",
      },
    ],
  },
  UEL: {
    code: "UEL",
    name: "QUELIMANE",
    chineseName: "克利马内",
    traditionalName: "克利馬內",
    airports: [
      {
        code: "UEL",
        name: "Quelimane airport",
        chineseName: "克利马内机场",
        traditionalName: "克利馬內機場",
      },
    ],
  },
  UEO: {
    code: "UEO",
    name: "KUMEJIMA",
    chineseName: "久米岛",
    traditionalName: "久米島",
    airports: [
      {
        code: "UEO",
        name: "Kumejima airport",
        chineseName: "久米岛机场",
        traditionalName: "久米島機場",
      },
    ],
  },
  UET: {
    code: "UET",
    name: "QUETTA",
    chineseName: "奎达",
    traditionalName: "奎達",
    airports: [
      {
        code: "UET",
        name: "Quetta intl.",
        chineseName: "奎达机场",
        traditionalName: "奎達機場",
      },
    ],
  },
  UFA: {
    code: "UFA",
    name: "UFA",
    chineseName: "乌法",
    traditionalName: "烏法",
    airports: [
      {
        code: "UFA",
        name: "Ufa airport",
        chineseName: "乌法机场",
        traditionalName: "烏法機場",
      },
    ],
  },
  UGC: {
    code: "UGC",
    name: "URGENCH",
    chineseName: "乌尔根齐",
    traditionalName: "烏爾根齊",
    airports: [
      {
        code: "UGC",
        name: "Urgench intl.",
        chineseName: "乌尔根奇机场",
        traditionalName: "烏爾根奇機場",
      },
    ],
  },
  UGI: {
    code: "UGI",
    name: "UGANIK",
    chineseName: "阿拉斯加城市乌加尼",
    traditionalName: "阿拉斯加都市烏加尼",
    airports: [
      {
        code: "UGI",
        name: "San juan (uganik) spb",
        chineseName: "乌加里特机场",
        traditionalName: "烏加裏特機場",
      },
    ],
  },
  UGS: {
    code: "UGS",
    name: "UGASHIK",
    chineseName: "尤加希克",
    traditionalName: "尤加希克",
    airports: [
      {
        code: "UGS",
        name: "Ugashik airport",
        chineseName: "尤加希克机场",
        traditionalName: "尤加希克機場",
      },
    ],
  },
  UHS: {
    code: "UHS",
    name: "ALEKSANDROVSK-SAKHALIN",
    chineseName: "亚历山大-萨哈林",
    traditionalName: "亞歷山大-薩哈林",
    airports: [
      {
        code: "UHS",
        name: "Aleksandrovsk-sakhalinskiy air",
        chineseName: "亚历山大-萨哈林斯基航空机场",
        traditionalName: "亞歷山大-薩哈林斯基航空機場",
      },
    ],
  },
  UIB: {
    code: "UIB",
    name: "QUIBDO",
    chineseName: "奎波多",
    traditionalName: "奎波多",
    airports: [
      {
        code: "UIB",
        name: "El carano",
        chineseName: "艾尔卡拉诺机场",
        traditionalName: "艾爾卡拉諾機場",
      },
    ],
  },
  UIH: {
    code: "UIH",
    name: "QUI NHON",
    chineseName: "归仁",
    traditionalName: "歸仁",
    airports: [
      {
        code: "UIH",
        name: "Phu cat",
        chineseName: "符吉机场",
        traditionalName: "符吉機場",
      },
    ],
  },
  UII: {
    code: "UII",
    name: "UTILA",
    chineseName: "乌蒂拉",
    traditionalName: "烏蒂拉",
    airports: [
      {
        code: "UII",
        name: "Utila airport",
        chineseName: "乌提拉机场",
        traditionalName: "烏提拉機場",
      },
    ],
  },
  UIK: {
    code: "UIK",
    name: "UST-ILIMSK",
    chineseName: "乌斯季伊利姆斯克",
    traditionalName: "烏斯季伊利姆斯克",
    airports: [
      {
        code: "UIK",
        name: "Ust-ilimsk airport",
        chineseName: "乌斯季伊利姆斯克机场",
        traditionalName: "烏斯季伊利姆斯克機場",
      },
    ],
  },
  UIN: {
    code: "UIN",
    name: "QUINCY",
    chineseName: "昆西",
    traditionalName: "昆西",
    airports: [
      {
        code: "UIN",
        name: "Regional (baldwin fld)",
        chineseName: "昆西地方机场",
        traditionalName: "昆西地方機場",
      },
    ],
  },
  UIO: {
    code: "UIO",
    name: "QUITO",
    chineseName: "基多",
    traditionalName: "基多",
    airports: [
      {
        code: "UIO",
        name: "Mariscal sucre intl",
        chineseName: "马里斯卡尔苏克雷国际机场",
        traditionalName: "馬裏斯卡爾蘇克雷國際機場",
      },
    ],
  },
  UIT: {
    code: "UIT",
    name: "JALUIT ISLAND",
    chineseName: "贾卢伊特",
    traditionalName: "賈盧伊特",
    airports: [
      {
        code: "UIT",
        name: "Jaluit island airport",
        chineseName: "贾鲁伊特机场",
        traditionalName: "賈魯伊特機場",
      },
    ],
  },
  UJE: {
    code: "UJE",
    name: "UJAE ISLAND",
    chineseName: "乌贾埃岛",
    traditionalName: "烏賈埃島",
    airports: [
      {
        code: "UJE",
        name: "Ujae island airport",
        chineseName: "乌贾埃岛机场",
        traditionalName: "烏賈埃島機場",
      },
    ],
  },
  UKA: {
    code: "UKA",
    name: "UKUNDA",
    chineseName: "乌昆达",
    traditionalName: "烏昆達",
    airports: [
      {
        code: "UKA",
        name: "Diani",
        chineseName: "乌昆达机场",
        traditionalName: "烏昆達機場",
      },
    ],
  },
  UKE: {
    code: "UKE",
    name: "UTKELA",
    chineseName: "乌特克拉",
    traditionalName: "烏特克拉",
    airports: [
      {
        code: "UKE",
        name: "Utkela airport",
        chineseName: "乌特卡拉机场",
        traditionalName: "烏特卡拉機場",
      },
    ],
  },
  UKG: {
    code: "UKG",
    name: "UST-KUYGA",
    chineseName: "乌斯季库伊加",
    traditionalName: "烏斯季庫伊加",
    airports: [
      {
        code: "UKG",
        name: "Ust-kuyga airport",
        chineseName: "乌斯季库伊加机场",
        traditionalName: "烏斯季庫伊加機場",
      },
    ],
  },
  UKH: {
    code: "UKH",
    name: "MUKHAIZNA",
    chineseName: "穆海兹纳",
    traditionalName: "穆海茲納",
    airports: [
      {
        code: "UKH",
        name: "Mukhaizna airport",
        chineseName: "穆海兹纳机场",
        traditionalName: "穆海茲納機場",
      },
    ],
  },
  UKK: {
    code: "UKK",
    name: "UST-KAMENOGORSK",
    chineseName: "厄斯克门",
    traditionalName: "厄斯克門",
    airports: [
      {
        code: "UKK",
        name: "Ust-kamenogorsk airport",
        chineseName: "乌斯季卡缅诺戈尔斯克机场",
        traditionalName: "烏斯季卡緬諾戈爾斯克機場",
      },
    ],
  },
  UKX: {
    code: "UKX",
    name: "UST-KUT",
    chineseName: "乌斯季库特",
    traditionalName: "烏斯季庫特",
    airports: [
      {
        code: "UKX",
        name: "Ust-kut airport",
        chineseName: "乌斯季库特机场",
        traditionalName: "烏斯季庫特機場",
      },
    ],
  },
  ULB: {
    code: "ULB",
    name: "ULEI",
    chineseName: "乌雷",
    traditionalName: "烏雷",
    airports: [
      {
        code: "ULB",
        name: "Ulei airport",
        chineseName: "乌雷机场",
        traditionalName: "烏雷機場",
      },
    ],
  },
  ULG: {
    code: "ULG",
    name: "OLGII",
    chineseName: "乌尔基特",
    traditionalName: "烏爾基特",
    airports: [
      {
        code: "ULG",
        name: "Olgii airport",
        chineseName: "乌尔基特机场",
        traditionalName: "烏爾基特機場",
      },
    ],
  },
  ULH: {
    code: "ULH",
    name: "ALULA",
    chineseName: "艾尔乌拉",
    traditionalName: "艾爾烏拉",
    airports: [
      {
        code: "ULH",
        name: "Alula international",
        chineseName: "阿卜杜马吉德本阿卜杜拉齐兹王子机场",
        traditionalName: "阿蔔杜馬吉德本阿蔔杜拉齊茲王子機場",
      },
    ],
  },
  ULK: {
    code: "ULK",
    name: "LENSK",
    chineseName: "连斯克",
    traditionalName: "連斯克",
    airports: [
      {
        code: "ULK",
        name: "Lensk airport",
        chineseName: "连斯克 机场",
        traditionalName: "連斯克機場",
      },
    ],
  },
  ULN: {
    code: "ULN",
    name: "ULAANBAATAR",
    chineseName: "乌兰巴托",
    traditionalName: "烏蘭巴托",
    airports: [
      {
        code: "UBN",
        name: "Chinggis khaan",
        chineseName: "新乌兰巴托国际机场",
        traditionalName: "新烏蘭巴托國際機場",
      },
      {
        code: "ULN",
        name: "Buyant-ukhaa",
        chineseName: "乌兰巴托机场",
        traditionalName: "烏蘭巴托機場",
      },
    ],
  },
  ULO: {
    code: "ULO",
    name: "ULAANGOM",
    chineseName: "乌兰固木",
    traditionalName: "烏蘭固木",
    airports: [
      {
        code: "ULO",
        name: "Ulaangom airport",
        chineseName: "乌兰固木机场",
        traditionalName: "烏蘭固木機場",
      },
    ],
  },
  ULP: {
    code: "ULP",
    name: "QUILPIE",
    chineseName: "奎尔派",
    traditionalName: "奎爾派",
    airports: [
      {
        code: "ULP",
        name: "Quilpie airport",
        chineseName: "奎皮尔机场",
        traditionalName: "奎皮爾機場",
      },
    ],
  },
  ULY: {
    code: "ULY",
    name: "ULYANOVSK",
    chineseName: "乌里扬诺夫斯克",
    traditionalName: "烏裡揚諾夫斯克",
    airports: [
      {
        code: "ULV",
        name: "Baratayevka",
        chineseName: "巴若塔叶夫克机场",
        traditionalName: "巴若塔葉夫克機場",
      },
    ],
  },
  ULZ: {
    code: "ULZ",
    name: "ULIASTAI",
    chineseName: "乌里雅苏台",
    traditionalName: "烏裡雅蘇台",
    airports: [
      {
        code: "ULZ",
        name: "Donoi",
        chineseName: "道诺伊机场",
        traditionalName: "道諾伊機場",
      },
    ],
  },
  UMB: {
    code: "UMB",
    name: "KALUMBILA",
    chineseName: "阿拉斯加城市乌姆纳克",
    traditionalName: "阿拉斯加都市烏姆納克",
    airports: [
      {
        code: "UMB",
        name: "Kalumbila airport",
        chineseName: "乌姆纳克岛机场",
        traditionalName: "烏姆納克島機場",
      },
    ],
  },
  UME: {
    code: "UME",
    name: "UMEA",
    chineseName: "于默奥",
    traditionalName: "于默真",
    airports: [
      {
        code: "UME",
        name: "Umea airport",
        chineseName: "于默奥机场",
        traditionalName: "于默真機場",
      },
    ],
  },
  UMU: {
    code: "UMU",
    name: "UMUARAMA",
    chineseName: "乌姆阿拉马",
    traditionalName: "烏姆阿拉馬",
    airports: [
      {
        code: "UMU",
        name: "Orlando de carvalho",
        chineseName: "乌姆阿拉马机场",
        traditionalName: "烏姆阿拉馬機場",
      },
    ],
  },
  UNA: {
    code: "UNA",
    name: "ILHA COMANDATUBA/UNA",
    chineseName: "乌纳",
    traditionalName: "烏納",
    airports: [
      {
        code: "UNA",
        name: "Ilha comandatuba/una airport",
        chineseName: "乌纳机场",
        traditionalName: "烏納機場",
      },
    ],
  },
  UNG: {
    code: "UNG",
    name: "KIUNGA",
    chineseName: "基温加",
    traditionalName: "基溫加",
    airports: [
      {
        code: "UNG",
        name: "Kiunga airport",
        chineseName: "基温加机场",
        traditionalName: "基溫加機場",
      },
    ],
  },
  UNI: {
    code: "UNI",
    name: "UNION ISLAND",
    chineseName: "联合岛",
    traditionalName: "聯合島",
    airports: [
      {
        code: "UNI",
        name: "Union island airport",
        chineseName: "乌尼翁岛机场",
        traditionalName: "烏尼翁島機場",
      },
    ],
  },
  UNK: {
    code: "UNK",
    name: "UNALAKLEET",
    chineseName: "尤纳拉克利特",
    traditionalName: "尤納拉克利特",
    airports: [
      {
        code: "UNK",
        name: "Unalakleet airport",
        chineseName: "尤纳拉克利特机场",
        traditionalName: "尤納拉克利特機場",
      },
    ],
  },
  UNN: {
    code: "UNN",
    name: "RANONG",
    chineseName: "拉廊",
    traditionalName: "拉廊",
    airports: [
      {
        code: "UNN",
        name: "Ranong airport",
        chineseName: "拉廊机场",
        traditionalName: "拉廊機場",
      },
    ],
  },
  UOL: {
    code: "UOL",
    name: "BUOL",
    chineseName: "布奥尔",
    traditionalName: "布奧爾",
    airports: [
      {
        code: "UOL",
        name: "Pogogul",
        chineseName: "布奥尔机场",
        traditionalName: "布奧爾機場",
      },
    ],
  },
  UPG: {
    code: "UPG",
    name: "MAKASSAR",
    chineseName: "乌戎潘当",
    traditionalName: "烏戎潘當",
    airports: [
      {
        code: "UPG",
        name: "Sultan hasanuddin",
        chineseName: "苏丹哈桑丁国际机场",
        traditionalName: "蘇丹哈桑丁國際機場",
      },
    ],
  },
  UPN: {
    code: "UPN",
    name: "URUAPAN",
    chineseName: "乌鲁阿潘",
    traditionalName: "烏盧阿潘",
    airports: [
      {
        code: "UPN",
        name: "Ignacio lopez rayon",
        chineseName: "乌鲁阿潘机场",
        traditionalName: "烏盧阿潘機場",
      },
    ],
  },
  URA: {
    code: "URA",
    name: "URALSK",
    chineseName: "乌拉尔斯克",
    traditionalName: "烏拉爾斯克",
    airports: [
      {
        code: "URA",
        name: "Ak zhol",
        chineseName: "乌拉尔斯克机场",
        traditionalName: "烏拉爾斯克機場",
      },
    ],
  },
  URC: {
    code: "URC",
    name: "URUMQI",
    chineseName: "乌鲁木齐",
    traditionalName: "烏魯木齊",
    airports: [
      {
        code: "URC",
        name: "Urumqi Tianshan International Airport",
        chineseName: "乌鲁木齐天山国际机场",
        traditionalName: "烏魯木齊天山國際機場",
      },
    ],
  },
  URE: {
    code: "URE",
    name: "KURESSAARE",
    chineseName: "库雷萨雷",
    traditionalName: "庫雷薩雷",
    airports: [
      {
        code: "URE",
        name: "Kuressaare airport",
        chineseName: "库雷萨雷机场",
        traditionalName: "庫雷薩雷機場",
      },
    ],
  },
  URG: {
    code: "URG",
    name: "URUGUAIANA",
    chineseName: "乌鲁瓜亚纳",
    traditionalName: "烏魯瓜亞納",
    airports: [
      {
        code: "URG",
        name: "Rubem berta intl",
        chineseName: "鲁本博塔国际机场",
        traditionalName: "魯本博塔國際機場",
      },
    ],
  },
  URJ: {
    code: "URJ",
    name: "URAY",
    chineseName: "乌拉季",
    traditionalName: "烏拉季",
    airports: [
      {
        code: "URJ",
        name: "Uray airport",
        chineseName: "乌拉基机场",
        traditionalName: "烏拉基機場",
      },
    ],
  },
  URO: {
    code: "URO",
    name: "ROUEN",
    chineseName: "鲁昂",
    traditionalName: "盧昂",
    airports: [
      {
        code: "URO",
        name: "Vallee de seine",
        chineseName: "布斯机场",
        traditionalName: "布斯機場",
      },
    ],
  },
  URT: {
    code: "URT",
    name: "SURAT THANI",
    chineseName: "素叻他尼",
    traditionalName: "素叻他尼",
    airports: [
      {
        code: "URT",
        name: "Surat thani airport",
        chineseName: "万伦机场",
        traditionalName: "萬倫機場",
      },
    ],
  },
  URY: {
    code: "URY",
    name: "GURAYAT",
    chineseName: "古拉亚特",
    traditionalName: "古拉亞特",
    airports: [
      {
        code: "URY",
        name: "Gurayat airport",
        chineseName: "古拉亚特机场",
        traditionalName: "古拉亞特機場",
      },
    ],
  },
  USA: {
    code: "USA",
    name: "CONCORD",
    chineseName: "康科德",
    traditionalName: "康科特",
    airports: [
      {
        code: "USA",
        name: "Concord reg. airport",
        chineseName: "康科德机场",
        traditionalName: "康科特機場",
      },
    ],
  },
  USH: {
    code: "USH",
    name: "USHUAIA",
    chineseName: "乌斯怀亚",
    traditionalName: "烏斯懷亞",
    airports: [
      {
        code: "USH",
        name: "Malvinas argentinas",
        chineseName: "马尔维纳斯国际机场",
        traditionalName: "瑪律維納斯國際機場",
      },
    ],
  },
  USJ: {
    code: "USJ",
    name: "USHARAL",
    chineseName: "乌沙拉尔",
    traditionalName: "烏沙拉爾",
    airports: [
      {
        code: "USJ",
        name: "Usharal airport",
        chineseName: "USHARAL机场",
        traditionalName: "USHARAL機場",
      },
    ],
  },
  USK: {
    code: "USK",
    name: "USINSK",
    chineseName: "乌辛斯克",
    traditionalName: "烏辛斯克",
    airports: [
      {
        code: "USK",
        name: "Usinsk airport",
        chineseName: "乌辛斯克机场",
        traditionalName: "烏辛斯克機場",
      },
    ],
  },
  USM: {
    code: "USM",
    name: "KO SAMUI",
    chineseName: "苏梅岛",
    traditionalName: "蘇梅島",
    airports: [
      {
        code: "USM",
        name: "Ko samui airport",
        chineseName: "苏梅国际机场",
        traditionalName: "蘇梅國際機場",
      },
    ],
  },
  USN: {
    code: "USN",
    name: "ULSAN",
    chineseName: "蔚山",
    traditionalName: "蔚山",
    airports: [
      {
        code: "USN",
        name: "Ulsan airport",
        chineseName: "蔚山机场",
        traditionalName: "蔚山機場",
      },
    ],
  },
  USR: {
    code: "USR",
    name: "UST-NERA",
    chineseName: "乌斯季涅拉",
    traditionalName: "烏斯季涅拉",
    airports: [
      {
        code: "USR",
        name: "Ust-nera airport",
        chineseName: "乌斯内拉机场",
        traditionalName: "烏斯內拉機場",
      },
    ],
  },
  USU: {
    code: "USU",
    name: "BUSUANGA",
    chineseName: "布桑加",
    traditionalName: "布桑加",
    airports: [
      {
        code: "USU",
        name: "Francisco b. reyes",
        chineseName: "弗朗西斯科雷耶斯机场",
        traditionalName: "弗朗西斯科雷耶斯機場",
      },
    ],
  },
  UTH: {
    code: "UTH",
    name: "UDON THANI",
    chineseName: "乌隆他尼",
    traditionalName: "烏隆他尼",
    airports: [
      {
        code: "UTH",
        name: "Udon thani intl.",
        chineseName: "乌隆他尼国际机场",
        traditionalName: "烏隆他尼國際機場",
      },
    ],
  },
  UTK: {
    code: "UTK",
    name: "UTIRIK ISLAND",
    chineseName: "乌提里克岛",
    traditionalName: "烏提裏克島",
    airports: [
      {
        code: "UTK",
        name: "Utirik island airport",
        chineseName: "乌提里克岛机场",
        traditionalName: "烏提裏克島機場",
      },
    ],
  },
  UTN: {
    code: "UTN",
    name: "UPINGTON",
    chineseName: "阿平顿",
    traditionalName: "阿平頓",
    airports: [
      {
        code: "UTN",
        name: "Upington airport",
        chineseName: "阿平顿机场",
        traditionalName: "阿平頓機場",
      },
    ],
  },
  UTP: {
    code: "UTP",
    name: "U-TAPAO",
    chineseName: "芭堤雅",
    traditionalName: "芭堤雅",
    airports: [
      {
        code: "UTP",
        name: "Rayong-pattaya intl",
        chineseName: "乌塔帕奥机场",
        traditionalName: "烏塔帕奧機場",
      },
    ],
  },
  UTS: {
    code: "UTS",
    name: "UST-TSILMA",
    chineseName: "乌斯季齐利马",
    traditionalName: "烏斯季齊利馬",
    airports: [
      {
        code: "UTS",
        name: "Ust-tsilma airport",
        chineseName: "乌斯齐马机场",
        traditionalName: "烏斯齊馬機場",
      },
    ],
  },
  UTT: {
    code: "UTT",
    name: "UMTATA",
    chineseName: "乌姆塔塔",
    traditionalName: "烏姆塔塔",
    airports: [
      {
        code: "UTT",
        name: "K.d. matanzima",
        chineseName: "乌姆塔塔机场",
        traditionalName: "烏姆塔塔機場",
      },
    ],
  },
  UUA: {
    code: "UUA",
    name: "BUGULMA",
    chineseName: "布古玛",
    traditionalName: "布古瑪",
    airports: [
      {
        code: "UUA",
        name: "Bugulma airport",
        chineseName: "布古尔马机场",
        traditionalName: "布古爾馬機場",
      },
    ],
  },
  UUD: {
    code: "UUD",
    name: "ULAN-UDE",
    chineseName: "乌兰乌德",
    traditionalName: "烏蘭烏德",
    airports: [
      {
        code: "UUD",
        name: "Mukhino",
        chineseName: "贝加尔国际机场",
        traditionalName: "貝加爾國際機場",
      },
    ],
  },
  UUK: {
    code: "UUK",
    name: "KUPARUK",
    chineseName: "阿拉斯加库帕鲁克",
    traditionalName: "阿拉斯加庫帕魯克",
    airports: [
      {
        code: "UUK",
        name: "Ugnu-kuparuk",
        chineseName: "库帕勒克机场",
        traditionalName: "庫帕勒克機場",
      },
    ],
  },
  UUS: {
    code: "UUS",
    name: "YUZHNO-SAKHALINSK",
    chineseName: "南萨哈林斯克",
    traditionalName: "南薩哈林斯克",
    airports: [
      {
        code: "UUS",
        name: "Khomutovo",
        chineseName: "南萨哈林斯克机场",
        traditionalName: "南薩哈林斯克機場",
      },
    ],
  },
  UVE: {
    code: "UVE",
    name: "OUVEA",
    chineseName: "乌韦阿",
    traditionalName: "烏韋阿",
    airports: [
      {
        code: "UVE",
        name: "Ouloup",
        chineseName: "乌韦阿机场",
        traditionalName: "烏韋阿機場",
      },
    ],
  },
  UVI: {
    code: "UVI",
    name: "UNIAO DA VITORIA",
    chineseName: "维多利亚",
    traditionalName: "維多利亞",
    airports: [
      {
        code: "UVI",
        name: "Uniao da vitoria airport",
        chineseName: "UNIAO DA VITORIA机场",
        traditionalName: "UNIAO DA VITORIA機場",
      },
    ],
  },
  UYN: {
    code: "UYN",
    name: "YULIN - SHANXI",
    chineseName: "榆林",
    traditionalName: "榆林",
    airports: [
      {
        code: "UYN",
        name: "Yuyang",
        chineseName: "榆阳机场",
        traditionalName: "榆陽機場",
      },
    ],
  },
  UYU: {
    code: "UYU",
    name: "UYUNI",
    chineseName: "乌尤尼",
    traditionalName: "烏尤尼",
    airports: [
      {
        code: "UYU",
        name: "Uyuni airport",
        chineseName: "乌尤尼机场",
        traditionalName: "烏尤尼機場",
      },
    ],
  },
  VAA: {
    code: "VAA",
    name: "VAASA",
    chineseName: "瓦萨",
    traditionalName: "瓦薩",
    airports: [
      {
        code: "VAA",
        name: "Vaasa airport",
        chineseName: "瓦萨机场",
        traditionalName: "瓦薩機場",
      },
    ],
  },
  VAG: {
    code: "VAG",
    name: "VARGINHA",
    chineseName: "瓦尔金哈",
    traditionalName: "瓦爾金哈",
    airports: [
      {
        code: "VAG",
        name: "Maj. brig. trompowsky",
        chineseName: "布里格－特洛姆波维斯基机场",
        traditionalName: "布裡格－特洛姆波維斯基機場",
      },
    ],
  },
  VAI: {
    code: "VAI",
    name: "VANIMO",
    chineseName: "瓦尼莫",
    traditionalName: "瓦尼莫",
    airports: [
      {
        code: "VAI",
        name: "Vanimo airport",
        chineseName: "瓦尼莫机场",
        traditionalName: "瓦尼莫機場",
      },
    ],
  },
  VAK: {
    code: "VAK",
    name: "CHEVAK",
    chineseName: "阿拉斯加州切瓦克",
    traditionalName: "阿拉斯加州切瓦克",
    airports: [
      {
        code: "VAK",
        name: "Chevak airport",
        chineseName: "切瓦克机场",
        traditionalName: "切瓦克機場",
      },
    ],
  },
  VAM: {
    code: "VAM",
    name: "MAAMIGILI ISLAND",
    chineseName: "马米基里",
    traditionalName: "馬米基裏",
    airports: [
      {
        code: "VAM",
        name: "Maamigili island airport",
        chineseName: "马米基里岛机场",
        traditionalName: "馬米基裡島機場",
      },
    ],
  },
  VAN: {
    code: "VAN",
    name: "VAN",
    chineseName: "凡镇",
    traditionalName: "凡鎮",
    airports: [
      {
        code: "VAN",
        name: "Ferit melen",
        chineseName: "费里特梅伦机场",
        traditionalName: "費裡特梅倫機場",
      },
    ],
  },
  VAO: {
    code: "VAO",
    name: "SUAVANAO",
    chineseName: "苏阿瓦瑙",
    traditionalName: "蘇阿瓦瑙",
    airports: [
      {
        code: "VAO",
        name: "Suavanao airport",
        chineseName: "苏阿法瑙机场",
        traditionalName: "蘇阿法瑙機場",
      },
    ],
  },
  VAQ: {
    code: "VAQ",
    name: "VANAVARA",
    chineseName: "瓦纳瓦拉",
    traditionalName: "瓦納瓦拉",
    airports: [
      {
        code: "VAQ",
        name: "Vanavara airport",
        chineseName: "瓦纳瓦拉机场",
        traditionalName: "瓦納瓦拉機場",
      },
    ],
  },
  VAR: {
    code: "VAR",
    name: "VARNA",
    chineseName: "瓦尔纳",
    traditionalName: "瓦爾納",
    airports: [
      {
        code: "VAR",
        name: "Varna airport",
        chineseName: "瓦尔纳机场",
        traditionalName: "瓦爾納機場",
      },
    ],
  },
  VAS: {
    code: "VAS",
    name: "SIVAS",
    chineseName: "锡瓦斯",
    traditionalName: "錫瓦斯",
    airports: [
      {
        code: "VAS",
        name: "Sivas airport",
        chineseName: "锡瓦斯机场",
        traditionalName: "錫瓦斯機場",
      },
    ],
  },
  VAV: {
    code: "VAV",
    name: "VAVA'U",
    chineseName: "瓦瓦乌岛 ",
    traditionalName: "瓦瓦烏島",
    airports: [
      {
        code: "VAV",
        name: "Vava'u intl.",
        chineseName: "卢佩帕奥机场",
        traditionalName: "盧佩帕奧機場",
      },
    ],
  },
  VAW: {
    code: "VAW",
    name: "VARDO",
    chineseName: "瓦尔多",
    traditionalName: "瓦爾多",
    airports: [
      {
        code: "VAW",
        name: "Svartnes",
        chineseName: "瓦尔多机场",
        traditionalName: "瓦爾多機場",
      },
    ],
  },
  VBP: {
    code: "VBP",
    name: "BOKPYIN",
    chineseName: "博宾",
    traditionalName: "博賓",
    airports: [
      {
        code: "VBP",
        name: "Bokpyin airport",
        chineseName: "博宾机场",
        traditionalName: "博賓機場",
      },
    ],
  },
  VBV: {
    code: "VBV",
    name: "VANUABALAVU ISLAND",
    chineseName: "瓦努阿巴拉乌",
    traditionalName: "瓦努阿巴拉烏",
    airports: [
      {
        code: "VBV",
        name: "Vanuabalavu island airport",
        chineseName: "瓦努阿巴拉乌机场",
        traditionalName: "瓦努阿巴拉烏機場",
      },
    ],
  },
  VBY: {
    code: "VBY",
    name: "VISBY",
    chineseName: "维斯比",
    traditionalName: "維斯比",
    airports: [
      {
        code: "VBY",
        name: "Visby airport",
        chineseName: "维斯比机场",
        traditionalName: "維斯比機場",
      },
    ],
  },
  VCA: {
    code: "VCA",
    name: "CAN THO",
    chineseName: "芹苴",
    traditionalName: "芹苴",
    airports: [
      {
        code: "VCA",
        name: "Can tho intl.",
        chineseName: "芹苴国际机场",
        traditionalName: "芹苴國際機場",
      },
    ],
  },
  VCE: {
    code: "VCE",
    name: "VENICE",
    chineseName: "威尼斯",
    traditionalName: "威尼斯",
    airports: [
      {
        code: "TSF",
        name: "Treviso/sant'angelo",
        chineseName: "特雷维索机场",
        traditionalName: "特雷維索機場",
      },
      {
        code: "VCE",
        name: "Marco polo",
        chineseName: "威尼斯-泰塞拉马可波罗机场",
        traditionalName: "威尼斯-泰塞拉馬可波羅機場",
      },
    ],
  },
  VCL: {
    code: "VCL",
    name: "CHU LAI",
    chineseName: "楚莱",
    traditionalName: "楚萊",
    airports: [
      {
        code: "VCL",
        name: "Chu lai intl.",
        chineseName: "楚莱机场",
        traditionalName: "楚萊機場",
      },
    ],
  },
  VCS: {
    code: "VCS",
    name: "CON DAO ISLAND",
    chineseName: "昆岛",
    traditionalName: "昆島",
    airports: [
      {
        code: "VCS",
        name: "Co ong",
        chineseName: "昆仑岛机场",
        traditionalName: "昆侖島機場",
      },
    ],
  },
  VCT: {
    code: "VCT",
    name: "VICTORIA",
    chineseName: "维多利亚",
    traditionalName: "維多利亞",
    airports: [
      {
        code: "VCT",
        name: "Victoria reg. airport",
        chineseName: "维多利亚机场",
        traditionalName: "維多利亞機場",
      },
    ],
  },
  VCV: {
    code: "VCV",
    name: "VICTORVILLE",
    chineseName: "加利福尼亚州维克多维尔",
    traditionalName: "加利福尼亞州維克多維爾",
    airports: [
      {
        code: "VCV",
        name: "S.calif. logistics apt",
        chineseName: "维多利亚维尔机场",
        traditionalName: "維多利亞維爾機場",
      },
    ],
  },
  VDC: {
    code: "VDC",
    name: "VITORIA DA CONQUISTA",
    chineseName: "维多利亚达孔基斯塔",
    traditionalName: "維多利亞達孔基斯塔",
    airports: [
      {
        code: "VDC",
        name: "Glauber rocha",
        chineseName: "维多利亚达孔基斯塔机场",
        traditionalName: "維多利亞達孔基斯塔機場",
      },
    ],
  },
  VDE: {
    code: "VDE",
    name: "VALVERDE",
    chineseName: "巴尔韦德",
    traditionalName: "巴爾韋德",
    airports: [
      {
        code: "VDE",
        name: "El hierro",
        chineseName: "耶罗机场",
        traditionalName: "耶羅機場",
      },
    ],
  },
  VDH: {
    code: "VDH",
    name: "DONG HOI",
    chineseName: "同海",
    traditionalName: "同海",
    airports: [
      {
        code: "VDH",
        name: "Dong hoi airport",
        chineseName: "洞海机场",
        traditionalName: "洞海機場",
      },
    ],
  },
  VDM: {
    code: "VDM",
    name: "VIEDMA",
    chineseName: "别德马",
    traditionalName: "別德馬",
    airports: [
      {
        code: "VDM",
        name: "Gobernador e. castello",
        chineseName: "别德马机场",
        traditionalName: "別德馬機場",
      },
    ],
  },
  VDO: {
    code: "VDO",
    name: "QUANG NINH",
    chineseName: "广宁",
    traditionalName: "廣寧",
    airports: [
      {
        code: "VDO",
        name: "Van don international",
        chineseName: "云屯国际机场",
        traditionalName: "雲屯國際機場",
      },
    ],
  },
  VDS: {
    code: "VDS",
    name: "VADSO",
    chineseName: "瓦德瑟",
    traditionalName: "瓦德瑟",
    airports: [
      {
        code: "VDS",
        name: "Vadso airport",
        chineseName: "瓦德瑟机场",
        traditionalName: "瓦德瑟機場",
      },
    ],
  },
  VDY: {
    code: "VDY",
    name: "VIDYANAGAR",
    chineseName: "维迪亚纳加尔",
    traditionalName: "維迪亞納加爾",
    airports: [
      {
        code: "VDY",
        name: "Jindal",
        chineseName: "金达尔机场",
        traditionalName: "金達爾機場",
      },
    ],
  },
  VDZ: {
    code: "VDZ",
    name: "VALDEZ",
    chineseName: "瓦尔迪兹",
    traditionalName: "瓦爾迪茲",
    airports: [
      {
        code: "VDZ",
        name: "Pioneer field",
        chineseName: "瓦尔迪兹机场",
        traditionalName: "瓦爾迪茲機場",
      },
    ],
  },
  VEE: {
    code: "VEE",
    name: "VENETIE",
    chineseName: "阿拉斯加州威尼蒂",
    traditionalName: "阿拉斯加州威尼蒂",
    airports: [
      {
        code: "VEE",
        name: "Venetie airport",
        chineseName: "韦尼蒂机场",
        traditionalName: "韋尼蒂機場",
      },
    ],
  },
  VEL: {
    code: "VEL",
    name: "VERNAL",
    chineseName: "犹他州韦尔纳尔",
    traditionalName: "猶他州韋爾納爾",
    airports: [
      {
        code: "VEL",
        name: "Vernal reg. airport",
        chineseName: "弗纳尔机场",
        traditionalName: "弗納爾機場",
      },
    ],
  },
  VEO: {
    code: "VEO",
    name: "SEVERO-YENISEYSKIY",
    chineseName: "塞维罗叶尼塞斯基",
    traditionalName: "塞維羅葉尼塞斯基",
    airports: [
      {
        code: "VEO",
        name: "Severo-yeniseyskiy airport",
        chineseName: "SEVERO-ENISEYSKIY机场",
        traditionalName: "SEVERO-ENISEYSKIY機場",
      },
    ],
  },
  VER: {
    code: "VER",
    name: "VERACRUZ",
    chineseName: "韦拉克鲁斯",
    traditionalName: "韋拉克魯斯",
    airports: [
      {
        code: "VER",
        name: "Heriberto jara intl",
        chineseName: "埃里博托哈拉将军国际机场",
        traditionalName: "埃裏博托哈拉將軍國際機場",
      },
    ],
  },
  VFA: {
    code: "VFA",
    name: "VICTORIA FALLS",
    chineseName: "维多利亚瀑布",
    traditionalName: "維多利亞瀑布",
    airports: [
      {
        code: "VFA",
        name: "Victoria falls intl.",
        chineseName: "维多利亚瀑布城机场",
        traditionalName: "維多利亞瀑布城機場",
      },
    ],
  },
  VGA: {
    code: "VGA",
    name: "VIJAYAWADA",
    chineseName: "维杰亚瓦达",
    traditionalName: "維傑亞瓦達",
    airports: [
      {
        code: "VGA",
        name: "Vijayawada airport",
        chineseName: "维杰亚瓦达机场",
        traditionalName: "維傑亞瓦達機場",
      },
    ],
  },
  VGD: {
    code: "VGD",
    name: "VOLOGDA",
    chineseName: "沃洛格达",
    traditionalName: "沃洛格達",
    airports: [
      {
        code: "VGD",
        name: "Vologda airport",
        chineseName: "伏尔加机场",
        traditionalName: "伏爾加機場",
      },
    ],
  },
  VGO: {
    code: "VGO",
    name: "VIGO",
    chineseName: "维戈",
    traditionalName: "維戈",
    airports: [
      {
        code: "VGO",
        name: "Vigo airport",
        chineseName: "比戈机场",
        traditionalName: "比戈機場",
      },
    ],
  },
  VGZ: {
    code: "VGZ",
    name: "VILLAGARZON",
    chineseName: "维拉加佐恩",
    traditionalName: "維拉加佐恩",
    airports: [
      {
        code: "VGZ",
        name: "Villagarzon airport",
        chineseName: "维拉加佐恩机场",
        traditionalName: "維拉加佐恩機場",
      },
    ],
  },
  VHC: {
    code: "VHC",
    name: "SAURIMO",
    chineseName: "绍里木",
    traditionalName: "紹裡木",
    airports: [
      {
        code: "VHC",
        name: "Saurimo airport",
        chineseName: "苏里莫机场",
        traditionalName: "蘇裏莫機場",
      },
    ],
  },
  VHM: {
    code: "VHM",
    name: "VILHELMINA",
    chineseName: "威廉敏娜",
    traditionalName: "威廉敏娜",
    airports: [
      {
        code: "VHM",
        name: "Vilhelmina airport",
        chineseName: "威廉敏娜机场",
        traditionalName: "威廉敏娜機場",
      },
    ],
  },
  VHZ: {
    code: "VHZ",
    name: "VAHITAHI",
    chineseName: "瓦希塔希",
    traditionalName: "瓦希塔希",
    airports: [
      {
        code: "VHZ",
        name: "Vahitahi airport",
        chineseName: "瓦希塔希机场",
        traditionalName: "瓦希塔希機場",
      },
    ],
  },
  VIE: {
    code: "VIE",
    name: "VIENNA",
    chineseName: "维也纳",
    traditionalName: "維也納",
    airports: [
      {
        code: "VIE",
        name: "Schwechat intl",
        chineseName: "维也纳国际机场",
        traditionalName: "維也納國際機場",
      },
    ],
  },
  VIG: {
    code: "VIG",
    name: "EL VIGIA",
    chineseName: "艾尔维吉亚",
    traditionalName: "艾爾維吉亞",
    airports: [
      {
        code: "VIG",
        name: "Juan p. perez alfonso",
        chineseName: "胡安帕布罗佩雷斯阿方索机场",
        traditionalName: "胡安帕布羅佩雷斯阿方索機場",
      },
    ],
  },
  VII: {
    code: "VII",
    name: "VINH",
    chineseName: "荣市",
    traditionalName: "榮市",
    airports: [
      {
        code: "VII",
        name: "Vinh airport",
        chineseName: "荣市机场",
        traditionalName: "榮市機場",
      },
    ],
  },
  VIJ: {
    code: "VIJ",
    name: "VIRGIN GORDA",
    chineseName: "维尔京戈尔达岛",
    traditionalName: "維爾京戈爾達島",
    airports: [
      {
        code: "VIJ",
        name: "Virgin gorda airport",
        chineseName: "维尔京戈尔达岛机场",
        traditionalName: "維爾京戈爾達島機場",
      },
    ],
  },
  VIL: {
    code: "VIL",
    name: "DAKHLA",
    chineseName: "达赫拉",
    traditionalName: "達赫拉",
    airports: [
      {
        code: "VIL",
        name: "Dakhla airport",
        chineseName: "达赫拉机场",
        traditionalName: "達赫拉機場",
      },
    ],
  },
  VIT: {
    code: "VIT",
    name: "VITORIA",
    chineseName: "维多利亚",
    traditionalName: "維多利亞",
    airports: [
      {
        code: "VIT",
        name: "Vitoria airport",
        chineseName: "维多利亚机场",
        traditionalName: "維多利亞機場",
      },
    ],
  },
  VIX: {
    code: "VIX",
    name: "VITORIA",
    chineseName: "维多利亚",
    traditionalName: "維多利亞",
    airports: [
      {
        code: "VIX",
        name: "E. de aguiar salles",
        chineseName: "欧里科德阿吉亚尔塞勒斯机场",
        traditionalName: "歐裏科德阿吉亞爾塞勒斯機場",
      },
    ],
  },
  VKG: {
    code: "VKG",
    name: "RACH GIA",
    chineseName: "迪石",
    traditionalName: "迪石",
    airports: [
      {
        code: "VKG",
        name: "Rach gia airport",
        chineseName: "迪石机场",
        traditionalName: "迪石機場",
      },
    ],
  },
  VKT: {
    code: "VKT",
    name: "VORKUTA",
    chineseName: "沃尔库塔",
    traditionalName: "沃爾庫塔",
    airports: [
      {
        code: "VKT",
        name: "Vorkuta airport",
        chineseName: "沃尔库塔机场",
        traditionalName: "沃爾庫塔機場",
      },
    ],
  },
  VLC: {
    code: "VLC",
    name: "VALENCIA",
    chineseName: "巴伦西亚",
    traditionalName: "華倫西亞",
    airports: [
      {
        code: "VLC",
        name: "Valencia airport",
        chineseName: "瓦伦西亚机场",
        traditionalName: "瓦倫西亞機場",
      },
    ],
  },
  VLD: {
    code: "VLD",
    name: "VALDOSTA",
    chineseName: "瓦尔多斯塔",
    traditionalName: "瓦爾多斯塔",
    airports: [
      {
        code: "VLD",
        name: "Valdosta reg. airport",
        chineseName: "瓦尔多斯塔地区机场",
        traditionalName: "瓦爾多斯塔地區機場",
      },
    ],
  },
  VLI: {
    code: "VLI",
    name: "PORT VILA",
    chineseName: "维拉港",
    traditionalName: "維拉港",
    airports: [
      {
        code: "VLI",
        name: "Port vila airport",
        chineseName: "鲍尔菲尔德机场",
        traditionalName: "鮑爾菲爾德機場",
      },
    ],
  },
  VLL: {
    code: "VLL",
    name: "VALLADOLID",
    chineseName: "巴利亚多利德",
    traditionalName: "巴利亞多利德",
    airports: [
      {
        code: "VLL",
        name: "Valladolid airport",
        chineseName: "巴利阿多里德机场",
        traditionalName: "巴厘阿多裡德機場",
      },
    ],
  },
  VLN: {
    code: "VLN",
    name: "VALENCIA",
    chineseName: "瓦伦西亚",
    traditionalName: "瓦倫西亞",
    airports: [
      {
        code: "VLN",
        name: "Arturo michelena intl",
        chineseName: "阿图罗米切莱纳机场",
        traditionalName: "阿圖羅米切萊納機場",
      },
    ],
  },
  VLY: {
    code: "VLY",
    name: "ANGLESEY",
    chineseName: "安格尔西岛",
    traditionalName: "安格爾西島",
    airports: [
      {
        code: "VLY",
        name: "Valley",
        chineseName: "安格尔西岛机场",
        traditionalName: "安格爾西島機場",
      },
    ],
  },
  VNO: {
    code: "VNO",
    name: "VILNIUS",
    chineseName: "维尔纽斯",
    traditionalName: "維爾紐斯",
    airports: [
      {
        code: "VNO",
        name: "Vilnius intl.",
        chineseName: "维尔纽斯国际机场",
        traditionalName: "維爾紐斯國際機場",
      },
    ],
  },
  VNS: {
    code: "VNS",
    name: "VARANASI",
    chineseName: "瓦拉纳西",
    traditionalName: "瓦拉納西",
    airports: [
      {
        code: "VNS",
        name: "Lal bahadur shastri",
        chineseName: "瓦拉纳西机场",
        traditionalName: "瓦拉納西機場",
      },
    ],
  },
  VNX: {
    code: "VNX",
    name: "VILANKULOS",
    chineseName: "维兰库卢什",
    traditionalName: "維蘭庫盧什",
    airports: [
      {
        code: "VNX",
        name: "Vilankulos airport",
        chineseName: "维兰库卢什机场",
        traditionalName: "維蘭庫盧什機場",
      },
    ],
  },
  VOG: {
    code: "VOG",
    name: "VOLGOGRAD",
    chineseName: "伏尔加格勒",
    traditionalName: "伏爾加格勒",
    airports: [
      {
        code: "VOG",
        name: "Gumrak",
        chineseName: "伏尔加格勒机场",
        traditionalName: "伏爾加格勒機場",
      },
    ],
  },
  VOL: {
    code: "VOL",
    name: "VOLOS",
    chineseName: "沃洛斯",
    traditionalName: "沃洛斯",
    airports: [
      {
        code: "VOL",
        name: "Nea anchialos",
        chineseName: "内安恰阿罗斯机场",
        traditionalName: "內安恰阿羅斯機場",
      },
    ],
  },
  VPE: {
    code: "VPE",
    name: "ONDJIVA",
    chineseName: "昂基瓦",
    traditionalName: "昂基瓦",
    airports: [
      {
        code: "VPE",
        name: "Ondjiva airport",
        chineseName: "昂基瓦机场",
        traditionalName: "昂基瓦機場",
      },
    ],
  },
  VPG: {
    code: "VPG",
    name: "VIPINGO",
    chineseName: "韦品戈",
    traditionalName: "韋品戈",
    airports: [
      {
        code: "VPG",
        name: "Vipingo airport",
        chineseName: "韦品戈山机场",
        traditionalName: "韋品戈山機場",
      },
    ],
  },
  VPN: {
    code: "VPN",
    name: "VOPNAFJORDUR",
    chineseName: "沃普纳菲厄泽",
    traditionalName: "沃普納菲厄澤",
    airports: [
      {
        code: "VPN",
        name: "Vopnafjordur airport",
        chineseName: "沃普纳菲厄泽机场",
        traditionalName: "沃普納菲厄澤機場",
      },
    ],
  },
  VPS: {
    code: "VPS",
    name: "DESTIN/FT WALTON BEACH",
    chineseName: "沃尔顿堡滩",
    traditionalName: "沃爾頓堡灘",
    airports: [
      {
        code: "VPS",
        name: "Destin-ft walton beach",
        chineseName: "瓦尔帕莱索机场",
        traditionalName: "瓦爾帕萊索機場",
      },
    ],
  },
  VPY: {
    code: "VPY",
    name: "CHIMOIO",
    chineseName: "希莫尤",
    traditionalName: "希莫尤",
    airports: [
      {
        code: "VPY",
        name: "Chimoio airport",
        chineseName: "希莫尤机场",
        traditionalName: "希莫尤機場",
      },
    ],
  },
  VQS: {
    code: "VQS",
    name: "VIEQUES",
    chineseName: "别克斯",
    traditionalName: "別克斯",
    airports: [
      {
        code: "VQS",
        name: "A.rivera rodriguez",
        chineseName: "安东尼奥里维拉罗德里格斯机场",
        traditionalName: "安東尼奧裏維拉羅德裏格斯機場",
      },
    ],
  },
  VRA: {
    code: "VRA",
    name: "VARADERO",
    chineseName: "瓦拉德",
    traditionalName: "瓦拉德",
    airports: [
      {
        code: "VRA",
        name: "Juan g. gomez intl",
        chineseName: "胡安瓜尔博特戈梅兹机场",
        traditionalName: "胡安瓜爾博特戈梅茲機場",
      },
    ],
  },
  VRB: {
    code: "VRB",
    name: "VERO BEACH",
    chineseName: "维罗比奇",
    traditionalName: "維羅比奇",
    airports: [
      {
        code: "VRB",
        name: "Vero beach municipal",
        chineseName: "维罗比奇地方机场",
        traditionalName: "維羅比奇地方機場",
      },
    ],
  },
  VRC: {
    code: "VRC",
    name: "VIRAC",
    chineseName: "比拉克",
    traditionalName: "比拉克",
    airports: [
      {
        code: "VRC",
        name: "Virac airport",
        chineseName: "比拉克机场",
        traditionalName: "比拉克機場",
      },
    ],
  },
  VRL: {
    code: "VRL",
    name: "VILA REAL",
    chineseName: "雷阿尔城",
    traditionalName: "雷阿爾城",
    airports: [
      {
        code: "VRL",
        name: "Vila real airport",
        chineseName: "雷阿尔城机场",
        traditionalName: "雷阿爾城機場",
      },
    ],
  },
  VRN: {
    code: "VRN",
    name: "VERONA",
    chineseName: "维罗纳",
    traditionalName: "維羅納",
    airports: [
      {
        code: "VBS",
        name: "Brescia/montichiari",
        chineseName: "布雷西亚机场",
        traditionalName: "佈雷西亞機場",
      },
      {
        code: "VRN",
        name: "Villafranca",
        chineseName: "维罗纳机场",
        traditionalName: "維羅納機場",
      },
    ],
  },
  VSA: {
    code: "VSA",
    name: "VILLAHERMOSA",
    chineseName: "比亚埃尔莫萨",
    traditionalName: "比亞埃爾莫薩",
    airports: [
      {
        code: "VSA",
        name: "C.rovirosa perez intl",
        chineseName: "卡洛斯罗维罗萨佩雷斯国际机场",
        traditionalName: "卡洛斯羅維羅薩佩雷斯國際機場",
      },
    ],
  },
  VSE: {
    code: "VSE",
    name: "VISEU",
    chineseName: "维塞乌",
    traditionalName: "維塞烏",
    airports: [
      {
        code: "VSE",
        name: "Viseu airport",
        chineseName: "维塞乌机场",
        traditionalName: "維塞烏機場",
      },
    ],
  },
  VSV: {
    code: "VSV",
    name: "SHRAVASTI",
    chineseName: "什拉瓦斯蒂",
    traditionalName: "什拉瓦斯蒂",
    airports: [
      {
        code: "VSV",
        name: "Shravasti airport",
        chineseName: "Shravasti机场",
        traditionalName: "Shravasti機場",
      },
    ],
  },
  VTB: {
    code: "VTB",
    name: "VITEBSK",
    chineseName: "维捷布斯克",
    traditionalName: "維捷布斯克",
    airports: [
      {
        code: "VTB",
        name: "Vostochny",
        chineseName: "维捷布斯克机场",
        traditionalName: "維捷布斯克機場",
      },
    ],
  },
  VTE: {
    code: "VTE",
    name: "VIENTIANE",
    chineseName: "万象",
    traditionalName: "萬象",
    airports: [
      {
        code: "VTE",
        name: "Wattay intl",
        chineseName: "瓦岱国际机场",
        traditionalName: "瓦岱國際機場",
      },
    ],
  },
  VTZ: {
    code: "VTZ",
    name: "VISHAKHAPATNAM",
    chineseName: "维萨卡帕特南",
    traditionalName: "維薩卡派特南",
    airports: [
      {
        code: "VTZ",
        name: "Vishakhapatnam airport",
        chineseName: "维沙卡帕特南机场",
        traditionalName: "維沙卡帕特南機場",
      },
    ],
  },
  VUP: {
    code: "VUP",
    name: "VALLEDUPAR",
    chineseName: "巴耶杜帕尔",
    traditionalName: "巴耶杜帕爾",
    airports: [
      {
        code: "VUP",
        name: "Alfonso lopez pumarejo",
        chineseName: "巴耶杜帕尔机场",
        traditionalName: "巴耶杜帕爾機場",
      },
    ],
  },
  VUS: {
    code: "VUS",
    name: "VELIKY USTYUG",
    chineseName: "大乌斯秋格",
    traditionalName: "大烏斯秋格",
    airports: [
      {
        code: "VUS",
        name: "Veliky ustyug airport",
        chineseName: "大乌斯秋格机场",
        traditionalName: "大烏斯秋格機場",
      },
    ],
  },
  VVC: {
    code: "VVC",
    name: "VILLAVICENCIO",
    chineseName: "拉万瓜尔迪亚",
    traditionalName: "拉萬瓜爾迪亞",
    airports: [
      {
        code: "VVC",
        name: "Vanguardia",
        chineseName: "拉万瓜尔迪亚机场",
        traditionalName: "拉萬瓜爾迪亞機場",
      },
    ],
  },
  VVO: {
    code: "VVO",
    name: "VLADIVOSTOK",
    chineseName: "符拉迪沃斯托克",
    traditionalName: "符拉迪沃斯托克",
    airports: [
      {
        code: "VVO",
        name: "Knevichi",
        chineseName: "符拉迪沃斯托克机场",
        traditionalName: "符拉迪沃斯托克機場",
      },
    ],
  },
  VVZ: {
    code: "VVZ",
    name: "ILLIZI",
    chineseName: "伊利济",
    traditionalName: "伊利濟",
    airports: [
      {
        code: "VVZ",
        name: "Takhamalt",
        chineseName: "伊利济机场",
        traditionalName: "伊利濟機場",
      },
    ],
  },
  VXC: {
    code: "VXC",
    name: "LICHINGA",
    chineseName: "利欣加",
    traditionalName: "利欣加",
    airports: [
      {
        code: "VXC",
        name: "Lichinga airport",
        chineseName: "利欣加机场",
        traditionalName: "利欣加機場",
      },
    ],
  },
  VXE: {
    code: "VXE",
    name: "SAO VICENTE ISLAND",
    chineseName: "圣维森特",
    traditionalName: "聖維森特",
    airports: [
      {
        code: "VXE",
        name: "Sao pedro",
        chineseName: "圣佩德罗机场",
        traditionalName: "聖佩德羅機場",
      },
    ],
  },
  VXO: {
    code: "VXO",
    name: "VAXJO",
    chineseName: "韦克舍",
    traditionalName: "韋克舍",
    airports: [
      {
        code: "VXO",
        name: "Smaland",
        chineseName: "斯马兰德机场",
        traditionalName: "斯馬蘭德機場",
      },
    ],
  },
  WAA: {
    code: "WAA",
    name: "WALES",
    chineseName: "阿拉斯加威尔士",
    traditionalName: "阿拉斯加威爾士",
    airports: [
      {
        code: "WAA",
        name: "Wales airport",
        chineseName: "威尔士机场",
        traditionalName: "威爾士機場",
      },
    ],
  },
  WAE: {
    code: "WAE",
    name: "WADI AL DAWASER",
    chineseName: "瓦迪阿德达瓦西尔",
    traditionalName: "瓦迪阿德達瓦西爾",
    airports: [
      {
        code: "WAE",
        name: "Wadi al dawaser airport",
        chineseName: "瓦蒂阿德达瓦希尔机场",
        traditionalName: "瓦蒂阿德達瓦希爾機場",
      },
    ],
  },
  WAG: {
    code: "WAG",
    name: "WHANGANUI",
    chineseName: "旺加努伊",
    traditionalName: "旺加努伊",
    airports: [
      {
        code: "WAG",
        name: "Whanganui airport",
        chineseName: "旺阿努伊机场",
        traditionalName: "旺阿努伊機場",
      },
    ],
  },
  WAS: {
    code: "WAS",
    name: "WASHINGTON",
    chineseName: "华盛顿",
    traditionalName: "華府",
    airports: [
      {
        code: "DCA",
        name: "Ronald reagan national",
        chineseName: "罗纳德里根国家机场",
        traditionalName: "羅納德裏根國家機場",
      },
      {
        code: "IAD",
        name: "Dulles intl",
        chineseName: "杜勒斯国际机场",
        traditionalName: "杜勒斯國際機場",
      },
    ],
  },
  WAW: {
    code: "WAW",
    name: "WARSAW",
    chineseName: "华沙",
    traditionalName: "華沙",
    airports: [
      {
        code: "RDO",
        name: "Warsaw airport",
        chineseName: "拉多姆机场",
        traditionalName: "拉多姆機場",
      },
      {
        code: "WAW",
        name: "Frederic chopin",
        chineseName: "肖邦机场",
        traditionalName: "蕭邦機場",
      },
    ],
  },
  WBB: {
    code: "WBB",
    name: "STEBBINS",
    chineseName: "斯蒂宾斯",
    traditionalName: "斯蒂賓斯",
    airports: [
      {
        code: "WBB",
        name: "Stebbins airport",
        chineseName: "斯蒂宾斯机场",
        traditionalName: "斯蒂賓斯機場",
      },
    ],
  },
  WBM: {
    code: "WBM",
    name: "WAPENAMANDA",
    chineseName: "瓦珀纳曼达",
    traditionalName: "瓦珀納曼達",
    airports: [
      {
        code: "WBM",
        name: "Wapenamanda airport",
        chineseName: "瓦珀纳曼达机场",
        traditionalName: "瓦珀納曼達機場",
      },
    ],
  },
  WBQ: {
    code: "WBQ",
    name: "BEAVER",
    chineseName: "阿拉斯加州比弗",
    traditionalName: "阿拉斯加州比弗",
    airports: [
      {
        code: "WBQ",
        name: "Beaver airport",
        chineseName: "比弗机场",
        traditionalName: "比弗機場",
      },
    ],
  },
  WCA: {
    code: "WCA",
    name: "CASTRO",
    chineseName: "卡斯特罗",
    traditionalName: "卡斯楚",
    airports: [
      {
        code: "MHC",
        name: "Mocopulli",
        chineseName: "莫柯普利机场",
        traditionalName: "莫柯普利機場",
      },
    ],
  },
  WCH: {
    code: "WCH",
    name: "CHAITEN",
    chineseName: "柴腾",
    traditionalName: "柴騰",
    airports: [
      {
        code: "WCH",
        name: "Nuevo chaiten",
        chineseName: "柴腾机场",
        traditionalName: "柴騰機場",
      },
    ],
  },
  WDB: {
    code: "WDB",
    name: "WEDA",
    chineseName: "阿拉斯加后海湾",
    traditionalName: "阿拉斯加後海灣",
    airports: [
      {
        code: "WDB",
        name: "Weda bay airport",
        chineseName: "后海湾机场",
        traditionalName: "後海灣機場",
      },
    ],
  },
  WDH: {
    code: "WDH",
    name: "WINDHOEK",
    chineseName: "温得和克",
    traditionalName: "溫吐克",
    airports: [
      {
        code: "ERS",
        name: "Eros",
        chineseName: "埃罗斯机场",
        traditionalName: "埃羅斯機場",
      },
      {
        code: "WDH",
        name: "Hosea kutako intl",
        chineseName: "卢格哈威机场",
        traditionalName: "盧格哈威機場",
      },
    ],
  },
  WDS: {
    code: "WDS",
    name: "SHIYAN",
    chineseName: "十堰",
    traditionalName: "十堰",
    airports: [
      {
        code: "WDS",
        name: "Wudangshan",
        chineseName: "武当山机场",
        traditionalName: "武當山機場",
      },
    ],
  },
  WEF: {
    code: "WEF",
    name: "WEIFANG",
    chineseName: "潍坊",
    traditionalName: "濰坊",
    airports: [
      {
        code: "WEF",
        name: "Weifang airport",
        chineseName: "潍坊机场",
        traditionalName: "濰坊機場",
      },
    ],
  },
  WEH: {
    code: "WEH",
    name: "WEIHAI",
    chineseName: "威海",
    traditionalName: "威海",
    airports: [
      {
        code: "WEH",
        name: "Dashuibo",
        chineseName: "大水泊机场",
        traditionalName: "大水泊機場",
      },
    ],
  },
  WEI: {
    code: "WEI",
    name: "WEIPA",
    chineseName: "韦伯",
    traditionalName: "韋伯",
    airports: [
      {
        code: "WEI",
        name: "Weipa airport",
        chineseName: "韦帕机场",
        traditionalName: "韋帕機場",
      },
    ],
  },
  WGA: {
    code: "WGA",
    name: "WAGGA WAGGA",
    chineseName: "沃加沃加",
    traditionalName: "沃加沃加",
    airports: [
      {
        code: "WGA",
        name: "Wagga wagga airport",
        chineseName: "沃加沃加机场",
        traditionalName: "沃加沃加機場",
      },
    ],
  },
  WGE: {
    code: "WGE",
    name: "WALGETT",
    chineseName: "沃尔格特",
    traditionalName: "沃爾格特",
    airports: [
      {
        code: "WGE",
        name: "Walgett airport",
        chineseName: "沃尔格特机场",
        traditionalName: "沃爾格特機場",
      },
    ],
  },
  WGN: {
    code: "WGN",
    name: "SHAOYANG",
    chineseName: "武冈",
    traditionalName: "武岡",
    airports: [
      {
        code: "WGN",
        name: "Wugang",
        chineseName: "武冈机场",
        traditionalName: "武岡機場",
      },
    ],
  },
  WGP: {
    code: "WGP",
    name: "WAINGAPU",
    chineseName: "瓦英阿普",
    traditionalName: "瓦英阿普",
    airports: [
      {
        code: "WGP",
        name: "Umbu mehang kunda",
        chineseName: "瓦英阿普机场",
        traditionalName: "瓦英阿普機場",
      },
    ],
  },
  WHK: {
    code: "WHK",
    name: "WHAKATANE",
    chineseName: "瓦卡塔尼",
    traditionalName: "瓦卡塔尼",
    airports: [
      {
        code: "WHK",
        name: "Whakatane airport",
        chineseName: "瓦卡塔尼机场",
        traditionalName: "瓦卡塔尼機場",
      },
    ],
  },
  WHU: {
    code: "WHU",
    name: "WUHU",
    chineseName: "芜湖",
    traditionalName: "蕪湖",
    airports: [
      {
        code: "WHA",
        name: "Xuanzhou",
        chineseName: "芜湖宣州机场",
        traditionalName: "蕪湖宣州機場",
      },
    ],
  },
  WIC: {
    code: "WIC",
    name: "WICK",
    chineseName: "维克",
    traditionalName: "維克",
    airports: [
      {
        code: "WIC",
        name: "Wick airport",
        chineseName: "威克机场",
        traditionalName: "威克機場",
      },
    ],
  },
  WIN: {
    code: "WIN",
    name: "WINTON",
    chineseName: "温顿",
    traditionalName: "溫頓",
    airports: [
      {
        code: "WIN",
        name: "Winton airport",
        chineseName: "温顿机场",
        traditionalName: "溫頓機場",
      },
    ],
  },
  WIR: {
    code: "WIR",
    name: "WAIROA",
    chineseName: "怀罗阿",
    traditionalName: "懷羅阿",
    airports: [
      {
        code: "WIR",
        name: "Wairoa airport",
        chineseName: "怀罗阿机场",
        traditionalName: "懷羅阿機場",
      },
    ],
  },
  WJA: {
    code: "WJA",
    name: "WOJA ISLAND",
    chineseName: "沃加",
    traditionalName: "沃加",
    airports: [
      {
        code: "WJA",
        name: "Woja island airport",
        chineseName: "沃贾机场",
        traditionalName: "沃賈機場",
      },
    ],
  },
  WJR: {
    code: "WJR",
    name: "WAJIR",
    chineseName: "瓦吉尔",
    traditionalName: "瓦吉爾",
    airports: [
      {
        code: "WJR",
        name: "Wajir airport",
        chineseName: "瓦吉尔机场",
        traditionalName: "瓦吉爾機場",
      },
    ],
  },
  WJU: {
    code: "WJU",
    name: "WONJU",
    chineseName: "原州",
    traditionalName: "原州",
    airports: [
      {
        code: "WJU",
        name: "Wonju airport",
        chineseName: "原州机场",
        traditionalName: "原州機場",
      },
    ],
  },
  WKA: {
    code: "WKA",
    name: "WANAKA",
    chineseName: "瓦纳卡",
    traditionalName: "瓦納卡",
    airports: [
      {
        code: "WKA",
        name: "Wanaka airport",
        chineseName: "瓦纳卡机场",
        traditionalName: "瓦納卡機場",
      },
    ],
  },
  WKJ: {
    code: "WKJ",
    name: "WAKKANAI",
    chineseName: "稚内",
    traditionalName: "稚內",
    airports: [
      {
        code: "WKJ",
        name: "Wakkanai airport",
        chineseName: "稚内机场",
        traditionalName: "稚內機場",
      },
    ],
  },
  WLE: {
    code: "WLE",
    name: "MILES",
    chineseName: "Miles Miles城",
    traditionalName: "Miles Miles城",
    airports: [
      {
        code: "WLE",
        name: "Miles airport",
        chineseName: "迈尔斯机场",
        traditionalName: "邁爾斯機場",
      },
    ],
  },
  WLG: {
    code: "WLG",
    name: "WELLINGTON",
    chineseName: "惠灵顿",
    traditionalName: "惠靈頓",
    airports: [
      {
        code: "WLG",
        name: "Wellington intl.",
        chineseName: "惠灵顿国际机场",
        traditionalName: "惠靈頓國際機場",
      },
    ],
  },
  WLH: {
    code: "WLH",
    name: "WALAHA",
    chineseName: "瓦拉哈",
    traditionalName: "瓦拉哈",
    airports: [
      {
        code: "WLH",
        name: "Walaha airport",
        chineseName: "瓦拉哈机场",
        traditionalName: "瓦拉哈機場",
      },
    ],
  },
  WLK: {
    code: "WLK",
    name: "SELAWIK",
    chineseName: "塞拉威克",
    traditionalName: "塞拉威克",
    airports: [
      {
        code: "WLK",
        name: "Selawik airport",
        chineseName: "塞拉威克机场",
        traditionalName: "塞拉威克機場",
      },
    ],
  },
  WLP: {
    code: "WLP",
    name: "WEST ANGELAS",
    chineseName: "西安吉拉斯",
    traditionalName: "西安吉拉斯",
    airports: [
      {
        code: "WLP",
        name: "West angelas airport",
        chineseName: "西安吉拉斯机场",
        traditionalName: "西安吉拉斯機場",
      },
    ],
  },
  WLS: {
    code: "WLS",
    name: "WALLIS ISLAND",
    chineseName: "瓦利斯群岛",
    traditionalName: "瓦利斯群島",
    airports: [
      {
        code: "WLS",
        name: "Hihifo",
        chineseName: "希希福机场",
        traditionalName: "希希福機場",
      },
    ],
  },
  WMI: {
    code: "WMI",
    name: "NOWY DWOR MAZOWIECKI",
    chineseName: "华沙",
    traditionalName: "華沙",
    airports: [
      {
        code: "WMI",
        name: "Modlin",
        chineseName: "莫德林机场",
        traditionalName: "莫德林機場",
      },
    ],
  },
  WMN: {
    code: "WMN",
    name: "MAROANTSETRA",
    chineseName: "马鲁安采特拉",
    traditionalName: "馬魯安采特拉",
    airports: [
      {
        code: "WMN",
        name: "Maroantsetra airport",
        chineseName: "马鲁安采特拉机场",
        traditionalName: "馬魯安采特拉機場",
      },
    ],
  },
  WMO: {
    code: "WMO",
    name: "WHITE MOUNTAIN",
    chineseName: "阿拉斯加白山",
    traditionalName: "阿拉斯加白山",
    airports: [
      {
        code: "WMO",
        name: "White mountain airport",
        chineseName: "怀特芒廷机场",
        traditionalName: "懷特芒廷機場",
      },
    ],
  },
  WMX: {
    code: "WMX",
    name: "WAMENA",
    chineseName: "瓦梅纳",
    traditionalName: "瓦梅納",
    airports: [
      {
        code: "WMX",
        name: "Wamena airport",
        chineseName: "瓦梅纳机场",
        traditionalName: "瓦梅納機場",
      },
    ],
  },
  WNA: {
    code: "WNA",
    name: "NAPAKIAK",
    chineseName: "阿拉斯加州纳帕基亚克",
    traditionalName: "阿拉斯加州納帕基亞克",
    airports: [
      {
        code: "WNA",
        name: "Napakiak airport",
        chineseName: "纳帕基亚克机场",
        traditionalName: "納帕基亞克機場",
      },
    ],
  },
  WNH: {
    code: "WNH",
    name: "WENSHAN",
    chineseName: "文山",
    traditionalName: "文山",
    airports: [
      {
        code: "WNH",
        name: "Puzhehei",
        chineseName: "文山砚山机场",
        traditionalName: "文山硯山機場",
      },
    ],
  },
  WNI: {
    code: "WNI",
    name: "WANGIWANGI ISLAND",
    chineseName: "望吉旺吉岛",
    traditionalName: "望吉旺吉島",
    airports: [
      {
        code: "WNI",
        name: "Matahora",
        chineseName: "马塔霍拉机场",
        traditionalName: "馬塔霍拉機場",
      },
    ],
  },
  WNN: {
    code: "WNN",
    name: "WUNNUMMIN LAKE",
    chineseName: "乌努明莱克",
    traditionalName: "烏努明萊克",
    airports: [
      {
        code: "WNN",
        name: "Wunnummin lake airport",
        chineseName: "乌努明莱克机场",
        traditionalName: "烏努明萊克機場",
      },
    ],
  },
  WNP: {
    code: "WNP",
    name: "NAGA",
    chineseName: "那牙",
    traditionalName: "那牙",
    airports: [
      {
        code: "WNP",
        name: "Naga airport",
        chineseName: "那牙机场",
        traditionalName: "那牙機場",
      },
    ],
  },
  WNR: {
    code: "WNR",
    name: "WINDORAH",
    chineseName: "温多拉",
    traditionalName: "溫多拉",
    airports: [
      {
        code: "WNR",
        name: "Windorah airport",
        chineseName: "温多拉机场",
        traditionalName: "溫多拉機場",
      },
    ],
  },
  WNZ: {
    code: "WNZ",
    name: "WENZHOU",
    chineseName: "温州",
    traditionalName: "溫州",
    airports: [
      {
        code: "WNZ",
        name: "Yongqiang intl",
        chineseName: "龙湾国际机场",
        traditionalName: "龍灣國際機場",
      },
    ],
  },
  WOL: {
    code: "WOL",
    name: "WOLLONGONG",
    chineseName: "伍伦贡",
    traditionalName: "伍倫貢",
    airports: [
      {
        code: "WOL",
        name: "Illawarra",
        chineseName: "伊拉瓦拉机场",
        traditionalName: "伊拉瓦拉機場",
      },
    ],
  },
  WOT: {
    code: "WOT",
    name: "WANG'AN",
    chineseName: "沃南",
    traditionalName: "沃南",
    airports: [
      {
        code: "WOT",
        name: "Wang'an airport",
        chineseName: "望安机场",
        traditionalName: "望安機場",
      },
    ],
  },
  WPR: {
    code: "WPR",
    name: "PORVENIR",
    chineseName: "波韦尼尔",
    traditionalName: "波韋尼爾",
    airports: [
      {
        code: "WPR",
        name: "Captain f. martinez",
        chineseName: "波韦尼尔机场",
        traditionalName: "波韋尼爾機場",
      },
    ],
  },
  WPU: {
    code: "WPU",
    name: "PUERTO WILLIAMS",
    chineseName: "威廉斯港",
    traditionalName: "威廉士港",
    airports: [
      {
        code: "WPU",
        name: "Guardiamarina zanartu",
        chineseName: "威廉斯港机场",
        traditionalName: "威廉士港機場",
      },
    ],
  },
  WRE: {
    code: "WRE",
    name: "WHANGAREI",
    chineseName: "旺阿雷",
    traditionalName: "旺阿雷",
    airports: [
      {
        code: "WRE",
        name: "Whangarei airport",
        chineseName: "旺阿雷机场",
        traditionalName: "旺阿雷機場",
      },
    ],
  },
  WRG: {
    code: "WRG",
    name: "WRANGELL",
    chineseName: "兰格尔",
    traditionalName: "蘭格爾",
    airports: [
      {
        code: "WRG",
        name: "Wrangell airport",
        chineseName: "兰格尔机场",
        traditionalName: "蘭格爾機場",
      },
    ],
  },
  WRO: {
    code: "WRO",
    name: "WROCLAW",
    chineseName: "弗罗莰瓦夫",
    traditionalName: "弗羅莰瓦夫",
    airports: [
      {
        code: "WRO",
        name: "Nicolaus copernicus",
        chineseName: "哥白尼机场",
        traditionalName: "哥白尼機場",
      },
    ],
  },
  WRZ: {
    code: "WRZ",
    name: "WEERAWILA",
    chineseName: "维拉维拉",
    traditionalName: "維拉維拉",
    airports: [
      {
        code: "WRZ",
        name: "Weerawila airport",
        chineseName: "维拉维拉机场",
        traditionalName: "維拉維拉機場",
      },
    ],
  },
  WSK: {
    code: "WSK",
    name: "WUSHAN",
    chineseName: "武山",
    traditionalName: "武山",
    airports: [
      {
        code: "WSK",
        name: "Chongqing",
        chineseName: "重庆巫山机场",
        traditionalName: "重慶巫山機場",
      },
    ],
  },
  WSN: {
    code: "WSN",
    name: "SOUTH NAKNEK",
    chineseName: "阿拉斯加州南纳克内克",
    traditionalName: "阿拉斯加州南納克內克",
    airports: [
      {
        code: "WSN",
        name: "South naknek airport",
        chineseName: "南纳克内克机场",
        traditionalName: "南納克內克機場",
      },
    ],
  },
  WST: {
    code: "WST",
    name: "WESTERLY",
    chineseName: "罗德岛州韦斯特利",
    traditionalName: "羅德島州韋斯特利",
    airports: [
      {
        code: "WST",
        name: "State",
        chineseName: "韦斯特利州立机场",
        traditionalName: "韋斯特利州立機場",
      },
    ],
  },
  WSZ: {
    code: "WSZ",
    name: "WESTPORT",
    chineseName: "韦斯特波特",
    traditionalName: "韋斯特波特",
    airports: [
      {
        code: "WSZ",
        name: "Westport airport",
        chineseName: "韦斯特波特机场",
        traditionalName: "韋斯特波特機場",
      },
    ],
  },
  WTE: {
    code: "WTE",
    name: "WOTJE ISLAND",
    chineseName: "沃杰",
    traditionalName: "沃傑",
    airports: [
      {
        code: "WTE",
        name: "Wotje island airport",
        chineseName: "沃杰机场",
        traditionalName: "沃傑機場",
      },
    ],
  },
  WTK: {
    code: "WTK",
    name: "NOATAK",
    chineseName: "诺阿塔克",
    traditionalName: "諾阿塔克",
    airports: [
      {
        code: "WTK",
        name: "Noatak airport",
        chineseName: "诺阿塔克机场",
        traditionalName: "諾阿塔克機場",
      },
    ],
  },
  WTL: {
    code: "WTL",
    name: "TUNTUTULIAK",
    chineseName: "阿拉斯加城市通图图利亚",
    traditionalName: "阿拉斯加都市通圖圖利亞",
    airports: [
      {
        code: "WTL",
        name: "Tuntutuliak airport",
        chineseName: "通图图里阿克机场",
        traditionalName: "通圖圖裡阿克機場",
      },
    ],
  },
  WTX: {
    code: "WTX",
    name: "WAY TUBA",
    chineseName: "Way Tuba",
    traditionalName: "Way Tuba",
    airports: [
      {
        code: "WTX",
        name: "Gatot subroto",
        chineseName: "Gatot Subroto机场",
        traditionalName: "Gatot Subroto機場",
      },
    ],
  },
  WTZ: {
    code: "WTZ",
    name: "WHITIANGA",
    chineseName: "维提安加",
    traditionalName: "維提安加",
    airports: [
      {
        code: "WTZ",
        name: "Whitianga airport",
        chineseName: "维提安加机场",
        traditionalName: "維提安加機場",
      },
    ],
  },
  WUA: {
    code: "WUA",
    name: "WUHAI",
    chineseName: "乌海",
    traditionalName: "烏海",
    airports: [
      {
        code: "WUA",
        name: "Wuhai airport",
        chineseName: "乌海机场",
        traditionalName: "烏海機場",
      },
    ],
  },
  WUH: {
    code: "WUH",
    name: "WUHAN",
    chineseName: "武汉",
    traditionalName: "武漢",
    airports: [
      {
        code: "WUH",
        name: "Tianhe intl",
        chineseName: "武汉天河国际机场",
        traditionalName: "武漢天河國際機場",
      },
    ],
  },
  WUN: {
    code: "WUN",
    name: "WILUNA",
    chineseName: "威卢纳",
    traditionalName: "威盧納",
    airports: [
      {
        code: "WUN",
        name: "Wiluna airport",
        chineseName: "威卢纳机场",
        traditionalName: "威盧納機場",
      },
    ],
  },
  WUS: {
    code: "WUS",
    name: "WUYISHAN",
    chineseName: "武夷山",
    traditionalName: "武夷山",
    airports: [
      {
        code: "WUS",
        name: "Wuyishan airport",
        chineseName: "武夷山机场",
        traditionalName: "武夷山機場",
      },
    ],
  },
  WUT: {
    code: "WUT",
    name: "XINZHOU",
    chineseName: "忻州",
    traditionalName: "忻州",
    airports: [
      {
        code: "WUT",
        name: "Xinzhou wutaishan",
        chineseName: "五台山机场",
        traditionalName: "五臺山機場",
      },
    ],
  },
  WUX: {
    code: "WUX",
    name: "WUXI",
    chineseName: "无锡",
    traditionalName: "無錫",
    airports: [
      {
        code: "WUX",
        name: "Sunan shuofang",
        chineseName: "苏南硕放国际机场",
        traditionalName: "蘇南碩放國際機場",
      },
    ],
  },
  WUZ: {
    code: "WUZ",
    name: "WUZHOU",
    chineseName: "梧州",
    traditionalName: "梧州",
    airports: [
      {
        code: "WUZ",
        name: "Xijiang",
        chineseName: "西江机场",
        traditionalName: "西江機場",
      },
    ],
  },
  WVB: {
    code: "WVB",
    name: "WALVIS BAY",
    chineseName: "沃尔维斯湾",
    traditionalName: "沃爾維斯灣",
    airports: [
      {
        code: "WVB",
        name: "Walvis bay airport",
        chineseName: "鲸湾港机场",
        traditionalName: "鯨灣港機場",
      },
    ],
  },
  WWK: {
    code: "WWK",
    name: "WEWAK",
    chineseName: "威瓦克",
    traditionalName: "威瓦克",
    airports: [
      {
        code: "WWK",
        name: "Wewak airport",
        chineseName: "博拉姆机场",
        traditionalName: "博拉姆機場",
      },
    ],
  },
  WWP: {
    code: "WWP",
    name: "WHALE PASS",
    chineseName: "韦尔帕斯",
    traditionalName: "韋爾帕斯",
    airports: [
      {
        code: "WWP",
        name: "North whale spb",
        chineseName: "诺斯韦尔水上飞机基地",
        traditionalName: "諾斯韋爾水上飛機基地",
      },
    ],
  },
  WWT: {
    code: "WWT",
    name: "NEWTOK",
    chineseName: "阿拉斯加州纽托克",
    traditionalName: "阿拉斯加州紐托克",
    airports: [
      {
        code: "WWT",
        name: "Newtok airport",
        chineseName: "纽特克机场",
        traditionalName: "紐特克機場",
      },
    ],
  },
  WXN: {
    code: "WXN",
    name: "WANZHOU",
    chineseName: "万州",
    traditionalName: "萬州",
    airports: [
      {
        code: "WXN",
        name: "Wuqiao",
        chineseName: "五桥机场",
        traditionalName: "五橋機場",
      },
    ],
  },
  WYA: {
    code: "WYA",
    name: "WHYALLA",
    chineseName: "怀阿拉",
    traditionalName: "懷阿拉",
    airports: [
      {
        code: "WYA",
        name: "Whyalla airport",
        chineseName: "怀阿拉机场",
        traditionalName: "懷阿拉機場",
      },
    ],
  },
  WYS: {
    code: "WYS",
    name: "WEST YELLOWSTONE",
    chineseName: "黄石",
    traditionalName: "黃石",
    airports: [
      {
        code: "WYS",
        name: "Yellowstone",
        chineseName: "西黄石机场",
        traditionalName: "西黃石機場",
      },
    ],
  },
  WZA: {
    code: "WZA",
    name: "WA",
    chineseName: "佤邦",
    traditionalName: "佤邦",
    airports: [
      {
        code: "WZA",
        name: "Wa airport",
        chineseName: "瓦城机场",
        traditionalName: "瓦城機場",
      },
    ],
  },
  XAI: {
    code: "XAI",
    name: "XINYANG",
    chineseName: "信阳",
    traditionalName: "信陽",
    airports: [
      {
        code: "XAI",
        name: "Minggang",
        chineseName: "明港机场",
        traditionalName: "明港機場",
      },
    ],
  },
  XAP: {
    code: "XAP",
    name: "CHAPECO",
    chineseName: "沙佩科",
    traditionalName: "沙佩科",
    airports: [
      {
        code: "XAP",
        name: "Serafin enoss bertaso",
        chineseName: "沙佩科机场",
        traditionalName: "沙佩科機場",
      },
    ],
  },
  XBE: {
    code: "XBE",
    name: "BEARSKIN LAKE",
    chineseName: "熊皮湖",
    traditionalName: "熊皮湖",
    airports: [
      {
        code: "XBE",
        name: "Bearskin lake airport",
        chineseName: "贝尔斯金莱克机场",
        traditionalName: "貝爾斯金萊克機場",
      },
    ],
  },
  XBJ: {
    code: "XBJ",
    name: "BIRJAND",
    chineseName: "比尔詹德",
    traditionalName: "比爾詹德",
    airports: [
      {
        code: "XBJ",
        name: "Birjand airport",
        chineseName: "比尔詹德机场",
        traditionalName: "比爾詹德機場",
      },
    ],
  },
  XCH: {
    code: "XCH",
    name: "CHRISTMAS ISLAND",
    chineseName: "圣诞岛",
    traditionalName: "聖誕島",
    airports: [
      {
        code: "XCH",
        name: "Christmas island airport",
        chineseName: "圣诞岛机场",
        traditionalName: "聖誕島機場",
      },
    ],
  },
  XFN: {
    code: "XFN",
    name: "XIANGYANG",
    chineseName: "襄阳",
    traditionalName: "襄陽",
    airports: [
      {
        code: "XFN",
        name: "Liuji",
        chineseName: "刘集机场",
        traditionalName: "劉集機場",
      },
    ],
  },
  XGR: {
    code: "XGR",
    name: "KANGIQSUALUJJUAQ",
    chineseName: "康吉克苏亚鲁具克",
    traditionalName: "康吉克蘇亞魯具克",
    airports: [
      {
        code: "XGR",
        name: "Georges river",
        chineseName: "坎基克苏阿鲁约克机场",
        traditionalName: "坎基克蘇阿魯約克機場",
      },
    ],
  },
  XIC: {
    code: "XIC",
    name: "XICHANG",
    chineseName: "西昌",
    traditionalName: "西昌",
    airports: [
      {
        code: "XIC",
        name: "Qingshan",
        chineseName: "青山机场",
        traditionalName: "青山機場",
      },
    ],
  },
  XIL: {
    code: "XIL",
    name: "XILINHOT",
    chineseName: "锡林浩特",
    traditionalName: "錫林浩特",
    airports: [
      {
        code: "XIL",
        name: "Xilinhot airport",
        chineseName: "锡林浩特机场",
        traditionalName: "錫林浩特機場",
      },
    ],
  },
  XKH: {
    code: "XKH",
    name: "PHONSAVAN",
    chineseName: "川圹",
    traditionalName: "川壙",
    airports: [
      {
        code: "XKH",
        name: "Xieng khouang",
        chineseName: "川圹机场",
        traditionalName: "川壙機場",
      },
    ],
  },
  XKS: {
    code: "XKS",
    name: "KASABONIKA",
    chineseName: "卡萨布尼卡",
    traditionalName: "卡薩布尼卡",
    airports: [
      {
        code: "XKS",
        name: "Kasabonika airport",
        chineseName: "卡萨布尼卡机场",
        traditionalName: "卡薩布尼卡機場",
      },
    ],
  },
  XMH: {
    code: "XMH",
    name: "MANIHI",
    chineseName: "马尼希",
    traditionalName: "馬尼希",
    airports: [
      {
        code: "XMH",
        name: "Manihi airport",
        chineseName: "马尼西机场",
        traditionalName: "馬尼西機場",
      },
    ],
  },
  XMN: {
    code: "XMN",
    name: "XIAMEN",
    chineseName: "厦门",
    traditionalName: "廈門",
    airports: [
      {
        code: "XMN",
        name: "Gaoqi intl",
        chineseName: "高崎国际机场",
        traditionalName: "高崎國際機場",
      },
    ],
  },
  XMY: {
    code: "XMY",
    name: "YAM ISLAND",
    chineseName: "雅姆岛",
    traditionalName: "雅姆島",
    airports: [
      {
        code: "XMY",
        name: "Yam island airport",
        chineseName: "雅姆岛机场",
        traditionalName: "雅姆島機場",
      },
    ],
  },
  XNN: {
    code: "XNN",
    name: "XINING",
    chineseName: "西宁",
    traditionalName: "西寧",
    airports: [
      {
        code: "XNN",
        name: "Caojiabao",
        chineseName: "曹家堡机场",
        traditionalName: "曹家堡機場",
      },
    ],
  },
  XNT: {
    code: "XNT",
    name: "XINGTAI",
    chineseName: "邢台",
    traditionalName: "邢臺",
    airports: [
      {
        code: "XNT",
        name: "Xingtai dalian",
        chineseName: "褡裢机场",
        traditionalName: "褡褳機場",
      },
    ],
  },
  XPK: {
    code: "XPK",
    name: "PUKATAWAGAN",
    chineseName: "普卡塔瓦干",
    traditionalName: "普卡塔瓦幹",
    airports: [
      {
        code: "XPK",
        name: "Pukatawagan airport",
        chineseName: "普卡塔瓦干机场",
        traditionalName: "普卡塔瓦幹機場",
      },
    ],
  },
  XQP: {
    code: "XQP",
    name: "QUEPOS",
    chineseName: "奎波斯",
    traditionalName: "奎波斯",
    airports: [
      {
        code: "XQP",
        name: "La managua",
        chineseName: "克波斯港机场",
        traditionalName: "克波斯港機場",
      },
    ],
  },
  XQU: {
    code: "XQU",
    name: "QUALICUM BEACH",
    chineseName: "夸利克姆",
    traditionalName: "誇利克姆",
    airports: [
      {
        code: "XQU",
        name: "Qualicum beach airport",
        chineseName: "夸利克姆机场",
        traditionalName: "誇利克姆機場",
      },
    ],
  },
  XRY: {
    code: "XRY",
    name: "JEREZ",
    chineseName: "赫雷斯-德拉弗龙特拉",
    traditionalName: "赫雷斯-德拉弗龍特拉",
    airports: [
      {
        code: "XRY",
        name: "Jerez airport",
        chineseName: "赫雷斯机场",
        traditionalName: "赫雷斯機場",
      },
    ],
  },
  XSC: {
    code: "XSC",
    name: "SOUTH CAICOS",
    chineseName: "凯科斯南部",
    traditionalName: "凱科斯南部",
    airports: [
      {
        code: "XSC",
        name: "South caicos intl.",
        chineseName: "南加各斯国际机场",
        traditionalName: "南加各斯國際機場",
      },
    ],
  },
  XTG: {
    code: "XTG",
    name: "THARGOMINDAH",
    chineseName: "塔尔戈明达",
    traditionalName: "塔爾戈明達",
    airports: [
      {
        code: "XTG",
        name: "Thargomindah airport",
        chineseName: "萨戈明达机场",
        traditionalName: "薩戈明達機場",
      },
    ],
  },
  XUZ: {
    code: "XUZ",
    name: "XUZHOU",
    chineseName: "徐州",
    traditionalName: "徐州",
    airports: [
      {
        code: "XUZ",
        name: "Guanyin",
        chineseName: "观音机场",
        traditionalName: "觀音機場",
      },
    ],
  },
  YAA: {
    code: "YAA",
    name: "ANAHIM LAKE",
    chineseName: "阿纳希姆湖",
    traditionalName: "阿納希姆湖",
    airports: [
      {
        code: "YAA",
        name: "Anahim lake airport",
        chineseName: "阿纳希姆莱克机场",
        traditionalName: "阿納希姆萊克機場",
      },
    ],
  },
  YAB: {
    code: "YAB",
    name: "ARCTIC BAY",
    chineseName: "北极湾城",
    traditionalName: "北極灣城",
    airports: [
      {
        code: "YAB",
        name: "Arctic bay airport",
        chineseName: "北极湾城机场",
        traditionalName: "北極灣城機場",
      },
    ],
  },
  YAC: {
    code: "YAC",
    name: "CAT LAKE",
    chineseName: "卡特莱克",
    traditionalName: "卡特萊克",
    airports: [
      {
        code: "YAC",
        name: "Cat lake airport",
        chineseName: "卡特莱克机场",
        traditionalName: "卡特萊克機場",
      },
    ],
  },
  YAG: {
    code: "YAG",
    name: "FORT FRANCES",
    chineseName: "弗朗西斯堡",
    traditionalName: "弗朗西斯堡",
    airports: [
      {
        code: "YAG",
        name: "Fort frances municipal",
        chineseName: "弗朗西斯堡地方机场",
        traditionalName: "弗朗西斯堡地方機場",
      },
    ],
  },
  YAJ: {
    code: "YAJ",
    name: "SATURNA ISLAND",
    chineseName: "里亚尔港",
    traditionalName: "裡亞爾港",
    airports: [
      {
        code: "YAJ",
        name: "Lyall harbour spb",
        chineseName: "里亚尔港机场",
        traditionalName: "裡亞爾港機場",
      },
    ],
  },
  YAK: {
    code: "YAK",
    name: "YAKUTAT",
    chineseName: "亚库塔特",
    traditionalName: "亞庫塔特",
    airports: [
      {
        code: "YAK",
        name: "Yakutat airport",
        chineseName: "亚库塔特机场",
        traditionalName: "亞庫塔特機場",
      },
    ],
  },
  YAM: {
    code: "YAM",
    name: "SAULT STE MARIE",
    chineseName: "苏圣玛丽",
    traditionalName: "蘇聖瑪麗",
    airports: [
      {
        code: "YAM",
        name: "Sault ste marie airport",
        chineseName: "苏圣玛丽机场",
        traditionalName: "蘇聖瑪麗機場",
      },
    ],
  },
  YAO: {
    code: "YAO",
    name: "YAOUNDE",
    chineseName: "雅温得",
    traditionalName: "雅恩德",
    airports: [
      {
        code: "NSI",
        name: "Nsimalen intl",
        chineseName: "希马伦国际机场",
        traditionalName: "希馬倫國際機場",
      },
    ],
  },
  YAP: {
    code: "YAP",
    name: "YAP",
    chineseName: "雅浦",
    traditionalName: "雅浦",
    airports: [
      {
        code: "YAP",
        name: "Yap intl.",
        chineseName: "雅浦群岛国际机场",
        traditionalName: "雅浦群島國際機場",
      },
    ],
  },
  YAQ: {
    code: "YAQ",
    name: "MAPLE BAY",
    chineseName: "枫树湾",
    traditionalName: "楓樹灣",
    airports: [
      {
        code: "YAQ",
        name: "Spb",
        chineseName: "梅普尔贝机场",
        traditionalName: "梅普爾貝機場",
      },
    ],
  },
  YAT: {
    code: "YAT",
    name: "ATTAWAPISKAT",
    chineseName: "阿塔瓦皮斯基特",
    traditionalName: "阿塔瓦皮斯基特",
    airports: [
      {
        code: "YAT",
        name: "Attawapiskat airport",
        chineseName: "阿塔瓦皮斯基特机场",
        traditionalName: "阿塔瓦皮斯基特機場",
      },
    ],
  },
  YAV: {
    code: "YAV",
    name: "MAYNE ISLAND",
    chineseName: "明纳斯贝",
    traditionalName: "明納斯貝",
    airports: [
      {
        code: "YAV",
        name: "Miners bay spb",
        chineseName: "明纳斯贝机场",
        traditionalName: "明納斯貝機場",
      },
    ],
  },
  YAX: {
    code: "YAX",
    name: "ANGLING LAKE",
    chineseName: "瓦佩卡",
    traditionalName: "瓦佩卡",
    airports: [
      {
        code: "YAX",
        name: "Wapekeka",
        chineseName: "昂格兰湖机场",
        traditionalName: "昂格蘭湖機場",
      },
    ],
  },
  YAY: {
    code: "YAY",
    name: "ST ANTHONY",
    chineseName: "圣安东尼",
    traditionalName: "聖安東尼",
    airports: [
      {
        code: "YAY",
        name: "St anthony airport",
        chineseName: "圣安东尼机场",
        traditionalName: "聖安東尼機場",
      },
    ],
  },
  YAZ: {
    code: "YAZ",
    name: "TOFINO",
    chineseName: "托菲诺",
    traditionalName: "托菲諾",
    airports: [
      {
        code: "YAZ",
        name: "Long beach",
        chineseName: "托菲诺机场",
        traditionalName: "托菲諾機場",
      },
      {
        code: "YTP",
        name: "Harbour spb",
        chineseName: "托菲诺水上飞机基地",
        traditionalName: "托菲諾水上飛機基地",
      },
    ],
  },
  YBB: {
    code: "YBB",
    name: "KUGAARUK",
    chineseName: "佩利贝",
    traditionalName: "佩利貝",
    airports: [
      {
        code: "YBB",
        name: "Kugaaruk airport",
        chineseName: "库加鲁克机场",
        traditionalName: "庫加魯克機場",
      },
    ],
  },
  YBC: {
    code: "YBC",
    name: "BAIE-COMEAU",
    chineseName: "贝科莫",
    traditionalName: "貝科莫",
    airports: [
      {
        code: "YBC",
        name: "Baie-comeau airport",
        chineseName: "贝克莫机场",
        traditionalName: "貝克莫機場",
      },
    ],
  },
  YBE: {
    code: "YBE",
    name: "URANIUM CITY",
    chineseName: "铀城",
    traditionalName: "鈾城",
    airports: [
      {
        code: "YBE",
        name: "Uranium city airport",
        chineseName: "铀城机场",
        traditionalName: "鈾城機場",
      },
    ],
  },
  YBG: {
    code: "YBG",
    name: "SAGUENAY-BAGOTVILLE",
    chineseName: "巴戈特维尔",
    traditionalName: "巴戈特維爾",
    airports: [
      {
        code: "YBG",
        name: "Saguenay-bagotville airport",
        chineseName: "巴戈特维尔机场",
        traditionalName: "巴戈特維爾機場",
      },
    ],
  },
  YBI: {
    code: "YBI",
    name: "BLACK TICKLE",
    chineseName: "贝勒克体克",
    traditionalName: "貝勒克體克",
    airports: [
      {
        code: "YBI",
        name: "Black tickle airport",
        chineseName: "贝勒克体克机场",
        traditionalName: "貝勒克體克機場",
      },
    ],
  },
  YBK: {
    code: "YBK",
    name: "BAKER LAKE",
    chineseName: "贝克湖",
    traditionalName: "貝克湖",
    airports: [
      {
        code: "YBK",
        name: "Baker lake airport",
        chineseName: "贝克湖机场",
        traditionalName: "貝克湖機場",
      },
    ],
  },
  YBL: {
    code: "YBL",
    name: "CAMPBELL RIVER",
    chineseName: "坎贝尔里弗",
    traditionalName: "坎貝爾裏弗",
    airports: [
      {
        code: "YBL",
        name: "Campbell river airport",
        chineseName: "坎贝尔里弗机场",
        traditionalName: "坎貝爾裏弗機場",
      },
    ],
  },
  YBP: {
    code: "YBP",
    name: "YIBIN",
    chineseName: "宜宾",
    traditionalName: "宜賓",
    airports: [
      {
        code: "YBP",
        name: "Wuliangye airport",
        chineseName: "五粮液机场",
        traditionalName: "五糧液機場",
      },
    ],
  },
  YBQ: {
    code: "YBQ",
    name: "THETIS ISLAND",
    chineseName: "特雷格拉夫港",
    traditionalName: "特雷格拉夫港",
    airports: [
      {
        code: "YBQ",
        name: "Telegraph harbour spb",
        chineseName: "特雷格拉夫港机场",
        traditionalName: "特雷格拉夫港機場",
      },
    ],
  },
  YBR: {
    code: "YBR",
    name: "BRANDON",
    chineseName: "布兰登",
    traditionalName: "布蘭登",
    airports: [
      {
        code: "YBR",
        name: "Brandon municipal",
        chineseName: "布兰登机场",
        traditionalName: "布蘭登機場",
      },
    ],
  },
  YBV: {
    code: "YBV",
    name: "BERENS RIVER",
    chineseName: "贝伦斯里弗",
    traditionalName: "貝倫斯裏弗",
    airports: [
      {
        code: "YBV",
        name: "Berens river airport",
        chineseName: "贝伦斯河机场",
        traditionalName: "貝倫斯河機場",
      },
    ],
  },
  YBX: {
    code: "YBX",
    name: "BLANC-SABLON",
    chineseName: "布兰科萨布隆",
    traditionalName: "布蘭科薩布隆",
    airports: [
      {
        code: "YBX",
        name: "Lourdes-de-blancsablon",
        chineseName: "卢尔德布朗萨布隆机场",
        traditionalName: "盧爾德布朗薩布隆機場",
      },
    ],
  },
  YCB: {
    code: "YCB",
    name: "CAMBRIDGE BAY",
    chineseName: " 剑桥湾镇",
    traditionalName: "劍橋灣鎮",
    airports: [
      {
        code: "YCB",
        name: "Cambridge bay airport",
        chineseName: "坎布里奇贝机场",
        traditionalName: "坎布裏奇貝機場",
      },
    ],
  },
  YCD: {
    code: "YCD",
    name: "NANAIMO",
    chineseName: "纳奈莫",
    traditionalName: "納奈莫",
    airports: [
      {
        code: "YCD",
        name: "Nanaimo airport",
        chineseName: "纳奈莫机场",
        traditionalName: "納奈莫機場",
      },
      {
        code: "ZNA",
        name: "Harbour spb",
        chineseName: "纳奈莫港水上机场",
        traditionalName: "納奈莫港水上機場",
      },
    ],
  },
  YCG: {
    code: "YCG",
    name: "CASTLEGAR",
    chineseName: "卡斯尔加",
    traditionalName: "卡斯爾加",
    airports: [
      {
        code: "YCG",
        name: "West kootenay regional",
        chineseName: "西库特尼地区机场",
        traditionalName: "西庫特尼地區機場",
      },
    ],
  },
  YCK: {
    code: "YCK",
    name: "COLVILLE LAKE",
    chineseName: "科尔维尔湖",
    traditionalName: "科爾維爾湖",
    airports: [
      {
        code: "YCK",
        name: "Tommy kochon",
        chineseName: "科尔维尔湖机场",
        traditionalName: "科爾維爾湖機場",
      },
    ],
  },
  YCO: {
    code: "YCO",
    name: "KUGLUKTUK",
    chineseName: "努那福特",
    traditionalName: "努那福特",
    airports: [
      {
        code: "YCO",
        name: "Kugluktuk airport",
        chineseName: "库格卢克图克机场",
        traditionalName: "庫格盧克圖克機場",
      },
    ],
  },
  YCS: {
    code: "YCS",
    name: "CHESTERFIELD INLET",
    chineseName: "切斯特菲尔德因莱特",
    traditionalName: "切斯特菲爾德因萊特",
    airports: [
      {
        code: "YCS",
        name: "Chesterfield inlet airport",
        chineseName: "切斯特菲尔德因莱特机场",
        traditionalName: "賈斯特菲爾德因萊特機場",
      },
    ],
  },
  YCU: {
    code: "YCU",
    name: "YUNCHENG",
    chineseName: "运城",
    traditionalName: "運城",
    airports: [
      {
        code: "YCU",
        name: "Guangong",
        chineseName: "盐湖国际机场",
        traditionalName: "鹽湖國際機場",
      },
    ],
  },
  YCY: {
    code: "YCY",
    name: "CLYDE RIVER",
    chineseName: "克莱德河",
    traditionalName: "克萊德河",
    airports: [
      {
        code: "YCY",
        name: "Clyde river airport",
        chineseName: "克莱德河机场",
        traditionalName: "克萊德河機場",
      },
    ],
  },
  YDA: {
    code: "YDA",
    name: "DAWSON CITY",
    chineseName: "道森",
    traditionalName: "道森",
    airports: [
      {
        code: "YDA",
        name: "Dawson city airport",
        chineseName: "道森市机场",
        traditionalName: "道森市機場",
      },
    ],
  },
  YDF: {
    code: "YDF",
    name: "DEER LAKE",
    chineseName: "鹿湖",
    traditionalName: "鹿湖",
    airports: [
      {
        code: "YDF",
        name: "Deer lake reg. airport",
        chineseName: "鹿湖地区机场",
        traditionalName: "鹿湖地區機場",
      },
    ],
  },
  YDP: {
    code: "YDP",
    name: "NAIN",
    chineseName: "纳因",
    traditionalName: "納因",
    airports: [
      {
        code: "YDP",
        name: "Nain airport",
        chineseName: "内恩机场",
        traditionalName: "內恩機場",
      },
    ],
  },
  YDV: {
    code: "YDV",
    name: "BLOODVEIN",
    chineseName: "布拉德韦恩",
    traditionalName: "布拉德韋恩",
    airports: [
      {
        code: "YDV",
        name: "Bloodvein river",
        chineseName: "布拉德韦恩.机场",
        traditionalName: "布拉德韋恩. 機場",
      },
    ],
  },
  YEA: {
    code: "YEA",
    name: "EDMONTON",
    chineseName: "埃德蒙顿",
    traditionalName: "埃德蒙頓",
    airports: [
      {
        code: "YEG",
        name: "Edmonton intl.",
        chineseName: "埃德蒙顿国际机场",
        traditionalName: "埃德蒙頓國際機場",
      },
    ],
  },
  YEI: {
    code: "YEI",
    name: "BURSA",
    chineseName: "布尔萨",
    traditionalName: "布爾薩",
    airports: [
      {
        code: "YEI",
        name: "Yenisehir",
        chineseName: "耶尼塞希尔机场",
        traditionalName: "耶尼塞希爾機場",
      },
    ],
  },
  YEK: {
    code: "YEK",
    name: "ARVIAT",
    chineseName: "阿维亚特",
    traditionalName: "阿維亞特",
    airports: [
      {
        code: "YEK",
        name: "Arviat airport",
        chineseName: "阿维亚特机场",
        traditionalName: "阿維亞特機場",
      },
    ],
  },
  YER: {
    code: "YER",
    name: "FORT SEVERN",
    chineseName: "塞文堡",
    traditionalName: "塞文堡",
    airports: [
      {
        code: "YER",
        name: "Fort severn airport",
        chineseName: "塞文堡机场",
        traditionalName: "塞文堡機場",
      },
    ],
  },
  YES: {
    code: "YES",
    name: "YASOUJ",
    chineseName: "雅索吉",
    traditionalName: "雅索吉",
    airports: [
      {
        code: "YES",
        name: "Yasouj airport",
        chineseName: "雅索吉机场",
        traditionalName: "雅索吉機場",
      },
    ],
  },
  YEV: {
    code: "YEV",
    name: "INUVIK",
    chineseName: "伊努维克",
    traditionalName: "伊努維克",
    airports: [
      {
        code: "YEV",
        name: "Mike zubko",
        chineseName: "伊努维克/麦克祖博克机场",
        traditionalName: "伊努維克/麥克祖博克機場",
      },
    ],
  },
  YFA: {
    code: "YFA",
    name: "FORT ALBANY",
    chineseName: "奥尔巴尼堡",
    traditionalName: "奧爾巴尼堡",
    airports: [
      {
        code: "YFA",
        name: "Fort albany airport",
        chineseName: "奥尔巴尼堡机场",
        traditionalName: "奧爾巴尼堡機場",
      },
    ],
  },
  YFB: {
    code: "YFB",
    name: "IQALUIT",
    chineseName: "伊卡卢伊特",
    traditionalName: "伊卡盧伊特",
    airports: [
      {
        code: "YFB",
        name: "Iqaluit airport",
        chineseName: "伊卡卢伊特机场",
        traditionalName: "伊卡盧伊特機場",
      },
    ],
  },
  YFC: {
    code: "YFC",
    name: "FREDERICTON",
    chineseName: "弗雷德里顿",
    traditionalName: "弗雷德里頓",
    airports: [
      {
        code: "YFC",
        name: "Fredericton intl.",
        chineseName: "弗雷德里克顿机场",
        traditionalName: "弗雷德裏克頓機場",
      },
    ],
  },
  YFH: {
    code: "YFH",
    name: "FORT HOPE",
    chineseName: "霍普堡",
    traditionalName: "霍普堡",
    airports: [
      {
        code: "YFH",
        name: "Fort hope airport",
        chineseName: "霍普堡机场",
        traditionalName: "霍普堡機場",
      },
    ],
  },
  YFJ: {
    code: "YFJ",
    name: "WEKWEETI",
    chineseName: "斯奈尔湖",
    traditionalName: "斯奈爾湖",
    airports: [
      {
        code: "YFJ",
        name: "Wekweeti airport",
        chineseName: "斯内克湖机场",
        traditionalName: "斯內克湖機場",
      },
    ],
  },
  YFO: {
    code: "YFO",
    name: "FLIN FLON",
    chineseName: "弗林弗伦",
    traditionalName: "弗林弗倫",
    airports: [
      {
        code: "YFO",
        name: "Flin flon airport",
        chineseName: "弗林弗伦机场",
        traditionalName: "弗林弗倫機場",
      },
    ],
  },
  YFS: {
    code: "YFS",
    name: "FORT SIMPSON",
    chineseName: "辛普森堡",
    traditionalName: "辛普森堡",
    airports: [
      {
        code: "YFS",
        name: "Fort simpson airport",
        chineseName: "辛普森堡机场",
        traditionalName: "辛普森堡機場",
      },
    ],
  },
  YGG: {
    code: "YGG",
    name: "GANGES",
    chineseName: "甘吉斯港",
    traditionalName: "甘吉斯港",
    airports: [
      {
        code: "YGG",
        name: "Spb",
        chineseName: "岗日港机场",
        traditionalName: "崗日港機場",
      },
    ],
  },
  YGH: {
    code: "YGH",
    name: "FORT GOOD HOPE",
    chineseName: "好望堡",
    traditionalName: "好望堡",
    airports: [
      {
        code: "YGH",
        name: "Fort good hope airport",
        chineseName: "好望堡机场",
        traditionalName: "好望堡機場",
      },
    ],
  },
  YGJ: {
    code: "YGJ",
    name: "YONAGO",
    chineseName: "米子",
    traditionalName: "米子",
    airports: [
      {
        code: "YGJ",
        name: "Miho",
        chineseName: "米子鬼太郎机场",
        traditionalName: "米子鬼太郎機場",
      },
    ],
  },
  YGL: {
    code: "YGL",
    name: "LA GRANDE RIVIERE",
    chineseName: "拉格兰奇",
    traditionalName: "拉格蘭奇",
    airports: [
      {
        code: "YGL",
        name: "La grande riviere airport",
        chineseName: "拉格兰奇机场",
        traditionalName: "拉格蘭奇機場",
      },
    ],
  },
  YGO: {
    code: "YGO",
    name: "GODS LAKE NARROWS",
    chineseName: "戈兹纳罗斯",
    traditionalName: "戈茲納羅斯",
    airports: [
      {
        code: "YGO",
        name: "Gods lake narrows airport",
        chineseName: "戈兹纳罗斯机场",
        traditionalName: "戈茲納羅斯機場",
      },
    ],
  },
  YGP: {
    code: "YGP",
    name: "GASPE",
    chineseName: "加斯佩",
    traditionalName: "加斯佩",
    airports: [
      {
        code: "YGP",
        name: "Michel-pouliot",
        chineseName: "米歇尔-包利华机场",
        traditionalName: "蜜雪兒-包利華機場",
      },
    ],
  },
  YGR: {
    code: "YGR",
    name: "ILES DE LA MADELEINE",
    chineseName: "麦迪兰",
    traditionalName: "麥迪蘭",
    airports: [
      {
        code: "YGR",
        name: "Iles de la madeleine airport",
        chineseName: "迈迪兰岛机场",
        traditionalName: "邁迪蘭島機場",
      },
    ],
  },
  YGT: {
    code: "YGT",
    name: "IGLOOLIK",
    chineseName: "伊格卢利克",
    traditionalName: "伊格盧利克",
    airports: [
      {
        code: "YGT",
        name: "Igloolik airport",
        chineseName: "伊格卢利克机场",
        traditionalName: "伊格盧利克機場",
      },
    ],
  },
  YGV: {
    code: "YGV",
    name: "HAVRE-ST-PIERRE",
    chineseName: "哈福雷圣皮埃尔",
    traditionalName: "哈福雷聖皮埃爾",
    airports: [
      {
        code: "YGV",
        name: "Havre-st-pierre airport",
        chineseName: "圣皮埃尔港机场",
        traditionalName: "聖皮爾港機場",
      },
    ],
  },
  YGW: {
    code: "YGW",
    name: "KUUJJUARAPIK",
    chineseName: "库朱瓦拉皮克",
    traditionalName: "庫朱瓦拉皮克",
    airports: [
      {
        code: "YGW",
        name: "Kuujjuarapik airport",
        chineseName: "库居阿尔阿皮克机场",
        traditionalName: "庫居阿爾阿皮克機場",
      },
    ],
  },
  YGX: {
    code: "YGX",
    name: "GILLAM",
    chineseName: "吉勒姆",
    traditionalName: "吉勒姆",
    airports: [
      {
        code: "YGX",
        name: "Gillam airport",
        chineseName: "吉勒姆机场",
        traditionalName: "吉勒姆機場",
      },
    ],
  },
  YGZ: {
    code: "YGZ",
    name: "GRISE FIORD",
    chineseName: "格赖斯菲约德",
    traditionalName: "格賴斯菲約德",
    airports: [
      {
        code: "YGZ",
        name: "Grise fiord airport",
        chineseName: "格莱斯峡湾机场",
        traditionalName: "格萊斯峽灣機場",
      },
    ],
  },
  YHD: {
    code: "YHD",
    name: "DRYDEN",
    chineseName: "德莱登",
    traditionalName: "德萊登",
    airports: [
      {
        code: "YHD",
        name: "Dryden reg. airport",
        chineseName: "德莱登地方机场",
        traditionalName: "德萊登地方機場",
      },
    ],
  },
  YHI: {
    code: "YHI",
    name: "ULUKHAKTOK",
    chineseName: "霍尔曼",
    traditionalName: "霍爾曼",
    airports: [
      {
        code: "YHI",
        name: "Ulukhaktok airport",
        chineseName: "霍尔曼机场",
        traditionalName: "霍爾曼機場",
      },
    ],
  },
  YHK: {
    code: "YHK",
    name: "GJOA HAVEN",
    chineseName: "约阿港",
    traditionalName: "約阿港",
    airports: [
      {
        code: "YHK",
        name: "Gjoa haven airport",
        chineseName: "约阿港机场",
        traditionalName: "約阿港機場",
      },
    ],
  },
  YHN: {
    code: "YHN",
    name: "HORNEPAYNE",
    chineseName: "霍恩佩恩",
    traditionalName: "霍恩佩恩",
    airports: [
      {
        code: "YHN",
        name: "Hornepayne municipal",
        chineseName: "霍恩佩恩机场",
        traditionalName: "霍恩佩恩機場",
      },
    ],
  },
  YHO: {
    code: "YHO",
    name: "HOPEDALE",
    chineseName: "霍普代尔",
    traditionalName: "霍普代爾",
    airports: [
      {
        code: "YHO",
        name: "Hopedale airport",
        chineseName: "霍普代尔机场",
        traditionalName: "霍普代爾機場",
      },
    ],
  },
  YHP: {
    code: "YHP",
    name: "POPLAR HILL",
    chineseName: "杨树山",
    traditionalName: "楊樹山",
    airports: [
      {
        code: "YHP",
        name: "Poplar hill airport",
        chineseName: "杨树山机场",
        traditionalName: "楊樹山機場",
      },
    ],
  },
  YHR: {
    code: "YHR",
    name: "CHEVERY",
    chineseName: "切贝利",
    traditionalName: "切貝利",
    airports: [
      {
        code: "YHR",
        name: "Chevery airport",
        chineseName: "切弗里机场",
        traditionalName: "切弗裡機場",
      },
    ],
  },
  YHS: {
    code: "YHS",
    name: "SECHELT",
    chineseName: "瑟切尔特",
    traditionalName: "瑟切爾特",
    airports: [
      {
        code: "YHS",
        name: "Sechelt airport",
        chineseName: "瑟切尔特机场",
        traditionalName: "瑟切爾特機場",
      },
    ],
  },
  YHY: {
    code: "YHY",
    name: "HAY RIVER",
    chineseName: "海伊里弗",
    traditionalName: "海伊裏弗",
    airports: [
      {
        code: "YHY",
        name: "Merlyn carter",
        chineseName: "海伊里弗机场",
        traditionalName: "海伊裏弗機場",
      },
    ],
  },
  YHZ: {
    code: "YHZ",
    name: "HALIFAX",
    chineseName: "哈利法克斯",
    traditionalName: "哈利法克斯",
    airports: [
      {
        code: "YHZ",
        name: "Stanfield intl",
        chineseName: "斯坦菲尔德国际机场",
        traditionalName: "斯坦菲爾德國際機場",
      },
    ],
  },
  YIC: {
    code: "YIC",
    name: "YICHUN (JIANGXI)",
    chineseName: "宜春",
    traditionalName: "宜春",
    airports: [
      {
        code: "YIC",
        name: "Mingyueshan",
        chineseName: "明月山机场",
        traditionalName: "明月山機場",
      },
    ],
  },
  YIE: {
    code: "YIE",
    name: "AERSHAN",
    chineseName: "阿尔山",
    traditionalName: "阿爾山",
    airports: [
      {
        code: "YIE",
        name: "Yiershi",
        chineseName: "伊尔施机场",
        traditionalName: "伊爾施機場",
      },
    ],
  },
  YIF: {
    code: "YIF",
    name: "ST-AUGUSTIN/PAKUASHIPI",
    chineseName: "帕夸什皮",
    traditionalName: "帕誇什皮",
    airports: [
      {
        code: "YIF",
        name: "St-augustin/pakuashipi airport",
        chineseName: "帕库阿西皮机场",
        traditionalName: "帕庫阿西皮機場",
      },
    ],
  },
  YIH: {
    code: "YIH",
    name: "YICHANG",
    chineseName: "宜昌",
    traditionalName: "宜昌",
    airports: [
      {
        code: "YIH",
        name: "Sanxia",
        chineseName: "三峡机场",
        traditionalName: "三峽機場",
      },
    ],
  },
  YIK: {
    code: "YIK",
    name: "IVUJIVIK",
    chineseName: "伊乌吉维克",
    traditionalName: "伊烏吉維克",
    airports: [
      {
        code: "YIK",
        name: "Ivujivik airport",
        chineseName: "伊乌吉维克机场",
        traditionalName: "伊烏吉維克機場",
      },
    ],
  },
  YIN: {
    code: "YIN",
    name: "YINING",
    chineseName: "伊宁",
    traditionalName: "伊寧",
    airports: [
      {
        code: "YIN",
        name: "Yining airport",
        chineseName: "伊宁机场",
        traditionalName: "伊寧機場",
      },
    ],
  },
  YIO: {
    code: "YIO",
    name: "POND INLET",
    chineseName: "庞德因莱特",
    traditionalName: "龐德因萊特",
    airports: [
      {
        code: "YIO",
        name: "Pond inlet airport",
        chineseName: "庞德因莱特机场",
        traditionalName: "龐德因萊特機場",
      },
    ],
  },
  YIV: {
    code: "YIV",
    name: "ISLAND LK/GARDEN HILL",
    chineseName: "艾兰湖",
    traditionalName: "艾蘭湖",
    airports: [
      {
        code: "YIV",
        name: "Island lk/garden hill airport",
        chineseName: "艾兰湖/加登希尔机场",
        traditionalName: "艾蘭湖/加登希爾機場",
      },
    ],
  },
  YIW: {
    code: "YIW",
    name: "YIWU",
    chineseName: "义乌",
    traditionalName: "義烏",
    airports: [
      {
        code: "YIW",
        name: "Yiwu airport",
        chineseName: "义乌机场",
        traditionalName: "義烏機場",
      },
    ],
  },
  YKA: {
    code: "YKA",
    name: "KAMLOOPS",
    chineseName: "坎卢普斯",
    traditionalName: "坎盧普斯",
    airports: [
      {
        code: "YKA",
        name: "Kamloops airport",
        chineseName: "坎卢普斯机场",
        traditionalName: "坎盧普斯機場",
      },
    ],
  },
  YKG: {
    code: "YKG",
    name: "KANGIRSUK",
    chineseName: "康吉苏克",
    traditionalName: "康吉蘇克",
    airports: [
      {
        code: "YKG",
        name: "Kangirsuk airport",
        chineseName: "坎基尔苏克机场",
        traditionalName: "坎基爾蘇克機場",
      },
    ],
  },
  YKH: {
    code: "YKH",
    name: "YINGKOU",
    chineseName: "营口",
    traditionalName: "營口",
    airports: [
      {
        code: "YKH",
        name: "Yingkou airport",
        chineseName: "兰旗机场",
        traditionalName: "蘭旗機場",
      },
    ],
  },
  YKL: {
    code: "YKL",
    name: "SCHEFFERVILLE",
    chineseName: "谢弗维尔",
    traditionalName: "謝弗維爾",
    airports: [
      {
        code: "YKL",
        name: "Schefferville airport",
        chineseName: "谢弗维尔机场",
        traditionalName: "謝弗維爾機場",
      },
    ],
  },
  YKM: {
    code: "YKM",
    name: "YAKIMA",
    chineseName: "亚基马",
    traditionalName: "亞基馬",
    airports: [
      {
        code: "YKM",
        name: "Air terminal",
        chineseName: "亚基马机场",
        traditionalName: "亞基馬機場",
      },
    ],
  },
  YKO: {
    code: "YKO",
    name: "HAKKARI",
    chineseName: "哈卡里",
    traditionalName: "哈卡裡",
    airports: [
      {
        code: "YKO",
        name: "Yuksekova",
        chineseName: "于克塞科瓦机场",
        traditionalName: "於克塞科瓦機場",
      },
    ],
  },
  YKQ: {
    code: "YKQ",
    name: "WASKAGANISH",
    chineseName: "瓦斯卡加尼什",
    traditionalName: "瓦斯卡加尼什",
    airports: [
      {
        code: "YKQ",
        name: "Waskaganish airport",
        chineseName: "瓦斯卡加尼什机场",
        traditionalName: "瓦斯卡加尼什機場",
      },
    ],
  },
  YKS: {
    code: "YKS",
    name: "YAKUTSK",
    chineseName: "雅库茨克",
    traditionalName: "亞庫次克",
    airports: [
      {
        code: "YKS",
        name: "Yakutsk airport",
        chineseName: "雅库茨克机场",
        traditionalName: "亞庫次克機場",
      },
    ],
  },
  YKU: {
    code: "YKU",
    name: "CHISASIBI",
    chineseName: "齐萨斯比",
    traditionalName: "齊薩斯比",
    airports: [
      {
        code: "YKU",
        name: "Chisasibi airport",
        chineseName: "奇萨希比机场",
        traditionalName: "奇薩希比機場",
      },
    ],
  },
  YLC: {
    code: "YLC",
    name: "KIMMIRUT",
    chineseName: "金米莱特",
    traditionalName: "金米萊特",
    airports: [
      {
        code: "YLC",
        name: "Kimmirut airport",
        chineseName: "金米莱特机场",
        traditionalName: "金米萊特機場",
      },
    ],
  },
  YLE: {
    code: "YLE",
    name: "WHATI",
    chineseName: "化提/拉科拉马特尔",
    traditionalName: "化提/拉科拉馬特爾",
    airports: [
      {
        code: "YLE",
        name: "Whati airport",
        chineseName: "化提机场",
        traditionalName: "化提機場",
      },
    ],
  },
  YLH: {
    code: "YLH",
    name: "LANSDOWNE HOUSE",
    chineseName: "兰斯当豪斯",
    traditionalName: "蘭斯當豪斯",
    airports: [
      {
        code: "YLH",
        name: "Lansdowne house airport",
        chineseName: "兰斯当豪斯机场",
        traditionalName: "蘭斯當豪斯機場",
      },
    ],
  },
  YLW: {
    code: "YLW",
    name: "KELOWNA",
    chineseName: "基隆拿",
    traditionalName: "基隆拿",
    airports: [
      {
        code: "YLW",
        name: "Kelowna intl.",
        chineseName: "基洛纳国际机场",
        traditionalName: "基洛納國際機場",
      },
    ],
  },
  YLX: {
    code: "YLX",
    name: "YULIN - GUANGXI",
    chineseName: "广西玉林",
    traditionalName: "廣西玉林",
    airports: [
      {
        code: "YLX",
        name: "Fumian",
        chineseName: "玉林福绵机场",
        traditionalName: "玉林福綿機場",
      },
    ],
  },
  YMF: {
    code: "YMF",
    name: "GALIANO ISLAND",
    chineseName: "蒙塔格讷港",
    traditionalName: "蒙塔格訥港",
    airports: [
      {
        code: "YMF",
        name: "Montague harbour spb",
        chineseName: "蒙塔格讷港机场",
        traditionalName: "蒙塔格訥港機場",
      },
    ],
  },
  YMM: {
    code: "YMM",
    name: "FORT MCMURRAY",
    chineseName: "麦克默里堡",
    traditionalName: "麥克默裏堡",
    airports: [
      {
        code: "YMM",
        name: "Fort mcmurray apt",
        chineseName: "麦克默里堡机场",
        traditionalName: "麥克默裏堡機場",
      },
    ],
  },
  YMN: {
    code: "YMN",
    name: "MAKKOVIK",
    chineseName: "马库维克",
    traditionalName: "馬庫維克",
    airports: [
      {
        code: "YMN",
        name: "Makkovik airport",
        chineseName: "马库维克机场",
        traditionalName: "馬庫維克機場",
      },
    ],
  },
  YMO: {
    code: "YMO",
    name: "MOOSONEE",
    chineseName: "穆索尼",
    traditionalName: "穆索尼",
    airports: [
      {
        code: "YMO",
        name: "Moosonee airport",
        chineseName: "穆索尼机场",
        traditionalName: "穆索尼機場",
      },
    ],
  },
  YMQ: {
    code: "YMQ",
    name: "MONTREAL",
    chineseName: "蒙特利尔",
    traditionalName: "蒙特利爾",
    airports: [
      {
        code: "YHU",
        name: "St-hubert",
        chineseName: "圣胡博特机场",
        traditionalName: "聖胡博特機場",
      },
      {
        code: "YMX",
        name: "Mirabel intl",
        chineseName: "米拉贝尔国际机场",
        traditionalName: "米拉貝爾國際機場",
      },
      {
        code: "YUL",
        name: "Pierre e.trudeau intl",
        chineseName: "特鲁多国际机场",
        traditionalName: "特魯多國際機場",
      },
    ],
  },
  YMT: {
    code: "YMT",
    name: "CHIBOUGAMAU",
    chineseName: "希布加莫",
    traditionalName: "希布加莫",
    airports: [
      {
        code: "YMT",
        name: "Chapais",
        chineseName: "希布加莫机场",
        traditionalName: "希布加莫機場",
      },
    ],
  },
  YNA: {
    code: "YNA",
    name: "NATASHQUAN",
    chineseName: "纳塔什昆",
    traditionalName: "納塔什昆",
    airports: [
      {
        code: "YNA",
        name: "Natashquan airport",
        chineseName: "纳塔什昆机场",
        traditionalName: "納塔什昆機場",
      },
    ],
  },
  YNB: {
    code: "YNB",
    name: "YANBU AL BAHR",
    chineseName: "延布",
    traditionalName: "延布",
    airports: [
      {
        code: "YNB",
        name: "Yanbu al bahr airport",
        chineseName: "延布机场",
        traditionalName: "延布機場",
      },
    ],
  },
  YNC: {
    code: "YNC",
    name: "WEMINDJI",
    chineseName: "维明吉",
    traditionalName: "維明吉",
    airports: [
      {
        code: "YNC",
        name: "Wemindji airport",
        chineseName: "维明吉机场",
        traditionalName: "維明吉機場",
      },
    ],
  },
  YNJ: {
    code: "YNJ",
    name: "YANJI",
    chineseName: "延吉",
    traditionalName: "延吉",
    airports: [
      {
        code: "YNJ",
        name: "Chaoyangchuan",
        chineseName: "朝阳川机场",
        traditionalName: "朝陽川機場",
      },
    ],
  },
  YNL: {
    code: "YNL",
    name: "POINTS NORTH LANDING",
    chineseName: "波因茨诺思兰丁",
    traditionalName: "波因茨諾思蘭丁",
    airports: [
      {
        code: "YNL",
        name: "Points north landing airport",
        chineseName: "波因茨诺思兰丁机场",
        traditionalName: "波因茨諾思蘭丁機場",
      },
    ],
  },
  YNO: {
    code: "YNO",
    name: "NORTH SPIRIT LAKE",
    chineseName: "诺斯比里特湖",
    traditionalName: "諾斯比裏特湖",
    airports: [
      {
        code: "YNO",
        name: "North spirit lake airport",
        chineseName: "诺斯比里特湖机场",
        traditionalName: "諾斯比裏特湖機場",
      },
    ],
  },
  YNP: {
    code: "YNP",
    name: "NATUASHISH",
    chineseName: "纳图阿舍什",
    traditionalName: "納圖阿舍什",
    airports: [
      {
        code: "YNP",
        name: "Natuashish airport",
        chineseName: "纳图啊希什机场",
        traditionalName: "納圖啊希什機場",
      },
    ],
  },
  YNS: {
    code: "YNS",
    name: "NEMISCAU",
    chineseName: "内米斯卡",
    traditionalName: "內米斯卡",
    airports: [
      {
        code: "YNS",
        name: "Nemiscau airport",
        chineseName: "内米斯卡机场",
        traditionalName: "內米斯卡機場",
      },
    ],
  },
  YNT: {
    code: "YNT",
    name: "YANTAI",
    chineseName: "烟台",
    traditionalName: "煙臺",
    airports: [
      {
        code: "YNT",
        name: "Penglai intl",
        chineseName: "蓬莱国际机场",
        traditionalName: "蓬萊國際機場",
      },
    ],
  },
  YNY: {
    code: "YNY",
    name: "YANGYANG",
    chineseName: "韩国襄阳",
    traditionalName: "韓國襄陽",
    airports: [
      {
        code: "YNY",
        name: "Yangyang intl.",
        chineseName: "襄阳国际机场",
        traditionalName: "襄陽國際機場",
      },
    ],
  },
  YNZ: {
    code: "YNZ",
    name: "YANCHENG",
    chineseName: "盐城",
    traditionalName: "鹽城",
    airports: [
      {
        code: "YNZ",
        name: "Nanyang",
        chineseName: "南洋机场",
        traditionalName: "南洋機場",
      },
    ],
  },
  YOC: {
    code: "YOC",
    name: "OLD CROW",
    chineseName: "旧克罗",
    traditionalName: "舊克羅",
    airports: [
      {
        code: "YOC",
        name: "Old crow airport",
        chineseName: "旧克罗机场",
        traditionalName: "舊克羅機場",
      },
    ],
  },
  YOG: {
    code: "YOG",
    name: "OGOKI",
    chineseName: "奥戈基",
    traditionalName: "奧戈基",
    airports: [
      {
        code: "YOG",
        name: "Ogoki post",
        chineseName: "奥戈基机场",
        traditionalName: "奧戈基機場",
      },
    ],
  },
  YOH: {
    code: "YOH",
    name: "OXFORD HOUSE",
    chineseName: "牛津豪斯",
    traditionalName: "牛津豪斯",
    airports: [
      {
        code: "YOH",
        name: "Oxford house airport",
        chineseName: "牛津豪斯机场",
        traditionalName: "牛津豪斯機場",
      },
    ],
  },
  YOJ: {
    code: "YOJ",
    name: "HIGH LEVEL",
    chineseName: "海莱夫尔",
    traditionalName: "海萊夫爾",
    airports: [
      {
        code: "YOJ",
        name: "High level airport",
        chineseName: "海莱夫尔机场",
        traditionalName: "海萊夫爾機場",
      },
    ],
  },
  YOL: {
    code: "YOL",
    name: "YOLA",
    chineseName: "约拉",
    traditionalName: "約拉",
    airports: [
      {
        code: "YOL",
        name: "Yola airport",
        chineseName: "约拉机场",
        traditionalName: "約拉機場",
      },
    ],
  },
  YON: {
    code: "YON",
    name: "TRASHIGANG",
    chineseName: "塔希冈",
    traditionalName: "塔希岡",
    airports: [
      {
        code: "YON",
        name: "Yonphula",
        chineseName: "塔希冈机场",
        traditionalName: "塔希岡機場",
      },
    ],
  },
  YOW: {
    code: "YOW",
    name: "OTTAWA",
    chineseName: "渥太华",
    traditionalName: "渥太華",
    airports: [
      {
        code: "YOW",
        name: "Macdonald-cartier intl",
        chineseName: "渥太华麦克唐纳-卡蒂埃国际机场",
        traditionalName: "渥太華麥克唐納－卡蒂埃國際機場",
      },
    ],
  },
  YPA: {
    code: "YPA",
    name: "PRINCE ALBERT",
    chineseName: "艾伯特王子城",
    traditionalName: "亞伯特王子城",
    airports: [
      {
        code: "YPA",
        name: "Glass field",
        chineseName: "艾伯特王子城机场",
        traditionalName: "亞伯特王子城機場",
      },
    ],
  },
  YPC: {
    code: "YPC",
    name: "PAULATUK",
    chineseName: "保拉图克",
    traditionalName: "保拉圖克",
    airports: [
      {
        code: "YPC",
        name: "Nora a. ruben",
        chineseName: "保拉图克机场",
        traditionalName: "保拉圖克機場",
      },
    ],
  },
  YPH: {
    code: "YPH",
    name: "INUKJUAK",
    chineseName: "伊努朱瓦克",
    traditionalName: "伊努朱瓦克",
    airports: [
      {
        code: "YPH",
        name: "Inukjuak airport",
        chineseName: "伊努克爪克机场",
        traditionalName: "伊努克爪克機場",
      },
    ],
  },
  YPJ: {
    code: "YPJ",
    name: "AUPALUK",
    chineseName: "奥帕卢克",
    traditionalName: "奧帕盧克",
    airports: [
      {
        code: "YPJ",
        name: "Aupaluk airport",
        chineseName: "奥帕卢克机场",
        traditionalName: "奧帕盧克機場",
      },
    ],
  },
  YPL: {
    code: "YPL",
    name: "PICKLE LAKE",
    chineseName: "皮克尔莱克",
    traditionalName: "皮克爾萊克",
    airports: [
      {
        code: "YPL",
        name: "Pickle lake airport",
        chineseName: "皮克尔莱克机场",
        traditionalName: "皮克爾萊克機場",
      },
    ],
  },
  YPM: {
    code: "YPM",
    name: "PIKANGIKUM",
    chineseName: "皮坎吉库姆",
    traditionalName: "皮坎吉庫姆",
    airports: [
      {
        code: "YPM",
        name: "Pikangikum airport",
        chineseName: "皮坎吉库姆机场",
        traditionalName: "皮坎吉庫姆機場",
      },
    ],
  },
  YPN: {
    code: "YPN",
    name: "PORT-MENIER",
    chineseName: "曼尼埃尔港",
    traditionalName: "曼尼埃爾港",
    airports: [
      {
        code: "YPN",
        name: "Port-menier airport",
        chineseName: "梅尼埃港机场",
        traditionalName: "梅尼埃港機場",
      },
    ],
  },
  YPO: {
    code: "YPO",
    name: "PEAWANUCK",
    chineseName: "皮沃那克",
    traditionalName: "皮沃那克",
    airports: [
      {
        code: "YPO",
        name: "Peawanuck airport",
        chineseName: "皮瓦努克机场",
        traditionalName: "皮瓦努克機場",
      },
    ],
  },
  YPR: {
    code: "YPR",
    name: "PRINCE RUPERT",
    chineseName: "鲁伯特王子市",
    traditionalName: "魯伯特王子市",
    airports: [
      {
        code: "YPR",
        name: "Prince rupert airport",
        chineseName: "鲁珀特王子港机场",
        traditionalName: "魯珀特王子港機場",
      },
    ],
  },
  YPT: {
    code: "YPT",
    name: "PENDER HARBOUR",
    chineseName: "彭德港",
    traditionalName: "彭德港",
    airports: [
      {
        code: "YPT",
        name: "Spb",
        chineseName: "彭德港机场",
        traditionalName: "彭德港機場",
      },
    ],
  },
  YPW: {
    code: "YPW",
    name: "POWELL RIVER",
    chineseName: "鲍威尔河",
    traditionalName: "鮑威爾河",
    airports: [
      {
        code: "WPL",
        name: "Powell lake spb",
        chineseName: "鲍威尔湖机场",
        traditionalName: "鮑威爾湖機場",
      },
      {
        code: "YPW",
        name: "Powell river airport",
        chineseName: "鲍威尔河机场",
        traditionalName: "鮑威爾河機場",
      },
    ],
  },
  YPX: {
    code: "YPX",
    name: "PUVIRNITUQ",
    chineseName: "波文格尼土克河",
    traditionalName: "波文格尼土克河",
    airports: [
      {
        code: "YPX",
        name: "Puvirnituq airport",
        chineseName: "波乌恩尼图克机场",
        traditionalName: "波烏恩尼圖克機場",
      },
    ],
  },
  YPY: {
    code: "YPY",
    name: "FORT CHIPEWYAN",
    chineseName: "福特齐普言",
    traditionalName: "福特齊普言",
    airports: [
      {
        code: "YPY",
        name: "Fort chipewyan airport",
        chineseName: "奇普怀恩堡机场",
        traditionalName: "奇普懷恩堡機場",
      },
    ],
  },
  YQB: {
    code: "YQB",
    name: "QUEBEC",
    chineseName: "魁北克",
    traditionalName: "魁北克",
    airports: [
      {
        code: "YQB",
        name: "Jean lesage intl",
        chineseName: "让勒萨热国际机场",
        traditionalName: "讓勒薩熱國際機場",
      },
    ],
  },
  YQC: {
    code: "YQC",
    name: "QUAQTAQ",
    chineseName: "夸克塔克",
    traditionalName: "誇克塔克",
    airports: [
      {
        code: "YQC",
        name: "Quaqtaq airport",
        chineseName: "夸克塔克机场",
        traditionalName: "誇克塔克機場",
      },
    ],
  },
  YQD: {
    code: "YQD",
    name: "THE PAS",
    chineseName: "帕斯",
    traditionalName: "帕斯",
    airports: [
      {
        code: "YQD",
        name: "The pas airport",
        chineseName: "达帕斯机场",
        traditionalName: "達帕斯機場",
      },
    ],
  },
  YQG: {
    code: "YQG",
    name: "WINDSOR",
    chineseName: "温莎",
    traditionalName: "溫莎",
    airports: [
      {
        code: "YQG",
        name: "Windsor airport",
        chineseName: "温莎机场",
        traditionalName: "溫莎機場",
      },
    ],
  },
  YQK: {
    code: "YQK",
    name: "KENORA",
    chineseName: "凯诺拉",
    traditionalName: "凱諾拉",
    airports: [
      {
        code: "YQK",
        name: "Kenora airport",
        chineseName: "凯诺拉机场",
        traditionalName: "凱諾拉機場",
      },
    ],
  },
  YQL: {
    code: "YQL",
    name: "LETHBRIDGE",
    chineseName: "莱斯布里奇",
    traditionalName: "萊斯布裏奇",
    airports: [
      {
        code: "YQL",
        name: "Lethbridge county",
        chineseName: "莱斯布里奇机场",
        traditionalName: "萊斯布裡奇機場",
      },
    ],
  },
  YQM: {
    code: "YQM",
    name: "MONCTON",
    chineseName: "蒙克顿",
    traditionalName: "蒙克頓",
    airports: [
      {
        code: "YQM",
        name: "Greater moncton intl",
        chineseName: "大蒙克顿国际机场",
        traditionalName: "大蒙克頓國際機場",
      },
    ],
  },
  YQQ: {
    code: "YQQ",
    name: "COMOX",
    chineseName: "科莫克斯",
    traditionalName: "科莫克斯",
    airports: [
      {
        code: "YQQ",
        name: "Comox airport",
        chineseName: "科莫克斯机场",
        traditionalName: "科莫克斯機場",
      },
    ],
  },
  YQR: {
    code: "YQR",
    name: "REGINA",
    chineseName: "里贾纳",
    traditionalName: "里賈納",
    airports: [
      {
        code: "YQR",
        name: "Regina intl.",
        chineseName: "里贾纳国际机场",
        traditionalName: "里賈納國際機場",
      },
    ],
  },
  YQT: {
    code: "YQT",
    name: "THUNDER BAY",
    chineseName: "桑德贝",
    traditionalName: "桑德貝",
    airports: [
      {
        code: "YQT",
        name: "Thunder bay intl.",
        chineseName: "桑德贝机场",
        traditionalName: "桑德貝機場",
      },
    ],
  },
  YQU: {
    code: "YQU",
    name: "GRANDE PRAIRIE",
    chineseName: "大草原城",
    traditionalName: "大草原城",
    airports: [
      {
        code: "YQU",
        name: "Grande prairie airport",
        chineseName: "大草原城机场",
        traditionalName: "大草原城機場",
      },
    ],
  },
  YQX: {
    code: "YQX",
    name: "GANDER",
    chineseName: "甘德",
    traditionalName: "甘德",
    airports: [
      {
        code: "YQX",
        name: "Gander intl.",
        chineseName: "甘德国际机场",
        traditionalName: "甘德國際機場",
      },
    ],
  },
  YQY: {
    code: "YQY",
    name: "SYDNEY",
    chineseName: "悉尼",
    traditionalName: "雪梨",
    airports: [
      {
        code: "YQY",
        name: "J.a. douglas mccurdy",
        chineseName: "悉尼机场",
        traditionalName: "雪梨機場",
      },
    ],
  },
  YQZ: {
    code: "YQZ",
    name: "QUESNEL",
    chineseName: "克内尔",
    traditionalName: "克內爾",
    airports: [
      {
        code: "YQZ",
        name: "Quesnel airport",
        chineseName: "克内尔机场",
        traditionalName: "克內爾機場",
      },
    ],
  },
  YRA: {
    code: "YRA",
    name: "GAMETI",
    chineseName: "雷湖",
    traditionalName: "雷湖",
    airports: [
      {
        code: "YRA",
        name: "Rae lakes",
        chineseName: "拉埃雷克斯机场",
        traditionalName: "拉埃雷克斯機場",
      },
    ],
  },
  YRB: {
    code: "YRB",
    name: "RESOLUTE",
    chineseName: "雷索卢特",
    traditionalName: "雷索盧特",
    airports: [
      {
        code: "YRB",
        name: "Resolute bay",
        chineseName: "雷索卢特机场",
        traditionalName: "雷索盧特機場",
      },
    ],
  },
  YRF: {
    code: "YRF",
    name: "CARTWRIGHT",
    chineseName: "卡特赖特",
    traditionalName: "卡特賴特",
    airports: [
      {
        code: "YRF",
        name: "Cartwright airport",
        chineseName: "卡特赖特机场",
        traditionalName: "卡特賴特機場",
      },
    ],
  },
  YRG: {
    code: "YRG",
    name: "RIGOLET",
    chineseName: "里戈莱特",
    traditionalName: "裏戈萊特",
    airports: [
      {
        code: "YRG",
        name: "Rigolet airport",
        chineseName: "里戈莱特机场",
        traditionalName: "裏戈萊特機場",
      },
    ],
  },
  YRL: {
    code: "YRL",
    name: "RED LAKE",
    chineseName: "雷德莱克",
    traditionalName: "雷德萊克",
    airports: [
      {
        code: "YRL",
        name: "Red lake airport",
        chineseName: "雷德莱克机场",
        traditionalName: "雷德萊克機場",
      },
    ],
  },
  YRS: {
    code: "YRS",
    name: "RED SUCKER LAKE",
    chineseName: "雷德萨克尔莱克",
    traditionalName: "雷德薩克爾萊克",
    airports: [
      {
        code: "YRS",
        name: "Red sucker lake airport",
        chineseName: "雷德萨克尔莱克机场",
        traditionalName: "雷德薩克爾萊克機場",
      },
    ],
  },
  YRT: {
    code: "YRT",
    name: "RANKIN INLET",
    chineseName: "兰金因雷特",
    traditionalName: "蘭金因雷特",
    airports: [
      {
        code: "YRT",
        name: "Rankin inlet airport",
        chineseName: "兰金因雷特机场",
        traditionalName: "蘭金因雷特機場",
      },
    ],
  },
  YSB: {
    code: "YSB",
    name: "SUDBURY",
    chineseName: "萨德伯里",
    traditionalName: "薩德伯裡",
    airports: [
      {
        code: "YSB",
        name: "Sudbury airport",
        chineseName: "萨德伯里机场",
        traditionalName: "薩德伯裡機場",
      },
    ],
  },
  YSF: {
    code: "YSF",
    name: "STONY RAPIDS",
    chineseName: "斯托尼拉匹兹",
    traditionalName: "斯托尼拉匹茲",
    airports: [
      {
        code: "YSF",
        name: "Stony rapids airport",
        chineseName: "斯托尼拉匹兹机场",
        traditionalName: "斯托尼拉匹茲機場",
      },
    ],
  },
  YSG: {
    code: "YSG",
    name: "LUTSELKE",
    chineseName: "路特萨尔克",
    traditionalName: "路特薩爾克",
    airports: [
      {
        code: "YSG",
        name: "Lutselke airport",
        chineseName: "鲁特塞尔克机场",
        traditionalName: "魯特塞爾克機場",
      },
    ],
  },
  YSJ: {
    code: "YSJ",
    name: "SAINT JOHN",
    chineseName: "圣约翰",
    traditionalName: "聖約翰",
    airports: [
      {
        code: "YSJ",
        name: "Saint john airport",
        chineseName: "圣约翰机场",
        traditionalName: "聖約翰機場",
      },
    ],
  },
  YSK: {
    code: "YSK",
    name: "SANIKILUAQ",
    chineseName: "萨尼基卢阿克",
    traditionalName: "薩尼基盧阿克",
    airports: [
      {
        code: "YSK",
        name: "Sanikiluaq airport",
        chineseName: "萨尼基卢阿克机场",
        traditionalName: "薩尼基盧阿克機場",
      },
    ],
  },
  YSM: {
    code: "YSM",
    name: "FORT SMITH",
    chineseName: "史密斯堡",
    traditionalName: "史密斯堡",
    airports: [
      {
        code: "YSM",
        name: "Fort smith airport",
        chineseName: "史密斯堡机场",
        traditionalName: "史密斯堡機場",
      },
    ],
  },
  YSO: {
    code: "YSO",
    name: "POSTVILLE",
    chineseName: "波斯特维尔",
    traditionalName: "波斯特維爾",
    airports: [
      {
        code: "YSO",
        name: "Postville airport",
        chineseName: "波茨维尔机场",
        traditionalName: "波茨維爾機場",
      },
    ],
  },
  YSQ: {
    code: "YSQ",
    name: "SONGYUAN",
    chineseName: "松原",
    traditionalName: "松原",
    airports: [
      {
        code: "YSQ",
        name: "Chaganhu",
        chineseName: "查干湖机场",
        traditionalName: "查幹湖機場",
      },
    ],
  },
  YST: {
    code: "YST",
    name: "ST THERESA POINT",
    chineseName: "圣泰雷斯角",
    traditionalName: "聖泰雷斯角",
    airports: [
      {
        code: "YST",
        name: "St theresa point airport",
        chineseName: "圣泰雷斯角机场",
        traditionalName: "聖泰雷斯角機場",
      },
    ],
  },
  YSY: {
    code: "YSY",
    name: "SACHS HARBOUR",
    chineseName: "萨彻斯港",
    traditionalName: "薩徹斯港",
    airports: [
      {
        code: "YSY",
        name: "D.nasogaluak saaryuaq",
        chineseName: "萨彻斯港机场",
        traditionalName: "薩徹斯港機場",
      },
    ],
  },
  YTE: {
    code: "YTE",
    name: "KINNGAIT",
    chineseName: "开普多塞特",
    traditionalName: "開普多塞特",
    airports: [
      {
        code: "YTE",
        name: "Cape dorset",
        chineseName: "开普多塞特机场",
        traditionalName: "開普多塞特機場",
      },
    ],
  },
  YTH: {
    code: "YTH",
    name: "THOMPSON",
    chineseName: "汤浦森",
    traditionalName: "湯浦森",
    airports: [
      {
        code: "YTH",
        name: "Thompson airport",
        chineseName: "汤浦森机场",
        traditionalName: "湯浦森機場",
      },
    ],
  },
  YTL: {
    code: "YTL",
    name: "BIG TROUT LAKE",
    chineseName: "大特劳特湖",
    traditionalName: "大特勞特湖",
    airports: [
      {
        code: "YTL",
        name: "Big trout lake airport",
        chineseName: "大特劳特机场",
        traditionalName: "大特勞特機場",
      },
    ],
  },
  YTO: {
    code: "YTO",
    name: "TORONTO",
    chineseName: "多伦多",
    traditionalName: "多倫多",
    airports: [
      {
        code: "YHM",
        name: "John c. munro hamilton",
        chineseName: "哈密尔顿机场",
        traditionalName: "漢米爾頓機場",
      },
      {
        code: "YKF",
        name: "Region of waterloo int",
        chineseName: "滑铁卢区国际机场",
        traditionalName: "滑鐵盧區國際機場",
      },
      {
        code: "YTZ",
        name: "Billy bishop city a/p",
        chineseName: "多伦多岛机场",
        traditionalName: "多倫多島機場",
      },
      {
        code: "YYZ",
        name: "Lester b. pearson intl",
        chineseName: "皮尔逊国际机场",
        traditionalName: "皮爾遜國際機場",
      },
    ],
  },
  YTQ: {
    code: "YTQ",
    name: "TASIUJAQ",
    chineseName: "塔休具阿克",
    traditionalName: "塔休具阿克",
    airports: [
      {
        code: "YTQ",
        name: "Tasiujaq airport",
        chineseName: "塔休华克机场",
        traditionalName: "塔休華克機場",
      },
    ],
  },
  YTS: {
    code: "YTS",
    name: "TIMMINS",
    chineseName: "蒂明斯",
    traditionalName: "蒂明斯",
    airports: [
      {
        code: "YTS",
        name: "Victor m. power",
        chineseName: "蒂明斯机场",
        traditionalName: "蒂明斯機場",
      },
    ],
  },
  YTW: {
    code: "YTW",
    name: "YUTIAN",
    chineseName: "玉田",
    traditionalName: "玉田",
    airports: [
      {
        code: "YTW",
        name: "Wanfang",
        chineseName: "万方机场",
        traditionalName: "萬方機場",
      },
    ],
  },
  YTY: {
    code: "YTY",
    name: "YANGZHOU",
    chineseName: "扬州",
    traditionalName: "揚州",
    airports: [
      {
        code: "YTY",
        name: "Yangzhou taizhou international",
        chineseName: "扬州泰州机场",
        traditionalName: "揚州泰州機場",
      },
    ],
  },
  YUD: {
    code: "YUD",
    name: "UMIUJAQ",
    chineseName: "厄缪亚克",
    traditionalName: "厄繆亞克",
    airports: [
      {
        code: "YUD",
        name: "Umiujaq airport",
        chineseName: "乌缪亚格机场",
        traditionalName: "烏繆亞格機場",
      },
    ],
  },
  YUM: {
    code: "YUM",
    name: "YUMA",
    chineseName: "尤马",
    traditionalName: "尤馬",
    airports: [
      {
        code: "YUM",
        name: "Yuma intl.",
        chineseName: "尤马国际机场",
        traditionalName: "尤馬國際機場",
      },
    ],
  },
  YUS: {
    code: "YUS",
    name: "YUSHU",
    chineseName: "玉树",
    traditionalName: "玉樹",
    airports: [
      {
        code: "YUS",
        name: "Batang",
        chineseName: "玉树巴塘机场",
        traditionalName: "玉樹巴塘機場",
      },
    ],
  },
  YUT: {
    code: "YUT",
    name: "REPULSE BAY",
    chineseName: "浅水湾",
    traditionalName: "淺水灣",
    airports: [
      {
        code: "YUT",
        name: "Repulse bay airport",
        chineseName: "里帕尔斯贝机场",
        traditionalName: "裏帕爾斯貝機場",
      },
    ],
  },
  YUX: {
    code: "YUX",
    name: "SANIRAJAK",
    chineseName: "哈尔比奇",
    traditionalName: "哈爾比奇",
    airports: [
      {
        code: "YUX",
        name: "Hall beach",
        chineseName: "哈尔比奇机场",
        traditionalName: "哈爾比奇機場",
      },
    ],
  },
  YUY: {
    code: "YUY",
    name: "ROUYN-NORANDA",
    chineseName: "鲁安",
    traditionalName: "魯安",
    airports: [
      {
        code: "YUY",
        name: "Rouyn-noranda airport",
        chineseName: "鲁安诺兰达机场",
        traditionalName: "魯安諾蘭達機場",
      },
    ],
  },
  YVA: {
    code: "YVA",
    name: "MORONI",
    chineseName: "莫罗尼",
    traditionalName: "莫洛尼",
    airports: [
      {
        code: "HAH",
        name: "Prince said ibrahim",
        chineseName: "赛义德易卜拉欣王子机场",
        traditionalName: "賽義德易蔔拉欣王子機場",
      },
    ],
  },
  YVB: {
    code: "YVB",
    name: "BONAVENTURE",
    chineseName: "博纳文图尔",
    traditionalName: "博納文圖爾",
    airports: [
      {
        code: "YVB",
        name: "Bonaventure airport",
        chineseName: "博纳旺蒂尔机场",
        traditionalName: "博納旺蒂爾機場",
      },
    ],
  },
  YVC: {
    code: "YVC",
    name: "LA RONGE",
    chineseName: "拉龙吉",
    traditionalName: "拉龍吉",
    airports: [
      {
        code: "YVC",
        name: "Barber field",
        chineseName: "拉龙吉机场",
        traditionalName: "拉龍吉機場",
      },
    ],
  },
  YVG: {
    code: "YVG",
    name: "VERMILION",
    chineseName: "弗米利恩",
    traditionalName: "弗米利恩",
    airports: [
      {
        code: "YVG",
        name: "Vermilion airport",
        chineseName: "弗米利恩机场",
        traditionalName: "弗米利恩機場",
      },
    ],
  },
  YVM: {
    code: "YVM",
    name: "QIKIQTARJUAQ",
    chineseName: "布劳顿岛",
    traditionalName: "布勞頓島",
    airports: [
      {
        code: "YVM",
        name: "Qikiqtarjuaq airport",
        chineseName: "齐齐克塔胡亚克机场",
        traditionalName: "齊齊克塔胡亞克機場",
      },
    ],
  },
  YVO: {
    code: "YVO",
    name: "VAL D'OR",
    chineseName: "瓦勒多",
    traditionalName: "瓦勒多",
    airports: [
      {
        code: "YVO",
        name: "Val d'or airport",
        chineseName: "瓦勒多机场",
        traditionalName: "瓦勒多機場",
      },
    ],
  },
  YVP: {
    code: "YVP",
    name: "KUUJJUAQ",
    chineseName: "库居阿克",
    traditionalName: "庫居阿克",
    airports: [
      {
        code: "YVP",
        name: "Kuujjuaq airport",
        chineseName: "库居阿克机场",
        traditionalName: "庫居阿克機場",
      },
    ],
  },
  YVQ: {
    code: "YVQ",
    name: "NORMAN WELLS",
    chineseName: "诺曼韦尔斯",
    traditionalName: "諾曼威爾斯",
    airports: [
      {
        code: "YVQ",
        name: "Norman wells airport",
        chineseName: "诺曼韦尔斯机场",
        traditionalName: "諾曼威爾斯機場",
      },
    ],
  },
  YVR: {
    code: "YVR",
    name: "VANCOUVER",
    chineseName: "温哥华",
    traditionalName: "溫哥華",
    airports: [
      {
        code: "CXH",
        name: "Harbour spb",
        chineseName: "温哥华港水上飞机基地",
        traditionalName: "溫哥華港水上飛機基地",
      },
      {
        code: "YVR",
        name: "Vancouver intl.",
        chineseName: "温哥华国际机场",
        traditionalName: "溫哥華國際機場",
      },
      {
        code: "YXX",
        name: "Abbotsford intl.",
        chineseName: "阿伯茨福德国际机场",
        traditionalName: "阿伯茨福德國際機場",
      },
    ],
  },
  YVZ: {
    code: "YVZ",
    name: "DEER LAKE",
    chineseName: "迪尔莱克",
    traditionalName: "迪爾萊克",
    airports: [
      {
        code: "YVZ",
        name: "Deer lake airport",
        chineseName: "迪尔莱克机场",
        traditionalName: "迪爾萊克機場",
      },
    ],
  },
  YWB: {
    code: "YWB",
    name: "KANGIQSUJUAQ",
    chineseName: "康吉克苏瓦克",
    traditionalName: "康吉克蘇瓦克",
    airports: [
      {
        code: "YWB",
        name: "Wakeham bay",
        chineseName: "维克哈姆湾机场",
        traditionalName: "維克哈姆灣機場",
      },
    ],
  },
  YWG: {
    code: "YWG",
    name: "WINNIPEG",
    chineseName: "温尼伯",
    traditionalName: "溫尼伯",
    airports: [
      {
        code: "YWG",
        name: "J.a. richardson intl",
        chineseName: "詹姆斯阿姆斯特朗理查森国际机场",
        traditionalName: "詹姆斯阿姆斯特朗理查森國際機場",
      },
    ],
  },
  YWJ: {
    code: "YWJ",
    name: "DELINE",
    chineseName: "迪莱",
    traditionalName: "迪萊",
    airports: [
      {
        code: "YWJ",
        name: "Deline airport",
        chineseName: "德莱恩机场",
        traditionalName: "德萊恩機場",
      },
    ],
  },
  YWK: {
    code: "YWK",
    name: "WABUSH",
    chineseName: "瓦布什",
    traditionalName: "瓦布什",
    airports: [
      {
        code: "YWK",
        name: "Wabush airport",
        chineseName: "瓦布什机场",
        traditionalName: "瓦布什機場",
      },
    ],
  },
  YWL: {
    code: "YWL",
    name: "WILLIAMS LAKE",
    chineseName: "威廉斯莱克",
    traditionalName: "威廉士萊克",
    airports: [
      {
        code: "YWL",
        name: "Williams lake airport",
        chineseName: "威廉斯湖机场",
        traditionalName: "威廉士湖機場",
      },
    ],
  },
  YWP: {
    code: "YWP",
    name: "WEBEQUIE",
    chineseName: "维博奎",
    traditionalName: "維博奎",
    airports: [
      {
        code: "YWP",
        name: "Webequie airport",
        chineseName: "维博奎机场",
        traditionalName: "維博奎機場",
      },
    ],
  },
  YWS: {
    code: "YWS",
    name: "WHISTLER",
    chineseName: "惠斯勒",
    traditionalName: "惠斯勒",
    airports: [
      {
        code: "YWS",
        name: "Green lake spb",
        chineseName: "惠斯勒机场",
        traditionalName: "惠斯勒機場",
      },
    ],
  },
  YXC: {
    code: "YXC",
    name: "CRANBROOK",
    chineseName: "克兰布鲁克",
    traditionalName: "克蘭布魯克",
    airports: [
      {
        code: "YXC",
        name: "Canadian rockies intl",
        chineseName: "克兰布鲁克机场",
        traditionalName: "克蘭布魯克機場",
      },
    ],
  },
  YXE: {
    code: "YXE",
    name: "SASKATOON",
    chineseName: "萨斯卡通",
    traditionalName: "薩斯卡通",
    airports: [
      {
        code: "YXE",
        name: "J.g. diefenbaker intl",
        chineseName: "约翰迪芬贝克国际机场",
        traditionalName: "約翰迪芬貝克國際機場",
      },
    ],
  },
  YXH: {
    code: "YXH",
    name: "MEDICINE HAT",
    chineseName: "梅迪辛哈特",
    traditionalName: "梅迪辛哈特",
    airports: [
      {
        code: "YXH",
        name: "Medicine hat airport",
        chineseName: "梅迪辛哈特机场",
        traditionalName: "梅迪辛哈特機場",
      },
    ],
  },
  YXJ: {
    code: "YXJ",
    name: "FORT ST JOHN",
    chineseName: "圣约翰堡",
    traditionalName: "聖約翰堡",
    airports: [
      {
        code: "YXJ",
        name: "North peace",
        chineseName: "圣约翰堡机场",
        traditionalName: "聖約翰堡機場",
      },
    ],
  },
  YXL: {
    code: "YXL",
    name: "SIOUX LOOKOUT",
    chineseName: "苏卢考特",
    traditionalName: "蘇盧考特",
    airports: [
      {
        code: "YXL",
        name: "Sioux lookout airport",
        chineseName: "苏卢考特机场",
        traditionalName: "蘇盧考特機場",
      },
    ],
  },
  YXN: {
    code: "YXN",
    name: "WHALE COVE",
    chineseName: "鲸湾",
    traditionalName: "鯨灣",
    airports: [
      {
        code: "YXN",
        name: "Whale cove airport",
        chineseName: "韦尔科夫机场",
        traditionalName: "韋爾科夫機場",
      },
    ],
  },
  YXP: {
    code: "YXP",
    name: "PANGNIRTUNG",
    chineseName: "旁纳唐",
    traditionalName: "旁納唐",
    airports: [
      {
        code: "YXP",
        name: "Pangnirtung airport",
        chineseName: "旁纳唐机场",
        traditionalName: "旁納唐機場",
      },
    ],
  },
  YXS: {
    code: "YXS",
    name: "PRINCE GEORGE",
    chineseName: "乔治王子城",
    traditionalName: "喬治王子城",
    airports: [
      {
        code: "YXS",
        name: "Prince george airport",
        chineseName: "乔治王子城机场",
        traditionalName: "喬治王子城機場",
      },
    ],
  },
  YXT: {
    code: "YXT",
    name: "TERRACE",
    chineseName: "特勒斯机场",
    traditionalName: "特勒斯機場",
    airports: [
      {
        code: "YXT",
        name: "Northwest regional",
        chineseName: "西北地区机场",
        traditionalName: "西北地方機場",
      },
    ],
  },
  YXU: {
    code: "YXU",
    name: "LONDON",
    chineseName: "伦敦",
    traditionalName: "倫敦",
    airports: [
      {
        code: "YXU",
        name: "London intl.",
        chineseName: "伦敦国际机场",
        traditionalName: "倫敦國際機場",
      },
    ],
  },
  YXY: {
    code: "YXY",
    name: "WHITEHORSE",
    chineseName: "怀特霍斯",
    traditionalName: "懷特霍斯",
    airports: [
      {
        code: "YXY",
        name: "Erik nielsen intl",
        chineseName: "埃里克尼尔森国际机场",
        traditionalName: "埃裏克尼爾森國際機場",
      },
    ],
  },
  YYA: {
    code: "YYA",
    name: "YUEYANG",
    chineseName: "岳阳",
    traditionalName: "岳陽",
    airports: [
      {
        code: "YYA",
        name: "Sanhe",
        chineseName: "三荷机场",
        traditionalName: "三荷機場",
      },
    ],
  },
  YYB: {
    code: "YYB",
    name: "NORTH BAY",
    chineseName: "诺斯贝",
    traditionalName: "諾斯貝",
    airports: [
      {
        code: "YYB",
        name: "Jack garland",
        chineseName: "北湾机场",
        traditionalName: "北灣機場",
      },
    ],
  },
  YYC: {
    code: "YYC",
    name: "CALGARY",
    chineseName: "卡尔加里",
    traditionalName: "卡爾加里",
    airports: [
      {
        code: "YYC",
        name: "Calgary intl.",
        chineseName: "卡尔加里国际机场",
        traditionalName: "卡爾加里國際機場",
      },
    ],
  },
  YYD: {
    code: "YYD",
    name: "SMITHERS",
    chineseName: "史密瑟斯",
    traditionalName: "史密瑟斯",
    airports: [
      {
        code: "YYD",
        name: "Smithers airport",
        chineseName: "史密瑟斯机场",
        traditionalName: "史密瑟斯機場",
      },
    ],
  },
  YYE: {
    code: "YYE",
    name: "FORT NELSON",
    chineseName: "纳尔逊堡",
    traditionalName: "納爾遜堡",
    airports: [
      {
        code: "YYE",
        name: "Northern rockies rgnl",
        chineseName: "纳尔逊堡机场",
        traditionalName: "納爾遜堡機場",
      },
    ],
  },
  YYF: {
    code: "YYF",
    name: "PENTICTON",
    chineseName: "彭蒂克顿",
    traditionalName: "彭蒂克頓",
    airports: [
      {
        code: "YYF",
        name: "Penticton reg. airport",
        chineseName: "彭蒂克顿机场",
        traditionalName: "彭蒂克頓機場",
      },
    ],
  },
  YYG: {
    code: "YYG",
    name: "CHARLOTTETOWN",
    chineseName: "夏洛特敦",
    traditionalName: "夏洛特敦",
    airports: [
      {
        code: "YYG",
        name: "Charlottetown airport",
        chineseName: "夏洛特敦机场",
        traditionalName: "夏洛特敦機場",
      },
    ],
  },
  YYH: {
    code: "YYH",
    name: "TALOYOAK",
    chineseName: "塔拉约科",
    traditionalName: "塔拉約科",
    airports: [
      {
        code: "YYH",
        name: "Taloyoak airport",
        chineseName: "塔罗约阿克机场",
        traditionalName: "塔羅約阿克機場",
      },
    ],
  },
  YYJ: {
    code: "YYJ",
    name: "VICTORIA",
    chineseName: "维多利亚",
    traditionalName: "維多利亞",
    airports: [
      {
        code: "YWH",
        name: "Inner harbour spb",
        chineseName: "维多利亚内港水上机场",
        traditionalName: "維多利亞內港水上機場",
      },
      {
        code: "YYJ",
        name: "Victoria intl.",
        chineseName: "维多利亚国际机场",
        traditionalName: "維多利亞國際機場",
      },
    ],
  },
  YYQ: {
    code: "YYQ",
    name: "CHURCHILL",
    chineseName: "丘吉尔河",
    traditionalName: "邱吉爾河",
    airports: [
      {
        code: "YYQ",
        name: "Churchill airport",
        chineseName: "丘吉尔机场",
        traditionalName: "邱吉爾機場",
      },
    ],
  },
  YYR: {
    code: "YYR",
    name: "GOOSE BAY",
    chineseName: "古斯湾",
    traditionalName: "古斯灣",
    airports: [
      {
        code: "YYR",
        name: "Goose bay airport",
        chineseName: "古斯贝机场",
        traditionalName: "古斯貝機場",
      },
    ],
  },
  YYT: {
    code: "YYT",
    name: "ST JOHN'S",
    chineseName: "圣约翰斯",
    traditionalName: "聖約翰斯",
    airports: [
      {
        code: "YYT",
        name: "St john's intl.",
        chineseName: "圣约翰斯国际机场",
        traditionalName: "聖約翰斯國際機場",
      },
    ],
  },
  YYU: {
    code: "YYU",
    name: "KAPUSKASING",
    chineseName: "卡普斯卡辛",
    traditionalName: "卡普斯卡辛",
    airports: [
      {
        code: "YYU",
        name: "Kapuskasing airport",
        chineseName: "卡普斯卡辛机场",
        traditionalName: "卡普斯卡辛機場",
      },
    ],
  },
  YYY: {
    code: "YYY",
    name: "MONT-JOLI",
    chineseName: "蒙特朱利",
    traditionalName: "蒙特朱利",
    airports: [
      {
        code: "YYY",
        name: "Mont-joli airport",
        chineseName: "蒙若利机场",
        traditionalName: "蒙若利機場",
      },
    ],
  },
  YZA: {
    code: "YZA",
    name: "CACHE CREEK/ASHCROFT",
    chineseName: "阿什克劳夫特",
    traditionalName: "阿什克勞夫特",
    airports: [
      {
        code: "YZA",
        name: "Cache creek/ashcroft reg. airp",
        chineseName: "阿什克劳夫特机场",
        traditionalName: "阿什克勞夫特機場",
      },
    ],
  },
  YZF: {
    code: "YZF",
    name: "YELLOWKNIFE",
    chineseName: "耶洛奈夫",
    traditionalName: "耶洛奈夫",
    airports: [
      {
        code: "YZF",
        name: "Yellowknife airport",
        chineseName: "耶洛奈夫机场",
        traditionalName: "耶洛奈夫機場",
      },
    ],
  },
  YZG: {
    code: "YZG",
    name: "SALLUIT",
    chineseName: "萨鲁伊特",
    traditionalName: "薩魯伊特",
    airports: [
      {
        code: "YZG",
        name: "Salluit airport",
        chineseName: "萨鲁伊特机场",
        traditionalName: "薩魯伊特機場",
      },
    ],
  },
  YZP: {
    code: "YZP",
    name: "SANDSPIT",
    chineseName: "桑兹皮特",
    traditionalName: "桑茲皮特",
    airports: [
      {
        code: "YZP",
        name: "Sandspit airport",
        chineseName: "桑兹皮特机场",
        traditionalName: "桑茲皮特機場",
      },
    ],
  },
  YZS: {
    code: "YZS",
    name: "CORAL HARBOUR",
    chineseName: "珊瑚港",
    traditionalName: "珊瑚港",
    airports: [
      {
        code: "YZS",
        name: "Coral harbour airport",
        chineseName: "科勒尔港机场",
        traditionalName: "科勒爾港機場",
      },
    ],
  },
  YZT: {
    code: "YZT",
    name: "PORT HARDY",
    chineseName: "哈迪港",
    traditionalName: "哈迪港",
    airports: [
      {
        code: "YZT",
        name: "Port hardy airport",
        chineseName: "哈迪港机场",
        traditionalName: "哈迪港機場",
      },
    ],
  },
  YZV: {
    code: "YZV",
    name: "SEPT-ILES",
    chineseName: "七岛港",
    traditionalName: "七島港",
    airports: [
      {
        code: "YZV",
        name: "Sept-iles airport",
        chineseName: "七岛港机场",
        traditionalName: "七島港機場",
      },
    ],
  },
  YZY: {
    code: "YZY",
    name: "ZHANGYE",
    chineseName: "张掖",
    traditionalName: "張掖",
    airports: [
      {
        code: "YZY",
        name: "Ganzhou",
        chineseName: "甘州机场",
        traditionalName: "甘州機場",
      },
    ],
  },
  YZZ: {
    code: "YZZ",
    name: "TRAIL",
    chineseName: "特雷尔",
    traditionalName: "特雷爾",
    airports: [
      {
        code: "YZZ",
        name: "Trail airport",
        chineseName: "特雷尔",
        traditionalName: "特雷爾",
      },
    ],
  },
  ZAD: {
    code: "ZAD",
    name: "ZADAR",
    chineseName: "扎达尔",
    traditionalName: "紮達爾",
    airports: [
      {
        code: "ZAD",
        name: "Zadar airport",
        chineseName: "扎达尔机场",
        traditionalName: "紮達爾機場",
      },
    ],
  },
  ZAG: {
    code: "ZAG",
    name: "ZAGREB",
    chineseName: "萨格勒布",
    traditionalName: "札格雷布",
    airports: [
      {
        code: "ZAG",
        name: "Franjo tudman",
        chineseName: "普雷索机场",
        traditionalName: "普雷索機場",
      },
    ],
  },
  ZAH: {
    code: "ZAH",
    name: "ZAHEDAN",
    chineseName: "扎黑丹",
    traditionalName: "紮黑丹",
    airports: [
      {
        code: "ZAH",
        name: "Zahedan intl.",
        chineseName: "扎黑丹机场",
        traditionalName: "紮黑丹機場",
      },
    ],
  },
  ZAL: {
    code: "ZAL",
    name: "VALDIVIA",
    chineseName: "瓦尔迪维亚",
    traditionalName: "瓦爾迪維亞",
    airports: [
      {
        code: "ZAL",
        name: "Pichoy",
        chineseName: "皮考伊机场",
        traditionalName: "皮考伊機場",
      },
    ],
  },
  ZAM: {
    code: "ZAM",
    name: "ZAMBOANGA",
    chineseName: "三宝颜",
    traditionalName: "三寶顏",
    airports: [
      {
        code: "ZAM",
        name: "Zamboanga intl.",
        chineseName: "三宝颜国际机场",
        traditionalName: "三寶顏國際機場",
      },
    ],
  },
  ZAT: {
    code: "ZAT",
    name: "ZHAOTONG",
    chineseName: "昭通",
    traditionalName: "昭通",
    airports: [
      {
        code: "ZAT",
        name: "Zhaotong airport",
        chineseName: "昭通机场",
        traditionalName: "昭通機場",
      },
    ],
  },
  ZAZ: {
    code: "ZAZ",
    name: "ZARAGOZA",
    chineseName: "萨拉戈萨",
    traditionalName: "薩拉戈薩",
    airports: [
      {
        code: "ZAZ",
        name: "Zaragoza airport",
        chineseName: "萨拉戈萨机场",
        traditionalName: "薩拉戈薩機場",
      },
    ],
  },
  ZBF: {
    code: "ZBF",
    name: "BATHURST",
    chineseName: "巴瑟斯特",
    traditionalName: "巴瑟斯特",
    airports: [
      {
        code: "ZBF",
        name: "Bathurst airport",
        chineseName: "巴瑟斯特机场",
        traditionalName: "巴瑟斯特機場",
      },
    ],
  },
  ZBL: {
    code: "ZBL",
    name: "BILOELA",
    chineseName: "比娄拉",
    traditionalName: "比婁拉",
    airports: [
      {
        code: "ZBL",
        name: "Biloela airport",
        chineseName: "比娄拉机场",
        traditionalName: "比婁拉機場",
      },
    ],
  },
  ZBR: {
    code: "ZBR",
    name: "CHAH BAHAR",
    chineseName: "恰赫巴哈尔",
    traditionalName: "恰赫巴哈爾",
    airports: [
      {
        code: "ZBR",
        name: "Konarak",
        chineseName: "恰赫巴哈尔机场",
        traditionalName: "恰赫巴哈爾機場",
      },
    ],
  },
  ZBY: {
    code: "ZBY",
    name: "SAYABOURY",
    chineseName: "沙耶武里",
    traditionalName: "沙耶武裡",
    airports: [
      {
        code: "ZBY",
        name: "Sayaboury airport",
        chineseName: "沙耶武里机场",
        traditionalName: "沙耶武裡機場",
      },
    ],
  },
  ZCL: {
    code: "ZCL",
    name: "ZACATECAS",
    chineseName: "萨卡特卡斯",
    traditionalName: "薩卡特卡斯",
    airports: [
      {
        code: "ZCL",
        name: "Leobardo c. ruiz intl",
        chineseName: "萨卡特卡斯机场",
        traditionalName: "薩卡特卡斯機場",
      },
    ],
  },
  ZCO: {
    code: "ZCO",
    name: "TEMUCO",
    chineseName: "特木科",
    traditionalName: "特木科",
    airports: [
      {
        code: "ZCO",
        name: "La araucania",
        chineseName: "特木科机场",
        traditionalName: "特木科機場",
      },
    ],
  },
  ZEL: {
    code: "ZEL",
    name: "BELLA BELLA",
    chineseName: "贝拉贝拉",
    traditionalName: "貝拉貝拉",
    airports: [
      {
        code: "ZEL",
        name: "Campbell island",
        chineseName: "贝拉贝拉机场",
        traditionalName: "貝拉貝拉機場",
      },
    ],
  },
  ZEM: {
    code: "ZEM",
    name: "EASTMAIN",
    chineseName: "伊斯特梅恩",
    traditionalName: "伊斯特梅恩",
    airports: [
      {
        code: "ZEM",
        name: "Eastmain river",
        chineseName: "伊斯特梅恩机场",
        traditionalName: "伊斯特梅恩機場",
      },
    ],
  },
  ZER: {
    code: "ZER",
    name: "ZIRO",
    chineseName: "齐罗",
    traditionalName: "齊羅",
    airports: [
      {
        code: "ZER",
        name: "Ziro airport",
        chineseName: "齐罗机场",
        traditionalName: "齊羅機場",
      },
    ],
  },
  ZFD: {
    code: "ZFD",
    name: "FOND-DU-LAC",
    chineseName: "丰迪拉克",
    traditionalName: "豐迪拉克",
    airports: [
      {
        code: "ZFD",
        name: "Fond-du-lac airport",
        chineseName: "丰迪拉克机场",
        traditionalName: "豐迪拉克機場",
      },
    ],
  },
  ZFL: {
    code: "ZFL",
    name: "ZHAOSU",
    chineseName: "南特劳特湖",
    traditionalName: "南特勞特湖",
    airports: [
      {
        code: "ZFL",
        name: "Tianma",
        chineseName: "天马机场",
        traditionalName: "天馬機場",
      },
    ],
  },
  ZFM: {
    code: "ZFM",
    name: "FORT MCPHERSON",
    chineseName: "麦克弗森堡",
    traditionalName: "麥克弗森堡",
    airports: [
      {
        code: "ZFM",
        name: "Fort mcpherson airport",
        chineseName: "麦克弗森堡机场",
        traditionalName: "麥克弗森堡機場",
      },
    ],
  },
  ZFN: {
    code: "ZFN",
    name: "TULITA",
    chineseName: "图利塔",
    traditionalName: "圖利塔",
    airports: [
      {
        code: "ZFN",
        name: "Tulita airport",
        chineseName: "图利塔机场",
        traditionalName: "圖利塔機場",
      },
    ],
  },
  ZGI: {
    code: "ZGI",
    name: "GODS RIVER",
    chineseName: "戈兹里弗",
    traditionalName: "戈茲裏弗",
    airports: [
      {
        code: "ZGI",
        name: "Gods river airport",
        chineseName: "戈兹里弗机场",
        traditionalName: "戈茲裏弗機場",
      },
    ],
  },
  ZGS: {
    code: "ZGS",
    name: "LA ROMAINE",
    chineseName: "客两马尼园",
    traditionalName: "客兩馬尼園",
    airports: [
      {
        code: "ZGS",
        name: "La romaine airport",
        chineseName: "拉罗曼机场",
        traditionalName: "拉羅曼機場",
      },
    ],
  },
  ZGU: {
    code: "ZGU",
    name: "GAUA ISLAND",
    chineseName: "高亚",
    traditionalName: "高亞",
    airports: [
      {
        code: "ZGU",
        name: "Gaua island airport",
        chineseName: "高亚机场",
        traditionalName: "高亞機場",
      },
    ],
  },
  ZHA: {
    code: "ZHA",
    name: "ZHANJIANG",
    chineseName: "湛江",
    traditionalName: "湛江",
    airports: [
      {
        code: "ZHA",
        name: "Wuchuan",
        chineseName: "湛江机场",
        traditionalName: "湛江機場",
      },
    ],
  },
  ZHY: {
    code: "ZHY",
    name: "ZHONGWEI",
    chineseName: "中卫",
    traditionalName: "中衛",
    airports: [
      {
        code: "ZHY",
        name: "Xiangshan",
        chineseName: "沙坡头机场",
        traditionalName: "沙坡頭機場",
      },
    ],
  },
  ZIA: {
    code: "ZIA",
    name: "ZHUKOVSKY",
    chineseName: "茹科夫斯基",
    traditionalName: "茹科夫斯基",
    airports: [
      {
        code: "ZIA",
        name: "Zhukovsky airport",
        chineseName: "茹科夫斯基机场",
        traditionalName: "茹科夫斯基機場",
      },
    ],
  },
  ZIG: {
    code: "ZIG",
    name: "ZIGUINCHOR",
    chineseName: "济金绍尔",
    traditionalName: "濟金紹爾",
    airports: [
      {
        code: "ZIG",
        name: "Ziguinchor airport",
        chineseName: "济金绍尔机场",
        traditionalName: "濟金紹爾機場",
      },
    ],
  },
  ZIH: {
    code: "ZIH",
    name: "IXTAPA/ZIHUATANEJO",
    chineseName: "伊斯塔帕",
    traditionalName: "伊斯塔帕",
    airports: [
      {
        code: "ZIH",
        name: "Ixtapa/zihuatanejo intl.",
        chineseName: "印坦巴国际机场",
        traditionalName: "印坦巴國際機場",
      },
    ],
  },
  ZIX: {
    code: "ZIX",
    name: "ZHIGANSK",
    chineseName: "日甘斯克",
    traditionalName: "日甘斯克",
    airports: [
      {
        code: "ZIX",
        name: "Zhigansk airport",
        chineseName: "日甘斯克机场",
        traditionalName: "日甘斯克機場",
      },
    ],
  },
  ZKE: {
    code: "ZKE",
    name: "KASHECHEWAN",
    chineseName: "卡舍切万",
    traditionalName: "卡舍切萬",
    airports: [
      {
        code: "ZKE",
        name: "Kashechewan airport",
        chineseName: "卡斯切彻瓦恩机场",
        traditionalName: "卡斯切徹瓦恩機場",
      },
    ],
  },
  ZKP: {
    code: "ZKP",
    name: "ZYRYANKA",
    chineseName: "济良卡",
    traditionalName: "濟良卡",
    airports: [
      {
        code: "ZKP",
        name: "Zyryanka airport",
        chineseName: "济良卡机场",
        traditionalName: "濟良卡機場",
      },
    ],
  },
  ZLO: {
    code: "ZLO",
    name: "MANZANILLO",
    chineseName: "曼萨尼约",
    traditionalName: "曼薩尼尤",
    airports: [
      {
        code: "ZLO",
        name: "Playa de oro intl",
        chineseName: "曼萨尼约机场",
        traditionalName: "曼薩尼尤機場",
      },
    ],
  },
  ZLT: {
    code: "ZLT",
    name: "LA TABATIERE",
    chineseName: "拉塔巴蒂埃耶",
    traditionalName: "拉塔巴蒂埃耶",
    airports: [
      {
        code: "ZLT",
        name: "La tabatiere airport",
        chineseName: "拉塔巴蒂埃耶机场",
        traditionalName: "拉塔巴蒂埃耶機場",
      },
    ],
  },
  ZMT: {
    code: "ZMT",
    name: "MASSET",
    chineseName: "马塞特",
    traditionalName: "馬塞特",
    airports: [
      {
        code: "ZMT",
        name: "Masset airport",
        chineseName: "马塞特机场",
        traditionalName: "馬塞特機場",
      },
    ],
  },
  ZNE: {
    code: "ZNE",
    name: "NEWMAN",
    chineseName: "纽曼",
    traditionalName: "紐曼",
    airports: [
      {
        code: "ZNE",
        name: "Newman airport",
        chineseName: "纽曼机场",
        traditionalName: "紐曼機場",
      },
    ],
  },
  ZNZ: {
    code: "ZNZ",
    name: "ZANZIBAR",
    chineseName: "桑给巴尔",
    traditionalName: "桑吉巴",
    airports: [
      {
        code: "ZNZ",
        name: "Abeid amani karume intl.",
        chineseName: "桑给巴尔机场",
        traditionalName: "桑吉巴機場",
      },
    ],
  },
  ZOS: {
    code: "ZOS",
    name: "OSORNO",
    chineseName: "奥索尔诺",
    traditionalName: "奧索爾諾",
    airports: [
      {
        code: "ZOS",
        name: "Canal bajo",
        chineseName: "卡纳尔巴罗机场",
        traditionalName: "卡納爾巴羅機場",
      },
    ],
  },
  ZPB: {
    code: "ZPB",
    name: "SACHIGO LAKE",
    chineseName: "萨奇哥莱克",
    traditionalName: "薩奇哥萊克",
    airports: [
      {
        code: "ZPB",
        name: "Sachigo lake airport",
        chineseName: "萨奇哥莱克机场",
        traditionalName: "薩奇哥萊克機場",
      },
    ],
  },
  ZQN: {
    code: "ZQN",
    name: "QUEENSTOWN",
    chineseName: "皇后镇",
    traditionalName: "皇后鎮",
    airports: [
      {
        code: "ZQN",
        name: "Queenstown airport",
        chineseName: "皇后镇机场",
        traditionalName: "皇后鎮機場",
      },
    ],
  },
  ZQZ: {
    code: "ZQZ",
    name: "ZHANGJIAKOU",
    chineseName: "张家口",
    traditionalName: "張家口",
    airports: [
      {
        code: "ZQZ",
        name: "Zhangjiakou airport",
        chineseName: "宁远机场",
        traditionalName: "寧遠機場",
      },
    ],
  },
  ZRH: {
    code: "ZRH",
    name: "ZURICH",
    chineseName: "苏黎世",
    traditionalName: "蘇黎世",
    airports: [
      {
        code: "ZRH",
        name: "Zurich airport",
        chineseName: "苏黎世机场",
        traditionalName: "蘇黎世機場",
      },
    ],
  },
  ZRI: {
    code: "ZRI",
    name: "SERUI",
    chineseName: "塞鲁伊",
    traditionalName: "塞魯伊",
    airports: [
      {
        code: "ZRI",
        name: "S.condronegoro",
        chineseName: "塞鲁伊机场",
        traditionalName: "塞魯伊機場",
      },
    ],
  },
  ZRJ: {
    code: "ZRJ",
    name: "ROUND LAKE",
    chineseName: "朗德莱克",
    traditionalName: "朗德萊克",
    airports: [
      {
        code: "ZRJ",
        name: "Weagamow lake",
        chineseName: "朗德莱克机场",
        traditionalName: "朗德萊克機場",
      },
    ],
  },
  ZSA: {
    code: "ZSA",
    name: "SAN SALVADOR",
    chineseName: "圣萨尔瓦多",
    traditionalName: "聖薩爾瓦多",
    airports: [
      {
        code: "ZSA",
        name: "Cockburn town",
        chineseName: "圣萨尔瓦多机场",
        traditionalName: "聖薩爾瓦多機場",
      },
    ],
  },
  ZSE: {
    code: "ZSE",
    name: "ST-PIERRE",
    chineseName: "圣皮埃尔德拉瑞乌尼翁",
    traditionalName: "聖皮埃爾德拉瑞烏尼翁",
    airports: [
      {
        code: "ZSE",
        name: "Pierrefonds",
        chineseName: "皮埃尔丰德机场",
        traditionalName: "皮埃爾豐德機場",
      },
    ],
  },
  ZSJ: {
    code: "ZSJ",
    name: "SANDY LAKE",
    chineseName: "桑迪莱克",
    traditionalName: "桑迪萊克",
    airports: [
      {
        code: "ZSJ",
        name: "Sandy lake airport",
        chineseName: "桑迪湖机场",
        traditionalName: "桑迪湖機場",
      },
    ],
  },
  ZTA: {
    code: "ZTA",
    name: "TUREIA",
    chineseName: "图雷拉",
    traditionalName: "圖雷拉",
    airports: [
      {
        code: "ZTA",
        name: "Tureia airport",
        chineseName: "图雷拉机场",
        traditionalName: "圖雷拉機場",
      },
    ],
  },
  ZTB: {
    code: "ZTB",
    name: "TETE-A-LA BALEINE",
    chineseName: "泰塔拉巴莱讷",
    traditionalName: "泰塔拉巴萊訥",
    airports: [
      {
        code: "ZTB",
        name: "Tete-a-la baleine airport",
        chineseName: "泰塔拉巴莱讷机场",
        traditionalName: "泰塔拉巴萊訥機場",
      },
    ],
  },
  ZTH: {
    code: "ZTH",
    name: "ZAKYNTHOS ISLAND",
    chineseName: "扎金索斯",
    traditionalName: "紮金索斯",
    airports: [
      {
        code: "ZTH",
        name: "Dionisios solomos",
        chineseName: "扎金索斯机场",
        traditionalName: "紮金索斯機場",
      },
    ],
  },
  ZUH: {
    code: "ZUH",
    name: "ZHUHAI",
    chineseName: "珠海",
    traditionalName: "珠海",
    airports: [
      {
        code: "ZUH",
        name: "Sanzao intl",
        chineseName: "珠海机场",
        traditionalName: "珠海機場",
      },
    ],
  },
  ZUM: {
    code: "ZUM",
    name: "CHURCHILL FALLS",
    chineseName: "丘吉尔瀑布",
    traditionalName: "邱吉爾瀑布",
    airports: [
      {
        code: "ZUM",
        name: "Churchill falls airport",
        chineseName: "丘吉尔佛斯机场",
        traditionalName: "邱吉爾佛斯機場",
      },
    ],
  },
  ZVK: {
    code: "ZVK",
    name: "SAVANNAKHET",
    chineseName: "沙湾拿吉",
    traditionalName: "沙灣拿吉",
    airports: [
      {
        code: "ZVK",
        name: "Savannakhet airport",
        chineseName: "沙湾拿吉机场",
        traditionalName: "沙灣拿吉機場",
      },
    ],
  },
  ZWL: {
    code: "ZWL",
    name: "WOLLASTON LAKE",
    chineseName: "伍拉斯顿莱克",
    traditionalName: "伍拉斯頓萊克",
    airports: [
      {
        code: "ZWL",
        name: "Wollaston lake airport",
        chineseName: "伍拉斯顿莱克机场",
        traditionalName: "伍拉斯頓萊克機場",
      },
    ],
  },
  ZYI: {
    code: "ZYI",
    name: "ZUNYI",
    chineseName: "遵义",
    traditionalName: "遵義",
    airports: [
      {
        code: "WMT",
        name: "Maotai",
        chineseName: "茅台机场",
        traditionalName: "茅臺機場",
      },
      {
        code: "ZYI",
        name: "Xinzhou",
        chineseName: "新舟机场",
        traditionalName: "新舟機場",
      },
    ],
  },
  ZYL: {
    code: "ZYL",
    name: "SYLHET",
    chineseName: "锡尔赫特",
    traditionalName: "錫爾赫特",
    airports: [
      {
        code: "ZYL",
        name: "Osmani intl",
        chineseName: "奥斯马尼国际机场",
        traditionalName: "奧斯馬尼國際機場",
      },
    ],
  },
  ZZO: {
    code: "ZZO",
    name: "ZONALNOYE",
    chineseName: "特莫夫斯科耶",
    traditionalName: "特莫夫斯科耶",
    airports: [
      {
        code: "ZZO",
        name: "Zonalnoye airport",
        chineseName: "查诺耶机场",
        traditionalName: "查諾耶機場",
      },
    ],
  },
};
